(() => {
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref19b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref19b"] = parcelRequire;
}
parcelRequire.register("e1jtj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "PureComponent", () => $a35043596f133777$export$221d75b3f55bb0bd);
$parcel$export(module.exports, "memo", () => $a35043596f133777$export$7c73462e0d25e514);
$parcel$export(module.exports, "forwardRef", () => $a35043596f133777$export$257a8862b851cb5b);
$parcel$export(module.exports, "Children", () => $a35043596f133777$export$dca3b0875bd9a954);
$parcel$export(module.exports, "Suspense", () => $a35043596f133777$export$74bf444e3cd11ea5);
$parcel$export(module.exports, "lazy", () => $a35043596f133777$export$488013bae63b21da);
$parcel$export(module.exports, "SuspenseList", () => $a35043596f133777$export$998bcd577473dd93);
$parcel$export(module.exports, "createPortal", () => $a35043596f133777$export$d39a5bbd09211389);
$parcel$export(module.exports, "render", () => $a35043596f133777$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $a35043596f133777$export$fa8d919ba61d84db);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $a35043596f133777$export$ae55be85d98224ed);
$parcel$export(module.exports, "version", () => $a35043596f133777$export$83d89fbfd8236492);
$parcel$export(module.exports, "createFactory", () => $a35043596f133777$export$d38cd72104c1f0e9);
$parcel$export(module.exports, "isValidElement", () => $a35043596f133777$export$a8257692ac88316c);
$parcel$export(module.exports, "isFragment", () => $a35043596f133777$export$9522e17588c12572);
$parcel$export(module.exports, "cloneElement", () => $a35043596f133777$export$e530037191fcd5d7);
$parcel$export(module.exports, "unmountComponentAtNode", () => $a35043596f133777$export$502457920280e6be);
$parcel$export(module.exports, "findDOMNode", () => $a35043596f133777$export$466bfc07425424d5);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $a35043596f133777$export$c78a37762a8d58e1);
$parcel$export(module.exports, "flushSync", () => $a35043596f133777$export$cd75ccfd720a3cd4);
$parcel$export(module.exports, "StrictMode", () => $a35043596f133777$export$5f8d39834fd61797);
$parcel$export(module.exports, "startTransition", () => $a35043596f133777$export$7568632d0d33d16d);
$parcel$export(module.exports, "useDeferredValue", () => $a35043596f133777$export$6a7bc4e911dc01cf);
$parcel$export(module.exports, "useTransition", () => $a35043596f133777$export$7b286972b8d8ccbf);
$parcel$export(module.exports, "useInsertionEffect", () => $a35043596f133777$export$aaabe4eda9ed9969);
$parcel$export(module.exports, "isElement", () => $a35043596f133777$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "useSyncExternalStore", () => $a35043596f133777$export$306c0aa65ff9ec16);
$parcel$export(module.exports, "default", () => $a35043596f133777$export$2e2bcd8739ae039);
$parcel$export(module.exports, "Component", () => (parcelRequire("5VC2c")).Component);
$parcel$export(module.exports, "Fragment", () => (parcelRequire("5VC2c")).Fragment);
$parcel$export(module.exports, "createContext", () => (parcelRequire("5VC2c")).createContext);
$parcel$export(module.exports, "createElement", () => (parcelRequire("5VC2c")).createElement);
$parcel$export(module.exports, "createRef", () => (parcelRequire("5VC2c")).createRef);

var $5VC2c = parcelRequire("5VC2c");

var $ir4bw = parcelRequire("ir4bw");
function $a35043596f133777$var$g(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $a35043596f133777$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $a35043596f133777$var$E(n, t) {
    return n === t && (0 !== n || 1 / n == 1 / t) || n != n && t != t;
}
function $a35043596f133777$export$221d75b3f55bb0bd(n) {
    this.props = n;
}
function $a35043596f133777$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $a35043596f133777$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $5VC2c.createElement)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($a35043596f133777$export$221d75b3f55bb0bd.prototype = new (0, $5VC2c.Component)).isPureReactComponent = !0, $a35043596f133777$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $a35043596f133777$var$C(this.props, n) || $a35043596f133777$var$C(this.state, t);
};
var $a35043596f133777$var$R = (0, $5VC2c.options).__b;
(0, $5VC2c.options).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $a35043596f133777$var$R && $a35043596f133777$var$R(n);
};
var $a35043596f133777$var$N = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $a35043596f133777$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $a35043596f133777$var$g({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $a35043596f133777$var$N, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $a35043596f133777$var$A = function(n, t) {
    return null == n ? null : (0, $5VC2c.toChildArray)((0, $5VC2c.toChildArray)(n).map(t));
}, $a35043596f133777$export$dca3b0875bd9a954 = {
    map: $a35043596f133777$var$A,
    forEach: $a35043596f133777$var$A,
    count: function(n) {
        return n ? (0, $5VC2c.toChildArray)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $5VC2c.toChildArray)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $5VC2c.toChildArray)
}, $a35043596f133777$var$T = (0, $5VC2c.options).__e;
(0, $5VC2c.options).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $a35043596f133777$var$T(n, t, e, r);
};
var $a35043596f133777$var$F = (0, $5VC2c.options).unmount;
function $a35043596f133777$var$I(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $a35043596f133777$var$g({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $a35043596f133777$var$I(n, t, e);
    })), n;
}
function $a35043596f133777$var$L(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $a35043596f133777$var$L(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.insertBefore(n.__e, n.__d), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $a35043596f133777$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $a35043596f133777$var$D(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $a35043596f133777$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $5VC2c.createElement)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $a35043596f133777$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $5VC2c.options).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && !0 === n.__h && (n.type = null), $a35043596f133777$var$F && $a35043596f133777$var$F(n);
}, ($a35043596f133777$export$74bf444e3cd11ea5.prototype = new (0, $5VC2c.Component)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $a35043596f133777$var$D(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $a35043596f133777$var$L(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    }, c = !0 === t.__h;
    r.__u++ || c || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $a35043596f133777$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $a35043596f133777$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $a35043596f133777$var$I(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $5VC2c.createElement)((0, $5VC2c.Fragment), null, n.fallback);
    return i && (i.__h = null), [
        (0, $5VC2c.createElement)((0, $5VC2c.Fragment), null, e.__a ? null : n.children),
        i
    ];
};
var $a35043596f133777$var$W = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $a35043596f133777$var$P(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $a35043596f133777$var$j(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $5VC2c.render)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $5VC2c.render)((0, $5VC2c.createElement)($a35043596f133777$var$P, {
        context: e.context
    }, n.__v), e.l);
}
function $a35043596f133777$export$d39a5bbd09211389(n, e) {
    var r = (0, $5VC2c.createElement)($a35043596f133777$var$j, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($a35043596f133777$export$998bcd577473dd93.prototype = new (0, $5VC2c.Component)).__a = function(n) {
    var t = this, e = $a35043596f133777$var$D(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $a35043596f133777$var$W(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $a35043596f133777$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $5VC2c.toChildArray)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $a35043596f133777$export$998bcd577473dd93.prototype.componentDidUpdate = $a35043596f133777$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $a35043596f133777$var$W(n, e, t);
    });
};
var $a35043596f133777$var$B = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $a35043596f133777$var$H = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $a35043596f133777$var$Z = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $a35043596f133777$var$Y = /[A-Z0-9]/g, $a35043596f133777$var$$ = "undefined" != typeof document, $a35043596f133777$var$q = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $a35043596f133777$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $5VC2c.render)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $a35043596f133777$export$fa8d919ba61d84db(n, t, e) {
    return (0, $5VC2c.hydrate)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $5VC2c.Component).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $5VC2c.Component).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $a35043596f133777$var$K = (0, $5VC2c.options).event;
function $a35043596f133777$var$Q() {}
function $a35043596f133777$var$X() {
    return this.cancelBubble;
}
function $a35043596f133777$var$nn() {
    return this.defaultPrevented;
}
(0, $5VC2c.options).event = function(n) {
    return $a35043596f133777$var$K && (n = $a35043596f133777$var$K(n)), n.persist = $a35043596f133777$var$Q, n.isPropagationStopped = $a35043596f133777$var$X, n.isDefaultPrevented = $a35043596f133777$var$nn, n.nativeEvent = n;
};
var $a35043596f133777$var$tn, $a35043596f133777$var$en = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $a35043596f133777$var$rn = (0, $5VC2c.options).vnode;
(0, $5VC2c.options).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {};
        for(var o in t){
            var i = t[o];
            if (!("value" === o && "defaultValue" in t && null == i || $a35043596f133777$var$$ && "children" === o && "noscript" === e || "class" === o || "className" === o)) {
                var l = o.toLowerCase();
                "defaultValue" === o && "value" in t && null == t.value ? o = "value" : "download" === o && !0 === i ? i = "" : "ondoubleclick" === l ? o = "ondblclick" : "onchange" !== l || "input" !== e && "textarea" !== e || $a35043596f133777$var$q(t.type) ? "onfocus" === l ? o = "onfocusin" : "onblur" === l ? o = "onfocusout" : $a35043596f133777$var$Z.test(o) ? o = l : -1 === e.indexOf("-") && $a35043596f133777$var$H.test(o) ? o = o.replace($a35043596f133777$var$Y, "-$&").toLowerCase() : null === i && (i = void 0) : l = o = "oninput", "oninput" === l && u[o = l] && (o = "oninputCapture"), u[o] = i;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $5VC2c.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $5VC2c.toChildArray)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $a35043596f133777$var$en)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $a35043596f133777$var$B, $a35043596f133777$var$rn && $a35043596f133777$var$rn(n);
};
var $a35043596f133777$var$un = (0, $5VC2c.options).__r;
(0, $5VC2c.options).__r = function(n) {
    $a35043596f133777$var$un && $a35043596f133777$var$un(n), $a35043596f133777$var$tn = n.__c;
};
var $a35043596f133777$var$on = (0, $5VC2c.options).diffed;
(0, $5VC2c.options).diffed = function(n) {
    $a35043596f133777$var$on && $a35043596f133777$var$on(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $a35043596f133777$var$tn = null;
};
var $a35043596f133777$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $a35043596f133777$var$tn.__n[n.__c].props.value;
            }
        }
    }
}, $a35043596f133777$export$83d89fbfd8236492 = "17.0.2";
function $a35043596f133777$export$d38cd72104c1f0e9(n) {
    return (0, $5VC2c.createElement).bind(null, n);
}
function $a35043596f133777$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $a35043596f133777$var$B;
}
function $a35043596f133777$export$9522e17588c12572(n) {
    return $a35043596f133777$export$a8257692ac88316c(n) && n.type === (0, $5VC2c.Fragment);
}
function $a35043596f133777$export$e530037191fcd5d7(n) {
    return $a35043596f133777$export$a8257692ac88316c(n) ? (0, $5VC2c.cloneElement).apply(null, arguments) : n;
}
function $a35043596f133777$export$502457920280e6be(n) {
    return !!n.__k && ((0, $5VC2c.render)(null, n), !0);
}
function $a35043596f133777$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $a35043596f133777$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $a35043596f133777$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $a35043596f133777$export$5f8d39834fd61797 = (0, $5VC2c.Fragment);
function $a35043596f133777$export$7568632d0d33d16d(n) {
    n();
}
function $a35043596f133777$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $a35043596f133777$export$7b286972b8d8ccbf() {
    return [
        !1,
        $a35043596f133777$export$7568632d0d33d16d
    ];
}
var $a35043596f133777$export$aaabe4eda9ed9969 = (0, $ir4bw.useLayoutEffect), $a35043596f133777$export$45a5e7f76e0caa8d = $a35043596f133777$export$a8257692ac88316c;
function $a35043596f133777$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $ir4bw.useState)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $ir4bw.useLayoutEffect)(function() {
        u.__ = e, u.v = t, $a35043596f133777$var$E(u.__, t()) || o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $ir4bw.useEffect)(function() {
        return $a35043596f133777$var$E(u.__, u.v()) || o({
            h: u
        }), n(function() {
            $a35043596f133777$var$E(u.__, u.v()) || o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
var $a35043596f133777$export$2e2bcd8739ae039 = {
    useState: (0, $ir4bw.useState),
    useId: (0, $ir4bw.useId),
    useReducer: (0, $ir4bw.useReducer),
    useEffect: (0, $ir4bw.useEffect),
    useLayoutEffect: (0, $ir4bw.useLayoutEffect),
    useInsertionEffect: $a35043596f133777$export$aaabe4eda9ed9969,
    useTransition: $a35043596f133777$export$7b286972b8d8ccbf,
    useDeferredValue: $a35043596f133777$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $a35043596f133777$export$306c0aa65ff9ec16,
    startTransition: $a35043596f133777$export$7568632d0d33d16d,
    useRef: (0, $ir4bw.useRef),
    useImperativeHandle: (0, $ir4bw.useImperativeHandle),
    useMemo: (0, $ir4bw.useMemo),
    useCallback: (0, $ir4bw.useCallback),
    useContext: (0, $ir4bw.useContext),
    useDebugValue: (0, $ir4bw.useDebugValue),
    version: "17.0.2",
    Children: $a35043596f133777$export$dca3b0875bd9a954,
    render: $a35043596f133777$export$b3890eb0ae9dca99,
    hydrate: $a35043596f133777$export$fa8d919ba61d84db,
    unmountComponentAtNode: $a35043596f133777$export$502457920280e6be,
    createPortal: $a35043596f133777$export$d39a5bbd09211389,
    createElement: (0, $5VC2c.createElement),
    createContext: (0, $5VC2c.createContext),
    createFactory: $a35043596f133777$export$d38cd72104c1f0e9,
    cloneElement: $a35043596f133777$export$e530037191fcd5d7,
    createRef: (0, $5VC2c.createRef),
    Fragment: (0, $5VC2c.Fragment),
    isValidElement: $a35043596f133777$export$a8257692ac88316c,
    isElement: $a35043596f133777$export$45a5e7f76e0caa8d,
    isFragment: $a35043596f133777$export$9522e17588c12572,
    findDOMNode: $a35043596f133777$export$466bfc07425424d5,
    Component: (0, $5VC2c.Component),
    PureComponent: $a35043596f133777$export$221d75b3f55bb0bd,
    memo: $a35043596f133777$export$7c73462e0d25e514,
    forwardRef: $a35043596f133777$export$257a8862b851cb5b,
    flushSync: $a35043596f133777$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $a35043596f133777$export$c78a37762a8d58e1,
    StrictMode: $a35043596f133777$export$5f8d39834fd61797,
    Suspense: $a35043596f133777$export$74bf444e3cd11ea5,
    SuspenseList: $a35043596f133777$export$998bcd577473dd93,
    lazy: $a35043596f133777$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $a35043596f133777$export$ae55be85d98224ed
};
$parcel$exportWildcard(module.exports, $ir4bw);

});
parcelRequire.register("5VC2c", function(module, exports) {

$parcel$export(module.exports, "options", () => $450fc775b2f7950e$export$41c562ebe57d11e2);
$parcel$export(module.exports, "createElement", () => $450fc775b2f7950e$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "createRef", () => $450fc775b2f7950e$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $450fc775b2f7950e$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $450fc775b2f7950e$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $450fc775b2f7950e$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $450fc775b2f7950e$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "hydrate", () => $450fc775b2f7950e$export$fa8d919ba61d84db);
$parcel$export(module.exports, "cloneElement", () => $450fc775b2f7950e$export$e530037191fcd5d7);
$parcel$export(module.exports, "createContext", () => $450fc775b2f7950e$export$fd42f52fd3ae1109);
var $450fc775b2f7950e$var$n, $450fc775b2f7950e$export$41c562ebe57d11e2, $450fc775b2f7950e$var$u, $450fc775b2f7950e$export$a8257692ac88316c, $450fc775b2f7950e$var$i, $450fc775b2f7950e$var$o, $450fc775b2f7950e$var$r, $450fc775b2f7950e$var$f, $450fc775b2f7950e$var$e, $450fc775b2f7950e$var$c = {}, $450fc775b2f7950e$var$s = [], $450fc775b2f7950e$var$a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $450fc775b2f7950e$var$v = Array.isArray;
function $450fc775b2f7950e$var$h(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $450fc775b2f7950e$var$p(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $450fc775b2f7950e$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $450fc775b2f7950e$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $450fc775b2f7950e$var$d(l, f, i, o, null);
}
function $450fc775b2f7950e$var$d(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: null == r ? ++$450fc775b2f7950e$var$u : r
    };
    return null == r && null != $450fc775b2f7950e$export$41c562ebe57d11e2.vnode && $450fc775b2f7950e$export$41c562ebe57d11e2.vnode(f), f;
}
function $450fc775b2f7950e$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $450fc775b2f7950e$export$ffb0004e005737fa(n) {
    return n.children;
}
function $450fc775b2f7950e$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $450fc775b2f7950e$var$g(n, l) {
    if (null == l) return n.__ ? $450fc775b2f7950e$var$g(n.__, n.__.__k.indexOf(n) + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__d || u.__e;
    return "function" == typeof n.type ? $450fc775b2f7950e$var$g(n) : null;
}
function $450fc775b2f7950e$var$m(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $450fc775b2f7950e$var$m(n);
    }
}
function $450fc775b2f7950e$var$w(n) {
    (!n.__d && (n.__d = !0) && $450fc775b2f7950e$var$i.push(n) && !$450fc775b2f7950e$var$x.__r++ || $450fc775b2f7950e$var$o !== $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering) && (($450fc775b2f7950e$var$o = $450fc775b2f7950e$export$41c562ebe57d11e2.debounceRendering) || $450fc775b2f7950e$var$r)($450fc775b2f7950e$var$x);
}
function $450fc775b2f7950e$var$x() {
    var n, l, u, t, o, r, e, c, s;
    for($450fc775b2f7950e$var$i.sort($450fc775b2f7950e$var$f); n = $450fc775b2f7950e$var$i.shift();)n.__d && (l = $450fc775b2f7950e$var$i.length, t = void 0, o = void 0, r = void 0, c = (e = (u = n).__v).__e, (s = u.__P) && (t = [], o = [], (r = $450fc775b2f7950e$var$h({}, e)).__v = e.__v + 1, $450fc775b2f7950e$var$z(s, e, r, u.__n, void 0 !== s.ownerSVGElement, null != e.__h ? [
        c
    ] : null, t, null == c ? $450fc775b2f7950e$var$g(e) : c, e.__h, o), $450fc775b2f7950e$var$L(t, e, o), e.__e != c && $450fc775b2f7950e$var$m(e)), $450fc775b2f7950e$var$i.length > l && $450fc775b2f7950e$var$i.sort($450fc775b2f7950e$var$f));
    $450fc775b2f7950e$var$x.__r = 0;
}
function $450fc775b2f7950e$var$P(n, l, u, t, i, o, r, f, e, a, h) {
    var p, y, _, b, m, w, x, P, C, D = 0, H = t && t.__k || $450fc775b2f7950e$var$s, I = H.length, T = I, j = l.length;
    for(u.__k = [], p = 0; p < j; p++)null != (b = u.__k[p] = null == (b = l[p]) || "boolean" == typeof b || "function" == typeof b ? null : "string" == typeof b || "number" == typeof b || "bigint" == typeof b ? $450fc775b2f7950e$var$d(null, b, null, null, b) : $450fc775b2f7950e$var$v(b) ? $450fc775b2f7950e$var$d($450fc775b2f7950e$export$ffb0004e005737fa, {
        children: b
    }, null, null, null) : b.__b > 0 ? $450fc775b2f7950e$var$d(b.type, b.props, b.key, b.ref ? b.ref : null, b.__v) : b) ? (b.__ = u, b.__b = u.__b + 1, -1 === (P = $450fc775b2f7950e$var$A(b, H, x = p + D, T)) ? _ = $450fc775b2f7950e$var$c : (_ = H[P] || $450fc775b2f7950e$var$c, H[P] = void 0, T--), $450fc775b2f7950e$var$z(n, b, _, i, o, r, f, e, a, h), m = b.__e, (y = b.ref) && _.ref != y && (_.ref && $450fc775b2f7950e$var$N(_.ref, null, b), h.push(y, b.__c || m, b)), null != m && (null == w && (w = m), (C = _ === $450fc775b2f7950e$var$c || null === _.__v) ? -1 == P && D-- : P !== x && (P === x + 1 ? D++ : P > x ? T > j - x ? D += P - x : D-- : D = P < x && P == x - 1 ? P - x : 0), x = p + D, "function" != typeof b.type || P === x && _.__k !== b.__k ? "function" == typeof b.type || P === x && !C ? void 0 !== b.__d ? (e = b.__d, b.__d = void 0) : e = m.nextSibling : e = $450fc775b2f7950e$var$S(n, m, e) : e = $450fc775b2f7950e$var$$(b, e, n), "function" == typeof u.type && (u.__d = e))) : (_ = H[p]) && null == _.key && _.__e && (_.__e == e && (_.__ = t, e = $450fc775b2f7950e$var$g(_)), $450fc775b2f7950e$var$O(_, _, !1), H[p] = null);
    for(u.__e = w, p = I; p--;)null != H[p] && ("function" == typeof u.type && null != H[p].__e && H[p].__e == u.__d && (u.__d = H[p].__e.nextSibling), $450fc775b2f7950e$var$O(H[p], H[p]));
}
function $450fc775b2f7950e$var$$(n, l, u) {
    for(var t, i = n.__k, o = 0; i && o < i.length; o++)(t = i[o]) && (t.__ = n, l = "function" == typeof t.type ? $450fc775b2f7950e$var$$(t, l, u) : $450fc775b2f7950e$var$S(u, t.__e, l));
    return l;
}
function $450fc775b2f7950e$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($450fc775b2f7950e$var$v(n) ? n.some(function(n) {
        $450fc775b2f7950e$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $450fc775b2f7950e$var$S(n, l, u) {
    return null == u || u.parentNode !== n ? n.insertBefore(l, null) : l == u && null != l.parentNode || n.insertBefore(l, u), l.nextSibling;
}
function $450fc775b2f7950e$var$A(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type) return u;
    if (t > (null != e ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $450fc775b2f7950e$var$D(n, l, u, t, i) {
    var o;
    for(o in u)"children" === o || "key" === o || o in l || $450fc775b2f7950e$var$I(n, o, null, u[o], t);
    for(o in l)i && "function" != typeof l[o] || "children" === o || "key" === o || "value" === o || "checked" === o || u[o] === l[o] || $450fc775b2f7950e$var$I(n, o, l[o], u[o], t);
}
function $450fc775b2f7950e$var$H(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $450fc775b2f7950e$var$a.test(l) ? u : u + "px";
}
function $450fc775b2f7950e$var$I(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $450fc775b2f7950e$var$H(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $450fc775b2f7950e$var$H(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/, "$1")), l = l.toLowerCase() in n ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = Date.now(), n.addEventListener(l, o ? $450fc775b2f7950e$var$j : $450fc775b2f7950e$var$T, o)) : n.removeEventListener(l, o ? $450fc775b2f7950e$var$j : $450fc775b2f7950e$var$T, o);
    else if ("dangerouslySetInnerHTML" !== l) {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" !== l && "height" !== l && "href" !== l && "list" !== l && "form" !== l && "tabIndex" !== l && "download" !== l && "rowSpan" !== l && "colSpan" !== l && "role" !== l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $450fc775b2f7950e$var$T(n) {
    var u = this.l[n.type + !1];
    if (n.t) {
        if (n.t <= u.u) return;
    } else n.t = Date.now();
    return u($450fc775b2f7950e$export$41c562ebe57d11e2.event ? $450fc775b2f7950e$export$41c562ebe57d11e2.event(n) : n);
}
function $450fc775b2f7950e$var$j(n) {
    return this.l[n.type + !0]($450fc775b2f7950e$export$41c562ebe57d11e2.event ? $450fc775b2f7950e$export$41c562ebe57d11e2.event(n) : n);
}
function $450fc775b2f7950e$var$z(n, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, g, m, w, x, $, C, S, A, D, H, I = u.type;
    if (void 0 !== u.constructor) return null;
    null != t.__h && (c = t.__h, e = u.__e = t.__e, u.__h = null, r = [
        e
    ]), (a = $450fc775b2f7950e$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof I) try {
        if (w = u.props, x = (a = I.contextType) && i[a.__c], $ = a ? x ? x.props.value : a.__ : i, t.__c ? m = (p = u.__c = t.__c).__ = p.__E : ("prototype" in I && I.prototype.render ? u.__c = p = new I(w, $) : (u.__c = p = new $450fc775b2f7950e$export$16fa2f45be04daa8(w, $), p.constructor = I, p.render = $450fc775b2f7950e$var$q), x && x.sub(p), p.props = w, p.state || (p.state = {}), p.context = $, p.__n = i, y = p.__d = !0, p.__h = [], p._sb = []), null == p.__s && (p.__s = p.state), null != I.getDerivedStateFromProps && (p.__s == p.state && (p.__s = $450fc775b2f7950e$var$h({}, p.__s)), $450fc775b2f7950e$var$h(p.__s, I.getDerivedStateFromProps(w, p.__s))), d = p.props, _ = p.state, p.__v = u, y) null == I.getDerivedStateFromProps && null != p.componentWillMount && p.componentWillMount(), null != p.componentDidMount && p.__h.push(p.componentDidMount);
        else {
            if (null == I.getDerivedStateFromProps && w !== d && null != p.componentWillReceiveProps && p.componentWillReceiveProps(w, $), !p.__e && (null != p.shouldComponentUpdate && !1 === p.shouldComponentUpdate(w, p.__s, $) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (p.props = w, p.state = p.__s, p.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), C = 0; C < p._sb.length; C++)p.__h.push(p._sb[C]);
                p._sb = [], p.__h.length && f.push(p);
                break n;
            }
            null != p.componentWillUpdate && p.componentWillUpdate(w, p.__s, $), null != p.componentDidUpdate && p.__h.push(function() {
                p.componentDidUpdate(d, _, g);
            });
        }
        if (p.context = $, p.props = w, p.__P = n, p.__e = !1, S = $450fc775b2f7950e$export$41c562ebe57d11e2.__r, A = 0, "prototype" in I && I.prototype.render) {
            for(p.state = p.__s, p.__d = !1, S && S(u), a = p.render(p.props, p.state, p.context), D = 0; D < p._sb.length; D++)p.__h.push(p._sb[D]);
            p._sb = [];
        } else do p.__d = !1, S && S(u), a = p.render(p.props, p.state, p.context), p.state = p.__s;
        while (p.__d && ++A < 25);
        p.state = p.__s, null != p.getChildContext && (i = $450fc775b2f7950e$var$h($450fc775b2f7950e$var$h({}, i), p.getChildContext())), y || null == p.getSnapshotBeforeUpdate || (g = p.getSnapshotBeforeUpdate(d, _)), $450fc775b2f7950e$var$P(n, $450fc775b2f7950e$var$v(H = null != a && a.type === $450fc775b2f7950e$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? H : [
            H
        ], u, t, i, o, r, f, e, c, s), p.base = u.__e, u.__h = null, p.__h.length && f.push(p), m && (p.__E = p.__ = null);
    } catch (n) {
        u.__v = null, (c || null != r) && (u.__e = e, u.__h = !!c, r[r.indexOf(e)] = null), $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $450fc775b2f7950e$var$M(t.__e, u, t, i, o, r, f, c, s);
    (a = $450fc775b2f7950e$export$41c562ebe57d11e2.diffed) && a(u);
}
function $450fc775b2f7950e$var$L(n, u, t) {
    for(var i = 0; i < t.length; i++)$450fc775b2f7950e$var$N(t[i], t[++i], t[++i]);
    $450fc775b2f7950e$export$41c562ebe57d11e2.__c && $450fc775b2f7950e$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $450fc775b2f7950e$var$M(l, u, t, i, o, r, f, e, s) {
    var a, h, y, d = t.props, _ = u.props, k = u.type, b = 0;
    if ("svg" === k && (o = !0), null != r) {
        for(; b < r.length; b++)if ((a = r[b]) && "setAttribute" in a == !!k && (k ? a.localName === k : 3 === a.nodeType)) {
            l = a, r[b] = null;
            break;
        }
    }
    if (null == l) {
        if (null === k) return document.createTextNode(_);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", k) : document.createElement(k, _.is && _), r = null, e = !1;
    }
    if (null === k) d === _ || e && l.data === _ || (l.data = _);
    else {
        if (r = r && $450fc775b2f7950e$var$n.call(l.childNodes), h = (d = t.props || $450fc775b2f7950e$var$c).dangerouslySetInnerHTML, y = _.dangerouslySetInnerHTML, !e) {
            if (null != r) for(d = {}, b = 0; b < l.attributes.length; b++)d[l.attributes[b].name] = l.attributes[b].value;
            (y || h) && (y && (h && y.__html == h.__html || y.__html === l.innerHTML) || (l.innerHTML = y && y.__html || ""));
        }
        if ($450fc775b2f7950e$var$D(l, _, d, o, e), y) u.__k = [];
        else if ($450fc775b2f7950e$var$P(l, $450fc775b2f7950e$var$v(b = u.props.children) ? b : [
            b
        ], u, t, i, o && "foreignObject" !== k, r, f, r ? r[0] : t.__k && $450fc775b2f7950e$var$g(t, 0), e, s), null != r) for(b = r.length; b--;)null != r[b] && $450fc775b2f7950e$var$p(r[b]);
        e || ("value" in _ && void 0 !== (b = _.value) && (b !== l.value || "progress" === k && !b || "option" === k && b !== d.value) && $450fc775b2f7950e$var$I(l, "value", b, d.value, !1), "checked" in _ && void 0 !== (b = _.checked) && b !== l.checked && $450fc775b2f7950e$var$I(l, "checked", b, d.checked, !1));
    }
    return l;
}
function $450fc775b2f7950e$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $450fc775b2f7950e$var$O(n, u, t) {
    var i, o;
    if ($450fc775b2f7950e$export$41c562ebe57d11e2.unmount && $450fc775b2f7950e$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $450fc775b2f7950e$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $450fc775b2f7950e$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null, n.__c = void 0;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $450fc775b2f7950e$var$O(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $450fc775b2f7950e$var$p(n.__e), n.__ = n.__e = n.__d = void 0;
}
function $450fc775b2f7950e$var$q(n, l, u) {
    return this.constructor(n, u);
}
function $450fc775b2f7950e$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $450fc775b2f7950e$export$41c562ebe57d11e2.__ && $450fc775b2f7950e$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $450fc775b2f7950e$var$z(t, u = (!o && i || t).__k = $450fc775b2f7950e$export$c8a8987d4410bf2d($450fc775b2f7950e$export$ffb0004e005737fa, null, [
        u
    ]), r || $450fc775b2f7950e$var$c, $450fc775b2f7950e$var$c, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $450fc775b2f7950e$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $450fc775b2f7950e$var$L(f, u, e);
}
function $450fc775b2f7950e$export$fa8d919ba61d84db(n, l) {
    $450fc775b2f7950e$export$b3890eb0ae9dca99(n, l, $450fc775b2f7950e$export$fa8d919ba61d84db);
}
function $450fc775b2f7950e$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $450fc775b2f7950e$var$h({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $450fc775b2f7950e$var$n.call(arguments, 2) : t), $450fc775b2f7950e$var$d(l.type, e, i || l.key, o || l.ref, null);
}
function $450fc775b2f7950e$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $450fc775b2f7950e$var$e++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $450fc775b2f7950e$var$w(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$450fc775b2f7950e$var$n = $450fc775b2f7950e$var$s.slice, $450fc775b2f7950e$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $450fc775b2f7950e$var$u = 0, $450fc775b2f7950e$export$a8257692ac88316c = function(n) {
    return null != n && void 0 === n.constructor;
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $450fc775b2f7950e$var$h({}, this.state), "function" == typeof n && (n = n($450fc775b2f7950e$var$h({}, u), this.props)), n && $450fc775b2f7950e$var$h(u, n), null != n && this.__v && (l && this._sb.push(l), $450fc775b2f7950e$var$w(this));
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $450fc775b2f7950e$var$w(this));
}, $450fc775b2f7950e$export$16fa2f45be04daa8.prototype.render = $450fc775b2f7950e$export$ffb0004e005737fa, $450fc775b2f7950e$var$i = [], $450fc775b2f7950e$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $450fc775b2f7950e$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $450fc775b2f7950e$var$x.__r = 0, $450fc775b2f7950e$var$e = 0;

});

parcelRequire.register("ir4bw", function(module, exports) {

$parcel$export(module.exports, "useState", () => $d6bdfea1a1e13052$export$60241385465d0a34);
$parcel$export(module.exports, "useReducer", () => $d6bdfea1a1e13052$export$13e3392192263954);
$parcel$export(module.exports, "useEffect", () => $d6bdfea1a1e13052$export$6d9c69b0de29b591);
$parcel$export(module.exports, "useLayoutEffect", () => $d6bdfea1a1e13052$export$e5c5a5f917a5871c);
$parcel$export(module.exports, "useRef", () => $d6bdfea1a1e13052$export$b8f5890fc79d6aca);
$parcel$export(module.exports, "useMemo", () => $d6bdfea1a1e13052$export$1538c33de8887b59);
$parcel$export(module.exports, "useImperativeHandle", () => $d6bdfea1a1e13052$export$d5a552a76deda3c2);
$parcel$export(module.exports, "useCallback", () => $d6bdfea1a1e13052$export$35808ee640e87ca7);
$parcel$export(module.exports, "useContext", () => $d6bdfea1a1e13052$export$fae74005e78b1a27);
$parcel$export(module.exports, "useDebugValue", () => $d6bdfea1a1e13052$export$dc8fbce3eb94dc1e);
$parcel$export(module.exports, "useErrorBoundary", () => $d6bdfea1a1e13052$export$c052f6604b7d51fe);
$parcel$export(module.exports, "useId", () => $d6bdfea1a1e13052$export$f680877a34711e37);

var $5VC2c = parcelRequire("5VC2c");
var $d6bdfea1a1e13052$var$t, $d6bdfea1a1e13052$var$r, $d6bdfea1a1e13052$var$u, $d6bdfea1a1e13052$var$i, $d6bdfea1a1e13052$var$o = 0, $d6bdfea1a1e13052$var$f = [], $d6bdfea1a1e13052$var$c = [], $d6bdfea1a1e13052$var$e = (0, $5VC2c.options).__b, $d6bdfea1a1e13052$var$a = (0, $5VC2c.options).__r, $d6bdfea1a1e13052$var$v = (0, $5VC2c.options).diffed, $d6bdfea1a1e13052$var$l = (0, $5VC2c.options).__c, $d6bdfea1a1e13052$var$m = (0, $5VC2c.options).unmount;
function $d6bdfea1a1e13052$var$d(t, u) {
    (0, $5VC2c.options).__h && (0, $5VC2c.options).__h($d6bdfea1a1e13052$var$r, t, $d6bdfea1a1e13052$var$o || u), $d6bdfea1a1e13052$var$o = 0;
    var i = $d6bdfea1a1e13052$var$r.__H || ($d6bdfea1a1e13052$var$r.__H = {
        __: [],
        __h: []
    });
    return t >= i.__.length && i.__.push({
        __V: $d6bdfea1a1e13052$var$c
    }), i.__[t];
}
function $d6bdfea1a1e13052$export$60241385465d0a34(n) {
    return $d6bdfea1a1e13052$var$o = 1, $d6bdfea1a1e13052$export$13e3392192263954($d6bdfea1a1e13052$var$B, n);
}
function $d6bdfea1a1e13052$export$13e3392192263954(n, u, i) {
    var o = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $d6bdfea1a1e13052$var$B(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $d6bdfea1a1e13052$var$r, !$d6bdfea1a1e13052$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $d6bdfea1a1e13052$var$r.u = !0;
        var c = $d6bdfea1a1e13052$var$r.shouldComponentUpdate, e = $d6bdfea1a1e13052$var$r.componentWillUpdate;
        $d6bdfea1a1e13052$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $d6bdfea1a1e13052$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $d6bdfea1a1e13052$export$6d9c69b0de29b591(u, i) {
    var o = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 3);
    !(0, $5VC2c.options).__s && $d6bdfea1a1e13052$var$z(o.__H, i) && (o.__ = u, o.i = i, $d6bdfea1a1e13052$var$r.__H.__h.push(o));
}
function $d6bdfea1a1e13052$export$e5c5a5f917a5871c(u, i) {
    var o = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 4);
    !(0, $5VC2c.options).__s && $d6bdfea1a1e13052$var$z(o.__H, i) && (o.__ = u, o.i = i, $d6bdfea1a1e13052$var$r.__h.push(o));
}
function $d6bdfea1a1e13052$export$b8f5890fc79d6aca(n) {
    return $d6bdfea1a1e13052$var$o = 5, $d6bdfea1a1e13052$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $d6bdfea1a1e13052$export$d5a552a76deda3c2(n, t, r) {
    $d6bdfea1a1e13052$var$o = 6, $d6bdfea1a1e13052$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $d6bdfea1a1e13052$export$1538c33de8887b59(n, r) {
    var u = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 7);
    return $d6bdfea1a1e13052$var$z(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $d6bdfea1a1e13052$export$35808ee640e87ca7(n, t) {
    return $d6bdfea1a1e13052$var$o = 8, $d6bdfea1a1e13052$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $d6bdfea1a1e13052$export$fae74005e78b1a27(n) {
    var u = $d6bdfea1a1e13052$var$r.context[n.__c], i = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($d6bdfea1a1e13052$var$r)), u.props.value) : n.__;
}
function $d6bdfea1a1e13052$export$dc8fbce3eb94dc1e(t, r) {
    (0, $5VC2c.options).useDebugValue && (0, $5VC2c.options).useDebugValue(r ? r(t) : t);
}
function $d6bdfea1a1e13052$export$c052f6604b7d51fe(n) {
    var u = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 10), i = $d6bdfea1a1e13052$export$60241385465d0a34();
    return u.__ = n, $d6bdfea1a1e13052$var$r.componentDidCatch || ($d6bdfea1a1e13052$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $d6bdfea1a1e13052$export$f680877a34711e37() {
    var n = $d6bdfea1a1e13052$var$d($d6bdfea1a1e13052$var$t++, 11);
    if (!n.__) {
        for(var u = $d6bdfea1a1e13052$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $d6bdfea1a1e13052$var$b() {
    for(var t; t = $d6bdfea1a1e13052$var$f.shift();)if (t.__P && t.__H) try {
        t.__H.__h.forEach($d6bdfea1a1e13052$var$k), t.__H.__h.forEach($d6bdfea1a1e13052$var$w), t.__H.__h = [];
    } catch (r) {
        t.__H.__h = [], (0, $5VC2c.options).__e(r, t.__v);
    }
}
(0, $5VC2c.options).__b = function(n) {
    $d6bdfea1a1e13052$var$r = null, $d6bdfea1a1e13052$var$e && $d6bdfea1a1e13052$var$e(n);
}, (0, $5VC2c.options).__r = function(n) {
    $d6bdfea1a1e13052$var$a && $d6bdfea1a1e13052$var$a(n), $d6bdfea1a1e13052$var$t = 0;
    var i = ($d6bdfea1a1e13052$var$r = n.__c).__H;
    i && ($d6bdfea1a1e13052$var$u === $d6bdfea1a1e13052$var$r ? (i.__h = [], $d6bdfea1a1e13052$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $d6bdfea1a1e13052$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($d6bdfea1a1e13052$var$k), i.__h.forEach($d6bdfea1a1e13052$var$w), i.__h = [], $d6bdfea1a1e13052$var$t = 0)), $d6bdfea1a1e13052$var$u = $d6bdfea1a1e13052$var$r;
}, (0, $5VC2c.options).diffed = function(t) {
    $d6bdfea1a1e13052$var$v && $d6bdfea1a1e13052$var$v(t);
    var o = t.__c;
    o && o.__H && (o.__H.__h.length && (1 !== $d6bdfea1a1e13052$var$f.push(o) && $d6bdfea1a1e13052$var$i === (0, $5VC2c.options).requestAnimationFrame || (($d6bdfea1a1e13052$var$i = (0, $5VC2c.options).requestAnimationFrame) || $d6bdfea1a1e13052$var$j)($d6bdfea1a1e13052$var$b)), o.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $d6bdfea1a1e13052$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $d6bdfea1a1e13052$var$c;
    })), $d6bdfea1a1e13052$var$u = $d6bdfea1a1e13052$var$r = null;
}, (0, $5VC2c.options).__c = function(t, r) {
    r.some(function(t) {
        try {
            t.__h.forEach($d6bdfea1a1e13052$var$k), t.__h = t.__h.filter(function(n) {
                return !n.__ || $d6bdfea1a1e13052$var$w(n);
            });
        } catch (u) {
            r.some(function(n) {
                n.__h && (n.__h = []);
            }), r = [], (0, $5VC2c.options).__e(u, t.__v);
        }
    }), $d6bdfea1a1e13052$var$l && $d6bdfea1a1e13052$var$l(t, r);
}, (0, $5VC2c.options).unmount = function(t) {
    $d6bdfea1a1e13052$var$m && $d6bdfea1a1e13052$var$m(t);
    var r, u = t.__c;
    u && u.__H && (u.__H.__.forEach(function(n) {
        try {
            $d6bdfea1a1e13052$var$k(n);
        } catch (n) {
            r = n;
        }
    }), u.__H = void 0, r && (0, $5VC2c.options).__e(r, u.__v));
};
var $d6bdfea1a1e13052$var$g = "function" == typeof requestAnimationFrame;
function $d6bdfea1a1e13052$var$j(n) {
    var t, r = function() {
        clearTimeout(u), $d6bdfea1a1e13052$var$g && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $d6bdfea1a1e13052$var$g && (t = requestAnimationFrame(r));
}
function $d6bdfea1a1e13052$var$k(n) {
    var t = $d6bdfea1a1e13052$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $d6bdfea1a1e13052$var$r = t;
}
function $d6bdfea1a1e13052$var$w(n) {
    var t = $d6bdfea1a1e13052$var$r;
    n.__c = n.__(), $d6bdfea1a1e13052$var$r = t;
}
function $d6bdfea1a1e13052$var$z(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $d6bdfea1a1e13052$var$B(n, t) {
    return "function" == typeof t ? t(n) : t;
}

});


var $9d97a5a9a883c69e$exports = {};

var $5VC2c = parcelRequire("5VC2c");
var $563cc721c6a67067$var$_ = 0;
function $563cc721c6a67067$export$34b9dba7ce09269b(o, e, n, t, f, l) {
    var s, u, a = {};
    for(u in e)"ref" == u ? s = e[u] : a[u] = e[u];
    var i = {
        type: o,
        props: a,
        key: n,
        ref: s,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        __h: null,
        constructor: void 0,
        __v: --$563cc721c6a67067$var$_,
        __source: f,
        __self: l
    };
    if ("function" == typeof o && (s = o.defaultProps)) for(u in s)void 0 === a[u] && (a[u] = s[u]);
    return (0, $5VC2c.options).vnode && (0, $5VC2c.options).vnode(i), i;
}


var $5VC2c = parcelRequire("5VC2c");

var $5VC2c = parcelRequire("5VC2c");
var $23fbbca513fd42e2$exports = {};

$parcel$export($23fbbca513fd42e2$exports, "default", () => $23fbbca513fd42e2$export$2e2bcd8739ae039);

var $5VC2c = parcelRequire("5VC2c");
parcelRequire("e1jtj");
var $ir4bw = parcelRequire("ir4bw");
var $c283a7eca7a97e89$exports = {};
var $695b3d6025d5e530$exports = {};

$parcel$defineInteropFlag($695b3d6025d5e530$exports);

$parcel$export($695b3d6025d5e530$exports, "Sortable", () => $695b3d6025d5e530$export$31b3ca70d8f57423);
$parcel$export($695b3d6025d5e530$exports, "Swap", () => $695b3d6025d5e530$export$bdb5f0a1b77546f4);
$parcel$export($695b3d6025d5e530$exports, "MultiDrag", () => $695b3d6025d5e530$export$18e5d2a5d1df842d);
$parcel$export($695b3d6025d5e530$exports, "default", () => $695b3d6025d5e530$export$2e2bcd8739ae039);
/**!
 * Sortable 1.15.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $695b3d6025d5e530$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $695b3d6025d5e530$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $695b3d6025d5e530$var$ownKeys(Object(source), true).forEach(function(key) {
            $695b3d6025d5e530$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $695b3d6025d5e530$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $695b3d6025d5e530$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $695b3d6025d5e530$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $695b3d6025d5e530$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $695b3d6025d5e530$var$_typeof(obj);
}
function $695b3d6025d5e530$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $695b3d6025d5e530$var$_extends() {
    $695b3d6025d5e530$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $695b3d6025d5e530$var$_extends.apply(this, arguments);
}
function $695b3d6025d5e530$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $695b3d6025d5e530$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $695b3d6025d5e530$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $695b3d6025d5e530$var$_toConsumableArray(arr) {
    return $695b3d6025d5e530$var$_arrayWithoutHoles(arr) || $695b3d6025d5e530$var$_iterableToArray(arr) || $695b3d6025d5e530$var$_unsupportedIterableToArray(arr) || $695b3d6025d5e530$var$_nonIterableSpread();
}
function $695b3d6025d5e530$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $695b3d6025d5e530$var$_arrayLikeToArray(arr);
}
function $695b3d6025d5e530$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $695b3d6025d5e530$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $695b3d6025d5e530$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $695b3d6025d5e530$var$_arrayLikeToArray(o, minLen);
}
function $695b3d6025d5e530$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $695b3d6025d5e530$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $695b3d6025d5e530$var$version = "1.15.0";
function $695b3d6025d5e530$var$userAgent(pattern) {
    if (typeof window !== "undefined" && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $695b3d6025d5e530$var$IE11OrLess = $695b3d6025d5e530$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $695b3d6025d5e530$var$Edge = $695b3d6025d5e530$var$userAgent(/Edge/i);
var $695b3d6025d5e530$var$FireFox = $695b3d6025d5e530$var$userAgent(/firefox/i);
var $695b3d6025d5e530$var$Safari = $695b3d6025d5e530$var$userAgent(/safari/i) && !$695b3d6025d5e530$var$userAgent(/chrome/i) && !$695b3d6025d5e530$var$userAgent(/android/i);
var $695b3d6025d5e530$var$IOS = $695b3d6025d5e530$var$userAgent(/iP(ad|od|hone)/i);
var $695b3d6025d5e530$var$ChromeForAndroid = $695b3d6025d5e530$var$userAgent(/chrome/i) && $695b3d6025d5e530$var$userAgent(/android/i);
var $695b3d6025d5e530$var$captureMode = {
    capture: false,
    passive: false
};
function $695b3d6025d5e530$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$695b3d6025d5e530$var$IE11OrLess && $695b3d6025d5e530$var$captureMode);
}
function $695b3d6025d5e530$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$695b3d6025d5e530$var$IE11OrLess && $695b3d6025d5e530$var$captureMode);
}
function $695b3d6025d5e530$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === ">" && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $695b3d6025d5e530$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $695b3d6025d5e530$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === ">" ? el.parentNode === ctx && $695b3d6025d5e530$var$matches(el, selector) : $695b3d6025d5e530$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $695b3d6025d5e530$var$getParentOrHost(el));
    }
    return null;
}
var $695b3d6025d5e530$var$R_SPACE = /\s+/g;
function $695b3d6025d5e530$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? "add" : "remove"](name);
        else {
            var className = (" " + el.className + " ").replace($695b3d6025d5e530$var$R_SPACE, " ").replace(" " + name + " ", " ");
            el.className = (className + (state ? " " + name : "")).replace($695b3d6025d5e530$var$R_SPACE, " ");
        }
    }
}
function $695b3d6025d5e530$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, "");
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf("webkit") === -1) prop = "-webkit-" + prop;
            style[prop] = val + (typeof val === "string" ? "" : "px");
        }
    }
}
function $695b3d6025d5e530$var$matrix(el, selfOnly) {
    var appliedTransforms = "";
    if (typeof el === "string") appliedTransforms = el;
    else do {
        var transform = $695b3d6025d5e530$var$css(el, "transform");
        if (transform && transform !== "none") appliedTransforms = transform + " " + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $695b3d6025d5e530$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $695b3d6025d5e530$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $695b3d6025d5e530$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $695b3d6025d5e530$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$695b3d6025d5e530$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($695b3d6025d5e530$var$css(container, "transform") !== "none" || relativeToNonStaticParent && $695b3d6025d5e530$var$css(container, "position") !== "static")) {
                var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($695b3d6025d5e530$var$css(container, "border-top-width"));
                left -= containerRect.left + parseInt($695b3d6025d5e530$var$css(container, "border-left-width"));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $695b3d6025d5e530$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $695b3d6025d5e530$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $695b3d6025d5e530$var$getParentAutoScrollElement(el, true), elSideVal = $695b3d6025d5e530$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $695b3d6025d5e530$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === "top" || parentSide === "left") visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $695b3d6025d5e530$var$getWindowScrollingElement()) break;
        parent = $695b3d6025d5e530$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $695b3d6025d5e530$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== "none" && children[i] !== $695b3d6025d5e530$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $695b3d6025d5e530$export$31b3ca70d8f57423.dragged) && $695b3d6025d5e530$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $695b3d6025d5e530$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $695b3d6025d5e530$export$31b3ca70d8f57423.ghost || $695b3d6025d5e530$var$css(last, "display") === "none" || selector && !$695b3d6025d5e530$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $695b3d6025d5e530$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== $695b3d6025d5e530$export$31b3ca70d8f57423.clone && (!selector || $695b3d6025d5e530$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $695b3d6025d5e530$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $695b3d6025d5e530$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $695b3d6025d5e530$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $695b3d6025d5e530$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $695b3d6025d5e530$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $695b3d6025d5e530$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $695b3d6025d5e530$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
            if (!elem.getBoundingClientRect || elem === document.body) return $695b3d6025d5e530$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $695b3d6025d5e530$var$getWindowScrollingElement();
}
function $695b3d6025d5e530$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $695b3d6025d5e530$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $695b3d6025d5e530$var$_throttleTimeout;
function $695b3d6025d5e530$var$throttle(callback, ms) {
    return function() {
        if (!$695b3d6025d5e530$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $695b3d6025d5e530$var$_throttleTimeout = setTimeout(function() {
                $695b3d6025d5e530$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $695b3d6025d5e530$var$cancelThrottle() {
    clearTimeout($695b3d6025d5e530$var$_throttleTimeout);
    $695b3d6025d5e530$var$_throttleTimeout = void 0;
}
function $695b3d6025d5e530$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $695b3d6025d5e530$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $695b3d6025d5e530$var$setRect(el, rect) {
    $695b3d6025d5e530$var$css(el, "position", "absolute");
    $695b3d6025d5e530$var$css(el, "top", rect.top);
    $695b3d6025d5e530$var$css(el, "left", rect.left);
    $695b3d6025d5e530$var$css(el, "width", rect.width);
    $695b3d6025d5e530$var$css(el, "height", rect.height);
}
function $695b3d6025d5e530$var$unsetRect(el) {
    $695b3d6025d5e530$var$css(el, "position", "");
    $695b3d6025d5e530$var$css(el, "top", "");
    $695b3d6025d5e530$var$css(el, "left", "");
    $695b3d6025d5e530$var$css(el, "width", "");
    $695b3d6025d5e530$var$css(el, "height", "");
}
var $695b3d6025d5e530$var$expando = "Sortable" + new Date().getTime();
function $695b3d6025d5e530$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($695b3d6025d5e530$var$css(child, "display") === "none" || child === $695b3d6025d5e530$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $695b3d6025d5e530$var$getRect(child)
                });
                var fromRect = $695b3d6025d5e530$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $695b3d6025d5e530$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($695b3d6025d5e530$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === "function") callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $695b3d6025d5e530$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $695b3d6025d5e530$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($695b3d6025d5e530$var$isRectEqual(prevFromRect, toRect) && !$695b3d6025d5e530$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $695b3d6025d5e530$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                } // if fromRect != toRect: animate
                if (!$695b3d6025d5e530$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === "function") callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === "function") callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $695b3d6025d5e530$var$css(target, "transition", "");
                $695b3d6025d5e530$var$css(target, "transform", "");
                var elMatrix = $695b3d6025d5e530$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $695b3d6025d5e530$var$css(target, "transform", "translate3d(" + translateX + "px," + translateY + "px,0)");
                this.forRepaintDummy = $695b3d6025d5e530$var$repaint(target); // repaint
                $695b3d6025d5e530$var$css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
                $695b3d6025d5e530$var$css(target, "transform", "translate3d(0,0,0)");
                typeof target.animated === "number" && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $695b3d6025d5e530$var$css(target, "transition", "");
                    $695b3d6025d5e530$var$css(target, "transform", "");
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $695b3d6025d5e530$var$repaint(target) {
    return target.offsetWidth;
}
function $695b3d6025d5e530$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $695b3d6025d5e530$var$plugins = [];
var $695b3d6025d5e530$var$defaults = {
    initializeByDefault: true
};
var $695b3d6025d5e530$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $695b3d6025d5e530$var$defaults)if ($695b3d6025d5e530$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $695b3d6025d5e530$var$defaults[option];
        $695b3d6025d5e530$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $695b3d6025d5e530$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + "Global";
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($695b3d6025d5e530$var$_objectSpread2({
                sortable: sortable
            }, evt));
             // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($695b3d6025d5e530$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized; // Add default options from plugin
            $695b3d6025d5e530$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== "undefined") sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== "function") return;
            $695b3d6025d5e530$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $695b3d6025d5e530$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $695b3d6025d5e530$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$695b3d6025d5e530$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature
    if (window.CustomEvent && !$695b3d6025d5e530$var$IE11OrLess && !$695b3d6025d5e530$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $695b3d6025d5e530$var$_objectSpread2($695b3d6025d5e530$var$_objectSpread2({}, extraEventProperties), $695b3d6025d5e530$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $695b3d6025d5e530$var$_excluded = [
    "evt"
];
var $695b3d6025d5e530$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $695b3d6025d5e530$var$_objectWithoutProperties(_ref, $695b3d6025d5e530$var$_excluded);
    $695b3d6025d5e530$var$PluginManager.pluginEvent.bind($695b3d6025d5e530$export$31b3ca70d8f57423)(eventName, sortable, $695b3d6025d5e530$var$_objectSpread2({
        dragEl: $695b3d6025d5e530$var$dragEl,
        parentEl: $695b3d6025d5e530$var$parentEl,
        ghostEl: $695b3d6025d5e530$var$ghostEl,
        rootEl: $695b3d6025d5e530$var$rootEl,
        nextEl: $695b3d6025d5e530$var$nextEl,
        lastDownEl: $695b3d6025d5e530$var$lastDownEl,
        cloneEl: $695b3d6025d5e530$var$cloneEl,
        cloneHidden: $695b3d6025d5e530$var$cloneHidden,
        dragStarted: $695b3d6025d5e530$var$moved,
        putSortable: $695b3d6025d5e530$var$putSortable,
        activeSortable: $695b3d6025d5e530$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $695b3d6025d5e530$var$oldIndex,
        oldDraggableIndex: $695b3d6025d5e530$var$oldDraggableIndex,
        newIndex: $695b3d6025d5e530$var$newIndex,
        newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex,
        hideGhostForTarget: $695b3d6025d5e530$var$_hideGhostForTarget,
        unhideGhostForTarget: $695b3d6025d5e530$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $695b3d6025d5e530$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $695b3d6025d5e530$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $695b3d6025d5e530$var$_dispatchEvent(info) {
    $695b3d6025d5e530$var$dispatchEvent($695b3d6025d5e530$var$_objectSpread2({
        putSortable: $695b3d6025d5e530$var$putSortable,
        cloneEl: $695b3d6025d5e530$var$cloneEl,
        targetEl: $695b3d6025d5e530$var$dragEl,
        rootEl: $695b3d6025d5e530$var$rootEl,
        oldIndex: $695b3d6025d5e530$var$oldIndex,
        oldDraggableIndex: $695b3d6025d5e530$var$oldDraggableIndex,
        newIndex: $695b3d6025d5e530$var$newIndex,
        newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex
    }, info));
}
var $695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$parentEl, $695b3d6025d5e530$var$ghostEl, $695b3d6025d5e530$var$rootEl, $695b3d6025d5e530$var$nextEl, $695b3d6025d5e530$var$lastDownEl, $695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$cloneHidden, $695b3d6025d5e530$var$oldIndex, $695b3d6025d5e530$var$newIndex, $695b3d6025d5e530$var$oldDraggableIndex, $695b3d6025d5e530$var$newDraggableIndex, $695b3d6025d5e530$var$activeGroup, $695b3d6025d5e530$var$putSortable, $695b3d6025d5e530$var$awaitingDragStarted = false, $695b3d6025d5e530$var$ignoreNextClick = false, $695b3d6025d5e530$var$sortables = [], $695b3d6025d5e530$var$tapEvt, $695b3d6025d5e530$var$touchEvt, $695b3d6025d5e530$var$lastDx, $695b3d6025d5e530$var$lastDy, $695b3d6025d5e530$var$tapDistanceLeft, $695b3d6025d5e530$var$tapDistanceTop, $695b3d6025d5e530$var$moved, $695b3d6025d5e530$var$lastTarget, $695b3d6025d5e530$var$lastDirection, $695b3d6025d5e530$var$pastFirstInvertThresh = false, $695b3d6025d5e530$var$isCircumstantialInvert = false, $695b3d6025d5e530$var$targetMoveDistance, // For positioning ghost absolutely
$695b3d6025d5e530$var$ghostRelativeParent, $695b3d6025d5e530$var$ghostRelativeParentInitialScroll = [], // (left, top)
$695b3d6025d5e530$var$_silent = false, $695b3d6025d5e530$var$savedInputChecked = [];
/** @const */ var $695b3d6025d5e530$var$documentExists = typeof document !== "undefined", $695b3d6025d5e530$var$PositionGhostAbsolutely = $695b3d6025d5e530$var$IOS, $695b3d6025d5e530$var$CSSFloatProperty = $695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess ? "cssFloat" : "float", // This will not pass for IE9, because IE9 DnD only works on anchors
$695b3d6025d5e530$var$supportDraggable = $695b3d6025d5e530$var$documentExists && !$695b3d6025d5e530$var$ChromeForAndroid && !$695b3d6025d5e530$var$IOS && "draggable" in document.createElement("div"), $695b3d6025d5e530$var$supportCssPointerEvents = function() {
    if (!$695b3d6025d5e530$var$documentExists) return; // false when <= IE11
    if ($695b3d6025d5e530$var$IE11OrLess) return false;
    var el = document.createElement("x");
    el.style.cssText = "pointer-events:auto";
    return el.style.pointerEvents === "auto";
}(), $695b3d6025d5e530$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $695b3d6025d5e530$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $695b3d6025d5e530$var$getChild(el, 0, options), child2 = $695b3d6025d5e530$var$getChild(el, 1, options), firstChildCSS = child1 && $695b3d6025d5e530$var$css(child1), secondChildCSS = child2 && $695b3d6025d5e530$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $695b3d6025d5e530$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $695b3d6025d5e530$var$getRect(child2).width;
    if (elCSS.display === "flex") return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
    if (elCSS.display === "grid") return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
        var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
        return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
    }
    return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[$695b3d6025d5e530$var$CSSFloatProperty] === "none" || child2 && elCSS[$695b3d6025d5e530$var$CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, $695b3d6025d5e530$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */ $695b3d6025d5e530$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $695b3d6025d5e530$var$sortables.some(function(sortable) {
        var threshold = sortable[$695b3d6025d5e530$var$expando].options.emptyInsertThreshold;
        if (!threshold || $695b3d6025d5e530$var$lastChild(sortable)) return;
        var rect = $695b3d6025d5e530$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $695b3d6025d5e530$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === "clone") return value;
            else if (typeof value === "function") return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $695b3d6025d5e530$var$_typeof(originalGroup) != "object") originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $695b3d6025d5e530$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$695b3d6025d5e530$var$supportCssPointerEvents && $695b3d6025d5e530$var$ghostEl) $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "display", "none");
}, $695b3d6025d5e530$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$695b3d6025d5e530$var$supportCssPointerEvents && $695b3d6025d5e530$var$ghostEl) $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "display", "");
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($695b3d6025d5e530$var$documentExists && !$695b3d6025d5e530$var$ChromeForAndroid) document.addEventListener("click", function(evt) {
    if ($695b3d6025d5e530$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $695b3d6025d5e530$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($695b3d6025d5e530$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $695b3d6025d5e530$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$695b3d6025d5e530$var$expando]._onDragOver(event);
        }
    }
};
var $695b3d6025d5e530$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($695b3d6025d5e530$var$dragEl) $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $695b3d6025d5e530$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $695b3d6025d5e530$var$_extends({}, options); // Export instance
    el[$695b3d6025d5e530$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $695b3d6025d5e530$var$_detectDirection(el, this.options);
        },
        ghostClass: "sortable-ghost",
        chosenClass: "sortable-chosen",
        dragClass: "sortable-drag",
        ignore: "a, img",
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData("Text", dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: "data-id",
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        supportPointer: $695b3d6025d5e530$export$31b3ca70d8f57423.supportPointer !== false && "PointerEvent" in window && !$695b3d6025d5e530$var$Safari,
        emptyInsertThreshold: 5
    };
    $695b3d6025d5e530$var$PluginManager.initializePlugins(this, el, defaults); // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $695b3d6025d5e530$var$_prepareGroup(options); // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
     // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $695b3d6025d5e530$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
     // Bind events
    if (options.supportPointer) $695b3d6025d5e530$var$on(el, "pointerdown", this._onTapStart);
    else {
        $695b3d6025d5e530$var$on(el, "mousedown", this._onTapStart);
        $695b3d6025d5e530$var$on(el, "touchstart", this._onTapStart);
    }
    if (this.nativeDraggable) {
        $695b3d6025d5e530$var$on(el, "dragover", this);
        $695b3d6025d5e530$var$on(el, "dragenter", this);
    }
    $695b3d6025d5e530$var$sortables.push(this.el); // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager
    $695b3d6025d5e530$var$_extends(this, $695b3d6025d5e530$var$AnimationStateManager());
}
$695b3d6025d5e530$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $695b3d6025d5e530$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $695b3d6025d5e530$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, $695b3d6025d5e530$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $695b3d6025d5e530$var$_saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($695b3d6025d5e530$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
         // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
         // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $695b3d6025d5e530$var$Safari && target && target.tagName.toUpperCase() === "SELECT") return;
        target = $695b3d6025d5e530$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($695b3d6025d5e530$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
         // Get the index of the dragged element within its parent
        $695b3d6025d5e530$var$oldIndex = $695b3d6025d5e530$var$index(target);
        $695b3d6025d5e530$var$oldDraggableIndex = $695b3d6025d5e530$var$index(target, options.draggable); // Check filter
        if (typeof filter === "function") {
            if (filter.call(this, evt, target, this)) {
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: "filter",
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $695b3d6025d5e530$var$pluginEvent("filter", _this, {
                    evt: evt
                });
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(",").some(function(criteria) {
                criteria = $695b3d6025d5e530$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $695b3d6025d5e530$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: "filter",
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $695b3d6025d5e530$var$pluginEvent("filter", _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.cancelable && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$695b3d6025d5e530$var$closest(originalTarget, options.handle, el, false)) return;
         // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$695b3d6025d5e530$var$dragEl && target.parentNode === el) {
            var dragRect = $695b3d6025d5e530$var$getRect(target);
            $695b3d6025d5e530$var$rootEl = el;
            $695b3d6025d5e530$var$dragEl = target;
            $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl.parentNode;
            $695b3d6025d5e530$var$nextEl = $695b3d6025d5e530$var$dragEl.nextSibling;
            $695b3d6025d5e530$var$lastDownEl = target;
            $695b3d6025d5e530$var$activeGroup = options.group;
            $695b3d6025d5e530$export$31b3ca70d8f57423.dragged = $695b3d6025d5e530$var$dragEl;
            $695b3d6025d5e530$var$tapEvt = {
                target: $695b3d6025d5e530$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $695b3d6025d5e530$var$tapDistanceLeft = $695b3d6025d5e530$var$tapEvt.clientX - dragRect.left;
            $695b3d6025d5e530$var$tapDistanceTop = $695b3d6025d5e530$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $695b3d6025d5e530$var$dragEl.style["will-change"] = "all";
            dragStartFn = function dragStartFn() {
                $695b3d6025d5e530$var$pluginEvent("delayEnded", _this, {
                    evt: evt
                });
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                } // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$695b3d6025d5e530$var$FireFox && _this.nativeDraggable) $695b3d6025d5e530$var$dragEl.draggable = true;
                 // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch); // Drag start event
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: _this,
                    name: "choose",
                    originalEvent: evt
                }); // Chosen item
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.chosenClass, true);
            }; // Disable "draggable"
            options.ignore.split(",").forEach(function(criteria) {
                $695b3d6025d5e530$var$find($695b3d6025d5e530$var$dragEl, criteria.trim(), $695b3d6025d5e530$var$_disableDraggable);
            });
            $695b3d6025d5e530$var$on(ownerDocument, "dragover", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, "mousemove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, "touchmove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
            $695b3d6025d5e530$var$on(ownerDocument, "mouseup", _this._onDrop);
            $695b3d6025d5e530$var$on(ownerDocument, "touchend", _this._onDrop);
            $695b3d6025d5e530$var$on(ownerDocument, "touchcancel", _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)
            if ($695b3d6025d5e530$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $695b3d6025d5e530$var$dragEl.draggable = true;
            }
            $695b3d6025d5e530$var$pluginEvent("delayStart", this, {
                evt: evt
            }); // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess))) {
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                } // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                $695b3d6025d5e530$var$on(ownerDocument, "mouseup", _this._disableDelayedDrag);
                $695b3d6025d5e530$var$on(ownerDocument, "touchend", _this._disableDelayedDrag);
                $695b3d6025d5e530$var$on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
                $695b3d6025d5e530$var$on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
                $695b3d6025d5e530$var$on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
                options.supportPointer && $695b3d6025d5e530$var$on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $695b3d6025d5e530$var$dragEl && $695b3d6025d5e530$var$_disableDraggable($695b3d6025d5e530$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $695b3d6025d5e530$var$off(ownerDocument, "mouseup", this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, "touchend", this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, "touchcancel", this._disableDelayedDrag);
        $695b3d6025d5e530$var$off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
        $695b3d6025d5e530$var$off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
        $695b3d6025d5e530$var$off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == "touch" && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $695b3d6025d5e530$var$on(document, "pointermove", this._onTouchMove);
            else if (touch) $695b3d6025d5e530$var$on(document, "touchmove", this._onTouchMove);
            else $695b3d6025d5e530$var$on(document, "mousemove", this._onTouchMove);
        } else {
            $695b3d6025d5e530$var$on($695b3d6025d5e530$var$dragEl, "dragend", this);
            $695b3d6025d5e530$var$on($695b3d6025d5e530$var$rootEl, "dragstart", this._onDragStart);
        }
        try {
            if (document.selection) // Timeout neccessary for IE9
            $695b3d6025d5e530$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $695b3d6025d5e530$var$awaitingDragStarted = false;
        if ($695b3d6025d5e530$var$rootEl && $695b3d6025d5e530$var$dragEl) {
            $695b3d6025d5e530$var$pluginEvent("dragStarted", this, {
                evt: evt
            });
            if (this.nativeDraggable) $695b3d6025d5e530$var$on(document, "dragover", $695b3d6025d5e530$var$_checkOutsideTargetEl);
            var options = this.options; // Apply effect
            !fallback && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.dragClass, false);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.ghostClass, true);
            $695b3d6025d5e530$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost(); // Drag start event
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: this,
                name: "start",
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($695b3d6025d5e530$var$touchEvt) {
            this._lastX = $695b3d6025d5e530$var$touchEvt.clientX;
            this._lastY = $695b3d6025d5e530$var$touchEvt.clientY;
            $695b3d6025d5e530$var$_hideGhostForTarget();
            var target = document.elementFromPoint($695b3d6025d5e530$var$touchEvt.clientX, $695b3d6025d5e530$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($695b3d6025d5e530$var$touchEvt.clientX, $695b3d6025d5e530$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$695b3d6025d5e530$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$695b3d6025d5e530$var$expando]._onDragOver({
                        clientX: $695b3d6025d5e530$var$touchEvt.clientX,
                        clientY: $695b3d6025d5e530$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = parent.parentNode);
            $695b3d6025d5e530$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($695b3d6025d5e530$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $695b3d6025d5e530$var$ghostEl && $695b3d6025d5e530$var$matrix($695b3d6025d5e530$var$ghostEl, true), scaleX = $695b3d6025d5e530$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $695b3d6025d5e530$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $695b3d6025d5e530$var$PositionGhostAbsolutely && $695b3d6025d5e530$var$ghostRelativeParent && $695b3d6025d5e530$var$getRelativeScrollOffset($695b3d6025d5e530$var$ghostRelativeParent), dx = (touch.clientX - $695b3d6025d5e530$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $695b3d6025d5e530$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $695b3d6025d5e530$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $695b3d6025d5e530$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging
            if (!$695b3d6025d5e530$export$31b3ca70d8f57423.active && !$695b3d6025d5e530$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($695b3d6025d5e530$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($695b3d6025d5e530$var$lastDx || 0);
                    ghostMatrix.f += dy - ($695b3d6025d5e530$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "webkitTransform", cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "mozTransform", cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "msTransform", cssMatrix);
                $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transform", cssMatrix);
                $695b3d6025d5e530$var$lastDx = dx;
                $695b3d6025d5e530$var$lastDy = dy;
                $695b3d6025d5e530$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$695b3d6025d5e530$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $695b3d6025d5e530$var$rootEl, rect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl, true, $695b3d6025d5e530$var$PositionGhostAbsolutely, true, container), options = this.options; // Position absolutely
            if ($695b3d6025d5e530$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $695b3d6025d5e530$var$ghostRelativeParent = container;
                while($695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostRelativeParent, "position") === "static" && $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostRelativeParent, "transform") === "none" && $695b3d6025d5e530$var$ghostRelativeParent !== document)$695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$ghostRelativeParent.parentNode;
                if ($695b3d6025d5e530$var$ghostRelativeParent !== document.body && $695b3d6025d5e530$var$ghostRelativeParent !== document.documentElement) {
                    if ($695b3d6025d5e530$var$ghostRelativeParent === document) $695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$getWindowScrollingElement();
                    rect.top += $695b3d6025d5e530$var$ghostRelativeParent.scrollTop;
                    rect.left += $695b3d6025d5e530$var$ghostRelativeParent.scrollLeft;
                } else $695b3d6025d5e530$var$ghostRelativeParent = $695b3d6025d5e530$var$getWindowScrollingElement();
                $695b3d6025d5e530$var$ghostRelativeParentInitialScroll = $695b3d6025d5e530$var$getRelativeScrollOffset($695b3d6025d5e530$var$ghostRelativeParent);
            }
            $695b3d6025d5e530$var$ghostEl = $695b3d6025d5e530$var$dragEl.cloneNode(true);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.ghostClass, false);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.fallbackClass, true);
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$ghostEl, options.dragClass, true);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transition", "");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transform", "");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "box-sizing", "border-box");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "margin", 0);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "top", rect.top);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "left", rect.left);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "width", rect.width);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "height", rect.height);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "opacity", "0.8");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "position", $695b3d6025d5e530$var$PositionGhostAbsolutely ? "absolute" : "fixed");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "zIndex", "100000");
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "pointerEvents", "none");
            $695b3d6025d5e530$export$31b3ca70d8f57423.ghost = $695b3d6025d5e530$var$ghostEl;
            container.appendChild($695b3d6025d5e530$var$ghostEl); // Set transform-origin
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$ghostEl, "transform-origin", $695b3d6025d5e530$var$tapDistanceLeft / parseInt($695b3d6025d5e530$var$ghostEl.style.width) * 100 + "% " + $695b3d6025d5e530$var$tapDistanceTop / parseInt($695b3d6025d5e530$var$ghostEl.style.height) * 100 + "%");
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $695b3d6025d5e530$var$pluginEvent("dragStart", this, {
            evt: evt
        });
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $695b3d6025d5e530$var$pluginEvent("setupClone", this);
        if (!$695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            $695b3d6025d5e530$var$cloneEl = $695b3d6025d5e530$var$clone($695b3d6025d5e530$var$dragEl);
            $695b3d6025d5e530$var$cloneEl.removeAttribute("id");
            $695b3d6025d5e530$var$cloneEl.draggable = false;
            $695b3d6025d5e530$var$cloneEl.style["will-change"] = "";
            this._hideClone();
            $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$cloneEl, this.options.chosenClass, false);
            $695b3d6025d5e530$export$31b3ca70d8f57423.clone = $695b3d6025d5e530$var$cloneEl;
        } // #1143: IFrame support workaround
        _this.cloneId = $695b3d6025d5e530$var$_nextTick(function() {
            $695b3d6025d5e530$var$pluginEvent("clone", _this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$dragEl);
            _this._hideClone();
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: _this,
                name: "clone"
            });
        });
        !fallback && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.dragClass, true); // Set proper drop events
        if (fallback) {
            $695b3d6025d5e530$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $695b3d6025d5e530$var$off(document, "mouseup", _this._onDrop);
            $695b3d6025d5e530$var$off(document, "touchend", _this._onDrop);
            $695b3d6025d5e530$var$off(document, "touchcancel", _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = "move";
                options.setData && options.setData.call(_this, dataTransfer, $695b3d6025d5e530$var$dragEl);
            }
            $695b3d6025d5e530$var$on(document, "drop", _this); // #1276 fix:
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$dragEl, "transform", "translateZ(0)");
        }
        $695b3d6025d5e530$var$awaitingDragStarted = true;
        _this._dragStartId = $695b3d6025d5e530$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $695b3d6025d5e530$var$on(document, "selectstart", _this);
        $695b3d6025d5e530$var$moved = true;
        if ($695b3d6025d5e530$var$Safari) $695b3d6025d5e530$var$css(document.body, "user-select", "none");
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $695b3d6025d5e530$export$31b3ca70d8f57423.active, isOwner = $695b3d6025d5e530$var$activeGroup === group, canSort = options.sort, fromSortable = $695b3d6025d5e530$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($695b3d6025d5e530$var$_silent) return;
        function dragOverEvent(name, extra) {
            $695b3d6025d5e530$var$pluginEvent(name, _this, $695b3d6025d5e530$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? "vertical" : "horizontal",
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, $695b3d6025d5e530$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        } // Capture animation state
        function capture() {
            dragOverEvent("dragOverAnimationCapture");
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        } // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent("dragOverCompleted", {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$putSortable ? $695b3d6025d5e530$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, options.ghostClass, true);
                }
                if ($695b3d6025d5e530$var$putSortable !== _this && _this !== $695b3d6025d5e530$export$31b3ca70d8f57423.active) $695b3d6025d5e530$var$putSortable = _this;
                else if (_this === $695b3d6025d5e530$export$31b3ca70d8f57423.active && $695b3d6025d5e530$var$putSortable) $695b3d6025d5e530$var$putSortable = null;
                 // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent("dragOverAnimationComplete");
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            } // Null lastTarget if it is not inside a previously swapped element
            if (target === $695b3d6025d5e530$var$dragEl && !$695b3d6025d5e530$var$dragEl.animated || target === el && !target.animated) $695b3d6025d5e530$var$lastTarget = null;
             // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $695b3d6025d5e530$var$dragEl.parentNode[$695b3d6025d5e530$var$expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted
                !insertion && $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        } // Call when dragEl has been inserted
        function changed() {
            $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
            $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
            $695b3d6025d5e530$var$_dispatchEvent({
                sortable: _this,
                name: "change",
                toEl: el,
                newIndex: $695b3d6025d5e530$var$newIndex,
                newDraggableIndex: $695b3d6025d5e530$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $695b3d6025d5e530$var$closest(target, options.draggable, el, true);
        dragOverEvent("dragOver");
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($695b3d6025d5e530$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $695b3d6025d5e530$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $695b3d6025d5e530$var$parentEl !== $695b3d6025d5e530$var$rootEl // Reverting item into the original list
        ) : $695b3d6025d5e530$var$putSortable === this || (this.lastPutMode = $695b3d6025d5e530$var$activeGroup.checkPull(this, activeSortable, $695b3d6025d5e530$var$dragEl, evt)) && group.checkPut(this, activeSortable, $695b3d6025d5e530$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === "vertical";
            dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl);
            dragOverEvent("dragOverValid");
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent("revert");
                if (!$695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
                    if ($695b3d6025d5e530$var$nextEl) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$nextEl);
                    else $695b3d6025d5e530$var$rootEl.appendChild($695b3d6025d5e530$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $695b3d6025d5e530$var$lastChild(el, options.draggable);
            if (!elLastChild || $695b3d6025d5e530$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $695b3d6025d5e530$var$dragEl) return completed(false);
                 // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $695b3d6025d5e530$var$getRect(target);
                if ($695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($695b3d6025d5e530$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($695b3d6025d5e530$var$dragEl);
                    $695b3d6025d5e530$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $695b3d6025d5e530$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $695b3d6025d5e530$var$getChild(el, 0, options, true);
                if (firstChild === $695b3d6025d5e530$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $695b3d6025d5e530$var$getRect(target);
                if ($695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($695b3d6025d5e530$var$dragEl, firstChild);
                    $695b3d6025d5e530$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $695b3d6025d5e530$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $695b3d6025d5e530$var$dragEl.parentNode !== el, differentRowCol = !$695b3d6025d5e530$var$_dragElInRowColumn($695b3d6025d5e530$var$dragEl.animated && $695b3d6025d5e530$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = $695b3d6025d5e530$var$isScrolledPast(target, "top", "top") || $695b3d6025d5e530$var$isScrolledPast($695b3d6025d5e530$var$dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($695b3d6025d5e530$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $695b3d6025d5e530$var$pastFirstInvertThresh = false;
                    $695b3d6025d5e530$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $695b3d6025d5e530$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $695b3d6025d5e530$var$isCircumstantialInvert, $695b3d6025d5e530$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $695b3d6025d5e530$var$parentEl.children[dragIndex];
                    }while (sibling && ($695b3d6025d5e530$var$css(sibling, "display") === "none" || sibling === $695b3d6025d5e530$var$ghostEl));
                } // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $695b3d6025d5e530$var$lastTarget = target;
                $695b3d6025d5e530$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $695b3d6025d5e530$var$_onMove($695b3d6025d5e530$var$rootEl, el, $695b3d6025d5e530$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $695b3d6025d5e530$var$_silent = true;
                    setTimeout($695b3d6025d5e530$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($695b3d6025d5e530$var$dragEl);
                    else target.parentNode.insertBefore($695b3d6025d5e530$var$dragEl, after ? nextSibling : target);
                     // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $695b3d6025d5e530$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$695b3d6025d5e530$var$isCircumstantialInvert) $695b3d6025d5e530$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $695b3d6025d5e530$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($695b3d6025d5e530$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $695b3d6025d5e530$var$off(document, "mousemove", this._onTouchMove);
        $695b3d6025d5e530$var$off(document, "touchmove", this._onTouchMove);
        $695b3d6025d5e530$var$off(document, "pointermove", this._onTouchMove);
        $695b3d6025d5e530$var$off(document, "dragover", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
        $695b3d6025d5e530$var$off(document, "mousemove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
        $695b3d6025d5e530$var$off(document, "touchmove", $695b3d6025d5e530$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $695b3d6025d5e530$var$off(ownerDocument, "mouseup", this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, "touchend", this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, "pointerup", this._onDrop);
        $695b3d6025d5e530$var$off(ownerDocument, "touchcancel", this._onDrop);
        $695b3d6025d5e530$var$off(document, "selectstart", this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options; // Get the index of the dragged element within its parent
        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
        $695b3d6025d5e530$var$pluginEvent("drop", this, {
            evt: evt
        });
        $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$dragEl && $695b3d6025d5e530$var$dragEl.parentNode; // Get again after plugin event
        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl);
        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl, options.draggable);
        if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $695b3d6025d5e530$var$awaitingDragStarted = false;
        $695b3d6025d5e530$var$isCircumstantialInvert = false;
        $695b3d6025d5e530$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $695b3d6025d5e530$var$_cancelNextTick(this.cloneId);
        $695b3d6025d5e530$var$_cancelNextTick(this._dragStartId); // Unbind events
        if (this.nativeDraggable) {
            $695b3d6025d5e530$var$off(document, "drop", this);
            $695b3d6025d5e530$var$off(el, "dragstart", this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($695b3d6025d5e530$var$Safari) $695b3d6025d5e530$var$css(document.body, "user-select", "");
        $695b3d6025d5e530$var$css($695b3d6025d5e530$var$dragEl, "transform", "");
        if (evt) {
            if ($695b3d6025d5e530$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $695b3d6025d5e530$var$ghostEl && $695b3d6025d5e530$var$ghostEl.parentNode && $695b3d6025d5e530$var$ghostEl.parentNode.removeChild($695b3d6025d5e530$var$ghostEl);
            if ($695b3d6025d5e530$var$rootEl === $695b3d6025d5e530$var$parentEl || $695b3d6025d5e530$var$putSortable && $695b3d6025d5e530$var$putSortable.lastPutMode !== "clone") // Remove clone(s)
            $695b3d6025d5e530$var$cloneEl && $695b3d6025d5e530$var$cloneEl.parentNode && $695b3d6025d5e530$var$cloneEl.parentNode.removeChild($695b3d6025d5e530$var$cloneEl);
            if ($695b3d6025d5e530$var$dragEl) {
                if (this.nativeDraggable) $695b3d6025d5e530$var$off($695b3d6025d5e530$var$dragEl, "dragend", this);
                $695b3d6025d5e530$var$_disableDraggable($695b3d6025d5e530$var$dragEl);
                $695b3d6025d5e530$var$dragEl.style["will-change"] = ""; // Remove classes
                // ghostClass is added in dragStarted
                if ($695b3d6025d5e530$var$moved && !$695b3d6025d5e530$var$awaitingDragStarted) $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$putSortable ? $695b3d6025d5e530$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl, this.options.chosenClass, false); // Drag stop event
                $695b3d6025d5e530$var$_dispatchEvent({
                    sortable: this,
                    name: "unchoose",
                    toEl: $695b3d6025d5e530$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($695b3d6025d5e530$var$rootEl !== $695b3d6025d5e530$var$parentEl) {
                    if ($695b3d6025d5e530$var$newIndex >= 0) {
                        // Add event
                        $695b3d6025d5e530$var$_dispatchEvent({
                            rootEl: $695b3d6025d5e530$var$parentEl,
                            name: "add",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            fromEl: $695b3d6025d5e530$var$rootEl,
                            originalEvent: evt
                        }); // Remove event
                        $695b3d6025d5e530$var$_dispatchEvent({
                            sortable: this,
                            name: "remove",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            originalEvent: evt
                        }); // drag from one list and drop into another
                        $695b3d6025d5e530$var$_dispatchEvent({
                            rootEl: $695b3d6025d5e530$var$parentEl,
                            name: "sort",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            fromEl: $695b3d6025d5e530$var$rootEl,
                            originalEvent: evt
                        });
                        $695b3d6025d5e530$var$_dispatchEvent({
                            sortable: this,
                            name: "sort",
                            toEl: $695b3d6025d5e530$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $695b3d6025d5e530$var$putSortable && $695b3d6025d5e530$var$putSortable.save();
                } else {
                    if ($695b3d6025d5e530$var$newIndex !== $695b3d6025d5e530$var$oldIndex) {
                        if ($695b3d6025d5e530$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $695b3d6025d5e530$var$_dispatchEvent({
                                sortable: this,
                                name: "update",
                                toEl: $695b3d6025d5e530$var$parentEl,
                                originalEvent: evt
                            });
                            $695b3d6025d5e530$var$_dispatchEvent({
                                sortable: this,
                                name: "sort",
                                toEl: $695b3d6025d5e530$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($695b3d6025d5e530$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($695b3d6025d5e530$var$newIndex == null || $695b3d6025d5e530$var$newIndex === -1) {
                        $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$oldIndex;
                        $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$oldDraggableIndex;
                    }
                    $695b3d6025d5e530$var$_dispatchEvent({
                        sortable: this,
                        name: "end",
                        toEl: $695b3d6025d5e530$var$parentEl,
                        originalEvent: evt
                    }); // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $695b3d6025d5e530$var$pluginEvent("nulling", this);
        $695b3d6025d5e530$var$rootEl = $695b3d6025d5e530$var$dragEl = $695b3d6025d5e530$var$parentEl = $695b3d6025d5e530$var$ghostEl = $695b3d6025d5e530$var$nextEl = $695b3d6025d5e530$var$cloneEl = $695b3d6025d5e530$var$lastDownEl = $695b3d6025d5e530$var$cloneHidden = $695b3d6025d5e530$var$tapEvt = $695b3d6025d5e530$var$touchEvt = $695b3d6025d5e530$var$moved = $695b3d6025d5e530$var$newIndex = $695b3d6025d5e530$var$newDraggableIndex = $695b3d6025d5e530$var$oldIndex = $695b3d6025d5e530$var$oldDraggableIndex = $695b3d6025d5e530$var$lastTarget = $695b3d6025d5e530$var$lastDirection = $695b3d6025d5e530$var$putSortable = $695b3d6025d5e530$var$activeGroup = $695b3d6025d5e530$export$31b3ca70d8f57423.dragged = $695b3d6025d5e530$export$31b3ca70d8f57423.ghost = $695b3d6025d5e530$export$31b3ca70d8f57423.clone = $695b3d6025d5e530$export$31b3ca70d8f57423.active = null;
        $695b3d6025d5e530$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $695b3d6025d5e530$var$savedInputChecked.length = $695b3d6025d5e530$var$lastDx = $695b3d6025d5e530$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case "drop":
            case "dragend":
                this._onDrop(evt);
                break;
            case "dragenter":
            case "dragover":
                if ($695b3d6025d5e530$var$dragEl) {
                    this._onDragOver(evt);
                    $695b3d6025d5e530$var$_globalDragOver(evt);
                }
                break;
            case "selectstart":
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($695b3d6025d5e530$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $695b3d6025d5e530$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($695b3d6025d5e530$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $695b3d6025d5e530$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $695b3d6025d5e530$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== "undefined") options[name] = modifiedValue;
            else options[name] = value;
            if (name === "group") $695b3d6025d5e530$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $695b3d6025d5e530$var$pluginEvent("destroy", this);
        var el = this.el;
        el[$695b3d6025d5e530$var$expando] = null;
        $695b3d6025d5e530$var$off(el, "mousedown", this._onTapStart);
        $695b3d6025d5e530$var$off(el, "touchstart", this._onTapStart);
        $695b3d6025d5e530$var$off(el, "pointerdown", this._onTapStart);
        if (this.nativeDraggable) {
            $695b3d6025d5e530$var$off(el, "dragover", this);
            $695b3d6025d5e530$var$off(el, "dragenter", this);
        } // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el) {
            el.removeAttribute("draggable");
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $695b3d6025d5e530$var$sortables.splice($695b3d6025d5e530$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$695b3d6025d5e530$var$cloneHidden) {
            $695b3d6025d5e530$var$pluginEvent("hideClone", this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return;
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$cloneEl, "display", "none");
            if (this.options.removeCloneOnHide && $695b3d6025d5e530$var$cloneEl.parentNode) $695b3d6025d5e530$var$cloneEl.parentNode.removeChild($695b3d6025d5e530$var$cloneEl);
            $695b3d6025d5e530$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== "clone") {
            this._hideClone();
            return;
        }
        if ($695b3d6025d5e530$var$cloneHidden) {
            $695b3d6025d5e530$var$pluginEvent("showClone", this);
            if ($695b3d6025d5e530$export$31b3ca70d8f57423.eventCanceled) return; // show clone at dragEl or original position
            if ($695b3d6025d5e530$var$dragEl.parentNode == $695b3d6025d5e530$var$rootEl && !this.options.group.revertClone) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$dragEl);
            else if ($695b3d6025d5e530$var$nextEl) $695b3d6025d5e530$var$rootEl.insertBefore($695b3d6025d5e530$var$cloneEl, $695b3d6025d5e530$var$nextEl);
            else $695b3d6025d5e530$var$rootEl.appendChild($695b3d6025d5e530$var$cloneEl);
            if (this.options.group.revertClone) this.animate($695b3d6025d5e530$var$dragEl, $695b3d6025d5e530$var$cloneEl);
            $695b3d6025d5e530$var$css($695b3d6025d5e530$var$cloneEl, "display", "");
            $695b3d6025d5e530$var$cloneHidden = false;
        }
    }
};
function $695b3d6025d5e530$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = "move";
    evt.cancelable && evt.preventDefault();
}
function $695b3d6025d5e530$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$695b3d6025d5e530$var$expando], onMoveFn = sortable.options.onMove, retVal; // Support for new CustomEvent feature
    if (window.CustomEvent && !$695b3d6025d5e530$var$IE11OrLess && !$695b3d6025d5e530$var$Edge) evt = new CustomEvent("move", {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent("Event");
        evt.initEvent("move", true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $695b3d6025d5e530$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $695b3d6025d5e530$var$_disableDraggable(el) {
    el.draggable = false;
}
function $695b3d6025d5e530$var$_unsilent() {
    $695b3d6025d5e530$var$_silent = false;
}
function $695b3d6025d5e530$var$_ghostIsFirst(evt, vertical, sortable) {
    var rect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$getChild(sortable.el, 0, sortable.options, true));
    var spacer = 10;
    return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function $695b3d6025d5e530$var$_ghostIsLast(evt, vertical, sortable) {
    var rect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$lastChild(sortable.el, sortable.options.draggable));
    var spacer = 10;
    return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function $695b3d6025d5e530$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $695b3d6025d5e530$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$695b3d6025d5e530$var$pastFirstInvertThresh && ($695b3d6025d5e530$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $695b3d6025d5e530$var$pastFirstInvertThresh = true;
            if (!$695b3d6025d5e530$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($695b3d6025d5e530$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $695b3d6025d5e530$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $695b3d6025d5e530$var$targetMoveDistance) return -$695b3d6025d5e530$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $695b3d6025d5e530$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $695b3d6025d5e530$var$_getInsertDirection(target) {
    if ($695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl) < $695b3d6025d5e530$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $695b3d6025d5e530$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $695b3d6025d5e530$var$_saveInputCheckedState(root) {
    $695b3d6025d5e530$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName("input");
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $695b3d6025d5e530$var$savedInputChecked.push(el);
    }
}
function $695b3d6025d5e530$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $695b3d6025d5e530$var$_cancelNextTick(id) {
    return clearTimeout(id);
} // Fixed #973:
if ($695b3d6025d5e530$var$documentExists) $695b3d6025d5e530$var$on(document, "touchmove", function(evt) {
    if (($695b3d6025d5e530$export$31b3ca70d8f57423.active || $695b3d6025d5e530$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
 // Export utils
$695b3d6025d5e530$export$31b3ca70d8f57423.utils = {
    on: $695b3d6025d5e530$var$on,
    off: $695b3d6025d5e530$var$off,
    css: $695b3d6025d5e530$var$css,
    find: $695b3d6025d5e530$var$find,
    is: function is(el, selector) {
        return !!$695b3d6025d5e530$var$closest(el, selector, el, false);
    },
    extend: $695b3d6025d5e530$var$extend,
    throttle: $695b3d6025d5e530$var$throttle,
    closest: $695b3d6025d5e530$var$closest,
    toggleClass: $695b3d6025d5e530$var$toggleClass,
    clone: $695b3d6025d5e530$var$clone,
    index: $695b3d6025d5e530$var$index,
    nextTick: $695b3d6025d5e530$var$_nextTick,
    cancelNextTick: $695b3d6025d5e530$var$_cancelNextTick,
    detectDirection: $695b3d6025d5e530$var$_detectDirection,
    getChild: $695b3d6025d5e530$var$getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.get = function(element) {
    return element[$695b3d6025d5e530$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $695b3d6025d5e530$export$31b3ca70d8f57423.utils = $695b3d6025d5e530$var$_objectSpread2($695b3d6025d5e530$var$_objectSpread2({}, $695b3d6025d5e530$export$31b3ca70d8f57423.utils), plugin.utils);
        $695b3d6025d5e530$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $695b3d6025d5e530$export$31b3ca70d8f57423.create = function(el, options) {
    return new $695b3d6025d5e530$export$31b3ca70d8f57423(el, options);
}; // Export
$695b3d6025d5e530$export$31b3ca70d8f57423.version = $695b3d6025d5e530$var$version;
var $695b3d6025d5e530$var$autoScrolls = [], $695b3d6025d5e530$var$scrollEl, $695b3d6025d5e530$var$scrollRootEl, $695b3d6025d5e530$var$scrolling = false, $695b3d6025d5e530$var$lastAutoScrollX, $695b3d6025d5e530$var$lastAutoScrollY, $695b3d6025d5e530$var$touchEvt$1, $695b3d6025d5e530$var$pointerElemChangedInterval;
function $695b3d6025d5e530$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        }; // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $695b3d6025d5e530$var$on(document, "dragover", this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $695b3d6025d5e530$var$on(document, "pointermove", this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $695b3d6025d5e530$var$on(document, "touchmove", this._handleFallbackAutoScroll);
                else $695b3d6025d5e530$var$on(document, "mousemove", this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $695b3d6025d5e530$var$off(document, "dragover", this._handleAutoScroll);
            else {
                $695b3d6025d5e530$var$off(document, "pointermove", this._handleFallbackAutoScroll);
                $695b3d6025d5e530$var$off(document, "touchmove", this._handleFallbackAutoScroll);
                $695b3d6025d5e530$var$off(document, "mousemove", this._handleFallbackAutoScroll);
            }
            $695b3d6025d5e530$var$clearPointerElemChangedInterval();
            $695b3d6025d5e530$var$clearAutoScrolls();
            $695b3d6025d5e530$var$cancelThrottle();
        },
        nulling: function nulling() {
            $695b3d6025d5e530$var$touchEvt$1 = $695b3d6025d5e530$var$scrollRootEl = $695b3d6025d5e530$var$scrollEl = $695b3d6025d5e530$var$scrolling = $695b3d6025d5e530$var$pointerElemChangedInterval = $695b3d6025d5e530$var$lastAutoScrollX = $695b3d6025d5e530$var$lastAutoScrollY = null;
            $695b3d6025d5e530$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $695b3d6025d5e530$var$touchEvt$1 = evt; // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $695b3d6025d5e530$var$Edge || $695b3d6025d5e530$var$IE11OrLess || $695b3d6025d5e530$var$Safari) {
                $695b3d6025d5e530$var$autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change
                var ogElemScroller = $695b3d6025d5e530$var$getParentAutoScrollElement(elem, true);
                if ($695b3d6025d5e530$var$scrolling && (!$695b3d6025d5e530$var$pointerElemChangedInterval || x !== $695b3d6025d5e530$var$lastAutoScrollX || y !== $695b3d6025d5e530$var$lastAutoScrollY)) {
                    $695b3d6025d5e530$var$pointerElemChangedInterval && $695b3d6025d5e530$var$clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour
                    $695b3d6025d5e530$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $695b3d6025d5e530$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $695b3d6025d5e530$var$clearAutoScrolls();
                        }
                        $695b3d6025d5e530$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $695b3d6025d5e530$var$lastAutoScrollX = x;
                    $695b3d6025d5e530$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $695b3d6025d5e530$var$getParentAutoScrollElement(elem, true) === $695b3d6025d5e530$var$getWindowScrollingElement()) {
                    $695b3d6025d5e530$var$clearAutoScrolls();
                    return;
                }
                $695b3d6025d5e530$var$autoScroll(evt, this.options, $695b3d6025d5e530$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $695b3d6025d5e530$var$_extends(AutoScroll, {
        pluginName: "scroll",
        initializeByDefault: true
    });
}
function $695b3d6025d5e530$var$clearAutoScrolls() {
    $695b3d6025d5e530$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $695b3d6025d5e530$var$autoScrolls = [];
}
function $695b3d6025d5e530$var$clearPointerElemChangedInterval() {
    clearInterval($695b3d6025d5e530$var$pointerElemChangedInterval);
}
var $695b3d6025d5e530$var$autoScroll = $695b3d6025d5e530$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $695b3d6025d5e530$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn; // New scroll root, set scrollEl
    if ($695b3d6025d5e530$var$scrollRootEl !== rootEl) {
        $695b3d6025d5e530$var$scrollRootEl = rootEl;
        $695b3d6025d5e530$var$clearAutoScrolls();
        $695b3d6025d5e530$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($695b3d6025d5e530$var$scrollEl === true) $695b3d6025d5e530$var$scrollEl = $695b3d6025d5e530$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $695b3d6025d5e530$var$scrollEl;
    do {
        var el = currentParent, rect = $695b3d6025d5e530$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $695b3d6025d5e530$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
            canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$695b3d6025d5e530$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$695b3d6025d5e530$var$autoScrolls[i]) $695b3d6025d5e530$var$autoScrolls[i] = {};
        }
        if ($695b3d6025d5e530$var$autoScrolls[layersOut].vx != vx || $695b3d6025d5e530$var$autoScrolls[layersOut].vy != vy || $695b3d6025d5e530$var$autoScrolls[layersOut].el !== el) {
            $695b3d6025d5e530$var$autoScrolls[layersOut].el = el;
            $695b3d6025d5e530$var$autoScrolls[layersOut].vx = vx;
            $695b3d6025d5e530$var$autoScrolls[layersOut].vy = vy;
            clearInterval($695b3d6025d5e530$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $695b3d6025d5e530$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $695b3d6025d5e530$export$31b3ca70d8f57423.active._onTouchMove($695b3d6025d5e530$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $695b3d6025d5e530$var$autoScrolls[this.layer].vy ? $695b3d6025d5e530$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $695b3d6025d5e530$var$autoScrolls[this.layer].vx ? $695b3d6025d5e530$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === "function") {
                        if (scrollCustomFn.call($695b3d6025d5e530$export$31b3ca70d8f57423.dragged.parentNode[$695b3d6025d5e530$var$expando], scrollOffsetX, scrollOffsetY, evt, $695b3d6025d5e530$var$touchEvt$1, $695b3d6025d5e530$var$autoScrolls[this.layer].el) !== "continue") return;
                    }
                    $695b3d6025d5e530$var$scrollBy($695b3d6025d5e530$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $695b3d6025d5e530$var$getParentAutoScrollElement(currentParent, false)));
    $695b3d6025d5e530$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $695b3d6025d5e530$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent("spill");
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $695b3d6025d5e530$var$Revert() {}
$695b3d6025d5e530$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $695b3d6025d5e530$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $695b3d6025d5e530$var$drop
};
$695b3d6025d5e530$var$_extends($695b3d6025d5e530$var$Revert, {
    pluginName: "revertOnSpill"
});
function $695b3d6025d5e530$var$Remove() {}
$695b3d6025d5e530$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $695b3d6025d5e530$var$drop
};
$695b3d6025d5e530$var$_extends($695b3d6025d5e530$var$Remove, {
    pluginName: "removeOnSpill"
});
var $695b3d6025d5e530$var$lastSwapEl;
function $695b3d6025d5e530$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: "sortable-swap-highlight"
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $695b3d6025d5e530$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $695b3d6025d5e530$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $695b3d6025d5e530$var$toggleClass(target, options.swapClass, true);
                    $695b3d6025d5e530$var$lastSwapEl = target;
                } else $695b3d6025d5e530$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $695b3d6025d5e530$var$lastSwapEl) $695b3d6025d5e530$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $695b3d6025d5e530$var$lastSwapEl && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$lastSwapEl, options.swapClass, false);
            if ($695b3d6025d5e530$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $695b3d6025d5e530$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $695b3d6025d5e530$var$swapNodes(dragEl, $695b3d6025d5e530$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $695b3d6025d5e530$var$lastSwapEl = null;
        }
    };
    return $695b3d6025d5e530$var$_extends(Swap, {
        pluginName: "swap",
        eventProperties: function eventProperties() {
            return {
                swapItem: $695b3d6025d5e530$var$lastSwapEl
            };
        }
    });
}
function $695b3d6025d5e530$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $695b3d6025d5e530$var$index(n1);
    i2 = $695b3d6025d5e530$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $695b3d6025d5e530$var$multiDragElements = [], $695b3d6025d5e530$var$multiDragClones = [], $695b3d6025d5e530$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$695b3d6025d5e530$var$multiDragSortable, $695b3d6025d5e530$var$initialFolding = false, // Initial multi-drag fold when drag started
$695b3d6025d5e530$var$folding = false, // Folding any other time
$695b3d6025d5e530$var$dragStarted = false, $695b3d6025d5e530$var$dragEl$1, $695b3d6025d5e530$var$clonesFromRect, $695b3d6025d5e530$var$clonesHidden;
function $695b3d6025d5e530$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === "_" && typeof this[fn] === "function") this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $695b3d6025d5e530$var$on(document, "pointerup", this._deselectMultiDrag);
            else {
                $695b3d6025d5e530$var$on(document, "mouseup", this._deselectMultiDrag);
                $695b3d6025d5e530$var$on(document, "touchend", this._deselectMultiDrag);
            }
        }
        $695b3d6025d5e530$var$on(document, "keydown", this._checkKeyDown);
        $695b3d6025d5e530$var$on(document, "keyup", this._checkKeyUp);
        this.defaults = {
            selectedClass: "sortable-selected",
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = "";
                if ($695b3d6025d5e530$var$multiDragElements.length && $695b3d6025d5e530$var$multiDragSortable === sortable) $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? "" : ", ") + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData("Text", data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $695b3d6025d5e530$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $695b3d6025d5e530$var$multiDragElements.length; i++){
                $695b3d6025d5e530$var$multiDragClones.push($695b3d6025d5e530$var$clone($695b3d6025d5e530$var$multiDragElements[i]));
                $695b3d6025d5e530$var$multiDragClones[i].sortableIndex = $695b3d6025d5e530$var$multiDragElements[i].sortableIndex;
                $695b3d6025d5e530$var$multiDragClones[i].draggable = false;
                $695b3d6025d5e530$var$multiDragClones[i].style["will-change"] = "";
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$multiDragClones[i], this.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements[i] === $695b3d6025d5e530$var$dragEl$1 && $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($695b3d6025d5e530$var$multiDragElements.length && $695b3d6025d5e530$var$multiDragSortable === sortable) {
                    $695b3d6025d5e530$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent("clone");
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $695b3d6025d5e530$var$insertMultiDragClones(false, rootEl);
            $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                $695b3d6025d5e530$var$css(clone, "display", "");
            });
            cloneNowShown();
            $695b3d6025d5e530$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                $695b3d6025d5e530$var$css(clone, "display", "none");
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $695b3d6025d5e530$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $695b3d6025d5e530$var$multiDragSortable) $695b3d6025d5e530$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $695b3d6025d5e530$var$index(multiDragElement);
            }); // Sort multi-drag elements
            $695b3d6025d5e530$var$multiDragElements = $695b3d6025d5e530$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $695b3d6025d5e530$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$css(multiDragElement, "position", "absolute");
                    });
                    var dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1, false, true, true);
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$setRect(multiDragElement, dragRect);
                    });
                    $695b3d6025d5e530$var$folding = true;
                    $695b3d6025d5e530$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$initialFolding = false;
                if (_this2.options.animation) $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                    $695b3d6025d5e530$var$unsetRect(multiDragElement);
                });
                 // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $695b3d6025d5e530$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($695b3d6025d5e530$var$folding && ~$695b3d6025d5e530$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($695b3d6025d5e530$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $695b3d6025d5e530$var$folding ? $695b3d6025d5e530$var$getRect(multiDragElement) : dragRect
                    });
                    $695b3d6025d5e530$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $695b3d6025d5e530$var$initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $695b3d6025d5e530$var$multiDragElements.length > 1 && ($695b3d6025d5e530$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1, false, true, true);
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
                        $695b3d6025d5e530$var$setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $695b3d6025d5e530$var$folding = true;
                } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$695b3d6025d5e530$var$folding) $695b3d6025d5e530$var$removeMultiDragElements();
                    if ($695b3d6025d5e530$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $695b3d6025d5e530$var$clonesHidden;
                        activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$695b3d6025d5e530$var$clonesHidden && clonesHiddenBefore) $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $695b3d6025d5e530$var$clonesFromRect
                            });
                            clone.fromRect = $695b3d6025d5e530$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $695b3d6025d5e530$var$clonesFromRect = $695b3d6025d5e530$var$_extends({}, dragRect);
                var dragMatrix = $695b3d6025d5e530$var$matrix($695b3d6025d5e530$var$dragEl$1, true);
                $695b3d6025d5e530$var$clonesFromRect.top -= dragMatrix.f;
                $695b3d6025d5e530$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($695b3d6025d5e530$var$folding) {
                $695b3d6025d5e530$var$folding = false;
                $695b3d6025d5e530$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children; // Multi-drag selection
            if (!$695b3d6025d5e530$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $695b3d6025d5e530$var$toggleClass($695b3d6025d5e530$var$dragEl$1, options.selectedClass, !~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1));
                if (!~$695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1)) {
                    $695b3d6025d5e530$var$multiDragElements.push($695b3d6025d5e530$var$dragEl$1);
                    $695b3d6025d5e530$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "select",
                        targetEl: $695b3d6025d5e530$var$dragEl$1,
                        originalEvent: evt
                    }); // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $695b3d6025d5e530$var$lastMultiDragSelect && sortable.el.contains($695b3d6025d5e530$var$lastMultiDragSelect)) {
                        var lastIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$lastMultiDragSelect), currentIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            for(; i < n; i++){
                                if (~$695b3d6025d5e530$var$multiDragElements.indexOf(children[i])) continue;
                                $695b3d6025d5e530$var$toggleClass(children[i], options.selectedClass, true);
                                $695b3d6025d5e530$var$multiDragElements.push(children[i]);
                                $695b3d6025d5e530$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: "select",
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        }
                    } else $695b3d6025d5e530$var$lastMultiDragSelect = $695b3d6025d5e530$var$dragEl$1;
                    $695b3d6025d5e530$var$multiDragSortable = toSortable;
                } else {
                    $695b3d6025d5e530$var$multiDragElements.splice($695b3d6025d5e530$var$multiDragElements.indexOf($695b3d6025d5e530$var$dragEl$1), 1);
                    $695b3d6025d5e530$var$lastMultiDragSelect = null;
                    $695b3d6025d5e530$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: "deselect",
                        targetEl: $695b3d6025d5e530$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            } // Multi-drag drop
            if ($695b3d6025d5e530$var$dragStarted && this.isMultiDrag) {
                $695b3d6025d5e530$var$folding = false; // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$695b3d6025d5e530$var$expando].options.sort || parentEl !== rootEl) && $695b3d6025d5e530$var$multiDragElements.length > 1) {
                    var dragRect = $695b3d6025d5e530$var$getRect($695b3d6025d5e530$var$dragEl$1), multiDragIndex = $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1, ":not(." + this.options.selectedClass + ")");
                    if (!$695b3d6025d5e530$var$initialFolding && options.animation) $695b3d6025d5e530$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$695b3d6025d5e530$var$initialFolding) {
                        if (options.animation) {
                            $695b3d6025d5e530$var$dragEl$1.fromRect = dragRect;
                            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $695b3d6025d5e530$var$dragEl$1) {
                                    var rect = $695b3d6025d5e530$var$folding ? $695b3d6025d5e530$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect; // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $695b3d6025d5e530$var$removeMultiDragElements();
                        $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        }); // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $695b3d6025d5e530$var$index($695b3d6025d5e530$var$dragEl$1)) {
                            var update = false;
                            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $695b3d6025d5e530$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) dispatchSortableEvent("update");
                        }
                    } // Must be done after capturing individual rects (scroll bar)
                    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                        $695b3d6025d5e530$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $695b3d6025d5e530$var$multiDragSortable = toSortable;
            } // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") $695b3d6025d5e530$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $695b3d6025d5e530$var$dragStarted = false;
            $695b3d6025d5e530$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $695b3d6025d5e530$var$off(document, "pointerup", this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, "mouseup", this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, "touchend", this._deselectMultiDrag);
            $695b3d6025d5e530$var$off(document, "keydown", this._checkKeyDown);
            $695b3d6025d5e530$var$off(document, "keyup", this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $695b3d6025d5e530$var$dragStarted !== "undefined" && $695b3d6025d5e530$var$dragStarted) return; // Only deselect if selection is in this sortable
            if ($695b3d6025d5e530$var$multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable
            if (evt && $695b3d6025d5e530$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($695b3d6025d5e530$var$multiDragElements.length){
                var el = $695b3d6025d5e530$var$multiDragElements[0];
                $695b3d6025d5e530$var$toggleClass(el, this.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements.shift();
                $695b3d6025d5e530$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: "deselect",
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $695b3d6025d5e530$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: "multiDrag",
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$695b3d6025d5e530$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$695b3d6025d5e530$var$multiDragElements.indexOf(el)) return;
                if ($695b3d6025d5e530$var$multiDragSortable && $695b3d6025d5e530$var$multiDragSortable !== sortable) {
                    $695b3d6025d5e530$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $695b3d6025d5e530$var$multiDragSortable = sortable;
                }
                $695b3d6025d5e530$var$toggleClass(el, sortable.options.selectedClass, true);
                $695b3d6025d5e530$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$695b3d6025d5e530$var$expando], index = $695b3d6025d5e530$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $695b3d6025d5e530$var$toggleClass(el, sortable.options.selectedClass, false);
                $695b3d6025d5e530$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                }); // multiDragElements will already be sorted if folding
                var newIndex;
                if ($695b3d6025d5e530$var$folding && multiDragElement !== $695b3d6025d5e530$var$dragEl$1) newIndex = -1;
                else if ($695b3d6025d5e530$var$folding) newIndex = $695b3d6025d5e530$var$index(multiDragElement, ":not(." + _this3.options.selectedClass + ")");
                else newIndex = $695b3d6025d5e530$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $695b3d6025d5e530$var$_toConsumableArray($695b3d6025d5e530$var$multiDragElements),
                clones: [].concat($695b3d6025d5e530$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === "ctrl") key = "Control";
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $695b3d6025d5e530$var$insertMultiDragElements(clonesInserted, rootEl) {
    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $695b3d6025d5e530$var$insertMultiDragClones(elementsInserted, rootEl) {
    $695b3d6025d5e530$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $695b3d6025d5e530$var$removeMultiDragElements() {
    $695b3d6025d5e530$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $695b3d6025d5e530$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$695b3d6025d5e530$export$31b3ca70d8f57423.mount(new $695b3d6025d5e530$var$AutoScrollPlugin());
$695b3d6025d5e530$export$31b3ca70d8f57423.mount($695b3d6025d5e530$var$Remove, $695b3d6025d5e530$var$Revert);
var $695b3d6025d5e530$export$2e2bcd8739ae039 = $695b3d6025d5e530$export$31b3ca70d8f57423;


var $f8c99c41bd600645$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $f8c99c41bd600645$exports) {
        classNames.default = classNames;
        $f8c99c41bd600645$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


parcelRequire("e1jtj");
var $5VC2c = parcelRequire("5VC2c");
var $e1jtj = parcelRequire("e1jtj");
var $fb0c6d61f86ba934$exports = {};

$parcel$defineInteropFlag($fb0c6d61f86ba934$exports);

$parcel$export($fb0c6d61f86ba934$exports, "default", () => $fb0c6d61f86ba934$export$2e2bcd8739ae039);
var $fb0c6d61f86ba934$var$isProduction = true;
var $fb0c6d61f86ba934$var$prefix = "Invariant failed";
function $fb0c6d61f86ba934$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($fb0c6d61f86ba934$var$isProduction) throw new Error($fb0c6d61f86ba934$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? $fb0c6d61f86ba934$var$prefix + ": " + provided : $fb0c6d61f86ba934$var$prefix;
    throw new Error(value);
}


function $c283a7eca7a97e89$var$$parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $c283a7eca7a97e89$var$$parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $c283a7eca7a97e89$var$$parcel$exportWildcard(dest, source) {
    Object.keys(source).forEach(function(key) {
        if (key === "default" || key === "__esModule" || dest.hasOwnProperty(key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function get() {
                return source[key];
            }
        });
    });
    return dest;
}
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "Sortable", ()=>$882b6d93070905b3$re_export$Sortable);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "Direction", ()=>$882b6d93070905b3$re_export$Direction);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "DOMRect", ()=>$882b6d93070905b3$re_export$DOMRect);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "GroupOptions", ()=>$882b6d93070905b3$re_export$GroupOptions);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "MoveEvent", ()=>$882b6d93070905b3$re_export$MoveEvent);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "Options", ()=>$882b6d93070905b3$re_export$Options);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "PullResult", ()=>$882b6d93070905b3$re_export$PullResult);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "PutResult", ()=>$882b6d93070905b3$re_export$PutResult);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "SortableEvent", ()=>$882b6d93070905b3$re_export$SortableEvent);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "SortableOptions", ()=>$882b6d93070905b3$re_export$SortableOptions);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "Utils", ()=>$882b6d93070905b3$re_export$Utils);
$c283a7eca7a97e89$var$$parcel$export($c283a7eca7a97e89$exports, "ReactSortable", ()=>$c283a7eca7a97e89$var$$7fe8e3ea572bda7a$export$11bbed9ee0012c13);
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1d0aa160432dfea5(node) {
    if (node.parentElement !== null) node.parentElement.removeChild(node);
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$6d240faa51aa562f(parent, newChild, index) {
    const refChild = parent.children[index] || null;
    parent.insertBefore(newChild, refChild);
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$d7d742816c28cf91(customs) {
    $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
    $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customs) {
    customs.forEach((curr)=>$c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1d0aa160432dfea5(curr.element));
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs) {
    customs.forEach((curr)=>{
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$6d240faa51aa562f(curr.parentElement, curr.element, curr.oldIndex);
    });
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$4655efe700f887a(evt, list) {
    const mode = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt);
    const parentElement = {
        parentElement: evt.from
    };
    let custom = [];
    switch(mode){
        case "normal":
            /* eslint-disable */ const item = {
                element: evt.item,
                newIndex: evt.newIndex,
                oldIndex: evt.oldIndex,
                parentElement: evt.from
            };
            custom = [
                item
            ];
            break;
        case "swap":
            const drag = {
                element: evt.item,
                oldIndex: evt.oldIndex,
                newIndex: evt.newIndex,
                ...parentElement
            };
            const swap = {
                element: evt.swapItem,
                oldIndex: evt.newIndex,
                newIndex: evt.oldIndex,
                ...parentElement
            };
            custom = [
                drag,
                swap
            ];
            break;
        case "multidrag":
            custom = evt.oldIndicies.map((curr, index)=>({
                    element: curr.multiDragElement,
                    oldIndex: curr.index,
                    newIndex: evt.newIndicies[index].index,
                    ...parentElement
                }));
            break;
    }
    /* eslint-enable */ const customs = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$bc06a3af7dc65f53(custom, list);
    return customs;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$c25cf8080bd305ec(normalized, list) {
    const a = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$be2da95e6167b0bd(normalized, list);
    const b = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$eca851ee65ae17e4(normalized, a);
    return b;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$be2da95e6167b0bd(normalized, list) {
    const newList = [
        ...list
    ];
    normalized.concat().reverse().forEach((curr)=>newList.splice(curr.oldIndex, 1));
    return newList;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$eca851ee65ae17e4(normalized, list, evt, clone) {
    const newList = [
        ...list
    ];
    normalized.forEach((curr)=>{
        const newItem = clone && evt && clone(curr.item, evt);
        newList.splice(curr.newIndex, 0, newItem || curr.item);
    });
    return newList;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt) {
    if (evt.oldIndicies && evt.oldIndicies.length > 0) return "multidrag";
    if (evt.swapItem) return "swap";
    return "normal";
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$bc06a3af7dc65f53(inputs, list) {
    const normalized = inputs.map((curr)=>({
            ...curr,
            item: list[curr.oldIndex]
        })).sort((a, b)=>a.oldIndex - b.oldIndex);
    return normalized;
}
function $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$7553c81e62e31b7e(props) {
    /* eslint-disable */ const { list: list, setList: setList, children: children, tag: tag, style: style, className: className, clone: clone, onAdd: onAdd, onChange: onChange, onChoose: onChoose, onClone: onClone, onEnd: onEnd, onFilter: onFilter, onRemove: onRemove, onSort: onSort, onStart: onStart, onUnchoose: onUnchoose, onUpdate: onUpdate, onMove: onMove, onSpill: onSpill, onSelect: onSelect, onDeselect: onDeselect, ...options } = props;
    /* eslint-enable */ return options;
}
/** Holds a global reference for which react element is being dragged */ // @todo - use context to manage this. How does one use 2 different providers?
const $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store = {
    dragging: null
};
class $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$export$11bbed9ee0012c13 extends $5VC2c.Component {
    /* eslint-disable-next-line */ static defaultProps = {
        clone: (item)=>item
    };
    constructor(props){
        super(props);
        // @todo forward ref this component
        this.ref = /*#__PURE__*/ (0, $5VC2c.createRef)();
        // make all state false because we can't change sortable unless a mouse gesture is made.
        const newList = [
            ...props.list
        ].map((item)=>Object.assign(item, {
                chosen: false,
                selected: false
            }));
        props.setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
        $c283a7eca7a97e89$var$$parcel$interopDefault($fb0c6d61f86ba934$exports)(!props.plugins, `
Plugins prop is no longer supported.
Instead, mount it with "Sortable.mount(new MultiDrag())"
Please read the updated README.md at https://github.com/SortableJS/react-sortablejs.
      `);
    }
    componentDidMount() {
        if (this.ref.current === null) return;
        const newOptions = this.makeOptions();
        $c283a7eca7a97e89$var$$parcel$interopDefault($695b3d6025d5e530$exports).create(this.ref.current, newOptions);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.disabled !== this.props.disabled && this.sortable) this.sortable.option("disabled", this.props.disabled);
    }
    render() {
        const { tag: tag, style: style, className: className, id: id } = this.props;
        const classicProps = {
            style: style,
            className: className,
            id: id
        };
        // if no tag, default to a `div` element.
        const newTag = !tag || tag === null ? "div" : tag;
        return /*#__PURE__*/ (0, $5VC2c.createElement)(newTag, {
            // @todo - find a way (perhaps with the callback) to allow AntD components to work
            ref: this.ref,
            ...classicProps
        }, this.getChildren());
    }
    getChildren() {
        const { children: children, dataIdAttr: dataIdAttr, selectedClass: selectedClass = "sortable-selected", chosenClass: chosenClass = "sortable-chosen", dragClass: /* eslint-disable */ dragClass = "sortable-drag", fallbackClass: fallbackClass = "sortable-falback", ghostClass: ghostClass = "sortable-ghost", swapClass: swapClass = "sortable-swap-highlight", filter: /* eslint-enable */ filter = "sortable-filter", list: list } = this.props;
        // if no children, don't do anything.
        if (!children || children == null) return null;
        const dataid = dataIdAttr || "data-id";
        /* eslint-disable-next-line */ return (0, $e1jtj.Children).map(children, (child, index)=>{
            if (child === undefined) return undefined;
            const item = list[index] || {};
            const { className: prevClassName } = child.props;
            // @todo - handle the function if avalable. I don't think anyone will be doing this soon.
            const filtered = typeof filter === "string" && {
                [filter.replace(".", "")]: !!item.filtered
            };
            const className = $c283a7eca7a97e89$var$$parcel$interopDefault($f8c99c41bd600645$exports)(prevClassName, {
                [selectedClass]: item.selected,
                [chosenClass]: item.chosen,
                ...filtered
            });
            return /*#__PURE__*/ (0, $e1jtj.cloneElement)(child, {
                [dataid]: child.key,
                className: className
            });
        });
    }
    /** Appends the `sortable` property to this component */ get sortable() {
        const el = this.ref.current;
        if (el === null) return null;
        const key = Object.keys(el).find((k)=>k.includes("Sortable"));
        if (!key) return null;
        //@ts-expect-error: fix me.
        return el[key];
    }
    /** Converts all the props from `ReactSortable` into the `options` object that `Sortable.create(el, [options])` can use. */ makeOptions() {
        const DOMHandlers = [
            "onAdd",
            "onChoose",
            "onDeselect",
            "onEnd",
            "onRemove",
            "onSelect",
            "onSpill",
            "onStart",
            "onUnchoose",
            "onUpdate"
        ];
        const NonDOMHandlers = [
            "onChange",
            "onClone",
            "onFilter",
            "onSort"
        ];
        const newOptions = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$7553c81e62e31b7e(this.props);
        DOMHandlers.forEach((name)=>newOptions[name] = this.prepareOnHandlerPropAndDOM(name));
        NonDOMHandlers.forEach((name)=>newOptions[name] = this.prepareOnHandlerProp(name));
        /** onMove has 2 arguments and needs to be handled seperately. */ const onMove1 = (evt, originalEvt)=>{
            const { onMove: onMove } = this.props;
            const defaultValue = evt.willInsertAfter || -1;
            if (!onMove) return defaultValue;
            const result = onMove(evt, originalEvt, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
            if (typeof result === "undefined") return false;
            return result;
        };
        return {
            ...newOptions,
            onMove: onMove1
        };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop & an `on[Handler]` ReactSortable method.  */ prepareOnHandlerPropAndDOM(evtName) {
        return (evt)=>{
            // call the component prop
            this.callOnHandlerProp(evt, evtName);
            // calls state change
            //@ts-expect-error: until @types multidrag item is in
            this[evtName](evt);
        };
    }
    /** Prepares a method that will be used in the sortable options to call an `on[Handler]` prop */ prepareOnHandlerProp(evtName) {
        return (evt)=>{
            // call the component prop
            this.callOnHandlerProp(evt, evtName);
        };
    }
    /** Calls the `props.on[Handler]` function */ callOnHandlerProp(evt, evtName) {
        const propEvent = this.props[evtName];
        if (propEvent) propEvent(evt, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    // SORTABLE DOM HANDLING
    onAdd(evt) {
        const { list: list, setList: setList, clone: clone } = this.props;
        /* eslint-disable-next-line */ const otherList = [
            ...$c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store.dragging.props.list
        ];
        const customs = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$4655efe700f887a(evt, otherList);
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
        const newList = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$eca851ee65ae17e4(customs, list, evt, clone).map((item)=>Object.assign(item, {
                selected: false
            }));
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onRemove(evt) {
        const { list: list, setList: setList } = this.props;
        const mode = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1fc0f6205829e19c(evt);
        const customs = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$4655efe700f887a(evt, list);
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
        let newList = [
            ...list
        ];
        // remove state if not in clone mode. otherwise, keep.
        if (evt.pullMode !== "clone") newList = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$be2da95e6167b0bd(customs, newList);
        else {
            // switch used to get the clone
            let customClones = customs;
            switch(mode){
                case "multidrag":
                    customClones = customs.map((item, index)=>({
                            ...item,
                            element: evt.clones[index]
                        }));
                    break;
                case "normal":
                    customClones = customs.map((item)=>({
                            ...item,
                            element: evt.clone
                        }));
                    break;
                case "swap":
                default:
                    $c283a7eca7a97e89$var$$parcel$interopDefault($fb0c6d61f86ba934$exports)(true, `mode "${mode}" cannot clone. Please remove "props.clone" from <ReactSortable/> when using the "${mode}" plugin`);
            }
            $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customClones);
            // replace selected items with cloned items
            customs.forEach((curr)=>{
                const index = curr.oldIndex;
                /* eslint-disable-next-line */ const newItem = this.props.clone(curr.item, evt);
                newList.splice(index, 1, newItem);
            });
        }
        // remove item.selected from list
        newList = newList.map((item)=>Object.assign(item, {
                selected: false
            }));
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onUpdate(evt) {
        const { list: list, setList: setList } = this.props;
        const customs = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$4655efe700f887a(evt, list);
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$77f49a256021c8de(customs);
        $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$a6177d5829f70ebc(customs);
        const newList = $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$c25cf8080bd305ec(customs, list);
        return setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onStart() {
        $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store.dragging = this;
    }
    onEnd() {
        $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store.dragging = null;
    }
    onChoose(evt) {
        const { list: list, setList: setList } = this.props;
        const newList = list.map((item, index)=>{
            let newItem = item;
            if (index === evt.oldIndex) newItem = Object.assign(item, {
                chosen: true
            });
            return newItem;
        });
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onUnchoose(evt) {
        const { list: list, setList: setList } = this.props;
        const newList = list.map((item, index)=>{
            let newItem = item;
            if (index === evt.oldIndex) newItem = Object.assign(newItem, {
                chosen: false
            });
            return newItem;
        });
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onSpill(evt) {
        const { removeOnSpill: removeOnSpill, revertOnSpill: revertOnSpill } = this.props;
        if (removeOnSpill && !revertOnSpill) $c283a7eca7a97e89$var$$eb03e74f8f7db1f3$export$1d0aa160432dfea5(evt.item);
    }
    onSelect(evt) {
        const { list: list, setList: setList } = this.props;
        const newList = list.map((item)=>Object.assign(item, {
                selected: false
            }));
        evt.newIndicies.forEach((curr)=>{
            const index = curr.index;
            if (index === -1) {
                console.log(`"${evt.type}" had indice of "${curr.index}", which is probably -1 and doesn't usually happen here.`);
                console.log(evt);
                return;
            }
            newList[index].selected = true;
        });
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
    onDeselect(evt) {
        const { list: list, setList: setList } = this.props;
        const newList = list.map((item)=>Object.assign(item, {
                selected: false
            }));
        evt.newIndicies.forEach((curr)=>{
            const index = curr.index;
            if (index === -1) return;
            newList[index].selected = true;
        });
        setList(newList, this.sortable, $c283a7eca7a97e89$var$$7fe8e3ea572bda7a$var$store);
    }
}
var $c283a7eca7a97e89$var$$faefaad95e5fcca0$exports = {};
$c283a7eca7a97e89$var$$parcel$exportWildcard($c283a7eca7a97e89$exports, $c283a7eca7a97e89$var$$faefaad95e5fcca0$exports);



var $ir4bw = parcelRequire("ir4bw");
var $2d3b74a5ba71405d$exports = {};

$parcel$export($2d3b74a5ba71405d$exports, "NavbarContext", () => $2d3b74a5ba71405d$export$fef0478b4574e50b);

var $5VC2c = parcelRequire("5VC2c");
var $2d3b74a5ba71405d$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2d3b74a5ba71405d$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2d3b74a5ba71405d$export$fef0478b4574e50b = (0, $5VC2c.createContext)({
    links: [],
    siteId: "",
    save: function(value) {
        return $2d3b74a5ba71405d$var$__awaiter(void 0, void 0, void 0, function() {
            return $2d3b74a5ba71405d$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    null
                ];
            });
        });
    },
    refetch: function(value) {
        return null;
    },
    update: function(value) {
        return null;
    },
    saveLink: function(value) {
        return null;
    },
    saveButton: function(value) {
        return null;
    },
    buttons: [],
    logoData: {
        id: "",
        logo_type: "text",
        logo_image: "",
        logo_text: "",
        logo_emoji: "",
        logo_size: 0,
        height: 0,
        is_floating: false,
        background_color: "",
        color: ""
    }
});


var $3412d7152e02b24a$exports = {};
"use client";
"use strict";
var $3412d7152e02b24a$var$Y = Object.create;
var $3412d7152e02b24a$var$E = Object.defineProperty;
var $3412d7152e02b24a$var$q = Object.getOwnPropertyDescriptor;
var $3412d7152e02b24a$var$G = Object.getOwnPropertyNames;
var $3412d7152e02b24a$var$K = Object.getPrototypeOf, $3412d7152e02b24a$var$Z = Object.prototype.hasOwnProperty;
var $3412d7152e02b24a$var$ee = (e, t)=>{
    for(var o in t)$3412d7152e02b24a$var$E(e, o, {
        get: t[o],
        enumerable: !0
    });
}, $3412d7152e02b24a$var$j = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let r of $3412d7152e02b24a$var$G(t))!$3412d7152e02b24a$var$Z.call(e, r) && r !== o && $3412d7152e02b24a$var$E(e, r, {
        get: ()=>t[r],
        enumerable: !(s = $3412d7152e02b24a$var$q(t, r)) || s.enumerable
    });
    return e;
};
var $3412d7152e02b24a$var$W = (e, t, o)=>(o = e != null ? $3412d7152e02b24a$var$Y($3412d7152e02b24a$var$K(e)) : {}, $3412d7152e02b24a$var$j(t || !e || !e.__esModule ? $3412d7152e02b24a$var$E(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), $3412d7152e02b24a$var$te = (e)=>$3412d7152e02b24a$var$j($3412d7152e02b24a$var$E({}, "__esModule", {
        value: !0
    }), e);
var $3412d7152e02b24a$var$Ve = {};
$3412d7152e02b24a$var$ee($3412d7152e02b24a$var$Ve, {
    CheckmarkIcon: ()=>$3412d7152e02b24a$var$F,
    ErrorIcon: ()=>$3412d7152e02b24a$var$w,
    LoaderIcon: ()=>$3412d7152e02b24a$var$M,
    ToastBar: ()=>$3412d7152e02b24a$var$$,
    ToastIcon: ()=>$3412d7152e02b24a$var$U,
    Toaster: ()=>$3412d7152e02b24a$var$J,
    default: ()=>$3412d7152e02b24a$var$_e,
    resolveValue: ()=>$3412d7152e02b24a$var$u,
    toast: ()=>$3412d7152e02b24a$var$n,
    useToaster: ()=>$3412d7152e02b24a$var$V,
    useToasterStore: ()=>$3412d7152e02b24a$var$_
});
$3412d7152e02b24a$exports = $3412d7152e02b24a$var$te($3412d7152e02b24a$var$Ve);
var $3412d7152e02b24a$var$oe = (e)=>typeof e == "function", $3412d7152e02b24a$var$u = (e, t)=>$3412d7152e02b24a$var$oe(e) ? e(t) : e;
var $3412d7152e02b24a$var$Q = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $3412d7152e02b24a$var$R = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();

var $3412d7152e02b24a$var$re = 20;
var $3412d7152e02b24a$var$v = new Map, $3412d7152e02b24a$var$se = 1e3, $3412d7152e02b24a$var$X = (e)=>{
    if ($3412d7152e02b24a$var$v.has(e)) return;
    let t = setTimeout(()=>{
        $3412d7152e02b24a$var$v.delete(e), $3412d7152e02b24a$var$l({
            type: 4,
            toastId: e
        });
    }, $3412d7152e02b24a$var$se);
    $3412d7152e02b24a$var$v.set(e, t);
}, $3412d7152e02b24a$var$ae = (e)=>{
    let t = $3412d7152e02b24a$var$v.get(e);
    t && clearTimeout(t);
}, $3412d7152e02b24a$var$H = (e, t)=>{
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, $3412d7152e02b24a$var$re)
            };
        case 1:
            return t.toast.id && $3412d7152e02b24a$var$ae(t.toast.id), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === t.toast.id ? {
                        ...a,
                        ...t.toast
                    } : a)
            };
        case 2:
            let { toast: o } = t;
            return e.toasts.find((a)=>a.id === o.id) ? $3412d7152e02b24a$var$H(e, {
                type: 1,
                toast: o
            }) : $3412d7152e02b24a$var$H(e, {
                type: 0,
                toast: o
            });
        case 3:
            let { toastId: s } = t;
            return s ? $3412d7152e02b24a$var$X(s) : e.toasts.forEach((a)=>{
                $3412d7152e02b24a$var$X(a.id);
            }), {
                ...e,
                toasts: e.toasts.map((a)=>a.id === s || s === void 0 ? {
                        ...a,
                        visible: !1
                    } : a)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((a)=>a.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let r = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((a)=>({
                        ...a,
                        pauseDuration: a.pauseDuration + r
                    }))
            };
    }
}, $3412d7152e02b24a$var$I = [], $3412d7152e02b24a$var$D = {
    toasts: [],
    pausedAt: void 0
}, $3412d7152e02b24a$var$l = (e)=>{
    $3412d7152e02b24a$var$D = $3412d7152e02b24a$var$H($3412d7152e02b24a$var$D, e), $3412d7152e02b24a$var$I.forEach((t)=>{
        t($3412d7152e02b24a$var$D);
    });
}, $3412d7152e02b24a$var$ie = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $3412d7152e02b24a$var$_ = (e = {})=>{
    let [t, o] = (0, (parcelRequire("ir4bw")).useState)($3412d7152e02b24a$var$D);
    (0, (parcelRequire("ir4bw")).useEffect)(()=>($3412d7152e02b24a$var$I.push(o), ()=>{
            let r = $3412d7152e02b24a$var$I.indexOf(o);
            r > -1 && $3412d7152e02b24a$var$I.splice(r, 1);
        }), [
        t
    ]);
    let s = t.toasts.map((r)=>{
        var a, c;
        return {
            ...e,
            ...e[r.type],
            ...r,
            duration: r.duration || ((a = e[r.type]) == null ? void 0 : a.duration) || (e == null ? void 0 : e.duration) || $3412d7152e02b24a$var$ie[r.type],
            style: {
                ...e.style,
                ...(c = e[r.type]) == null ? void 0 : c.style,
                ...r.style
            }
        };
    });
    return {
        ...t,
        toasts: s
    };
};
var $3412d7152e02b24a$var$ce = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $3412d7152e02b24a$var$Q()
    }), $3412d7152e02b24a$var$S = (e)=>(t, o)=>{
        let s = $3412d7152e02b24a$var$ce(t, e, o);
        return $3412d7152e02b24a$var$l({
            type: 2,
            toast: s
        }), s.id;
    }, $3412d7152e02b24a$var$n = (e, t)=>$3412d7152e02b24a$var$S("blank")(e, t);
$3412d7152e02b24a$var$n.error = $3412d7152e02b24a$var$S("error");
$3412d7152e02b24a$var$n.success = $3412d7152e02b24a$var$S("success");
$3412d7152e02b24a$var$n.loading = $3412d7152e02b24a$var$S("loading");
$3412d7152e02b24a$var$n.custom = $3412d7152e02b24a$var$S("custom");
$3412d7152e02b24a$var$n.dismiss = (e)=>{
    $3412d7152e02b24a$var$l({
        type: 3,
        toastId: e
    });
};
$3412d7152e02b24a$var$n.remove = (e)=>$3412d7152e02b24a$var$l({
        type: 4,
        toastId: e
    });
$3412d7152e02b24a$var$n.promise = (e, t, o)=>{
    let s = $3412d7152e02b24a$var$n.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return e.then((r)=>($3412d7152e02b24a$var$n.success($3412d7152e02b24a$var$u(t.success, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }), r)).catch((r)=>{
        $3412d7152e02b24a$var$n.error($3412d7152e02b24a$var$u(t.error, r), {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        });
    }), e;
};

var $3412d7152e02b24a$var$pe = (e, t)=>{
    $3412d7152e02b24a$var$l({
        type: 1,
        toast: {
            id: e,
            height: t
        }
    });
}, $3412d7152e02b24a$var$de = ()=>{
    $3412d7152e02b24a$var$l({
        type: 5,
        time: Date.now()
    });
}, $3412d7152e02b24a$var$V = (e)=>{
    let { toasts: t, pausedAt: o } = $3412d7152e02b24a$var$_(e);
    (0, (parcelRequire("ir4bw")).useEffect)(()=>{
        if (o) return;
        let a = Date.now(), c = t.map((i)=>{
            if (i.duration === 1 / 0) return;
            let d = (i.duration || 0) + i.pauseDuration - (a - i.createdAt);
            if (d < 0) {
                i.visible && $3412d7152e02b24a$var$n.dismiss(i.id);
                return;
            }
            return setTimeout(()=>$3412d7152e02b24a$var$n.dismiss(i.id), d);
        });
        return ()=>{
            c.forEach((i)=>i && clearTimeout(i));
        };
    }, [
        t,
        o
    ]);
    let s = (0, (parcelRequire("ir4bw")).useCallback)(()=>{
        o && $3412d7152e02b24a$var$l({
            type: 6,
            time: Date.now()
        });
    }, [
        o
    ]), r = (0, (parcelRequire("ir4bw")).useCallback)((a, c)=>{
        let { reverseOrder: i = !1, gutter: d = 8, defaultPosition: p } = c || {}, g = t.filter((m)=>(m.position || p) === (a.position || p) && m.height), z = g.findIndex((m)=>m.id === a.id), O = g.filter((m, B)=>B < z && m.visible).length;
        return g.filter((m)=>m.visible).slice(...i ? [
            O + 1
        ] : [
            0,
            O
        ]).reduce((m, B)=>m + (B.height || 0) + d, 0);
    }, [
        t
    ]);
    return {
        toasts: t,
        handlers: {
            updateHeight: $3412d7152e02b24a$var$pe,
            startPause: $3412d7152e02b24a$var$de,
            endPause: s,
            calculateOffset: r
        }
    };
};

var $3412d7152e02b24a$var$T = $3412d7152e02b24a$var$W((parcelRequire("e1jtj")));
let $6ddbe9a43451bf52$var$e = {
    data: ""
}, $6ddbe9a43451bf52$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $6ddbe9a43451bf52$var$e, $6ddbe9a43451bf52$export$54aba348a7896325 = (e)=>{
    let r = $6ddbe9a43451bf52$var$t(e), l = r.data;
    return r.data = "", l;
}, $6ddbe9a43451bf52$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $6ddbe9a43451bf52$var$a = /\/\*[^]*?\*\/|  +/g, $6ddbe9a43451bf52$var$n = /\n+/g, $6ddbe9a43451bf52$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $6ddbe9a43451bf52$var$o(c, n) : n + "{" + $6ddbe9a43451bf52$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $6ddbe9a43451bf52$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $6ddbe9a43451bf52$var$o.p ? $6ddbe9a43451bf52$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $6ddbe9a43451bf52$var$c = {}, $6ddbe9a43451bf52$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $6ddbe9a43451bf52$var$s(e[r]);
        return t;
    }
    return e;
}, $6ddbe9a43451bf52$var$i = (e, t, r, i, p)=>{
    let u = $6ddbe9a43451bf52$var$s(e), d = $6ddbe9a43451bf52$var$c[u] || ($6ddbe9a43451bf52$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$6ddbe9a43451bf52$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $6ddbe9a43451bf52$var$l.exec(e.replace($6ddbe9a43451bf52$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($6ddbe9a43451bf52$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($6ddbe9a43451bf52$var$n, " ").trim();
            return o[0];
        })(e);
        $6ddbe9a43451bf52$var$c[d] = $6ddbe9a43451bf52$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $6ddbe9a43451bf52$var$c.g ? $6ddbe9a43451bf52$var$c.g : null;
    return r && ($6ddbe9a43451bf52$var$c.g = $6ddbe9a43451bf52$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($6ddbe9a43451bf52$var$c[d], t, i, f), d;
}, $6ddbe9a43451bf52$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $6ddbe9a43451bf52$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $6ddbe9a43451bf52$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $6ddbe9a43451bf52$var$i(l.unshift ? l.raw ? $6ddbe9a43451bf52$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $6ddbe9a43451bf52$var$t(r.target), r.g, r.o, r.k);
}
let $6ddbe9a43451bf52$var$d, $6ddbe9a43451bf52$var$f, $6ddbe9a43451bf52$var$g, $6ddbe9a43451bf52$export$442f1a04865e4790 = $6ddbe9a43451bf52$export$dbf350e5966cf602.bind({
    g: 1
}), $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e = $6ddbe9a43451bf52$export$dbf350e5966cf602.bind({
    k: 1
});
function $6ddbe9a43451bf52$export$de27182ff8187d6c(e, t, r, l) {
    $6ddbe9a43451bf52$var$o.p = t, $6ddbe9a43451bf52$var$d = e, $6ddbe9a43451bf52$var$f = r, $6ddbe9a43451bf52$var$g = l;
}
function $6ddbe9a43451bf52$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $6ddbe9a43451bf52$var$f && $6ddbe9a43451bf52$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $6ddbe9a43451bf52$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $6ddbe9a43451bf52$var$g && i[0] && $6ddbe9a43451bf52$var$g(c), $6ddbe9a43451bf52$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}



var $3412d7152e02b24a$var$y = $3412d7152e02b24a$var$W((parcelRequire("e1jtj")));


var $3412d7152e02b24a$var$me = $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $3412d7152e02b24a$var$ue = $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $3412d7152e02b24a$var$le = $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $3412d7152e02b24a$var$w = (0, $6ddbe9a43451bf52$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$3412d7152e02b24a$var$me} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$3412d7152e02b24a$var$ue} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$3412d7152e02b24a$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;

var $3412d7152e02b24a$var$Te = $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $3412d7152e02b24a$var$M = (0, $6ddbe9a43451bf52$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$3412d7152e02b24a$var$Te} 1s linear infinite;
`;

var $3412d7152e02b24a$var$fe = $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $3412d7152e02b24a$var$ye = $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $3412d7152e02b24a$var$F = (0, $6ddbe9a43451bf52$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$3412d7152e02b24a$var$fe} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$3412d7152e02b24a$var$ye} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $3412d7152e02b24a$var$ge = (0, $6ddbe9a43451bf52$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $3412d7152e02b24a$var$he = (0, $6ddbe9a43451bf52$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $3412d7152e02b24a$var$xe = $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $3412d7152e02b24a$var$be = (0, $6ddbe9a43451bf52$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$3412d7152e02b24a$var$xe} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $3412d7152e02b24a$var$U = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $3412d7152e02b24a$var$y.createElement($3412d7152e02b24a$var$be, null, t) : t : o === "blank" ? null : $3412d7152e02b24a$var$y.createElement($3412d7152e02b24a$var$he, null, $3412d7152e02b24a$var$y.createElement($3412d7152e02b24a$var$M, {
        ...s
    }), o !== "loading" && $3412d7152e02b24a$var$y.createElement($3412d7152e02b24a$var$ge, null, o === "error" ? $3412d7152e02b24a$var$y.createElement($3412d7152e02b24a$var$w, {
        ...s
    }) : $3412d7152e02b24a$var$y.createElement($3412d7152e02b24a$var$F, {
        ...s
    })));
};
var $3412d7152e02b24a$var$Se = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $3412d7152e02b24a$var$Ae = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $3412d7152e02b24a$var$Pe = "0%{opacity:0;} 100%{opacity:1;}", $3412d7152e02b24a$var$Oe = "0%{opacity:1;} 100%{opacity:0;}", $3412d7152e02b24a$var$Ee = (0, $6ddbe9a43451bf52$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $3412d7152e02b24a$var$Re = (0, $6ddbe9a43451bf52$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $3412d7152e02b24a$var$ve = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [r, a] = $3412d7152e02b24a$var$R() ? [
        $3412d7152e02b24a$var$Pe,
        $3412d7152e02b24a$var$Oe
    ] : [
        $3412d7152e02b24a$var$Se(s),
        $3412d7152e02b24a$var$Ae(s)
    ];
    return {
        animation: t ? `${(0, $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e)(r)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $6ddbe9a43451bf52$export$d25ddfdf17c3ad3e)(a)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $3412d7152e02b24a$var$$ = $3412d7152e02b24a$var$T.memo(({ toast: e, position: t, style: o, children: s })=>{
    let r = e.height ? $3412d7152e02b24a$var$ve(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, a = $3412d7152e02b24a$var$T.createElement($3412d7152e02b24a$var$U, {
        toast: e
    }), c = $3412d7152e02b24a$var$T.createElement($3412d7152e02b24a$var$Re, {
        ...e.ariaProps
    }, $3412d7152e02b24a$var$u(e.message, e));
    return $3412d7152e02b24a$var$T.createElement($3412d7152e02b24a$var$Ee, {
        className: e.className,
        style: {
            ...r,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: a,
        message: c
    }) : $3412d7152e02b24a$var$T.createElement($3412d7152e02b24a$var$T.Fragment, null, a, c));
});


var $3412d7152e02b24a$var$f = $3412d7152e02b24a$var$W((parcelRequire("e1jtj")));
(0, $6ddbe9a43451bf52$export$de27182ff8187d6c)($3412d7152e02b24a$var$f.createElement);
var $3412d7152e02b24a$var$Ie = ({ id: e, className: t, style: o, onHeightUpdate: s, children: r })=>{
    let a = $3412d7152e02b24a$var$f.useCallback((c)=>{
        if (c) {
            let i = ()=>{
                let d = c.getBoundingClientRect().height;
                s(e, d);
            };
            i(), new MutationObserver(i).observe(c, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $3412d7152e02b24a$var$f.createElement("div", {
        ref: a,
        className: t,
        style: o
    }, r);
}, $3412d7152e02b24a$var$De = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, r = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $3412d7152e02b24a$var$R() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...r
    };
}, $3412d7152e02b24a$var$ke = $6ddbe9a43451bf52$export$dbf350e5966cf602`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $3412d7152e02b24a$var$L = 16, $3412d7152e02b24a$var$J = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: r, containerStyle: a, containerClassName: c })=>{
    let { toasts: i, handlers: d } = $3412d7152e02b24a$var$V(o);
    return $3412d7152e02b24a$var$f.createElement("div", {
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $3412d7152e02b24a$var$L,
            left: $3412d7152e02b24a$var$L,
            right: $3412d7152e02b24a$var$L,
            bottom: $3412d7152e02b24a$var$L,
            pointerEvents: "none",
            ...a
        },
        className: c,
        onMouseEnter: d.startPause,
        onMouseLeave: d.endPause
    }, i.map((p)=>{
        let g = p.position || t, z = d.calculateOffset(p, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), O = $3412d7152e02b24a$var$De(g, z);
        return $3412d7152e02b24a$var$f.createElement($3412d7152e02b24a$var$Ie, {
            id: p.id,
            key: p.id,
            onHeightUpdate: d.updateHeight,
            className: p.visible ? $3412d7152e02b24a$var$ke : "",
            style: O
        }, p.type === "custom" ? $3412d7152e02b24a$var$u(p.message, p) : r ? r(p) : $3412d7152e02b24a$var$f.createElement($3412d7152e02b24a$var$$, {
            toast: p,
            position: g
        }));
    }));
};
var $3412d7152e02b24a$var$_e = $3412d7152e02b24a$var$n;


var $f2ec8d2c6ac3c51c$exports = {};

$parcel$export($f2ec8d2c6ac3c51c$exports, "default", () => $f2ec8d2c6ac3c51c$export$2e2bcd8739ae039);
"use strict";
function $93b0f01b05e2607a$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}


"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $aace3e920a0f1e4d$var$toString } = Object.prototype;
const { getPrototypeOf: $aace3e920a0f1e4d$var$getPrototypeOf } = Object;
const $aace3e920a0f1e4d$var$kindOf = ((cache)=>(thing)=>{
        const str = $aace3e920a0f1e4d$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $aace3e920a0f1e4d$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$aace3e920a0f1e4d$var$kindOf(thing) === type;
};
const $aace3e920a0f1e4d$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $aace3e920a0f1e4d$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $aace3e920a0f1e4d$var$isUndefined = $aace3e920a0f1e4d$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isBuffer(val) {
    return val !== null && !$aace3e920a0f1e4d$var$isUndefined(val) && val.constructor !== null && !$aace3e920a0f1e4d$var$isUndefined(val.constructor) && $aace3e920a0f1e4d$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $aace3e920a0f1e4d$var$isArrayBuffer = $aace3e920a0f1e4d$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $aace3e920a0f1e4d$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $aace3e920a0f1e4d$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $aace3e920a0f1e4d$var$isString = $aace3e920a0f1e4d$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $aace3e920a0f1e4d$var$isFunction = $aace3e920a0f1e4d$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $aace3e920a0f1e4d$var$isNumber = $aace3e920a0f1e4d$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $aace3e920a0f1e4d$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $aace3e920a0f1e4d$var$isPlainObject = (val)=>{
    if ($aace3e920a0f1e4d$var$kindOf(val) !== "object") return false;
    const prototype = $aace3e920a0f1e4d$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $aace3e920a0f1e4d$var$isDate = $aace3e920a0f1e4d$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFile = $aace3e920a0f1e4d$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $aace3e920a0f1e4d$var$isBlob = $aace3e920a0f1e4d$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $aace3e920a0f1e4d$var$isFileList = $aace3e920a0f1e4d$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $aace3e920a0f1e4d$var$isStream = (val)=>$aace3e920a0f1e4d$var$isObject(val) && $aace3e920a0f1e4d$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $aace3e920a0f1e4d$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $aace3e920a0f1e4d$var$isFunction(thing.append) && ((kind = $aace3e920a0f1e4d$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $aace3e920a0f1e4d$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $aace3e920a0f1e4d$var$isURLSearchParams = $aace3e920a0f1e4d$var$kindOfTest("URLSearchParams");
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $aace3e920a0f1e4d$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $aace3e920a0f1e4d$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($aace3e920a0f1e4d$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $aace3e920a0f1e4d$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $aace3e920a0f1e4d$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $aace3e920a0f1e4d$var$isContextDefined = (context)=>!$aace3e920a0f1e4d$var$isUndefined(context) && context !== $aace3e920a0f1e4d$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $aace3e920a0f1e4d$var$merge() {
    const { caseless: caseless } = $aace3e920a0f1e4d$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $aace3e920a0f1e4d$var$findKey(result, key) || key;
        if ($aace3e920a0f1e4d$var$isPlainObject(result[targetKey]) && $aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge(result[targetKey], val);
        else if ($aace3e920a0f1e4d$var$isPlainObject(val)) result[targetKey] = $aace3e920a0f1e4d$var$merge({}, val);
        else if ($aace3e920a0f1e4d$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $aace3e920a0f1e4d$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $aace3e920a0f1e4d$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $aace3e920a0f1e4d$var$forEach(b, (val, key)=>{
        if (thisArg && $aace3e920a0f1e4d$var$isFunction(val)) a[key] = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $aace3e920a0f1e4d$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $aace3e920a0f1e4d$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $aace3e920a0f1e4d$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $aace3e920a0f1e4d$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $aace3e920a0f1e4d$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($aace3e920a0f1e4d$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$aace3e920a0f1e4d$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $aace3e920a0f1e4d$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $aace3e920a0f1e4d$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $aace3e920a0f1e4d$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $aace3e920a0f1e4d$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $aace3e920a0f1e4d$var$isHTMLForm = $aace3e920a0f1e4d$var$kindOfTest("HTMLFormElement");
const $aace3e920a0f1e4d$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $aace3e920a0f1e4d$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $aace3e920a0f1e4d$var$isRegExp = $aace3e920a0f1e4d$var$kindOfTest("RegExp");
const $aace3e920a0f1e4d$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $aace3e920a0f1e4d$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $aace3e920a0f1e4d$var$freezeMethods = (obj)=>{
    $aace3e920a0f1e4d$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($aace3e920a0f1e4d$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$aace3e920a0f1e4d$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $aace3e920a0f1e4d$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $aace3e920a0f1e4d$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $aace3e920a0f1e4d$var$noop = ()=>{};
const $aace3e920a0f1e4d$var$toFiniteNumber = (value, defaultValue)=>{
    value = +value;
    return Number.isFinite(value) ? value : defaultValue;
};
const $aace3e920a0f1e4d$var$ALPHA = "abcdefghijklmnopqrstuvwxyz";
const $aace3e920a0f1e4d$var$DIGIT = "0123456789";
const $aace3e920a0f1e4d$var$ALPHABET = {
    DIGIT: $aace3e920a0f1e4d$var$DIGIT,
    ALPHA: $aace3e920a0f1e4d$var$ALPHA,
    ALPHA_DIGIT: $aace3e920a0f1e4d$var$ALPHA + $aace3e920a0f1e4d$var$ALPHA.toUpperCase() + $aace3e920a0f1e4d$var$DIGIT
};
const $aace3e920a0f1e4d$var$generateString = (size = 16, alphabet = $aace3e920a0f1e4d$var$ALPHABET.ALPHA_DIGIT)=>{
    let str = "";
    const { length: length } = alphabet;
    while(size--)str += alphabet[Math.random() * length | 0];
    return str;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $aace3e920a0f1e4d$var$isSpecCompliantForm(thing) {
    return !!(thing && $aace3e920a0f1e4d$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $aace3e920a0f1e4d$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($aace3e920a0f1e4d$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $aace3e920a0f1e4d$var$isArray(source) ? [] : {};
                $aace3e920a0f1e4d$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$aace3e920a0f1e4d$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $aace3e920a0f1e4d$var$isAsyncFn = $aace3e920a0f1e4d$var$kindOfTest("AsyncFunction");
const $aace3e920a0f1e4d$var$isThenable = (thing)=>thing && ($aace3e920a0f1e4d$var$isObject(thing) || $aace3e920a0f1e4d$var$isFunction(thing)) && $aace3e920a0f1e4d$var$isFunction(thing.then) && $aace3e920a0f1e4d$var$isFunction(thing.catch);
var $aace3e920a0f1e4d$export$2e2bcd8739ae039 = {
    isArray: $aace3e920a0f1e4d$var$isArray,
    isArrayBuffer: $aace3e920a0f1e4d$var$isArrayBuffer,
    isBuffer: $aace3e920a0f1e4d$var$isBuffer,
    isFormData: $aace3e920a0f1e4d$var$isFormData,
    isArrayBufferView: $aace3e920a0f1e4d$var$isArrayBufferView,
    isString: $aace3e920a0f1e4d$var$isString,
    isNumber: $aace3e920a0f1e4d$var$isNumber,
    isBoolean: $aace3e920a0f1e4d$var$isBoolean,
    isObject: $aace3e920a0f1e4d$var$isObject,
    isPlainObject: $aace3e920a0f1e4d$var$isPlainObject,
    isUndefined: $aace3e920a0f1e4d$var$isUndefined,
    isDate: $aace3e920a0f1e4d$var$isDate,
    isFile: $aace3e920a0f1e4d$var$isFile,
    isBlob: $aace3e920a0f1e4d$var$isBlob,
    isRegExp: $aace3e920a0f1e4d$var$isRegExp,
    isFunction: $aace3e920a0f1e4d$var$isFunction,
    isStream: $aace3e920a0f1e4d$var$isStream,
    isURLSearchParams: $aace3e920a0f1e4d$var$isURLSearchParams,
    isTypedArray: $aace3e920a0f1e4d$var$isTypedArray,
    isFileList: $aace3e920a0f1e4d$var$isFileList,
    forEach: $aace3e920a0f1e4d$var$forEach,
    merge: $aace3e920a0f1e4d$var$merge,
    extend: $aace3e920a0f1e4d$var$extend,
    trim: $aace3e920a0f1e4d$var$trim,
    stripBOM: $aace3e920a0f1e4d$var$stripBOM,
    inherits: $aace3e920a0f1e4d$var$inherits,
    toFlatObject: $aace3e920a0f1e4d$var$toFlatObject,
    kindOf: $aace3e920a0f1e4d$var$kindOf,
    kindOfTest: $aace3e920a0f1e4d$var$kindOfTest,
    endsWith: $aace3e920a0f1e4d$var$endsWith,
    toArray: $aace3e920a0f1e4d$var$toArray,
    forEachEntry: $aace3e920a0f1e4d$var$forEachEntry,
    matchAll: $aace3e920a0f1e4d$var$matchAll,
    isHTMLForm: $aace3e920a0f1e4d$var$isHTMLForm,
    hasOwnProperty: $aace3e920a0f1e4d$var$hasOwnProperty,
    hasOwnProp: $aace3e920a0f1e4d$var$hasOwnProperty,
    reduceDescriptors: $aace3e920a0f1e4d$var$reduceDescriptors,
    freezeMethods: $aace3e920a0f1e4d$var$freezeMethods,
    toObjectSet: $aace3e920a0f1e4d$var$toObjectSet,
    toCamelCase: $aace3e920a0f1e4d$var$toCamelCase,
    noop: $aace3e920a0f1e4d$var$noop,
    toFiniteNumber: $aace3e920a0f1e4d$var$toFiniteNumber,
    findKey: $aace3e920a0f1e4d$var$findKey,
    global: $aace3e920a0f1e4d$var$_global,
    isContextDefined: $aace3e920a0f1e4d$var$isContextDefined,
    ALPHABET: $aace3e920a0f1e4d$var$ALPHABET,
    generateString: $aace3e920a0f1e4d$var$generateString,
    isSpecCompliantForm: $aace3e920a0f1e4d$var$isSpecCompliantForm,
    toJSONObject: $aace3e920a0f1e4d$var$toJSONObject,
    isAsyncFn: $aace3e920a0f1e4d$var$isAsyncFn,
    isThenable: $aace3e920a0f1e4d$var$isThenable
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $0139f1d30f4d6bd5$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    response && (this.response = response);
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($0139f1d30f4d6bd5$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    }
});
const $0139f1d30f4d6bd5$var$prototype = $0139f1d30f4d6bd5$var$AxiosError.prototype;
const $0139f1d30f4d6bd5$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $0139f1d30f4d6bd5$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($0139f1d30f4d6bd5$var$AxiosError, $0139f1d30f4d6bd5$var$descriptors);
Object.defineProperty($0139f1d30f4d6bd5$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$0139f1d30f4d6bd5$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($0139f1d30f4d6bd5$var$prototype);
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $0139f1d30f4d6bd5$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $0139f1d30f4d6bd5$export$2e2bcd8739ae039 = $0139f1d30f4d6bd5$var$AxiosError;


// eslint-disable-next-line strict
var $86ebf0c810395e29$export$2e2bcd8739ae039 = null;


/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $0934e0939605d48c$export$a143d493d941bafc;
var $0934e0939605d48c$export$e4cf37d7f6fb9e0a;
var $0934e0939605d48c$export$f99ded8fe4b79145;
var $0934e0939605d48c$export$599f31c3813fae4d;
"use strict";
var $8a0a73e6b73fd0c4$export$a48f0734ac7c2329;
var $8a0a73e6b73fd0c4$export$d622b2ad8d90c771;
var $8a0a73e6b73fd0c4$export$6100ba28696e12de;
"use strict";
$8a0a73e6b73fd0c4$export$a48f0734ac7c2329 = $8a0a73e6b73fd0c4$var$byteLength;
$8a0a73e6b73fd0c4$export$d622b2ad8d90c771 = $8a0a73e6b73fd0c4$var$toByteArray;
$8a0a73e6b73fd0c4$export$6100ba28696e12de = $8a0a73e6b73fd0c4$var$fromByteArray;
var $8a0a73e6b73fd0c4$var$lookup = [];
var $8a0a73e6b73fd0c4$var$revLookup = [];
var $8a0a73e6b73fd0c4$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $8a0a73e6b73fd0c4$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $8a0a73e6b73fd0c4$var$i = 0, $8a0a73e6b73fd0c4$var$len = $8a0a73e6b73fd0c4$var$code.length; $8a0a73e6b73fd0c4$var$i < $8a0a73e6b73fd0c4$var$len; ++$8a0a73e6b73fd0c4$var$i){
    $8a0a73e6b73fd0c4$var$lookup[$8a0a73e6b73fd0c4$var$i] = $8a0a73e6b73fd0c4$var$code[$8a0a73e6b73fd0c4$var$i];
    $8a0a73e6b73fd0c4$var$revLookup[$8a0a73e6b73fd0c4$var$code.charCodeAt($8a0a73e6b73fd0c4$var$i)] = $8a0a73e6b73fd0c4$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$8a0a73e6b73fd0c4$var$revLookup["-".charCodeAt(0)] = 62;
$8a0a73e6b73fd0c4$var$revLookup["_".charCodeAt(0)] = 63;
function $8a0a73e6b73fd0c4$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $8a0a73e6b73fd0c4$var$byteLength(b64) {
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $8a0a73e6b73fd0c4$var$toByteArray(b64) {
    var tmp;
    var lens = $8a0a73e6b73fd0c4$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $8a0a73e6b73fd0c4$var$Arr($8a0a73e6b73fd0c4$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 18 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 2 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i)] << 10 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $8a0a73e6b73fd0c4$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $8a0a73e6b73fd0c4$var$tripletToBase64(num) {
    return $8a0a73e6b73fd0c4$var$lookup[num >> 18 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 12 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num >> 6 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[num & 0x3F];
}
function $8a0a73e6b73fd0c4$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($8a0a73e6b73fd0c4$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $8a0a73e6b73fd0c4$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($8a0a73e6b73fd0c4$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 2] + $8a0a73e6b73fd0c4$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($8a0a73e6b73fd0c4$var$lookup[tmp >> 10] + $8a0a73e6b73fd0c4$var$lookup[tmp >> 4 & 0x3F] + $8a0a73e6b73fd0c4$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}


/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $998eb38f4d082829$export$aafa59e2e03f2942;
var $998eb38f4d082829$export$68d8715fc104d294;
$998eb38f4d082829$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$998eb38f4d082829$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};


const $0934e0939605d48c$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$0934e0939605d48c$export$a143d493d941bafc = $0934e0939605d48c$var$Buffer;
$0934e0939605d48c$export$e4cf37d7f6fb9e0a = $0934e0939605d48c$var$SlowBuffer;
$0934e0939605d48c$export$f99ded8fe4b79145 = 50;
const $0934e0939605d48c$var$K_MAX_LENGTH = 0x7fffffff;
$0934e0939605d48c$export$599f31c3813fae4d = $0934e0939605d48c$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT = $0934e0939605d48c$var$typedArraySupport();
if (!$0934e0939605d48c$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $0934e0939605d48c$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($0934e0939605d48c$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$0934e0939605d48c$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $0934e0939605d48c$var$createBuffer(length) {
    if (length > $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $0934e0939605d48c$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $0934e0939605d48c$var$allocUnsafe(arg);
    }
    return $0934e0939605d48c$var$from(arg, encodingOrOffset, length);
}
$0934e0939605d48c$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $0934e0939605d48c$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $0934e0939605d48c$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $0934e0939605d48c$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($0934e0939605d48c$var$isInstance(value, ArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, ArrayBuffer)) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($0934e0939605d48c$var$isInstance(value, SharedArrayBuffer) || value && $0934e0939605d48c$var$isInstance(value.buffer, SharedArrayBuffer))) return $0934e0939605d48c$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $0934e0939605d48c$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $0934e0939605d48c$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $0934e0939605d48c$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $0934e0939605d48c$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $0934e0939605d48c$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($0934e0939605d48c$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($0934e0939605d48c$var$Buffer, Uint8Array);
function $0934e0939605d48c$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $0934e0939605d48c$var$alloc(size, fill, encoding) {
    $0934e0939605d48c$var$assertSize(size);
    if (size <= 0) return $0934e0939605d48c$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $0934e0939605d48c$var$createBuffer(size).fill(fill, encoding) : $0934e0939605d48c$var$createBuffer(size).fill(fill);
    return $0934e0939605d48c$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $0934e0939605d48c$var$Buffer.alloc = function(size, fill, encoding) {
    return $0934e0939605d48c$var$alloc(size, fill, encoding);
};
function $0934e0939605d48c$var$allocUnsafe(size) {
    $0934e0939605d48c$var$assertSize(size);
    return $0934e0939605d48c$var$createBuffer(size < 0 ? 0 : $0934e0939605d48c$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $0934e0939605d48c$var$Buffer.allocUnsafe = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $0934e0939605d48c$var$Buffer.allocUnsafeSlow = function(size) {
    return $0934e0939605d48c$var$allocUnsafe(size);
};
function $0934e0939605d48c$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $0934e0939605d48c$var$byteLength(string, encoding) | 0;
    let buf = $0934e0939605d48c$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $0934e0939605d48c$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $0934e0939605d48c$var$checked(array.length) | 0;
    const buf = $0934e0939605d48c$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $0934e0939605d48c$var$fromArrayView(arrayView) {
    if ($0934e0939605d48c$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $0934e0939605d48c$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $0934e0939605d48c$var$fromArrayLike(arrayView);
}
function $0934e0939605d48c$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $0934e0939605d48c$var$Buffer.prototype);
    return buf;
}
function $0934e0939605d48c$var$fromObject(obj) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(obj)) {
        const len = $0934e0939605d48c$var$checked(obj.length) | 0;
        const buf = $0934e0939605d48c$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $0934e0939605d48c$var$numberIsNaN(obj.length)) return $0934e0939605d48c$var$createBuffer(0);
        return $0934e0939605d48c$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $0934e0939605d48c$var$fromArrayLike(obj.data);
}
function $0934e0939605d48c$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $0934e0939605d48c$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $0934e0939605d48c$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $0934e0939605d48c$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $0934e0939605d48c$var$Buffer.alloc(+length);
}
$0934e0939605d48c$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $0934e0939605d48c$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$0934e0939605d48c$var$Buffer.compare = function compare(a, b) {
    if ($0934e0939605d48c$var$isInstance(a, Uint8Array)) a = $0934e0939605d48c$var$Buffer.from(a, a.offset, a.byteLength);
    if ($0934e0939605d48c$var$isInstance(b, Uint8Array)) b = $0934e0939605d48c$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(a) || !$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$0934e0939605d48c$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$0934e0939605d48c$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $0934e0939605d48c$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $0934e0939605d48c$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($0934e0939605d48c$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) buf = $0934e0939605d48c$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $0934e0939605d48c$var$byteLength(string, encoding) {
    if ($0934e0939605d48c$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $0934e0939605d48c$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $0934e0939605d48c$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $0934e0939605d48c$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$0934e0939605d48c$var$Buffer.byteLength = $0934e0939605d48c$var$byteLength;
function $0934e0939605d48c$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Slice(this, start, end);
        case "ascii":
            return $0934e0939605d48c$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$latin1Slice(this, start, end);
        case "base64":
            return $0934e0939605d48c$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$0934e0939605d48c$var$Buffer.prototype._isBuffer = true;
function $0934e0939605d48c$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$0934e0939605d48c$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$0934e0939605d48c$var$swap(this, i, i + 1);
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $0934e0939605d48c$var$swap(this, i, i + 3);
        $0934e0939605d48c$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $0934e0939605d48c$var$swap(this, i, i + 7);
        $0934e0939605d48c$var$swap(this, i + 1, i + 6);
        $0934e0939605d48c$var$swap(this, i + 2, i + 5);
        $0934e0939605d48c$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$0934e0939605d48c$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $0934e0939605d48c$var$utf8Slice(this, 0, length);
    return $0934e0939605d48c$var$slowToString.apply(this, arguments);
};
$0934e0939605d48c$var$Buffer.prototype.toLocaleString = $0934e0939605d48c$var$Buffer.prototype.toString;
$0934e0939605d48c$var$Buffer.prototype.equals = function equals(b) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $0934e0939605d48c$var$Buffer.compare(this, b) === 0;
};
$0934e0939605d48c$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $0934e0939605d48c$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($0934e0939605d48c$var$customInspectSymbol) $0934e0939605d48c$var$Buffer.prototype[$0934e0939605d48c$var$customInspectSymbol] = $0934e0939605d48c$var$Buffer.prototype.inspect;
$0934e0939605d48c$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($0934e0939605d48c$var$isInstance(target, Uint8Array)) target = $0934e0939605d48c$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $0934e0939605d48c$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($0934e0939605d48c$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $0934e0939605d48c$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($0934e0939605d48c$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $0934e0939605d48c$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $0934e0939605d48c$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $0934e0939605d48c$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$0934e0939605d48c$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$0934e0939605d48c$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$0934e0939605d48c$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $0934e0939605d48c$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $0934e0939605d48c$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($0934e0939605d48c$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $0934e0939605d48c$var$utf8Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $0934e0939605d48c$var$asciiWrite(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$asciiToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$base64Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$base64ToBytes(string), buf, offset, length);
}
function $0934e0939605d48c$var$ucs2Write(buf, string, offset, length) {
    return $0934e0939605d48c$var$blitBuffer($0934e0939605d48c$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$0934e0939605d48c$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $0934e0939605d48c$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $0934e0939605d48c$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $0934e0939605d48c$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $0934e0939605d48c$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $0934e0939605d48c$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$0934e0939605d48c$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $0934e0939605d48c$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf);
    else return $8a0a73e6b73fd0c4$export$6100ba28696e12de(buf.slice(start, end));
}
function $0934e0939605d48c$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $0934e0939605d48c$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $0934e0939605d48c$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $0934e0939605d48c$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $0934e0939605d48c$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $0934e0939605d48c$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $0934e0939605d48c$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $0934e0939605d48c$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $0934e0939605d48c$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$0934e0939605d48c$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $0934e0939605d48c$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $0934e0939605d48c$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$0934e0939605d48c$var$Buffer.prototype.readUintLE = $0934e0939605d48c$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUintBE = $0934e0939605d48c$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readUint8 = $0934e0939605d48c$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$0934e0939605d48c$var$Buffer.prototype.readUint16LE = $0934e0939605d48c$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$0934e0939605d48c$var$Buffer.prototype.readUint16BE = $0934e0939605d48c$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$0934e0939605d48c$var$Buffer.prototype.readUint32LE = $0934e0939605d48c$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$0934e0939605d48c$var$Buffer.prototype.readUint32BE = $0934e0939605d48c$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$0934e0939605d48c$var$Buffer.prototype.readBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$0934e0939605d48c$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$0934e0939605d48c$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$0934e0939605d48c$var$Buffer.prototype.readBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$0934e0939605d48c$var$Buffer.prototype.readBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $0934e0939605d48c$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$0934e0939605d48c$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 4, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 23, 4);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, true, 52, 8);
};
$0934e0939605d48c$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkOffset(offset, 8, this.length);
    return $998eb38f4d082829$export$aafa59e2e03f2942(this, offset, false, 52, 8);
};
function $0934e0939605d48c$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$0934e0939605d48c$var$Buffer.prototype.writeUintLE = $0934e0939605d48c$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUintBE = $0934e0939605d48c$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint8 = $0934e0939605d48c$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint16BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32LE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeUint32BE = $0934e0939605d48c$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $0934e0939605d48c$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $0934e0939605d48c$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigUInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $0934e0939605d48c$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64LE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$0934e0939605d48c$var$Buffer.prototype.writeBigInt64BE = $0934e0939605d48c$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $0934e0939605d48c$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $0934e0939605d48c$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $0934e0939605d48c$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$0934e0939605d48c$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeFloat(this, value, offset, false, noAssert);
};
function $0934e0939605d48c$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $0934e0939605d48c$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $998eb38f4d082829$export$68d8715fc104d294(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$0934e0939605d48c$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, true, noAssert);
};
$0934e0939605d48c$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $0934e0939605d48c$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$0934e0939605d48c$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$0934e0939605d48c$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$0934e0939605d48c$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$0934e0939605d48c$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $0934e0939605d48c$var$Buffer.isBuffer(val) ? val : $0934e0939605d48c$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $0934e0939605d48c$var$errors = {};
function $0934e0939605d48c$var$E(sym, getMessage, Base) {
    $0934e0939605d48c$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$0934e0939605d48c$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$0934e0939605d48c$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$0934e0939605d48c$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $0934e0939605d48c$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $0934e0939605d48c$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $0934e0939605d48c$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $0934e0939605d48c$var$checkBounds(buf, offset, byteLength) {
    $0934e0939605d48c$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $0934e0939605d48c$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $0934e0939605d48c$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $0934e0939605d48c$var$checkBounds(buf, offset, byteLength);
}
function $0934e0939605d48c$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $0934e0939605d48c$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $0934e0939605d48c$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $0934e0939605d48c$var$validateNumber(value, type);
        throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $0934e0939605d48c$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $0934e0939605d48c$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $0934e0939605d48c$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $0934e0939605d48c$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($0934e0939605d48c$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $0934e0939605d48c$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $0934e0939605d48c$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $0934e0939605d48c$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $0934e0939605d48c$var$base64ToBytes(str) {
    return $8a0a73e6b73fd0c4$export$d622b2ad8d90c771($0934e0939605d48c$var$base64clean(str));
}
function $0934e0939605d48c$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $0934e0939605d48c$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $0934e0939605d48c$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $0934e0939605d48c$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $0934e0939605d48c$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $0934e0939605d48c$var$BufferBigIntNotDefined : fn;
}
function $0934e0939605d48c$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}


var $fd07b9cb0132c1f6$require$Buffer = $0934e0939605d48c$export$a143d493d941bafc;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isVisitable(thing) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $fd07b9cb0132c1f6$var$removeBrackets(key) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $fd07b9cb0132c1f6$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $fd07b9cb0132c1f6$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $fd07b9cb0132c1f6$var$isFlatArray(arr) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(arr) && !arr.some($fd07b9cb0132c1f6$var$isVisitable);
}
const $fd07b9cb0132c1f6$var$predicates = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $fd07b9cb0132c1f6$var$toFormData(obj, formData, options) {
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $86ebf0c810395e29$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $fd07b9cb0132c1f6$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) && $fd07b9cb0132c1f6$var$isFlatArray(value) || ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(value) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $fd07b9cb0132c1f6$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $fd07b9cb0132c1f6$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($fd07b9cb0132c1f6$var$isVisitable(value)) return true;
        formData.append($fd07b9cb0132c1f6$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($fd07b9cb0132c1f6$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $fd07b9cb0132c1f6$var$isVisitable
    });
    function build(value, path) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $fd07b9cb0132c1f6$export$2e2bcd8739ae039 = $fd07b9cb0132c1f6$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $344cf8e4292137b6$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\x00"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $344cf8e4292137b6$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(params, this, options);
}
const $344cf8e4292137b6$var$prototype = $344cf8e4292137b6$var$AxiosURLSearchParams.prototype;
$344cf8e4292137b6$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$344cf8e4292137b6$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $344cf8e4292137b6$var$encode);
    } : $344cf8e4292137b6$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $344cf8e4292137b6$export$2e2bcd8739ae039 = $344cf8e4292137b6$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $db2f05ec923f2ee7$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $db2f05ec923f2ee7$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $db2f05ec923f2ee7$var$encode;
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $344cf8e4292137b6$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $01c17f80085c95b1$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $01c17f80085c95b1$export$2e2bcd8739ae039 = $01c17f80085c95b1$var$InterceptorManager;





"use strict";
var $3075bac9f30e7782$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $a85e5bed82430d61$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $344cf8e4292137b6$export$2e2bcd8739ae039);


"use strict";
var $46b12d255f217052$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $2e4211376cea43e6$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $fb24c6d0b2a74508$var$isStandardBrowserEnv = (()=>{
    let product;
    if (typeof navigator !== "undefined" && ((product = navigator.product) === "ReactNative" || product === "NativeScript" || product === "NS")) return false;
    return typeof window !== "undefined" && typeof document !== "undefined";
})();
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $fb24c6d0b2a74508$var$isStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
var $fb24c6d0b2a74508$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $a85e5bed82430d61$export$2e2bcd8739ae039,
        FormData: $46b12d255f217052$export$2e2bcd8739ae039,
        Blob: $2e4211376cea43e6$export$2e2bcd8739ae039
    },
    isStandardBrowserEnv: $fb24c6d0b2a74508$var$isStandardBrowserEnv,
    isStandardBrowserWebWorkerEnv: $fb24c6d0b2a74508$var$isStandardBrowserWebWorkerEnv,
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


"use strict";
function $aa000567d8bb5ae2$export$2e2bcd8739ae039(data, options) {
    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(data, new (0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).isNode && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $cb8fe7f388dc4432$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $cb8fe7f388dc4432$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $cb8fe7f388dc4432$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $cb8fe7f388dc4432$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(formData) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($cb8fe7f388dc4432$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $cb8fe7f388dc4432$export$2e2bcd8739ae039 = $cb8fe7f388dc4432$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $e30871f78dcd7f19$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $e30871f78dcd7f19$var$defaults = {
    transitional: (0, $3075bac9f30e7782$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) {
                if (!hasJSONContentType) return data;
                return hasJSONContentType ? JSON.stringify((0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)(data)) : data;
            }
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBuffer(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isStream(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFile(data) || (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isBlob(data)) return data;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $aa000567d8bb5ae2$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $e30871f78dcd7f19$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $e30871f78dcd7f19$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if (data && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).from(e, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $e30871f78dcd7f19$var$defaults.headers[method] = {};
});
var $e30871f78dcd7f19$export$2e2bcd8739ae039 = $e30871f78dcd7f19$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $36eacf0f5ae88424$var$ignoreDuplicateOf = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $36eacf0f5ae88424$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $36eacf0f5ae88424$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $54e5234108b8e954$var$$internals = Symbol("internals");
function $54e5234108b8e954$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $54e5234108b8e954$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.map($54e5234108b8e954$var$normalizeValue) : String(value);
}
function $54e5234108b8e954$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $54e5234108b8e954$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $54e5234108b8e954$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $54e5234108b8e954$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $54e5234108b8e954$var$buildAccessors(obj, header) {
    const accessorName = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $54e5234108b8e954$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $54e5234108b8e954$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$54e5234108b8e954$var$isValidHeaderName(header)) setHeaders((0, $36eacf0f5ae88424$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $54e5234108b8e954$var$parseTokens(value);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $54e5234108b8e954$var$normalizeHeader(header);
        if (header) {
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $54e5234108b8e954$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $54e5234108b8e954$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $54e5234108b8e954$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $54e5234108b8e954$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $54e5234108b8e954$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $54e5234108b8e954$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$54e5234108b8e954$var$$internals] = this[$54e5234108b8e954$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $54e5234108b8e954$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $54e5234108b8e954$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$54e5234108b8e954$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).reduceDescriptors($54e5234108b8e954$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).freezeMethods($54e5234108b8e954$var$AxiosHeaders);
var $54e5234108b8e954$export$2e2bcd8739ae039 = $54e5234108b8e954$var$AxiosHeaders;


"use strict";
function $ec027d10dfede142$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $fbc9c01c5c3dc518$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $63b8b72909769bf2$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).inherits($63b8b72909769bf2$var$CanceledError, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $63b8b72909769bf2$export$2e2bcd8739ae039 = $63b8b72909769bf2$var$CanceledError;







"use strict";
function $c0e22576f74b8071$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}




"use strict";
var $4d3cf801f7fd4dc6$export$2e2bcd8739ae039 = (0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            const cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isNumber(expires)) cookie.push("expires=" + new Date(expires).toGMTString());
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(path)) cookie.push("path=" + path);
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(domain)) cookie.push("domain=" + domain);
            if (secure === true) cookie.push("secure");
            document.cookie = cookie.join("; ");
        },
        read: function read(name) {
            const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, "", Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();



"use strict";
function $05bf269bfca011f3$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $7c49e720f6231ba2$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $8ed3292b1f9dccb5$export$2e2bcd8739ae039(baseURL, requestedURL) {
    if (baseURL && !(0, $05bf269bfca011f3$export$2e2bcd8739ae039)(requestedURL)) return (0, $7c49e720f6231ba2$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
var $3a08e3bf7b3045fa$export$2e2bcd8739ae039 = (0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).isStandardBrowserEnv ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    const msie = /(msie|trident)/i.test(navigator.userAgent);
    const urlParsingNode = document.createElement("a");
    let originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        let href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute("href", href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        const parsed = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();





"use strict";
function $9cab09d0d089fc0e$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $48a8aeed25ee768a$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $48a8aeed25ee768a$export$2e2bcd8739ae039 = $48a8aeed25ee768a$var$speedometer;


"use strict";
function $61abd1574bd1dd32$var$progressEventReducer(listener, isDownloadStream) {
    let bytesNotified = 0;
    const _speedometer = (0, $48a8aeed25ee768a$export$2e2bcd8739ae039)(50, 250);
    return (e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e
        };
        data[isDownloadStream ? "download" : "upload"] = true;
        listener(data);
    };
}
const $61abd1574bd1dd32$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $61abd1574bd1dd32$export$2e2bcd8739ae039 = $61abd1574bd1dd32$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        let requestData = config.data;
        const requestHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(config.headers).normalize();
        const responseType = config.responseType;
        let onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener("abort", onCanceled);
        }
        let contentType;
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFormData(requestData)) {
            if ((0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).isStandardBrowserEnv || (0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).isStandardBrowserWebWorkerEnv) requestHeaders.setContentType(false); // Let the browser set it
            else if (!requestHeaders.getContentType(/^\s*multipart\/form-data/)) requestHeaders.setContentType("multipart/form-data"); // mobile/desktop app frameworks
            else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isString(contentType = requestHeaders.getContentType())) // fix semicolon duplication issue for ReactNative FormData implementation
            requestHeaders.setContentType(contentType.replace(/^\s*(multipart\/form-data);+/, "$1"));
        }
        let request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            const username = config.auth.username || "";
            const password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
            requestHeaders.set("Authorization", "Basic " + btoa(username + ":" + password));
        }
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $c0e22576f74b8071$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Request aborted", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Network Error", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = config.transitional || (0, $3075bac9f30e7782$export$2e2bcd8739ae039);
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ETIMEDOUT : (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ((0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).isStandardBrowserEnv) {
            // Add xsrf header
            const xsrfValue = (config.withCredentials || (0, $3a08e3bf7b3045fa$export$2e2bcd8739ae039)(fullPath)) && config.xsrfCookieName && (0, $4d3cf801f7fd4dc6$export$2e2bcd8739ae039).read(config.xsrfCookieName);
            if (xsrfValue) requestHeaders.set(config.xsrfHeaderName, xsrfValue);
        }
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === "function") request.addEventListener("progress", $61abd1574bd1dd32$var$progressEventReducer(config.onDownloadProgress, true));
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === "function" && request.upload) request.upload.addEventListener("progress", $61abd1574bd1dd32$var$progressEventReducer(config.onUploadProgress));
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $9cab09d0d089fc0e$export$2e2bcd8739ae039)(fullPath);
        if (protocol && (0, $fb24c6d0b2a74508$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};



const $d570c100e0cb7a05$var$knownAdapters = {
    http: (0, $86ebf0c810395e29$export$2e2bcd8739ae039),
    xhr: (0, $61abd1574bd1dd32$export$2e2bcd8739ae039)
};
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach($d570c100e0cb7a05$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $d570c100e0cb7a05$var$renderReason = (reason)=>`- ${reason}`;
const $d570c100e0cb7a05$var$isResolvedHandle = (adapter)=>(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $d570c100e0cb7a05$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$d570c100e0cb7a05$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $d570c100e0cb7a05$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($d570c100e0cb7a05$var$renderReason).join("\n") : " " + $d570c100e0cb7a05$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $d570c100e0cb7a05$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $96666136aaccd2e5$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(null, config);
}
function $96666136aaccd2e5$export$2e2bcd8739ae039(config) {
    $96666136aaccd2e5$var$throwIfCancellationRequested(config);
    config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $e30871f78dcd7f19$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $96666136aaccd2e5$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039)(reason)) {
            $96666136aaccd2e5$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $ec027d10dfede142$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




"use strict";
const $20ede3a7e8b675d4$var$headersToObject = (thing)=>thing instanceof (0, $54e5234108b8e954$export$2e2bcd8739ae039) ? thing.toJSON() : thing;
function $20ede3a7e8b675d4$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, caseless) {
        if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(target) && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, caseless) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, caseless);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b)=>mergeDeepProperties($20ede3a7e8b675d4$var$headersToObject(a), $20ede3a7e8b675d4$var$headersToObject(b), true)
    };
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}



const $4c74d331112ba968$export$a4ad2735b021c132 = "1.5.1";



"use strict";
const $63efb8494987aa98$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $63efb8494987aa98$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $63efb8494987aa98$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $63efb8494987aa98$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $4c74d331112ba968$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$63efb8494987aa98$var$deprecatedWarnings[opt]) {
            $63efb8494987aa98$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $63efb8494987aa98$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("options must be an object", (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $63efb8494987aa98$export$2e2bcd8739ae039 = {
    assertOptions: $63efb8494987aa98$var$assertOptions,
    validators: $63efb8494987aa98$var$validators
};



"use strict";
const $cd0b8e3cbef64068$var$validators = (0, $63efb8494987aa98$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $cd0b8e3cbef64068$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)(),
            response: new (0, $01c17f80085c95b1$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            forcedJSONParsing: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean),
            clarifyTimeoutError: $cd0b8e3cbef64068$var$validators.transitional($cd0b8e3cbef64068$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $63efb8494987aa98$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $cd0b8e3cbef64068$var$validators.function,
                serialize: $cd0b8e3cbef64068$var$validators.function
            }, true);
        }
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $54e5234108b8e954$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $96666136aaccd2e5$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $96666136aaccd2e5$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $8ed3292b1f9dccb5$export$2e2bcd8739ae039)(config.baseURL, config.url);
        return (0, $db2f05ec923f2ee7$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $cd0b8e3cbef64068$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $cd0b8e3cbef64068$var$Axios.prototype[method] = generateHTTPMethod();
    $cd0b8e3cbef64068$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $cd0b8e3cbef64068$export$2e2bcd8739ae039 = $cd0b8e3cbef64068$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $3218dd97b5460664$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $63b8b72909769bf2$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $3218dd97b5460664$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $3218dd97b5460664$export$2e2bcd8739ae039 = $3218dd97b5460664$var$CancelToken;






"use strict";
function $7874d702b64e6994$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $16f479813f4fb9c8$export$2e2bcd8739ae039(payload) {
    return (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $edd7ef3f6e3b67e5$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($edd7ef3f6e3b67e5$var$HttpStatusCode).forEach(([key, value])=>{
    $edd7ef3f6e3b67e5$var$HttpStatusCode[value] = key;
});
var $edd7ef3f6e3b67e5$export$2e2bcd8739ae039 = $edd7ef3f6e3b67e5$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $5d7526a7a1e5b3fb$var$createInstance(defaultConfig) {
    const context = new (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $93b0f01b05e2607a$export$2e2bcd8739ae039)((0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $5d7526a7a1e5b3fb$var$createInstance((0, $20ede3a7e8b675d4$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $5d7526a7a1e5b3fb$var$axios = $5d7526a7a1e5b3fb$var$createInstance((0, $e30871f78dcd7f19$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$5d7526a7a1e5b3fb$var$axios.Axios = (0, $cd0b8e3cbef64068$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$5d7526a7a1e5b3fb$var$axios.CanceledError = (0, $63b8b72909769bf2$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.CancelToken = (0, $3218dd97b5460664$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.isCancel = (0, $fbc9c01c5c3dc518$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.VERSION = (0, $4c74d331112ba968$export$a4ad2735b021c132);
$5d7526a7a1e5b3fb$var$axios.toFormData = (0, $fd07b9cb0132c1f6$export$2e2bcd8739ae039);
// Expose AxiosError class
$5d7526a7a1e5b3fb$var$axios.AxiosError = (0, $0139f1d30f4d6bd5$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$5d7526a7a1e5b3fb$var$axios.Cancel = $5d7526a7a1e5b3fb$var$axios.CanceledError;
// Expose all/spread
$5d7526a7a1e5b3fb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$5d7526a7a1e5b3fb$var$axios.spread = (0, $7874d702b64e6994$export$2e2bcd8739ae039);
// Expose isAxiosError
$5d7526a7a1e5b3fb$var$axios.isAxiosError = (0, $16f479813f4fb9c8$export$2e2bcd8739ae039);
// Expose mergeConfig
$5d7526a7a1e5b3fb$var$axios.mergeConfig = (0, $20ede3a7e8b675d4$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.AxiosHeaders = (0, $54e5234108b8e954$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.formToJSON = (thing)=>(0, $cb8fe7f388dc4432$export$2e2bcd8739ae039)((0, $aace3e920a0f1e4d$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$5d7526a7a1e5b3fb$var$axios.getAdapter = (0, $d570c100e0cb7a05$export$2e2bcd8739ae039).getAdapter;
$5d7526a7a1e5b3fb$var$axios.HttpStatusCode = (0, $edd7ef3f6e3b67e5$export$2e2bcd8739ae039);
$5d7526a7a1e5b3fb$var$axios.default = $5d7526a7a1e5b3fb$var$axios;
var // this module should only have a default export
$5d7526a7a1e5b3fb$export$2e2bcd8739ae039 = $5d7526a7a1e5b3fb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $125d1ceb57662f9a$export$1c00760e9e5a4e95, AxiosError: $125d1ceb57662f9a$export$c1fbed17c2f6a328, CanceledError: $125d1ceb57662f9a$export$1ab0c6b20d94fa14, isCancel: $125d1ceb57662f9a$export$3b22524397b493c6, CancelToken: $125d1ceb57662f9a$export$fd08e3cb425f0d61, VERSION: $125d1ceb57662f9a$export$a4ad2735b021c132, all: $125d1ceb57662f9a$export$84bf76cd7afc7469, Cancel: $125d1ceb57662f9a$export$848c9b7ead0df967, isAxiosError: $125d1ceb57662f9a$export$fbafdbe06a5b5a9a, spread: $125d1ceb57662f9a$export$3ae0fd4797ed47c8, toFormData: $125d1ceb57662f9a$export$10ae0d317ea97f8b, AxiosHeaders: $125d1ceb57662f9a$export$4e7d6ff0f3e6520, HttpStatusCode: $125d1ceb57662f9a$export$a972f69c851492b3, formToJSON: $125d1ceb57662f9a$export$86d7c59254d6a2c9, getAdapter: $125d1ceb57662f9a$export$17ddc20a97d669e2, mergeConfig: $125d1ceb57662f9a$export$7ec1ebcfa9d8bd6a } = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039);


var $f2ec8d2c6ac3c51c$var$__assign = undefined && undefined.__assign || function() {
    $f2ec8d2c6ac3c51c$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f2ec8d2c6ac3c51c$var$__assign.apply(this, arguments);
};
var $f2ec8d2c6ac3c51c$var$NavbarAPI = /** @class */ function() {
    function NavbarAPI() {
        var token = sessionStorage.getItem("jwt_access_token");
        var headers = {
            Authorization: "Bearer ".concat(token)
        };
        this.client = (0, $5d7526a7a1e5b3fb$export$2e2bcd8739ae039).create({
            baseURL: "https://api.thesimple.ink/site",
            // withCredentials: true,
            timeout: Infinity,
            headers: $f2ec8d2c6ac3c51c$var$__assign({
                "Content-Type": "application/json"
            }, headers)
        });
    }
    NavbarAPI.getInstance = function() {
        if (!this.instance) this.instance = new NavbarAPI();
        return this.instance;
    };
    NavbarAPI.prototype.fetch = function(siteId) {
        return this.client.get("/".concat(siteId, "/navbar"));
    };
    NavbarAPI.prototype.create = function(siteId, data) {
        return this.client.post("/".concat(siteId, "/navbar"), data);
    };
    NavbarAPI.prototype.update = function(siteId, data) {
        return this.client.put("/".concat(siteId, "/navbar"), data);
    };
    NavbarAPI.prototype.remove = function(siteId) {
        return this.client.delete("/".concat(siteId, "/navbar"));
    };
    NavbarAPI.prototype.createButton = function(siteId, data) {
        return this.client.post("/".concat(siteId, "/navbar_button"), data);
    };
    NavbarAPI.prototype.createLink = function(siteId, data) {
        return this.client.post("/".concat(siteId, "/navbar_link"), data);
    };
    NavbarAPI.prototype.updateButton = function(siteId, id, data) {
        return this.client.put("/".concat(siteId, "/navbar_button/").concat(id), data);
    };
    NavbarAPI.prototype.updateLink = function(siteId, id, data) {
        return this.client.put("/".concat(siteId, "/navbar_link").concat(id), data);
    };
    NavbarAPI.prototype.deleteButton = function(siteId, id) {
        return this.client.delete("/".concat(siteId, "/navbar_button/").concat(id));
    };
    NavbarAPI.prototype.deleteLink = function(siteId, id) {
        return this.client.delete("/".concat(siteId, "/navbar_link/").concat(id));
    };
    return NavbarAPI;
}();
var $f2ec8d2c6ac3c51c$export$2e2bcd8739ae039 // strict-origin-when-cross-origin
 = $f2ec8d2c6ac3c51c$var$NavbarAPI.getInstance();


var $1b004826bb3c78d0$exports = {};
/*!
* sweetalert2 v11.7.32
* Released under the MIT License.
*/ (function(global, factory) {
    $1b004826bb3c78d0$exports = factory();
})($1b004826bb3c78d0$exports, function() {
    "use strict";
    function _classPrivateFieldGet(receiver, privateMap) {
        var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get");
        return _classApplyDescriptorGet(receiver, descriptor);
    }
    function _classPrivateFieldSet(receiver, privateMap, value) {
        var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set");
        _classApplyDescriptorSet(receiver, descriptor, value);
        return value;
    }
    function _classExtractFieldDescriptor(receiver, privateMap, action) {
        if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
        return privateMap.get(receiver);
    }
    function _classApplyDescriptorGet(receiver, descriptor) {
        if (descriptor.get) return descriptor.get.call(receiver);
        return descriptor.value;
    }
    function _classApplyDescriptorSet(receiver, descriptor, value) {
        if (descriptor.set) descriptor.set.call(receiver, value);
        else {
            if (!descriptor.writable) throw new TypeError("attempted to set read only private field");
            descriptor.value = value;
        }
    }
    function _checkPrivateRedeclaration(obj, privateCollection) {
        if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
    }
    function _classPrivateFieldInitSpec(obj, privateMap, value) {
        _checkPrivateRedeclaration(obj, privateMap);
        privateMap.set(obj, value);
    }
    const RESTORE_FOCUS_TIMEOUT = 100;
    /** @type {GlobalState} */ const globalState = {};
    const focusPreviousActiveElement = ()=>{
        if (globalState.previousActiveElement instanceof HTMLElement) {
            globalState.previousActiveElement.focus();
            globalState.previousActiveElement = null;
        } else if (document.body) document.body.focus();
    };
    /**
   * Restore previous active (focused) element
   *
   * @param {boolean} returnFocus
   * @returns {Promise<void>}
   */ const restoreActiveElement = (returnFocus)=>{
        return new Promise((resolve)=>{
            if (!returnFocus) return resolve();
            const x = window.scrollX;
            const y = window.scrollY;
            globalState.restoreFocusTimeout = setTimeout(()=>{
                focusPreviousActiveElement();
                resolve();
            }, RESTORE_FOCUS_TIMEOUT); // issues/900
            window.scrollTo(x, y);
        });
    };
    const swalPrefix = "swal2-";
    /**
   * @typedef
   * { | 'container'
   *   | 'shown'
   *   | 'height-auto'
   *   | 'iosfix'
   *   | 'popup'
   *   | 'modal'
   *   | 'no-backdrop'
   *   | 'no-transition'
   *   | 'toast'
   *   | 'toast-shown'
   *   | 'show'
   *   | 'hide'
   *   | 'close'
   *   | 'title'
   *   | 'html-container'
   *   | 'actions'
   *   | 'confirm'
   *   | 'deny'
   *   | 'cancel'
   *   | 'default-outline'
   *   | 'footer'
   *   | 'icon'
   *   | 'icon-content'
   *   | 'image'
   *   | 'input'
   *   | 'file'
   *   | 'range'
   *   | 'select'
   *   | 'radio'
   *   | 'checkbox'
   *   | 'label'
   *   | 'textarea'
   *   | 'inputerror'
   *   | 'input-label'
   *   | 'validation-message'
   *   | 'progress-steps'
   *   | 'active-progress-step'
   *   | 'progress-step'
   *   | 'progress-step-line'
   *   | 'loader'
   *   | 'loading'
   *   | 'styled'
   *   | 'top'
   *   | 'top-start'
   *   | 'top-end'
   *   | 'top-left'
   *   | 'top-right'
   *   | 'center'
   *   | 'center-start'
   *   | 'center-end'
   *   | 'center-left'
   *   | 'center-right'
   *   | 'bottom'
   *   | 'bottom-start'
   *   | 'bottom-end'
   *   | 'bottom-left'
   *   | 'bottom-right'
   *   | 'grow-row'
   *   | 'grow-column'
   *   | 'grow-fullscreen'
   *   | 'rtl'
   *   | 'timer-progress-bar'
   *   | 'timer-progress-bar-container'
   *   | 'scrollbar-measure'
   *   | 'icon-success'
   *   | 'icon-warning'
   *   | 'icon-info'
   *   | 'icon-question'
   *   | 'icon-error'
   * } SwalClass
   * @typedef {Record<SwalClass, string>} SwalClasses
   */ /**
   * @typedef {'success' | 'warning' | 'info' | 'question' | 'error'} SwalIcon
   * @typedef {Record<SwalIcon, string>} SwalIcons
   */ /** @type {SwalClass[]} */ const classNames = [
        "container",
        "shown",
        "height-auto",
        "iosfix",
        "popup",
        "modal",
        "no-backdrop",
        "no-transition",
        "toast",
        "toast-shown",
        "show",
        "hide",
        "close",
        "title",
        "html-container",
        "actions",
        "confirm",
        "deny",
        "cancel",
        "default-outline",
        "footer",
        "icon",
        "icon-content",
        "image",
        "input",
        "file",
        "range",
        "select",
        "radio",
        "checkbox",
        "label",
        "textarea",
        "inputerror",
        "input-label",
        "validation-message",
        "progress-steps",
        "active-progress-step",
        "progress-step",
        "progress-step-line",
        "loader",
        "loading",
        "styled",
        "top",
        "top-start",
        "top-end",
        "top-left",
        "top-right",
        "center",
        "center-start",
        "center-end",
        "center-left",
        "center-right",
        "bottom",
        "bottom-start",
        "bottom-end",
        "bottom-left",
        "bottom-right",
        "grow-row",
        "grow-column",
        "grow-fullscreen",
        "rtl",
        "timer-progress-bar",
        "timer-progress-bar-container",
        "scrollbar-measure",
        "icon-success",
        "icon-warning",
        "icon-info",
        "icon-question",
        "icon-error"
    ];
    const swalClasses = classNames.reduce((acc, className)=>{
        acc[className] = swalPrefix + className;
        return acc;
    }, /** @type {SwalClasses} */ {});
    /** @type {SwalIcon[]} */ const icons = [
        "success",
        "warning",
        "info",
        "question",
        "error"
    ];
    const iconTypes = icons.reduce((acc, icon)=>{
        acc[icon] = swalPrefix + icon;
        return acc;
    }, /** @type {SwalIcons} */ {});
    const consolePrefix = "SweetAlert2:";
    /**
   * Capitalize the first letter of a string
   *
   * @param {string} str
   * @returns {string}
   */ const capitalizeFirstLetter = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
    /**
   * Standardize console warnings
   *
   * @param {string | string[]} message
   */ const warn = (message)=>{
        console.warn("".concat(consolePrefix, " ").concat(typeof message === "object" ? message.join(" ") : message));
    };
    /**
   * Standardize console errors
   *
   * @param {string} message
   */ const error = (message)=>{
        console.error("".concat(consolePrefix, " ").concat(message));
    };
    /**
   * Private global state for `warnOnce`
   *
   * @type {string[]}
   * @private
   */ const previousWarnOnceMessages = [];
    /**
   * Show a console warning, but only if it hasn't already been shown
   *
   * @param {string} message
   */ const warnOnce = (message)=>{
        if (!previousWarnOnceMessages.includes(message)) {
            previousWarnOnceMessages.push(message);
            warn(message);
        }
    };
    /**
   * Show a one-time console warning about deprecated params/methods
   *
   * @param {string} deprecatedParam
   * @param {string} useInstead
   */ const warnAboutDeprecation = (deprecatedParam, useInstead)=>{
        warnOnce('"'.concat(deprecatedParam, '" is deprecated and will be removed in the next major release. Please use "').concat(useInstead, '" instead.'));
    };
    /**
   * If `arg` is a function, call it (with no arguments or context) and return the result.
   * Otherwise, just pass the value through
   *
   * @param {Function | any} arg
   * @returns {any}
   */ const callIfFunction = (arg)=>typeof arg === "function" ? arg() : arg;
    /**
   * @param {any} arg
   * @returns {boolean}
   */ const hasToPromiseFn = (arg)=>arg && typeof arg.toPromise === "function";
    /**
   * @param {any} arg
   * @returns {Promise<any>}
   */ const asPromise = (arg)=>hasToPromiseFn(arg) ? arg.toPromise() : Promise.resolve(arg);
    /**
   * @param {any} arg
   * @returns {boolean}
   */ const isPromise = (arg)=>arg && Promise.resolve(arg) === arg;
    /**
   * Gets the popup container which contains the backdrop and the popup itself.
   *
   * @returns {HTMLElement | null}
   */ const getContainer = ()=>document.body.querySelector(".".concat(swalClasses.container));
    /**
   * @param {string} selectorString
   * @returns {HTMLElement | null}
   */ const elementBySelector = (selectorString)=>{
        const container = getContainer();
        return container ? container.querySelector(selectorString) : null;
    };
    /**
   * @param {string} className
   * @returns {HTMLElement | null}
   */ const elementByClass = (className)=>{
        return elementBySelector(".".concat(className));
    };
    /**
   * @returns {HTMLElement | null}
   */ const getPopup = ()=>elementByClass(swalClasses.popup);
    /**
   * @returns {HTMLElement | null}
   */ const getIcon = ()=>elementByClass(swalClasses.icon);
    /**
   * @returns {HTMLElement | null}
   */ const getIconContent = ()=>elementByClass(swalClasses["icon-content"]);
    /**
   * @returns {HTMLElement | null}
   */ const getTitle = ()=>elementByClass(swalClasses.title);
    /**
   * @returns {HTMLElement | null}
   */ const getHtmlContainer = ()=>elementByClass(swalClasses["html-container"]);
    /**
   * @returns {HTMLElement | null}
   */ const getImage = ()=>elementByClass(swalClasses.image);
    /**
   * @returns {HTMLElement | null}
   */ const getProgressSteps = ()=>elementByClass(swalClasses["progress-steps"]);
    /**
   * @returns {HTMLElement | null}
   */ const getValidationMessage = ()=>elementByClass(swalClasses["validation-message"]);
    /**
   * @returns {HTMLButtonElement | null}
   */ const getConfirmButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.confirm));
    /**
   * @returns {HTMLButtonElement | null}
   */ const getCancelButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.cancel));
    /**
   * @returns {HTMLButtonElement | null}
   */ const getDenyButton = ()=>/** @type {HTMLButtonElement} */ elementBySelector(".".concat(swalClasses.actions, " .").concat(swalClasses.deny));
    /**
   * @returns {HTMLElement | null}
   */ const getInputLabel = ()=>elementByClass(swalClasses["input-label"]);
    /**
   * @returns {HTMLElement | null}
   */ const getLoader = ()=>elementBySelector(".".concat(swalClasses.loader));
    /**
   * @returns {HTMLElement | null}
   */ const getActions = ()=>elementByClass(swalClasses.actions);
    /**
   * @returns {HTMLElement | null}
   */ const getFooter = ()=>elementByClass(swalClasses.footer);
    /**
   * @returns {HTMLElement | null}
   */ const getTimerProgressBar = ()=>elementByClass(swalClasses["timer-progress-bar"]);
    /**
   * @returns {HTMLElement | null}
   */ const getCloseButton = ()=>elementByClass(swalClasses.close);
    // https://github.com/jkup/focusable/blob/master/index.js
    const focusable = '\n  a[href],\n  area[href],\n  input:not([disabled]),\n  select:not([disabled]),\n  textarea:not([disabled]),\n  button:not([disabled]),\n  iframe,\n  object,\n  embed,\n  [tabindex="0"],\n  [contenteditable],\n  audio[controls],\n  video[controls],\n  summary\n';
    /**
   * @returns {HTMLElement[]}
   */ const getFocusableElements = ()=>{
        const popup = getPopup();
        if (!popup) return [];
        /** @type {NodeListOf<HTMLElement>} */ const focusableElementsWithTabindex = popup.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])');
        const focusableElementsWithTabindexSorted = Array.from(focusableElementsWithTabindex)// sort according to tabindex
        .sort((a, b)=>{
            const tabindexA = parseInt(a.getAttribute("tabindex") || "0");
            const tabindexB = parseInt(b.getAttribute("tabindex") || "0");
            if (tabindexA > tabindexB) return 1;
            else if (tabindexA < tabindexB) return -1;
            return 0;
        });
        /** @type {NodeListOf<HTMLElement>} */ const otherFocusableElements = popup.querySelectorAll(focusable);
        const otherFocusableElementsFiltered = Array.from(otherFocusableElements).filter((el)=>el.getAttribute("tabindex") !== "-1");
        return [
            ...new Set(focusableElementsWithTabindexSorted.concat(otherFocusableElementsFiltered))
        ].filter((el)=>isVisible$1(el));
    };
    /**
   * @returns {boolean}
   */ const isModal = ()=>{
        return hasClass(document.body, swalClasses.shown) && !hasClass(document.body, swalClasses["toast-shown"]) && !hasClass(document.body, swalClasses["no-backdrop"]);
    };
    /**
   * @returns {boolean}
   */ const isToast = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return hasClass(popup, swalClasses.toast);
    };
    /**
   * @returns {boolean}
   */ const isLoading = ()=>{
        const popup = getPopup();
        if (!popup) return false;
        return popup.hasAttribute("data-loading");
    };
    /**
   * Securely set innerHTML of an element
   * https://github.com/sweetalert2/sweetalert2/issues/1926
   *
   * @param {HTMLElement} elem
   * @param {string} html
   */ const setInnerHtml = (elem, html)=>{
        elem.textContent = "";
        if (html) {
            const parser = new DOMParser();
            const parsed = parser.parseFromString(html, "text/html");
            const head = parsed.querySelector("head");
            head && Array.from(head.childNodes).forEach((child)=>{
                elem.appendChild(child);
            });
            const body = parsed.querySelector("body");
            body && Array.from(body.childNodes).forEach((child)=>{
                if (child instanceof HTMLVideoElement || child instanceof HTMLAudioElement) elem.appendChild(child.cloneNode(true)); // https://github.com/sweetalert2/sweetalert2/issues/2507
                else elem.appendChild(child);
            });
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {boolean}
   */ const hasClass = (elem, className)=>{
        if (!className) return false;
        const classList = className.split(/\s+/);
        for(let i = 0; i < classList.length; i++){
            if (!elem.classList.contains(classList[i])) return false;
        }
        return true;
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   */ const removeCustomClasses = (elem, params)=>{
        Array.from(elem.classList).forEach((className)=>{
            if (!Object.values(swalClasses).includes(className) && !Object.values(iconTypes).includes(className) && !Object.values(params.showClass || {}).includes(className)) elem.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement} elem
   * @param {SweetAlertOptions} params
   * @param {string} className
   */ const applyCustomClass = (elem, params, className)=>{
        removeCustomClasses(elem, params);
        if (params.customClass && params.customClass[className]) {
            if (typeof params.customClass[className] !== "string" && !params.customClass[className].forEach) {
                warn("Invalid type of customClass.".concat(className, '! Expected string or iterable object, got "').concat(typeof params.customClass[className], '"'));
                return;
            }
            addClass(elem, params.customClass[className]);
        }
    };
    /**
   * @param {HTMLElement} popup
   * @param {import('./renderers/renderInput').InputClass | SweetAlertInput} inputClass
   * @returns {HTMLInputElement | null}
   */ const getInput$1 = (popup, inputClass)=>{
        if (!inputClass) return null;
        switch(inputClass){
            case "select":
            case "textarea":
            case "file":
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses[inputClass]));
            case "checkbox":
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.checkbox, " input"));
            case "radio":
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.radio, " input:checked")) || popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.radio, " input:first-child"));
            case "range":
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.range, " input"));
            default:
                return popup.querySelector(".".concat(swalClasses.popup, " > .").concat(swalClasses.input));
        }
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} input
   */ const focusInput = (input)=>{
        input.focus();
        // place cursor at end of text in text input
        if (input.type !== "file") {
            // http://stackoverflow.com/a/2345915
            const val = input.value;
            input.value = "";
            input.value = val;
        }
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   * @param {boolean} condition
   */ const toggleClass = (target, classList, condition)=>{
        if (!target || !classList) return;
        if (typeof classList === "string") classList = classList.split(/\s+/).filter(Boolean);
        classList.forEach((className)=>{
            if (Array.isArray(target)) target.forEach((elem)=>{
                condition ? elem.classList.add(className) : elem.classList.remove(className);
            });
            else condition ? target.classList.add(className) : target.classList.remove(className);
        });
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const addClass = (target, classList)=>{
        toggleClass(target, classList, true);
    };
    /**
   * @param {HTMLElement | HTMLElement[] | null} target
   * @param {string | string[] | readonly string[] | undefined} classList
   */ const removeClass = (target, classList)=>{
        toggleClass(target, classList, false);
    };
    /**
   * Get direct child of an element by class name
   *
   * @param {HTMLElement} elem
   * @param {string} className
   * @returns {HTMLElement | undefined}
   */ const getDirectChildByClass = (elem, className)=>{
        const children = Array.from(elem.children);
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            if (child instanceof HTMLElement && hasClass(child, className)) return child;
        }
    };
    /**
   * @param {HTMLElement} elem
   * @param {string} property
   * @param {*} value
   */ const applyNumericalStyle = (elem, property, value)=>{
        if (value === "".concat(parseInt(value))) value = parseInt(value);
        if (value || parseInt(value) === 0) elem.style[property] = typeof value === "number" ? "".concat(value, "px") : value;
        else elem.style.removeProperty(property);
    };
    /**
   * @param {HTMLElement | null} elem
   * @param {string} display
   */ const show = function(elem) {
        let display = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "flex";
        elem && (elem.style.display = display);
    };
    /**
   * @param {HTMLElement | null} elem
   */ const hide = (elem)=>{
        elem && (elem.style.display = "none");
    };
    /**
   * @param {HTMLElement} parent
   * @param {string} selector
   * @param {string} property
   * @param {string} value
   */ const setStyle = (parent, selector, property, value)=>{
        /** @type {HTMLElement} */ const el = parent.querySelector(selector);
        if (el) el.style[property] = value;
    };
    /**
   * @param {HTMLElement} elem
   * @param {any} condition
   * @param {string} display
   */ const toggle = function(elem, condition) {
        let display = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "flex";
        condition ? show(elem, display) : hide(elem);
    };
    /**
   * borrowed from jquery $(elem).is(':visible') implementation
   *
   * @param {HTMLElement | null} elem
   * @returns {boolean}
   */ const isVisible$1 = (elem)=>!!(elem && (elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length));
    /**
   * @returns {boolean}
   */ const allButtonsAreHidden = ()=>!isVisible$1(getConfirmButton()) && !isVisible$1(getDenyButton()) && !isVisible$1(getCancelButton());
    /**
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const isScrollable = (elem)=>!!(elem.scrollHeight > elem.clientHeight);
    /**
   * borrowed from https://stackoverflow.com/a/46352119
   *
   * @param {HTMLElement} elem
   * @returns {boolean}
   */ const hasCssAnimation = (elem)=>{
        const style = window.getComputedStyle(elem);
        const animDuration = parseFloat(style.getPropertyValue("animation-duration") || "0");
        const transDuration = parseFloat(style.getPropertyValue("transition-duration") || "0");
        return animDuration > 0 || transDuration > 0;
    };
    /**
   * @param {number} timer
   * @param {boolean} reset
   */ const animateTimerProgressBar = function(timer) {
        let reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        if (isVisible$1(timerProgressBar)) {
            if (reset) {
                timerProgressBar.style.transition = "none";
                timerProgressBar.style.width = "100%";
            }
            setTimeout(()=>{
                timerProgressBar.style.transition = "width ".concat(timer / 1000, "s linear");
                timerProgressBar.style.width = "0%";
            }, 10);
        }
    };
    const stopTimerProgressBar = ()=>{
        const timerProgressBar = getTimerProgressBar();
        if (!timerProgressBar) return;
        const timerProgressBarWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        timerProgressBar.style.removeProperty("transition");
        timerProgressBar.style.width = "100%";
        const timerProgressBarFullWidth = parseInt(window.getComputedStyle(timerProgressBar).width);
        const timerProgressBarPercent = timerProgressBarWidth / timerProgressBarFullWidth * 100;
        timerProgressBar.style.width = "".concat(timerProgressBarPercent, "%");
    };
    /**
   * Detect Node env
   *
   * @returns {boolean}
   */ const isNodeEnv = ()=>typeof window === "undefined" || typeof document === "undefined";
    const sweetHTML = '\n <div aria-labelledby="'.concat(swalClasses.title, '" aria-describedby="').concat(swalClasses["html-container"], '" class="').concat(swalClasses.popup, '" tabindex="-1">\n   <button type="button" class="').concat(swalClasses.close, '"></button>\n   <ul class="').concat(swalClasses["progress-steps"], '"></ul>\n   <div class="').concat(swalClasses.icon, '"></div>\n   <img class="').concat(swalClasses.image, '" />\n   <h2 class="').concat(swalClasses.title, '" id="').concat(swalClasses.title, '"></h2>\n   <div class="').concat(swalClasses["html-container"], '" id="').concat(swalClasses["html-container"], '"></div>\n   <input class="').concat(swalClasses.input, '" id="').concat(swalClasses.input, '" />\n   <input type="file" class="').concat(swalClasses.file, '" />\n   <div class="').concat(swalClasses.range, '">\n     <input type="range" />\n     <output></output>\n   </div>\n   <select class="').concat(swalClasses.select, '" id="').concat(swalClasses.select, '"></select>\n   <div class="').concat(swalClasses.radio, '"></div>\n   <label class="').concat(swalClasses.checkbox, '">\n     <input type="checkbox" id="').concat(swalClasses.checkbox, '" />\n     <span class="').concat(swalClasses.label, '"></span>\n   </label>\n   <textarea class="').concat(swalClasses.textarea, '" id="').concat(swalClasses.textarea, '"></textarea>\n   <div class="').concat(swalClasses["validation-message"], '" id="').concat(swalClasses["validation-message"], '"></div>\n   <div class="').concat(swalClasses.actions, '">\n     <div class="').concat(swalClasses.loader, '"></div>\n     <button type="button" class="').concat(swalClasses.confirm, '"></button>\n     <button type="button" class="').concat(swalClasses.deny, '"></button>\n     <button type="button" class="').concat(swalClasses.cancel, '"></button>\n   </div>\n   <div class="').concat(swalClasses.footer, '"></div>\n   <div class="').concat(swalClasses["timer-progress-bar-container"], '">\n     <div class="').concat(swalClasses["timer-progress-bar"], '"></div>\n   </div>\n </div>\n').replace(/(^|\n)\s*/g, "");
    /**
   * @returns {boolean}
   */ const resetOldContainer = ()=>{
        const oldContainer = getContainer();
        if (!oldContainer) return false;
        oldContainer.remove();
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses["no-backdrop"],
            swalClasses["toast-shown"],
            swalClasses["has-column"]
        ]);
        return true;
    };
    const resetValidationMessage$1 = ()=>{
        globalState.currentInstance.resetValidationMessage();
    };
    const addInputChangeListeners = ()=>{
        const popup = getPopup();
        const input = getDirectChildByClass(popup, swalClasses.input);
        const file = getDirectChildByClass(popup, swalClasses.file);
        /** @type {HTMLInputElement} */ const range = popup.querySelector(".".concat(swalClasses.range, " input"));
        /** @type {HTMLOutputElement} */ const rangeOutput = popup.querySelector(".".concat(swalClasses.range, " output"));
        const select = getDirectChildByClass(popup, swalClasses.select);
        /** @type {HTMLInputElement} */ const checkbox = popup.querySelector(".".concat(swalClasses.checkbox, " input"));
        const textarea = getDirectChildByClass(popup, swalClasses.textarea);
        input.oninput = resetValidationMessage$1;
        file.onchange = resetValidationMessage$1;
        select.onchange = resetValidationMessage$1;
        checkbox.onchange = resetValidationMessage$1;
        textarea.oninput = resetValidationMessage$1;
        range.oninput = ()=>{
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
        range.onchange = ()=>{
            resetValidationMessage$1();
            rangeOutput.value = range.value;
        };
    };
    /**
   * @param {string | HTMLElement} target
   * @returns {HTMLElement}
   */ const getTarget = (target)=>typeof target === "string" ? document.querySelector(target) : target;
    /**
   * @param {SweetAlertOptions} params
   */ const setupAccessibility = (params)=>{
        const popup = getPopup();
        popup.setAttribute("role", params.toast ? "alert" : "dialog");
        popup.setAttribute("aria-live", params.toast ? "polite" : "assertive");
        if (!params.toast) popup.setAttribute("aria-modal", "true");
    };
    /**
   * @param {HTMLElement} targetElement
   */ const setupRTL = (targetElement)=>{
        if (window.getComputedStyle(targetElement).direction === "rtl") addClass(getContainer(), swalClasses.rtl);
    };
    /**
   * Add modal + backdrop + no-war message for Russians to DOM
   *
   * @param {SweetAlertOptions} params
   */ const init = (params)=>{
        // Clean up the old popup container if it exists
        const oldContainerExisted = resetOldContainer();
        if (isNodeEnv()) {
            error("SweetAlert2 requires document to initialize");
            return;
        }
        const container = document.createElement("div");
        container.className = swalClasses.container;
        if (oldContainerExisted) addClass(container, swalClasses["no-transition"]);
        setInnerHtml(container, sweetHTML);
        const targetElement = getTarget(params.target);
        targetElement.appendChild(container);
        setupAccessibility(params);
        setupRTL(targetElement);
        addInputChangeListeners();
    };
    /**
   * @param {HTMLElement | object | string} param
   * @param {HTMLElement} target
   */ const parseHtmlToContainer = (param, target)=>{
        // DOM element
        if (param instanceof HTMLElement) target.appendChild(param);
        else if (typeof param === "object") handleObject(param, target);
        else if (param) setInnerHtml(target, param);
    };
    /**
   * @param {any} param
   * @param {HTMLElement} target
   */ const handleObject = (param, target)=>{
        // JQuery element(s)
        if (param.jquery) handleJqueryElem(target, param);
        else setInnerHtml(target, param.toString());
    };
    /**
   * @param {HTMLElement} target
   * @param {any} elem
   */ const handleJqueryElem = (target, elem)=>{
        target.textContent = "";
        if (0 in elem) for(let i = 0; (i in elem); i++)target.appendChild(elem[i].cloneNode(true));
        else target.appendChild(elem.cloneNode(true));
    };
    /**
   * @returns {'webkitAnimationEnd' | 'animationend' | false}
   */ const animationEndEvent = (()=>{
        // Prevent run in Node env
        if (isNodeEnv()) return false;
        const testEl = document.createElement("div");
        // Chrome, Safari and Opera
        if (typeof testEl.style.webkitAnimation !== "undefined") return "webkitAnimationEnd";
        // Standard syntax
        if (typeof testEl.style.animation !== "undefined") return "animationend";
        return false;
    })();
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderActions = (instance, params)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        // Actions (buttons) wrapper
        if (!params.showConfirmButton && !params.showDenyButton && !params.showCancelButton) hide(actions);
        else show(actions);
        // Custom class
        applyCustomClass(actions, params, "actions");
        // Render all the buttons
        renderButtons(actions, loader, params);
        // Loader
        setInnerHtml(loader, params.loaderHtml || "");
        applyCustomClass(loader, params, "loader");
    };
    /**
   * @param {HTMLElement} actions
   * @param {HTMLElement} loader
   * @param {SweetAlertOptions} params
   */ function renderButtons(actions, loader, params) {
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!confirmButton || !denyButton || !cancelButton) return;
        // Render buttons
        renderButton(confirmButton, "confirm", params);
        renderButton(denyButton, "deny", params);
        renderButton(cancelButton, "cancel", params);
        handleButtonsStyling(confirmButton, denyButton, cancelButton, params);
        if (params.reverseButtons) {
            if (params.toast) {
                actions.insertBefore(cancelButton, confirmButton);
                actions.insertBefore(denyButton, confirmButton);
            } else {
                actions.insertBefore(cancelButton, loader);
                actions.insertBefore(denyButton, loader);
                actions.insertBefore(confirmButton, loader);
            }
        }
    }
    /**
   * @param {HTMLElement} confirmButton
   * @param {HTMLElement} denyButton
   * @param {HTMLElement} cancelButton
   * @param {SweetAlertOptions} params
   */ function handleButtonsStyling(confirmButton, denyButton, cancelButton, params) {
        if (!params.buttonsStyling) {
            removeClass([
                confirmButton,
                denyButton,
                cancelButton
            ], swalClasses.styled);
            return;
        }
        addClass([
            confirmButton,
            denyButton,
            cancelButton
        ], swalClasses.styled);
        // Buttons background colors
        if (params.confirmButtonColor) {
            confirmButton.style.backgroundColor = params.confirmButtonColor;
            addClass(confirmButton, swalClasses["default-outline"]);
        }
        if (params.denyButtonColor) {
            denyButton.style.backgroundColor = params.denyButtonColor;
            addClass(denyButton, swalClasses["default-outline"]);
        }
        if (params.cancelButtonColor) {
            cancelButton.style.backgroundColor = params.cancelButtonColor;
            addClass(cancelButton, swalClasses["default-outline"]);
        }
    }
    /**
   * @param {HTMLElement} button
   * @param {'confirm' | 'deny' | 'cancel'} buttonType
   * @param {SweetAlertOptions} params
   */ function renderButton(button, buttonType, params) {
        const buttonName = /** @type {'Confirm' | 'Deny' | 'Cancel'} */ capitalizeFirstLetter(buttonType);
        toggle(button, params["show".concat(buttonName, "Button")], "inline-block");
        setInnerHtml(button, params["".concat(buttonType, "ButtonText")] || ""); // Set caption text
        button.setAttribute("aria-label", params["".concat(buttonType, "ButtonAriaLabel")] || ""); // ARIA label
        // Add buttons custom classes
        button.className = swalClasses[buttonType];
        applyCustomClass(button, params, "".concat(buttonType, "Button"));
    }
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderCloseButton = (instance, params)=>{
        const closeButton = getCloseButton();
        if (!closeButton) return;
        setInnerHtml(closeButton, params.closeButtonHtml || "");
        // Custom class
        applyCustomClass(closeButton, params, "closeButton");
        toggle(closeButton, params.showCloseButton);
        closeButton.setAttribute("aria-label", params.closeButtonAriaLabel || "");
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContainer = (instance, params)=>{
        const container = getContainer();
        if (!container) return;
        handleBackdropParam(container, params.backdrop);
        handlePositionParam(container, params.position);
        handleGrowParam(container, params.grow);
        // Custom class
        applyCustomClass(container, params, "container");
    };
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['backdrop']} backdrop
   */ function handleBackdropParam(container, backdrop) {
        if (typeof backdrop === "string") container.style.background = backdrop;
        else if (!backdrop) addClass([
            document.documentElement,
            document.body
        ], swalClasses["no-backdrop"]);
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['position']} position
   */ function handlePositionParam(container, position) {
        if (!position) return;
        if (position in swalClasses) addClass(container, swalClasses[position]);
        else {
            warn('The "position" parameter is not valid, defaulting to "center"');
            addClass(container, swalClasses.center);
        }
    }
    /**
   * @param {HTMLElement} container
   * @param {SweetAlertOptions['grow']} grow
   */ function handleGrowParam(container, grow) {
        if (!grow) return;
        addClass(container, swalClasses["grow-".concat(grow)]);
    }
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateProps = {
        innerParams: new WeakMap(),
        domCache: new WeakMap()
    };
    /// <reference path="../../../../sweetalert2.d.ts"/>
    /** @type {InputClass[]} */ const inputClasses = [
        "input",
        "file",
        "range",
        "select",
        "radio",
        "checkbox",
        "textarea"
    ];
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderInput = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        const innerParams = privateProps.innerParams.get(instance);
        const rerender = !innerParams || params.input !== innerParams.input;
        inputClasses.forEach((inputClass)=>{
            const inputContainer = getDirectChildByClass(popup, swalClasses[inputClass]);
            if (!inputContainer) return;
            // set attributes
            setAttributes(inputClass, params.inputAttributes);
            // set class
            inputContainer.className = swalClasses[inputClass];
            if (rerender) hide(inputContainer);
        });
        if (params.input) {
            if (rerender) showInput(params);
            // set custom class
            setCustomClass(params);
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ const showInput = (params)=>{
        if (!params.input) return;
        if (!renderInputType[params.input]) {
            error('Unexpected type of input! Expected "text", "email", "password", "number", "tel", "select", "radio", "checkbox", "textarea", "file" or "url", got "'.concat(params.input, '"'));
            return;
        }
        const inputContainer = getInputContainer(params.input);
        const input = renderInputType[params.input](inputContainer, params);
        show(inputContainer);
        // input autofocus
        if (params.inputAutoFocus) setTimeout(()=>{
            focusInput(input);
        });
    };
    /**
   * @param {HTMLInputElement} input
   */ const removeAttributes = (input)=>{
        for(let i = 0; i < input.attributes.length; i++){
            const attrName = input.attributes[i].name;
            if (![
                "id",
                "type",
                "value",
                "style"
            ].includes(attrName)) input.removeAttribute(attrName);
        }
    };
    /**
   * @param {InputClass} inputClass
   * @param {SweetAlertOptions['inputAttributes']} inputAttributes
   */ const setAttributes = (inputClass, inputAttributes)=>{
        const input = getInput$1(getPopup(), inputClass);
        if (!input) return;
        removeAttributes(input);
        for(const attr in inputAttributes)input.setAttribute(attr, inputAttributes[attr]);
    };
    /**
   * @param {SweetAlertOptions} params
   */ const setCustomClass = (params)=>{
        const inputContainer = getInputContainer(params.input);
        if (typeof params.customClass === "object") addClass(inputContainer, params.customClass.input);
    };
    /**
   * @param {HTMLInputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions} params
   */ const setInputPlaceholder = (input, params)=>{
        if (!input.placeholder || params.inputPlaceholder) input.placeholder = params.inputPlaceholder;
    };
    /**
   * @param {Input} input
   * @param {Input} prependTo
   * @param {SweetAlertOptions} params
   */ const setInputLabel = (input, prependTo, params)=>{
        if (params.inputLabel) {
            const label = document.createElement("label");
            const labelClass = swalClasses["input-label"];
            label.setAttribute("for", input.id);
            label.className = labelClass;
            if (typeof params.customClass === "object") addClass(label, params.customClass.inputLabel);
            label.innerText = params.inputLabel;
            prependTo.insertAdjacentElement("beforebegin", label);
        }
    };
    /**
   * @param {SweetAlertOptions['input']} inputType
   * @returns {HTMLElement}
   */ const getInputContainer = (inputType)=>{
        return getDirectChildByClass(getPopup(), swalClasses[inputType] || swalClasses.input);
    };
    /**
   * @param {HTMLInputElement | HTMLOutputElement | HTMLTextAreaElement} input
   * @param {SweetAlertOptions['inputValue']} inputValue
   */ const checkAndSetInputValue = (input, inputValue)=>{
        if ([
            "string",
            "number"
        ].includes(typeof inputValue)) input.value = "".concat(inputValue);
        else if (!isPromise(inputValue)) warn('Unexpected type of inputValue! Expected "string", "number" or "Promise", got "'.concat(typeof inputValue, '"'));
    };
    /** @type {Record<SweetAlertInput, (input: Input | HTMLElement, params: SweetAlertOptions) => Input>} */ const renderInputType = {};
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.text = renderInputType.email = renderInputType.password = renderInputType.number = renderInputType.tel = renderInputType.url = (input, params)=>{
        checkAndSetInputValue(input, params.inputValue);
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        input.type = params.input;
        return input;
    };
    /**
   * @param {HTMLInputElement} input
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.file = (input, params)=>{
        setInputLabel(input, input, params);
        setInputPlaceholder(input, params);
        return input;
    };
    /**
   * @param {HTMLInputElement} range
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.range = (range, params)=>{
        const rangeInput = range.querySelector("input");
        const rangeOutput = range.querySelector("output");
        checkAndSetInputValue(rangeInput, params.inputValue);
        rangeInput.type = params.input;
        checkAndSetInputValue(rangeOutput, params.inputValue);
        setInputLabel(rangeInput, range, params);
        return range;
    };
    /**
   * @param {HTMLSelectElement} select
   * @param {SweetAlertOptions} params
   * @returns {HTMLSelectElement}
   */ renderInputType.select = (select, params)=>{
        select.textContent = "";
        if (params.inputPlaceholder) {
            const placeholder = document.createElement("option");
            setInnerHtml(placeholder, params.inputPlaceholder);
            placeholder.value = "";
            placeholder.disabled = true;
            placeholder.selected = true;
            select.appendChild(placeholder);
        }
        setInputLabel(select, select, params);
        return select;
    };
    /**
   * @param {HTMLInputElement} radio
   * @returns {HTMLInputElement}
   */ renderInputType.radio = (radio)=>{
        radio.textContent = "";
        return radio;
    };
    /**
   * @param {HTMLLabelElement} checkboxContainer
   * @param {SweetAlertOptions} params
   * @returns {HTMLInputElement}
   */ renderInputType.checkbox = (checkboxContainer, params)=>{
        const checkbox = getInput$1(getPopup(), "checkbox");
        checkbox.value = "1";
        checkbox.checked = Boolean(params.inputValue);
        const label = checkboxContainer.querySelector("span");
        setInnerHtml(label, params.inputPlaceholder);
        return checkbox;
    };
    /**
   * @param {HTMLTextAreaElement} textarea
   * @param {SweetAlertOptions} params
   * @returns {HTMLTextAreaElement}
   */ renderInputType.textarea = (textarea, params)=>{
        checkAndSetInputValue(textarea, params.inputValue);
        setInputPlaceholder(textarea, params);
        setInputLabel(textarea, textarea, params);
        /**
     * @param {HTMLElement} el
     * @returns {number}
     */ const getMargin = (el)=>parseInt(window.getComputedStyle(el).marginLeft) + parseInt(window.getComputedStyle(el).marginRight);
        // https://github.com/sweetalert2/sweetalert2/issues/2291
        setTimeout(()=>{
            // https://github.com/sweetalert2/sweetalert2/issues/1699
            if ("MutationObserver" in window) {
                const initialPopupWidth = parseInt(window.getComputedStyle(getPopup()).width);
                const textareaResizeHandler = ()=>{
                    // check if texarea is still in document (i.e. popup wasn't closed in the meantime)
                    if (!document.body.contains(textarea)) return;
                    const textareaWidth = textarea.offsetWidth + getMargin(textarea);
                    if (textareaWidth > initialPopupWidth) getPopup().style.width = "".concat(textareaWidth, "px");
                    else applyNumericalStyle(getPopup(), "width", params.width);
                };
                new MutationObserver(textareaResizeHandler).observe(textarea, {
                    attributes: true,
                    attributeFilter: [
                        "style"
                    ]
                });
            }
        });
        return textarea;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderContent = (instance, params)=>{
        const htmlContainer = getHtmlContainer();
        if (!htmlContainer) return;
        applyCustomClass(htmlContainer, params, "htmlContainer");
        // Content as HTML
        if (params.html) {
            parseHtmlToContainer(params.html, htmlContainer);
            show(htmlContainer, "block");
        } else if (params.text) {
            htmlContainer.textContent = params.text;
            show(htmlContainer, "block");
        } else hide(htmlContainer);
        renderInput(instance, params);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderFooter = (instance, params)=>{
        const footer = getFooter();
        if (!footer) return;
        toggle(footer, params.footer, "block");
        if (params.footer) parseHtmlToContainer(params.footer, footer);
        // Custom class
        applyCustomClass(footer, params, "footer");
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderIcon = (instance, params)=>{
        const innerParams = privateProps.innerParams.get(instance);
        const icon = getIcon();
        if (!icon) return;
        // if the given icon already rendered, apply the styling without re-rendering the icon
        if (innerParams && params.icon === innerParams.icon) {
            // Custom or default content
            setContent(icon, params);
            applyStyles(icon, params);
            return;
        }
        if (!params.icon && !params.iconHtml) {
            hide(icon);
            return;
        }
        if (params.icon && Object.keys(iconTypes).indexOf(params.icon) === -1) {
            error('Unknown icon! Expected "success", "error", "warning", "info" or "question", got "'.concat(params.icon, '"'));
            hide(icon);
            return;
        }
        show(icon);
        // Custom or default content
        setContent(icon, params);
        applyStyles(icon, params);
        // Animate icon
        addClass(icon, params.showClass && params.showClass.icon);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const applyStyles = (icon, params)=>{
        for (const [iconType, iconClassName] of Object.entries(iconTypes))if (params.icon !== iconType) removeClass(icon, iconClassName);
        addClass(icon, params.icon && iconTypes[params.icon]);
        // Icon color
        setColor(icon, params);
        // Success icon background color
        adjustSuccessIconBackgroundColor();
        // Custom class
        applyCustomClass(icon, params, "icon");
    };
    // Adjust success icon background color to match the popup background color
    const adjustSuccessIconBackgroundColor = ()=>{
        const popup = getPopup();
        if (!popup) return;
        const popupBackgroundColor = window.getComputedStyle(popup).getPropertyValue("background-color");
        /** @type {NodeListOf<HTMLElement>} */ const successIconParts = popup.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
        for(let i = 0; i < successIconParts.length; i++)successIconParts[i].style.backgroundColor = popupBackgroundColor;
    };
    const successIconHtml = '\n  <div class="swal2-success-circular-line-left"></div>\n  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>\n  <div class="swal2-success-ring"></div> <div class="swal2-success-fix"></div>\n  <div class="swal2-success-circular-line-right"></div>\n';
    const errorIconHtml = '\n  <span class="swal2-x-mark">\n    <span class="swal2-x-mark-line-left"></span>\n    <span class="swal2-x-mark-line-right"></span>\n  </span>\n';
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setContent = (icon, params)=>{
        if (!params.icon && !params.iconHtml) return;
        let oldContent = icon.innerHTML;
        let newContent = "";
        if (params.iconHtml) newContent = iconContent(params.iconHtml);
        else if (params.icon === "success") {
            newContent = successIconHtml;
            oldContent = oldContent.replace(/ style=".*?"/g, ""); // undo adjustSuccessIconBackgroundColor()
        } else if (params.icon === "error") newContent = errorIconHtml;
        else if (params.icon) {
            const defaultIconHtml = {
                question: "?",
                warning: "!",
                info: "i"
            };
            newContent = iconContent(defaultIconHtml[params.icon]);
        }
        if (oldContent.trim() !== newContent.trim()) setInnerHtml(icon, newContent);
    };
    /**
   * @param {HTMLElement} icon
   * @param {SweetAlertOptions} params
   */ const setColor = (icon, params)=>{
        if (!params.iconColor) return;
        icon.style.color = params.iconColor;
        icon.style.borderColor = params.iconColor;
        for (const sel of [
            ".swal2-success-line-tip",
            ".swal2-success-line-long",
            ".swal2-x-mark-line-left",
            ".swal2-x-mark-line-right"
        ])setStyle(icon, sel, "backgroundColor", params.iconColor);
        setStyle(icon, ".swal2-success-ring", "borderColor", params.iconColor);
    };
    /**
   * @param {string} content
   * @returns {string}
   */ const iconContent = (content)=>'<div class="'.concat(swalClasses["icon-content"], '">').concat(content, "</div>");
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderImage = (instance, params)=>{
        const image = getImage();
        if (!image) return;
        if (!params.imageUrl) {
            hide(image);
            return;
        }
        show(image, "");
        // Src, alt
        image.setAttribute("src", params.imageUrl);
        image.setAttribute("alt", params.imageAlt || "");
        // Width, height
        applyNumericalStyle(image, "width", params.imageWidth);
        applyNumericalStyle(image, "height", params.imageHeight);
        // Class
        image.className = swalClasses.image;
        applyCustomClass(image, params, "image");
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderPopup = (instance, params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (!container || !popup) return;
        // Width
        // https://github.com/sweetalert2/sweetalert2/issues/2170
        if (params.toast) {
            applyNumericalStyle(container, "width", params.width);
            popup.style.width = "100%";
            const loader = getLoader();
            loader && popup.insertBefore(loader, getIcon());
        } else applyNumericalStyle(popup, "width", params.width);
        // Padding
        applyNumericalStyle(popup, "padding", params.padding);
        // Color
        if (params.color) popup.style.color = params.color;
        // Background
        if (params.background) popup.style.background = params.background;
        hide(getValidationMessage());
        // Classes
        addClasses$1(popup, params);
    };
    /**
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses$1 = (popup, params)=>{
        const showClass = params.showClass || {};
        // Default Class + showClass when updating Swal.update({})
        popup.className = "".concat(swalClasses.popup, " ").concat(isVisible$1(popup) ? showClass.popup : "");
        if (params.toast) {
            addClass([
                document.documentElement,
                document.body
            ], swalClasses["toast-shown"]);
            addClass(popup, swalClasses.toast);
        } else addClass(popup, swalClasses.modal);
        // Custom class
        applyCustomClass(popup, params, "popup");
        if (typeof params.customClass === "string") addClass(popup, params.customClass);
        // Icon class (#1842)
        if (params.icon) addClass(popup, swalClasses["icon-".concat(params.icon)]);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderProgressSteps = (instance, params)=>{
        const progressStepsContainer = getProgressSteps();
        if (!progressStepsContainer) return;
        const { progressSteps: progressSteps, currentProgressStep: currentProgressStep } = params;
        if (!progressSteps || progressSteps.length === 0 || currentProgressStep === undefined) {
            hide(progressStepsContainer);
            return;
        }
        show(progressStepsContainer);
        progressStepsContainer.textContent = "";
        if (currentProgressStep >= progressSteps.length) warn("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)");
        progressSteps.forEach((step, index)=>{
            const stepEl = createStepElement(step);
            progressStepsContainer.appendChild(stepEl);
            if (index === currentProgressStep) addClass(stepEl, swalClasses["active-progress-step"]);
            if (index !== progressSteps.length - 1) {
                const lineEl = createLineElement(params);
                progressStepsContainer.appendChild(lineEl);
            }
        });
    };
    /**
   * @param {string} step
   * @returns {HTMLLIElement}
   */ const createStepElement = (step)=>{
        const stepEl = document.createElement("li");
        addClass(stepEl, swalClasses["progress-step"]);
        setInnerHtml(stepEl, step);
        return stepEl;
    };
    /**
   * @param {SweetAlertOptions} params
   * @returns {HTMLLIElement}
   */ const createLineElement = (params)=>{
        const lineEl = document.createElement("li");
        addClass(lineEl, swalClasses["progress-step-line"]);
        if (params.progressStepsDistance) applyNumericalStyle(lineEl, "width", params.progressStepsDistance);
        return lineEl;
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const renderTitle = (instance, params)=>{
        const title = getTitle();
        if (!title) return;
        toggle(title, params.title || params.titleText, "block");
        if (params.title) parseHtmlToContainer(params.title, title);
        if (params.titleText) title.innerText = params.titleText;
        // Custom class
        applyCustomClass(title, params, "title");
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const render = (instance, params)=>{
        renderPopup(instance, params);
        renderContainer(instance, params);
        renderProgressSteps(instance, params);
        renderIcon(instance, params);
        renderImage(instance, params);
        renderTitle(instance, params);
        renderCloseButton(instance, params);
        renderContent(instance, params);
        renderActions(instance, params);
        renderFooter(instance, params);
        const popup = getPopup();
        if (typeof params.didRender === "function" && popup) params.didRender(popup);
    };
    /*
   * Global function to determine if SweetAlert2 popup is shown
   */ const isVisible = ()=>{
        return isVisible$1(getPopup());
    };
    /*
   * Global function to click 'Confirm' button
   */ const clickConfirm = ()=>{
        var _dom$getConfirmButton;
        return (_dom$getConfirmButton = getConfirmButton()) === null || _dom$getConfirmButton === void 0 ? void 0 : _dom$getConfirmButton.click();
    };
    /*
   * Global function to click 'Deny' button
   */ const clickDeny = ()=>{
        var _dom$getDenyButton;
        return (_dom$getDenyButton = getDenyButton()) === null || _dom$getDenyButton === void 0 ? void 0 : _dom$getDenyButton.click();
    };
    /*
   * Global function to click 'Cancel' button
   */ const clickCancel = ()=>{
        var _dom$getCancelButton;
        return (_dom$getCancelButton = getCancelButton()) === null || _dom$getCancelButton === void 0 ? void 0 : _dom$getCancelButton.click();
    };
    /** @typedef {'cancel' | 'backdrop' | 'close' | 'esc' | 'timer'} DismissReason */ /** @type {Record<DismissReason, DismissReason>} */ const DismissReason = Object.freeze({
        cancel: "cancel",
        backdrop: "backdrop",
        close: "close",
        esc: "esc",
        timer: "timer"
    });
    /**
   * @param {GlobalState} globalState
   */ const removeKeydownHandler = (globalState)=>{
        if (globalState.keydownTarget && globalState.keydownHandlerAdded) {
            globalState.keydownTarget.removeEventListener("keydown", globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = false;
        }
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {*} dismissWith
   */ const addKeydownHandler = (globalState, innerParams, dismissWith)=>{
        removeKeydownHandler(globalState);
        if (!innerParams.toast) {
            globalState.keydownHandler = (e)=>keydownHandler(innerParams, e, dismissWith);
            globalState.keydownTarget = innerParams.keydownListenerCapture ? window : getPopup();
            globalState.keydownListenerCapture = innerParams.keydownListenerCapture;
            globalState.keydownTarget.addEventListener("keydown", globalState.keydownHandler, {
                capture: globalState.keydownListenerCapture
            });
            globalState.keydownHandlerAdded = true;
        }
    };
    /**
   * @param {number} index
   * @param {number} increment
   */ const setFocus = (index, increment)=>{
        var _dom$getPopup;
        const focusableElements = getFocusableElements();
        // search for visible elements and select the next possible match
        if (focusableElements.length) {
            index = index + increment;
            // rollover to first item
            if (index === focusableElements.length) index = 0;
            else if (index === -1) index = focusableElements.length - 1;
            focusableElements[index].focus();
            return;
        }
        // no visible focusable elements, focus the popup
        (_dom$getPopup = getPopup()) === null || _dom$getPopup === void 0 || _dom$getPopup.focus();
    };
    const arrowKeysNextButton = [
        "ArrowRight",
        "ArrowDown"
    ];
    const arrowKeysPreviousButton = [
        "ArrowLeft",
        "ArrowUp"
    ];
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {KeyboardEvent} event
   * @param {Function} dismissWith
   */ const keydownHandler = (innerParams, event, dismissWith)=>{
        if (!innerParams) return; // This instance has already been destroyed
        // Ignore keydown during IME composition
        // https://developer.mozilla.org/en-US/docs/Web/API/Document/keydown_event#ignoring_keydown_during_ime_composition
        // https://github.com/sweetalert2/sweetalert2/issues/720
        // https://github.com/sweetalert2/sweetalert2/issues/2406
        if (event.isComposing || event.keyCode === 229) return;
        if (innerParams.stopKeydownPropagation) event.stopPropagation();
        // ENTER
        if (event.key === "Enter") handleEnter(event, innerParams);
        else if (event.key === "Tab") handleTab(event);
        else if ([
            ...arrowKeysNextButton,
            ...arrowKeysPreviousButton
        ].includes(event.key)) handleArrows(event.key);
        else if (event.key === "Escape") handleEsc(event, innerParams, dismissWith);
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   */ const handleEnter = (event, innerParams)=>{
        // https://github.com/sweetalert2/sweetalert2/issues/2386
        if (!callIfFunction(innerParams.allowEnterKey)) return;
        const input = getInput$1(getPopup(), innerParams.input);
        if (event.target && input && event.target instanceof HTMLElement && event.target.outerHTML === input.outerHTML) {
            if ([
                "textarea",
                "file"
            ].includes(innerParams.input)) return; // do not submit
            clickConfirm();
            event.preventDefault();
        }
    };
    /**
   * @param {KeyboardEvent} event
   */ const handleTab = (event)=>{
        const targetElement = event.target;
        const focusableElements = getFocusableElements();
        let btnIndex = -1;
        for(let i = 0; i < focusableElements.length; i++)if (targetElement === focusableElements[i]) {
            btnIndex = i;
            break;
        }
        // Cycle to the next button
        if (!event.shiftKey) setFocus(btnIndex, 1);
        else setFocus(btnIndex, -1);
        event.stopPropagation();
        event.preventDefault();
    };
    /**
   * @param {string} key
   */ const handleArrows = (key)=>{
        const actions = getActions();
        const confirmButton = getConfirmButton();
        const denyButton = getDenyButton();
        const cancelButton = getCancelButton();
        if (!actions || !confirmButton || !denyButton || !cancelButton) return;
        /** @type HTMLElement[] */ const buttons = [
            confirmButton,
            denyButton,
            cancelButton
        ];
        if (document.activeElement instanceof HTMLElement && !buttons.includes(document.activeElement)) return;
        const sibling = arrowKeysNextButton.includes(key) ? "nextElementSibling" : "previousElementSibling";
        let buttonToFocus = document.activeElement;
        if (!buttonToFocus) return;
        for(let i = 0; i < actions.children.length; i++){
            buttonToFocus = buttonToFocus[sibling];
            if (!buttonToFocus) return;
            if (buttonToFocus instanceof HTMLButtonElement && isVisible$1(buttonToFocus)) break;
        }
        if (buttonToFocus instanceof HTMLButtonElement) buttonToFocus.focus();
    };
    /**
   * @param {KeyboardEvent} event
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ const handleEsc = (event, innerParams, dismissWith)=>{
        if (callIfFunction(innerParams.allowEscapeKey)) {
            event.preventDefault();
            dismissWith(DismissReason.esc);
        }
    };
    /**
   * This module contains `WeakMap`s for each effectively-"private  property" that a `Swal` has.
   * For example, to set the private property "foo" of `this` to "bar", you can `privateProps.foo.set(this, 'bar')`
   * This is the approach that Babel will probably take to implement private methods/fields
   *   https://github.com/tc39/proposal-private-methods
   *   https://github.com/babel/babel/pull/7555
   * Once we have the changes from that PR in Babel, and our core class fits reasonable in *one module*
   *   then we can use that language feature.
   */ var privateMethods = {
        swalPromiseResolve: new WeakMap(),
        swalPromiseReject: new WeakMap()
    };
    // From https://developer.paciellogroup.com/blog/2018/06/the-current-state-of-modal-dialog-accessibility/
    // Adding aria-hidden="true" to elements outside of the active modal dialog ensures that
    // elements not within the active modal dialog will not be surfaced if a user opens a screen
    // reader’s list of elements (headings, form controls, landmarks, etc.) in the document.
    const setAriaHidden = ()=>{
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el === getContainer() || el.contains(getContainer())) return;
            if (el.hasAttribute("aria-hidden")) el.setAttribute("data-previous-aria-hidden", el.getAttribute("aria-hidden") || "");
            el.setAttribute("aria-hidden", "true");
        });
    };
    const unsetAriaHidden = ()=>{
        const bodyChildren = Array.from(document.body.children);
        bodyChildren.forEach((el)=>{
            if (el.hasAttribute("data-previous-aria-hidden")) {
                el.setAttribute("aria-hidden", el.getAttribute("data-previous-aria-hidden") || "");
                el.removeAttribute("data-previous-aria-hidden");
            } else el.removeAttribute("aria-hidden");
        });
    };
    // @ts-ignore
    const isSafariOrIOS = typeof window !== "undefined" && !!window.GestureEvent; // true for Safari desktop + all iOS browsers https://stackoverflow.com/a/70585394
    /**
   * Fix iOS scrolling
   * http://stackoverflow.com/q/39626302
   */ const iOSfix = ()=>{
        if (isSafariOrIOS && !hasClass(document.body, swalClasses.iosfix)) {
            const offset = document.body.scrollTop;
            document.body.style.top = "".concat(offset * -1, "px");
            addClass(document.body, swalClasses.iosfix);
            lockBodyScroll();
        }
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1246
   */ const lockBodyScroll = ()=>{
        const container = getContainer();
        if (!container) return;
        /** @type {boolean} */ let preventTouchMove;
        /**
     * @param {TouchEvent} event
     */ container.ontouchstart = (event)=>{
            preventTouchMove = shouldPreventTouchMove(event);
        };
        /**
     * @param {TouchEvent} event
     */ container.ontouchmove = (event)=>{
            if (preventTouchMove) {
                event.preventDefault();
                event.stopPropagation();
            }
        };
    };
    /**
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const shouldPreventTouchMove = (event)=>{
        const target = event.target;
        const container = getContainer();
        const htmlContainer = getHtmlContainer();
        if (!container || !htmlContainer) return false;
        if (isStylus(event) || isZoom(event)) return false;
        if (target === container) return true;
        if (!isScrollable(container) && target instanceof HTMLElement && target.tagName !== "INPUT" && // #1603
        target.tagName !== "TEXTAREA" && // #2266
        !(isScrollable(htmlContainer) && // #1944
        htmlContainer.contains(target))) return true;
        return false;
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1786
   *
   * @param {*} event
   * @returns {boolean}
   */ const isStylus = (event)=>{
        return event.touches && event.touches.length && event.touches[0].touchType === "stylus";
    };
    /**
   * https://github.com/sweetalert2/sweetalert2/issues/1891
   *
   * @param {TouchEvent} event
   * @returns {boolean}
   */ const isZoom = (event)=>{
        return event.touches && event.touches.length > 1;
    };
    const undoIOSfix = ()=>{
        if (hasClass(document.body, swalClasses.iosfix)) {
            const offset = parseInt(document.body.style.top, 10);
            removeClass(document.body, swalClasses.iosfix);
            document.body.style.top = "";
            document.body.scrollTop = offset * -1;
        }
    };
    /**
   * Measure scrollbar width for padding body during modal show/hide
   * https://github.com/twbs/bootstrap/blob/master/js/src/modal.js
   *
   * @returns {number}
   */ const measureScrollbar = ()=>{
        const scrollDiv = document.createElement("div");
        scrollDiv.className = swalClasses["scrollbar-measure"];
        document.body.appendChild(scrollDiv);
        const scrollbarWidth = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);
        return scrollbarWidth;
    };
    /**
   * Remember state in cases where opening and handling a modal will fiddle with it.
   * @type {number | null}
   */ let previousBodyPadding = null;
    /**
   * @param {string} initialBodyOverflow
   */ const replaceScrollbarWithPadding = (initialBodyOverflow)=>{
        // for queues, do not do this more than once
        if (previousBodyPadding !== null) return;
        // if the body has overflow
        if (document.body.scrollHeight > window.innerHeight || initialBodyOverflow === "scroll" // https://github.com/sweetalert2/sweetalert2/issues/2663
        ) {
            // add padding so the content doesn't shift after removal of scrollbar
            previousBodyPadding = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right"));
            document.body.style.paddingRight = "".concat(previousBodyPadding + measureScrollbar(), "px");
        }
    };
    const undoReplaceScrollbarWithPadding = ()=>{
        if (previousBodyPadding !== null) {
            document.body.style.paddingRight = "".concat(previousBodyPadding, "px");
            previousBodyPadding = null;
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ function removePopupAndResetState(instance, container, returnFocus, didClose) {
        if (isToast()) triggerDidCloseAndDispose(instance, didClose);
        else {
            restoreActiveElement(returnFocus).then(()=>triggerDidCloseAndDispose(instance, didClose));
            removeKeydownHandler(globalState);
        }
        // workaround for https://github.com/sweetalert2/sweetalert2/issues/2088
        // for some reason removing the container in Safari will scroll the document to bottom
        if (isSafariOrIOS) {
            container.setAttribute("style", "display:none !important");
            container.removeAttribute("class");
            container.innerHTML = "";
        } else container.remove();
        if (isModal()) {
            undoReplaceScrollbarWithPadding();
            undoIOSfix();
            unsetAriaHidden();
        }
        removeBodyClasses();
    }
    /**
   * Remove SweetAlert2 classes from body
   */ function removeBodyClasses() {
        removeClass([
            document.documentElement,
            document.body
        ], [
            swalClasses.shown,
            swalClasses["height-auto"],
            swalClasses["no-backdrop"],
            swalClasses["toast-shown"]
        ]);
    }
    /**
   * Instance method to close sweetAlert
   *
   * @param {any} resolveValue
   */ function close(resolveValue) {
        resolveValue = prepareResolveValue(resolveValue);
        const swalPromiseResolve = privateMethods.swalPromiseResolve.get(this);
        const didClose = triggerClosePopup(this);
        if (this.isAwaitingPromise) // A swal awaiting for a promise (after a click on Confirm or Deny) cannot be dismissed anymore #2335
        {
            if (!resolveValue.isDismissed) {
                handleAwaitingPromise(this);
                swalPromiseResolve(resolveValue);
            }
        } else if (didClose) // Resolve Swal promise
        swalPromiseResolve(resolveValue);
    }
    const triggerClosePopup = (instance)=>{
        const popup = getPopup();
        if (!popup) return false;
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams || hasClass(popup, innerParams.hideClass.popup)) return false;
        removeClass(popup, innerParams.showClass.popup);
        addClass(popup, innerParams.hideClass.popup);
        const backdrop = getContainer();
        removeClass(backdrop, innerParams.showClass.backdrop);
        addClass(backdrop, innerParams.hideClass.backdrop);
        handlePopupAnimation(instance, popup, innerParams);
        return true;
    };
    /**
   * @param {any} error
   */ function rejectPromise(error) {
        const rejectPromise = privateMethods.swalPromiseReject.get(this);
        handleAwaitingPromise(this);
        if (rejectPromise) // Reject Swal promise
        rejectPromise(error);
    }
    /**
   * @param {SweetAlert} instance
   */ const handleAwaitingPromise = (instance)=>{
        if (instance.isAwaitingPromise) {
            delete instance.isAwaitingPromise;
            // The instance might have been previously partly destroyed, we must resume the destroy process in this case #2335
            if (!privateProps.innerParams.get(instance)) instance._destroy();
        }
    };
    /**
   * @param {any} resolveValue
   * @returns {SweetAlertResult}
   */ const prepareResolveValue = (resolveValue)=>{
        // When user calls Swal.close()
        if (typeof resolveValue === "undefined") return {
            isConfirmed: false,
            isDenied: false,
            isDismissed: true
        };
        return Object.assign({
            isConfirmed: false,
            isDenied: false,
            isDismissed: false
        }, resolveValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} innerParams
   */ const handlePopupAnimation = (instance, popup, innerParams)=>{
        const container = getContainer();
        // If animation is supported, animate
        const animationIsSupported = animationEndEvent && hasCssAnimation(popup);
        if (typeof innerParams.willClose === "function") innerParams.willClose(popup);
        if (animationIsSupported) animatePopup(instance, popup, container, innerParams.returnFocus, innerParams.didClose);
        else // Otherwise, remove immediately
        removePopupAndResetState(instance, container, innerParams.returnFocus, innerParams.didClose);
    };
    /**
   * @param {SweetAlert} instance
   * @param {HTMLElement} popup
   * @param {HTMLElement} container
   * @param {boolean} returnFocus
   * @param {Function} didClose
   */ const animatePopup = (instance, popup, container, returnFocus, didClose)=>{
        if (!animationEndEvent) return;
        globalState.swalCloseEventFinishedCallback = removePopupAndResetState.bind(null, instance, container, returnFocus, didClose);
        popup.addEventListener(animationEndEvent, function(e) {
            if (e.target === popup) {
                globalState.swalCloseEventFinishedCallback();
                delete globalState.swalCloseEventFinishedCallback;
            }
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} didClose
   */ const triggerDidCloseAndDispose = (instance, didClose)=>{
        setTimeout(()=>{
            if (typeof didClose === "function") didClose.bind(instance.params)();
            // instance might have been destroyed already
            if (instance._destroy) instance._destroy();
        });
    };
    /**
   * Shows loader (spinner), this is useful with AJAX requests.
   * By default the loader be shown instead of the "Confirm" button.
   *
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const showLoading = (buttonToReplace)=>{
        let popup = getPopup();
        if (!popup) new Swal(); // eslint-disable-line no-new
        popup = getPopup();
        if (!popup) return;
        const loader = getLoader();
        if (isToast()) hide(getIcon());
        else replaceButton(popup, buttonToReplace);
        show(loader);
        popup.setAttribute("data-loading", "true");
        popup.setAttribute("aria-busy", "true");
        popup.focus();
    };
    /**
   * @param {HTMLElement} popup
   * @param {HTMLButtonElement | null} [buttonToReplace]
   */ const replaceButton = (popup, buttonToReplace)=>{
        const actions = getActions();
        const loader = getLoader();
        if (!actions || !loader) return;
        if (!buttonToReplace && isVisible$1(getConfirmButton())) buttonToReplace = getConfirmButton();
        show(actions);
        if (buttonToReplace) {
            hide(buttonToReplace);
            loader.setAttribute("data-button-to-replace", buttonToReplace.className);
            actions.insertBefore(loader, buttonToReplace);
        }
        addClass([
            popup,
            actions
        ], swalClasses.loading);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptionsAndValue = (instance, params)=>{
        if (params.input === "select" || params.input === "radio") handleInputOptions(instance, params);
        else if ([
            "text",
            "email",
            "number",
            "tel",
            "textarea"
        ].some((i)=>i === params.input) && (hasToPromiseFn(params.inputValue) || isPromise(params.inputValue))) {
            showLoading(getConfirmButton());
            handleInputValue(instance, params);
        }
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} innerParams
   * @returns {SweetAlertInputValue}
   */ const getInputValue = (instance, innerParams)=>{
        const input = instance.getInput();
        if (!input) return null;
        switch(innerParams.input){
            case "checkbox":
                return getCheckboxValue(input);
            case "radio":
                return getRadioValue(input);
            case "file":
                return getFileValue(input);
            default:
                return innerParams.inputAutoTrim ? input.value.trim() : input.value;
        }
    };
    /**
   * @param {HTMLInputElement} input
   * @returns {number}
   */ const getCheckboxValue = (input)=>input.checked ? 1 : 0;
    /**
   * @param {HTMLInputElement} input
   * @returns {string | null}
   */ const getRadioValue = (input)=>input.checked ? input.value : null;
    /**
   * @param {HTMLInputElement} input
   * @returns {FileList | File | null}
   */ const getFileValue = (input)=>input.files && input.files.length ? input.getAttribute("multiple") !== null ? input.files : input.files[0] : null;
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputOptions = (instance, params)=>{
        const popup = getPopup();
        if (!popup) return;
        /**
     * @param {Record<string, any>} inputOptions
     */ const processInputOptions = (inputOptions)=>{
            if (params.input === "select") populateSelectOptions(popup, formatInputOptions(inputOptions), params);
            else if (params.input === "radio") populateRadioOptions(popup, formatInputOptions(inputOptions), params);
        };
        if (hasToPromiseFn(params.inputOptions) || isPromise(params.inputOptions)) {
            showLoading(getConfirmButton());
            asPromise(params.inputOptions).then((inputOptions)=>{
                instance.hideLoading();
                processInputOptions(inputOptions);
            });
        } else if (typeof params.inputOptions === "object") processInputOptions(params.inputOptions);
        else error("Unexpected type of inputOptions! Expected object, Map or Promise, got ".concat(typeof params.inputOptions));
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertOptions} params
   */ const handleInputValue = (instance, params)=>{
        const input = instance.getInput();
        if (!input) return;
        hide(input);
        asPromise(params.inputValue).then((inputValue)=>{
            input.value = params.input === "number" ? "".concat(parseFloat(inputValue) || 0) : "".concat(inputValue);
            show(input);
            input.focus();
            instance.hideLoading();
        }).catch((err)=>{
            error("Error in inputValue promise: ".concat(err));
            input.value = "";
            show(input);
            input.focus();
            instance.hideLoading();
        });
    };
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateSelectOptions(popup, inputOptions, params) {
        const select = getDirectChildByClass(popup, swalClasses.select);
        if (!select) return;
        /**
     * @param {HTMLElement} parent
     * @param {string} optionLabel
     * @param {string} optionValue
     */ const renderOption = (parent, optionLabel, optionValue)=>{
            const option = document.createElement("option");
            option.value = optionValue;
            setInnerHtml(option, optionLabel);
            option.selected = isSelected(optionValue, params.inputValue);
            parent.appendChild(option);
        };
        inputOptions.forEach((inputOption)=>{
            const optionValue = inputOption[0];
            const optionLabel = inputOption[1];
            // <optgroup> spec:
            // https://www.w3.org/TR/html401/interact/forms.html#h-17.6
            // "...all OPTGROUP elements must be specified directly within a SELECT element (i.e., groups may not be nested)..."
            // check whether this is a <optgroup>
            if (Array.isArray(optionLabel)) {
                // if it is an array, then it is an <optgroup>
                const optgroup = document.createElement("optgroup");
                optgroup.label = optionValue;
                optgroup.disabled = false; // not configurable for now
                select.appendChild(optgroup);
                optionLabel.forEach((o)=>renderOption(optgroup, o[1], o[0]));
            } else // case of <option>
            renderOption(select, optionLabel, optionValue);
        });
        select.focus();
    }
    /**
   * @param {HTMLElement} popup
   * @param {InputOptionFlattened[]} inputOptions
   * @param {SweetAlertOptions} params
   */ function populateRadioOptions(popup, inputOptions, params) {
        const radio = getDirectChildByClass(popup, swalClasses.radio);
        if (!radio) return;
        inputOptions.forEach((inputOption)=>{
            const radioValue = inputOption[0];
            const radioLabel = inputOption[1];
            const radioInput = document.createElement("input");
            const radioLabelElement = document.createElement("label");
            radioInput.type = "radio";
            radioInput.name = swalClasses.radio;
            radioInput.value = radioValue;
            if (isSelected(radioValue, params.inputValue)) radioInput.checked = true;
            const label = document.createElement("span");
            setInnerHtml(label, radioLabel);
            label.className = swalClasses.label;
            radioLabelElement.appendChild(radioInput);
            radioLabelElement.appendChild(label);
            radio.appendChild(radioLabelElement);
        });
        const radios = radio.querySelectorAll("input");
        if (radios.length) radios[0].focus();
    }
    /**
   * Converts `inputOptions` into an array of `[value, label]`s
   *
   * @param {Record<string, any>} inputOptions
   * @typedef {string[]} InputOptionFlattened
   * @returns {InputOptionFlattened[]}
   */ const formatInputOptions = (inputOptions)=>{
        /** @type {InputOptionFlattened[]} */ const result = [];
        if (inputOptions instanceof Map) inputOptions.forEach((value, key)=>{
            let valueFormatted = value;
            if (typeof valueFormatted === "object") // case of <optgroup>
            valueFormatted = formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        else Object.keys(inputOptions).forEach((key)=>{
            let valueFormatted = inputOptions[key];
            if (typeof valueFormatted === "object") // case of <optgroup>
            valueFormatted = formatInputOptions(valueFormatted);
            result.push([
                key,
                valueFormatted
            ]);
        });
        return result;
    };
    /**
   * @param {string} optionValue
   * @param {SweetAlertInputValue} inputValue
   * @returns {boolean}
   */ const isSelected = (optionValue, inputValue)=>{
        return !!inputValue && inputValue.toString() === optionValue.toString();
    };
    /**
   * @param {SweetAlert} instance
   */ const handleConfirmButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.input) handleConfirmOrDenyWithInput(instance, "confirm");
        else confirm(instance, true);
    };
    /**
   * @param {SweetAlert} instance
   */ const handleDenyButtonClick = (instance)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableButtons();
        if (innerParams.returnInputValueOnDeny) handleConfirmOrDenyWithInput(instance, "deny");
        else deny(instance, false);
    };
    /**
   * @param {SweetAlert} instance
   * @param {Function} dismissWith
   */ const handleCancelButtonClick = (instance, dismissWith)=>{
        instance.disableButtons();
        dismissWith(DismissReason.cancel);
    };
    /**
   * @param {SweetAlert} instance
   * @param {'confirm' | 'deny'} type
   */ const handleConfirmOrDenyWithInput = (instance, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        if (!innerParams.input) {
            error('The "input" parameter is needed to be set when using returnInputValueOn'.concat(capitalizeFirstLetter(type)));
            return;
        }
        const input = instance.getInput();
        const inputValue = getInputValue(instance, innerParams);
        if (innerParams.inputValidator) handleInputValidator(instance, inputValue, type);
        else if (input && !input.checkValidity()) {
            instance.enableButtons();
            instance.showValidationMessage(innerParams.validationMessage);
        } else if (type === "deny") deny(instance, inputValue);
        else confirm(instance, inputValue);
    };
    /**
   * @param {SweetAlert} instance
   * @param {SweetAlertInputValue} inputValue
   * @param {'confirm' | 'deny'} type
   */ const handleInputValidator = (instance, inputValue, type)=>{
        const innerParams = privateProps.innerParams.get(instance);
        instance.disableInput();
        const validationPromise = Promise.resolve().then(()=>asPromise(innerParams.inputValidator(inputValue, innerParams.validationMessage)));
        validationPromise.then((validationMessage)=>{
            instance.enableButtons();
            instance.enableInput();
            if (validationMessage) instance.showValidationMessage(validationMessage);
            else if (type === "deny") deny(instance, inputValue);
            else confirm(instance, inputValue);
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ const deny = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance || undefined);
        if (innerParams.showLoaderOnDeny) showLoading(getDenyButton());
        if (innerParams.preDeny) {
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preDeny's promise is received
            const preDenyPromise = Promise.resolve().then(()=>asPromise(innerParams.preDeny(value, innerParams.validationMessage)));
            preDenyPromise.then((preDenyValue)=>{
                if (preDenyValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else instance.close({
                    isDenied: true,
                    value: typeof preDenyValue === "undefined" ? value : preDenyValue
                });
            }).catch((error)=>rejectWith(instance || undefined, error));
        } else instance.close({
            isDenied: true,
            value: value
        });
    };
    /**
   * @param {SweetAlert} instance
   * @param {any} value
   */ const succeedWith = (instance, value)=>{
        instance.close({
            isConfirmed: true,
            value: value
        });
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {string} error
   */ const rejectWith = (instance, error)=>{
        instance.rejectPromise(error);
    };
    /**
   *
   * @param {SweetAlert} instance
   * @param {any} value
   */ const confirm = (instance, value)=>{
        const innerParams = privateProps.innerParams.get(instance || undefined);
        if (innerParams.showLoaderOnConfirm) showLoading();
        if (innerParams.preConfirm) {
            instance.resetValidationMessage();
            instance.isAwaitingPromise = true; // Flagging the instance as awaiting a promise so it's own promise's reject/resolve methods doesn't get destroyed until the result from this preConfirm's promise is received
            const preConfirmPromise = Promise.resolve().then(()=>asPromise(innerParams.preConfirm(value, innerParams.validationMessage)));
            preConfirmPromise.then((preConfirmValue)=>{
                if (isVisible$1(getValidationMessage()) || preConfirmValue === false) {
                    instance.hideLoading();
                    handleAwaitingPromise(instance);
                } else succeedWith(instance, typeof preConfirmValue === "undefined" ? value : preConfirmValue);
            }).catch((error)=>rejectWith(instance || undefined, error));
        } else succeedWith(instance, value);
    };
    /**
   * Hides loader and shows back the button which was hidden by .showLoading()
   */ function hideLoading() {
        // do nothing if popup is closed
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) return;
        const domCache = privateProps.domCache.get(this);
        hide(domCache.loader);
        if (isToast()) {
            if (innerParams.icon) show(getIcon());
        } else showRelatedButton(domCache);
        removeClass([
            domCache.popup,
            domCache.actions
        ], swalClasses.loading);
        domCache.popup.removeAttribute("aria-busy");
        domCache.popup.removeAttribute("data-loading");
        domCache.confirmButton.disabled = false;
        domCache.denyButton.disabled = false;
        domCache.cancelButton.disabled = false;
    }
    const showRelatedButton = (domCache)=>{
        const buttonToReplace = domCache.popup.getElementsByClassName(domCache.loader.getAttribute("data-button-to-replace"));
        if (buttonToReplace.length) show(buttonToReplace[0], "inline-block");
        else if (allButtonsAreHidden()) hide(domCache.actions);
    };
    /**
   * Gets the input DOM node, this method works with input parameter.
   *
   * @returns {HTMLInputElement | null}
   */ function getInput() {
        const innerParams = privateProps.innerParams.get(this);
        const domCache = privateProps.domCache.get(this);
        if (!domCache) return null;
        return getInput$1(domCache.popup, innerParams.input);
    }
    /**
   * @param {SweetAlert} instance
   * @param {string[]} buttons
   * @param {boolean} disabled
   */ function setButtonsDisabled(instance, buttons, disabled) {
        const domCache = privateProps.domCache.get(instance);
        buttons.forEach((button)=>{
            domCache[button].disabled = disabled;
        });
    }
    /**
   * @param {HTMLInputElement | null} input
   * @param {boolean} disabled
   */ function setInputDisabled(input, disabled) {
        const popup = getPopup();
        if (!popup || !input) return;
        if (input.type === "radio") {
            /** @type {NodeListOf<HTMLInputElement>} */ const radios = popup.querySelectorAll('[name="'.concat(swalClasses.radio, '"]'));
            for(let i = 0; i < radios.length; i++)radios[i].disabled = disabled;
        } else input.disabled = disabled;
    }
    /**
   * Enable all the buttons
   * @this {SweetAlert}
   */ function enableButtons() {
        setButtonsDisabled(this, [
            "confirmButton",
            "denyButton",
            "cancelButton"
        ], false);
    }
    /**
   * Disable all the buttons
   * @this {SweetAlert}
   */ function disableButtons() {
        setButtonsDisabled(this, [
            "confirmButton",
            "denyButton",
            "cancelButton"
        ], true);
    }
    /**
   * Enable the input field
   * @this {SweetAlert}
   */ function enableInput() {
        setInputDisabled(this.getInput(), false);
    }
    /**
   * Disable the input field
   * @this {SweetAlert}
   */ function disableInput() {
        setInputDisabled(this.getInput(), true);
    }
    /**
   * Show block with validation message
   *
   * @param {string} error
   * @this {SweetAlert}
   */ function showValidationMessage(error) {
        const domCache = privateProps.domCache.get(this);
        const params = privateProps.innerParams.get(this);
        setInnerHtml(domCache.validationMessage, error);
        domCache.validationMessage.className = swalClasses["validation-message"];
        if (params.customClass && params.customClass.validationMessage) addClass(domCache.validationMessage, params.customClass.validationMessage);
        show(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.setAttribute("aria-invalid", "true");
            input.setAttribute("aria-describedby", swalClasses["validation-message"]);
            focusInput(input);
            addClass(input, swalClasses.inputerror);
        }
    }
    /**
   * Hide block with validation message
   *
   * @this {SweetAlert}
   */ function resetValidationMessage() {
        const domCache = privateProps.domCache.get(this);
        if (domCache.validationMessage) hide(domCache.validationMessage);
        const input = this.getInput();
        if (input) {
            input.removeAttribute("aria-invalid");
            input.removeAttribute("aria-describedby");
            removeClass(input, swalClasses.inputerror);
        }
    }
    const defaultParams = {
        title: "",
        titleText: "",
        text: "",
        html: "",
        footer: "",
        icon: undefined,
        iconColor: undefined,
        iconHtml: undefined,
        template: undefined,
        toast: false,
        showClass: {
            popup: "swal2-show",
            backdrop: "swal2-backdrop-show",
            icon: "swal2-icon-show"
        },
        hideClass: {
            popup: "swal2-hide",
            backdrop: "swal2-backdrop-hide",
            icon: "swal2-icon-hide"
        },
        customClass: {},
        target: "body",
        color: undefined,
        backdrop: true,
        heightAuto: true,
        allowOutsideClick: true,
        allowEscapeKey: true,
        allowEnterKey: true,
        stopKeydownPropagation: true,
        keydownListenerCapture: false,
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: false,
        preConfirm: undefined,
        preDeny: undefined,
        confirmButtonText: "OK",
        confirmButtonAriaLabel: "",
        confirmButtonColor: undefined,
        denyButtonText: "No",
        denyButtonAriaLabel: "",
        denyButtonColor: undefined,
        cancelButtonText: "Cancel",
        cancelButtonAriaLabel: "",
        cancelButtonColor: undefined,
        buttonsStyling: true,
        reverseButtons: false,
        focusConfirm: true,
        focusDeny: false,
        focusCancel: false,
        returnFocus: true,
        showCloseButton: false,
        closeButtonHtml: "&times;",
        closeButtonAriaLabel: "Close this dialog",
        loaderHtml: "",
        showLoaderOnConfirm: false,
        showLoaderOnDeny: false,
        imageUrl: undefined,
        imageWidth: undefined,
        imageHeight: undefined,
        imageAlt: "",
        timer: undefined,
        timerProgressBar: false,
        width: undefined,
        padding: undefined,
        background: undefined,
        input: undefined,
        inputPlaceholder: "",
        inputLabel: "",
        inputValue: "",
        inputOptions: {},
        inputAutoFocus: true,
        inputAutoTrim: true,
        inputAttributes: {},
        inputValidator: undefined,
        returnInputValueOnDeny: false,
        validationMessage: undefined,
        grow: false,
        position: "center",
        progressSteps: [],
        currentProgressStep: undefined,
        progressStepsDistance: undefined,
        willOpen: undefined,
        didOpen: undefined,
        didRender: undefined,
        willClose: undefined,
        didClose: undefined,
        didDestroy: undefined,
        scrollbarPadding: true
    };
    const updatableParams = [
        "allowEscapeKey",
        "allowOutsideClick",
        "background",
        "buttonsStyling",
        "cancelButtonAriaLabel",
        "cancelButtonColor",
        "cancelButtonText",
        "closeButtonAriaLabel",
        "closeButtonHtml",
        "color",
        "confirmButtonAriaLabel",
        "confirmButtonColor",
        "confirmButtonText",
        "currentProgressStep",
        "customClass",
        "denyButtonAriaLabel",
        "denyButtonColor",
        "denyButtonText",
        "didClose",
        "didDestroy",
        "footer",
        "hideClass",
        "html",
        "icon",
        "iconColor",
        "iconHtml",
        "imageAlt",
        "imageHeight",
        "imageUrl",
        "imageWidth",
        "preConfirm",
        "preDeny",
        "progressSteps",
        "returnFocus",
        "reverseButtons",
        "showCancelButton",
        "showCloseButton",
        "showConfirmButton",
        "showDenyButton",
        "text",
        "title",
        "titleText",
        "willClose"
    ];
    /** @type {Record<string, string>} */ const deprecatedParams = {};
    const toastIncompatibleParams = [
        "allowOutsideClick",
        "allowEnterKey",
        "backdrop",
        "focusConfirm",
        "focusDeny",
        "focusCancel",
        "returnFocus",
        "heightAuto",
        "keydownListenerCapture"
    ];
    /**
   * Is valid parameter
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isValidParameter = (paramName)=>{
        return Object.prototype.hasOwnProperty.call(defaultParams, paramName);
    };
    /**
   * Is valid parameter for Swal.update() method
   *
   * @param {string} paramName
   * @returns {boolean}
   */ const isUpdatableParameter = (paramName)=>{
        return updatableParams.indexOf(paramName) !== -1;
    };
    /**
   * Is deprecated parameter
   *
   * @param {string} paramName
   * @returns {string | undefined}
   */ const isDeprecatedParameter = (paramName)=>{
        return deprecatedParams[paramName];
    };
    /**
   * @param {string} param
   */ const checkIfParamIsValid = (param)=>{
        if (!isValidParameter(param)) warn('Unknown parameter "'.concat(param, '"'));
    };
    /**
   * @param {string} param
   */ const checkIfToastParamIsValid = (param)=>{
        if (toastIncompatibleParams.includes(param)) warn('The parameter "'.concat(param, '" is incompatible with toasts'));
    };
    /**
   * @param {string} param
   */ const checkIfParamIsDeprecated = (param)=>{
        const isDeprecated = isDeprecatedParameter(param);
        if (isDeprecated) warnAboutDeprecation(param, isDeprecated);
    };
    /**
   * Show relevant warnings for given params
   *
   * @param {SweetAlertOptions} params
   */ const showWarningsForParams = (params)=>{
        if (params.backdrop === false && params.allowOutsideClick) warn('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`');
        for(const param in params){
            checkIfParamIsValid(param);
            if (params.toast) checkIfToastParamIsValid(param);
            checkIfParamIsDeprecated(param);
        }
    };
    /**
   * Updates popup parameters.
   *
   * @param {SweetAlertOptions} params
   */ function update(params) {
        const popup = getPopup();
        const innerParams = privateProps.innerParams.get(this);
        if (!popup || hasClass(popup, innerParams.hideClass.popup)) {
            warn("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
            return;
        }
        const validUpdatableParams = filterValidParams(params);
        const updatedParams = Object.assign({}, innerParams, validUpdatableParams);
        render(this, updatedParams);
        privateProps.innerParams.set(this, updatedParams);
        Object.defineProperties(this, {
            params: {
                value: Object.assign({}, this.params, params),
                writable: false,
                enumerable: true
            }
        });
    }
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const filterValidParams = (params)=>{
        const validUpdatableParams = {};
        Object.keys(params).forEach((param)=>{
            if (isUpdatableParameter(param)) validUpdatableParams[param] = params[param];
            else warn("Invalid parameter to update: ".concat(param));
        });
        return validUpdatableParams;
    };
    /**
   * Dispose the current SweetAlert2 instance
   */ function _destroy() {
        const domCache = privateProps.domCache.get(this);
        const innerParams = privateProps.innerParams.get(this);
        if (!innerParams) {
            disposeWeakMaps(this); // The WeakMaps might have been partly destroyed, we must recall it to dispose any remaining WeakMaps #2335
            return; // This instance has already been destroyed
        }
        // Check if there is another Swal closing
        if (domCache.popup && globalState.swalCloseEventFinishedCallback) {
            globalState.swalCloseEventFinishedCallback();
            delete globalState.swalCloseEventFinishedCallback;
        }
        if (typeof innerParams.didDestroy === "function") innerParams.didDestroy();
        disposeSwal(this);
    }
    /**
   * @param {SweetAlert} instance
   */ const disposeSwal = (instance)=>{
        disposeWeakMaps(instance);
        // Unset this.params so GC will dispose it (#1569)
        delete instance.params;
        // Unset globalState props so GC will dispose globalState (#1569)
        delete globalState.keydownHandler;
        delete globalState.keydownTarget;
        // Unset currentInstance
        delete globalState.currentInstance;
    };
    /**
   * @param {SweetAlert} instance
   */ const disposeWeakMaps = (instance)=>{
        // If the current instance is awaiting a promise result, we keep the privateMethods to call them once the promise result is retrieved #2335
        if (instance.isAwaitingPromise) {
            unsetWeakMaps(privateProps, instance);
            instance.isAwaitingPromise = true;
        } else {
            unsetWeakMaps(privateMethods, instance);
            unsetWeakMaps(privateProps, instance);
            delete instance.isAwaitingPromise;
            // Unset instance methods
            delete instance.disableButtons;
            delete instance.enableButtons;
            delete instance.getInput;
            delete instance.disableInput;
            delete instance.enableInput;
            delete instance.hideLoading;
            delete instance.disableLoading;
            delete instance.showValidationMessage;
            delete instance.resetValidationMessage;
            delete instance.close;
            delete instance.closePopup;
            delete instance.closeModal;
            delete instance.closeToast;
            delete instance.rejectPromise;
            delete instance.update;
            delete instance._destroy;
        }
    };
    /**
   * @param {object} obj
   * @param {SweetAlert} instance
   */ const unsetWeakMaps = (obj, instance)=>{
        for(const i in obj)obj[i].delete(instance);
    };
    var instanceMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        _destroy: _destroy,
        close: close,
        closeModal: close,
        closePopup: close,
        closeToast: close,
        disableButtons: disableButtons,
        disableInput: disableInput,
        disableLoading: hideLoading,
        enableButtons: enableButtons,
        enableInput: enableInput,
        getInput: getInput,
        handleAwaitingPromise: handleAwaitingPromise,
        hideLoading: hideLoading,
        rejectPromise: rejectPromise,
        resetValidationMessage: resetValidationMessage,
        showValidationMessage: showValidationMessage,
        update: update
    });
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handlePopupClick = (innerParams, domCache, dismissWith)=>{
        if (innerParams.toast) handleToastClick(innerParams, domCache, dismissWith);
        else {
            // Ignore click events that had mousedown on the popup but mouseup on the container
            // This can happen when the user drags a slider
            handleModalMousedown(domCache);
            // Ignore click events that had mousedown on the container but mouseup on the popup
            handleContainerMousedown(domCache);
            handleModalClick(innerParams, domCache, dismissWith);
        }
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handleToastClick = (innerParams, domCache, dismissWith)=>{
        // Closing toast by internal click
        domCache.popup.onclick = ()=>{
            if (innerParams && (isAnyButtonShown(innerParams) || innerParams.timer || innerParams.input)) return;
            dismissWith(DismissReason.close);
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const isAnyButtonShown = (innerParams)=>{
        return !!(innerParams.showConfirmButton || innerParams.showDenyButton || innerParams.showCancelButton || innerParams.showCloseButton);
    };
    let ignoreOutsideClick = false;
    /**
   * @param {DomCache} domCache
   */ const handleModalMousedown = (domCache)=>{
        domCache.popup.onmousedown = ()=>{
            domCache.container.onmouseup = function(e) {
                domCache.container.onmouseup = ()=>{};
                // We only check if the mouseup target is the container because usually it doesn't
                // have any other direct children aside of the popup
                if (e.target === domCache.container) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {DomCache} domCache
   */ const handleContainerMousedown = (domCache)=>{
        domCache.container.onmousedown = ()=>{
            domCache.popup.onmouseup = function(e) {
                domCache.popup.onmouseup = ()=>{};
                // We also need to check if the mouseup target is a child of the popup
                if (e.target === domCache.popup || e.target instanceof HTMLElement && domCache.popup.contains(e.target)) ignoreOutsideClick = true;
            };
        };
    };
    /**
   * @param {SweetAlertOptions} innerParams
   * @param {DomCache} domCache
   * @param {Function} dismissWith
   */ const handleModalClick = (innerParams, domCache, dismissWith)=>{
        domCache.container.onclick = (e)=>{
            if (ignoreOutsideClick) {
                ignoreOutsideClick = false;
                return;
            }
            if (e.target === domCache.container && callIfFunction(innerParams.allowOutsideClick)) dismissWith(DismissReason.backdrop);
        };
    };
    const isJqueryElement = (elem)=>typeof elem === "object" && elem.jquery;
    const isElement = (elem)=>elem instanceof Element || isJqueryElement(elem);
    const argsToParams = (args)=>{
        const params = {};
        if (typeof args[0] === "object" && !isElement(args[0])) Object.assign(params, args[0]);
        else [
            "title",
            "html",
            "icon"
        ].forEach((name, index)=>{
            const arg = args[index];
            if (typeof arg === "string" || isElement(arg)) params[name] = arg;
            else if (arg !== undefined) error("Unexpected type of ".concat(name, '! Expected "string" or "Element", got ').concat(typeof arg));
        });
        return params;
    };
    /**
   * Main method to create a new SweetAlert2 popup
   *
   * @param  {...SweetAlertOptions} args
   * @returns {Promise<SweetAlertResult>}
   */ function fire() {
        const Swal = this; // eslint-disable-line @typescript-eslint/no-this-alias
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return new Swal(...args);
    }
    /**
   * Returns an extended version of `Swal` containing `params` as defaults.
   * Useful for reusing Swal configuration.
   *
   * For example:
   *
   * Before:
   * const textPromptOptions = { input: 'text', showCancelButton: true }
   * const {value: firstName} = await Swal.fire({ ...textPromptOptions, title: 'What is your first name?' })
   * const {value: lastName} = await Swal.fire({ ...textPromptOptions, title: 'What is your last name?' })
   *
   * After:
   * const TextPrompt = Swal.mixin({ input: 'text', showCancelButton: true })
   * const {value: firstName} = await TextPrompt('What is your first name?')
   * const {value: lastName} = await TextPrompt('What is your last name?')
   *
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlert}
   */ function mixin(mixinParams) {
        class MixinSwal extends this {
            _main(params, priorityMixinParams) {
                return super._main(params, Object.assign({}, mixinParams, priorityMixinParams));
            }
        }
        // @ts-ignore
        return MixinSwal;
    }
    /**
   * If `timer` parameter is set, returns number of milliseconds of timer remained.
   * Otherwise, returns undefined.
   *
   * @returns {number | undefined}
   */ const getTimerLeft = ()=>{
        return globalState.timeout && globalState.timeout.getTimerLeft();
    };
    /**
   * Stop timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const stopTimer = ()=>{
        if (globalState.timeout) {
            stopTimerProgressBar();
            return globalState.timeout.stop();
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const resumeTimer = ()=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.start();
            animateTimerProgressBar(remaining);
            return remaining;
        }
    };
    /**
   * Resume timer. Returns number of milliseconds of timer remained.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @returns {number | undefined}
   */ const toggleTimer = ()=>{
        const timer = globalState.timeout;
        return timer && (timer.running ? stopTimer() : resumeTimer());
    };
    /**
   * Increase timer. Returns number of milliseconds of an updated timer.
   * If `timer` parameter isn't set, returns undefined.
   *
   * @param {number} ms
   * @returns {number | undefined}
   */ const increaseTimer = (ms)=>{
        if (globalState.timeout) {
            const remaining = globalState.timeout.increase(ms);
            animateTimerProgressBar(remaining, true);
            return remaining;
        }
    };
    /**
   * Check if timer is running. Returns true if timer is running
   * or false if timer is paused or stopped.
   * If `timer` parameter isn't set, returns undefined
   *
   * @returns {boolean}
   */ const isTimerRunning = ()=>{
        return !!(globalState.timeout && globalState.timeout.isRunning());
    };
    let bodyClickListenerAdded = false;
    const clickHandlers = {};
    /**
   * @param {string} attr
   */ function bindClickHandler() {
        let attr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "data-swal-template";
        clickHandlers[attr] = this;
        if (!bodyClickListenerAdded) {
            document.body.addEventListener("click", bodyClickListener);
            bodyClickListenerAdded = true;
        }
    }
    const bodyClickListener = (event)=>{
        for(let el = event.target; el && el !== document; el = el.parentNode)for(const attr in clickHandlers){
            const template = el.getAttribute(attr);
            if (template) {
                clickHandlers[attr].fire({
                    template: template
                });
                return;
            }
        }
    };
    var staticMethods = /*#__PURE__*/ Object.freeze({
        __proto__: null,
        argsToParams: argsToParams,
        bindClickHandler: bindClickHandler,
        clickCancel: clickCancel,
        clickConfirm: clickConfirm,
        clickDeny: clickDeny,
        enableLoading: showLoading,
        fire: fire,
        getActions: getActions,
        getCancelButton: getCancelButton,
        getCloseButton: getCloseButton,
        getConfirmButton: getConfirmButton,
        getContainer: getContainer,
        getDenyButton: getDenyButton,
        getFocusableElements: getFocusableElements,
        getFooter: getFooter,
        getHtmlContainer: getHtmlContainer,
        getIcon: getIcon,
        getIconContent: getIconContent,
        getImage: getImage,
        getInputLabel: getInputLabel,
        getLoader: getLoader,
        getPopup: getPopup,
        getProgressSteps: getProgressSteps,
        getTimerLeft: getTimerLeft,
        getTimerProgressBar: getTimerProgressBar,
        getTitle: getTitle,
        getValidationMessage: getValidationMessage,
        increaseTimer: increaseTimer,
        isDeprecatedParameter: isDeprecatedParameter,
        isLoading: isLoading,
        isTimerRunning: isTimerRunning,
        isUpdatableParameter: isUpdatableParameter,
        isValidParameter: isValidParameter,
        isVisible: isVisible,
        mixin: mixin,
        resumeTimer: resumeTimer,
        showLoading: showLoading,
        stopTimer: stopTimer,
        toggleTimer: toggleTimer
    });
    class Timer {
        /**
     * @param {Function} callback
     * @param {number} delay
     */ constructor(callback, delay){
            this.callback = callback;
            this.remaining = delay;
            this.running = false;
            this.start();
        }
        /**
     * @returns {number}
     */ start() {
            if (!this.running) {
                this.running = true;
                this.started = new Date();
                this.id = setTimeout(this.callback, this.remaining);
            }
            return this.remaining;
        }
        /**
     * @returns {number}
     */ stop() {
            if (this.started && this.running) {
                this.running = false;
                clearTimeout(this.id);
                this.remaining -= new Date().getTime() - this.started.getTime();
            }
            return this.remaining;
        }
        /**
     * @param {number} n
     * @returns {number}
     */ increase(n) {
            const running = this.running;
            if (running) this.stop();
            this.remaining += n;
            if (running) this.start();
            return this.remaining;
        }
        /**
     * @returns {number}
     */ getTimerLeft() {
            if (this.running) {
                this.stop();
                this.start();
            }
            return this.remaining;
        }
        /**
     * @returns {boolean}
     */ isRunning() {
            return this.running;
        }
    }
    const swalStringParams = [
        "swal-title",
        "swal-html",
        "swal-footer"
    ];
    /**
   * @param {SweetAlertOptions} params
   * @returns {SweetAlertOptions}
   */ const getTemplateParams = (params)=>{
        /** @type {HTMLTemplateElement} */ const template = typeof params.template === "string" ? document.querySelector(params.template) : params.template;
        if (!template) return {};
        /** @type {DocumentFragment} */ const templateContent = template.content;
        showWarningsForElements(templateContent);
        const result = Object.assign(getSwalParams(templateContent), getSwalFunctionParams(templateContent), getSwalButtons(templateContent), getSwalImage(templateContent), getSwalIcon(templateContent), getSwalInput(templateContent), getSwalStringParams(templateContent, swalStringParams));
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */ const getSwalParams = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement[]} */ const swalParams = Array.from(templateContent.querySelectorAll("swal-param"));
        swalParams.forEach((param)=>{
            showWarningsForAttributes(param, [
                "name",
                "value"
            ]);
            const paramName = param.getAttribute("name");
            const value = param.getAttribute("value");
            if (typeof defaultParams[paramName] === "boolean") result[paramName] = value !== "false";
            else if (typeof defaultParams[paramName] === "object") result[paramName] = JSON.parse(value);
            else result[paramName] = value;
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */ const getSwalFunctionParams = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement[]} */ const swalFunctions = Array.from(templateContent.querySelectorAll("swal-function-param"));
        swalFunctions.forEach((param)=>{
            const paramName = param.getAttribute("name");
            const value = param.getAttribute("value");
            result[paramName] = new Function("return ".concat(value))();
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */ const getSwalButtons = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement[]} */ const swalButtons = Array.from(templateContent.querySelectorAll("swal-button"));
        swalButtons.forEach((button)=>{
            showWarningsForAttributes(button, [
                "type",
                "color",
                "aria-label"
            ]);
            const type = button.getAttribute("type");
            result["".concat(type, "ButtonText")] = button.innerHTML;
            result["show".concat(capitalizeFirstLetter(type), "Button")] = true;
            if (button.hasAttribute("color")) result["".concat(type, "ButtonColor")] = button.getAttribute("color");
            if (button.hasAttribute("aria-label")) result["".concat(type, "ButtonAriaLabel")] = button.getAttribute("aria-label");
        });
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */ const getSwalImage = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement} */ const image = templateContent.querySelector("swal-image");
        if (image) {
            showWarningsForAttributes(image, [
                "src",
                "width",
                "height",
                "alt"
            ]);
            if (image.hasAttribute("src")) result.imageUrl = image.getAttribute("src");
            if (image.hasAttribute("width")) result.imageWidth = image.getAttribute("width");
            if (image.hasAttribute("height")) result.imageHeight = image.getAttribute("height");
            if (image.hasAttribute("alt")) result.imageAlt = image.getAttribute("alt");
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */ const getSwalIcon = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement} */ const icon = templateContent.querySelector("swal-icon");
        if (icon) {
            showWarningsForAttributes(icon, [
                "type",
                "color"
            ]);
            if (icon.hasAttribute("type")) /** @type {SweetAlertIcon} */ // @ts-ignore
            result.icon = icon.getAttribute("type");
            if (icon.hasAttribute("color")) result.iconColor = icon.getAttribute("color");
            result.iconHtml = icon.innerHTML;
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @returns {SweetAlertOptions}
   */ const getSwalInput = (templateContent)=>{
        const result = {};
        /** @type {HTMLElement} */ const input = templateContent.querySelector("swal-input");
        if (input) {
            showWarningsForAttributes(input, [
                "type",
                "label",
                "placeholder",
                "value"
            ]);
            /** @type {SweetAlertInput} */ // @ts-ignore
            result.input = input.getAttribute("type") || "text";
            if (input.hasAttribute("label")) result.inputLabel = input.getAttribute("label");
            if (input.hasAttribute("placeholder")) result.inputPlaceholder = input.getAttribute("placeholder");
            if (input.hasAttribute("value")) result.inputValue = input.getAttribute("value");
        }
        /** @type {HTMLElement[]} */ const inputOptions = Array.from(templateContent.querySelectorAll("swal-input-option"));
        if (inputOptions.length) {
            result.inputOptions = {};
            inputOptions.forEach((option)=>{
                showWarningsForAttributes(option, [
                    "value"
                ]);
                const optionValue = option.getAttribute("value");
                const optionName = option.innerHTML;
                result.inputOptions[optionValue] = optionName;
            });
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   * @param {string[]} paramNames
   * @returns {SweetAlertOptions}
   */ const getSwalStringParams = (templateContent, paramNames)=>{
        const result = {};
        for(const i in paramNames){
            const paramName = paramNames[i];
            /** @type {HTMLElement} */ const tag = templateContent.querySelector(paramName);
            if (tag) {
                showWarningsForAttributes(tag, []);
                result[paramName.replace(/^swal-/, "")] = tag.innerHTML.trim();
            }
        }
        return result;
    };
    /**
   * @param {DocumentFragment} templateContent
   */ const showWarningsForElements = (templateContent)=>{
        const allowedElements = swalStringParams.concat([
            "swal-param",
            "swal-function-param",
            "swal-button",
            "swal-image",
            "swal-icon",
            "swal-input",
            "swal-input-option"
        ]);
        Array.from(templateContent.children).forEach((el)=>{
            const tagName = el.tagName.toLowerCase();
            if (!allowedElements.includes(tagName)) warn("Unrecognized element <".concat(tagName, ">"));
        });
    };
    /**
   * @param {HTMLElement} el
   * @param {string[]} allowedAttributes
   */ const showWarningsForAttributes = (el, allowedAttributes)=>{
        Array.from(el.attributes).forEach((attribute)=>{
            if (allowedAttributes.indexOf(attribute.name) === -1) warn([
                'Unrecognized attribute "'.concat(attribute.name, '" on <').concat(el.tagName.toLowerCase(), ">."),
                "".concat(allowedAttributes.length ? "Allowed attributes are: ".concat(allowedAttributes.join(", ")) : "To set the value, use HTML within the element.")
            ]);
        });
    };
    const SHOW_CLASS_TIMEOUT = 10;
    /**
   * Open popup, add necessary classes and styles, fix scrollbar
   *
   * @param {SweetAlertOptions} params
   */ const openPopup = (params)=>{
        const container = getContainer();
        const popup = getPopup();
        if (typeof params.willOpen === "function") params.willOpen(popup);
        const bodyStyles = window.getComputedStyle(document.body);
        const initialBodyOverflow = bodyStyles.overflowY;
        addClasses(container, popup, params);
        // scrolling is 'hidden' until animation is done, after that 'auto'
        setTimeout(()=>{
            setScrollingVisibility(container, popup);
        }, SHOW_CLASS_TIMEOUT);
        if (isModal()) {
            fixScrollContainer(container, params.scrollbarPadding, initialBodyOverflow);
            setAriaHidden();
        }
        if (!isToast() && !globalState.previousActiveElement) globalState.previousActiveElement = document.activeElement;
        if (typeof params.didOpen === "function") setTimeout(()=>params.didOpen(popup));
        removeClass(container, swalClasses["no-transition"]);
    };
    /**
   * @param {AnimationEvent} event
   */ const swalOpenAnimationFinished = (event)=>{
        const popup = getPopup();
        if (event.target !== popup || !animationEndEvent) return;
        const container = getContainer();
        popup.removeEventListener(animationEndEvent, swalOpenAnimationFinished);
        container.style.overflowY = "auto";
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   */ const setScrollingVisibility = (container, popup)=>{
        if (animationEndEvent && hasCssAnimation(popup)) {
            container.style.overflowY = "hidden";
            popup.addEventListener(animationEndEvent, swalOpenAnimationFinished);
        } else container.style.overflowY = "auto";
    };
    /**
   * @param {HTMLElement} container
   * @param {boolean} scrollbarPadding
   * @param {string} initialBodyOverflow
   */ const fixScrollContainer = (container, scrollbarPadding, initialBodyOverflow)=>{
        iOSfix();
        if (scrollbarPadding && initialBodyOverflow !== "hidden") replaceScrollbarWithPadding(initialBodyOverflow);
        // sweetalert2/issues/1247
        setTimeout(()=>{
            container.scrollTop = 0;
        });
    };
    /**
   * @param {HTMLElement} container
   * @param {HTMLElement} popup
   * @param {SweetAlertOptions} params
   */ const addClasses = (container, popup, params)=>{
        addClass(container, params.showClass.backdrop);
        // this workaround with opacity is needed for https://github.com/sweetalert2/sweetalert2/issues/2059
        popup.style.setProperty("opacity", "0", "important");
        show(popup, "grid");
        setTimeout(()=>{
            // Animate popup right after showing it
            addClass(popup, params.showClass.popup);
            // and remove the opacity workaround
            popup.style.removeProperty("opacity");
        }, SHOW_CLASS_TIMEOUT); // 10ms in order to fix #2062
        addClass([
            document.documentElement,
            document.body
        ], swalClasses.shown);
        if (params.heightAuto && params.backdrop && !params.toast) addClass([
            document.documentElement,
            document.body
        ], swalClasses["height-auto"]);
    };
    var defaultInputValidators = {
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ email: (string, validationMessage)=>{
            return /^[a-zA-Z0-9.+_-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,24}$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || "Invalid email address");
        },
        /**
     * @param {string} string
     * @param {string} [validationMessage]
     * @returns {Promise<string | void>}
     */ url: (string, validationMessage)=>{
            // taken from https://stackoverflow.com/a/3809435 with a small change from #1306 and #2013
            return /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(string) ? Promise.resolve() : Promise.resolve(validationMessage || "Invalid URL");
        }
    };
    /**
   * @param {SweetAlertOptions} params
   */ function setDefaultInputValidators(params) {
        // Use default `inputValidator` for supported input types if not provided
        if (params.inputValidator) return;
        if (params.input === "email") params.inputValidator = defaultInputValidators["email"];
        if (params.input === "url") params.inputValidator = defaultInputValidators["url"];
    }
    /**
   * @param {SweetAlertOptions} params
   */ function validateCustomTargetElement(params) {
        // Determine if the custom target element is valid
        if (!params.target || typeof params.target === "string" && !document.querySelector(params.target) || typeof params.target !== "string" && !params.target.appendChild) {
            warn('Target parameter is not valid, defaulting to "body"');
            params.target = "body";
        }
    }
    /**
   * Set type, text and actions on popup
   *
   * @param {SweetAlertOptions} params
   */ function setParameters(params) {
        setDefaultInputValidators(params);
        // showLoaderOnConfirm && preConfirm
        if (params.showLoaderOnConfirm && !params.preConfirm) warn("showLoaderOnConfirm is set to true, but preConfirm is not defined.\nshowLoaderOnConfirm should be used together with preConfirm, see usage example:\nhttps://sweetalert2.github.io/#ajax-request");
        validateCustomTargetElement(params);
        // Replace newlines with <br> in title
        if (typeof params.title === "string") params.title = params.title.split("\n").join("<br />");
        init(params);
    }
    /** @type {SweetAlert} */ let currentInstance;
    var _promise = /*#__PURE__*/ new WeakMap();
    class SweetAlert {
        /**
     * @param {...any} args
     * @this {SweetAlert}
     */ constructor(){
            /**
       * @type {Promise<SweetAlertResult>}
       */ _classPrivateFieldInitSpec(this, _promise, {
                writable: true,
                value: void 0
            });
            // Prevent run in Node env
            if (typeof window === "undefined") return;
            currentInstance = this;
            // @ts-ignore
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            const outerParams = Object.freeze(this.constructor.argsToParams(args));
            /** @type {Readonly<SweetAlertOptions>} */ this.params = outerParams;
            /** @type {boolean} */ this.isAwaitingPromise = false;
            _classPrivateFieldSet(this, _promise, this._main(currentInstance.params));
        }
        _main(userParams) {
            let mixinParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            showWarningsForParams(Object.assign({}, mixinParams, userParams));
            if (globalState.currentInstance) {
                globalState.currentInstance._destroy();
                if (isModal()) unsetAriaHidden();
            }
            globalState.currentInstance = currentInstance;
            const innerParams = prepareParams(userParams, mixinParams);
            setParameters(innerParams);
            Object.freeze(innerParams);
            // clear the previous timer
            if (globalState.timeout) {
                globalState.timeout.stop();
                delete globalState.timeout;
            }
            // clear the restore focus timeout
            clearTimeout(globalState.restoreFocusTimeout);
            const domCache = populateDomCache(currentInstance);
            render(currentInstance, innerParams);
            privateProps.innerParams.set(currentInstance, innerParams);
            return swalPromise(currentInstance, domCache, innerParams);
        }
        // `catch` cannot be the name of a module export, so we define our thenable methods here instead
        then(onFulfilled) {
            return _classPrivateFieldGet(this, _promise).then(onFulfilled);
        }
        finally(onFinally) {
            return _classPrivateFieldGet(this, _promise).finally(onFinally);
        }
    }
    /**
   * @param {SweetAlert} instance
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {Promise}
   */ const swalPromise = (instance, domCache, innerParams)=>{
        return new Promise((resolve, reject)=>{
            // functions to handle all closings/dismissals
            /**
       * @param {DismissReason} dismiss
       */ const dismissWith = (dismiss)=>{
                instance.close({
                    isDismissed: true,
                    dismiss: dismiss
                });
            };
            privateMethods.swalPromiseResolve.set(instance, resolve);
            privateMethods.swalPromiseReject.set(instance, reject);
            domCache.confirmButton.onclick = ()=>{
                handleConfirmButtonClick(instance);
            };
            domCache.denyButton.onclick = ()=>{
                handleDenyButtonClick(instance);
            };
            domCache.cancelButton.onclick = ()=>{
                handleCancelButtonClick(instance, dismissWith);
            };
            domCache.closeButton.onclick = ()=>{
                dismissWith(DismissReason.close);
            };
            handlePopupClick(innerParams, domCache, dismissWith);
            addKeydownHandler(globalState, innerParams, dismissWith);
            handleInputOptionsAndValue(instance, innerParams);
            openPopup(innerParams);
            setupTimer(globalState, innerParams, dismissWith);
            initFocus(domCache, innerParams);
            // Scroll container to top on open (#1247, #1946)
            setTimeout(()=>{
                domCache.container.scrollTop = 0;
            });
        });
    };
    /**
   * @param {SweetAlertOptions} userParams
   * @param {SweetAlertOptions} mixinParams
   * @returns {SweetAlertOptions}
   */ const prepareParams = (userParams, mixinParams)=>{
        const templateParams = getTemplateParams(userParams);
        const params = Object.assign({}, defaultParams, mixinParams, templateParams, userParams); // precedence is described in #2131
        params.showClass = Object.assign({}, defaultParams.showClass, params.showClass);
        params.hideClass = Object.assign({}, defaultParams.hideClass, params.hideClass);
        return params;
    };
    /**
   * @param {SweetAlert} instance
   * @returns {DomCache}
   */ const populateDomCache = (instance)=>{
        const domCache = {
            popup: getPopup(),
            container: getContainer(),
            actions: getActions(),
            confirmButton: getConfirmButton(),
            denyButton: getDenyButton(),
            cancelButton: getCancelButton(),
            loader: getLoader(),
            closeButton: getCloseButton(),
            validationMessage: getValidationMessage(),
            progressSteps: getProgressSteps()
        };
        privateProps.domCache.set(instance, domCache);
        return domCache;
    };
    /**
   * @param {GlobalState} globalState
   * @param {SweetAlertOptions} innerParams
   * @param {Function} dismissWith
   */ const setupTimer = (globalState, innerParams, dismissWith)=>{
        const timerProgressBar = getTimerProgressBar();
        hide(timerProgressBar);
        if (innerParams.timer) {
            globalState.timeout = new Timer(()=>{
                dismissWith("timer");
                delete globalState.timeout;
            }, innerParams.timer);
            if (innerParams.timerProgressBar) {
                show(timerProgressBar);
                applyCustomClass(timerProgressBar, innerParams, "timerProgressBar");
                setTimeout(()=>{
                    if (globalState.timeout && globalState.timeout.running) // timer can be already stopped or unset at this point
                    animateTimerProgressBar(innerParams.timer);
                });
            }
        }
    };
    /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   */ const initFocus = (domCache, innerParams)=>{
        if (innerParams.toast) return;
        if (!callIfFunction(innerParams.allowEnterKey)) {
            blurActiveElement();
            return;
        }
        if (!focusButton(domCache, innerParams)) setFocus(-1, 1);
    };
    /**
   * @param {DomCache} domCache
   * @param {SweetAlertOptions} innerParams
   * @returns {boolean}
   */ const focusButton = (domCache, innerParams)=>{
        if (innerParams.focusDeny && isVisible$1(domCache.denyButton)) {
            domCache.denyButton.focus();
            return true;
        }
        if (innerParams.focusCancel && isVisible$1(domCache.cancelButton)) {
            domCache.cancelButton.focus();
            return true;
        }
        if (innerParams.focusConfirm && isVisible$1(domCache.confirmButton)) {
            domCache.confirmButton.focus();
            return true;
        }
        return false;
    };
    const blurActiveElement = ()=>{
        if (document.activeElement instanceof HTMLElement && typeof document.activeElement.blur === "function") document.activeElement.blur();
    };
    // Dear russian users visiting russian sites. Let's have fun.
    if (typeof window !== "undefined" && /^ru\b/.test(navigator.language) && location.host.match(/\.(ru|su|by|xn--p1ai)$/)) {
        const now = new Date();
        const initiationDate = localStorage.getItem("swal-initiation");
        if (!initiationDate) localStorage.setItem("swal-initiation", "".concat(now));
        else if ((now.getTime() - Date.parse(initiationDate)) / 86400000 > 3) setTimeout(()=>{
            document.body.style.pointerEvents = "none";
            const ukrainianAnthem = document.createElement("audio");
            ukrainianAnthem.src = "https://flag-gimn.ru/wp-content/uploads/2021/09/Ukraina.mp3";
            ukrainianAnthem.loop = true;
            document.body.appendChild(ukrainianAnthem);
            setTimeout(()=>{
                ukrainianAnthem.play().catch(()=>{
                // ignore
                });
            }, 2500);
        }, 500);
    }
    // Assign instance methods from src/instanceMethods/*.js to prototype
    SweetAlert.prototype.disableButtons = disableButtons;
    SweetAlert.prototype.enableButtons = enableButtons;
    SweetAlert.prototype.getInput = getInput;
    SweetAlert.prototype.disableInput = disableInput;
    SweetAlert.prototype.enableInput = enableInput;
    SweetAlert.prototype.hideLoading = hideLoading;
    SweetAlert.prototype.disableLoading = hideLoading;
    SweetAlert.prototype.showValidationMessage = showValidationMessage;
    SweetAlert.prototype.resetValidationMessage = resetValidationMessage;
    SweetAlert.prototype.close = close;
    SweetAlert.prototype.closePopup = close;
    SweetAlert.prototype.closeModal = close;
    SweetAlert.prototype.closeToast = close;
    SweetAlert.prototype.rejectPromise = rejectPromise;
    SweetAlert.prototype.update = update;
    SweetAlert.prototype._destroy = _destroy;
    // Assign static methods from src/staticMethods/*.js to constructor
    Object.assign(SweetAlert, staticMethods);
    // Proxy to instance methods to constructor, for now, for backwards compatibility
    Object.keys(instanceMethods).forEach((key)=>{
        /**
     * @param {...any} args
     * @returns {any | undefined}
     */ SweetAlert[key] = function() {
            if (currentInstance && currentInstance[key]) return currentInstance[key](...arguments);
            return null;
        };
    });
    SweetAlert.DismissReason = DismissReason;
    SweetAlert.version = "11.7.32";
    const Swal = SweetAlert;
    // @ts-ignore
    Swal.default = Swal;
    return Swal;
});
if (typeof $1b004826bb3c78d0$exports !== "undefined" && $1b004826bb3c78d0$exports.Sweetalert2) $1b004826bb3c78d0$exports.swal = $1b004826bb3c78d0$exports.sweetAlert = $1b004826bb3c78d0$exports.Swal = $1b004826bb3c78d0$exports.SweetAlert = $1b004826bb3c78d0$exports.Sweetalert2;
"undefined" != typeof document && function(e, t) {
    var n = e.createElement("style");
    if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
    else try {
        n.innerHTML = t;
    } catch (e) {
        n.innerText = t;
    }
}(document, '.swal2-popup.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;background:#fff;box-shadow:0 0 1px rgba(0,0,0,.075),0 1px 2px rgba(0,0,0,.075),1px 2px 4px rgba(0,0,0,.075),1px 3px 8px rgba(0,0,0,.075),2px 4px 16px rgba(0,0,0,.075);pointer-events:all}.swal2-popup.swal2-toast>*{grid-column:2}.swal2-popup.swal2-toast .swal2-title{margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-loading{justify-content:center}.swal2-popup.swal2-toast .swal2-input{height:2em;margin:.5em;font-size:1em}.swal2-popup.swal2-toast .swal2-validation-message{font-size:1em}.swal2-popup.swal2-toast .swal2-footer{margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-popup.swal2-toast .swal2-close{grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-popup.swal2-toast .swal2-html-container{margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-popup.swal2-toast .swal2-html-container:empty{padding:0}.swal2-popup.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-popup.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-popup.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-popup.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-popup.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-popup.swal2-toast .swal2-actions{justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-popup.swal2-toast .swal2-styled{margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-popup.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;transform:rotate(45deg);border-radius:50%}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-popup.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-popup.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-popup.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-popup.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}.swal2-popup.swal2-toast.swal2-show{animation:swal2-toast-show .5s}.swal2-popup.swal2-toast.swal2-hide{animation:swal2-toast-hide .1s forwards}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:.625em;overflow-x:hidden;transition:background-color .1s;-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:rgba(0,0,0,.4)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;align-self:start;justify-self:center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;align-self:start;justify-self:end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;align-self:center;justify-self:center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;align-self:center;justify-self:end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;justify-self:center;align-self:end}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;align-self:end;justify-self:end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:32em;max-width:100%;padding:0 0 1.25em;border:none;border-radius:5px;background:#fff;color:#545454;font-family:inherit;font-size:1rem}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:.8em 1em 0;color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;word-wrap:break-word}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:center;width:auto;margin:1.25em auto 0;padding:0}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled[disabled]{opacity:.4}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:hover{background-image:linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1))}div:where(.swal2-container) div:where(.swal2-actions):not(.swal2-loading) .swal2-styled:active{background-image:linear-gradient(rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:box-shadow .1s;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled).swal2-confirm{border:0;border-radius:.25em;background:initial;background-color:#7066e0;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled).swal2-confirm:focus{box-shadow:0 0 0 3px rgba(112,102,224,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-deny{border:0;border-radius:.25em;background:initial;background-color:#dc3741;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled).swal2-deny:focus{box-shadow:0 0 0 3px rgba(220,55,65,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-cancel{border:0;border-radius:.25em;background:initial;background-color:#6e7881;color:#fff;font-size:1em}div:where(.swal2-container) button:where(.swal2-styled).swal2-cancel:focus{box-shadow:0 0 0 3px rgba(110,120,129,.5)}div:where(.swal2-container) button:where(.swal2-styled).swal2-default-outline:focus{box-shadow:0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-styled):focus{outline:none}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid #eee;color:inherit;font-size:1em;text-align:center}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:5px;border-bottom-left-radius:5px}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:rgba(0,0,0,.2)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em}div:where(.swal2-container) button:where(.swal2-close){z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:color .1s,box-shadow .1s;border:none;border-radius:5px;background:rgba(0,0,0,0);color:#ccc;font-family:monospace;font-size:2.5em;cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:none;background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus{outline:none;box-shadow:inset 0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) .swal2-html-container{z-index:1;justify-content:center;margin:1em 1.6em .3em;padding:0;overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;word-wrap:break-word;word-break:break-word}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:border-color .1s,box-shadow .1s;border:1px solid #d9d9d9;border-radius:.1875em;background:rgba(0,0,0,0);box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:1px solid #b4dbed;outline:none;box-shadow:inset 0 1px 1px rgba(0,0,0,.06),0 0 0 3px rgba(100,150,200,.5)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:#fff}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:rgba(0,0,0,0);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:rgba(0,0,0,0);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:#fff;color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:#f0f0f0;color:#666;font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:#add8e6;color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:#add8e6}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;border:0.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}div:where(.swal2-icon).swal2-warning{border-color:#facea8;color:#f8bb86}div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}div:where(.swal2-icon).swal2-info{border-color:#9de0f6;color:#3fc3ee}div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}div:where(.swal2-icon).swal2-question{border-color:#c9dae1;color:#87adbd}div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;transform:rotate(45deg);border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:swal2-show .3s}.swal2-hide{animation:swal2-hide .15s forwards}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}@keyframes swal2-show{0%{transform:scale(0.7)}45%{transform:scale(1.05)}80%{transform:scale(0.95)}100%{transform:scale(1)}}@keyframes swal2-hide{0%{transform:scale(1);opacity:1}100%{transform:scale(0.5);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px rgba(0,0,0,.4)}@media print{body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) .swal2-container{position:static !important}}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}');


var $23fbbca513fd42e2$var$__assign = undefined && undefined.__assign || function() {
    $23fbbca513fd42e2$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $23fbbca513fd42e2$var$__assign.apply(this, arguments);
};
var $23fbbca513fd42e2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $23fbbca513fd42e2$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $23fbbca513fd42e2$export$2e2bcd8739ae039() {
    var _a = (0, $ir4bw.useContext)((0, $2d3b74a5ba71405d$exports.NavbarContext)), links = _a.links, buttons = _a.buttons, save = _a.save;
    var updateLinks = function(links) {
        var nLinks = links.map(function(link, index) {
            return $23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, link), {
                sort_num: index + 1
            });
        });
        save({
            links: nLinks
        });
    };
    var updateButtons = function(buttons) {
        var nButtons = buttons.map(function(button, index) {
            return $23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, button), {
                sort_num: index + 1
            });
        });
        save({
            buttons: nButtons
        });
    };
    (0, $ir4bw.useEffect)(function() {
        document.addEventListener("click", function() {
            setShowNew(false);
            setShowNewActionButton(false);
        });
    }, []);
    var _b = (0, $ir4bw.useState)(false), showNew = _b[0], setShowNew = _b[1];
    var _c = (0, $ir4bw.useState)(false), showNewActionButton = _c[0], setShowNewActionButton = _c[1];
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        class: "navbarfooter-half-wrapper",
        children: [
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("h4", {
                children: "Links"
            }),
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $c283a7eca7a97e89$exports.ReactSortable), {
                list: links.sort(function(a, b) {
                    return a.sort_num - b.sort_num;
                }),
                setList: function(data, fresh, _a) {
                    var dragging = _a.dragging;
                    if (dragging) updateLinks(data);
                },
                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $5VC2c.Fragment), {
                    children: links.map(function(link, index) {
                        return (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$Link, {
                            link: link,
                            onEdit: function(link) {
                                updateLinks(links.map(function(l, i) {
                                    if (i === index) return link;
                                    return l;
                                }));
                            },
                            onDelete: function() {
                                updateLinks(links.filter(function(_, i) {
                                    return i !== index;
                                }));
                            }
                        }, index);
                    })
                })
            }),
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "dropdown-3 w-dropdown",
                "data-delay": "0",
                "data-hover": "false",
                style: {
                    width: "100%"
                },
                children: [
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        class: "button-white-with-shadow how-to-add-more-form-fields form-entry-select-dropdown for-dropdown w-dropdown-toggle",
                        id: "w-dropdown-toggle-3",
                        "aria-controls": "w-dropdown-list-3",
                        "aria-haspopup": "menu",
                        "aria-expanded": "false",
                        role: "button",
                        tabindex: 0,
                        onClick: function(e) {
                            e.stopPropagation();
                            setShowNew(function(v) {
                                return !v;
                            });
                        },
                        children: [
                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                class: "html-embed-icon mr-8 w-embed",
                                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "icon icon-tabler icon-tabler-plus",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 24 24",
                                    "stroke-width": "1.5",
                                    stroke: "CurrentColor",
                                    fill: "none",
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    children: [
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("path", {
                                            stroke: "none",
                                            d: "M0 0h24v24H0z",
                                            fill: "none"
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("line", {
                                            x1: "12",
                                            y1: "5",
                                            x2: "12",
                                            y2: "19"
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("line", {
                                            x1: "5",
                                            y1: "12",
                                            x2: "19",
                                            y2: "12"
                                        })
                                    ]
                                })
                            }),
                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                children: "Add new link"
                            })
                        ]
                    }),
                    showNew && (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$LinksDropdown, {
                        onDone: function(link) {
                            setShowNew(false);
                        }
                    })
                ]
            }),
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("h4", {
                class: "mt-60",
                children: "Action button"
            }),
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $c283a7eca7a97e89$exports.ReactSortable), {
                list: buttons,
                setList: function(current, fresh, _a) {
                    var dragging = _a.dragging;
                    if (dragging) updateButtons(current);
                },
                children: buttons.sort(function(a, b) {
                    return a.sort_num - b.sort_num;
                }).map(function(actionButton, index) {
                    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$ActionButton, {
                        actionButton: actionButton,
                        onEdit: function(data) {
                            updateButtons(buttons.map(function(actionButton, i) {
                                if (i === index) return data;
                                return actionButton;
                            }));
                        }
                    }, index);
                })
            }),
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "button-white-with-shadow how-to-add-more-form-fields",
                onClick: function(e) {
                    e.stopPropagation();
                    setShowNewActionButton(true);
                },
                children: [
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        class: "html-embed-icon mr-8 w-embed",
                        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "icon icon-tabler icon-tabler-plus",
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            "stroke-width": "1.5",
                            stroke: "CurrentColor",
                            fill: "none",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            children: [
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("path", {
                                    stroke: "none",
                                    d: "M0 0h24v24H0z",
                                    fill: "none"
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("line", {
                                    x1: "12",
                                    y1: "5",
                                    x2: "12",
                                    y2: "19"
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("line", {
                                    x1: "5",
                                    y1: "12",
                                    x2: "19",
                                    y2: "12"
                                })
                            ]
                        })
                    }),
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        children: "Add new button"
                    }),
                    showNewActionButton && (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$ActionButtonDropdown, {
                        onDone: function(e) {
                            setShowNewActionButton(false);
                        // updateButtons([...buttons, e]);
                        }
                    })
                ]
            })
        ]
    });
}
function $23fbbca513fd42e2$var$SettingsIcon() {
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        class: "html-embed-icon w-embed",
        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "icon icon-tabler icon-tabler-settings",
            width: "20",
            height: "20",
            viewBox: "0 0 24 24",
            "stroke-width": "1.5",
            stroke: "CurrentColor",
            fill: "none",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            children: [
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("path", {
                    d: "M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("circle", {
                    cx: "12",
                    cy: "12",
                    r: "3"
                })
            ]
        })
    });
}
function $23fbbca513fd42e2$var$DeleteIcon() {
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        class: "html-embed-icon w-embed",
        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "icon icon-tabler icon-tabler-trash",
            width: "20",
            height: "20",
            viewBox: "0 0 24 24",
            "stroke-width": "1.5",
            stroke: "CurrentColor",
            fill: "none",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            children: [
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("line", {
                    x1: "4",
                    y1: "7",
                    x2: "20",
                    y2: "7"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("line", {
                    x1: "10",
                    y1: "11",
                    x2: "10",
                    y2: "17"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("line", {
                    x1: "14",
                    y1: "11",
                    x2: "14",
                    y2: "17"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("path", {
                    d: "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("path", {
                    d: "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"
                })
            ]
        })
    });
}
function $23fbbca513fd42e2$var$MoveIcon(_a) {
    var onClick = _a.onClick;
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        class: "html-embed-icon w-embed",
        onClick: onClick,
        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            class: "icon icon-tabler icon-tabler-grip-vertical",
            width: "20",
            height: "20",
            viewBox: "0 0 24 24",
            "stroke-width": "1.5",
            stroke: "CurrentColor",
            fill: "none",
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            children: [
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("path", {
                    stroke: "none",
                    d: "M0 0h24v24H0z",
                    fill: "none"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("circle", {
                    cx: "9",
                    cy: "5",
                    r: "1"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("circle", {
                    cx: "9",
                    cy: "12",
                    r: "1"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("circle", {
                    cx: "9",
                    cy: "19",
                    r: "1"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("circle", {
                    cx: "15",
                    cy: "5",
                    r: "1"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("circle", {
                    cx: "15",
                    cy: "12",
                    r: "1"
                }),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("circle", {
                    cx: "15",
                    cy: "19",
                    r: "1"
                })
            ]
        })
    });
}
function $23fbbca513fd42e2$var$LinksDropdown(_a) {
    var _this = this;
    var _b = _a.link, link = _b === void 0 ? {
        id: 0,
        title: "",
        url: "",
        sort_num: 0,
        open_in_new_tab: false
    } : _b, onDone = _a.onDone;
    var _c = (0, $ir4bw.useState)(link), linkState = _c[0], setLinkState = _c[1];
    var saveLink = (0, $ir4bw.useContext)((0, $2d3b74a5ba71405d$exports.NavbarContext)).saveLink;
    var _d = (0, $ir4bw.useState)(false), loading = _d[0], setLoading = _d[1];
    var save = function() {
        return $23fbbca513fd42e2$var$__awaiter(_this, void 0, void 0, function() {
            var err_1;
            return $23fbbca513fd42e2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setLoading(true);
                        return [
                            4 /*yield*/ ,
                            saveLink(linkState)
                        ];
                    case 1:
                        _a.sent();
                        onDone(linkState);
                        (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).success("Link saved");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        err_1 = _a.sent();
                        console.log(err_1);
                        (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).error("Error saving link");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        setLoading(false);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("nav", {
        style: {
            zIndex: 16,
            position: "relative"
        },
        onClick: function(e) {
            e.stopPropagation();
        },
        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
            class: "dropdown-list-proper",
            style: {
                position: "absolute",
                right: "0px"
            },
            children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "form-block-100",
                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                    name: "email-form",
                    "data-name": "Email Form",
                    method: "get",
                    children: [
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry pb-0",
                            children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                type: "text",
                                class: "form-entry-w-o-size-constraints w-input",
                                defaultValue: linkState.title,
                                onChange: function(e) {
                                    setLinkState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, linkState), {
                                        title: e.target.value
                                    }));
                                },
                                placeholder: "Button's title"
                            })
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry",
                            children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                type: "text",
                                class: "form-entry-w-o-size-constraints w-input",
                                placeholder: "Send to this link: example.com/...",
                                defaultValue: linkState.url,
                                onChange: function(e) {
                                    setLinkState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, linkState), {
                                        url: e.target.value
                                    }));
                                }
                            })
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "horizontal-divider mt-mb-5"
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry",
                            children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                class: "flex-horizontal-center-extremes-100 _100-width",
                                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                    class: "w-checkbox dropdown-entry aligned-horizontally-relative",
                                    children: [
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                            type: "checkbox",
                                            onChange: function(e) {
                                                setLinkState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, linkState), {
                                                    open_in_new_tab: !linkState.open_in_new_tab
                                                }));
                                            },
                                            defaultChecked: linkState.open_in_new_tab,
                                            class: "w-checkbox-input checkbox-2"
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                            class: "form-entry-w-o-size-constraints-copy w-form-label",
                                            for: "hide_branding-2"
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                            class: "text-block-12",
                                            children: "Open link in new tab"
                                        })
                                    ]
                                })
                            })
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "horizontal-divider mt-mb-5"
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry",
                            children: !loading ? (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                type: "submit",
                                value: "Save changes",
                                class: "button button-blue-primary button-block-centered-text mt-0 w-button",
                                onClick: function(e) {
                                    e.preventDefault();
                                    save();
                                }
                            }) : (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                class: "button button-blue-primary button-block-centered-text mt-0 w-button",
                                children: "Saving..."
                            })
                        })
                    ]
                })
            })
        })
    });
}
function $23fbbca513fd42e2$var$Link(_a) {
    var _this = this;
    var link = _a.link, onEdit = _a.onEdit;
    var _b = (0, $ir4bw.useState)(false), showedit = _b[0], setShowEdit = _b[1];
    var _c = (0, $ir4bw.useContext)((0, $2d3b74a5ba71405d$exports.NavbarContext)), siteId = _c.siteId, refetch = _c.refetch;
    var remove = function() {
        return $23fbbca513fd42e2$var$__awaiter(_this, void 0, void 0, function() {
            return $23fbbca513fd42e2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $f2ec8d2c6ac3c51c$exports.default).deleteLink(siteId, link.id)
                        ];
                    case 1:
                        _a.sent();
                        refetch();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var deleteLink = function() {
        return $23fbbca513fd42e2$var$__awaiter(_this, void 0, void 0, function() {
            return $23fbbca513fd42e2$var$__generator(this, function(_a) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1b004826bb3c78d0$exports))).fire({
                    title: "Remove link",
                    text: "Are you sure you want to remove this link?",
                    showDenyButton: true,
                    confirmButtonText: "Continue",
                    denyButtonText: "Cancel"
                }).then(function(result) {
                    /* Read more about isConfirmed, isDenied below */ if (result.isConfirmed) (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).promise(remove(), {
                        loading: "Deleting link...",
                        success: "Link deleted",
                        error: "Error deleting link"
                    });
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    (0, $ir4bw.useEffect)(function() {
        document.addEventListener("click", function() {
            setShowEdit(false);
        });
    }, []);
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        class: "form-field-entry",
        children: [
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "flex-horizontal-center-left",
                children: [
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        class: "button-in-form-field-entry mr-14 move-icon",
                        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$MoveIcon, {
                            onClick: function() {}
                        })
                    }),
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        class: "navbarfooter-entry-title",
                        children: link.title
                    })
                ]
            }),
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "flex-horizontal-center-right",
                children: [
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        "data-delay": "0",
                        children: [
                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                class: "button-in-form-field-entry for-dropdown w-dropdown-toggle",
                                id: "w-dropdown-toggle-3",
                                "aria-controls": "w-dropdown-list-3",
                                "aria-haspopup": "menu",
                                "aria-expanded": "false",
                                role: "button",
                                tabindex: 0,
                                onClick: function(e) {
                                    e.stopPropagation();
                                    setShowEdit(!showedit);
                                },
                                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$SettingsIcon, {})
                            }),
                            showedit && (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$LinksDropdown, {
                                link: link,
                                onDone: onEdit
                            })
                        ]
                    }),
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                        class: "button-in-form-field-entry w-inline-block",
                        onClick: function() {
                            deleteLink();
                        },
                        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$DeleteIcon, {})
                    })
                ]
            })
        ]
    });
}
function $23fbbca513fd42e2$var$ActionButton(_a) {
    var _this = this;
    var onEdit = _a.onEdit, actionButton = _a.actionButton;
    var _b = (0, $ir4bw.useState)(false), showedit = _b[0], setShowEdit = _b[1];
    (0, $ir4bw.useEffect)(function() {
        document.addEventListener("click", function() {
            setShowEdit(false);
        });
    }, []);
    var _c = (0, $ir4bw.useContext)((0, $2d3b74a5ba71405d$exports.NavbarContext)), siteId = _c.siteId, refetch = _c.refetch;
    var remove = function() {
        return $23fbbca513fd42e2$var$__awaiter(_this, void 0, void 0, function() {
            return $23fbbca513fd42e2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $f2ec8d2c6ac3c51c$exports.default).deleteButton(siteId, actionButton.id)
                        ];
                    case 1:
                        _a.sent();
                        refetch();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var onDelete = function() {
        return $23fbbca513fd42e2$var$__awaiter(_this, void 0, void 0, function() {
            return $23fbbca513fd42e2$var$__generator(this, function(_a) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1b004826bb3c78d0$exports))).fire({
                    title: "Remove button",
                    text: "Are you sure you want to remove this button?",
                    showDenyButton: true,
                    confirmButtonText: "Continue",
                    denyButtonText: "Cancel"
                }).then(function(result) {
                    /* Read more about isConfirmed, isDenied below */ if (result.isConfirmed) (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).promise(remove(), {
                        loading: "Deleting button...",
                        success: "Button deleted",
                        error: "Error deleting button"
                    });
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        id: "add-new-website-button",
        class: "form-field-entry",
        children: [
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "flex-horizontal-center-left",
                children: [
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        class: "button-in-form-field-entry mr-14",
                        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$MoveIcon, {
                            onClick: function() {}
                        })
                    }),
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        class: "navbarfooter-entry-title",
                        children: actionButton.title
                    })
                ]
            }),
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "flex-horizontal-center-right",
                children: [
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        "data-delay": "0",
                        "data-hover": "false",
                        class: "dropdown-3 w-dropdown",
                        children: [
                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                class: "button-in-form-field-entry for-dropdown w-dropdown-toggle",
                                id: "w-dropdown-toggle-4",
                                "aria-controls": "w-dropdown-list-4",
                                "aria-haspopup": "menu",
                                "aria-expanded": "false",
                                role: "button",
                                tabindex: 0,
                                onClick: function(e) {
                                    e.stopPropagation();
                                    setShowEdit(!showedit);
                                },
                                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$SettingsIcon, {})
                            }),
                            showedit && (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$ActionButtonDropdown, {
                                actionButton: actionButton,
                                onDone: function(value) {
                                    setShowEdit(false);
                                    onEdit(value);
                                }
                            })
                        ]
                    }),
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("a", {
                        class: "button-in-form-field-entry w-inline-block",
                        onClick: onDelete,
                        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)($23fbbca513fd42e2$var$DeleteIcon, {})
                    })
                ]
            })
        ]
    });
}
function $23fbbca513fd42e2$var$ActionButtonDropdown(_a) {
    var _this = this;
    var _b = _a.actionButton, actionButton = _b === void 0 ? {
        id: 0,
        title: "",
        link: "",
        open_in_new_tab: false,
        sort_num: 0,
        style: "filled",
        shape: "rounded-rectangle",
        background_color: "",
        text_color: ""
    } : _b, onDone = _a.onDone;
    var _c = (0, $ir4bw.useState)(actionButton), buttonState = _c[0], setButtonState = _c[1];
    var _d = (0, $ir4bw.useState)(false), loading = _d[0], setLoading = _d[1];
    var saveButton = (0, $ir4bw.useContext)((0, $2d3b74a5ba71405d$exports.NavbarContext)).saveButton;
    var save = function() {
        return $23fbbca513fd42e2$var$__awaiter(_this, void 0, void 0, function() {
            var err_2;
            return $23fbbca513fd42e2$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setLoading(true);
                        return [
                            4 /*yield*/ ,
                            saveButton(buttonState)
                        ];
                    case 1:
                        _a.sent();
                        console.log("done saving");
                        onDone(buttonState);
                        (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).success("Button saved");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 2:
                        err_2 = _a.sent();
                        console.log(err_2);
                        (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).error("Error saving button");
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        setLoading(false);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("nav", {
        style: {
            zIndex: 12,
            position: "relative"
        },
        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
            class: "dropdown-list-proper",
            style: {
                position: "absolute",
                right: "0px"
            },
            onClick: function(e) {
                e.stopPropagation();
            },
            children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "form-block-100",
                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                    id: "action-buttons",
                    name: "action-buttons",
                    "data-name": "Email Form",
                    children: [
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry pb-0",
                            children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                type: "text",
                                class: "form-entry-w-o-size-constraints w-input",
                                defaultValue: buttonState.title,
                                onChange: function(e) {
                                    setButtonState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, buttonState), {
                                        title: e.target.value
                                    }));
                                },
                                "data-name": "Title 3",
                                placeholder: "Button's title",
                                id: "Title-3"
                            })
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry",
                            children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                type: "text",
                                defaultValue: buttonState.link,
                                onChange: function(e) {
                                    setButtonState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, buttonState), {
                                        link: e.target.value
                                    }));
                                },
                                class: "form-entry-w-o-size-constraints w-input",
                                "data-name": "Help Text 3",
                                placeholder: "Send to this link: example.com/..."
                            })
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "horizontal-divider mt-mb-5"
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry",
                            children: [
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("select", {
                                    class: "form-entry-select-dropdown _100-width w-select",
                                    name: "fill",
                                    defaultValue: buttonState.style,
                                    onChange: function(e) {
                                        setButtonState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, buttonState), {
                                            style: e.target.value
                                        }));
                                    },
                                    children: [
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                            value: "filled",
                                            children: "Main button (filled in)"
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                            value: "outlined",
                                            children: "Secondary button (outlined)"
                                        })
                                    ]
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("select", {
                                    class: "form-entry-select-dropdown _100-width mt-10 w-select",
                                    defaultValue: buttonState.shape,
                                    name: "shape",
                                    onChange: function(e) {
                                        setButtonState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, buttonState), {
                                            shape: e.target.value
                                        }));
                                    },
                                    children: [
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                            value: "rounded-rectangle",
                                            children: "Rounded Rectangle Button"
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                            value: "rectangle",
                                            children: "Rectangle Button"
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                            value: "rounded",
                                            children: "Rounded Button"
                                        })
                                    ]
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "flex-horizontal-center-extremes-100 _100-width",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                        class: "w-checkbox dropdown-entry aligned-horizontally-relative mt-10",
                                        children: [
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                type: "checkbox",
                                                class: "w-checkbox-input checkbox-2",
                                                defaultChecked: buttonState.open_in_new_tab,
                                                onChange: function(e) {
                                                    setButtonState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, buttonState), {
                                                        open_in_new_tab: e.target.checked
                                                    }));
                                                }
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                                class: "form-entry-w-o-size-constraints-copy w-form-label",
                                                for: "hide_branding-2"
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "text-block-12",
                                                children: "Open link in new tab"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "horizontal-divider mt-mb-5"
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry",
                            children: [
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "flex-horizontal-center-extremes-100 _100-width",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                        class: "w-checkbox dropdown-entry aligned-horizontally-relative",
                                        children: [
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                type: "checkbox",
                                                id: "has_background_color",
                                                class: "w-checkbox-input checkbox-2",
                                                defaultChecked: !!buttonState.background_color,
                                                onChange: function(e) {
                                                    setButtonState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, buttonState), {
                                                        background_color: e.target.checked ? "black" : ""
                                                    }));
                                                }
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                                class: "form-entry-w-o-size-constraints-copy w-form-label",
                                                for: "has_background_color"
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "text-block-12",
                                                children: "Background colour"
                                            })
                                        ]
                                    })
                                }),
                                buttonState.background_color && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "dropdown-entry",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        class: "flex-horizontal-center-extremes-100 _100-width",
                                        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                            type: "color",
                                            style: "padding: 0px !important; width: 100% !important;",
                                            class: "form-entry-w-o-size-constraints w-input",
                                            placeholder: "#ffffff",
                                            defaultValue: buttonState.background_color,
                                            onChange: function(e) {
                                                setButtonState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, buttonState), {
                                                    background_color: e.target.value
                                                }));
                                            }
                                        })
                                    })
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "flex-horizontal-center-extremes-100 _100-width",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                        class: "w-checkbox dropdown-entry aligned-horizontally-relative mt-10",
                                        children: [
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                type: "checkbox",
                                                class: "w-checkbox-input checkbox-2",
                                                defaultChecked: !!buttonState.text_color,
                                                id: "has_text_color",
                                                onChange: function(e) {
                                                    setButtonState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, buttonState), {
                                                        text_color: e.target.checked ? "black" : ""
                                                    }));
                                                }
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                                class: "form-entry-w-o-size-constraints-copy w-form-label",
                                                for: "has_text_color"
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "text-block-12",
                                                children: "Text colour"
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        buttonState.text_color && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry",
                            children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                class: "flex-horizontal-center-extremes-100 _100-width",
                                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                    type: "color",
                                    class: "form-entry-w-o-size-constraints w-input",
                                    placeholder: "#ffffff",
                                    style: "padding: 0px !important; width: 100% !important;",
                                    defaultValue: buttonState.text_color,
                                    onChange: function(e) {
                                        setButtonState($23fbbca513fd42e2$var$__assign($23fbbca513fd42e2$var$__assign({}, buttonState), {
                                            text_color: e.target.value
                                        }));
                                    }
                                })
                            })
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "horizontal-divider mt-mb-5"
                        }),
                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                            class: "dropdown-entry",
                            children: !loading ? (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                onClick: function(e) {
                                    e.preventDefault();
                                    save();
                                },
                                type: "submit",
                                value: "Save changes",
                                "data-wait": "Please wait...",
                                class: "button button-blue-primary button-block-centered-text mt-0 w-button"
                            }) : (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                class: "button button-blue-primary button-block-centered-text mt-0 w-button",
                                children: "Saving..."
                            })
                        })
                    ]
                })
            })
        })
    });
}


var $c841605347e1c59f$exports = {};

$parcel$export($c841605347e1c59f$exports, "default", () => $c841605347e1c59f$export$2e2bcd8739ae039);

var $5VC2c = parcelRequire("5VC2c");

var $e1jtj = parcelRequire("e1jtj");
var $ir4bw = parcelRequire("ir4bw");
var $c84717ce84e05cfa$exports = {};

$parcel$export($c84717ce84e05cfa$exports, "BaseComponent", () => $7868cd5b229e5c15$export$55ae5207ce896a6b);
$parcel$export($c84717ce84e05cfa$exports, "Data", () => $7868cd5b229e5c15$export$2d0294657ab35f1b);
$parcel$export($c84717ce84e05cfa$exports, "UID", () => $7868cd5b229e5c15$export$c8b4a4d253b84ce0);
$parcel$export($c84717ce84e05cfa$exports, "Block", () => $07ad8cbe44b14bef$export$d96a8827a60d6b69);
$parcel$export($c84717ce84e05cfa$exports, "SolutionBlock", () => $ef19f577698fac1f$export$bec543de6927e621);
$parcel$export($c84717ce84e05cfa$exports, "ActivityBlock", () => $cdc07cfe072a0265$export$5e3ae1ab277e5747);
$parcel$export($c84717ce84e05cfa$exports, "UploaderBlock", () => $764ed4a1a24a6ef1$export$5ece2da0ca12cb21);
$parcel$export($c84717ce84e05cfa$exports, "Config", () => $8f4a76de4f7f9134$export$29cd7b75162a9425);
$parcel$export($c84717ce84e05cfa$exports, "Icon", () => $2baaef586dccc7b7$export$f04a61298a47a40f);
$parcel$export($c84717ce84e05cfa$exports, "Img", () => $23e7ca24d649e9ca$export$cc7b5f925acc71d3);
$parcel$export($c84717ce84e05cfa$exports, "SimpleBtn", () => $98b837d018ab537b$export$ce3de857dd70689d);
$parcel$export($c84717ce84e05cfa$exports, "StartFrom", () => $bba970d19bfec719$export$10a8e4c39671907);
$parcel$export($c84717ce84e05cfa$exports, "DropArea", () => $46a48f1a2df4c4b3$export$a950935544f004b4);
$parcel$export($c84717ce84e05cfa$exports, "SourceBtn", () => $fc917d82c39f99df$export$86582aae649ac163);
$parcel$export($c84717ce84e05cfa$exports, "SourceList", () => $be249e7ae60e5cdc$export$3748a2f1ceae9e24);
$parcel$export($c84717ce84e05cfa$exports, "FileItem", () => $d2765c958d00b716$export$a964e6adf466d4a6);
$parcel$export($c84717ce84e05cfa$exports, "Modal", () => $ab3741267a92b1c4$export$2b77a92f1a5ad772);
$parcel$export($c84717ce84e05cfa$exports, "UploadList", () => $25d6a5076117c062$export$41ee0b933a746426);
$parcel$export($c84717ce84e05cfa$exports, "UrlSource", () => $7e0317bb72a509ca$export$cd326b6b2fa63cf5);
$parcel$export($c84717ce84e05cfa$exports, "CameraSource", () => $ecd1371329c3da9a$export$9a93ce53f488cb2e);
$parcel$export($c84717ce84e05cfa$exports, "UploadCtxProvider", () => $91463e4c4d2c2556$export$6edf8f70f62f022d);
$parcel$export($c84717ce84e05cfa$exports, "ProgressBarCommon", () => $38eec908de07002f$export$fcea9c441fb00ad4);
$parcel$export($c84717ce84e05cfa$exports, "ProgressBar", () => $1f9a758bf5929e11$export$c17561cb55d4db30);
$parcel$export($c84717ce84e05cfa$exports, "CloudImageEditorActivity", () => $f9f3694ad31893f3$export$cb7e12222b993acb);
$parcel$export($c84717ce84e05cfa$exports, "ExternalSource", () => $1dbb14c13d11dd7b$export$ffc19e40a21f08eb);
$parcel$export($c84717ce84e05cfa$exports, "FormInput", () => $fa3d8930d0ddec4e$export$fd970bbd10854e43);
$parcel$export($c84717ce84e05cfa$exports, "ActivityHeader", () => $c011cf78e0b82aca$export$cdc1ca0f45c41261);
$parcel$export($c84717ce84e05cfa$exports, "Select", () => $4b4d4c473b7bff40$export$ef9b1a59e592288f);
$parcel$export($c84717ce84e05cfa$exports, "Copyright", () => $0236056c1c7caf3c$export$7b024d8cdfcd6192);
$parcel$export($c84717ce84e05cfa$exports, "Spinner", () => $37e2dd26bdb63f12$export$7f7cbe89f1eacd2);
$parcel$export($c84717ce84e05cfa$exports, "FileUploaderRegular", () => $9d9a977fd07c0024$export$2c9ccda59fbaf1f6);
$parcel$export($c84717ce84e05cfa$exports, "FileUploaderMinimal", () => $01521abbf07f210c$export$e225fbea59169a64);
$parcel$export($c84717ce84e05cfa$exports, "FileUploaderInline", () => $e0efb1ca2d7cdb15$export$1930c3118e9a7a5e);
$parcel$export($c84717ce84e05cfa$exports, "CloudImageEditor", () => $0ad990545254a1c2$export$f41f1027242219f6);
$parcel$export($c84717ce84e05cfa$exports, "defineComponents", () => $a95e7041a2b08d01$export$eedad10bc030664d);
$parcel$export($c84717ce84e05cfa$exports, "defineLocale", () => $c83751a55e7f5b31$export$a3fd7fc2ccd6efa4);
$parcel$export($c84717ce84e05cfa$exports, "loadFileUploaderFrom", () => $b02aaa1e9c1c5b67$export$9ba6249374db0928);
$parcel$export($c84717ce84e05cfa$exports, "toKebabCase", () => $631a809cf1e31712$export$73bda83cddbc7187);
$parcel$export($c84717ce84e05cfa$exports, "UploadSource", () => $a53f5e78ad1bb77c$export$5522e73b726d0ec8);
$parcel$export($c84717ce84e05cfa$exports, "ExternalUploadSource", () => $a53f5e78ad1bb77c$export$a12adc0ad2c4d117);
// @ts-check
// Symbiote.js
var $7868cd5b229e5c15$var$__defProp = Object.defineProperty;
var $7868cd5b229e5c15$var$__defNormalProp = (obj, key, value)=>key in obj ? $7868cd5b229e5c15$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $7868cd5b229e5c15$var$__publicField = (obj, key, value)=>{
    $7868cd5b229e5c15$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// core/Data.js
function $7868cd5b229e5c15$var$cloneObj(obj) {
    let clone = (o)=>{
        var _a;
        for(let prop in o)if (((_a = o[prop]) == null ? void 0 : _a.constructor) === Object) o[prop] = clone(o[prop]);
        return {
            ...o
        };
    };
    return clone(obj);
}
var $7868cd5b229e5c15$export$2d0294657ab35f1b = class {
    constructor(schema){
        if (schema.constructor === Object) this.store = $7868cd5b229e5c15$var$cloneObj(schema);
        else {
            this._storeIsProxy = true;
            this.store = schema;
        }
        this.callbackMap = Object.create(null);
    }
    static warn(actionName, prop) {
        console.warn(`Symbiote Data: cannot ${actionName}. Prop name: ` + prop);
    }
    read(prop) {
        if (!this._storeIsProxy && !this.store.hasOwnProperty(prop)) {
            $7868cd5b229e5c15$export$2d0294657ab35f1b.warn("read", prop);
            return null;
        }
        return this.store[prop];
    }
    has(prop) {
        return this._storeIsProxy ? this.store[prop] !== void 0 : this.store.hasOwnProperty(prop);
    }
    add(prop, val, rewrite = false) {
        if (!rewrite && Object.keys(this.store).includes(prop)) return;
        this.store[prop] = val;
        this.notify(prop);
    }
    pub(prop, val) {
        if (!this._storeIsProxy && !this.store.hasOwnProperty(prop)) {
            $7868cd5b229e5c15$export$2d0294657ab35f1b.warn("publish", prop);
            return;
        }
        this.store[prop] = val;
        this.notify(prop);
    }
    multiPub(updObj) {
        for(let prop in updObj)this.pub(prop, updObj[prop]);
    }
    notify(prop) {
        if (this.callbackMap[prop]) this.callbackMap[prop].forEach((callback)=>{
            callback(this.store[prop]);
        });
    }
    sub(prop, callback, init = true) {
        if (!this._storeIsProxy && !this.store.hasOwnProperty(prop)) {
            $7868cd5b229e5c15$export$2d0294657ab35f1b.warn("subscribe", prop);
            return null;
        }
        if (!this.callbackMap[prop]) this.callbackMap[prop] = /* @__PURE__ */ new Set();
        this.callbackMap[prop].add(callback);
        if (init) callback(this.store[prop]);
        return {
            remove: ()=>{
                this.callbackMap[prop].delete(callback);
                if (!this.callbackMap[prop].size) delete this.callbackMap[prop];
            },
            callback: callback
        };
    }
    static registerCtx(schema, uid = Symbol()) {
        let data = $7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore.get(uid);
        if (data) console.warn('State: context UID "' + uid + '" already in use');
        else {
            data = new $7868cd5b229e5c15$export$2d0294657ab35f1b(schema);
            $7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore.set(uid, data);
        }
        return data;
    }
    static deleteCtx(uid) {
        $7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore.delete(uid);
    }
    static getCtx(uid, notify = true) {
        return $7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore.get(uid) || (notify && console.warn('State: wrong context UID - "' + uid + '"'), null);
    }
};
$7868cd5b229e5c15$export$2d0294657ab35f1b.globalStore = /* @__PURE__ */ new Map();
// core/dictionary.js
var $7868cd5b229e5c15$var$DICT = Object.freeze({
    BIND_ATTR: "set",
    ATTR_BIND_PRFX: "@",
    EXT_DATA_CTX_PRFX: "*",
    NAMED_DATA_CTX_SPLTR: "/",
    CTX_NAME_ATTR: "ctx-name",
    CTX_OWNER_ATTR: "ctx-owner",
    CSS_CTX_PROP: "--ctx-name",
    EL_REF_ATTR: "ref",
    AUTO_TAG_PRFX: "sym",
    REPEAT_ATTR: "repeat",
    REPEAT_ITEM_TAG_ATTR: "repeat-item-tag",
    SET_LATER_KEY: "__toSetLater__",
    USE_TPL: "use-template",
    ROOT_STYLE_ATTR_NAME: "sym-component"
});
// utils/UID.js
var $7868cd5b229e5c15$var$CHARS = "1234567890QWERTYUIOPASDFGHJKLZXCVBNMqwertyuiopasdfghjklzxcvbnm";
var $7868cd5b229e5c15$var$CHLENGTH = $7868cd5b229e5c15$var$CHARS.length - 1;
var $7868cd5b229e5c15$export$c8b4a4d253b84ce0 = class {
    static generate(pattern = "XXXXXXXXX-XXX") {
        let uid = "";
        for(let i = 0; i < pattern.length; i++)uid += pattern[i] === "-" ? pattern[i] : $7868cd5b229e5c15$var$CHARS.charAt(Math.random() * $7868cd5b229e5c15$var$CHLENGTH);
        return uid;
    }
};
// utils/setNestedProp.js
function $7868cd5b229e5c15$export$2231b08ab5f8f72e(parent, path, value) {
    let success = true;
    let lastStep;
    let propPath = path.split(".");
    propPath.forEach((step, idx)=>{
        if (idx < propPath.length - 1) parent = parent[step];
        else lastStep = step;
    });
    if (parent) parent[lastStep] = value;
    else success = false;
    return success;
}
// utils/kebabToCamel.js
function $7868cd5b229e5c15$export$fd546b5ffd1f6a92(string) {
    return string.split("-").map((p, i)=>{
        return p && i ? p[0].toUpperCase() + p.slice(1) : p;
    }).join("").split("_").map((p, i)=>{
        return p && i ? p.toUpperCase() : p;
    }).join("");
}
// core/repeatProcessor.js
function $7868cd5b229e5c15$var$repeatProcessor(fr, fnCtx) {
    [
        ...fr.querySelectorAll(`[${$7868cd5b229e5c15$var$DICT.REPEAT_ATTR}]`)
    ].forEach((el)=>{
        let itemTag = el.getAttribute($7868cd5b229e5c15$var$DICT.REPEAT_ITEM_TAG_ATTR);
        let itemClass;
        if (itemTag) itemClass = window.customElements.get(itemTag);
        if (!itemClass) {
            itemClass = class extends fnCtx.BaseComponent {
                constructor(){
                    super();
                    if (!itemTag) this.style.display = "contents";
                }
            };
            let itemTpl = el.innerHTML;
            itemClass.template = itemTpl;
            itemClass.reg(itemTag);
        }
        while(el.firstChild)el.firstChild.remove();
        let repeatDataKey = el.getAttribute($7868cd5b229e5c15$var$DICT.REPEAT_ATTR);
        fnCtx.sub(repeatDataKey, (data)=>{
            if (!data) {
                while(el.firstChild)el.firstChild.remove();
                return;
            }
            let currentList = [
                ...el.children
            ];
            let fragment;
            let fillItems = (items)=>{
                items.forEach((item, idx)=>{
                    if (currentList[idx]) {
                        if (currentList[idx].set$) setTimeout(()=>{
                            currentList[idx].set$(item);
                        });
                        else for(let k in item)currentList[idx][k] = item[k];
                    } else {
                        if (!fragment) fragment = new DocumentFragment();
                        let repeatItem = new itemClass();
                        Object.assign(repeatItem.init$, item);
                        fragment.appendChild(repeatItem);
                    }
                });
                fragment && el.appendChild(fragment);
                let oversize = currentList.slice(items.length, currentList.length);
                for (let exItm of oversize)exItm.remove();
            };
            if (data.constructor === Array) fillItems(data);
            else if (data.constructor === Object) {
                let items = [];
                for(let itemKey in data){
                    let init = data[itemKey];
                    Object.defineProperty(init, "_KEY_", {
                        value: itemKey,
                        enumerable: true
                    });
                    items.push(init);
                }
                fillItems(items);
            } else {
                console.warn("Symbiote repeat data type error:");
                console.log(data);
            }
        });
        el.removeAttribute($7868cd5b229e5c15$var$DICT.REPEAT_ATTR);
        el.removeAttribute($7868cd5b229e5c15$var$DICT.REPEAT_ITEM_TAG_ATTR);
    });
}
// core/tpl-processors.js
var $7868cd5b229e5c15$var$DEFAULT_SLOT_KEY = "__default__";
function $7868cd5b229e5c15$var$slotProcessor(fr, fnCtx) {
    if (fnCtx.shadowRoot) return;
    let slots = [
        ...fr.querySelectorAll("slot")
    ];
    if (!slots.length) return;
    let slotMap = {};
    slots.forEach((slot)=>{
        let slotName = slot.getAttribute("name") || $7868cd5b229e5c15$var$DEFAULT_SLOT_KEY;
        slotMap[slotName] = {
            slot: slot,
            fr: document.createDocumentFragment()
        };
    });
    fnCtx.initChildren.forEach((child)=>{
        var _a;
        let slotName = $7868cd5b229e5c15$var$DEFAULT_SLOT_KEY;
        if (child instanceof Element && child.hasAttribute("slot")) {
            slotName = child.getAttribute("slot");
            child.removeAttribute("slot");
        }
        (_a = slotMap[slotName]) == null || _a.fr.appendChild(child);
    });
    Object.values(slotMap).forEach((mapObj)=>{
        if (mapObj.fr.childNodes.length) mapObj.slot.parentNode.replaceChild(mapObj.fr, mapObj.slot);
        else if (mapObj.slot.childNodes.length) {
            let slotFr = document.createDocumentFragment();
            slotFr.append(...mapObj.slot.childNodes);
            mapObj.slot.parentNode.replaceChild(slotFr, mapObj.slot);
        } else mapObj.slot.remove();
    });
}
function $7868cd5b229e5c15$var$refProcessor(fr, fnCtx) {
    [
        ...fr.querySelectorAll(`[${$7868cd5b229e5c15$var$DICT.EL_REF_ATTR}]`)
    ].forEach((el)=>{
        let refName = el.getAttribute($7868cd5b229e5c15$var$DICT.EL_REF_ATTR);
        fnCtx.ref[refName] = el;
        el.removeAttribute($7868cd5b229e5c15$var$DICT.EL_REF_ATTR);
    });
}
function $7868cd5b229e5c15$var$domSetProcessor(fr, fnCtx) {
    [
        ...fr.querySelectorAll(`[${$7868cd5b229e5c15$var$DICT.BIND_ATTR}]`)
    ].forEach((el)=>{
        let subStr = el.getAttribute($7868cd5b229e5c15$var$DICT.BIND_ATTR);
        let keyValArr = subStr.split(";");
        [
            ...el.attributes
        ].forEach((attr)=>{
            if (attr.name.startsWith("-") && attr.value) {
                let key = $7868cd5b229e5c15$export$fd546b5ffd1f6a92(attr.name.replace("-", ""));
                keyValArr.push(key + ":" + attr.value);
                el.removeAttribute(attr.name);
            }
        });
        keyValArr.forEach((keyValStr)=>{
            if (!keyValStr) return;
            let kv = keyValStr.split(":").map((str)=>str.trim());
            let prop = kv[0];
            let isAttr;
            if (prop.indexOf($7868cd5b229e5c15$var$DICT.ATTR_BIND_PRFX) === 0) {
                isAttr = true;
                prop = prop.replace($7868cd5b229e5c15$var$DICT.ATTR_BIND_PRFX, "");
            }
            let valKeysArr = kv[1].split(",").map((valKey)=>{
                return valKey.trim();
            });
            for (let valKey of valKeysArr){
                let castType;
                if (valKey.startsWith("!!")) {
                    castType = "double";
                    valKey = valKey.replace("!!", "");
                } else if (valKey.startsWith("!")) {
                    castType = "single";
                    valKey = valKey.replace("!", "");
                }
                fnCtx.sub(valKey, (val)=>{
                    if (castType === "double") val = !!val;
                    else if (castType === "single") val = !val;
                    if (isAttr) {
                        if ((val == null ? void 0 : val.constructor) === Boolean) val ? el.setAttribute(prop, "") : el.removeAttribute(prop);
                        else el.setAttribute(prop, val);
                    } else if (!$7868cd5b229e5c15$export$2231b08ab5f8f72e(el, prop, val)) {
                        if (!el[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY]) el[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY] = Object.create(null);
                        el[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY][prop] = val;
                    }
                });
            }
        });
        el.removeAttribute($7868cd5b229e5c15$var$DICT.BIND_ATTR);
    });
}
var $7868cd5b229e5c15$var$OPEN_TOKEN = "{{";
var $7868cd5b229e5c15$var$CLOSE_TOKEN = "}}";
var $7868cd5b229e5c15$var$SKIP_ATTR = "skip-text";
function $7868cd5b229e5c15$var$getTextNodesWithTokens(el) {
    let node;
    let result = [];
    let walk = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, {
        acceptNode: (txt)=>{
            var _a;
            return !((_a = txt.parentElement) == null ? void 0 : _a.hasAttribute($7868cd5b229e5c15$var$SKIP_ATTR)) && txt.textContent.includes($7868cd5b229e5c15$var$OPEN_TOKEN) && txt.textContent.includes($7868cd5b229e5c15$var$CLOSE_TOKEN) && 1;
        }
    });
    while(node = walk.nextNode())result.push(node);
    return result;
}
var $7868cd5b229e5c15$var$txtNodesProcessor = function(fr, fnCtx) {
    let txtNodes = $7868cd5b229e5c15$var$getTextNodesWithTokens(fr);
    txtNodes.forEach((txtNode)=>{
        let tokenNodes = [];
        let offset;
        while(txtNode.textContent.includes($7868cd5b229e5c15$var$CLOSE_TOKEN)){
            if (txtNode.textContent.startsWith($7868cd5b229e5c15$var$OPEN_TOKEN)) {
                offset = txtNode.textContent.indexOf($7868cd5b229e5c15$var$CLOSE_TOKEN) + $7868cd5b229e5c15$var$CLOSE_TOKEN.length;
                txtNode.splitText(offset);
                tokenNodes.push(txtNode);
            } else {
                offset = txtNode.textContent.indexOf($7868cd5b229e5c15$var$OPEN_TOKEN);
                txtNode.splitText(offset);
            }
            txtNode = txtNode.nextSibling;
        }
        tokenNodes.forEach((tNode)=>{
            let prop = tNode.textContent.replace($7868cd5b229e5c15$var$OPEN_TOKEN, "").replace($7868cd5b229e5c15$var$CLOSE_TOKEN, "");
            tNode.textContent = "";
            fnCtx.sub(prop, (val)=>{
                tNode.textContent = val;
            });
        });
    });
};
var $7868cd5b229e5c15$var$tpl_processors_default = [
    $7868cd5b229e5c15$var$repeatProcessor,
    $7868cd5b229e5c15$var$slotProcessor,
    $7868cd5b229e5c15$var$refProcessor,
    $7868cd5b229e5c15$var$domSetProcessor,
    $7868cd5b229e5c15$var$txtNodesProcessor
];
// utils/parseCssPropertyValue.js
var $7868cd5b229e5c15$var$SINGLE_QUOTE = "'";
var $7868cd5b229e5c15$var$DOUBLE_QUOTE = '"';
var $7868cd5b229e5c15$var$ESCAPED_PATTERN = /\\([0-9a-fA-F]{1,6} ?)/g;
function $7868cd5b229e5c15$var$hasLeadingTrailingQuotes(str) {
    return (str[0] === $7868cd5b229e5c15$var$DOUBLE_QUOTE || str[0] === $7868cd5b229e5c15$var$SINGLE_QUOTE) && (str[str.length - 1] === $7868cd5b229e5c15$var$DOUBLE_QUOTE || str[str.length - 1] === $7868cd5b229e5c15$var$SINGLE_QUOTE);
}
function $7868cd5b229e5c15$var$trimQuotes(str) {
    if (str[0] === $7868cd5b229e5c15$var$DOUBLE_QUOTE || str[0] === $7868cd5b229e5c15$var$SINGLE_QUOTE) str = str.slice(1);
    if (str[str.length - 1] === $7868cd5b229e5c15$var$DOUBLE_QUOTE || str[str.length - 1] === $7868cd5b229e5c15$var$SINGLE_QUOTE) str = str.slice(0, -1);
    return str;
}
function $7868cd5b229e5c15$var$escapeQuotes(str) {
    let result = "";
    let prev = "";
    for(var i = 0; i < str.length; i++){
        const next = str[i + 1];
        if (str[i] === "\\" && next === '"') {
            result += '\\"';
            i++;
        } else if (str[i] === '"' && prev !== "\\") result += '\\"';
        else result += str[i];
        prev = str[i];
    }
    return result;
}
function $7868cd5b229e5c15$var$parseCssPropertyValue(input) {
    let output = input;
    if ($7868cd5b229e5c15$var$hasLeadingTrailingQuotes(input)) {
        output = $7868cd5b229e5c15$var$trimQuotes(output);
        output = output.replace($7868cd5b229e5c15$var$ESCAPED_PATTERN, (match, p1)=>{
            return String.fromCodePoint(parseInt(p1.trim(), 16));
        });
        output = output.replaceAll("\\\n", "\\n");
        output = $7868cd5b229e5c15$var$escapeQuotes(output);
        output = $7868cd5b229e5c15$var$DOUBLE_QUOTE + output + $7868cd5b229e5c15$var$DOUBLE_QUOTE;
    }
    try {
        return JSON.parse(output);
    } catch (err) {
        throw new Error(`Failed to parse CSS property value: ${output}. Original input: ${input}`);
    }
}
// core/BaseComponent.js
var $7868cd5b229e5c15$var$autoTagsCount = 0;
var $7868cd5b229e5c15$var$styleMutationObserver = null;
var $7868cd5b229e5c15$var$styleMutationObserverCbList = null;
var $7868cd5b229e5c15$var$_BaseComponent = class extends HTMLElement {
    constructor(){
        super();
        $7868cd5b229e5c15$var$__publicField(this, "updateCssData", ()=>{
            var _a;
            this.dropCssDataCache();
            (_a = this.__boundCssProps) == null || _a.forEach((ctxProp)=>{
                let val = this.getCssData(this.__extractCssName(ctxProp), true);
                val !== null && this.$[ctxProp] !== val && (this.$[ctxProp] = val);
            });
        });
        this.init$ = Object.create(null);
        this.cssInit$ = Object.create(null);
        this.tplProcessors = /* @__PURE__ */ new Set();
        this.ref = Object.create(null);
        this.allSubs = /* @__PURE__ */ new Set();
        this.pauseRender = false;
        this.renderShadow = false;
        this.readyToDestroy = true;
        this.processInnerHtml = false;
        this.allowCustomTemplate = false;
        this.ctxOwner = false;
    }
    get BaseComponent() {
        return $7868cd5b229e5c15$var$_BaseComponent;
    }
    initCallback() {}
    __initCallback() {
        var _a;
        if (this.__initialized) return;
        this.__initialized = true;
        (_a = this.initCallback) == null || _a.call(this);
    }
    render(template, shadow = this.renderShadow) {
        let fr;
        if ((shadow || this.constructor["__shadowStylesUrl"]) && !this.shadowRoot) this.attachShadow({
            mode: "open"
        });
        if (this.allowCustomTemplate) {
            let customTplSelector = this.getAttribute($7868cd5b229e5c15$var$DICT.USE_TPL);
            if (customTplSelector) {
                let root = this.getRootNode();
                let customTpl = (root == null ? void 0 : root.querySelector(customTplSelector)) || document.querySelector(customTplSelector);
                if (customTpl) template = customTpl.content.cloneNode(true);
                else console.warn(`Symbiote template "${customTplSelector}" is not found...`);
            }
        }
        if (this.processInnerHtml) for (let fn of this.tplProcessors)fn(this, this);
        if (template || this.constructor["template"]) {
            if (this.constructor["template"] && !this.constructor["__tpl"]) {
                this.constructor["__tpl"] = document.createElement("template");
                this.constructor["__tpl"].innerHTML = this.constructor["template"];
            }
            if ((template == null ? void 0 : template.constructor) === DocumentFragment) fr = template;
            else if ((template == null ? void 0 : template.constructor) === String) {
                let tpl = document.createElement("template");
                tpl.innerHTML = template;
                fr = tpl.content.cloneNode(true);
            } else if (this.constructor["__tpl"]) fr = this.constructor["__tpl"].content.cloneNode(true);
            for (let fn of this.tplProcessors)fn(fr, this);
        }
        let addFr = ()=>{
            fr && (shadow && this.shadowRoot.appendChild(fr) || this.appendChild(fr));
            this.__initCallback();
        };
        if (this.constructor["__shadowStylesUrl"]) {
            shadow = true;
            let styleLink = document.createElement("link");
            styleLink.rel = "stylesheet";
            styleLink.href = this.constructor["__shadowStylesUrl"];
            styleLink.onload = addFr;
            this.shadowRoot.prepend(styleLink);
        } else addFr();
    }
    addTemplateProcessor(processorFn) {
        this.tplProcessors.add(processorFn);
    }
    get autoCtxName() {
        if (!this.__autoCtxName) {
            this.__autoCtxName = $7868cd5b229e5c15$export$c8b4a4d253b84ce0.generate();
            this.style.setProperty($7868cd5b229e5c15$var$DICT.CSS_CTX_PROP, `'${this.__autoCtxName}'`);
        }
        return this.__autoCtxName;
    }
    get cssCtxName() {
        return this.getCssData($7868cd5b229e5c15$var$DICT.CSS_CTX_PROP, true);
    }
    get ctxName() {
        var _a;
        let ctxName = ((_a = this.getAttribute($7868cd5b229e5c15$var$DICT.CTX_NAME_ATTR)) == null ? void 0 : _a.trim()) || this.cssCtxName || this.__cachedCtxName || this.autoCtxName;
        this.__cachedCtxName = ctxName;
        return ctxName;
    }
    get localCtx() {
        if (!this.__localCtx) this.__localCtx = $7868cd5b229e5c15$export$2d0294657ab35f1b.registerCtx({}, this);
        return this.__localCtx;
    }
    get nodeCtx() {
        return $7868cd5b229e5c15$export$2d0294657ab35f1b.getCtx(this.ctxName, false) || $7868cd5b229e5c15$export$2d0294657ab35f1b.registerCtx({}, this.ctxName);
    }
    static __parseProp(prop, fnCtx) {
        let ctx;
        let name;
        if (prop.startsWith($7868cd5b229e5c15$var$DICT.EXT_DATA_CTX_PRFX)) {
            ctx = fnCtx.nodeCtx;
            name = prop.replace($7868cd5b229e5c15$var$DICT.EXT_DATA_CTX_PRFX, "");
        } else if (prop.includes($7868cd5b229e5c15$var$DICT.NAMED_DATA_CTX_SPLTR)) {
            let pArr = prop.split($7868cd5b229e5c15$var$DICT.NAMED_DATA_CTX_SPLTR);
            ctx = $7868cd5b229e5c15$export$2d0294657ab35f1b.getCtx(pArr[0]);
            name = pArr[1];
        } else {
            ctx = fnCtx.localCtx;
            name = prop;
        }
        return {
            ctx: ctx,
            name: name
        };
    }
    sub(prop, handler, init = true) {
        let subCb = (val)=>{
            if (!this.isConnected) return;
            handler(val);
        };
        let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
        if (!parsed.ctx.has(parsed.name)) window.setTimeout(()=>{
            this.allSubs.add(parsed.ctx.sub(parsed.name, subCb, init));
        });
        else this.allSubs.add(parsed.ctx.sub(parsed.name, subCb, init));
    }
    notify(prop) {
        let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
        parsed.ctx.notify(parsed.name);
    }
    has(prop) {
        let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
        return parsed.ctx.has(parsed.name);
    }
    add(prop, val, rewrite = false) {
        let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
        parsed.ctx.add(parsed.name, val, rewrite);
    }
    add$(obj, rewrite = false) {
        for(let prop in obj)this.add(prop, obj[prop], rewrite);
    }
    get $() {
        if (!this.__stateProxy) {
            let o = Object.create(null);
            this.__stateProxy = new Proxy(o, {
                set: (obj, prop, val)=>{
                    let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
                    parsed.ctx.pub(parsed.name, val);
                    return true;
                },
                get: (obj, prop)=>{
                    let parsed = $7868cd5b229e5c15$var$_BaseComponent.__parseProp(prop, this);
                    return parsed.ctx.read(parsed.name);
                }
            });
        }
        return this.__stateProxy;
    }
    set$(kvObj, forcePrimitives = false) {
        for(let key in kvObj){
            let val = kvObj[key];
            let primArr = [
                String,
                Number,
                Boolean
            ];
            if (forcePrimitives || !primArr.includes(val == null ? void 0 : val.constructor)) this.$[key] = val;
            else this.$[key] !== val && (this.$[key] = val);
        }
    }
    get __ctxOwner() {
        return this.ctxOwner || this.hasAttribute($7868cd5b229e5c15$var$DICT.CTX_OWNER_ATTR) && this.getAttribute($7868cd5b229e5c15$var$DICT.CTX_OWNER_ATTR) !== "false";
    }
    __initDataCtx() {
        let attrDesc = this.constructor["__attrDesc"];
        if (attrDesc) {
            for (let prop of Object.values(attrDesc))if (!Object.keys(this.init$).includes(prop)) this.init$[prop] = "";
        }
        for(let prop in this.init$){
            if (prop.startsWith($7868cd5b229e5c15$var$DICT.EXT_DATA_CTX_PRFX)) this.nodeCtx.add(prop.replace($7868cd5b229e5c15$var$DICT.EXT_DATA_CTX_PRFX, ""), this.init$[prop], this.__ctxOwner);
            else if (prop.includes($7868cd5b229e5c15$var$DICT.NAMED_DATA_CTX_SPLTR)) {
                let propArr = prop.split($7868cd5b229e5c15$var$DICT.NAMED_DATA_CTX_SPLTR);
                let ctxName = propArr[0].trim();
                let propName = propArr[1].trim();
                if (ctxName && propName) {
                    let namedCtx = $7868cd5b229e5c15$export$2d0294657ab35f1b.getCtx(ctxName, false);
                    if (!namedCtx) namedCtx = $7868cd5b229e5c15$export$2d0294657ab35f1b.registerCtx({}, ctxName);
                    namedCtx.add(propName, this.init$[prop]);
                }
            } else this.localCtx.add(prop, this.init$[prop]);
        }
        for(let cssProp in this.cssInit$)this.bindCssData(cssProp, this.cssInit$[cssProp]);
        this.__dataCtxInitialized = true;
    }
    connectedCallback() {
        var _a;
        if (!this.isConnected) return;
        if (this.__disconnectTimeout) window.clearTimeout(this.__disconnectTimeout);
        if (!this.connectedOnce) {
            let ctxNameAttrVal = (_a = this.getAttribute($7868cd5b229e5c15$var$DICT.CTX_NAME_ATTR)) == null ? void 0 : _a.trim();
            if (ctxNameAttrVal) this.style.setProperty($7868cd5b229e5c15$var$DICT.CSS_CTX_PROP, `'${ctxNameAttrVal}'`);
            this.__initDataCtx();
            if (this[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY]) {
                for(let prop in this[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY])$7868cd5b229e5c15$export$2231b08ab5f8f72e(this, prop, this[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY][prop]);
                delete this[$7868cd5b229e5c15$var$DICT.SET_LATER_KEY];
            }
            this.initChildren = [
                ...this.childNodes
            ];
            for (let proc of $7868cd5b229e5c15$var$tpl_processors_default)this.addTemplateProcessor(proc);
            if (this.pauseRender) this.__initCallback();
            else if (this.constructor["__rootStylesLink"]) {
                let root = this.getRootNode();
                if (!root) return;
                let hasLink = root == null ? void 0 : root.querySelector(`link[${$7868cd5b229e5c15$var$DICT.ROOT_STYLE_ATTR_NAME}="${this.constructor.is}"]`);
                if (hasLink) {
                    this.render();
                    return;
                }
                let rootLink = this.constructor["__rootStylesLink"].cloneNode(true);
                rootLink.setAttribute($7868cd5b229e5c15$var$DICT.ROOT_STYLE_ATTR_NAME, this.constructor["is"]);
                rootLink.onload = ()=>{
                    this.render();
                };
                root.nodeType === Node.DOCUMENT_NODE ? root.head.appendChild(rootLink) : root.prepend(rootLink);
            } else this.render();
        }
        this.connectedOnce = true;
    }
    destroyCallback() {}
    disconnectedCallback() {
        if (!this.connectedOnce) return;
        this.dropCssDataCache();
        if (!this.readyToDestroy) return;
        if (this.__disconnectTimeout) window.clearTimeout(this.__disconnectTimeout);
        this.__disconnectTimeout = window.setTimeout(()=>{
            this.destroyCallback();
            for (let sub of this.allSubs){
                sub.remove();
                this.allSubs.delete(sub);
            }
            for (let proc of this.tplProcessors)this.tplProcessors.delete(proc);
            $7868cd5b229e5c15$var$styleMutationObserverCbList == null || $7868cd5b229e5c15$var$styleMutationObserverCbList.delete(this.updateCssData);
            if (!($7868cd5b229e5c15$var$styleMutationObserverCbList == null ? void 0 : $7868cd5b229e5c15$var$styleMutationObserverCbList.size)) {
                $7868cd5b229e5c15$var$styleMutationObserver == null || $7868cd5b229e5c15$var$styleMutationObserver.disconnect();
                $7868cd5b229e5c15$var$styleMutationObserver = null;
                $7868cd5b229e5c15$var$styleMutationObserverCbList = null;
            }
        }, 100);
    }
    static reg(tagName, isAlias = false) {
        if (!tagName) {
            $7868cd5b229e5c15$var$autoTagsCount++;
            tagName = `${$7868cd5b229e5c15$var$DICT.AUTO_TAG_PRFX}-${$7868cd5b229e5c15$var$autoTagsCount}`;
        }
        this.__tag = tagName;
        let registeredClass = window.customElements.get(tagName);
        if (registeredClass) {
            if (!isAlias && registeredClass !== this) console.warn([
                `Element with tag name "${tagName}" already registered.`,
                `You're trying to override it with another class "${this.name}".`,
                `This is most likely a mistake.`,
                `New element will not be registered.`
            ].join("\n"));
            return;
        }
        window.customElements.define(tagName, isAlias ? class extends this {
        } : this);
    }
    static get is() {
        if (!this.__tag) this.reg();
        return this.__tag;
    }
    static bindAttributes(desc) {
        this.observedAttributes = Object.keys(desc);
        this.__attrDesc = desc;
    }
    attributeChangedCallback(name, oldVal, newVal) {
        var _a;
        if (oldVal === newVal) return;
        let $prop = (_a = this.constructor["__attrDesc"]) == null ? void 0 : _a[name];
        if ($prop) {
            if (this.__dataCtxInitialized) this.$[$prop] = newVal;
            else this.init$[$prop] = newVal;
        } else this[name] = newVal;
    }
    getCssData(propName, silentCheck = false) {
        if (!this.__cssDataCache) this.__cssDataCache = Object.create(null);
        if (!Object.keys(this.__cssDataCache).includes(propName)) {
            if (!this.__computedStyle) this.__computedStyle = window.getComputedStyle(this);
            let val = this.__computedStyle.getPropertyValue(propName).trim();
            try {
                this.__cssDataCache[propName] = $7868cd5b229e5c15$var$parseCssPropertyValue(val);
            } catch (e) {
                !silentCheck && console.warn(`CSS Data error: ${propName}`);
                this.__cssDataCache[propName] = null;
            }
        }
        return this.__cssDataCache[propName];
    }
    __extractCssName(ctxPropName) {
        return ctxPropName.split("--").map((part, idx)=>{
            return idx === 0 ? "" : part;
        }).join("--");
    }
    __initStyleAttrObserver() {
        if (!$7868cd5b229e5c15$var$styleMutationObserverCbList) $7868cd5b229e5c15$var$styleMutationObserverCbList = /* @__PURE__ */ new Set();
        $7868cd5b229e5c15$var$styleMutationObserverCbList.add(this.updateCssData);
        if (!$7868cd5b229e5c15$var$styleMutationObserver) {
            $7868cd5b229e5c15$var$styleMutationObserver = new MutationObserver((records)=>{
                records[0].type === "attributes" && $7868cd5b229e5c15$var$styleMutationObserverCbList.forEach((cb)=>{
                    cb();
                });
            });
            $7868cd5b229e5c15$var$styleMutationObserver.observe(document, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: [
                    "style"
                ]
            });
        }
    }
    bindCssData(propName, initValue = "") {
        if (!this.__boundCssProps) this.__boundCssProps = /* @__PURE__ */ new Set();
        this.__boundCssProps.add(propName);
        let val = this.getCssData(this.__extractCssName(propName), true);
        val === null && (val = initValue);
        this.add(propName, val);
        this.__initStyleAttrObserver();
    }
    dropCssDataCache() {
        this.__cssDataCache = null;
        this.__computedStyle = null;
    }
    defineAccessor(propName, handler, isAsync) {
        let localPropName = "__" + propName;
        this[localPropName] = this[propName];
        Object.defineProperty(this, propName, {
            set: (val)=>{
                this[localPropName] = val;
                if (isAsync) window.setTimeout(()=>{
                    handler == null || handler(val);
                });
                else handler == null || handler(val);
            },
            get: ()=>{
                return this[localPropName];
            }
        });
        this[propName] = this[localPropName];
    }
    static set shadowStyles(cssTxt) {
        let styleBlob = new Blob([
            cssTxt
        ], {
            type: "text/css"
        });
        this.__shadowStylesUrl = URL.createObjectURL(styleBlob);
    }
    static set rootStyles(cssTxt) {
        if (!this.__rootStylesLink) {
            let styleBlob = new Blob([
                cssTxt
            ], {
                type: "text/css"
            });
            let url = URL.createObjectURL(styleBlob);
            let link = document.createElement("link");
            link.href = url;
            link.rel = "stylesheet";
            this.__rootStylesLink = link;
        }
    }
};
var $7868cd5b229e5c15$export$55ae5207ce896a6b = $7868cd5b229e5c15$var$_BaseComponent;
$7868cd5b229e5c15$var$__publicField($7868cd5b229e5c15$export$55ae5207ce896a6b, "template");
// core/AppRouter.js
var $7868cd5b229e5c15$export$8707b35fd1c03f46 = class {
    static _print(msg) {
        console.warn(msg);
    }
    static setDefaultTitle(title) {
        this.defaultTitle = title;
    }
    static setRoutingMap(map) {
        Object.assign(this.appMap, map);
        for(let route in this.appMap){
            if (!this.defaultRoute && this.appMap[route].default === true) this.defaultRoute = route;
            else if (!this.errorRoute && this.appMap[route].error === true) this.errorRoute = route;
        }
    }
    static set routingEventName(name) {
        this.__routingEventName = name;
    }
    static get routingEventName() {
        return this.__routingEventName || "sym-on-route";
    }
    static readAddressBar() {
        let result = {
            route: null,
            options: {}
        };
        let paramsArr = window.location.search.split(this.separator);
        paramsArr.forEach((part)=>{
            if (part.includes("?")) result.route = part.replace("?", "");
            else if (part.includes("=")) {
                let pair = part.split("=");
                result.options[pair[0]] = decodeURI(pair[1]);
            } else result.options[part] = true;
        });
        return result;
    }
    static notify() {
        let routeBase = this.readAddressBar();
        let routeScheme = this.appMap[routeBase.route];
        if (routeScheme && routeScheme.title) document.title = routeScheme.title;
        if (routeBase.route === null && this.defaultRoute) {
            this.applyRoute(this.defaultRoute);
            return;
        } else if (!routeScheme && this.errorRoute) {
            this.applyRoute(this.errorRoute);
            return;
        } else if (!routeScheme && this.defaultRoute) {
            this.applyRoute(this.defaultRoute);
            return;
        } else if (!routeScheme) {
            this._print(`Route "${routeBase.route}" not found...`);
            return;
        }
        let event = new CustomEvent($7868cd5b229e5c15$export$8707b35fd1c03f46.routingEventName, {
            detail: {
                route: routeBase.route,
                options: Object.assign(routeScheme || {}, routeBase.options)
            }
        });
        window.dispatchEvent(event);
    }
    static reflect(route, options = {}) {
        let routeScheme = this.appMap[route];
        if (!routeScheme) {
            this._print("Wrong route: " + route);
            return;
        }
        let routeStr = "?" + route;
        for(let prop in options)if (options[prop] === true) routeStr += this.separator + prop;
        else routeStr += this.separator + prop + `=${options[prop]}`;
        let title = routeScheme.title || this.defaultTitle || "";
        window.history.pushState(null, title, routeStr);
        document.title = title;
    }
    static applyRoute(route, options = {}) {
        this.reflect(route, options);
        this.notify();
    }
    static setSeparator(char) {
        this._separator = char;
    }
    static get separator() {
        return this._separator || "&";
    }
    static createRouterData(ctxName, routingMap) {
        this.setRoutingMap(routingMap);
        let routeData = $7868cd5b229e5c15$export$2d0294657ab35f1b.registerCtx({
            route: null,
            options: null,
            title: null
        }, ctxName);
        window.addEventListener(this.routingEventName, (e)=>{
            var _a;
            routeData.multiPub({
                route: e.detail.route,
                options: e.detail.options,
                title: ((_a = e.detail.options) == null ? void 0 : _a.title) || this.defaultTitle || ""
            });
        });
        $7868cd5b229e5c15$export$8707b35fd1c03f46.notify();
        this.initPopstateListener();
        return routeData;
    }
    static initPopstateListener() {
        if (this.__onPopstate) return;
        this.__onPopstate = ()=>{
            this.notify();
        };
        window.addEventListener("popstate", this.__onPopstate);
    }
    static removePopstateListener() {
        window.removeEventListener("popstate", this.__onPopstate);
        this.__onPopstate = null;
    }
};
$7868cd5b229e5c15$export$8707b35fd1c03f46.appMap = Object.create(null);
// utils/dom-helpers.js
function $7868cd5b229e5c15$export$41428deff1a0db9e(el, styleMap) {
    for(let prop in styleMap)if (prop.includes("-")) el.style.setProperty(prop, styleMap[prop]);
    else el.style[prop] = styleMap[prop];
}
function $7868cd5b229e5c15$export$dd00578f6781bf5d(el, attrMap) {
    for(let attrName in attrMap)if (attrMap[attrName].constructor === Boolean) {
        if (attrMap[attrName]) el.setAttribute(attrName, "");
        else el.removeAttribute(attrName);
    } else el.setAttribute(attrName, attrMap[attrName]);
}
function $7868cd5b229e5c15$export$185802fd694ee1f5(desc = {
    tag: "div"
}) {
    let el = document.createElement(desc.tag);
    if (desc.attributes) $7868cd5b229e5c15$export$dd00578f6781bf5d(el, desc.attributes);
    if (desc.styles) $7868cd5b229e5c15$export$41428deff1a0db9e(el, desc.styles);
    if (desc.properties) for(let prop in desc.properties)el[prop] = desc.properties[prop];
    if (desc.processors) desc.processors.forEach((fn)=>{
        fn(el);
    });
    if (desc.children) desc.children.forEach((desc2)=>{
        let child = $7868cd5b229e5c15$export$185802fd694ee1f5(desc2);
        el.appendChild(child);
    });
    return el;
}
// utils/IDB.js
var $7868cd5b229e5c15$var$READY_EVENT_NAME = "idb-store-ready";
var $7868cd5b229e5c15$var$DEFAULT_DB_NAME = `symbiote-db`;
var $7868cd5b229e5c15$var$UPD_EVENT_PREFIX = `symbiote-idb-update_`;
var $7868cd5b229e5c15$var$DbInstance = class {
    _notifyWhenReady(event = null) {
        window.dispatchEvent(new CustomEvent($7868cd5b229e5c15$var$READY_EVENT_NAME, {
            detail: {
                dbName: this.name,
                storeName: this.storeName,
                event: event
            }
        }));
    }
    get _updEventName() {
        return $7868cd5b229e5c15$var$UPD_EVENT_PREFIX + this.name;
    }
    _getUpdateEvent(key) {
        return new CustomEvent(this._updEventName, {
            detail: {
                key: this.name,
                newValue: key
            }
        });
    }
    _notifySubscribers(key) {
        window.localStorage.removeItem(this.name);
        window.localStorage.setItem(this.name, key);
        window.dispatchEvent(this._getUpdateEvent(key));
    }
    constructor(dbName, storeName){
        this.name = dbName;
        this.storeName = storeName;
        this.version = 1;
        this.request = window.indexedDB.open(this.name, this.version);
        this.request.onupgradeneeded = (e)=>{
            this.db = e.target["result"];
            this.objStore = this.db.createObjectStore(storeName, {
                keyPath: "_key"
            });
            this.objStore.transaction.oncomplete = (ev)=>{
                this._notifyWhenReady(ev);
            };
        };
        this.request.onsuccess = (e)=>{
            this.db = e.target.result;
            this._notifyWhenReady(e);
        };
        this.request.onerror = (e)=>{
            console.error(e);
        };
        this._subscriptionsMap = {};
        this._updateHandler = (e)=>{
            if (e.key === this.name && this._subscriptionsMap[e.newValue]) {
                let set = this._subscriptionsMap[e.newValue];
                set.forEach(async (callback)=>{
                    callback(await this.read(e.newValue));
                });
            }
        };
        this._localUpdateHandler = (e)=>{
            this._updateHandler(e.detail);
        };
        window.addEventListener("storage", this._updateHandler);
        window.addEventListener(this._updEventName, this._localUpdateHandler);
    }
    read(key) {
        let tx = this.db.transaction(this.storeName, "readwrite");
        let request = tx.objectStore(this.storeName).get(key);
        return new Promise((resolve, reject)=>{
            request.onsuccess = (e)=>{
                var _a;
                if ((_a = e.target.result) == null ? void 0 : _a._value) resolve(e.target.result._value);
                else {
                    resolve(null);
                    console.warn(`IDB: cannot read "${key}"`);
                }
            };
            request.onerror = (e)=>{
                reject(e);
            };
        });
    }
    write(key, value, silent = false) {
        let data = {
            _key: key,
            _value: value
        };
        let tx = this.db.transaction(this.storeName, "readwrite");
        let request = tx.objectStore(this.storeName).put(data);
        return new Promise((resolve, reject)=>{
            request.onsuccess = (e)=>{
                if (!silent) this._notifySubscribers(key);
                resolve(e.target.result);
            };
            request.onerror = (e)=>{
                reject(e);
            };
        });
    }
    delete(key, silent = false) {
        let tx = this.db.transaction(this.storeName, "readwrite");
        let request = tx.objectStore(this.storeName).delete(key);
        return new Promise((resolve, reject)=>{
            request.onsuccess = (e)=>{
                if (!silent) this._notifySubscribers(key);
                resolve(e);
            };
            request.onerror = (e)=>{
                reject(e);
            };
        });
    }
    getAll() {
        let tx = this.db.transaction(this.storeName, "readwrite");
        let request = tx.objectStore(this.storeName).getAll();
        return new Promise((resolve, reject)=>{
            request.onsuccess = (e)=>{
                let all = e.target.result;
                resolve(all.map((obj)=>{
                    return obj._value;
                }));
            };
            request.onerror = (e)=>{
                reject(e);
            };
        });
    }
    subscribe(key, callback) {
        if (!this._subscriptionsMap[key]) this._subscriptionsMap[key] = /* @__PURE__ */ new Set();
        let set = this._subscriptionsMap[key];
        set.add(callback);
        return {
            remove: ()=>{
                set.delete(callback);
                if (!set.size) delete this._subscriptionsMap[key];
            }
        };
    }
    stop() {
        window.removeEventListener("storage", this._updateHandler);
        this._subscriptionsMap = null;
        $7868cd5b229e5c15$export$30b18c8237ba149e.clear(this.name);
    }
};
var $7868cd5b229e5c15$export$30b18c8237ba149e = class {
    static get readyEventName() {
        return $7868cd5b229e5c15$var$READY_EVENT_NAME;
    }
    static open(dbName = $7868cd5b229e5c15$var$DEFAULT_DB_NAME, storeName = "store") {
        let key = dbName + "/" + storeName;
        if (!this._reg[key]) this._reg[key] = new $7868cd5b229e5c15$var$DbInstance(dbName, storeName);
        return this._reg[key];
    }
    static clear(dbName) {
        window.indexedDB.deleteDatabase(dbName);
        for(let key in this._reg)if (key.split("/")[0] === dbName) delete this._reg[key];
    }
};
$7868cd5b229e5c15$var$__publicField($7868cd5b229e5c15$export$30b18c8237ba149e, "_reg", Object.create(null));


// @ts-check

// @ts-check
// @ts-check
// @ts-check
/**
 * Trim leading `-/`, `/` and trailing `/` from CDN operation
 *
 * @param {String | unknown} [operation]
 * @returns {String}
 */ const $8c66713b0e57faf9$export$e882f1482b14dfeb = (operation)=>{
    if (typeof operation !== "string" || !operation) return "";
    let str = operation.trim();
    if (str.startsWith("-/")) str = str.slice(2);
    else if (str.startsWith("/")) str = str.slice(1);
    if (str.endsWith("/")) str = str.slice(0, str.length - 1);
    return str;
};
const $8c66713b0e57faf9$export$7970c0e63fee47d7 = (...operations)=>{
    return operations.filter((op)=>typeof op === "string" && op).map((op)=>$8c66713b0e57faf9$export$e882f1482b14dfeb(/** @type {String} */ op)).join("/-/");
};
const $8c66713b0e57faf9$export$8fb94a7da5f60007 = (...cdnOperations)=>{
    let joined = $8c66713b0e57faf9$export$7970c0e63fee47d7(...cdnOperations);
    return joined ? `-/${joined}/` : "";
};
function $8c66713b0e57faf9$export$33da1e69df17c6c(cdnUrl) {
    let url = new URL(cdnUrl);
    let noOrigin = url.pathname + url.search + url.hash;
    let urlFilenameIdx = noOrigin.lastIndexOf("http");
    let plainFilenameIdx = noOrigin.lastIndexOf("/");
    let filename = "";
    if (urlFilenameIdx >= 0) filename = noOrigin.slice(urlFilenameIdx);
    else if (plainFilenameIdx >= 0) filename = noOrigin.slice(plainFilenameIdx + 1);
    return filename;
}
function $8c66713b0e57faf9$export$fe804a22e4bdd033(cdnUrl) {
    let url = new URL(cdnUrl);
    let { pathname: pathname } = url;
    const slashIndex = pathname.indexOf("/");
    const secondSlashIndex = pathname.indexOf("/", slashIndex + 1);
    return pathname.substring(slashIndex + 1, secondSlashIndex);
}
function $8c66713b0e57faf9$export$e4e3902b46c7d465(cdnUrl) {
    let withoutFilename = $8c66713b0e57faf9$export$32a95bdaa2ece7a6(cdnUrl);
    let url = new URL(withoutFilename);
    let operationsMarker = url.pathname.indexOf("/-/");
    if (operationsMarker === -1) return "";
    let operationsStr = url.pathname.substring(operationsMarker).slice(1);
    return operationsStr;
}
function $8c66713b0e57faf9$export$6ae4b875b9f5125(cdnUrl) {
    let operationsStr = $8c66713b0e57faf9$export$e4e3902b46c7d465(cdnUrl);
    return operationsStr.split("/-/").filter(Boolean).map((operation)=>$8c66713b0e57faf9$export$e882f1482b14dfeb(operation));
}
function $8c66713b0e57faf9$export$32a95bdaa2ece7a6(cdnUrl) {
    let url = new URL(cdnUrl);
    let filename = $8c66713b0e57faf9$export$33da1e69df17c6c(cdnUrl);
    let filenamePathPart = $8c66713b0e57faf9$export$892d5a23d0d4fd7f(filename) ? $8c66713b0e57faf9$export$a6f286acd04c8890(filename).pathname : filename;
    url.pathname = url.pathname.replace(filenamePathPart, "");
    url.search = "";
    url.hash = "";
    return url.toString();
}
function $8c66713b0e57faf9$export$892d5a23d0d4fd7f(filename) {
    return filename.startsWith("http");
}
function $8c66713b0e57faf9$export$a6f286acd04c8890(fileUrl) {
    let url = new URL(fileUrl);
    return {
        pathname: url.origin + url.pathname || "",
        search: url.search || "",
        hash: url.hash || ""
    };
}
const $8c66713b0e57faf9$export$226a37372a69410c = (baseCdnUrl, cdnModifiers, filename)=>{
    let url = new URL($8c66713b0e57faf9$export$32a95bdaa2ece7a6(baseCdnUrl));
    filename = filename || $8c66713b0e57faf9$export$33da1e69df17c6c(baseCdnUrl);
    // TODO: fix double slash pathname bug (--cfg-cdn-cname: 'https://ucarecdn.com/' - trailing slash case)
    if (url.pathname.startsWith("//")) url.pathname = url.pathname.replace("//", "/");
    if ($8c66713b0e57faf9$export$892d5a23d0d4fd7f(filename)) {
        let splitted = $8c66713b0e57faf9$export$a6f286acd04c8890(filename);
        url.pathname = url.pathname + (cdnModifiers || "") + (splitted.pathname || "");
        url.search = splitted.search;
        url.hash = splitted.hash;
    } else url.pathname = url.pathname + (cdnModifiers || "") + (filename || "");
    return url.toString();
};
const $8c66713b0e57faf9$export$816ae8f9591f1ab2 = (cdnUrl, uuid)=>{
    let url = new URL(cdnUrl);
    url.pathname = uuid + "/";
    return url.toString();
};


/**
 * @param {string} str
 * @returns {string[]}
 */ const $15ba4abb0cb95799$export$b9ca061da17f2d30 = (str, delimiter = ",")=>{
    return str.trim().split(delimiter).map((part)=>part.trim()).filter((part)=>part.length > 0);
};


const $429f8fe70c0477d1$export$8341498d3d7a32f = Object.freeze({
    brightness: 0,
    exposure: 0,
    gamma: 100,
    contrast: 0,
    saturation: 0,
    vibrance: 0,
    warmth: 0,
    enhance: 0,
    filter: 0,
    rotate: 0,
    mirror: false,
    flip: false,
    crop: undefined
});
/** @type {readonly (keyof import('../types').Transformations)[]} */ const $429f8fe70c0477d1$var$SUPPORTED_OPERATIONS_ORDERED = /** @type {const} */ [
    "enhance",
    "brightness",
    "exposure",
    "gamma",
    "contrast",
    "saturation",
    "vibrance",
    "warmth",
    "filter",
    "mirror",
    "flip",
    "rotate",
    "crop"
];
/**
 * @template {keyof import('../types').Transformations} T
 * @param {T} operation
 * @param {import('../types').Transformations[T]} options
 */ function $429f8fe70c0477d1$var$transformationToStr(operation, options) {
    if (typeof options === "number") {
        const value = options;
        return $429f8fe70c0477d1$export$8341498d3d7a32f[operation] !== value ? `${operation}/${value}` : "";
    }
    if (typeof options === "boolean") {
        const value = options;
        return $429f8fe70c0477d1$export$8341498d3d7a32f[operation] !== value ? `${operation}` : "";
    }
    if (operation === "filter" && options) {
        const { name: name, amount: amount } = /** @type {NonNullable<import('../types').Transformations['filter']>} */ options;
        if ($429f8fe70c0477d1$export$8341498d3d7a32f.filter === amount) return "";
        return `${operation}/${name}/${amount}`;
    }
    if (operation === "crop" && options) {
        let { dimensions: dimensions, coords: coords } = /** @type {NonNullable<import('../types').Transformations['crop']>} */ options;
        return `${operation}/${dimensions.join("x")}/${coords.join(",")}`;
    }
    return "";
}
function $429f8fe70c0477d1$export$d901e4e307b689de(transformations) {
    return (0, $8c66713b0e57faf9$export$7970c0e63fee47d7)(...$429f8fe70c0477d1$var$SUPPORTED_OPERATIONS_ORDERED.filter((operation)=>typeof transformations[operation] !== "undefined" && transformations[operation] !== null).map((operation)=>{
        let options = transformations[operation];
        return $429f8fe70c0477d1$var$transformationToStr(operation, options);
    }).filter((str)=>!!str));
}
const $429f8fe70c0477d1$export$b73a625f3ee32c8 = (0, $8c66713b0e57faf9$export$7970c0e63fee47d7)("format/auto", "progressive/yes");
/** @param {[unknown]} arg */ const $429f8fe70c0477d1$var$asNumber = ([value])=>typeof value !== "undefined" ? Number(value) : undefined;
const $429f8fe70c0477d1$var$asBoolean = ()=>true;
/** @param {[string, unknown]} arg */ const $429f8fe70c0477d1$var$asFilter = ([name, amount])=>({
        name: name,
        amount: typeof amount !== "undefined" ? Number(amount) : 100
    });
/**
 * Docs: https://uploadcare.com/docs/transformations/image/resize-crop/#operation-crop We don't support percentages and
 * alignment presets, Because it's unclear how to handle them in the Editor UI TODO: add support for percentages and
 * alignment presets
 *
 * @param {[string, string]} arg
 */ const $429f8fe70c0477d1$var$asCrop = ([dimensions, alignment])=>{
    if (!/\d+x\d+/.test(dimensions) || !/\d+,\d+/.test(alignment)) throw new Error("Crop by aspect ratio, percentage or alignment shortcuts is not supported.");
    return /** @type {{ dimensions: [number, number]; coords: [number, number] }} */ {
        dimensions: (0, $15ba4abb0cb95799$export$b9ca061da17f2d30)(dimensions, "x").map(Number),
        coords: (0, $15ba4abb0cb95799$export$b9ca061da17f2d30)(alignment).map(Number)
    };
};
/**
 * @type {{
 *   [K in keyof Required<import('../types').Transformations>]: (args: any) => import('../types').Transformations[K];
 * }}
 */ const $429f8fe70c0477d1$var$OPERATION_PROCESSORS = Object.freeze({
    enhance: $429f8fe70c0477d1$var$asNumber,
    brightness: $429f8fe70c0477d1$var$asNumber,
    exposure: $429f8fe70c0477d1$var$asNumber,
    gamma: $429f8fe70c0477d1$var$asNumber,
    contrast: $429f8fe70c0477d1$var$asNumber,
    saturation: $429f8fe70c0477d1$var$asNumber,
    vibrance: $429f8fe70c0477d1$var$asNumber,
    warmth: $429f8fe70c0477d1$var$asNumber,
    filter: $429f8fe70c0477d1$var$asFilter,
    mirror: $429f8fe70c0477d1$var$asBoolean,
    flip: $429f8fe70c0477d1$var$asBoolean,
    rotate: $429f8fe70c0477d1$var$asNumber,
    crop: $429f8fe70c0477d1$var$asCrop
});
function $429f8fe70c0477d1$export$df8366105975a86f(operations) {
    /** @type {Record<string, unknown>} */ const transformations = {};
    for (const operation of operations){
        const [name, ...args] = operation.split("/");
        if (!$429f8fe70c0477d1$var$SUPPORTED_OPERATIONS_ORDERED.includes(name)) continue;
        const operationName = /** @type {(typeof SUPPORTED_OPERATIONS_ORDERED)[number]} */ name;
        const processor = $429f8fe70c0477d1$var$OPERATION_PROCESSORS[operationName];
        try {
            const value = processor(args);
            transformations[operationName] = value;
        } catch (err) {
            console.warn([
                `Failed to parse URL operation "${operation}". It will be ignored.`,
                err instanceof Error ? `Error message: "${err.message}"` : err,
                "If you need this functionality, please feel free to open an issue at https://github.com/uploadcare/blocks/issues/new"
            ].join("\n"));
        }
    }
    return /** @type {import('../types.js').Transformations} */ transformations;
}


const $8b84db27cd8d65ab$export$bb9ea7aab152411a = Object.freeze({
    CROP: "crop",
    TUNING: "tuning",
    FILTERS: "filters"
});
const $8b84db27cd8d65ab$export$d9a4cca3740decc7 = [
    $8b84db27cd8d65ab$export$bb9ea7aab152411a.CROP,
    $8b84db27cd8d65ab$export$bb9ea7aab152411a.TUNING,
    $8b84db27cd8d65ab$export$bb9ea7aab152411a.FILTERS
];
const $8b84db27cd8d65ab$export$68b0885f31248db9 = [
    "brightness",
    "exposure",
    "gamma",
    "contrast",
    "saturation",
    "vibrance",
    "warmth",
    "enhance"
];
const $8b84db27cd8d65ab$export$5773a777940e5760 = [
    "adaris",
    "briaril",
    "calarel",
    "carris",
    "cynarel",
    "cyren",
    "elmet",
    "elonni",
    "enzana",
    "erydark",
    "fenralan",
    "ferand",
    "galen",
    "gavin",
    "gethriel",
    "iorill",
    "iothari",
    "iselva",
    "jadis",
    "lavra",
    "misiara",
    "namala",
    "nerion",
    "nethari",
    "pamaya",
    "sarnar",
    "sedis",
    "sewen",
    "sorahel",
    "sorlen",
    "tarian",
    "thellassan",
    "varriel",
    "varven",
    "vevera",
    "virkas",
    "yedis",
    "yllara",
    "zatvel",
    "zevcen"
];
const $8b84db27cd8d65ab$export$daf320f6382e1d0a = [
    "rotate",
    "mirror",
    "flip"
];
const $8b84db27cd8d65ab$export$e3dcdd21a8cd88f9 = Object.freeze({
    brightness: {
        zero: (0, $429f8fe70c0477d1$export$8341498d3d7a32f).brightness,
        range: [
            -100,
            100
        ],
        keypointsNumber: 2
    },
    exposure: {
        zero: (0, $429f8fe70c0477d1$export$8341498d3d7a32f).exposure,
        range: [
            -500,
            500
        ],
        keypointsNumber: 2
    },
    gamma: {
        zero: (0, $429f8fe70c0477d1$export$8341498d3d7a32f).gamma,
        range: [
            0,
            1000
        ],
        keypointsNumber: 2
    },
    contrast: {
        zero: (0, $429f8fe70c0477d1$export$8341498d3d7a32f).contrast,
        range: [
            -100,
            500
        ],
        keypointsNumber: 2
    },
    saturation: {
        zero: (0, $429f8fe70c0477d1$export$8341498d3d7a32f).saturation,
        range: [
            -100,
            500
        ],
        keypointsNumber: 1
    },
    vibrance: {
        zero: (0, $429f8fe70c0477d1$export$8341498d3d7a32f).vibrance,
        range: [
            -100,
            500
        ],
        keypointsNumber: 1
    },
    warmth: {
        zero: (0, $429f8fe70c0477d1$export$8341498d3d7a32f).warmth,
        range: [
            -100,
            100
        ],
        keypointsNumber: 1
    },
    enhance: {
        zero: (0, $429f8fe70c0477d1$export$8341498d3d7a32f).enhance,
        range: [
            0,
            100
        ],
        keypointsNumber: 1
    },
    filter: {
        zero: (0, $429f8fe70c0477d1$export$8341498d3d7a32f).filter,
        range: [
            0,
            100
        ],
        keypointsNumber: 1
    }
});


// @ts-check
/** @param {string} value */ const $cf5145deda9036ee$export$7a086f785998e32e = (value)=>{
    if (!value) return [];
    return value.split(",").map((item)=>item.trim()).filter(Boolean);
};
const $cf5145deda9036ee$export$1494b4974e65fb4e = (value)=>{
    if (!value) return "";
    return value.join(",");
};


const $de12e36881279399$export$62db5c549ced9180 = "https://ucarecdn.com";
const $de12e36881279399$export$6554e0e4e82f1b3a = "https://upload.uploadcare.com";
const $de12e36881279399$export$4d917129503a6a33 = "https://social.uploadcare.com";
const $de12e36881279399$export$288021aefa12c882 = {
    pubkey: "",
    multiple: true,
    multipleMin: 0,
    multipleMax: Number.MAX_SAFE_INTEGER,
    confirmUpload: false,
    imgOnly: false,
    accept: "",
    externalSourcesPreferredTypes: "",
    externalSourcesEmbedCss: "",
    store: "auto",
    cameraMirror: false,
    cameraCapture: "",
    sourceList: "local, url, camera, dropbox, gdrive",
    cloudImageEditorTabs: (0, $cf5145deda9036ee$export$1494b4974e65fb4e)((0, $8b84db27cd8d65ab$export$d9a4cca3740decc7)),
    maxLocalFileSizeBytes: 0,
    thumbSize: 76,
    showEmptyList: false,
    useLocalImageEditor: false,
    useCloudImageEditor: true,
    removeCopyright: false,
    cropPreset: "",
    imageShrink: "",
    modalScrollLock: true,
    modalBackdropStrokes: false,
    sourceListWrap: true,
    remoteTabSessionKey: "",
    cdnCname: $de12e36881279399$export$62db5c549ced9180,
    baseUrl: $de12e36881279399$export$6554e0e4e82f1b3a,
    socialBaseUrl: $de12e36881279399$export$4d917129503a6a33,
    secureSignature: "",
    secureExpire: "",
    secureDeliveryProxy: "",
    retryThrottledRequestMaxTimes: 1,
    multipartMinFileSize: 26214400,
    multipartChunkSize: 5242880,
    maxConcurrentRequests: 10,
    multipartMaxConcurrentRequests: 4,
    multipartMaxAttempts: 3,
    checkForUrlDuplicates: false,
    saveUrlForRecurrentUploads: false,
    groupOutput: false,
    userAgentIntegration: "",
    debug: false,
    metadata: null,
    localeName: "en",
    localeDefinitionOverride: null,
    secureUploadsExpireThreshold: 600000,
    secureUploadsSignatureResolver: null,
    secureDeliveryProxyUrlResolver: null,
    iconHrefResolver: null,
    fileValidators: [],
    collectionValidators: [],
    cameraModes: "photo, video",
    defaultCameraMode: null,
    enableAudioRecording: true,
    enableVideoRecording: null,
    maxVideoRecordingDuration: null,
    mediaRecorderOptions: null
};


//  @ts-check
const $068cac2d61e2e514$var$DEFAULT_DEBOUNCE_TIMEOUT = 20;
const $068cac2d61e2e514$export$3d7865934588d77e = Object.freeze({
    FILE_ADDED: "file-added",
    FILE_REMOVED: "file-removed",
    FILE_UPLOAD_START: "file-upload-start",
    FILE_UPLOAD_PROGRESS: "file-upload-progress",
    FILE_UPLOAD_SUCCESS: "file-upload-success",
    FILE_UPLOAD_FAILED: "file-upload-failed",
    FILE_URL_CHANGED: "file-url-changed",
    MODAL_OPEN: "modal-open",
    MODAL_CLOSE: "modal-close",
    DONE_CLICK: "done-click",
    UPLOAD_CLICK: "upload-click",
    ACTIVITY_CHANGE: "activity-change",
    COMMON_UPLOAD_START: "common-upload-start",
    COMMON_UPLOAD_PROGRESS: "common-upload-progress",
    COMMON_UPLOAD_SUCCESS: "common-upload-success",
    COMMON_UPLOAD_FAILED: "common-upload-failed",
    CHANGE: "change",
    GROUP_CREATED: "group-created"
});
class $068cac2d61e2e514$export$4fae95256245c8c0 {
    /**
   * @private
   * @type {Map<string, number>}
   */ _timeoutStore = new Map();
    /**
   * @private
   * @type {Set<import('../../abstract/Block.js').Block>}
   */ _targets = new Set();
    /**
   * @private
   * @type {((...args: unknown[]) => void) | null}
   */ _debugPrint = null;
    /** @param {(...args: unknown[]) => void} debugPrint */ constructor(debugPrint){
        this._debugPrint = debugPrint;
    }
    /** @param {import('../../abstract/Block.js').Block} target */ bindTarget(target) {
        this._targets.add(target);
    }
    /** @param {import('../../abstract/Block.js').Block} target */ unbindTarget(target) {
        this._targets.delete(target);
    }
    /**
   * @private
   * @template {(typeof EventType)[keyof typeof EventType]} T
   * @param {T} type
   * @param {unknown} [payload]
   */ _dispatch(type, payload) {
        for (const target of this._targets)target.dispatchEvent(new CustomEvent(type, {
            detail: payload
        }));
        this._debugPrint?.(()=>{
            const copyPayload = !!payload && typeof payload === "object" ? {
                ...payload
            } : payload;
            return [
                `event "${type}"`,
                copyPayload
            ];
        });
    }
    /**
   * @template {(typeof EventType)[keyof typeof EventType]} T
   * @template {boolean | number | undefined} TDebounce
   * @param {T} type
   * @param {TDebounce extends false | undefined ? unknown : () => unknown} [payload]
   * @param {{ debounce?: TDebounce }} [options]
   */ emit(type, payload, { debounce: debounce } = {}) {
        if (typeof debounce !== "number" && !debounce) {
            this._dispatch(type, typeof payload === "function" ? payload() : payload);
            return;
        }
        if (this._timeoutStore.has(type)) window.clearTimeout(this._timeoutStore.get(type));
        const timeout = typeof debounce === "number" ? debounce : $068cac2d61e2e514$var$DEFAULT_DEBOUNCE_TIMEOUT;
        const timeoutId = window.setTimeout(()=>{
            this._dispatch(type, typeof payload === "function" ? payload() : payload);
            this._timeoutStore.delete(type);
        }, timeout);
        this._timeoutStore.set(type, timeoutId);
    }
}


// @ts-check
// @ts-check
/**
 * @template {{ (...args: any[]): any }} T
 * @param {T} callback
 * @param {number} wait
 * @returns {T & { cancel: () => void }} }
 */ function $10eeafe046ef78dd$export$61fc7d43ac8f84b0(callback, wait) {
    /** @type {NodeJS.Timeout} */ let timer;
    const debounced = /** @param {...any} args */ (...args)=>{
        clearTimeout(timer);
        timer = setTimeout(()=>callback(...args), wait);
    };
    debounced.cancel = ()=>{
        clearTimeout(timer);
    };
    return /** @type {T & { cancel: () => void }} } */ debounced;
}


const $eafdc04e5c65e8bf$var$WINDOW_HEIGHT_TRACKER_PROPERTY = "--uploadcare-blocks-window-height";
class $eafdc04e5c65e8bf$export$164c1ecdf58fbaaa {
    /**
   * @private
   * @type {Set<unknown>}
   */ static clientsRegistry = new Set();
    /** @private */ static flush = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(()=>{
        document.documentElement.style.setProperty($eafdc04e5c65e8bf$var$WINDOW_HEIGHT_TRACKER_PROPERTY, `${window.innerHeight}px`);
    }, 100);
    /**
   * @param {unknown} client
   * @public
   */ static registerClient(client) {
        if (this.clientsRegistry.size === 0) this.attachTracker();
        this.clientsRegistry.add(client);
    }
    /**
   * @param {unknown} client
   * @public
   */ static unregisterClient(client) {
        this.clientsRegistry.delete(client);
        if (this.clientsRegistry.size === 0) this.detachTracker();
    }
    /** @private */ static attachTracker() {
        window.addEventListener("resize", this.flush, {
            passive: true,
            capture: true
        });
        this.flush();
    }
    /** @private */ static detachTracker() {
        window.removeEventListener("resize", this.flush, {
            capture: true
        });
        document.documentElement.style.removeProperty($eafdc04e5c65e8bf$var$WINDOW_HEIGHT_TRACKER_PROPERTY);
    }
}



// @ts-check
/** @param {string} localeId */ const $da808ba176947d84$export$13de19f8f61a4abf = (localeId)=>{
    /**
   * @type {typeof Intl.Locale & {
   *   textInfo?: { direction: string };
   *   getTextInfo?: () => { direction: string };
   * }}
   */ const locale = /** @type {any} */ new Intl.Locale(localeId);
    let direction = "ltr";
    if (typeof locale.getTextInfo === "function" && locale.getTextInfo().direction) direction = locale.getTextInfo().direction;
    else if ("textInfo" in locale && locale.textInfo?.direction) direction = locale.textInfo.direction;
    return direction;
};


// @ts-check
/** @typedef {Intl.LDMLPluralRule} PluralForm */ /**
 * @param {string} locale
 * @param {number} count
 * @returns {PluralForm}
 */ const $afa2c82b84d64c9d$export$9f3f0d2d02951501 = (locale, count)=>{
    const pluralForm = new Intl.PluralRules(locale).select(count);
    return pluralForm;
};


/** @typedef {{ [key: String]: String | Number | Boolean | InputData }} InputData */ const $0d29a7eceb5ca5dd$var$DEFAULT_TRANSFORMER = (value)=>value;
const $0d29a7eceb5ca5dd$var$OPEN_TOKEN = "{{";
const $0d29a7eceb5ca5dd$var$CLOSE_TOKEN = "}}";
const $0d29a7eceb5ca5dd$var$PLURAL_PREFIX = "plural:";
function $0d29a7eceb5ca5dd$export$34afab4d3a450b60(template, data, options = {}) {
    let { openToken: openToken = $0d29a7eceb5ca5dd$var$OPEN_TOKEN, closeToken: closeToken = $0d29a7eceb5ca5dd$var$CLOSE_TOKEN, transform: transform = $0d29a7eceb5ca5dd$var$DEFAULT_TRANSFORMER } = options;
    for(let key in data){
        let value = data[key]?.toString();
        template = template.replaceAll(openToken + key + closeToken, typeof value === "string" ? transform(value) : value);
    }
    return template;
}
function $0d29a7eceb5ca5dd$export$eabb0be5d19ba097(template) {
    const pluralObjects = [];
    let open = template.indexOf($0d29a7eceb5ca5dd$var$OPEN_TOKEN);
    while(open !== -1){
        const close = template.indexOf($0d29a7eceb5ca5dd$var$CLOSE_TOKEN, open);
        const variable = template.substring(open + 2, close);
        if (variable.startsWith($0d29a7eceb5ca5dd$var$PLURAL_PREFIX)) {
            const keyValue = template.substring(open + 2, close).replace($0d29a7eceb5ca5dd$var$PLURAL_PREFIX, "");
            const key = keyValue.substring(0, keyValue.indexOf("("));
            const count = keyValue.substring(keyValue.indexOf("(") + 1, keyValue.indexOf(")"));
            pluralObjects.push({
                variable: variable,
                pluralKey: key,
                countVariable: count
            });
        }
        open = template.indexOf($0d29a7eceb5ca5dd$var$OPEN_TOKEN, close);
    }
    return pluralObjects;
}


// @ts-check
/**
 * @param {{
 *   element: HTMLElement;
 *   attribute: string;
 *   onSuccess: (value: string) => void;
 *   onTimeout: () => void;
 *   timeout?: number;
 * }} options
 */ const $f288d94b4e2e622a$export$bf3e2014f0f6687e = ({ element: element, attribute: attribute, onSuccess: onSuccess, onTimeout: onTimeout, timeout: timeout = 300 })=>{
    const currentAttrValue = element.getAttribute(attribute);
    if (currentAttrValue !== null) {
        onSuccess(currentAttrValue);
        return;
    }
    const observer = new MutationObserver((mutations)=>{
        const mutation = mutations[mutations.length - 1];
        handleMutation(mutation);
    });
    observer.observe(element, {
        attributes: true,
        attributeFilter: [
            attribute
        ]
    });
    const timeoutId = setTimeout(()=>{
        observer.disconnect();
        onTimeout();
    }, timeout);
    /** @param {MutationRecord} mutation */ const handleMutation = (mutation)=>{
        const attrValue = element.getAttribute(attribute);
        if (mutation.type === "attributes" && mutation.attributeName === attribute && attrValue !== null) {
            clearTimeout(timeoutId);
            observer.disconnect();
            onSuccess(attrValue);
        }
    };
};


// @ts-check
function $3905b2ce68ef12c7$var$isObject(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
const $3905b2ce68ef12c7$var$SEPARATOR = /\W|_/g;
function $3905b2ce68ef12c7$var$camelizeString(text) {
    return text.split($3905b2ce68ef12c7$var$SEPARATOR).map((word, index)=>word.charAt(0)[index > 0 ? "toUpperCase" : "toLowerCase"]() + word.slice(1)).join("");
}
function $3905b2ce68ef12c7$var$camelizeArrayItems(array, { ignoreKeys: ignoreKeys } = {
    ignoreKeys: []
}) {
    if (!Array.isArray(array)) return array;
    return array.map((item)=>$3905b2ce68ef12c7$var$camelizeKeys(item, {
            ignoreKeys: ignoreKeys
        }));
}
function $3905b2ce68ef12c7$var$camelizeKeys(source, { ignoreKeys: ignoreKeys } = {
    ignoreKeys: []
}) {
    if (Array.isArray(source)) return $3905b2ce68ef12c7$var$camelizeArrayItems(source, {
        ignoreKeys: ignoreKeys
    });
    if (!$3905b2ce68ef12c7$var$isObject(source)) return source;
    const result = {};
    for (const key of Object.keys(source)){
        let value = source[key];
        if (ignoreKeys.includes(key)) {
            result[key] = value;
            continue;
        }
        if ($3905b2ce68ef12c7$var$isObject(value)) value = $3905b2ce68ef12c7$var$camelizeKeys(value, {
            ignoreKeys: ignoreKeys
        });
        else if (Array.isArray(value)) value = $3905b2ce68ef12c7$var$camelizeArrayItems(value, {
            ignoreKeys: ignoreKeys
        });
        result[$3905b2ce68ef12c7$var$camelizeString(key)] = value;
    }
    return result;
}
/**
 * SetTimeout as Promise.
 *
 * @param {number} ms Timeout in milliseconds.
 */ const $3905b2ce68ef12c7$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
function $3905b2ce68ef12c7$export$7935961ef7719cb0({ libraryName: libraryName, libraryVersion: libraryVersion, userAgent: userAgent, publicKey: publicKey = "", integration: integration = "" }) {
    const languageName = "JavaScript";
    if (typeof userAgent === "string") return userAgent;
    if (typeof userAgent === "function") return userAgent({
        publicKey: publicKey,
        libraryName: libraryName,
        libraryVersion: libraryVersion,
        languageName: languageName,
        integration: integration
    });
    const mainInfo = [
        libraryName,
        libraryVersion,
        publicKey
    ].filter(Boolean).join("/");
    const additionInfo = [
        languageName,
        integration
    ].filter(Boolean).join("; ");
    return `${mainInfo} (${additionInfo})`;
}
const $3905b2ce68ef12c7$var$defaultOptions = {
    factor: 2,
    time: 100
};
function $3905b2ce68ef12c7$var$retrier(fn, options = $3905b2ce68ef12c7$var$defaultOptions) {
    let attempts = 0;
    function runAttempt(fn) {
        const defaultDelayTime = Math.round(options.time * options.factor ** attempts);
        const retry = (ms)=>$3905b2ce68ef12c7$var$delay(ms ?? defaultDelayTime).then(()=>{
                attempts += 1;
                return runAttempt(fn);
            });
        return fn({
            attempt: attempts,
            retry: retry
        });
    }
    return runAttempt(fn);
}
class $3905b2ce68ef12c7$export$2b0985b1459cbeaf extends Error {
}
class $3905b2ce68ef12c7$export$bae979e68e4dc802 extends $3905b2ce68ef12c7$export$2b0985b1459cbeaf {
    originalProgressEvent;
    constructor(progressEvent){
        super();
        this.name = "NetworkError";
        this.message = "Network error";
        Object.setPrototypeOf(this, $3905b2ce68ef12c7$export$bae979e68e4dc802.prototype);
        this.originalProgressEvent = progressEvent;
    }
}
const $3905b2ce68ef12c7$var$onCancel = (signal, callback)=>{
    if (signal) {
        if (signal.aborted) Promise.resolve().then(callback);
        else signal.addEventListener("abort", ()=>callback(), {
            once: true
        });
    }
};
class $3905b2ce68ef12c7$export$d7f5e52d091a66db extends $3905b2ce68ef12c7$export$2b0985b1459cbeaf {
    isCancel = true;
    constructor(message = "Request canceled"){
        super(message);
        this.name = "CancelError";
        Object.setPrototypeOf(this, $3905b2ce68ef12c7$export$d7f5e52d091a66db.prototype);
    }
}
const $3905b2ce68ef12c7$var$DEFAULT_INTERVAL = 500;
const $3905b2ce68ef12c7$var$poll = ({ check: check, interval: interval = $3905b2ce68ef12c7$var$DEFAULT_INTERVAL, timeout: timeout, signal: signal })=>new Promise((resolve, reject)=>{
        let tickTimeoutId;
        let timeoutId;
        $3905b2ce68ef12c7$var$onCancel(signal, ()=>{
            tickTimeoutId && clearTimeout(tickTimeoutId);
            reject(new $3905b2ce68ef12c7$export$d7f5e52d091a66db("Poll cancelled"));
        });
        if (timeout) timeoutId = setTimeout(()=>{
            tickTimeoutId && clearTimeout(tickTimeoutId);
            reject(new $3905b2ce68ef12c7$export$d7f5e52d091a66db("Timed out"));
        }, timeout);
        const tick = ()=>{
            try {
                Promise.resolve(check(signal)).then((result)=>{
                    if (result) {
                        timeoutId && clearTimeout(timeoutId);
                        resolve(result);
                    } else tickTimeoutId = setTimeout(tick, interval);
                }).catch((error)=>{
                    timeoutId && clearTimeout(timeoutId);
                    reject(error);
                });
            } catch (error) {
                timeoutId && clearTimeout(timeoutId);
                reject(error);
            }
        };
        tickTimeoutId = setTimeout(tick, 0);
    });
/*
  Settings for future support:
  parallelDirectUploads: 10,
 */ const $3905b2ce68ef12c7$var$defaultSettings = {
    baseCDN: "https://ucarecdn.com",
    baseURL: "https://upload.uploadcare.com",
    maxContentLength: 52428800,
    retryThrottledRequestMaxTimes: 1,
    retryNetworkErrorMaxTimes: 3,
    multipartMinFileSize: 26214400,
    multipartChunkSize: 5242880,
    multipartMinLastPartSize: 1048576,
    maxConcurrentRequests: 4,
    pollingTimeoutMilliseconds: 10000,
    pusherKey: "79ae88bd931ea68464d9"
};
const $3905b2ce68ef12c7$var$defaultContentType = "application/octet-stream";
const $3905b2ce68ef12c7$var$defaultFilename = "original";
const $3905b2ce68ef12c7$var$request = ({ method: method, url: url, data: data, headers: headers = {}, signal: signal, onProgress: onProgress })=>new Promise((resolve, reject)=>{
        const xhr = new XMLHttpRequest();
        const requestMethod = method?.toUpperCase() || "GET";
        let aborted = false;
        /**
     * Force synchronous flag to be off Some chrome versions gets
     * `InvalidAccessError` error when we set `responseType` See
     * https://xhr.spec.whatwg.org/#synchronous-flag and
     * https://bugs.chromium.org/p/chromium/issues/detail?id=1346628
     */ xhr.open(requestMethod, url, true);
        if (headers) Object.entries(headers).forEach((entry)=>{
            const [key, value] = entry;
            typeof value !== "undefined" && !Array.isArray(value) && xhr.setRequestHeader(key, value);
        });
        xhr.responseType = "text";
        $3905b2ce68ef12c7$var$onCancel(signal, ()=>{
            aborted = true;
            xhr.abort();
            reject(new $3905b2ce68ef12c7$export$d7f5e52d091a66db());
        });
        xhr.onload = ()=>{
            if (xhr.status != 200) // analyze HTTP status of the response
            reject(new Error(`Error ${xhr.status}: ${xhr.statusText}`)); // e.g. 404: Not Found
            else {
                const request = {
                    method: requestMethod,
                    url: url,
                    data: data,
                    headers: headers || undefined,
                    signal: signal,
                    onProgress: onProgress
                };
                // Convert the header string into an array
                // of individual headers
                const headersArray = xhr.getAllResponseHeaders().trim().split(/[\r\n]+/);
                // Create a map of header names to values
                const responseHeaders = {};
                headersArray.forEach(function(line) {
                    const parts = line.split(": ");
                    const header = parts.shift();
                    const value = parts.join(": ");
                    if (header && typeof header !== "undefined") responseHeaders[header] = value;
                });
                const responseData = xhr.response;
                const responseStatus = xhr.status;
                resolve({
                    request: request,
                    data: responseData,
                    headers: responseHeaders,
                    status: responseStatus
                });
            }
        };
        xhr.onerror = (progressEvent)=>{
            if (aborted) return;
            // only triggers if the request couldn't be made at all
            reject(new $3905b2ce68ef12c7$export$bae979e68e4dc802(progressEvent));
        };
        if (onProgress && typeof onProgress === "function") xhr.upload.onprogress = (event)=>{
            if (event.lengthComputable) onProgress({
                isComputable: true,
                value: event.loaded / event.total
            });
            else onProgress({
                isComputable: false
            });
        };
        if (data) xhr.send(data);
        else xhr.send();
    });
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $3905b2ce68ef12c7$var$identity(obj, ..._args) {
    return obj;
}
const $3905b2ce68ef12c7$var$getFileOptions = ({ name: name })=>name ? [
        name
    ] : [];
const $3905b2ce68ef12c7$var$transformFile = $3905b2ce68ef12c7$var$identity;
var $3905b2ce68ef12c7$var$getFormData = ()=>new FormData();
const $3905b2ce68ef12c7$var$isBuffer = (data)=>false;
const $3905b2ce68ef12c7$var$isBlob = (data)=>{
    return typeof Blob !== "undefined" && data instanceof Blob;
};
const $3905b2ce68ef12c7$var$isFile = (data)=>{
    return typeof File !== "undefined" && data instanceof File;
};
const $3905b2ce68ef12c7$var$isReactNativeAsset = (data)=>{
    return !!data && typeof data === "object" && !Array.isArray(data) && "uri" in data && typeof data.uri === "string";
};
const $3905b2ce68ef12c7$var$isFileData = (data)=>{
    return $3905b2ce68ef12c7$var$isBlob(data) || $3905b2ce68ef12c7$var$isFile(data) || $3905b2ce68ef12c7$var$isBuffer() || $3905b2ce68ef12c7$var$isReactNativeAsset(data);
};
const $3905b2ce68ef12c7$var$isSimpleValue = (value)=>{
    return typeof value === "string" || typeof value === "number" || typeof value === "undefined";
};
const $3905b2ce68ef12c7$var$isObjectValue = (value)=>{
    return !!value && typeof value === "object" && !Array.isArray(value);
};
const $3905b2ce68ef12c7$var$isFileValue = (value)=>!!value && typeof value === "object" && "data" in value && $3905b2ce68ef12c7$var$isFileData(value.data);
function $3905b2ce68ef12c7$var$collectParams(params, inputKey, inputValue) {
    if (Array.isArray(inputValue)) for (const value of inputValue)$3905b2ce68ef12c7$var$collectParams(params, `${inputKey}[]`, value);
    else if ($3905b2ce68ef12c7$var$isFileValue(inputValue)) {
        const { name: name, contentType: contentType } = inputValue;
        const file = $3905b2ce68ef12c7$var$transformFile(inputValue.data, name, contentType ?? $3905b2ce68ef12c7$var$defaultContentType);
        const options = $3905b2ce68ef12c7$var$getFileOptions({
            name: name,
            contentType: contentType
        });
        params.push([
            inputKey,
            file,
            ...options
        ]);
    } else if ($3905b2ce68ef12c7$var$isObjectValue(inputValue)) {
        for (const [key, value] of Object.entries(inputValue))if (typeof value !== "undefined") params.push([
            `${inputKey}[${key}]`,
            String(value)
        ]);
    } else if ($3905b2ce68ef12c7$var$isSimpleValue(inputValue) && inputValue) params.push([
        inputKey,
        inputValue.toString()
    ]);
}
function $3905b2ce68ef12c7$var$getFormDataParams(options) {
    const params = [];
    for (const [key, value] of Object.entries(options))$3905b2ce68ef12c7$var$collectParams(params, key, value);
    return params;
}
function $3905b2ce68ef12c7$var$buildFormData(options) {
    const formData = $3905b2ce68ef12c7$var$getFormData();
    const paramsList = $3905b2ce68ef12c7$var$getFormDataParams(options);
    for (const params of paramsList){
        const [key, value, ...rest] = params;
        // node form-data has another signature for append
        formData.append(key, value, ...rest);
    }
    return formData;
}
class $3905b2ce68ef12c7$export$137ec66182ed30ea extends $3905b2ce68ef12c7$export$2b0985b1459cbeaf {
    code;
    request;
    response;
    headers;
    constructor(message, code, request, response, headers){
        super();
        this.name = "UploadError";
        this.message = message;
        this.code = code;
        this.request = request;
        this.response = response;
        this.headers = headers;
        Object.setPrototypeOf(this, $3905b2ce68ef12c7$export$137ec66182ed30ea.prototype);
    }
}
const $3905b2ce68ef12c7$var$buildSearchParams = (query)=>{
    const searchParams = new URLSearchParams();
    for (const [key, value] of Object.entries(query)){
        if (value && typeof value === "object" && !Array.isArray(value)) Object.entries(value).filter((entry)=>entry[1] ?? false).forEach((entry)=>searchParams.set(`${key}[${entry[0]}]`, String(entry[1])));
        else if (Array.isArray(value)) value.forEach((val)=>{
            searchParams.append(`${key}[]`, val);
        });
        else if (typeof value === "string" && value) searchParams.set(key, value);
        else if (typeof value === "number") searchParams.set(key, value.toString());
    }
    return searchParams.toString();
};
const $3905b2ce68ef12c7$var$getUrl = (base, path, query)=>{
    const url = new URL(base);
    url.pathname = (url.pathname + path).replace("//", "/");
    if (query) url.search = $3905b2ce68ef12c7$var$buildSearchParams(query);
    return url.toString();
};
var $3905b2ce68ef12c7$var$version = "6.14.3";
const $3905b2ce68ef12c7$var$LIBRARY_NAME = "UploadcareUploadClient";
const $3905b2ce68ef12c7$var$LIBRARY_VERSION = $3905b2ce68ef12c7$var$version;
function $3905b2ce68ef12c7$var$getUserAgent(options) {
    return $3905b2ce68ef12c7$export$7935961ef7719cb0({
        libraryName: $3905b2ce68ef12c7$var$LIBRARY_NAME,
        libraryVersion: $3905b2ce68ef12c7$var$LIBRARY_VERSION,
        ...options
    });
}
const $3905b2ce68ef12c7$var$REQUEST_WAS_THROTTLED_CODE = "RequestThrottledError";
const $3905b2ce68ef12c7$var$DEFAULT_RETRY_AFTER_TIMEOUT = 15000;
const $3905b2ce68ef12c7$var$DEFAULT_NETWORK_ERROR_TIMEOUT = 1000;
function $3905b2ce68ef12c7$var$getTimeoutFromThrottledRequest(error) {
    const { headers: headers } = error || {};
    if (!headers || typeof headers["retry-after"] !== "string") return $3905b2ce68ef12c7$var$DEFAULT_RETRY_AFTER_TIMEOUT;
    const seconds = parseInt(headers["retry-after"], 10);
    if (!Number.isFinite(seconds)) return $3905b2ce68ef12c7$var$DEFAULT_RETRY_AFTER_TIMEOUT;
    return seconds * 1000;
}
function $3905b2ce68ef12c7$var$retryIfFailed(fn, options) {
    const { retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes } = options;
    return $3905b2ce68ef12c7$var$retrier(({ attempt: attempt, retry: retry })=>fn().catch((error)=>{
            if ("response" in error && error?.code === $3905b2ce68ef12c7$var$REQUEST_WAS_THROTTLED_CODE && attempt < retryThrottledRequestMaxTimes) return retry($3905b2ce68ef12c7$var$getTimeoutFromThrottledRequest(error));
            if (error instanceof $3905b2ce68ef12c7$export$bae979e68e4dc802 && attempt < retryNetworkErrorMaxTimes) return retry((attempt + 1) * $3905b2ce68ef12c7$var$DEFAULT_NETWORK_ERROR_TIMEOUT);
            throw error;
        }));
}
const $3905b2ce68ef12c7$var$getContentType = (file)=>{
    let contentType = "";
    if ($3905b2ce68ef12c7$var$isBlob(file) || $3905b2ce68ef12c7$var$isFile(file) || $3905b2ce68ef12c7$var$isReactNativeAsset(file)) contentType = file.type;
    return contentType || $3905b2ce68ef12c7$var$defaultContentType;
};
const $3905b2ce68ef12c7$var$getFileName = (file)=>{
    let filename = "";
    if ($3905b2ce68ef12c7$var$isFile(file) && file.name) filename = file.name;
    else if ($3905b2ce68ef12c7$var$isBlob(file) || $3905b2ce68ef12c7$var$isBuffer()) filename = "";
    else if ($3905b2ce68ef12c7$var$isReactNativeAsset(file) && file.name) filename = file.name;
    return filename || $3905b2ce68ef12c7$var$defaultFilename;
};
function $3905b2ce68ef12c7$var$getStoreValue(store) {
    if (typeof store === "undefined" || store === "auto") return "auto";
    return store ? "1" : "0";
}
/**
 * Performs file uploading request to Uploadcare Upload API. Can be canceled and
 * has progress.
 */ function $3905b2ce68ef12c7$export$e2253033e6e1df16(file, { publicKey: publicKey, fileName: fileName, contentType: contentType, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source = "local", integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes, metadata: metadata }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: "POST",
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, "/base/", {
                jsonerrors: 1
            }),
            headers: {
                "X-UC-User-Agent": $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            data: $3905b2ce68ef12c7$var$buildFormData({
                file: {
                    data: file,
                    name: fileName || $3905b2ce68ef12c7$var$getFileName(file),
                    contentType: contentType || $3905b2ce68ef12c7$var$getContentType(file)
                },
                UPLOADCARE_PUB_KEY: publicKey,
                UPLOADCARE_STORE: $3905b2ce68ef12c7$var$getStoreValue(store),
                signature: secureSignature,
                expire: secureExpire,
                source: source,
                metadata: metadata
            }),
            signal: signal,
            onProgress: onProgress
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ("error" in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    });
}
var $3905b2ce68ef12c7$var$TypeEnum;
(function(TypeEnum) {
    TypeEnum["Token"] = "token";
    TypeEnum["FileInfo"] = "file_info";
})($3905b2ce68ef12c7$var$TypeEnum || ($3905b2ce68ef12c7$var$TypeEnum = {}));
/** Uploading files from URL. */ function $3905b2ce68ef12c7$export$8344cc6f9c959d9b(sourceUrl, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, store: store, fileName: fileName, checkForUrlDuplicates: checkForUrlDuplicates, saveUrlForRecurrentUploads: saveUrlForRecurrentUploads, secureSignature: secureSignature, secureExpire: secureExpire, source: source = "url", signal: signal, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes, metadata: metadata }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: "POST",
            headers: {
                "X-UC-User-Agent": $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, "/from_url/", {
                jsonerrors: 1,
                pub_key: publicKey,
                source_url: sourceUrl,
                store: $3905b2ce68ef12c7$var$getStoreValue(store),
                filename: fileName,
                check_URL_duplicates: checkForUrlDuplicates ? 1 : undefined,
                save_URL_duplicates: saveUrlForRecurrentUploads ? 1 : undefined,
                signature: secureSignature,
                expire: secureExpire,
                source: source,
                metadata: metadata
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ("error" in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    });
}
var $3905b2ce68ef12c7$var$Status;
(function(Status) {
    Status["Unknown"] = "unknown";
    Status["Waiting"] = "waiting";
    Status["Progress"] = "progress";
    Status["Error"] = "error";
    Status["Success"] = "success";
})($3905b2ce68ef12c7$var$Status || ($3905b2ce68ef12c7$var$Status = {}));
const $3905b2ce68ef12c7$var$isErrorResponse = (response)=>{
    return "status" in response && response.status === $3905b2ce68ef12c7$var$Status.Error;
};
/** Checking upload status and working with file tokens. */ function $3905b2ce68ef12c7$export$11ce33276c18fc77(token, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, signal: signal, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes } = {}) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: "GET",
            headers: publicKey ? {
                "X-UC-User-Agent": $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            } : undefined,
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, "/from_url/status/", {
                jsonerrors: 1,
                token: token
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ("error" in response && !$3905b2ce68ef12c7$var$isErrorResponse(response)) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    });
}
/** Create files group. */ function $3905b2ce68ef12c7$export$e5e25fbcc1f7affe(uuids, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, jsonpCallback: jsonpCallback, secureSignature: secureSignature, secureExpire: secureExpire, signal: signal, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: "POST",
            headers: {
                "X-UC-User-Agent": $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, "/group/", {
                jsonerrors: 1
            }),
            data: $3905b2ce68ef12c7$var$buildFormData({
                files: uuids,
                callback: jsonpCallback,
                pub_key: publicKey,
                signature: secureSignature,
                expire: secureExpire,
                source: source
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ("error" in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes
    });
}
/** Get info about group. */ function $3905b2ce68ef12c7$export$ff32046efef5c2f5(id, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, signal: signal, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: "GET",
            headers: {
                "X-UC-User-Agent": $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, "/group/info/", {
                jsonerrors: 1,
                pub_key: publicKey,
                group_id: id,
                source: source
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ("error" in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
/** Returns a JSON dictionary holding file info. */ function $3905b2ce68ef12c7$export$a80b3bd66acc52ff(uuid, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, signal: signal, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: "GET",
            headers: {
                "X-UC-User-Agent": $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, "/info/", {
                jsonerrors: 1,
                pub_key: publicKey,
                file_id: uuid,
                source: source
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ("error" in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
/** Start multipart uploading. */ function $3905b2ce68ef12c7$export$1afebf94ca4ea92e(size, { publicKey: publicKey, contentType: contentType, fileName: fileName, multipartChunkSize: multipartChunkSize = $3905b2ce68ef12c7$var$defaultSettings.multipartChunkSize, baseURL: baseURL = "", secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, source: source = "local", integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes, metadata: metadata }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: "POST",
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, "/multipart/start/", {
                jsonerrors: 1
            }),
            headers: {
                "X-UC-User-Agent": $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            data: $3905b2ce68ef12c7$var$buildFormData({
                filename: fileName || $3905b2ce68ef12c7$var$defaultFilename,
                size: size,
                content_type: contentType || $3905b2ce68ef12c7$var$defaultContentType,
                part_size: multipartChunkSize,
                UPLOADCARE_STORE: $3905b2ce68ef12c7$var$getStoreValue(store),
                UPLOADCARE_PUB_KEY: publicKey,
                signature: secureSignature,
                expire: secureExpire,
                source: source,
                metadata: metadata
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ("error" in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else {
                // convert to array
                response.parts = Object.keys(response.parts).map((key)=>response.parts[Number(key)]);
                return response;
            }
        }), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
/** Complete multipart uploading. */ function $3905b2ce68ef12c7$export$73b98a86a54f96ed(part, url, { contentType: contentType, signal: signal, onProgress: onProgress, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: "PUT",
            url: url,
            data: part,
            // Upload request can't be non-computable because we always know exact size
            onProgress: onProgress,
            signal: signal,
            headers: {
                "Content-Type": contentType || $3905b2ce68ef12c7$var$defaultContentType
            }
        }).then((result)=>{
            // hack for node ¯\_(ツ)_/¯
            if (onProgress) onProgress({
                isComputable: true,
                value: 1
            });
            return result;
        }).then(({ status: status })=>({
                code: status
            })), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
/** Complete multipart uploading. */ function $3905b2ce68ef12c7$export$54ca83d7986c917a(uuid, { publicKey: publicKey, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, source: source = "local", signal: signal, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes = $3905b2ce68ef12c7$var$defaultSettings.retryNetworkErrorMaxTimes }) {
    return $3905b2ce68ef12c7$var$retryIfFailed(()=>$3905b2ce68ef12c7$var$request({
            method: "POST",
            url: $3905b2ce68ef12c7$var$getUrl(baseURL, "/multipart/complete/", {
                jsonerrors: 1
            }),
            headers: {
                "X-UC-User-Agent": $3905b2ce68ef12c7$var$getUserAgent({
                    publicKey: publicKey,
                    integration: integration,
                    userAgent: userAgent
                })
            },
            data: $3905b2ce68ef12c7$var$buildFormData({
                uuid: uuid,
                UPLOADCARE_PUB_KEY: publicKey,
                source: source
            }),
            signal: signal
        }).then(({ data: data, headers: headers, request: request })=>{
            const response = $3905b2ce68ef12c7$var$camelizeKeys(JSON.parse(data));
            if ("error" in response) throw new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error.content, response.error.errorCode, request, response, headers);
            else return response;
        }), {
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
}
function $3905b2ce68ef12c7$export$8d1698d1c44a6cfa(uuid, { publicKey: publicKey, baseURL: baseURL, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, signal: signal, onProgress: onProgress }) {
    return $3905b2ce68ef12c7$var$poll({
        check: (signal)=>$3905b2ce68ef12c7$export$a80b3bd66acc52ff(uuid, {
                publicKey: publicKey,
                baseURL: baseURL,
                signal: signal,
                source: source,
                integration: integration,
                userAgent: userAgent,
                retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
                retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
            }).then((response)=>{
                if (response.isReady) return response;
                onProgress && onProgress({
                    isComputable: true,
                    value: 1
                });
                return false;
            }),
        signal: signal
    });
}
function $3905b2ce68ef12c7$var$isGroupFileInfo(fileInfo) {
    return "defaultEffects" in fileInfo;
}
class $3905b2ce68ef12c7$export$92ff693e656b1c76 {
    uuid;
    name;
    size;
    isStored;
    isImage;
    mimeType;
    cdnUrl;
    s3Url;
    originalFilename;
    imageInfo;
    videoInfo;
    contentInfo;
    metadata;
    s3Bucket;
    defaultEffects = null;
    constructor(fileInfo, { baseCDN: baseCDN = $3905b2ce68ef12c7$var$defaultSettings.baseCDN, fileName: fileName } = {}){
        const { uuid: uuid, s3Bucket: s3Bucket } = fileInfo;
        const cdnUrl = $3905b2ce68ef12c7$var$getUrl(baseCDN, `${uuid}/`);
        const s3Url = s3Bucket ? $3905b2ce68ef12c7$var$getUrl(`https://${s3Bucket}.s3.amazonaws.com/`, `${uuid}/${fileInfo.filename}`) : null;
        this.uuid = uuid;
        this.name = fileName || fileInfo.filename;
        this.size = fileInfo.size;
        this.isStored = fileInfo.isStored;
        this.isImage = fileInfo.isImage;
        this.mimeType = fileInfo.mimeType;
        this.cdnUrl = cdnUrl;
        this.originalFilename = fileInfo.originalFilename;
        this.imageInfo = fileInfo.imageInfo;
        this.videoInfo = fileInfo.videoInfo;
        this.contentInfo = fileInfo.contentInfo;
        this.metadata = fileInfo.metadata || null;
        this.s3Bucket = s3Bucket || null;
        this.s3Url = s3Url;
        if ($3905b2ce68ef12c7$var$isGroupFileInfo(fileInfo)) this.defaultEffects = fileInfo.defaultEffects;
    }
}
const $3905b2ce68ef12c7$export$3bd9b83d6d44a7c = (file, { publicKey: publicKey, fileName: fileName, baseURL: baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, contentType: contentType, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, baseCDN: baseCDN, metadata: metadata })=>{
    return $3905b2ce68ef12c7$export$e2253033e6e1df16(file, {
        publicKey: publicKey,
        fileName: fileName,
        contentType: contentType,
        baseURL: baseURL,
        secureSignature: secureSignature,
        secureExpire: secureExpire,
        store: store,
        signal: signal,
        onProgress: onProgress,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        metadata: metadata
    }).then(({ file: file })=>{
        return $3905b2ce68ef12c7$export$8d1698d1c44a6cfa(file, {
            publicKey: publicKey,
            baseURL: baseURL,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            onProgress: onProgress,
            signal: signal
        });
    }).then((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
            baseCDN: baseCDN
        }));
};
const $3905b2ce68ef12c7$export$3bfa52b0ed198643 = (uuid, { publicKey: publicKey, fileName: fileName, baseURL: baseURL, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, baseCDN: baseCDN })=>{
    return $3905b2ce68ef12c7$export$a80b3bd66acc52ff(uuid, {
        publicKey: publicKey,
        baseURL: baseURL,
        signal: signal,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    }).then((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
            baseCDN: baseCDN,
            fileName: fileName
        })).then((result)=>{
        // hack for node ¯\_(ツ)_/¯
        if (onProgress) onProgress({
            isComputable: true,
            value: 1
        });
        return result;
    });
};
const $3905b2ce68ef12c7$var$race = (fns, { signal: signal } = {})=>{
    let lastError = null;
    let winnerIndex = null;
    const controllers = fns.map(()=>new AbortController());
    const createStopRaceCallback = (i)=>()=>{
            winnerIndex = i;
            controllers.forEach((controller, index)=>index !== i && controller.abort());
        };
    $3905b2ce68ef12c7$var$onCancel(signal, ()=>{
        controllers.forEach((controller)=>controller.abort());
    });
    return Promise.all(fns.map((fn, i)=>{
        const stopRace = createStopRaceCallback(i);
        return Promise.resolve().then(()=>fn({
                stopRace: stopRace,
                signal: controllers[i].signal
            })).then((result)=>{
            stopRace();
            return result;
        }).catch((error)=>{
            lastError = error;
            return null;
        });
    })).then((results)=>{
        if (winnerIndex === null) throw lastError;
        else return results[winnerIndex];
    });
};
var $3905b2ce68ef12c7$var$WebSocket = window.WebSocket;
class $3905b2ce68ef12c7$var$Events {
    events = Object.create({});
    emit(event, data) {
        this.events[event]?.forEach((fn)=>fn(data));
    }
    on(event, callback) {
        this.events[event] = this.events[event] || [];
        this.events[event].push(callback);
    }
    off(event, callback) {
        if (callback) this.events[event] = this.events[event].filter((fn)=>fn !== callback);
        else this.events[event] = [];
    }
}
const $3905b2ce68ef12c7$var$response = (type, data)=>{
    if (type === "success") return {
        status: $3905b2ce68ef12c7$var$Status.Success,
        ...data
    };
    if (type === "progress") return {
        status: $3905b2ce68ef12c7$var$Status.Progress,
        ...data
    };
    return {
        status: $3905b2ce68ef12c7$var$Status.Error,
        ...data
    };
};
class $3905b2ce68ef12c7$var$Pusher {
    key;
    disconnectTime;
    ws = undefined;
    queue = [];
    isConnected = false;
    subscribers = 0;
    emmitter = new $3905b2ce68ef12c7$var$Events();
    disconnectTimeoutId = null;
    constructor(pusherKey, disconnectTime = 30000){
        this.key = pusherKey;
        this.disconnectTime = disconnectTime;
    }
    connect() {
        this.disconnectTimeoutId && clearTimeout(this.disconnectTimeoutId);
        if (!this.isConnected && !this.ws) {
            const pusherUrl = `wss://ws.pusherapp.com/app/${this.key}?protocol=5&client=js&version=1.12.2`;
            this.ws = new $3905b2ce68ef12c7$var$WebSocket(pusherUrl);
            this.ws.addEventListener("error", (error)=>{
                this.emmitter.emit("error", new Error(error.message));
            });
            this.emmitter.on("connected", ()=>{
                this.isConnected = true;
                this.queue.forEach((message)=>this.send(message.event, message.data));
                this.queue = [];
            });
            this.ws.addEventListener("message", (e)=>{
                const data = JSON.parse(e.data.toString());
                switch(data.event){
                    case "pusher:connection_established":
                        this.emmitter.emit("connected", undefined);
                        break;
                    case "pusher:ping":
                        this.send("pusher:pong", {});
                        break;
                    case "progress":
                    case "success":
                    case "fail":
                        this.emmitter.emit(data.channel, $3905b2ce68ef12c7$var$response(data.event, JSON.parse(data.data)));
                }
            });
        }
    }
    disconnect() {
        const actualDisconect = ()=>{
            this.ws?.close();
            this.ws = undefined;
            this.isConnected = false;
        };
        if (this.disconnectTime) this.disconnectTimeoutId = setTimeout(()=>{
            actualDisconect();
        }, this.disconnectTime);
        else actualDisconect();
    }
    send(event, data) {
        const str = JSON.stringify({
            event: event,
            data: data
        });
        this.ws?.send(str);
    }
    subscribe(token, handler) {
        this.subscribers += 1;
        this.connect();
        const channel = `task-status-${token}`;
        const message = {
            event: "pusher:subscribe",
            data: {
                channel: channel
            }
        };
        this.emmitter.on(channel, handler);
        if (this.isConnected) this.send(message.event, message.data);
        else this.queue.push(message);
    }
    unsubscribe(token) {
        this.subscribers -= 1;
        const channel = `task-status-${token}`;
        const message = {
            event: "pusher:unsubscribe",
            data: {
                channel: channel
            }
        };
        this.emmitter.off(channel);
        if (this.isConnected) this.send(message.event, message.data);
        else this.queue = this.queue.filter((msg)=>msg.data.channel !== channel);
        if (this.subscribers === 0) this.disconnect();
    }
    onError(callback) {
        this.emmitter.on("error", callback);
        return ()=>this.emmitter.off("error", callback);
    }
}
let $3905b2ce68ef12c7$var$pusher = null;
const $3905b2ce68ef12c7$var$getPusher = (key)=>{
    if (!$3905b2ce68ef12c7$var$pusher) {
        // no timeout for nodeJS and 30000 ms for browser
        const disconectTimeout = typeof window === "undefined" ? 0 : 30000;
        $3905b2ce68ef12c7$var$pusher = new $3905b2ce68ef12c7$var$Pusher(key, disconectTimeout);
    }
    return $3905b2ce68ef12c7$var$pusher;
};
const $3905b2ce68ef12c7$var$preconnect = (key)=>{
    $3905b2ce68ef12c7$var$getPusher(key).connect();
};
function $3905b2ce68ef12c7$var$pollStrategy({ token: token, publicKey: publicKey, baseURL: baseURL, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, onProgress: onProgress, signal: signal }) {
    return $3905b2ce68ef12c7$var$poll({
        check: (signal)=>$3905b2ce68ef12c7$export$11ce33276c18fc77(token, {
                publicKey: publicKey,
                baseURL: baseURL,
                integration: integration,
                userAgent: userAgent,
                retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
                retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
                signal: signal
            }).then((response)=>{
                switch(response.status){
                    case $3905b2ce68ef12c7$var$Status.Error:
                        return new $3905b2ce68ef12c7$export$137ec66182ed30ea(response.error, response.errorCode);
                    case $3905b2ce68ef12c7$var$Status.Waiting:
                        return false;
                    case $3905b2ce68ef12c7$var$Status.Unknown:
                        return new $3905b2ce68ef12c7$export$137ec66182ed30ea(`Token "${token}" was not found.`);
                    case $3905b2ce68ef12c7$var$Status.Progress:
                        if (onProgress) {
                            if (response.total === "unknown") onProgress({
                                isComputable: false
                            });
                            else onProgress({
                                isComputable: true,
                                value: response.done / response.total
                            });
                        }
                        return false;
                    case $3905b2ce68ef12c7$var$Status.Success:
                        if (onProgress) onProgress({
                            isComputable: true,
                            value: response.done / response.total
                        });
                        return response;
                    default:
                        throw new Error("Unknown status");
                }
            }),
        signal: signal
    });
}
const $3905b2ce68ef12c7$var$pushStrategy = ({ token: token, pusherKey: pusherKey, signal: signal, onProgress: onProgress })=>new Promise((resolve, reject)=>{
        const pusher = $3905b2ce68ef12c7$var$getPusher(pusherKey);
        const unsubErrorHandler = pusher.onError(reject);
        const destroy = ()=>{
            unsubErrorHandler();
            pusher.unsubscribe(token);
        };
        $3905b2ce68ef12c7$var$onCancel(signal, ()=>{
            destroy();
            reject(new $3905b2ce68ef12c7$export$d7f5e52d091a66db("pusher cancelled"));
        });
        pusher.subscribe(token, (result)=>{
            switch(result.status){
                case $3905b2ce68ef12c7$var$Status.Progress:
                    if (onProgress) {
                        if (result.total === "unknown") onProgress({
                            isComputable: false
                        });
                        else onProgress({
                            isComputable: true,
                            value: result.done / result.total
                        });
                    }
                    break;
                case $3905b2ce68ef12c7$var$Status.Success:
                    destroy();
                    if (onProgress) onProgress({
                        isComputable: true,
                        value: result.done / result.total
                    });
                    resolve(result);
                    break;
                case $3905b2ce68ef12c7$var$Status.Error:
                    destroy();
                    reject(new $3905b2ce68ef12c7$export$137ec66182ed30ea(result.msg, result.error_code));
            }
        });
    });
const $3905b2ce68ef12c7$export$f5b9f3f82b877f1f = (sourceUrl, { publicKey: publicKey, fileName: fileName, baseURL: baseURL, baseCDN: baseCDN, checkForUrlDuplicates: checkForUrlDuplicates, saveUrlForRecurrentUploads: saveUrlForRecurrentUploads, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, pusherKey: pusherKey = $3905b2ce68ef12c7$var$defaultSettings.pusherKey, metadata: metadata })=>Promise.resolve($3905b2ce68ef12c7$var$preconnect(pusherKey)).then(()=>$3905b2ce68ef12c7$export$8344cc6f9c959d9b(sourceUrl, {
            publicKey: publicKey,
            fileName: fileName,
            baseURL: baseURL,
            checkForUrlDuplicates: checkForUrlDuplicates,
            saveUrlForRecurrentUploads: saveUrlForRecurrentUploads,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            store: store,
            signal: signal,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            metadata: metadata
        })).catch((error)=>{
        const pusher = $3905b2ce68ef12c7$var$getPusher(pusherKey);
        pusher?.disconnect();
        return Promise.reject(error);
    }).then((urlResponse)=>{
        if (urlResponse.type === $3905b2ce68ef12c7$var$TypeEnum.FileInfo) return urlResponse;
        else return $3905b2ce68ef12c7$var$race([
            ({ signal: signal })=>$3905b2ce68ef12c7$var$pollStrategy({
                    token: urlResponse.token,
                    publicKey: publicKey,
                    baseURL: baseURL,
                    integration: integration,
                    userAgent: userAgent,
                    retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
                    onProgress: onProgress,
                    signal: signal
                }),
            ({ signal: signal })=>$3905b2ce68ef12c7$var$pushStrategy({
                    token: urlResponse.token,
                    pusherKey: pusherKey,
                    signal: signal,
                    onProgress: onProgress
                })
        ], {
            signal: signal
        });
    }).then((result)=>{
        if (result instanceof $3905b2ce68ef12c7$export$137ec66182ed30ea) throw result;
        return result;
    }).then((result)=>$3905b2ce68ef12c7$export$8d1698d1c44a6cfa(result.uuid, {
            publicKey: publicKey,
            baseURL: baseURL,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            onProgress: onProgress,
            signal: signal
        })).then((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
            baseCDN: baseCDN
        }));
const $3905b2ce68ef12c7$var$memo = new WeakMap();
const $3905b2ce68ef12c7$var$getBlobFromReactNativeAsset = async (asset)=>{
    if ($3905b2ce68ef12c7$var$memo.has(asset)) return $3905b2ce68ef12c7$var$memo.get(asset);
    const blob = await fetch(asset.uri).then((res)=>res.blob());
    $3905b2ce68ef12c7$var$memo.set(asset, blob);
    return blob;
};
const $3905b2ce68ef12c7$var$getFileSize = async (file)=>{
    if ($3905b2ce68ef12c7$var$isFile(file) || $3905b2ce68ef12c7$var$isBlob(file)) return file.size;
    if ($3905b2ce68ef12c7$var$isReactNativeAsset(file)) {
        const blob = await $3905b2ce68ef12c7$var$getBlobFromReactNativeAsset(file);
        return blob.size;
    }
    throw new Error(`Unknown file type. Cannot determine file size.`);
};
/** Check if FileData is multipart data. */ const $3905b2ce68ef12c7$var$isMultipart = (fileSize, multipartMinFileSize = $3905b2ce68ef12c7$var$defaultSettings.multipartMinFileSize)=>{
    return fileSize >= multipartMinFileSize;
};
/** Uuid type guard. */ const $3905b2ce68ef12c7$var$isUuid = (data)=>{
    const UUID_REGEX = "[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}";
    const regExp = new RegExp(UUID_REGEX);
    return !$3905b2ce68ef12c7$var$isFileData(data) && regExp.test(data);
};
/**
 * Url type guard.
 *
 * @param {SupportedFileInput | Url | Uuid} data
 */ const $3905b2ce68ef12c7$var$isUrl = (data)=>{
    const URL_REGEX = "^(?:\\w+:)?\\/\\/([^\\s\\.]+\\.\\S{2}|localhost[\\:?\\d]*)\\S*$";
    const regExp = new RegExp(URL_REGEX);
    return !$3905b2ce68ef12c7$var$isFileData(data) && regExp.test(data);
};
const $3905b2ce68ef12c7$var$runWithConcurrency = (concurrency, tasks)=>{
    return new Promise((resolve, reject)=>{
        const results = [];
        let rejected = false;
        let settled = tasks.length;
        const forRun = [
            ...tasks
        ];
        const run = ()=>{
            const index = tasks.length - forRun.length;
            const next = forRun.shift();
            if (next) next().then((result)=>{
                if (rejected) return;
                results[index] = result;
                settled -= 1;
                if (settled) run();
                else resolve(results);
            }).catch((error)=>{
                rejected = true;
                reject(error);
            });
        };
        for(let i = 0; i < concurrency; i++)run();
    });
};
const $3905b2ce68ef12c7$var$sliceChunk = (file, index, fileSize, chunkSize)=>{
    const start = chunkSize * index;
    const end = Math.min(start + chunkSize, fileSize);
    return file.slice(start, end);
};
const $3905b2ce68ef12c7$var$prepareChunks = async (file, fileSize, chunkSize)=>{
    return (index)=>$3905b2ce68ef12c7$var$sliceChunk(file, index, fileSize, chunkSize);
};
const $3905b2ce68ef12c7$var$uploadPart = (chunk, url, { publicKey: publicKey, contentType: contentType, onProgress: onProgress, signal: signal, integration: integration, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes })=>$3905b2ce68ef12c7$export$73b98a86a54f96ed(chunk, url, {
        publicKey: publicKey,
        contentType: contentType,
        onProgress: onProgress,
        signal: signal,
        integration: integration,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
    });
const $3905b2ce68ef12c7$export$a2810c3ec0d2473a = async (file, { publicKey: publicKey, fileName: fileName, fileSize: fileSize, baseURL: baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, contentType: contentType, multipartChunkSize: multipartChunkSize = $3905b2ce68ef12c7$var$defaultSettings.multipartChunkSize, maxConcurrentRequests: maxConcurrentRequests = $3905b2ce68ef12c7$var$defaultSettings.maxConcurrentRequests, baseCDN: baseCDN, metadata: metadata })=>{
    const size = fileSize ?? await $3905b2ce68ef12c7$var$getFileSize(file);
    let progressValues;
    const createProgressHandler = (totalChunks, chunkIdx)=>{
        if (!onProgress) return;
        if (!progressValues) progressValues = Array(totalChunks).fill(0);
        const sum = (values)=>values.reduce((sum, next)=>sum + next, 0);
        return (info)=>{
            if (!info.isComputable) return;
            progressValues[chunkIdx] = info.value;
            onProgress({
                isComputable: true,
                value: sum(progressValues) / totalChunks
            });
        };
    };
    contentType ||= $3905b2ce68ef12c7$var$getContentType(file);
    return $3905b2ce68ef12c7$export$1afebf94ca4ea92e(size, {
        publicKey: publicKey,
        contentType: contentType,
        fileName: fileName || $3905b2ce68ef12c7$var$getFileName(file),
        baseURL: baseURL,
        secureSignature: secureSignature,
        secureExpire: secureExpire,
        store: store,
        signal: signal,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        metadata: metadata,
        multipartChunkSize: multipartChunkSize
    }).then(async ({ uuid: uuid, parts: parts })=>{
        const getChunk = await $3905b2ce68ef12c7$var$prepareChunks(file, size, multipartChunkSize);
        return Promise.all([
            uuid,
            $3905b2ce68ef12c7$var$runWithConcurrency(maxConcurrentRequests, parts.map((url, index)=>()=>$3905b2ce68ef12c7$var$uploadPart(getChunk(index), url, {
                        publicKey: publicKey,
                        contentType: contentType,
                        onProgress: createProgressHandler(parts.length, index),
                        signal: signal,
                        integration: integration,
                        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
                        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
                    })))
        ]);
    }).then(([uuid])=>$3905b2ce68ef12c7$export$54ca83d7986c917a(uuid, {
            publicKey: publicKey,
            baseURL: baseURL,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
        })).then((fileInfo)=>{
        if (fileInfo.isReady) return fileInfo;
        else return $3905b2ce68ef12c7$export$8d1698d1c44a6cfa(fileInfo.uuid, {
            publicKey: publicKey,
            baseURL: baseURL,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            onProgress: onProgress,
            signal: signal
        });
    }).then((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
            baseCDN: baseCDN
        }));
};
/** Uploads file from provided data. */ async function $3905b2ce68ef12c7$export$a5575dbeeffdad98(data, { publicKey: publicKey, fileName: fileName, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, contentType: contentType, multipartMinFileSize: multipartMinFileSize, multipartChunkSize: multipartChunkSize, maxConcurrentRequests: maxConcurrentRequests, baseCDN: baseCDN = $3905b2ce68ef12c7$var$defaultSettings.baseCDN, checkForUrlDuplicates: checkForUrlDuplicates, saveUrlForRecurrentUploads: saveUrlForRecurrentUploads, pusherKey: pusherKey, metadata: metadata }) {
    if ($3905b2ce68ef12c7$var$isFileData(data)) {
        const fileSize = await $3905b2ce68ef12c7$var$getFileSize(data);
        if ($3905b2ce68ef12c7$var$isMultipart(fileSize, multipartMinFileSize)) return $3905b2ce68ef12c7$export$a2810c3ec0d2473a(data, {
            publicKey: publicKey,
            contentType: contentType,
            multipartChunkSize: multipartChunkSize,
            fileSize: fileSize,
            fileName: fileName,
            baseURL: baseURL,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            store: store,
            signal: signal,
            onProgress: onProgress,
            source: source,
            integration: integration,
            userAgent: userAgent,
            maxConcurrentRequests: maxConcurrentRequests,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            baseCDN: baseCDN,
            metadata: metadata
        });
        return $3905b2ce68ef12c7$export$3bd9b83d6d44a7c(data, {
            publicKey: publicKey,
            fileName: fileName,
            contentType: contentType,
            baseURL: baseURL,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            store: store,
            signal: signal,
            onProgress: onProgress,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            baseCDN: baseCDN,
            metadata: metadata
        });
    }
    if ($3905b2ce68ef12c7$var$isUrl(data)) return $3905b2ce68ef12c7$export$f5b9f3f82b877f1f(data, {
        publicKey: publicKey,
        fileName: fileName,
        baseURL: baseURL,
        baseCDN: baseCDN,
        checkForUrlDuplicates: checkForUrlDuplicates,
        saveUrlForRecurrentUploads: saveUrlForRecurrentUploads,
        secureSignature: secureSignature,
        secureExpire: secureExpire,
        store: store,
        signal: signal,
        onProgress: onProgress,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        pusherKey: pusherKey,
        metadata: metadata
    });
    if ($3905b2ce68ef12c7$var$isUuid(data)) return $3905b2ce68ef12c7$export$3bfa52b0ed198643(data, {
        publicKey: publicKey,
        fileName: fileName,
        baseURL: baseURL,
        signal: signal,
        onProgress: onProgress,
        source: source,
        integration: integration,
        userAgent: userAgent,
        retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
        retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
        baseCDN: baseCDN
    });
    throw new TypeError(`File uploading from "${data}" is not supported`);
}
class $3905b2ce68ef12c7$export$b13eb28553283718 {
    uuid;
    filesCount;
    totalSize;
    isStored;
    isImage;
    cdnUrl;
    files;
    createdAt;
    storedAt = null;
    constructor(groupInfo, { baseCDN: baseCDN = $3905b2ce68ef12c7$var$defaultSettings.baseCDN } = {}){
        this.uuid = groupInfo.id;
        this.filesCount = groupInfo.filesCount;
        const groupFiles = groupInfo.files.filter(Boolean);
        this.totalSize = Object.values(groupFiles).reduce((acc, file)=>acc + file.size, 0);
        this.isStored = !!groupInfo.datetimeStored;
        this.isImage = !!Object.values(groupFiles).filter((file)=>file.isImage).length;
        this.cdnUrl = groupInfo.cdnUrl;
        this.files = groupFiles.map((fileInfo)=>new $3905b2ce68ef12c7$export$92ff693e656b1c76(fileInfo, {
                baseCDN: baseCDN
            }));
        this.createdAt = groupInfo.datetimeCreated;
        this.storedAt = groupInfo.datetimeStored;
    }
}
/** FileData type guard. */ const $3905b2ce68ef12c7$var$isFileDataArray = (data)=>{
    for (const item of data){
        if (!$3905b2ce68ef12c7$var$isFileData(item)) return false;
    }
    return true;
};
/** Uuid type guard. */ const $3905b2ce68ef12c7$var$isUuidArray = (data)=>{
    for (const item of data){
        if (!$3905b2ce68ef12c7$var$isUuid(item)) return false;
    }
    return true;
};
/** Url type guard. */ const $3905b2ce68ef12c7$var$isUrlArray = (data)=>{
    for (const item of data){
        if (!$3905b2ce68ef12c7$var$isUrl(item)) return false;
    }
    return true;
};
function $3905b2ce68ef12c7$export$1116551e0a2a403c(data, { publicKey: publicKey, fileName: fileName, baseURL: baseURL = $3905b2ce68ef12c7$var$defaultSettings.baseURL, secureSignature: secureSignature, secureExpire: secureExpire, store: store, signal: signal, onProgress: onProgress, source: source, integration: integration, userAgent: userAgent, retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes, retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes, contentType: contentType, multipartChunkSize: multipartChunkSize = $3905b2ce68ef12c7$var$defaultSettings.multipartChunkSize, baseCDN: baseCDN = $3905b2ce68ef12c7$var$defaultSettings.baseCDN, checkForUrlDuplicates: checkForUrlDuplicates, saveUrlForRecurrentUploads: saveUrlForRecurrentUploads, jsonpCallback: jsonpCallback }) {
    if (!$3905b2ce68ef12c7$var$isFileDataArray(data) && !$3905b2ce68ef12c7$var$isUrlArray(data) && !$3905b2ce68ef12c7$var$isUuidArray(data)) throw new TypeError(`Group uploading from "${data}" is not supported`);
    let progressValues;
    let isStillComputable = true;
    const filesCount = data.length;
    const createProgressHandler = (size, index)=>{
        if (!onProgress) return;
        if (!progressValues) progressValues = Array(size).fill(0);
        const normalize = (values)=>values.reduce((sum, next)=>sum + next) / size;
        return (info)=>{
            if (!info.isComputable || !isStillComputable) {
                isStillComputable = false;
                onProgress({
                    isComputable: false
                });
                return;
            }
            progressValues[index] = info.value;
            onProgress({
                isComputable: true,
                value: normalize(progressValues)
            });
        };
    };
    return Promise.all(data.map((file, index)=>{
        if ($3905b2ce68ef12c7$var$isFileData(file) || $3905b2ce68ef12c7$var$isUrl(file)) return $3905b2ce68ef12c7$export$a5575dbeeffdad98(file, {
            publicKey: publicKey,
            fileName: fileName,
            baseURL: baseURL,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            store: store,
            signal: signal,
            onProgress: createProgressHandler(filesCount, index),
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes,
            contentType: contentType,
            multipartChunkSize: multipartChunkSize,
            baseCDN: baseCDN,
            checkForUrlDuplicates: checkForUrlDuplicates,
            saveUrlForRecurrentUploads: saveUrlForRecurrentUploads
        }).then((fileInfo)=>fileInfo.uuid);
        else // Do not request file info by uuid before creating group because this isn't necessary
        return file;
    })).then((uuids)=>{
        return $3905b2ce68ef12c7$export$e5e25fbcc1f7affe(uuids, {
            publicKey: publicKey,
            baseURL: baseURL,
            jsonpCallback: jsonpCallback,
            secureSignature: secureSignature,
            secureExpire: secureExpire,
            signal: signal,
            source: source,
            integration: integration,
            userAgent: userAgent,
            retryThrottledRequestMaxTimes: retryThrottledRequestMaxTimes,
            retryNetworkErrorMaxTimes: retryNetworkErrorMaxTimes
        }).then((groupInfo)=>new $3905b2ce68ef12c7$export$b13eb28553283718(groupInfo, {
                baseCDN: baseCDN
            })).then((group)=>{
            onProgress && onProgress({
                isComputable: true,
                value: 1
            });
            return group;
        });
    });
}
/** Populate options with settings. */ const $3905b2ce68ef12c7$var$populateOptionsWithSettings = (options, settings)=>({
        ...settings,
        ...options
    });
class $3905b2ce68ef12c7$export$4fe1226bcf692a6e {
    settings;
    constructor(settings){
        this.settings = Object.assign({}, $3905b2ce68ef12c7$var$defaultSettings, settings);
    }
    updateSettings(newSettings) {
        this.settings = Object.assign(this.settings, newSettings);
    }
    getSettings() {
        return this.settings;
    }
    base(file, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$e2253033e6e1df16(file, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    info(uuid, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$a80b3bd66acc52ff(uuid, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    fromUrl(sourceUrl, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$8344cc6f9c959d9b(sourceUrl, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    fromUrlStatus(token, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$11ce33276c18fc77(token, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    group(uuids, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$e5e25fbcc1f7affe(uuids, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    groupInfo(id, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$ff32046efef5c2f5(id, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    multipartStart(size, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$1afebf94ca4ea92e(size, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    multipartUpload(part, url, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$73b98a86a54f96ed(part, url, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    multipartComplete(uuid, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$54ca83d7986c917a(uuid, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    uploadFile(data, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$a5575dbeeffdad98(data, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    uploadFileGroup(data, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$1116551e0a2a403c(data, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
    isReadyPoll(uuid, options = {}) {
        const settings = this.getSettings();
        return $3905b2ce68ef12c7$export$8d1698d1c44a6cfa(uuid, $3905b2ce68ef12c7$var$populateOptionsWithSettings(options, settings));
    }
}
class $3905b2ce68ef12c7$export$3dc07afe418952bc {
    _concurrency = 1;
    _pending = [];
    _running = 0;
    _resolvers = new Map();
    _rejectors = new Map();
    constructor(concurrency){
        this._concurrency = concurrency;
    }
    _run() {
        const tasksLeft = this._concurrency - this._running;
        for(let i = 0; i < tasksLeft; i++){
            const task = this._pending.shift();
            if (!task) return;
            const resolver = this._resolvers.get(task);
            const rejector = this._rejectors.get(task);
            if (!resolver || !rejector) throw new Error("Unexpected behavior: resolver or rejector is undefined");
            this._running += 1;
            task().finally(()=>{
                this._resolvers.delete(task);
                this._rejectors.delete(task);
                this._running -= 1;
                this._run();
            }).then((value)=>resolver(value)).catch((error)=>rejector(error));
        }
    }
    add(task) {
        return new Promise((resolve, reject)=>{
            this._resolvers.set(task, resolve);
            this._rejectors.set(task, reject);
            this._pending.push(task);
            this._run();
        });
    }
    get pending() {
        return this._pending.length;
    }
    get running() {
        return this._running;
    }
    set concurrency(value) {
        this._concurrency = value;
        this._run();
    }
    get concurrency() {
        return this._concurrency;
    }
}
/* Low-Level API */ /** @deprecated Please use NetworkError instead. */ const $3905b2ce68ef12c7$export$4bec6bfd2c2d47c0 = $3905b2ce68ef12c7$export$bae979e68e4dc802;
/** @deprecated Please use UploadError instead. */ const $3905b2ce68ef12c7$export$2a2eb4af8e8eb7d1 = $3905b2ce68ef12c7$export$137ec66182ed30ea;


const $7f5f1305336629aa$export$769f81ea46f1d = ()=>({});
const $7f5f1305336629aa$export$b6eaf5cda4248fe4 = (fnCtx)=>({
        ...$7f5f1305336629aa$export$769f81ea46f1d(),
        "*currentActivity": null,
        "*currentActivityParams": {},
        "*history": [],
        "*historyBack": null,
        "*closeModal": ()=>{
            fnCtx.set$({
                "*currentActivity": null,
                "*modalActive": false
            });
        }
    });
const $7f5f1305336629aa$export$e6278a3220543f46 = (fnCtx)=>({
        ...$7f5f1305336629aa$export$b6eaf5cda4248fe4(fnCtx),
        "*commonProgress": 0,
        "*uploadList": [],
        "*uploadQueue": new (0, $3905b2ce68ef12c7$export$3dc07afe418952bc)(1),
        /** @type {ReturnType<import('../types').OutputErrorCollection>[]} */ "*collectionErrors": [],
        /** @type {import('../types').OutputCollectionState | null} */ "*collectionState": null,
        /** @type {import('@uploadcare/upload-client').UploadcareGroup | null} */ "*groupInfo": null,
        /** @type {Set<string>} */ "*uploadTrigger": new Set(),
        /** @type {import('./SecureUploadsManager.js').SecureUploadsManager | null} */ "*secureUploadsManager": null
    });


// @ts-check

// @ts-check
var $dbaf2fb881db190c$export$2e2bcd8739ae039 = {
    "locale-id": "en",
    "social-source-lang": "en",
    "upload-file": "Upload file",
    "upload-files": "Upload files",
    "choose-file": "Choose file",
    "choose-files": "Choose files",
    "drop-files-here": "Drop files here",
    "select-file-source": "Select file source",
    selected: "Selected",
    upload: "Upload",
    "add-more": "Add more",
    cancel: "Cancel",
    "start-from-cancel": "Cancel",
    clear: "Clear",
    "camera-shot": "Shot",
    "upload-url": "Import",
    "upload-url-placeholder": "Paste link here",
    "edit-image": "Edit image",
    "edit-detail": "Details",
    back: "Back",
    done: "Done",
    ok: "Ok",
    "remove-from-list": "Remove",
    no: "No",
    yes: "Yes",
    "confirm-your-action": "Confirm your action",
    "are-you-sure": "Are you sure?",
    "selected-count": "{{count}} of {{total}} selected",
    "select-all": "Select all",
    "deselect-all": "Deselect all",
    "upload-error": "Upload error",
    "validation-error": "Validation error",
    "no-files": "No files selected",
    browse: "Browse",
    "not-uploaded-yet": "Not uploaded yet...",
    file__one: "file",
    file__other: "files",
    error__one: "error",
    error__other: "errors",
    "header-uploading": "Uploading {{count}} {{plural:file(count)}}",
    "header-failed": "{{count}} {{plural:error(count)}}",
    "header-succeed": "{{count}} {{plural:file(count)}} uploaded",
    "header-total": "{{count}} {{plural:file(count)}} selected",
    "src-type-local": "From device",
    "src-type-from-url": "From link",
    "src-type-camera": "Camera",
    "src-type-mobile-video-camera": "Video",
    "src-type-mobile-photo-camera": "Photo",
    "src-type-draw": "Draw",
    "src-type-facebook": "Facebook",
    "src-type-dropbox": "Dropbox",
    "src-type-gdrive": "Google Drive",
    "src-type-gphotos": "Google Photos",
    "src-type-flickr": "Flickr",
    "src-type-vk": "VK",
    "src-type-evernote": "Evernote",
    "src-type-box": "Box",
    "src-type-onedrive": "Onedrive",
    "src-type-huddle": "Huddle",
    "src-type-other": "Other",
    "caption-from-url": "Import from link",
    "caption-camera": "Camera",
    "caption-draw": "Draw",
    "caption-edit-file": "Edit file",
    "file-no-name": "No name...",
    "toggle-fullscreen": "Toggle fullscreen",
    "toggle-guides": "Toggle guides",
    rotate: "Rotate",
    "flip-vertical": "Flip vertical",
    "flip-horizontal": "Flip horizontal",
    apply: "Apply",
    brightness: "Brightness",
    contrast: "Contrast",
    saturation: "Saturation",
    exposure: "Exposure",
    gamma: "Gamma",
    vibrance: "Vibrance",
    warmth: "Warmth",
    enhance: "Enhance",
    original: "Original",
    resize: "Resize image",
    crop: "Crop",
    "select-color": "Select color",
    text: "Text",
    draw: "Draw",
    "cancel-edit": "Cancel edit",
    "tab-view": "Preview",
    "tab-details": "Details",
    "file-name": "Name",
    "file-size": "Size",
    "cdn-url": "CDN URL",
    "file-size-unknown": "Unknown",
    "camera-permissions-denied": "Camera access denied",
    "camera-permissions-prompt": "Please allow access to the camera",
    "camera-permissions-request": "Request access",
    "files-count-limit-error-title": "Files count limit overflow",
    "files-count-limit-error-too-few": "You’ve chosen {{total}} {{plural:file(total)}}. At least {{min}} {{plural:file(min)}} required.",
    "files-count-limit-error-too-many": "You’ve chosen too many files. {{max}} {{plural:file(max)}} is maximum.",
    "files-max-size-limit-error": "File is too big. Max file size is {{maxFileSize}}.",
    "has-validation-errors": "File validation error occurred. Please, check your files before upload.",
    "images-only-accepted": "Only image files are accepted.",
    "file-type-not-allowed": "Uploading of these file types is not allowed.",
    "some-files-were-not-uploaded": "Some files were not uploaded.",
    "file-item-edit-button": "Edit",
    "file-item-remove-button": "Remove",
    "a11y-editor-tab-filters": "Filters",
    "a11y-editor-tab-tuning": "Tuning",
    "a11y-editor-tab-crop": "Crop",
    "a11y-activity-header-button-close": "Close",
    flip: "Flip",
    mirror: "Mirror",
    "a11y-cloud-editor-apply-filter": "Apply {{name}} filter",
    "a11y-cloud-editor-apply-crop": "Apply {{name}} operation",
    "a11y-cloud-editor-apply-tuning": "Apply {{name}} tuning",
    finished: "Finished",
    failed: "Failed",
    uploading: "Uploading",
    idle: "Idle",
    "a11y-file-item-status": "File {{fileName}} in status {{status}}",
    "waiting-for": "Waiting for {{source}}"
};


/** @type {Map<string, LocaleDefinition>} */ const $c83751a55e7f5b31$var$localeRegistry = new Map();
/** @type {Map<string, LocaleDefinitionResolver>} */ const $c83751a55e7f5b31$var$localeResolvers = new Map();
/** @typedef {Record<string, string>} LocaleDefinition */ /** @typedef {() => Promise<LocaleDefinition>} LocaleDefinitionResolver */ /**
 * @param {string} localeName
 * @param {LocaleDefinition} definition
 */ const $c83751a55e7f5b31$var$defineLocaleSync = (localeName, definition)=>{
    if ($c83751a55e7f5b31$var$localeRegistry.has(localeName)) console.log(`Locale ${localeName} is already defined. Overwriting...`);
    $c83751a55e7f5b31$var$localeRegistry.set(localeName, {
        ...(0, $dbaf2fb881db190c$export$2e2bcd8739ae039),
        ...definition
    });
};
/**
 * @param {string} localeName
 * @param {LocaleDefinitionResolver} definitionResolver
 */ const $c83751a55e7f5b31$var$defineLocaleAsync = (localeName, definitionResolver)=>{
    $c83751a55e7f5b31$var$localeResolvers.set(localeName, definitionResolver);
};
const $c83751a55e7f5b31$export$a3fd7fc2ccd6efa4 = (localeName, definitionOrResolver)=>{
    if (typeof definitionOrResolver === "function") $c83751a55e7f5b31$var$defineLocaleAsync(localeName, definitionOrResolver);
    else $c83751a55e7f5b31$var$defineLocaleSync(localeName, definitionOrResolver);
};
const $c83751a55e7f5b31$export$4ef12f5707c72a54 = async (localeName)=>{
    if (!$c83751a55e7f5b31$var$localeRegistry.has(localeName)) {
        if (!$c83751a55e7f5b31$var$localeResolvers.has(localeName)) throw new Error(`Locale ${localeName} is not defined`);
        const definitionResolver = /** @type {LocaleDefinitionResolver} */ $c83751a55e7f5b31$var$localeResolvers.get(localeName);
        const definition = await definitionResolver();
        $c83751a55e7f5b31$var$defineLocaleSync(localeName, definition);
    }
    return /** @type {LocaleDefinition} */ $c83751a55e7f5b31$var$localeRegistry.get(localeName);
};
$c83751a55e7f5b31$export$a3fd7fc2ccd6efa4("en", (0, $dbaf2fb881db190c$export$2e2bcd8739ae039));



const $1a4d0fdf706f38f0$export$cbff06bd40180ba8 = (key)=>`*l10n/${key}`;
const $1a4d0fdf706f38f0$export$1af4c7e47ad72f44 = "en";
class $1a4d0fdf706f38f0$export$9a5c40674650b7fa {
    /**
   * @private
   * @type {import('./Block.js').Block | null}
   */ _blockInstance = null;
    /** @private */ _localeName = "";
    /**
   * @private
   * @type {Set<() => void>}
   */ _callbacks = new Set();
    /**
   * @private
   * @type {Map<import('./Block.js').Block, Map<string, () => void>>}
   */ _boundBlocks = new Map();
    /** @param {import('./Block.js').Block} blockInstance */ constructor(blockInstance){
        this._blockInstance = blockInstance;
        for (let [key, value] of Object.entries((0, $dbaf2fb881db190c$export$2e2bcd8739ae039)))this._blockInstance.add($1a4d0fdf706f38f0$export$cbff06bd40180ba8(key), value, false);
        setTimeout(()=>{
            blockInstance.subConfigValue("localeName", async (localeName)=>{
                if (!this._blockInstance || !localeName) return;
                this._localeName = localeName;
                const definition = await (0, $c83751a55e7f5b31$export$4ef12f5707c72a54)(localeName);
                if (localeName !== $1a4d0fdf706f38f0$export$1af4c7e47ad72f44 && this._localeName !== localeName) return;
                const overrides = this._blockInstance.cfg.localeDefinitionOverride?.[localeName];
                for (const [key, value] of Object.entries(definition)){
                    const overriddenValue = overrides?.[key];
                    this._blockInstance.add($1a4d0fdf706f38f0$export$cbff06bd40180ba8(key), overriddenValue ?? value, true);
                    for (const callback of this._callbacks)callback();
                }
            });
            blockInstance.subConfigValue("localeDefinitionOverride", (localeDefinitionOverride)=>{
                if (!localeDefinitionOverride) return;
                const definition = localeDefinitionOverride[this._localeName];
                if (!definition) return;
                for (const [key, value] of Object.entries(definition)){
                    this._blockInstance?.add($1a4d0fdf706f38f0$export$cbff06bd40180ba8(key), value, true);
                    for (const callback of this._callbacks)callback();
                }
            });
        });
    }
    /**
   * @param {() => void} callback
   * @returns {() => void}
   */ onLocaleChange(callback) {
        const debouncedCb = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(callback, 0);
        this._callbacks.add(debouncedCb);
        return ()=>{
            this._callbacks.delete(debouncedCb);
        };
    }
    /**
   * @param {import('./Block.js').Block} block
   * @param {string} key
   * @param {() => void} resolver
   */ bindL10n(block, key, resolver) {
        block.$[key] = resolver();
        if (!this._boundBlocks.has(block)) this._boundBlocks.set(block, new Map());
        this._boundBlocks.get(block)?.get(key)?.();
        const destroyCallback = this.onLocaleChange(()=>{
            block.$[key] = resolver();
        });
        this._boundBlocks.get(block)?.set(key, destroyCallback);
    }
    /** @param {import('./Block.js').Block} block */ destroyL10nBindings(block) {
        const callbacks = this._boundBlocks.get(block);
        if (!callbacks) return;
        for (const callback of callbacks.values())callback();
        this._boundBlocks.delete(block);
    }
    destroy() {
        this._callbacks.clear();
    }
}


// @ts-check

function $3233ab69513c590c$export$8d48d87b0c41c5e0(fr, fnCtx) {
    [
        ...fr.querySelectorAll("[l10n]")
    ].forEach((el)=>{
        let key = el.getAttribute("l10n");
        if (!key) return;
        const list = key.split(";");
        for (const item of list)if (item) $3233ab69513c590c$var$locale(el, item, fnCtx);
    });
}
/**
 * @param {Element} el
 * @param {string} key
 * @param {any} fnCtx
 */ const $3233ab69513c590c$var$locale = (el, key, fnCtx)=>{
    let elProp = "textContent";
    let useAttribute = false;
    if (key.includes(":")) {
        const arr = key.split(":");
        elProp = arr[0];
        key = arr[1];
        if (elProp.startsWith("@")) {
            elProp = elProp.slice(1);
            useAttribute = true;
        }
    }
    // Check if the key is present in the local context
    const localCtxKey = key;
    if (fnCtx.has(localCtxKey)) fnCtx.sub(localCtxKey, (/** @type {string} */ mappedKey)=>{
        if (!mappedKey) return;
        // Store the subscription in a temporary map to be able to unsubscribe later
        if (!fnCtx.l10nProcessorSubs.has(localCtxKey)) fnCtx.l10nProcessorSubs.set(localCtxKey, new Set());
        const keySubs = fnCtx.l10nProcessorSubs.get(localCtxKey);
        keySubs?.forEach(/** @param {{ remove: () => void }} sub */ (sub)=>{
            sub.remove();
            keySubs.delete(sub);
            fnCtx.allSubs.delete(sub);
        });
        // We don't need the leading * in the key because we use the key as a local context key relative to the global state
        const nodeStateKey = (0, $1a4d0fdf706f38f0$export$cbff06bd40180ba8)(mappedKey).replace("*", "");
        // If the key is not present in the node context, add it
        if (!fnCtx.nodeCtx.has(nodeStateKey)) fnCtx.nodeCtx.add(nodeStateKey, mappedKey);
        // Subscribe on the global l10n key change
        const sub = fnCtx.nodeCtx.sub(nodeStateKey, ()=>{
            el[/** @type {'textContent'} */ elProp] = fnCtx.l10n(mappedKey);
        });
        keySubs?.add(sub);
        // Store the subscription in the global context to make able Symbiote to unsubscribe it on destroy
        fnCtx.allSubs.add(sub);
        el.removeAttribute("l10n");
    });
    // Otherwise, assume the key is in the global context
    const stateKey = (0, $1a4d0fdf706f38f0$export$cbff06bd40180ba8)(key);
    if (!fnCtx.has(stateKey)) fnCtx.add(stateKey, "");
    fnCtx.sub(stateKey, ()=>{
        /** @type {string} */ key;
        if (useAttribute) el.setAttribute(elProp, fnCtx.l10n(key));
        else el[/** @type {'textContent'} */ elProp] = fnCtx.l10n(key);
    });
    el.removeAttribute("l10n");
};


// @ts-check
/**
 * @template {keyof import('../types').ConfigType} T
 * @param {T} key
 * @returns {`*cfg/${T}`}
 */ const $93e58aaabbd81ebb$export$16930f9e982fa181 = (key)=>`*cfg/${key}`;


// @ts-check
const $113845b0160eeb00$var$ROLES = {
    button: [
        "toolbar"
    ],
    checkbox: [
        "toolbar"
    ],
    menuitem: [
        "menu",
        "menubar"
    ],
    option: [
        "listbox"
    ],
    tab: [
        "tablist"
    ]
};
function $113845b0160eeb00$var$focus(current, next) {
    next.tabIndex = 0;
    next.focus();
    current.tabIndex = -1;
}
function $113845b0160eeb00$var$findGroupNodeByEventTarget(target) {
    let itemRole = target.role || target.type || target.tagName;
    if (!itemRole) return null;
    let groupRoles = $113845b0160eeb00$var$ROLES[itemRole.toLowerCase()];
    if (!groupRoles) return null;
    for (let role of groupRoles){
        let node = target.closest(`[role=${role}]`);
        if (node) return node;
    }
}
function $113845b0160eeb00$var$getItems(target, group) {
    if (group.role === "toolbar") return $113845b0160eeb00$var$getToolbarItems(group);
    return group.querySelectorAll(`[role=${target.role}]`);
}
function $113845b0160eeb00$var$getToolbarItems(group) {
    let items = [
        ...group.querySelectorAll("*")
    ];
    return items.filter((item)=>{
        return item.role === "button" || item.type === "button" || item.role === "checkbox" || item.type === "checkbox";
    });
}
function $113845b0160eeb00$var$isHorizontalOrientation(group) {
    let ariaOrientation = group.getAttribute("aria-orientation");
    if (ariaOrientation === "vertical") return false;
    if (ariaOrientation === "horizontal") return true;
    let role = group.role;
    return role === "menubar" || role === "tablist" || role === "toolbar";
}
function $113845b0160eeb00$export$4036317dc850fbde(options) {
    return (window)=>{
        let inGroup = false;
        let typingDelayMs = options?.searchDelayMs || 300;
        let lastTyped = 0;
        let searchPrefix = "";
        function keyDown(event) {
            let group = $113845b0160eeb00$var$findGroupNodeByEventTarget(event.target);
            if (!group) {
                stop();
                return;
            }
            let items = $113845b0160eeb00$var$getItems(event.target, group);
            let index = Array.from(items).indexOf(event.target);
            let nextKey = "ArrowDown";
            let prevKey = "ArrowUp";
            if ($113845b0160eeb00$var$isHorizontalOrientation(group)) {
                if (window.document.dir === "rtl") {
                    nextKey = "ArrowLeft";
                    prevKey = "ArrowRight";
                } else {
                    nextKey = "ArrowRight";
                    prevKey = "ArrowLeft";
                }
            }
            if (event.key === nextKey) {
                event.preventDefault();
                $113845b0160eeb00$var$focus(event.target, items[index + 1] || items[0]);
            } else if (event.key === prevKey) {
                event.preventDefault();
                $113845b0160eeb00$var$focus(event.target, items[index - 1] || items[items.length - 1]);
            } else if (event.key === "Home") {
                event.preventDefault();
                $113845b0160eeb00$var$focus(event.target, items[0]);
            } else if (event.key === "End") {
                event.preventDefault();
                $113845b0160eeb00$var$focus(event.target, items[items.length - 1]);
            } else if (event.key.length === 1 && group.role !== "tablist") {
                let now = Date.now();
                if (now - lastTyped <= typingDelayMs) searchPrefix += event.key.toLowerCase();
                else searchPrefix = event.key.toLowerCase();
                lastTyped = now;
                let found = Array.from(items).find((item)=>{
                    return item.textContent?.trim()?.toLowerCase()?.startsWith(searchPrefix);
                });
                if (found) {
                    event.preventDefault();
                    $113845b0160eeb00$var$focus(event.target, found);
                }
            }
        }
        function stop() {
            inGroup = false;
            window.removeEventListener("keydown", keyDown);
        }
        function focusIn(event) {
            let group = $113845b0160eeb00$var$findGroupNodeByEventTarget(event.target);
            if (group) {
                if (!inGroup) {
                    inGroup = true;
                    window.addEventListener("keydown", keyDown);
                }
                let items = $113845b0160eeb00$var$getItems(event.target, group);
                for (let item of items)if (item !== event.target) item.setAttribute("tabindex", -1);
            } else if (inGroup) stop();
        }
        function focusOut(event) {
            if (!event.relatedTarget || event.relatedTarget === window.document) stop();
        }
        function click(event) {
            let group = $113845b0160eeb00$var$findGroupNodeByEventTarget(event.target);
            if (group) {
                let items = $113845b0160eeb00$var$getItems(event.target, group);
                for (let item of items)if (item !== event.target) item.setAttribute("tabindex", -1);
                event.target.setAttribute("tabindex", 0);
            }
        }
        window.addEventListener("click", click);
        window.addEventListener("focusin", focusIn);
        window.addEventListener("focusout", focusOut);
        return ()=>{
            stop();
            window.removeEventListener("click", click);
            window.removeEventListener("focusin", focusIn);
            window.removeEventListener("focusout", focusOut);
        };
    };
}

function $00b4ba2af40ee582$export$ea652582f199fdc1() {
    return (window)=>{
        let allowed;
        let wasHidden;
        function jump(e) {
            if (e.target.getAttribute("aria-hidden") === "true") {
                allowed = e.target;
                allowed.setAttribute("aria-hidden", "false");
                wasHidden = allowed.hidden;
                if (wasHidden) allowed.hidden = false;
                let first = e.target.querySelector('a, button, select, textarea, input:not([type=radio]), [type=radio]:checked, [tabindex]:not([tabindex="-1"])');
                if (first) first.tabIndex = 0;
            }
        }
        function focusOut(e) {
            if (allowed && allowed.contains(e.target) && (!e.relatedTarget || !allowed.contains(e.relatedTarget))) {
                e.target.tabIndex = -1;
                allowed.setAttribute("aria-hidden", "true");
                if (wasHidden) allowed.hidden = true;
                allowed = null;
            }
        }
        window.addEventListener("keyuxJump", jump);
        window.addEventListener("focusout", focusOut);
        return ()=>{
            window.removeEventListener("keyuxJump", jump);
            window.removeEventListener("focusout", focusOut);
        };
    };
}

function $e83e6706ed96e2c3$export$864a0fab0956aa50() {
    return (window)=>{
        let jumps = [];
        function focus(next) {
            let current = window.document.activeElement;
            if (current && current !== window.document.body) jumps.push(new WeakRef(current));
            next.focus({
                focusVisible: true
            });
        }
        function back() {
            let ref = jumps.pop();
            if (!ref) {
                window.document.activeElement.blur();
                return;
            }
            let el = ref.deref();
            if (el && el.isConnected) el.focus();
            else back();
        }
        let tries = 0;
        let finding;
        function jump(from) {
            clearInterval(finding);
            let ariaControls = from.getAttribute("aria-controls");
            finding = setInterval(()=>{
                if (tries++ > 50) {
                    clearInterval(finding);
                    return;
                }
                let area = window.document.getElementById(ariaControls);
                if (area) {
                    let next = area.querySelector('a, button, select, textarea, input:not([type=radio]), [type=radio]:checked, [tabindex]:not([tabindex="-1"])');
                    if (next) {
                        clearInterval(finding);
                        area.dispatchEvent(new window.CustomEvent("keyuxJump", {
                            bubbles: true
                        }));
                        focus(next);
                    }
                }
            }, 50);
        }
        function keyDown(event) {
            if (event.target.getAttribute("aria-controls")) {
                if (event.key === "Enter") jump(event.target);
            }
            if (event.key === "Escape") back();
        }
        window.addEventListener("keydown", keyDown);
        return ()=>{
            window.removeEventListener("keydown", keyDown);
        };
    };
}

function $8aaba0555b282d0c$export$55f718a52d0a3da3(pressedClass) {
    let pressedElement;
    let classes = pressedClass.split(" ");
    let down;
    function keyDown(event) {
        if (event.key === "Enter" && (event.target.tagName === "BUTTON" || event.target.tagName === "A")) {
            keyUp();
            event.target.classList.add(...classes);
            pressedElement = event.target;
            down = event.target;
        }
    }
    function keyUp() {
        if (pressedElement) pressedElement.classList.remove(...classes);
        down = null;
    }
    function click(event) {
        if (event.clientX === 0 && event.clientY === 0) {
            if (down !== event.target) {
                keyUp();
                event.target.classList.add(...classes);
                pressedElement = event.target;
            }
        }
    }
    return (window)=>{
        window.addEventListener("click", click);
        window.addEventListener("keydown", keyDown);
        window.addEventListener("keyup", keyUp);
        return ()=>{
            window.removeEventListener("click", click);
            window.removeEventListener("keydown", keyDown);
            window.removeEventListener("keyup", keyUp);
        };
    };
}








function $e2e2f0de788aca68$export$b67d050b31c150c4(window, plugins) {
    let unbinds = plugins.map((plugin)=>plugin(window));
    return ()=>{
        unbinds.forEach((unbind)=>unbind());
    };
}
function $e2e2f0de788aca68$export$f9480bf69ccef5e1(window = globalThis) {
    let agent = window.navigator.userAgent.toLowerCase();
    return ![
        "iphone",
        "ipad",
        "android"
    ].some((device)=>agent.includes(device));
}
function $e2e2f0de788aca68$export$94f3bebd7f1cb96f(window, code, transformers = []) {
    let realCode = code;
    for (let transformer of transformers)realCode = transformer[1](realCode, window, "r");
    let prettyParts = realCode.split("+").map((part)=>part[0].toUpperCase() + part.slice(1));
    if (window.navigator.platform.indexOf("Mac") === 0) return prettyParts.join("").replace(/(.*)Meta(.*)/, "⌘ $1$2").replace(/(.*)Shift(.*)/, "⇧ $1$2").replace(/(.*)Alt(.*)/, "⌥ $1$2").replace(/(.*)Ctrl(.*)/, "⌃ $1$2");
    else return prettyParts.join(" + ");
}


/**
 * MinimalWindow interface is not exported by keyux, so we import it here using tricky way.
 *
 * @typedef {Parameters<import('keyux').KeyUXModule>[0]} MinimalWindow
 */ /**
 * This is global window wrapper that allows to scope event listeners to a specific part of the DOM.
 *
 * It is used to scope the key UX to the widget.
 *
 * @implements {MinimalWindow}
 */ class $d349d6a6f92c7c8d$var$ScopedMinimalWindow {
    /**
   * @private
   * @type {Map<Function, (event: Event) => void>}
   */ _listeners = new Map();
    /**
   * @private
   * @type {Node[]}
   */ _scope = [];
    /**
   * @param {'keydown' | 'keyup'} type
   * @param {(event: Event) => void} listener
   */ addEventListener(type, listener) {
        /** @param {Event} e */ const wrappedListener = (e)=>{
            const target = e.target;
            if (!target) return;
            if (this._scope.some((el)=>el === e.target || el.contains(/** @type {Node} */ target))) listener(e);
        };
        this._listeners.set(listener, wrappedListener);
        window.addEventListener(type, wrappedListener);
    }
    /**
   * @param {'keydown' | 'keyup'} type
   * @param {(event: {}) => void} listener
   */ removeEventListener(type, listener) {
        const wrappedListener = this._listeners.get(listener);
        if (wrappedListener) window.removeEventListener(type, wrappedListener);
        this._listeners.delete(listener);
    }
    get CustomEvent() {
        return window.CustomEvent;
    }
    get document() {
        return window.document;
    }
    get navigator() {
        return window.navigator;
    }
    /** @param {Node} scope */ registerScope(scope) {
        this._scope.push(scope);
    }
    destroy() {
        this._scope = [];
        this._listeners.forEach((listener, originalListener)=>{
            window.removeEventListener("keydown", listener);
            window.removeEventListener("keyup", listener);
            this._listeners.delete(originalListener);
        });
    }
}
class $d349d6a6f92c7c8d$export$449db1cfb4dcf84e {
    /**
   * @private
   * @type {(() => void) | undefined}
   */ _destroyKeyUX;
    /**
   * @private
   * @type {ScopedMinimalWindow}
   */ _scopedWindow;
    constructor(){
        this._scopedWindow = new $d349d6a6f92c7c8d$var$ScopedMinimalWindow();
        this._destroyKeyUX = (0, $e2e2f0de788aca68$export$b67d050b31c150c4)(this._scopedWindow, [
            (0, $113845b0160eeb00$export$4036317dc850fbde)(),
            (0, $8aaba0555b282d0c$export$55f718a52d0a3da3)("is-pressed"),
            (0, $e83e6706ed96e2c3$export$864a0fab0956aa50)(),
            (0, $00b4ba2af40ee582$export$ea652582f199fdc1)()
        ]);
    }
    /** @param {import('./Block.js').Block} scope */ registerBlock(scope) {
        this._scopedWindow.registerScope(scope);
    }
    destroy() {
        this._destroyKeyUX?.();
        this._scopedWindow.destroy();
    }
}


const $07ad8cbe44b14bef$var$TAG_PREFIX = "uc-";
class $07ad8cbe44b14bef$export$d96a8827a60d6b69 extends (0, $7868cd5b229e5c15$export$55ae5207ce896a6b) {
    /** @type {string | null} */ static StateConsumerScope = null;
    /** @type {string[]} */ static styleAttrs = [];
    /** @protected */ requireCtxName = false;
    /** @type {import('./ActivityBlock.js').ActivityType} */ activityType = null;
    init$ = (0, $7f5f1305336629aa$export$769f81ea46f1d)();
    /**
   * @param {String} str
   * @param {{ [key: string]: string | number }} variables
   * @returns {String}
   */ l10n(str, variables = {}) {
        if (!str) return "";
        let template = this.$[(0, $1a4d0fdf706f38f0$export$cbff06bd40180ba8)(str)] || str;
        let pluralObjects = (0, $0d29a7eceb5ca5dd$export$eabb0be5d19ba097)(template);
        for (let pluralObject of pluralObjects)variables[pluralObject.variable] = this.pluralize(pluralObject.pluralKey, Number(variables[pluralObject.countVariable]));
        let result = (0, $0d29a7eceb5ca5dd$export$34afab4d3a450b60)(template, variables);
        return result;
    }
    /**
   * @private
   * @param {string} key
   * @param {number} count
   * @returns {string}
   */ pluralize(key, count) {
        const locale = this.l10n("locale-id") || "en";
        const pluralForm = (0, $afa2c82b84d64c9d$export$9f3f0d2d02951501)(locale, count);
        return this.l10n(`${key}__${pluralForm}`);
    }
    /**
   * @param {string} key
   * @param {() => void} resolver
   * @protected
   */ bindL10n(key, resolver) {
        this.localeManager?.bindL10n(this, key, resolver);
    }
    constructor(){
        super();
        /** @type {Map<string, Set<{ remove: () => void }>>} */ this.l10nProcessorSubs = new Map();
        // @ts-ignore TODO: fix this
        this.addTemplateProcessor((0, $3233ab69513c590c$export$8d48d87b0c41c5e0));
    }
    /**
   * @param {Parameters<import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter['emit']>[0]} type
   * @param {Parameters<import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter['emit']>[1]} [payload]
   * @param {Parameters<import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter['emit']>[2]} [options]
   */ emit(type, payload, options) {
        /** @type {import('../blocks/UploadCtxProvider/EventEmitter.js').EventEmitter} */ const eventEmitter = this.has("*eventEmitter") && this.$["*eventEmitter"];
        if (!eventEmitter) return;
        eventEmitter.emit(type, payload, options);
    }
    /**
   * @param {(block: Block) => boolean} callback
   * @returns {Boolean}
   */ hasBlockInCtx(callback) {
        for (let block of this.blocksRegistry){
            if (callback(block)) return true;
        }
        return false;
    }
    /**
   * @param {String} prop
   * @param {any} newVal
   */ setOrAddState(prop, newVal) {
        this.add$({
            [prop]: newVal
        }, true);
    }
    /** @protected */ connectedCallback() {
        const styleAttrs = /** @type {typeof Block} */ this.constructor.styleAttrs;
        styleAttrs.forEach((attr)=>{
            this.setAttribute(attr, "");
        });
        if (this.hasAttribute("retpl")) {
            // @ts-ignore TODO: fix this
            this.constructor["template"] = null;
            this.processInnerHtml = true;
        }
        if (this.requireCtxName) (0, $f288d94b4e2e622a$export$bf3e2014f0f6687e)({
            element: this,
            attribute: "ctx-name",
            onSuccess: ()=>{
                // async wait for ctx-name attribute to be set, needed for Angular because it sets attributes after mount
                // TODO: should be moved to the symbiote core
                super.connectedCallback();
            },
            onTimeout: ()=>{
                console.error("Attribute `ctx-name` is required and it is not set.");
            }
        });
        else super.connectedCallback();
        (0, $eafdc04e5c65e8bf$export$164c1ecdf58fbaaa).registerClient(this);
    }
    /** @protected */ disconnectedCallback() {
        super.disconnectedCallback();
        (0, $eafdc04e5c65e8bf$export$164c1ecdf58fbaaa).unregisterClient(this);
    }
    /** @protected */ initCallback() {
        if (!this.has("*blocksRegistry")) this.add("*blocksRegistry", new Set());
        let blocksRegistry = this.$["*blocksRegistry"];
        blocksRegistry.add(this);
        if (!this.has("*eventEmitter")) this.add("*eventEmitter", new (0, $068cac2d61e2e514$export$4fae95256245c8c0)(this.debugPrint.bind(this)));
        if (!this.has("*localeManager")) this.add("*localeManager", new (0, $1a4d0fdf706f38f0$export$9a5c40674650b7fa)(this));
        if (!this.has("*a11y")) this.add("*a11y", new (0, $d349d6a6f92c7c8d$export$449db1cfb4dcf84e)());
        this.sub((0, $1a4d0fdf706f38f0$export$cbff06bd40180ba8)("locale-id"), (localeId)=>{
            const direction = (0, $da808ba176947d84$export$13de19f8f61a4abf)(localeId);
            this.style.direction = direction === "ltr" ? "" : direction;
        });
    }
    /**
   * @private
   * @returns {LocaleManager | null}
   */ get localeManager() {
        return this.has("*localeManager") ? this.$["*localeManager"] : null;
    }
    /**
   * @returns {A11y | null}
   * @protected
   */ get a11y() {
        return this.has("*a11y") ? this.$["*a11y"] : null;
    }
    /** @type {Set<Block>} */ get blocksRegistry() {
        return this.$["*blocksRegistry"];
    }
    /** @protected */ destroyCallback() {
        super.destroyCallback();
        let blocksRegistry = this.blocksRegistry;
        blocksRegistry?.delete(this);
        this.localeManager?.destroyL10nBindings(this);
        this.l10nProcessorSubs = new Map();
        // Destroy local context
        // TODO: this should be done inside symbiote
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this);
        if (blocksRegistry?.size === 0) setTimeout(()=>{
            // Destroy global context after all blocks are destroyed and all callbacks are run
            this.destroyCtxCallback();
        }, 0);
    }
    /**
   * Called when the last block is removed from the context. Note that inheritors must run their callback before that.
   *
   * @protected
   */ destroyCtxCallback() {
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this.ctxName);
        this.localeManager?.destroy();
    }
    /**
   * @param {String} url
   * @returns {Promise<String>}
   * @protected
   */ async proxyUrl(url) {
        if (this.cfg.secureDeliveryProxy && this.cfg.secureDeliveryProxyUrlResolver) console.warn("Both secureDeliveryProxy and secureDeliveryProxyUrlResolver are set. The secureDeliveryProxyUrlResolver will be used.");
        if (this.cfg.secureDeliveryProxyUrlResolver) try {
            return await this.cfg.secureDeliveryProxyUrlResolver(url, {
                uuid: (0, $8c66713b0e57faf9$export$fe804a22e4bdd033)(url),
                cdnUrlModifiers: (0, $8c66713b0e57faf9$export$e4e3902b46c7d465)(url),
                fileName: (0, $8c66713b0e57faf9$export$33da1e69df17c6c)(url)
            });
        } catch (err) {
            console.error("Failed to resolve secure delivery proxy URL. Falling back to the default URL.", err);
            return url;
        }
        if (this.cfg.secureDeliveryProxy) return (0, $0d29a7eceb5ca5dd$export$34afab4d3a450b60)(this.cfg.secureDeliveryProxy, {
            previewUrl: url
        }, {
            transform: (value)=>window.encodeURIComponent(value)
        });
        return url;
    }
    /** @returns {import('../types').ConfigType} } */ get cfg() {
        if (!this.__cfgProxy) {
            let o = Object.create(null);
            /** @private */ this.__cfgProxy = new Proxy(o, {
                set: (obj, key, value)=>{
                    if (typeof key !== "string") return false;
                    const sharedKey = (0, $93e58aaabbd81ebb$export$16930f9e982fa181)(/** @type {keyof import('../types').ConfigType} */ key);
                    if (!this.has(sharedKey)) this.add(sharedKey, (0, $de12e36881279399$export$288021aefa12c882)[/** @type {keyof import('../types').ConfigType} */ key]);
                    this.$[sharedKey] = value;
                    return true;
                },
                /**
         * @param {never} obj
         * @param {keyof import('../types').ConfigType} key
         */ get: (obj, key)=>{
                    const sharedKey = (0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key);
                    if (!this.has(sharedKey)) this.add(sharedKey, (0, $de12e36881279399$export$288021aefa12c882)[key]);
                    return this.$[(0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key)];
                }
            });
        }
        return this.__cfgProxy;
    }
    /**
   * @template {keyof import('../types').ConfigType} T
   * @param {T} key
   * @param {(value: import('../types').ConfigType[T]) => void} callback
   */ subConfigValue(key, callback) {
        const sharedKey = (0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key);
        if (!this.has(sharedKey)) this.add(sharedKey, (0, $de12e36881279399$export$288021aefa12c882)[key]);
        this.sub(sharedKey, callback);
    }
    /** @param {unknown[]} args */ debugPrint(...args) {
        if (!this.cfg.debug) return;
        let consoleArgs = args;
        if (typeof args?.[0] === "function") {
            const resolver = args[0];
            consoleArgs = resolver();
        }
        console.log(`[${this.ctxName}]`, ...consoleArgs);
    }
    /** @param {String} [name] */ static reg(name) {
        if (!name) {
            super.reg();
            return;
        }
        if (name.startsWith($07ad8cbe44b14bef$var$TAG_PREFIX)) super.reg(name);
    }
}


var $9e528c2cfed3abf6$export$2e2bcd8739ae039 = "<svg width='0' height='0' style='position:absolute'><symbol viewBox='0 0 24 24' id='uc-icon-about' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M11.152 14.12v.1h1.523v-.1c.007-.409.053-.752.138-1.028.086-.277.22-.517.405-.72.188-.202.434-.397.735-.586.32-.191.593-.412.82-.66.232-.249.41-.531.533-.847.125-.32.187-.678.187-1.076 0-.579-.137-1.085-.41-1.518a2.717 2.717 0 0 0-1.14-1.018c-.49-.245-1.062-.367-1.715-.367-.597 0-1.142.114-1.636.34-.49.228-.884.564-1.182 1.008-.299.44-.46.98-.485 1.619h1.62c.024-.377.118-.684.282-.922a1.48 1.48 0 0 1 .617-.532c.25-.114.51-.17.784-.17.301 0 .575.063.82.191.248.124.447.302.597.533.149.23.223.504.223.82 0 .263-.05.502-.149.72a1.91 1.91 0 0 1-.405.574 3.48 3.48 0 0 1-.575.453 4.22 4.22 0 0 0-.847.66c-.234.242-.415.558-.543.949-.125.39-.19.916-.197 1.577Zm.053 3.03c.21.206.46.31.75.31.196 0 .374-.049.534-.144a1.1 1.1 0 0 0 .383-.384c.1-.163.15-.343.15-.538a1 1 0 0 0-.32-.746 1.019 1.019 0 0 0-.746-.314c-.291 0-.542.105-.751.314-.21.206-.314.455-.314.746 0 .295.104.547.314.756ZM24 12c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12Zm-1.5 0c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-add' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M12.75 21a.75.75 0 0 1-1.5 0v-8.25H3a.75.75 0 0 1 0-1.5h8.25V3a.75.75 0 0 1 1.5 0v8.25H21a.75.75 0 0 1 0 1.5h-8.25V21Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-arrow-down' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M11.5 23.03a.75.75 0 0 0 .999 0l9.29-8.276a.75.75 0 0 0-.998-1.12l-8.042 7.164V1.53a.75.75 0 0 0-1.5 0v19.267l-8.04-7.163a.75.75 0 0 0-.998 1.12z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-back' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M20.251 12a.75.75 0 0 1-.75.75H6.067l5.72 5.85a.75.75 0 1 1-1.072 1.05L4.136 12.92a1.292 1.292 0 0 1 0-1.842l6.579-6.728a.75.75 0 1 1 1.072 1.048l-5.72 5.851H19.5a.75.75 0 0 1 .75.75Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-badge-error' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M13.6 18.4a1.6 1.6 0 1 1-3.2 0 1.6 1.6 0 0 1 3.2 0zM12 4.5A1.5 1.5 0 0 1 13.5 6v7a1.5 1.5 0 0 1-3 0V6A1.5 1.5 0 0 1 12 4.5z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-badge-success' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='m10.5 18.204 7.6-8.183a1.5 1.5 0 0 0-2.2-2.042l-5.4 5.817-2.4-2.586a1.5 1.5 0 1 0-2.2 2.041l4.6 4.953Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-box' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M1.01 4.148a.75.75 0 0 1 .75.75v4.348a4.437 4.437 0 0 1 2.988-1.153c1.734 0 3.23.992 3.978 2.438a4.478 4.478 0 0 1 3.978-2.438c2.49 0 4.488 2.044 4.488 4.543 0 2.5-1.999 4.544-4.488 4.544a4.478 4.478 0 0 1-3.978-2.438 4.478 4.478 0 0 1-3.978 2.438C2.26 17.18.26 15.135.26 12.636V4.898a.75.75 0 0 1 .75-.75Zm.75 8.488c0 1.692 1.348 3.044 2.988 3.044s2.989-1.352 2.989-3.044c0-1.691-1.349-3.043-2.989-3.043S1.76 10.945 1.76 12.636Zm10.944-3.043c-1.64 0-2.988 1.352-2.988 3.043 0 1.692 1.348 3.044 2.988 3.044s2.988-1.352 2.988-3.044c0-1.69-1.348-3.043-2.988-3.043Zm4.328-1.23a.75.75 0 0 1 1.052.128l2.333 2.983 2.333-2.983a.75.75 0 0 1 1.181.924l-2.562 3.277 2.562 3.276a.75.75 0 1 1-1.181.924l-2.333-2.983-2.333 2.983a.75.75 0 1 1-1.181-.924l2.562-3.276-2.562-3.277a.75.75 0 0 1 .129-1.052Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-camera' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M7.65 2.55a.75.75 0 0 1 .6-.3h7.5a.75.75 0 0 1 .6.3l2.025 2.7H21a3 3 0 0 1 3 3v10.5a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h2.625zm.975 1.2L6.6 6.45a.75.75 0 0 1-.6.3H3a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5V8.25a1.5 1.5 0 0 0-1.5-1.5h-3a.75.75 0 0 1-.6-.3l-2.025-2.7zm3.375 6a3.375 3.375 0 1 0 0 6.75 3.375 3.375 0 0 0 0-6.75zm-4.875 3.375a4.875 4.875 0 1 1 9.75 0 4.875 4.875 0 0 1-9.75 0z'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-camera-full' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M2 4.667a2 2 0 0 0-2 2V16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6.667a2 2 0 0 0-2-2h-2.667l-2-2.667H6.667l-2 2.667H2Zm8 10a3.667 3.667 0 1 0 0-7.334 3.667 3.667 0 0 0 0 7.334Z' fill='currentColor'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-close' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M4.604 4.604a.75.75 0 0 1 1.06 0L12 10.939l6.335-6.335a.75.75 0 1 1 1.061 1.06L13.061 12l6.335 6.335a.75.75 0 1 1-1.06 1.061L12 13.061l-6.335 6.335a.75.75 0 0 1-1.061-1.06L10.939 12 4.604 5.665a.75.75 0 0 1 0-1.061z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-collapse' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M3.116 12a.75.75 0 0 1 .75-.75h16.268a.75.75 0 0 1 0 1.5H3.866a.75.75 0 0 1-.75-.75Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-default' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M11.501.392a.75.75 0 0 1 .998 0l6.704 5.972a.75.75 0 0 1-.998 1.12l-5.455-4.86v13.439a.75.75 0 0 1-1.5 0V2.625l-5.454 4.86a.75.75 0 1 1-.998-1.12zM.857 16.73a.75.75 0 0 1 .75.75v4.914h20.786v-4.914a.75.75 0 0 1 1.5 0v5.664a.75.75 0 0 1-.75.75H.857a.75.75 0 0 1-.75-.75v-5.664a.75.75 0 0 1 .75-.75z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-dropbox' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M6.019 1.92a.75.75 0 0 1 .806 0L12 5.219l5.176-3.297a.75.75 0 0 1 .806 0l5.577 3.553a.75.75 0 0 1 0 1.265l-4.574 2.914 4.574 2.914a.75.75 0 0 1 0 1.265l-5.577 3.554a.75.75 0 0 1-.806 0L12 14.089l-5.175 3.297a.75.75 0 0 1-.806 0L.44 13.833a.75.75 0 0 1 0-1.266l4.575-2.914L.44 6.74a.75.75 0 0 1 0-1.265zm.403 8.616L2.24 13.2l4.182 2.664 4.181-2.664zm6.975 2.664 4.182 2.664L21.76 13.2l-4.181-2.664zm2.776-3.547L12 12.311 7.828 9.653 12 6.995zm1.406-.882 4.181-2.664-4.181-2.664-4.182 2.664zm-6.976-2.664L6.422 3.443 2.24 6.107 6.422 8.77zM5.791 18.544a.75.75 0 0 1 1.035-.23l5.175 3.297 5.175-3.297a.75.75 0 1 1 .806 1.265l-5.578 3.554a.75.75 0 0 1-.806 0L6.02 19.579a.75.75 0 0 1-.23-1.035z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-edit-file' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M18.558 2.804a.78.78 0 0 0-.557.235l-.008.007-2.472 2.46 3.847 3.848 2.46-2.473.004-.003a.78.78 0 0 0 0-1.108l-.004-.003-2.712-2.728a.78.78 0 0 0-.558-.235Zm-.248 7.613-3.852-3.852-8.93 8.887-1.516 5.41 5.41-1.515 8.888-8.93Zm-.636-8.934a2.28 2.28 0 0 1 2.512.505l2.702 2.717.002.002a2.278 2.278 0 0 1 0 3.234l-.002.002-12.541 12.602a.75.75 0 0 1-.33.193l-6.884 1.928a.75.75 0 0 1-.925-.924l1.928-6.885a.75.75 0 0 1 .193-.33l12.603-12.54a2.28 2.28 0 0 1 .742-.504Z' clip-rule='evenodd'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-error' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M13 13h-2V7h2m0 10h-2v-2h2M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-evernote' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M9.804 2.27v-.048c.055-.263.313-.562.85-.562h.44c.142 0 .325.014.526.033.066.009.124.023.267.06l.13.032h.002c.319.079.515.275.644.482a1.461 1.461 0 0 1 .16.356l.004.012a.75.75 0 0 0 .603.577l1.191.207a1988.512 1988.512 0 0 0 2.332.402c.512.083 1.1.178 1.665.442.64.3 1.19.795 1.376 1.77.548 2.931.657 5.829.621 8a39.233 39.233 0 0 1-.125 2.602 17.518 17.518 0 0 1-.092.849.735.735 0 0 0-.024.112c-.378 2.705-1.269 3.796-2.04 4.27-.746.457-1.53.451-2.217.447h-.192c-.46 0-1.073-.23-1.581-.635-.518-.412-.763-.87-.763-1.217 0-.45.188-.688.355-.786.161-.095.436-.137.796.087a.75.75 0 1 0 .792-1.274c-.766-.476-1.64-.52-2.345-.108-.7.409-1.098 1.188-1.098 2.08 0 .996.634 1.84 1.329 2.392.704.56 1.638.96 2.515.96l.185.002c.667.009 1.874.025 3.007-.67 1.283-.786 2.314-2.358 2.733-5.276a4.213 4.213 0 0 0 .056-.335c.023-.184.051-.445.079-.772.055-.655.111-1.585.13-2.704.037-2.234-.074-5.239-.647-8.301v-.002c-.294-1.544-1.233-2.391-2.215-2.85-.777-.363-1.623-.496-2.129-.576a8.872 8.872 0 0 1-.25-.041l-.006-.001-1.99-.345-.761-.132a2.93 2.93 0 0 0-.182-.338A2.532 2.532 0 0 0 12.379.329l-.091-.023a3.967 3.967 0 0 0-.493-.103L11.769.2a7.846 7.846 0 0 0-.675-.04h-.44c-.733 0-1.368.284-1.795.742L2.416 7.431c-.468.428-.751 1.071-.751 1.81 0 .02 0 .041.003.062l.003.034c.017.21.038.468.096.796.107.715.275 1.47.391 1.994.029.13.055.245.075.342l.002.008c.258 1.141.641 1.94.978 2.466.168.263.323.456.444.589a2.808 2.808 0 0 0 .192.194c1.536 1.562 3.713 2.196 5.731 2.08.13-.005.35-.032.537-.073a2.627 2.627 0 0 0 .652-.24c.425-.26.75-.661.992-1.046.184-.294.342-.61.473-.915a3.8 3.8 0 0 0 .627.493 5.022 5.022 0 0 0 1.97.709l.023.002.018.003.11.016c.088.014.205.035.325.058l.056.014c.088.022.164.04.235.061a1.736 1.736 0 0 1 .145.048l.03.014c.765.34 1.302 1.09 1.302 1.871a.75.75 0 0 0 1.5 0c0-1.456-.964-2.69-2.18-3.235a3.595 3.595 0 0 0-.679-.217l-.063-.015a10.616 10.616 0 0 0-.606-.105l-.02-.003-.03-.003h-.002a3.542 3.542 0 0 1-1.331-.485c-.471-.298-.788-.692-.828-1.234a.75.75 0 0 0-1.48-.106l-.001.003-.004.017a8.23 8.23 0 0 1-.092.352 9.963 9.963 0 0 1-.298.892c-.132.34-.29.68-.47.966-.174.276-.339.454-.478.549a1.178 1.178 0 0 1-.221.072 1.949 1.949 0 0 1-.241.036h-.013l-.032.002c-1.684.1-3.423-.437-4.604-1.65a.746.746 0 0 0-.053-.05L4.84 14.6a1.348 1.348 0 0 1-.07-.073 2.99 2.99 0 0 1-.293-.392c-.242-.379-.558-1.014-.778-1.985a54.1 54.1 0 0 0-.083-.376 27.494 27.494 0 0 1-.367-1.872l-.003-.02a6.791 6.791 0 0 1-.08-.67c.004-.277.086-.475.2-.609l.067-.067a.63.63 0 0 1 .292-.145h.05c.18 0 1.095.055 2.013.115l1.207.08.534.037a.747.747 0 0 0 .052.002c.782 0 1.349-.206 1.759-.585l.005-.005c.553-.52.622-1.225.622-1.76V6.24l-.026-.565A774.97 774.97 0 0 1 9.885 4.4c-.042-.961-.081-1.939-.081-2.13ZM4.995 6.953a251.126 251.126 0 0 1 2.102.137l.508.035c.48-.004.646-.122.715-.185.07-.068.146-.209.147-.649l-.024-.548a791.69 791.69 0 0 1-.095-2.187L4.995 6.953Zm16.122 9.996Zm-5.479-5.323a.75.75 0 0 0 1.014.31 2.04 2.04 0 0 1 .304-.089 1.84 1.84 0 0 1 .544-.039c.215.023.321.06.37.085.033.016.039.026.047.04a.75.75 0 0 0 1.289-.767c-.337-.567-.906-.783-1.552-.85a3.334 3.334 0 0 0-1.002.062c-.27.056-.531.14-.705.234a.75.75 0 0 0-.31 1.014Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-expand' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='m12 8.337-8.47 8.47a.75.75 0 0 1-1.06-1.06l8.605-8.606a1.29 1.29 0 0 1 1.85 0l8.605 8.605a.75.75 0 1 1-1.06 1.06L12 8.338Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-external-source-placeholder' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M6.341 3.27a10.5 10.5 0 0 1 5.834-1.77.75.75 0 0 0 0-1.5 12 12 0 1 0 12 12 .75.75 0 0 0-1.5 0A10.5 10.5 0 1 1 6.34 3.27Zm14.145 1.48a.75.75 0 1 0-1.06-1.062L9.925 13.19V7.95a.75.75 0 1 0-1.5 0V15c0 .414.336.75.75.75h7.05a.75.75 0 0 0 0-1.5h-5.24l9.501-9.5Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-facebook' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M12 1.5C6.201 1.5 1.5 6.201 1.5 12c0 4.943 3.416 9.089 8.016 10.204v-6.108H7.383a.75.75 0 0 1-.75-.75v-3.281a.75.75 0 0 1 .75-.75h2.133V9.393c0-.958.225-2.511 1.38-3.65 1.194-1.177 3.174-1.718 6.254-1.056a.75.75 0 0 1 .592.733v2.754a.75.75 0 0 1-.75.75c-.692 0-1.203.026-1.584.082-.387.057-.578.137-.675.202-.109.073-.237.205-.237 1.029v1.078h2.39a.75.75 0 0 1 .742.866l-.516 3.281a.75.75 0 0 1-.74.634h-1.876v6.106C19.09 21.082 22.5 16.939 22.5 12c0-5.799-4.701-10.5-10.5-10.5zM0 12C0 5.373 5.373 0 12 0s12 5.373 12 12c0 5.995-4.395 10.961-10.138 11.856a.75.75 0 0 1-.866-.74v-7.77a.75.75 0 0 1 .75-.75h1.984l.28-1.781h-2.264a.75.75 0 0 1-.75-.75v-1.828c0-.829.089-1.729.9-2.274.363-.244.807-.37 1.293-.441a9.623 9.623 0 0 1 1.053-.086V6.04c-2.41-.405-3.645.132-4.293.771-.737.728-.933 1.793-.933 2.582v2.672a.75.75 0 0 1-.75.75H8.133v1.78h2.133a.75.75 0 0 1 .75.75v7.772a.75.75 0 0 1-.865.741C4.4 22.968 0 18 0 12z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-file' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M2.895 1.201c0-.473.383-.857.857-.857h8.4c.227 0 .445.09.606.251l8.4 8.4c.16.16.25.379.25.606v13.2a.857.857 0 0 1-.856.857h-16.8a.857.857 0 0 1-.857-.857zm1.714.857v19.886h15.085V10.458h-7.542a.857.857 0 0 1-.858-.857V2.058zm8.4 1.213 5.473 5.473H13.01z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-flickr' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M5.959 7.926c-2.298 0-4.14 1.834-4.14 4.073 0 2.241 1.842 4.075 4.14 4.075 2.302 0 4.145-1.834 4.145-4.075 0-2.238-1.843-4.073-4.145-4.073Zm-5.64 4.073c0-3.086 2.533-5.573 5.64-5.573 3.11 0 5.645 2.486 5.645 5.573 0 3.089-2.535 5.575-5.645 5.575-3.107 0-5.64-2.487-5.64-5.575Zm18.07-4.073c-2.301 0-4.144 1.835-4.144 4.073 0 2.24 1.843 4.075 4.145 4.075 2.299 0 4.141-1.834 4.141-4.075 0-2.239-1.842-4.073-4.141-4.073Zm-5.644 4.073c0-3.087 2.535-5.573 5.645-5.573 3.108 0 5.641 2.487 5.641 5.573 0 3.088-2.533 5.575-5.641 5.575-3.11 0-5.645-2.486-5.645-5.575Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-gdrive' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M7.736 1.818a.75.75 0 0 1 .647-.37h7.587a.75.75 0 0 1 .655.383l7.233 12.946a.75.75 0 0 1-.003.737l-3.794 6.66a.75.75 0 0 1-.651.378H4.59a.75.75 0 0 1-.651-.378l-3.794-6.66a.75.75 0 0 1 .005-.75zm.64 1.876L1.663 15.148l2.93 5.145 6.655-11.581zm3.736 6.526-2.398 4.173H14.5zm4.116 4.173h5.697L15.53 2.947H9.677zm5.685 1.5H8.852l-2.966 5.16h13.088z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-gphotos' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M12.51 0c-.702 0-1.272.57-1.272 1.273V7.35A6.381 6.381 0 0 0 0 11.489c0 .703.57 1.273 1.273 1.273H7.35A6.381 6.381 0 0 0 11.488 24c.704 0 1.274-.57 1.274-1.273V16.65A6.381 6.381 0 0 0 24 12.51c0-.703-.57-1.273-1.273-1.273H16.65A6.381 6.381 0 0 0 12.511 0Zm.252 11.232V1.53a4.857 4.857 0 0 1 0 9.702Zm-1.53.006H1.53a4.857 4.857 0 0 1 9.702 0Zm1.536 1.524a4.857 4.857 0 0 0 9.702 0h-9.702Zm-6.136 4.857c0-2.598 2.04-4.72 4.606-4.85v9.7a4.857 4.857 0 0 1-4.606-4.85Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-huddle' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M6.204 2.002c-.252.23-.357.486-.357.67V21.07c0 .15.084.505.313.812.208.28.499.477.929.477.519 0 .796-.174.956-.365.178-.212.286-.535.286-.924v-.013l.117-6.58c.004-1.725 1.419-3.883 3.867-3.883 1.33 0 2.332.581 2.987 1.364.637.762.95 1.717.95 2.526v6.47c0 .392.11.751.305.995.175.22.468.41 1.008.41.52 0 .816-.198 1.002-.437.207-.266.31-.633.31-.969V14.04c0-2.81-1.943-5.108-4.136-5.422a5.971 5.971 0 0 0-3.183.41c-.912.393-1.538.96-1.81 1.489a.75.75 0 0 1-1.417-.344v-7.5c0-.587-.47-1.031-1.242-1.031-.315 0-.638.136-.885.36ZM5.194.892A2.844 2.844 0 0 1 7.09.142c1.328 0 2.742.867 2.742 2.53v5.607a6.358 6.358 0 0 1 1.133-.629 7.47 7.47 0 0 1 3.989-.516c3.056.436 5.425 3.482 5.425 6.906v6.914c0 .602-.177 1.313-.627 1.89-.47.605-1.204 1.016-2.186 1.016-.96 0-1.698-.37-2.179-.973-.46-.575-.633-1.294-.633-1.933v-6.469c0-.456-.19-1.071-.602-1.563-.394-.471-.986-.827-1.836-.827-1.447 0-2.367 1.304-2.367 2.39v.014l-.117 6.58c-.001.64-.177 1.333-.637 1.881-.48.57-1.2.9-2.105.9-.995 0-1.7-.5-2.132-1.081-.41-.552-.61-1.217-.61-1.708V2.672c0-.707.366-1.341.847-1.78Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-info' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M11 9h2V7h-2m1 13c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8m0-18A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2m-1 15h2v-6h-2v6Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-local' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M3 3.75a1.5 1.5 0 0 0-1.5 1.5v13.5a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5V9A1.5 1.5 0 0 0 21 7.5h-9a.75.75 0 0 1-.643-.364L9.325 3.75zm-3 1.5a3 3 0 0 1 3-3h6.75a.75.75 0 0 1 .643.364L12.425 6H21a3 3 0 0 1 3 3v9.75a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-microphone' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' clip-rule='evenodd' d='M7.5 4.781a4.5 4.5 0 0 1 9 0v6.469a4.5 4.5 0 1 1-9 0V4.781Zm4.5-3a3 3 0 0 0-3 3v6.469a3 3 0 1 0 6 0V4.781a3 3 0 0 0-3-3Zm-8.156 8.11a.75.75 0 0 1 .75.75 7.406 7.406 0 1 0 14.812 0 .75.75 0 0 1 1.5 0 8.907 8.907 0 0 1-8.156 8.875v2.703h3.258a.75.75 0 1 1 0 1.5H7.992a.75.75 0 0 1 0-1.5h3.258v-2.703a8.907 8.907 0 0 1-8.156-8.875.75.75 0 0 1 .75-.75Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-microphone-mute' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' clip-rule='evenodd' d='M7.5 4.781a4.5 4.5 0 0 1 9 0V6l3.524-3.524a.75.75 0 1 1 1.061 1.06L5.036 19.585a.75.75 0 0 1-1.06-1.06l1.656-1.657a8.88 8.88 0 0 1-2.538-6.227.75.75 0 0 1 1.5 0c0 2.009.8 3.83 2.1 5.166l1.771-1.772A4.483 4.483 0 0 1 7.5 11.25V4.781Zm2.037 8.182L15 7.5V4.781a3 3 0 1 0-6 0v6.469c0 .637.198 1.227.537 1.713Zm10.62-3.072a.75.75 0 0 1 .75.75 8.907 8.907 0 0 1-8.157 8.875v2.703h3.258a.75.75 0 1 1 0 1.5H7.992a.75.75 0 0 1 0-1.5h3.258v-2.703a8.855 8.855 0 0 1-3.035-.811.75.75 0 1 1 .638-1.358 7.406 7.406 0 0 0 10.553-6.707.75.75 0 0 1 .75-.75ZM15 10.81a.75.75 0 0 1 1.5 0v.439a4.5 4.5 0 0 1-5 4.473.75.75 0 1 1 .166-1.491A3 3 0 0 0 15 11.25v-.44Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-mobile-photo-camera' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M7.65 2.55a.75.75 0 0 1 .6-.3h7.5a.75.75 0 0 1 .6.3l2.025 2.7H21a3 3 0 0 1 3 3v10.5a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V8.25a3 3 0 0 1 3-3h2.625zm.975 1.2L6.6 6.45a.75.75 0 0 1-.6.3H3a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h18a1.5 1.5 0 0 0 1.5-1.5V8.25a1.5 1.5 0 0 0-1.5-1.5h-3a.75.75 0 0 1-.6-.3l-2.025-2.7zm3.375 6a3.375 3.375 0 1 0 0 6.75 3.375 3.375 0 0 0 0-6.75zm-4.875 3.375a4.875 4.875 0 1 1 9.75 0 4.875 4.875 0 0 1-9.75 0z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-mobile-video-camera' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' clip-rule='evenodd' d='M0 6.75a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v1.078L22.873 5A.75.75 0 0 1 24 5.648v12.704a.75.75 0 0 1-1.123.65L18 16.207v1.043a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6.75Zm18 7.728 4.5 2.58V6.95L18 9.562v4.916ZM16.5 6.75a1.5 1.5 0 0 0-1.5-1.5H3a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5V6.75Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-onedrive' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M13.616 4.147a7.689 7.689 0 0 0-7.642 3.285A6.299 6.299 0 0 0 1.455 17.3c.684.894 2.473 2.658 5.17 2.658h12.141c.95 0 1.882-.256 2.697-.743.815-.486 1.514-1.247 1.964-2.083a5.26 5.26 0 0 0-3.713-7.612 7.69 7.69 0 0 0-6.098-5.373ZM3.34 17.15c.674.63 1.761 1.308 3.284 1.308h12.142a3.76 3.76 0 0 0 2.915-1.383l-7.494-4.489L3.34 17.15Zm10.875-6.25 2.47-1.038a5.239 5.239 0 0 1 1.427-.389 6.19 6.19 0 0 0-10.3-1.952 6.338 6.338 0 0 1 2.118.813l4.285 2.567Zm4.55.033c-.512 0-1.019.104-1.489.307l-.006.003-1.414.594 6.521 3.906a3.76 3.76 0 0 0-3.357-4.8l-.254-.01ZM4.097 9.617A4.799 4.799 0 0 1 6.558 8.9c.9 0 1.84.25 2.587.713l3.4 2.037-10.17 4.28a4.799 4.799 0 0 1 1.721-6.312Z'/></symbol><symbol fill='none' viewBox='0 0 10 10' id='uc-icon-pause' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' d='M1 0h2.5v10H1zM6.5 0H9v10H6.5z'/></symbol><symbol fill='none' viewBox='0 0 10 10' id='uc-icon-play' xmlns='http://www.w3.org/2000/svg'><path d='m1 0 9 5-9 5V0Z' fill='currentColor'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-remove-file' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M11.955 3.3A2.969 2.969 0 0 0 8.998 6h5.914a2.97 2.97 0 0 0-2.957-2.7zM16.416 6a4.47 4.47 0 0 0-8.922 0h-2.32a.755.755 0 0 0-.111.008H3.075a.75.75 0 1 0 0 1.5h1.35V19.35a2.85 2.85 0 0 0 2.85 2.85h9.45a2.85 2.85 0 0 0 2.85-2.85V7.508h1.35a.75.75 0 0 0 0-1.5h-1.989A.754.754 0 0 0 18.825 6zM5.925 7.508V19.35a1.35 1.35 0 0 0 1.35 1.35h9.45a1.35 1.35 0 0 0 1.35-1.35V7.508z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-select' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='m7 10 5 5 5-5H7Z'/></symbol><symbol fill='none' viewBox='0 0 20 20' id='uc-icon-square' xmlns='http://www.w3.org/2000/svg'><rect width='20' height='20' rx='4' fill='#fff'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-upload' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M11.501.392a.75.75 0 0 1 .998 0l6.704 5.972a.75.75 0 0 1-.998 1.12l-5.455-4.86v13.439a.75.75 0 0 1-1.5 0V2.625l-5.454 4.86a.75.75 0 1 1-.998-1.12zM.857 16.73a.75.75 0 0 1 .75.75v4.914h20.786v-4.914a.75.75 0 0 1 1.5 0v5.664a.75.75 0 0 1-.75.75H.857a.75.75 0 0 1-.75-.75v-5.664a.75.75 0 0 1 .75-.75z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-upload-error' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M13 13h-2V7h2m0 10h-2v-2h2M12 2A10 10 0 0 0 2 12a10 10 0 0 0 10 10 10 10 0 0 0 10-10A10 10 0 0 0 12 2Z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-url' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M19.11 3.67c-1.71-1.709-4.578-1.682-6.408.148l-2.22 2.22a.75.75 0 0 1-1.062-1.06l2.222-2.221C14.018.381 17.836.276 20.17 2.61l1.22 1.22c2.335 2.334 2.23 6.153-.147 8.529l-2.22 2.22a.75.75 0 0 1-1.062-1.06l2.222-2.221c1.83-1.83 1.856-4.698.147-6.408zm-3.36 4.58a.75.75 0 0 1 0 1.06l-6.439 6.44a.75.75 0 0 1-1.06-1.06l6.439-6.44a.75.75 0 0 1 1.06 0zM6.04 9.42a.75.75 0 0 1 0 1.061l-2.222 2.222c-1.83 1.83-1.856 4.698-.147 6.407l1.22 1.22c1.71 1.71 4.578 1.683 6.408-.147l2.221-2.221a.75.75 0 1 1 1.06 1.06l-2.22 2.222c-2.377 2.376-6.195 2.481-8.53.147l-1.22-1.22c-2.334-2.334-2.228-6.153.148-8.53l2.221-2.22a.75.75 0 0 1 1.06 0z'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-video-camera' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' clip-rule='evenodd' d='M0 6.75a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v1.078L22.873 5A.75.75 0 0 1 24 5.648v12.704a.75.75 0 0 1-1.123.65L18 16.207v1.043a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V6.75Zm18 7.728 4.5 2.58V6.95L18 9.562v4.916ZM16.5 6.75a1.5 1.5 0 0 0-1.5-1.5H3a1.5 1.5 0 0 0-1.5 1.5v10.5a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5V6.75Z'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-video-camera-full' xmlns='http://www.w3.org/2000/svg'><path d='M2 3.333a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h10.938a2 2 0 0 0 2-2v-2.013L20 15.646V4.354l-5.063 3.03v-2.05a2 2 0 0 0-2-2H2Z' fill='currentColor'/></symbol><symbol viewBox='0 0 24 24' id='uc-icon-vk' xmlns='http://www.w3.org/2000/svg'><path fill='currentColor' fill-rule='evenodd' d='M6.341 3.27a10.5 10.5 0 0 1 5.834-1.77.75.75 0 0 0 0-1.5 12 12 0 1 0 12 12 .75.75 0 0 0-1.5 0A10.5 10.5 0 1 1 6.34 3.27Zm14.145 1.48a.75.75 0 1 0-1.06-1.062L9.925 13.19V7.95a.75.75 0 1 0-1.5 0V15c0 .414.336.75.75.75h7.05a.75.75 0 0 0 0-1.5h-5.24l9.501-9.5Z'/></symbol></svg>";




class $ef19f577698fac1f$export$bec543de6927e621 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    static styleAttrs = [
        "uc-wgt-common"
    ];
    requireCtxName = true;
    init$ = (0, $7f5f1305336629aa$export$e6278a3220543f46)(this);
    _template = null;
    initCallback() {
        super.initCallback();
        this.a11y?.registerBlock(this);
    }
    static set template(value) {
        this._template = (0, $9e528c2cfed3abf6$export$2e2bcd8739ae039) + value + /** HTML */ `<slot></slot>`;
    }
    static get template() {
        return this._template;
    }
}


// @ts-check




const $cdc07cfe072a0265$var$ACTIVE_ATTR = "active";
const $cdc07cfe072a0265$var$ACTIVE_PROP = "___ACTIVITY_IS_ACTIVE___";
class $cdc07cfe072a0265$export$5e3ae1ab277e5747 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    /** @protected */ historyTracked = false;
    init$ = (0, $7f5f1305336629aa$export$b6eaf5cda4248fe4)(this);
    _debouncedHistoryFlush = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(this._historyFlush.bind(this), 10);
    /** @private */ _deactivate() {
        let actDesc = $cdc07cfe072a0265$export$5e3ae1ab277e5747._activityCallbacks.get(this);
        this[$cdc07cfe072a0265$var$ACTIVE_PROP] = false;
        this.removeAttribute($cdc07cfe072a0265$var$ACTIVE_ATTR);
        actDesc?.deactivateCallback?.();
    }
    /** @private */ _activate() {
        let actDesc = $cdc07cfe072a0265$export$5e3ae1ab277e5747._activityCallbacks.get(this);
        this.$["*historyBack"] = this.historyBack.bind(this);
        /** @private */ this[$cdc07cfe072a0265$var$ACTIVE_PROP] = true;
        this.setAttribute($cdc07cfe072a0265$var$ACTIVE_ATTR, "");
        actDesc?.activateCallback?.();
        this._debouncedHistoryFlush();
        this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).ACTIVITY_CHANGE, {
            activity: this.activityType
        });
    }
    /** @protected */ initCallback() {
        super.initCallback();
        if (this.hasAttribute("current-activity")) this.sub("*currentActivity", (/** @type {String} */ val)=>{
            this.setAttribute("current-activity", val);
        });
        // TODO: rename activityType to activityId
        if (this.activityType) {
            if (!this.hasAttribute("activity")) this.setAttribute("activity", this.activityType);
            this.sub("*currentActivity", (/** @type {String} */ val)=>{
                try {
                    if (this.activityType !== val && this[$cdc07cfe072a0265$var$ACTIVE_PROP]) this._deactivate();
                    else if (this.activityType === val && !this[$cdc07cfe072a0265$var$ACTIVE_PROP]) this._activate();
                } catch (err) {
                    console.error(`Error in activity "${this.activityType}". `, err);
                    this.$["*currentActivity"] = this.$["*history"][this.$["*history"].length - 1] ?? null;
                }
                if (!val) this.$["*history"] = [];
            });
            if (this.has("*modalActive")) this.sub("*modalActive", (modalActive)=>{
                if (!modalActive && this.activityType === this.$["*currentActivity"]) this.$["*currentActivity"] = null;
            });
        }
    }
    /** @private */ _historyFlush() {
        let history = this.$["*history"];
        if (history) {
            if (history.length > 10) history = history.slice(history.length - 11, history.length - 1);
            if (this.historyTracked && history[history.length - 1] !== this.activityType) history.push(this.activityType);
            this.$["*history"] = history;
        }
    }
    /** @private */ _isActivityRegistered() {
        return this.activityType && $cdc07cfe072a0265$export$5e3ae1ab277e5747._activityCallbacks.has(this);
    }
    /**
   * @private
   * @type {Map<
   *   ActivityBlock,
   *   { activateCallback: (() => void) | undefined; deactivateCallback: (() => void) | undefined }
   * >}
   */ static _activityCallbacks = new Map();
    get isActivityActive() {
        return this[$cdc07cfe072a0265$var$ACTIVE_PROP];
    }
    get couldOpenActivity() {
        return true;
    }
    /**
   * TODO: remove name argument
   *
   * @param {String} name
   * @param {Object} [options]
   * @param {() => void} [options.onActivate]
   * @param {() => void} [options.onDeactivate]
   */ registerActivity(name, options = {}) {
        const { onActivate: onActivate, onDeactivate: onDeactivate } = options;
        $cdc07cfe072a0265$export$5e3ae1ab277e5747._activityCallbacks.set(this, {
            activateCallback: onActivate,
            deactivateCallback: onDeactivate
        });
    }
    unregisterActivity() {
        if (this.isActivityActive) this._deactivate();
        $cdc07cfe072a0265$export$5e3ae1ab277e5747._activityCallbacks.delete(this);
    }
    /** @protected */ destroyCallback() {
        super.destroyCallback();
        this._isActivityRegistered() && this.unregisterActivity();
        /** @type {string | null} */ const currentActivity = this.$["*currentActivity"];
        const hasCurrentActivityInCtx = !![
            ...this.blocksRegistry
        ].find((block)=>block instanceof $cdc07cfe072a0265$export$5e3ae1ab277e5747 && block.activityType === currentActivity);
        if (!hasCurrentActivityInCtx) {
            this.$["*currentActivity"] = null;
            this.setOrAddState("*modalActive", false);
        }
    }
    get activityKey() {
        return this.ctxName + this.activityType;
    }
    /** @type {ActivityParamsMap[keyof ActivityParamsMap]} */ get activityParams() {
        return this.$["*currentActivityParams"];
    }
    /** @type {String} */ get initActivity() {
        return this.getCssData("--cfg-init-activity");
    }
    /** @type {String} */ get doneActivity() {
        return this.getCssData("--cfg-done-activity");
    }
    historyBack() {
        /** @type {String[]} */ let history = this.$["*history"];
        if (history) {
            let nextActivity = history.pop();
            while(nextActivity === this.activityType)nextActivity = history.pop();
            let couldOpenActivity = !!nextActivity;
            if (nextActivity) {
                const nextActivityBlock = [
                    ...this.blocksRegistry
                ].find((block)=>block.activityType === nextActivity);
                couldOpenActivity = /** @type {ActivityBlock} */ nextActivityBlock?.couldOpenActivity ?? false;
            }
            nextActivity = couldOpenActivity ? nextActivity : undefined;
            this.$["*currentActivity"] = nextActivity;
            this.$["*history"] = history;
            if (!nextActivity) this.setOrAddState("*modalActive", false);
        }
    }
}
$cdc07cfe072a0265$export$5e3ae1ab277e5747.activities = Object.freeze({
    START_FROM: "start-from",
    CAMERA: "camera",
    DRAW: "draw",
    UPLOAD_LIST: "upload-list",
    URL: "url",
    CLOUD_IMG_EDIT: "cloud-image-edit",
    EXTERNAL: "external"
}); /** @typedef {(typeof ActivityBlock)['activities'][keyof (typeof ActivityBlock)['activities']]} RegisteredActivityType */  /** @typedef {RegisteredActivityType | (string & {}) | null} ActivityType */ 


// @ts-check



// @ts-check
const $c1f033c89897f5fc$export$79bf3aa6ff8a6a3c = 20;
const $c1f033c89897f5fc$export$b69960716b5f670f = 24;
const $c1f033c89897f5fc$export$df6c1d4a19114db4 = 34;
const $c1f033c89897f5fc$export$9fc5d1d39ca040ea = 3;
const $c1f033c89897f5fc$export$4515e32f363eb04b = $c1f033c89897f5fc$export$9fc5d1d39ca040ea / 2;
const $c1f033c89897f5fc$export$1cf2b3e7100e85af = 1;
const $c1f033c89897f5fc$export$f958e4635c8aa22c = 100 / 3;
const $c1f033c89897f5fc$export$9c132ec810e22d8a = 1;
const $c1f033c89897f5fc$export$2950b0064b6e4e77 = 24;
const $c1f033c89897f5fc$export$d00854ad80ddb8a1 = 6;


function $ec2c5c3a08a9901b$export$54374d41e42e9676(node, attrs) {
    for(let p in attrs)node.setAttributeNS(null, p, attrs[p].toString());
}
function $ec2c5c3a08a9901b$export$183806b242873ed9(name, attrs = {}) {
    let node = document.createElementNS("http://www.w3.org/2000/svg", name);
    $ec2c5c3a08a9901b$export$54374d41e42e9676(node, attrs);
    return node;
}
function $ec2c5c3a08a9901b$export$790b609df538a7dd(rect, direction, sizeMultiplier) {
    let { x: x, y: y, width: width, height: height } = rect;
    let wMul = direction.includes("w") ? 0 : 1;
    let hMul = direction.includes("n") ? 0 : 1;
    let xSide = [
        -1,
        1
    ][wMul];
    let ySide = [
        -1,
        1
    ][hMul];
    let p1 = [
        x + wMul * width + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * xSide,
        y + hMul * height + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * ySide - (0, $c1f033c89897f5fc$export$b69960716b5f670f) * sizeMultiplier * ySide
    ];
    let p2 = [
        x + wMul * width + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * xSide,
        y + hMul * height + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * ySide
    ];
    let p3 = [
        x + wMul * width - (0, $c1f033c89897f5fc$export$b69960716b5f670f) * sizeMultiplier * xSide + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * xSide,
        y + hMul * height + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * ySide
    ];
    let path = `M ${p1[0]} ${p1[1]} L ${p2[0]} ${p2[1]} L ${p3[0]} ${p3[1]}`;
    let center = p2;
    return {
        d: path,
        center: center
    };
}
function $ec2c5c3a08a9901b$export$7b179e18f4ee631a(rect, direction, sizeMultiplier) {
    let { x: x, y: y, width: width, height: height } = rect;
    let wMul = [
        "n",
        "s"
    ].includes(direction) ? 0.5 : ({
        w: 0,
        e: 1
    })[/** @type {Extract<import('./types.js').Direction, 'w' | 'e'>} */ direction];
    let hMul = [
        "w",
        "e"
    ].includes(direction) ? 0.5 : ({
        n: 0,
        s: 1
    })[/** @type {Extract<import('./types.js').Direction, 'n' | 's'>} */ direction];
    let xSide = [
        -1,
        1
    ][wMul];
    let ySide = [
        -1,
        1
    ][hMul];
    let p1, p2;
    if ([
        "n",
        "s"
    ].includes(direction)) {
        p1 = [
            x + wMul * width - (0, $c1f033c89897f5fc$export$df6c1d4a19114db4) * sizeMultiplier / 2,
            y + hMul * height + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * ySide
        ];
        p2 = [
            x + wMul * width + (0, $c1f033c89897f5fc$export$df6c1d4a19114db4) * sizeMultiplier / 2,
            y + hMul * height + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * ySide
        ];
    } else {
        p1 = [
            x + wMul * width + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * xSide,
            y + hMul * height - (0, $c1f033c89897f5fc$export$df6c1d4a19114db4) * sizeMultiplier / 2
        ];
        p2 = [
            x + wMul * width + (0, $c1f033c89897f5fc$export$4515e32f363eb04b) * xSide,
            y + hMul * height + (0, $c1f033c89897f5fc$export$df6c1d4a19114db4) * sizeMultiplier / 2
        ];
    }
    let path = `M ${p1[0]} ${p1[1]} L ${p2[0]} ${p2[1]}`;
    let center = [
        p2[0] - (p2[0] - p1[0]) / 2,
        p2[1] - (p2[1] - p1[1]) / 2
    ];
    return {
        d: path,
        center: center
    };
}
function $ec2c5c3a08a9901b$export$96239d218eb7ece8(direction) {
    if (direction === "") return "move";
    if ([
        "e",
        "w"
    ].includes(direction)) return "ew-resize";
    if ([
        "n",
        "s"
    ].includes(direction)) return "ns-resize";
    if ([
        "nw",
        "se"
    ].includes(direction)) return "nwse-resize";
    return "nesw-resize";
}
function $ec2c5c3a08a9901b$export$88498a0045263460({ rect: rect, delta: [dx, dy], imageBox: imageBox }) {
    return $ec2c5c3a08a9901b$export$25fd15ab86a7b28b({
        ...rect,
        x: rect.x + dx,
        y: rect.y + dy
    }, imageBox);
}
function $ec2c5c3a08a9901b$export$25fd15ab86a7b28b(rect1, rect2) {
    let { x: x } = rect1;
    let { y: y } = rect1;
    if (rect1.x < rect2.x) x = rect2.x;
    else if (rect1.x + rect1.width > rect2.x + rect2.width) x = rect2.x + rect2.width - rect1.width;
    if (rect1.y < rect2.y) y = rect2.y;
    else if (rect1.y + rect1.height > rect2.y + rect2.height) y = rect2.y + rect2.height - rect1.height;
    return {
        ...rect1,
        x: x,
        y: y
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $ec2c5c3a08a9901b$var$resizeNorth({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    const [, dy] = delta;
    let { y: y, width: width, height: height } = rect;
    y += dy;
    height -= dy;
    if (aspectRatio) width = height * aspectRatio;
    let x = rect.x + rect.width / 2 - width / 2;
    if (y <= imageBox.y) {
        y = imageBox.y;
        height = rect.y + rect.height - y;
        if (aspectRatio) {
            width = height * aspectRatio;
            x = rect.x + rect.width / 2 - width / 2;
        }
    }
    if (x <= imageBox.x) {
        x = imageBox.x;
        y = rect.y + rect.height - height;
    }
    if (x + width >= imageBox.x + imageBox.width) {
        x = Math.max(imageBox.x, imageBox.x + imageBox.width - width);
        width = imageBox.x + imageBox.width - x;
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height - height;
    }
    if (height < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        height = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) {
            width = height * aspectRatio;
            x = rect.x + rect.width / 2 - width / 2;
        }
        y = rect.y + rect.height - height;
    }
    if (width < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        width = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) {
            height = width / aspectRatio;
            x = rect.x + rect.width / 2 - width / 2;
        }
        y = rect.y + rect.height - height;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $ec2c5c3a08a9901b$var$resizeWest({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    const [dx] = delta;
    let { x: x, width: width, height: height } = rect;
    x += dx;
    width -= dx;
    if (aspectRatio) height = width / aspectRatio;
    let y = rect.y + rect.height / 2 - height / 2;
    if (x <= imageBox.x) {
        x = imageBox.x;
        width = rect.x + rect.width - x;
        if (aspectRatio) {
            height = width / aspectRatio;
            y = rect.y + rect.height / 2 - height / 2;
        }
    }
    if (y <= imageBox.y) {
        y = imageBox.y;
        x = rect.x + rect.width - width;
    }
    if (y + height >= imageBox.y + imageBox.height) {
        y = Math.max(imageBox.y, imageBox.y + imageBox.height - height);
        height = imageBox.y + imageBox.height - y;
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width - width;
    }
    if (height < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        height = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
        x = rect.x + rect.width - width;
    }
    if (width < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        width = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
        x = rect.x + rect.width - width;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $ec2c5c3a08a9901b$var$resizeSouth({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    const [, dy] = delta;
    let { y: y, width: width, height: height } = rect;
    height += dy;
    if (aspectRatio) width = height * aspectRatio;
    let x = rect.x + rect.width / 2 - width / 2;
    if (y + height >= imageBox.y + imageBox.height) {
        height = imageBox.y + imageBox.height - y;
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width / 2 - width / 2;
    }
    if (x <= imageBox.x) {
        x = imageBox.x;
        y = rect.y;
    }
    if (x + width >= imageBox.x + imageBox.width) {
        x = Math.max(imageBox.x, imageBox.x + imageBox.width - width);
        width = imageBox.x + imageBox.width - x;
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y;
    }
    if (height < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        height = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width / 2 - width / 2;
    }
    if (width < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        width = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        x = rect.x + rect.width / 2 - width / 2;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $ec2c5c3a08a9901b$var$resizeEast({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    const [dx] = delta;
    let { x: x, width: width, height: height } = rect;
    width += dx;
    if (aspectRatio) height = width / aspectRatio;
    let y = rect.y + rect.height / 2 - height / 2;
    if (x + width >= imageBox.x + imageBox.width) {
        width = imageBox.x + imageBox.width - x;
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
    }
    if (y <= imageBox.y) {
        y = imageBox.y;
        x = rect.x;
    }
    if (y + height >= imageBox.y + imageBox.height) {
        y = Math.max(imageBox.y, imageBox.y + imageBox.height - height);
        height = imageBox.y + imageBox.height - y;
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x;
    }
    if (height < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        height = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
    }
    if (width < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        width = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height / 2 - height / 2;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $ec2c5c3a08a9901b$var$resizeNorthWest({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    let [dx, dy] = delta;
    let { x: x, y: y, width: width, height: height } = rect;
    if (x + dx < imageBox.x) dx = imageBox.x - x;
    if (y + dy < imageBox.y) dy = imageBox.y - y;
    x += dx;
    width -= dx;
    y += dy;
    height -= dy;
    if (aspectRatio && Math.abs(width / height) > aspectRatio) {
        dy = width / aspectRatio - height;
        height += dy;
        y -= dy;
        if (y <= imageBox.y) {
            height = height - (imageBox.y - y);
            width = height * aspectRatio;
            x = rect.x + rect.width - width;
            y = imageBox.y;
        }
    } else if (aspectRatio) {
        dx = height * aspectRatio - width;
        width = width + dx;
        x -= dx;
        if (x <= imageBox.x) {
            width = width - (imageBox.x - x);
            height = width / aspectRatio;
            x = imageBox.x;
            y = rect.y + rect.height - height;
        }
    }
    if (height < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        height = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width - width;
        y = rect.y + rect.height - height;
    }
    if (width < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        width = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        x = rect.x + rect.width - width;
        y = rect.y + rect.height - height;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $ec2c5c3a08a9901b$var$resizeNorthEast({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    let [dx, dy] = delta;
    let { x: x, y: y, width: width, height: height } = rect;
    if (x + width + dx > imageBox.x + imageBox.width) dx = imageBox.x + imageBox.width - x - width;
    if (y + dy < imageBox.y) dy = imageBox.y - y;
    width += dx;
    y += dy;
    height -= dy;
    if (aspectRatio && Math.abs(width / height) > aspectRatio) {
        dy = width / aspectRatio - height;
        height += dy;
        y -= dy;
        if (y <= imageBox.y) {
            height = height - (imageBox.y - y);
            width = height * aspectRatio;
            x = rect.x;
            y = imageBox.y;
        }
    } else if (aspectRatio) {
        dx = height * aspectRatio - width;
        width += dx;
        if (x + width >= imageBox.x + imageBox.width) {
            width = imageBox.x + imageBox.width - x;
            height = width / aspectRatio;
            x = imageBox.x + imageBox.width - width;
            y = rect.y + rect.height - height;
        }
    }
    if (height < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        height = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        y = rect.y + rect.height - height;
    }
    if (width < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        width = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        y = rect.y + rect.height - height;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $ec2c5c3a08a9901b$var$resizeSouthWest({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    let [dx, dy] = delta;
    let { x: x, y: y, width: width, height: height } = rect;
    if (x + dx < imageBox.x) dx = imageBox.x - x;
    if (y + height + dy > imageBox.y + imageBox.height) dy = imageBox.y + imageBox.height - y - height;
    x += dx;
    width -= dx;
    height += dy;
    if (aspectRatio && Math.abs(width / height) > aspectRatio) {
        dy = width / aspectRatio - height;
        height += dy;
        if (y + height >= imageBox.y + imageBox.height) {
            height = imageBox.y + imageBox.height - y;
            width = height * aspectRatio;
            x = rect.x + rect.width - width;
            y = imageBox.y + imageBox.height - height;
        }
    } else if (aspectRatio) {
        dx = height * aspectRatio - width;
        width += dx;
        x -= dx;
        if (x <= imageBox.x) {
            width = width - (imageBox.x - x);
            height = width / aspectRatio;
            x = imageBox.x;
            y = rect.y;
        }
    }
    if (height < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        height = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
        x = rect.x + rect.width - width;
    }
    if (width < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        width = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
        x = rect.x + rect.width - width;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
/**
 * @param {{
 *   rect: import('./types.js').Rectangle;
 *   delta: [Number, Number];
 *   aspectRatio?: number;
 *   imageBox: import('./types.js').Rectangle;
 * }} options
 */ function $ec2c5c3a08a9901b$var$resizeSouthEast({ rect: rect, delta: delta, aspectRatio: aspectRatio, imageBox: imageBox }) {
    let [dx, dy] = delta;
    let { x: x, y: y, width: width, height: height } = rect;
    if (x + width + dx > imageBox.x + imageBox.width) dx = imageBox.x + imageBox.width - x - width;
    if (y + height + dy > imageBox.y + imageBox.height) dy = imageBox.y + imageBox.height - y - height;
    width += dx;
    height += dy;
    if (aspectRatio && Math.abs(width / height) > aspectRatio) {
        dy = width / aspectRatio - height;
        height += dy;
        if (y + height >= imageBox.y + imageBox.height) {
            height = imageBox.y + imageBox.height - y;
            width = height * aspectRatio;
            x = rect.x;
            y = imageBox.y + imageBox.height - height;
        }
    } else if (aspectRatio) {
        dx = height * aspectRatio - width;
        width += dx;
        if (x + width >= imageBox.x + imageBox.width) {
            width = imageBox.x + imageBox.width - x;
            height = width / aspectRatio;
            x = imageBox.x + imageBox.width - width;
            y = rect.y;
        }
    }
    if (height < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        height = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) width = height * aspectRatio;
    }
    if (width < (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) {
        width = (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
        if (aspectRatio) height = width / aspectRatio;
    }
    return {
        x: x,
        y: y,
        width: width,
        height: height
    };
}
function $ec2c5c3a08a9901b$export$7395518b474faf76({ direction: direction, ...rest }) {
    switch(direction){
        case "n":
            return $ec2c5c3a08a9901b$var$resizeNorth(rest);
        case "w":
            return $ec2c5c3a08a9901b$var$resizeWest(rest);
        case "s":
            return $ec2c5c3a08a9901b$var$resizeSouth(rest);
        case "e":
            return $ec2c5c3a08a9901b$var$resizeEast(rest);
        case "nw":
            return $ec2c5c3a08a9901b$var$resizeNorthWest(rest);
        case "ne":
            return $ec2c5c3a08a9901b$var$resizeNorthEast(rest);
        case "sw":
            return $ec2c5c3a08a9901b$var$resizeSouthWest(rest);
        case "se":
            return $ec2c5c3a08a9901b$var$resizeSouthEast(rest);
        default:
            return rest.rect;
    }
}
function $ec2c5c3a08a9901b$export$ac4bbe5b05d4ed3f(rect, [x, y]) {
    return rect.x <= x && x <= rect.x + rect.width && rect.y <= y && y <= rect.y + rect.height;
}
function $ec2c5c3a08a9901b$export$5b9ad582f7a393a7(rect1, rect2) {
    return rect1.x >= rect2.x && rect1.y >= rect2.y && rect1.x + rect1.width <= rect2.x + rect2.width && rect1.y + rect1.height <= rect2.y + rect2.height;
}
function $ec2c5c3a08a9901b$export$c875bfe83ce4f5e0(rect, aspectRatio) {
    const THRESHOLD = 0.1;
    return Math.abs(rect.width / rect.height - aspectRatio) < THRESHOLD;
}
function $ec2c5c3a08a9901b$export$9e53471bfbfdc361({ width: width, height: height }, angle) {
    let swap = angle / 90 % 2 !== 0;
    return {
        width: swap ? height : width,
        height: swap ? width : height
    };
}
function $ec2c5c3a08a9901b$export$c770ef1d0f2175d9(width, height, aspectRatio) {
    const imageAspectRatio = width / height;
    let cropWidth, cropHeight;
    if (imageAspectRatio > aspectRatio) {
        cropWidth = Math.round(height * aspectRatio);
        cropHeight = height;
    } else {
        cropWidth = width;
        cropHeight = Math.round(width / aspectRatio);
    }
    const cropX = Math.round((width - cropWidth) / 2);
    const cropY = Math.round((height - cropHeight) / 2);
    if (cropX + cropWidth > width) cropWidth = width - cropX;
    if (cropY + cropHeight > height) cropHeight = height - cropY;
    return {
        x: cropX,
        y: cropY,
        width: cropWidth,
        height: cropHeight
    };
}
function $ec2c5c3a08a9901b$export$166e03518104bf21(rect) {
    return {
        x: Math.round(rect.x),
        y: Math.round(rect.y),
        width: Math.round(rect.width),
        height: Math.round(rect.height)
    };
}
function $ec2c5c3a08a9901b$export$7d15b64cf5a3a4c4(value, min, max) {
    return Math.min(Math.max(value, min), max);
}


// @ts-check
/** @param {import('../../../../types/exported.d.ts').ConfigType['cropPreset']} cropPreset */ const $cdbc5d9b903cbec9$export$a99f8a1d2eae458 = (cropPreset)=>{
    if (!cropPreset) return [];
    const [w, h] = cropPreset.split(":").map(Number);
    if (!Number.isFinite(w) || !Number.isFinite(h)) {
        console.error(`Invalid crop preset: ${cropPreset}`);
        return;
    }
    /** @type {import('../types.js').CropAspectRatio} */ const aspectRatio = {
        type: "aspect-ratio",
        width: w,
        height: h
    };
    return [
        aspectRatio
    ];
};





var $4b0d1e35b7235ecb$exports = {};

$parcel$export($4b0d1e35b7235ecb$exports, "PACKAGE_NAME", () => $4b0d1e35b7235ecb$export$b8b9d90f9e5bd72b);
$parcel$export($4b0d1e35b7235ecb$exports, "PACKAGE_VERSION", () => $4b0d1e35b7235ecb$export$4a03ffab3315ee34);
/** Do not edit this file manually. It's generated during build process. */ const $4b0d1e35b7235ecb$export$b8b9d90f9e5bd72b = "blocks";
const $4b0d1e35b7235ecb$export$4a03ffab3315ee34 = "1.14.0";


function $fef9a574c8419dd8$export$bfcf574709d3c346(options) {
    return (0, $3905b2ce68ef12c7$export$7935961ef7719cb0)({
        ...options,
        libraryName: (0, $4b0d1e35b7235ecb$export$b8b9d90f9e5bd72b),
        libraryVersion: (0, $4b0d1e35b7235ecb$export$4a03ffab3315ee34)
    });
}




// @ts-check
/** @param {number} ms */ const $8768b5e191c7407a$var$msToUnixTimestamp = (ms)=>Math.floor(ms / 1000);
const $8768b5e191c7407a$export$32681a6105797f49 = (secureToken, { threshold: threshold })=>{
    const { secureExpire: secureExpire } = secureToken;
    const nowUnix = $8768b5e191c7407a$var$msToUnixTimestamp(Date.now());
    const expireUnix = Number(secureExpire);
    const thresholdUnix = $8768b5e191c7407a$var$msToUnixTimestamp(threshold);
    return nowUnix + thresholdUnix >= expireUnix;
};


class $ce11555aa1636ae1$export$1af0355fcc05f133 {
    /**
   * @private
   * @type {import('./UploaderBlock.js').UploaderBlock}
   */ _block;
    /**
   * @private
   * @type {import('../types').SecureUploadsSignatureAndExpire | null}
   */ _secureToken = null;
    /** @param {import('./UploaderBlock.js').UploaderBlock} block */ constructor(block){
        this._block = block;
    }
    /**
   * @private
   * @param {unknown[]} args
   */ _debugPrint(...args) {
        this._block.debugPrint("[secure-uploads]", ...args);
    }
    /** @returns {Promise<import('../types').SecureUploadsSignatureAndExpire | null>} */ async getSecureToken() {
        const { secureSignature: secureSignature, secureExpire: secureExpire, secureUploadsSignatureResolver: secureUploadsSignatureResolver } = this._block.cfg;
        if ((secureSignature || secureExpire) && secureUploadsSignatureResolver) console.warn("Both secureSignature/secureExpire and secureUploadsSignatureResolver are set. secureUploadsSignatureResolver will be used.");
        if (secureUploadsSignatureResolver) {
            if (!this._secureToken || (0, $8768b5e191c7407a$export$32681a6105797f49)(this._secureToken, {
                threshold: this._block.cfg.secureUploadsExpireThreshold
            })) {
                if (!this._secureToken) this._debugPrint("Secure signature is not set yet.");
                else this._debugPrint("Secure signature is expired. Resolving a new one...");
                try {
                    const result = await secureUploadsSignatureResolver();
                    if (!result) {
                        this._debugPrint("Secure signature resolver returned nothing.");
                        this._secureToken = null;
                    } else if (!result.secureSignature || !result.secureExpire) console.error("Secure signature resolver returned an invalid result:", result);
                    else {
                        this._debugPrint("Secure signature resolved:", result);
                        this._debugPrint("Secure signature will expire in", new Date(Number(result.secureExpire) * 1000).toISOString());
                        this._secureToken = result;
                    }
                } catch (err) {
                    console.error("Secure signature resolving failed. Falling back to the previous one.", err);
                }
            }
            return this._secureToken;
        }
        if (secureSignature && secureExpire) {
            this._debugPrint("Secure signature and expire are set. Using them...", {
                secureSignature: secureSignature,
                secureExpire: secureExpire
            });
            return {
                secureSignature: secureSignature,
                secureExpire: secureExpire
            };
        }
        return null;
    }
}




const $33dc30fa6775299e$var$MSG_NAME = "[Typed State] Wrong property name: ";
const $33dc30fa6775299e$var$MSG_TYPE = "[Typed State] Wrong property type: ";
class $33dc30fa6775299e$export$c2ad652e2643afc3 {
    /**
   * @param {Object<string, { type: any; value: any; nullable?: Boolean }>} typedSchema
   * @param {String} [ctxName]
   */ constructor(typedSchema, ctxName){
        /** @private */ this.__typedSchema = typedSchema;
        /** @private */ this.__ctxId = ctxName || (0, $7868cd5b229e5c15$export$c8b4a4d253b84ce0).generate();
        /** @private */ this.__schema = Object.keys(typedSchema).reduce((acc, key)=>{
            acc[key] = typedSchema[key].value;
            return acc;
        }, {});
        /**
     * @private
     * @type {Data}
     */ this.__data = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).registerCtx(this.__schema, this.__ctxId);
    }
    /** @returns {String} */ get uid() {
        return this.__ctxId;
    }
    /**
   * @param {String} prop
   * @param {any} value
   */ setValue(prop, value) {
        if (!this.__typedSchema.hasOwnProperty(prop)) {
            console.warn($33dc30fa6775299e$var$MSG_NAME + prop);
            return;
        }
        let pDesc = this.__typedSchema[prop];
        if (value?.constructor === pDesc.type || value instanceof pDesc.type || pDesc.nullable && value === null) {
            this.__data.pub(prop, value);
            return;
        }
        console.warn($33dc30fa6775299e$var$MSG_TYPE + prop);
    }
    /** @param {Object<string, any>} updObj */ setMultipleValues(updObj) {
        for(let prop in updObj)this.setValue(prop, updObj[prop]);
    }
    /** @param {String} prop */ getValue(prop) {
        if (!this.__typedSchema.hasOwnProperty(prop)) {
            console.warn($33dc30fa6775299e$var$MSG_NAME + prop);
            return undefined;
        }
        return this.__data.read(prop);
    }
    /**
   * @param {String} prop
   * @param {(newVal: any) => void} handler
   */ subscribe(prop, handler) {
        return this.__data.sub(prop, handler);
    }
    remove() {
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this.__ctxId);
    }
}


class $28e6f06700817354$export$3a688a1eb31a757a {
    /**
   * @param {Object} options
   * @param {Object<string, { type: any; value: any }>} options.typedSchema
   * @param {String[]} [options.watchList]
   * @param {(list: string[], added: Set<any>, removed: Set<any>) => void} [options.handler]
   * @param {String} [options.ctxName]
   */ constructor(options){
        /**
     * @private
     * @type {Object<string, { type: any; value: any }>}
     */ this.__typedSchema = options.typedSchema;
        /**
     * @private
     * @type {String}
     */ this.__ctxId = options.ctxName || (0, $7868cd5b229e5c15$export$c8b4a4d253b84ce0).generate();
        /**
     * @private
     * @type {Data}
     */ this.__data = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).registerCtx({}, this.__ctxId);
        /**
     * @private
     * @type {string[]}
     */ this.__watchList = options.watchList || [];
        /**
     * @private
     * @type {Object<string, any>}
     */ this.__subsMap = Object.create(null);
        /**
     * @private
     * @type {Set<Function>}
     */ this.__propertyObservers = new Set();
        /**
     * @private
     * @type {Set<(list: string[], added: Set<any>, removed: Set<any>) => void>}
     */ this.__collectionObservers = new Set();
        /**
     * @private
     * @type {Set<string>}
     */ this.__items = new Set();
        /**
     * @private
     * @type {Set<any>}
     */ this.__removed = new Set();
        /**
     * @private
     * @type {Set<any>}
     */ this.__added = new Set();
        let changeMap = Object.create(null);
        /**
     * @private
     * @param {String} propName
     * @param {String} ctxId
     */ this.__notifyObservers = (propName, ctxId)=>{
            if (this.__observeTimeout) window.clearTimeout(this.__observeTimeout);
            if (!changeMap[propName]) changeMap[propName] = new Set();
            changeMap[propName].add(ctxId);
            /** @private */ this.__observeTimeout = window.setTimeout(()=>{
                if (Object.keys(changeMap).length === 0) return;
                this.__propertyObservers.forEach((handler)=>{
                    handler({
                        ...changeMap
                    });
                });
                changeMap = Object.create(null);
            });
        };
    }
    notify() {
        if (this.__notifyTimeout) window.clearTimeout(this.__notifyTimeout);
        /** @private */ this.__notifyTimeout = window.setTimeout(()=>{
            let added = new Set(this.__added);
            let removed = new Set(this.__removed);
            this.__added.clear();
            this.__removed.clear();
            for (const handler of this.__collectionObservers)handler?.([
                ...this.__items
            ], added, removed);
        });
    }
    /** @param {(list: string[], added: Set<any>, removed: Set<any>) => void} handler */ observeCollection(handler) {
        this.__collectionObservers.add(handler);
        if (this.__items.size > 0) this.notify();
        return ()=>{
            this.unobserveCollection(handler);
        };
    }
    /** @param {Function} handler */ unobserveCollection(handler) {
        this.__collectionObservers?.delete(handler);
    }
    /**
   * @param {Object<string, any>} init
   * @returns {string}
   */ add(init) {
        let item = new (0, $33dc30fa6775299e$export$c2ad652e2643afc3)(this.__typedSchema);
        for(let prop in init)item.setValue(prop, init[prop]);
        this.__items.add(item.uid);
        this.notify();
        this.__data.add(item.uid, item);
        this.__added.add(item);
        this.__watchList.forEach((propName)=>{
            if (!this.__subsMap[item.uid]) this.__subsMap[item.uid] = [];
            this.__subsMap[item.uid].push(item.subscribe(propName, ()=>{
                this.__notifyObservers(propName, item.uid);
            }));
        });
        return item.uid;
    }
    /**
   * @param {String} id
   * @returns {TypedData}
   */ read(id) {
        return this.__data.read(id);
    }
    /**
   * @param {String} id
   * @param {String} propName
   * @returns {any}
   */ readProp(id, propName) {
        let item = this.read(id);
        return item.getValue(propName);
    }
    /**
   * @template T
   * @param {String} id
   * @param {String} propName
   * @param {T} value
   */ publishProp(id, propName, value) {
        let item = this.read(id);
        item.setValue(propName, value);
    }
    /** @param {String} id */ remove(id) {
        this.__removed.add(this.__data.read(id));
        this.__items.delete(id);
        this.notify();
        this.__data.pub(id, null);
        delete this.__subsMap[id];
    }
    clearAll() {
        this.__items.forEach((id)=>{
            this.remove(id);
        });
    }
    /** @param {Function} handler */ observeProperties(handler) {
        this.__propertyObservers.add(handler);
        return ()=>{
            this.unobserveProperties(handler);
        };
    }
    /** @param {Function} handler */ unobserveProperties(handler) {
        this.__propertyObservers?.delete(handler);
    }
    /**
   * @param {(item: TypedData) => Boolean} checkFn
   * @returns {String[]}
   */ findItems(checkFn) {
        let result = [];
        this.__items.forEach((id)=>{
            let item = this.read(id);
            if (checkFn(item)) result.push(id);
        });
        return result;
    }
    items() {
        return [
            ...this.__items
        ];
    }
    get size() {
        return this.__items.size;
    }
    destroy() {
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this.__ctxId);
        this.__propertyObservers = null;
        this.__collectionObservers = null;
        for(let id in this.__subsMap){
            this.__subsMap[id].forEach((sub)=>{
                sub.remove();
            });
            delete this.__subsMap[id];
        }
    }
}


// @ts-check



// @ts-check
const $a53f5e78ad1bb77c$export$a12adc0ad2c4d117 = Object.freeze({
    FACEBOOK: "facebook",
    DROPBOX: "dropbox",
    GDRIVE: "gdrive",
    GPHOTOS: "gphotos",
    FLICKR: "flickr",
    VK: "vk",
    EVERNOTE: "evernote",
    BOX: "box",
    ONEDRIVE: "onedrive",
    HUDDLE: "huddle"
});
const $a53f5e78ad1bb77c$export$f7d782fb0db58d2a = Object.freeze({
    MOBILE_VIDEO_CAMERA: "mobile-video-camera",
    MOBILE_PHOTO_CAMERA: "mobile-photo-camera"
});
const $a53f5e78ad1bb77c$export$5522e73b726d0ec8 = Object.freeze({
    LOCAL: "local",
    DROP_AREA: "drop-area",
    CAMERA: "camera",
    EXTERNAL: "external",
    API: "js-api",
    URL: "url",
    DRAW: "draw",
    ...$a53f5e78ad1bb77c$export$f7d782fb0db58d2a,
    ...$a53f5e78ad1bb77c$export$a12adc0ad2c4d117
}); /** @typedef {(typeof UploadSource)[keyof typeof UploadSource]} SourceTypes */ 



// @ts-check

const $776c9232ebc0ef80$export$ac87ac3138ad3b2a = [
    "image/*",
    "image/heif",
    "image/heif-sequence",
    "image/heic",
    "image/heic-sequence",
    "image/avif",
    "image/avif-sequence",
    ".heif",
    ".heifs",
    ".heic",
    ".heics",
    ".avif",
    ".avifs"
];
const $776c9232ebc0ef80$export$90f2b68ae2c5fe52 = (fileTypes)=>{
    if (!fileTypes) return [];
    return fileTypes.filter((item)=>typeof item === "string").map((str)=>(0, $15ba4abb0cb95799$export$b9ca061da17f2d30)(str)).flat();
};
const $776c9232ebc0ef80$export$b1eb18852d39b12f = (mimeType, allowedFileTypes)=>{
    return allowedFileTypes.some((type)=>{
        if (type.endsWith("*")) {
            type = type.replace("*", "");
            return mimeType.startsWith(type);
        }
        return mimeType === type;
    });
};
const $776c9232ebc0ef80$export$eef1a5ad5eea15d = (fileName, allowedFileTypes)=>{
    return allowedFileTypes.some((type)=>{
        if (!type.startsWith(".")) return false;
        return fileName.toLowerCase().endsWith(type.toLowerCase());
    });
};
const $776c9232ebc0ef80$export$9788fb119e95d11e = (file)=>{
    let type = file?.type;
    if (!type) return false;
    return $776c9232ebc0ef80$export$b1eb18852d39b12f(type, $776c9232ebc0ef80$export$ac87ac3138ad3b2a);
};
const $776c9232ebc0ef80$export$5bcd6e94ed871c88 = (data)=>{
    return typeof Blob !== "undefined" && data instanceof Blob;
};
const $776c9232ebc0ef80$export$be78b3111c50efdd = (data)=>{
    return typeof File !== "undefined" && data instanceof File;
};


const $b18fd096c57e76d2$var$uuidRegex = /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/i;
const $b18fd096c57e76d2$var$cdnUrlRegex = new RegExp(`^/?(${$b18fd096c57e76d2$var$uuidRegex.source})(?:/(-/(?:[^/]+/)+)?([^/]*))?$`, "i");
const $b18fd096c57e76d2$export$7bc65061b70cfcf6 = ({ url: url, cdnBase: cdnBase })=>{
    const cdnBaseUrlObj = new URL(cdnBase);
    const urlObj = new URL(url);
    if (cdnBaseUrlObj.host !== urlObj.host) return null;
    const [, uuid, cdnUrlModifiers, filename] = $b18fd096c57e76d2$var$cdnUrlRegex.exec(urlObj.pathname);
    return {
        uuid: uuid,
        cdnUrlModifiers: cdnUrlModifiers || "",
        filename: filename || null
    };
};


// @ts-check
// @ts-check
/**
 * @template {any[]} TArgs
 * @template {any} TReturn
 * @template {(...args: TArgs) => TReturn} T
 * @param {T} fn
 * @returns {T}
 */ const $f3f0f4a6f7ab8c83$export$fc10aeed3a532e2a = (fn)=>{
    const cache = new Map();
    return /** @type {T} */ (...args)=>{
        const key = JSON.stringify(args);
        if (cache.has(key)) return cache.get(key);
        const result = fn(...args);
        cache.set(key, result);
        return result;
    };
};


const $0c6bb43f104c669a$var$warnings = new Set();
function $0c6bb43f104c669a$export$5b28268982f175ba(message) {
    if ($0c6bb43f104c669a$var$warnings.has(message)) return;
    $0c6bb43f104c669a$var$warnings.add(message);
    console.warn(message);
}


/** @param {string} warning */ function $f0b8c7dd616571c2$var$createAsyncAssertWrapper(warning) {
    let isAsync = false;
    setTimeout(()=>{
        isAsync = true;
    }, 0);
    /**
   * @template {any[]} TArgs
   * @template {any} TReturn
   * @template {(...args: TArgs) => TReturn} T
   * @param {T} fn
   * @returns {T}
   */ const withAssert = (fn)=>{
        return /** @type {T} */ (...args)=>{
            if (isAsync) (0, $0c6bb43f104c669a$export$5b28268982f175ba)(warning);
            return fn(...args);
        };
    };
    return withAssert;
}
function $f0b8c7dd616571c2$export$45cb442eb820cab7(uploaderBlock) {
    const getters = {
        /** @returns {number} */ progress: ()=>{
            return uploaderBlock.$["*commonProgress"];
        },
        /** @returns {ReturnType<import('../types').OutputErrorFile>[]} */ errors: ()=>{
            return uploaderBlock.$["*collectionErrors"];
        },
        /** @returns {import('@uploadcare/upload-client').UploadcareGroup | null} */ group: ()=>{
            return uploaderBlock.$["*groupInfo"];
        },
        totalCount: ()=>{
            return uploaderBlock.uploadCollection.size;
        },
        failedCount: ()=>{
            return state.failedEntries.length;
        },
        successCount: ()=>{
            return state.successEntries.length;
        },
        uploadingCount: ()=>{
            return state.uploadingEntries.length;
        },
        status: ()=>{
            const status = state.isFailed ? "failed" : state.isUploading ? "uploading" : state.isSuccess ? "success" : "idle";
            return /** @type {TCollectionStatus} */ status;
        },
        isSuccess: ()=>{
            return state.allEntries.length > 0 && state.errors.length === 0 && state.successEntries.length === state.allEntries.length;
        },
        isUploading: ()=>{
            return state.allEntries.some((entry)=>entry.status === "uploading");
        },
        isFailed: ()=>{
            return state.errors.length > 0 || state.failedEntries.length > 0;
        },
        allEntries: ()=>{
            return uploaderBlock.getOutputData();
        },
        successEntries: ()=>{
            return state.allEntries.filter((entry)=>entry.status === "success");
        },
        failedEntries: ()=>{
            return state.allEntries.filter((entry)=>entry.status === "failed");
        },
        uploadingEntries: ()=>{
            return state.allEntries.filter((entry)=>entry.status === "uploading");
        },
        idleEntries: ()=>{
            return state.allEntries.filter((entry)=>entry.status === "idle");
        }
    };
    const state = /** @type {import('../index.js').OutputCollectionState<TCollectionStatus, TGroupFlag>} */ /** @type {unknown} */ {};
    const withAssert = $f0b8c7dd616571c2$var$createAsyncAssertWrapper("You're trying to access the OutputCollectionState asynchronously. In this case, the data you retrieve will be newer than it was when the OutputCollectionState was created or when the event was dispatched. If you want to retain the state at a specific moment in time, you should use the spread operator like this: `{...outputCollectionState}` or `{...e.detail}`");
    for (const [key, value] of Object.entries(getters)){
        const name = /** @type {keyof typeof getters} */ key;
        const getter = /** @type {(typeof getters)[name]} */ value;
        const wrapped = (0, $f3f0f4a6f7ab8c83$export$fc10aeed3a532e2a)(withAssert(getter));
        Object.defineProperty(state, name, {
            get: wrapped,
            enumerable: true
        });
    }
    return state;
}



//@ts-check

const $5b19d5bf1367d1d4$export$7db9bdd2f098cbde = Object.freeze({
    PHOTO: "photo",
    VIDEO: "video"
});
const $5b19d5bf1367d1d4$export$9d766d51f3f726e2 = Object.freeze({
    IDLE: "idle",
    SHOT: "shot",
    PLAY: "play",
    PAUSE: "pause",
    RESUME: "resume",
    STOP: "stop",
    RETAKE: "retake",
    ACCEPT: "accept"
}); /** @typedef {(typeof CameraSourceTypes)[keyof typeof CameraSourceTypes]} ModeCameraType */ 


const $df49fbf1d7bfef62$export$452b75918745d4bd = (/** @type {import('../../types').ConfigType} } */ cfg)=>{
    return {
        isVideoRecordingEnabled: (0, $cf5145deda9036ee$export$7a086f785998e32e)(cfg.cameraModes).includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO),
        isPhotoEnabled: (0, $cf5145deda9036ee$export$7a086f785998e32e)(cfg.cameraModes).includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO)
    };
};



const $28daeac476405872$export$90f565abb5a84cb2 = ()=>{
    return "capture" in document.createElement("input");
};


class $21e0a565bbf027db$export$462d1f905e62861b {
    /**
   * @private
   * @type {import('./UploaderBlock.js').UploaderBlock}
   */ _ctx;
    /** @param {import('./UploaderBlock.js').UploaderBlock} ctx */ constructor(ctx){
        this._ctx = ctx;
    }
    /** @private */ get _uploadCollection() {
        return this._ctx.uploadCollection;
    }
    get cfg() {
        return this._ctx.cfg;
    }
    get l10n() {
        return this._ctx.l10n.bind(this._ctx);
    }
    /**
   * TODO: Probably we should not allow user to override `source` property
   *
   * @param {string} url
   * @param {{ silent?: boolean; fileName?: string; source?: string }} [options]
   * @returns {import('../types').OutputFileEntry<'idle'>}
   */ addFileFromUrl = (url, { silent: silent, fileName: fileName, source: source } = {})=>{
        const internalId = this._uploadCollection.add({
            externalUrl: url,
            fileName: fileName ?? null,
            silent: silent ?? false,
            source: source ?? (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).API
        });
        return this.getOutputItem(internalId);
    };
    /**
   * @param {string} uuid
   * @param {{ silent?: boolean; fileName?: string; source?: string }} [options]
   * @returns {import('../types').OutputFileEntry<'idle'>}
   */ addFileFromUuid = (uuid, { silent: silent, fileName: fileName, source: source } = {})=>{
        const internalId = this._uploadCollection.add({
            uuid: uuid,
            fileName: fileName ?? null,
            silent: silent ?? false,
            source: source ?? (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).API
        });
        return this.getOutputItem(internalId);
    };
    /**
   * @param {string} cdnUrl
   * @param {{ silent?: boolean; fileName?: string; source?: string }} [options]
   * @returns {import('../types').OutputFileEntry<'idle'>}
   */ addFileFromCdnUrl = (cdnUrl, { silent: silent, fileName: fileName, source: source } = {})=>{
        const parsedCdnUrl = (0, $b18fd096c57e76d2$export$7bc65061b70cfcf6)({
            url: cdnUrl,
            cdnBase: this.cfg.cdnCname
        });
        if (!parsedCdnUrl) throw new Error("Invalid CDN URL");
        const internalId = this._uploadCollection.add({
            uuid: parsedCdnUrl.uuid,
            cdnUrl: cdnUrl,
            cdnUrlModifiers: parsedCdnUrl.cdnUrlModifiers,
            fileName: fileName ?? parsedCdnUrl.filename ?? null,
            silent: silent ?? false,
            source: source ?? (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).API
        });
        return this.getOutputItem(internalId);
    };
    /**
   * @param {File} file
   * @param {{ silent?: boolean; fileName?: string; source?: string; fullPath?: string }} [options]
   * @returns {import('../types').OutputFileEntry<'idle'>}
   */ addFileFromObject = (file, { silent: silent, fileName: fileName, source: source, fullPath: fullPath } = {})=>{
        const internalId = this._uploadCollection.add({
            file: file,
            isImage: (0, $776c9232ebc0ef80$export$9788fb119e95d11e)(file),
            mimeType: file.type,
            fileName: fileName ?? file.name,
            fileSize: file.size,
            silent: silent ?? false,
            source: source ?? (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).API,
            fullPath: fullPath ?? null
        });
        return this.getOutputItem(internalId);
    };
    /** @param {string} internalId */ removeFileByInternalId = (internalId)=>{
        if (!this._uploadCollection.read(internalId)) throw new Error(`File with internalId ${internalId} not found`);
        this._uploadCollection.remove(internalId);
    };
    removeAllFiles() {
        this._uploadCollection.clearAll();
    }
    uploadAll = ()=>{
        const itemsToUpload = this._uploadCollection.items().filter((id)=>{
            const entry = this._uploadCollection.read(id);
            return !entry.getValue("isRemoved") && !entry.getValue("isUploading") && !entry.getValue("fileInfo");
        });
        if (itemsToUpload.length === 0) return;
        this._ctx.$["*uploadTrigger"] = new Set(itemsToUpload);
        this._ctx.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).COMMON_UPLOAD_START, /** @type {import('../types').OutputCollectionState<'uploading'>} */ this.getOutputCollectionState());
    };
    /** @param {{ captureCamera?: boolean; modeCamera?: import('../blocks/CameraSource/constants.js').ModeCameraType }} options */ openSystemDialog = (options = {})=>{
        const accept = (0, $cf5145deda9036ee$export$1494b4974e65fb4e)((0, $776c9232ebc0ef80$export$90f2b68ae2c5fe52)([
            this.cfg.accept ?? "",
            ...this.cfg.imgOnly ? (0, $776c9232ebc0ef80$export$ac87ac3138ad3b2a) : []
        ]));
        const INPUT_ATTR_NAME = "uploadcare-file-input";
        const fileInput = document.createElement("input");
        fileInput.setAttribute(INPUT_ATTR_NAME, "");
        (0, $7868cd5b229e5c15$export$41428deff1a0db9e)(fileInput, {
            opacity: 0,
            height: 0,
            width: 0,
            visibility: "hidden"
        });
        fileInput.type = "file";
        fileInput.multiple = this.cfg.multiple;
        if (options.captureCamera) {
            fileInput.capture = this.cfg.cameraCapture;
            const { isPhotoEnabled: isPhotoEnabled, isVideoRecordingEnabled: isVideoRecordingEnabled } = (0, $df49fbf1d7bfef62$export$452b75918745d4bd)(this.cfg);
            if (options.modeCamera === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO && isPhotoEnabled) fileInput.accept = "image/*";
            else if (options.modeCamera === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO && isVideoRecordingEnabled) fileInput.accept = "video/*";
            else fileInput.accept = [
                "image/*",
                isVideoRecordingEnabled && "video/*"
            ].filter(Boolean).join(",");
        } else fileInput.accept = accept;
        fileInput.addEventListener("change", ()=>{
            if (!fileInput.files) return;
            [
                ...fileInput.files
            ].forEach((file)=>this.addFileFromObject(file, {
                    source: options.captureCamera ? (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).CAMERA : (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).LOCAL
                }));
            // To call uploadTrigger UploadList should draw file items first:
            this._ctx.$["*currentActivity"] = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
            this._ctx.setOrAddState("*modalActive", true);
            fileInput.remove();
        }, {
            once: true
        });
        document.querySelectorAll(`[${INPUT_ATTR_NAME}]`).forEach((el)=>el.remove());
        /**
     * Some browsers (e.g. Safari) require the file input to be in the DOM to work properly. Without it the file input
     * will open system dialog but won't trigger the change event sometimes.
     */ document.body.appendChild(fileInput);
        fileInput.dispatchEvent(new MouseEvent("click"));
    };
    /**
   * @template {import('../types').OutputFileStatus} TStatus
   * @param {string} entryId
   * @returns {import('../types/exported.js').OutputFileEntry<TStatus>}
   */ getOutputItem = (entryId)=>{
        const uploadEntryData = /** @type {import('./uploadEntrySchema.js').UploadEntry} */ (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
        /** @type {import('@uploadcare/upload-client').UploadcareFile?} */ const fileInfo = uploadEntryData.fileInfo;
        /** @type {import('../types').OutputFileEntry['status']} */ let status = uploadEntryData.isRemoved ? "removed" : uploadEntryData.errors.length > 0 ? "failed" : !!uploadEntryData.fileInfo ? "success" : uploadEntryData.isUploading ? "uploading" : "idle";
        /** @type {unknown} */ const outputItem = {
            uuid: fileInfo?.uuid ?? uploadEntryData.uuid ?? null,
            internalId: entryId,
            name: fileInfo?.originalFilename ?? uploadEntryData.fileName,
            size: fileInfo?.size ?? uploadEntryData.fileSize,
            isImage: fileInfo?.isImage ?? uploadEntryData.isImage,
            mimeType: fileInfo?.mimeType ?? uploadEntryData.mimeType,
            file: uploadEntryData.file,
            externalUrl: uploadEntryData.externalUrl,
            cdnUrlModifiers: uploadEntryData.cdnUrlModifiers,
            cdnUrl: uploadEntryData.cdnUrl ?? fileInfo?.cdnUrl ?? null,
            fullPath: uploadEntryData.fullPath,
            uploadProgress: uploadEntryData.uploadProgress,
            fileInfo: fileInfo ?? null,
            metadata: uploadEntryData.metadata ?? fileInfo?.metadata ?? null,
            isSuccess: status === "success",
            isUploading: status === "uploading",
            isFailed: status === "failed",
            isRemoved: status === "removed",
            errors: /** @type {import('../types/exported.js').OutputFileEntry['errors']} */ uploadEntryData.errors,
            status: status,
            source: uploadEntryData?.source
        };
        return /** @type {import('../types/exported.js').OutputFileEntry<TStatus>} */ outputItem;
    };
    /** @template {import('../types').OutputCollectionStatus} TStatus */ getOutputCollectionState = ()=>{
        return /** @type {ReturnType<typeof buildOutputCollectionState<TStatus>>} */ (0, $f0b8c7dd616571c2$export$45cb442eb820cab7)(this._ctx);
    };
    /** @param {Boolean} [force] */ initFlow = (force = false)=>{
        if (this._uploadCollection.size > 0 && !force) {
            this._ctx.set$({
                "*currentActivity": (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST
            });
            this._ctx.setOrAddState("*modalActive", true);
        } else if (this._sourceList?.length === 1) {
            const srcKey = this._sourceList[0];
            // TODO: We should refactor those handlers
            if (srcKey === "local") {
                this._ctx.$["*currentActivity"] = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
                this.openSystemDialog();
                return;
            }
            if (srcKey === "camera" && (0, $28daeac476405872$export$90f565abb5a84cb2)()) {
                const { isPhotoEnabled: isPhotoEnabled, isVideoRecordingEnabled: isVideoRecordingEnabled } = (0, $df49fbf1d7bfef62$export$452b75918745d4bd)(this.cfg);
                if (isPhotoEnabled && isVideoRecordingEnabled) {
                    this._ctx.set$({
                        "*currentActivity": (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.START_FROM
                    });
                    this._ctx.setOrAddState("*modalActive", true);
                    return;
                } else if (isPhotoEnabled || isVideoRecordingEnabled) {
                    this.openSystemDialog({
                        captureCamera: true,
                        modeCamera: isPhotoEnabled ? (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO : (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO
                    });
                    return;
                } else this.openSystemDialog({
                    captureCamera: true,
                    modeCamera: (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO
                });
            }
            /** @type {Set<import('./Block').Block>} */ const blocksRegistry = this._ctx.$["*blocksRegistry"];
            /**
         * @param {import('./Block').Block} block
         * @returns {block is import('../blocks/SourceBtn/SourceBtn.js').SourceBtn}
         */ const isSourceBtn = (block)=>"type" in block && block.type === srcKey;
            const sourceBtnBlock = [
                ...blocksRegistry
            ].find(isSourceBtn);
            // TODO: This is weird that we have this logic inside UI component, we should consider to move it somewhere else
            sourceBtnBlock?.activate();
            if (this._ctx.$["*currentActivity"]) this._ctx.setOrAddState("*modalActive", true);
        } else {
            // Multiple sources case:
            this._ctx.set$({
                "*currentActivity": (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.START_FROM
            });
            this._ctx.setOrAddState("*modalActive", true);
        }
    };
    doneFlow = ()=>{
        this._ctx.set$({
            "*currentActivity": this._ctx.doneActivity,
            "*history": this._ctx.doneActivity ? [
                this._ctx.doneActivity
            ] : []
        });
        if (!this._ctx.$["*currentActivity"]) this._ctx.setOrAddState("*modalActive", false);
    };
    /**
   * @type {<T extends import('./ActivityBlock.js').ActivityType>(
   *   activityType: T,
   *   ...params: T extends keyof import('./ActivityBlock.js').ActivityParamsMap
   *     ? [import('./ActivityBlock.js').ActivityParamsMap[T]]
   *     : T extends import('./ActivityBlock.js').RegisteredActivityType
   *       ? [undefined?]
   *       : [any?]
   * ) => void}
   */ setCurrentActivity = (activityType, params)=>{
        if (this._ctx.hasBlockInCtx((b)=>b.activityType === activityType)) {
            this._ctx.set$({
                "*currentActivityParams": params ?? {},
                "*currentActivity": activityType
            });
            return;
        }
        console.warn(`Activity type "${activityType}" not found in the context`);
    };
    /** @returns {import('./ActivityBlock.js').ActivityType} */ getCurrentActivity = ()=>{
        return this._ctx.$["*currentActivity"];
    };
    /** @param {boolean} opened */ setModalState = (opened)=>{
        if (opened && !this._ctx.$["*currentActivity"]) {
            console.warn(`Can't open modal without current activity. Please use "setCurrentActivity" method first.`);
            return;
        }
        this._ctx.setOrAddState("*modalActive", opened);
    };
    /**
   * @private
   * @type {string[]}
   */ get _sourceList() {
        /** @type {string[]} */ let list = [];
        if (this.cfg.sourceList) list = (0, $15ba4abb0cb95799$export$b9ca061da17f2d30)(this.cfg.sourceList);
        return list;
    }
}


// @ts-check

// @ts-check

const $02a98febf4fec7bd$export$5fca150d0f6b0a4a = (outputEntry, api)=>{
    const imagesOnly = api.cfg.imgOnly;
    const accept = api.cfg.accept;
    const allowedFileTypes = (0, $776c9232ebc0ef80$export$90f2b68ae2c5fe52)([
        ...imagesOnly ? (0, $776c9232ebc0ef80$export$ac87ac3138ad3b2a) : [],
        accept
    ]);
    if (!allowedFileTypes.length) return;
    const mimeType = outputEntry.mimeType;
    const fileName = outputEntry.name;
    if (!mimeType || !fileName) // Skip client validation if mime type or file name are not available for some reasons
    return;
    const mimeOk = (0, $776c9232ebc0ef80$export$b1eb18852d39b12f)(mimeType, allowedFileTypes);
    const extOk = (0, $776c9232ebc0ef80$export$eef1a5ad5eea15d)(fileName, allowedFileTypes);
    if (!mimeOk && !extOk) // Assume file type is not allowed if both mime and ext checks fail
    return {
        type: "FORBIDDEN_FILE_TYPE",
        message: api.l10n("file-type-not-allowed"),
        payload: {
            entry: outputEntry
        }
    };
};

// @ts-check
/** @type {import('../../../abstract/ValidationManager.js').FuncFileValidator} */ const $827762d3aaca2413$export$ea2578ea7374b3b7 = (outputEntry, api)=>{
    const imagesOnly = api.cfg.imgOnly;
    const isImage = outputEntry.isImage;
    if (!imagesOnly || isImage) return;
    if (!outputEntry.fileInfo && outputEntry.externalUrl) // skip validation for not uploaded files with external url, cause we don't know if they're images or not
    return;
    if (!outputEntry.fileInfo && !outputEntry.mimeType) // skip validation for not uploaded files without mime-type, cause we don't know if they're images or not
    return;
    return {
        type: "NOT_AN_IMAGE",
        message: api.l10n("images-only-accepted"),
        payload: {
            entry: outputEntry
        }
    };
};

// @ts-check
// @ts-check

const $b446817634722b23$var$BASE = 1000;
const $b446817634722b23$export$5c5e3263d95d3a40 = Object.freeze({
    AUTO: "auto",
    BYTE: "byte",
    KB: "kb",
    MB: "mb",
    GB: "gb",
    TB: "tb",
    PB: "pb"
});
/**
 * Round a specified number to decimal with two places. Round to larger value, because basically we use it for usage and
 * we charge customers for 1 GB even he consumed 1 byte. Feature limits are usually specified in exact MB/GB/TB, so they
 * will not be rounded.
 *
 * @param {number} number
 * @returns {number}
 */ const $b446817634722b23$var$round = (number)=>Math.ceil(number * 100) / 100;
const $b446817634722b23$export$7746799a10bf2f57 = (bytes, unit = $b446817634722b23$export$5c5e3263d95d3a40.AUTO)=>{
    const isAutoMode = unit === $b446817634722b23$export$5c5e3263d95d3a40.AUTO;
    if (unit === $b446817634722b23$export$5c5e3263d95d3a40.BYTE || isAutoMode && bytes < $b446817634722b23$var$BASE ** 1) {
        // TODO: handle blocks locale
        const pluralForm = /** @type {Extract<import('./getPluralForm').PluralForm, 'one' | 'other'>} */ (0, $afa2c82b84d64c9d$export$9f3f0d2d02951501)("en-US", bytes);
        const pluralized = {
            one: "byte",
            other: "bytes"
        }[pluralForm];
        return `${bytes} ${pluralized}`;
    }
    if (unit === $b446817634722b23$export$5c5e3263d95d3a40.KB || isAutoMode && bytes < $b446817634722b23$var$BASE ** 2) return `${$b446817634722b23$var$round(bytes / $b446817634722b23$var$BASE ** 1)} KB`;
    if (unit === $b446817634722b23$export$5c5e3263d95d3a40.MB || isAutoMode && bytes < $b446817634722b23$var$BASE ** 3) return `${$b446817634722b23$var$round(bytes / $b446817634722b23$var$BASE ** 2)} MB`;
    if (unit === $b446817634722b23$export$5c5e3263d95d3a40.GB || isAutoMode && bytes < $b446817634722b23$var$BASE ** 4) return `${$b446817634722b23$var$round(bytes / $b446817634722b23$var$BASE ** 3)} GB`;
    if (unit === $b446817634722b23$export$5c5e3263d95d3a40.TB || isAutoMode && bytes < $b446817634722b23$var$BASE ** 5) return `${$b446817634722b23$var$round(bytes / $b446817634722b23$var$BASE ** 4)} TB`;
    return `${$b446817634722b23$var$round(bytes / $b446817634722b23$var$BASE ** 5)} PB`;
};


const $f6d0629ef1a45549$export$9e3d625eea8cc2e5 = (outputEntry, api)=>{
    const maxFileSize = api.cfg.maxLocalFileSizeBytes;
    const fileSize = outputEntry.size;
    if (maxFileSize && fileSize && fileSize > maxFileSize) return {
        type: "FILE_SIZE_EXCEEDED",
        message: api.l10n("files-max-size-limit-error", {
            maxFileSize: (0, $b446817634722b23$export$7746799a10bf2f57)(maxFileSize)
        }),
        payload: {
            entry: outputEntry
        }
    };
};

// @ts-check

const $6ff5fd68b71f0ad9$export$c78c4cb705e0ff2d = (outputEntry, api)=>{
    const { internalId: internalId } = outputEntry;
    // @ts-expect-error Use private API that is not exposed in the types
    const internalEntry = api._uploadCollection.read(internalId);
    /** @type {unknown} */ const cause = internalEntry?.getValue("uploadError");
    if (!cause) return;
    if (cause instanceof (0, $3905b2ce68ef12c7$export$137ec66182ed30ea)) return {
        type: "UPLOAD_ERROR",
        message: cause.message,
        payload: {
            entry: outputEntry,
            error: cause
        }
    };
    if (cause instanceof (0, $3905b2ce68ef12c7$export$bae979e68e4dc802)) return {
        type: "NETWORK_ERROR",
        message: cause.message,
        payload: {
            entry: outputEntry,
            error: cause
        }
    };
    const error = cause instanceof Error ? cause : new Error("Unknown error", {
        cause: cause
    });
    return {
        type: "UNKNOWN_ERROR",
        message: error.message,
        payload: {
            entry: outputEntry,
            error: error
        }
    };
};


// @ts-check
/** @type {import('../../../abstract/ValidationManager.js').FuncCollectionValidator} */ const $7943f18ad66d6e01$export$705fc21993934f1e = (collection, api)=>{
    if (collection.failedCount > 0) return {
        type: "SOME_FILES_HAS_ERRORS",
        message: api.l10n("some-files-were-not-uploaded")
    };
};

//@ts-check
/** @type {import('../../../abstract/ValidationManager.js').FuncCollectionValidator} */ const $cfc558fddbfb6bd1$export$5565a4e7172e6edc = (collection, api)=>{
    const total = collection.totalCount;
    const multipleMin = api.cfg.multiple ? api.cfg.multipleMin : 0;
    const multipleMax = api.cfg.multiple ? api.cfg.multipleMax : 1;
    if (multipleMin && total < multipleMin) {
        const message = api.l10n("files-count-limit-error-too-few", {
            min: multipleMin,
            max: multipleMax,
            total: total
        });
        return {
            type: "TOO_FEW_FILES",
            message: message,
            payload: {
                total: total,
                min: multipleMin,
                max: multipleMax
            }
        };
    }
    if (multipleMax && total > multipleMax) {
        const message = api.l10n("files-count-limit-error-too-many", {
            min: multipleMin,
            max: multipleMax,
            total: total
        });
        return {
            type: "TOO_MANY_FILES",
            message: message,
            payload: {
                total: total,
                min: multipleMin,
                max: multipleMax
            }
        };
    }
};


/**
 * @typedef {(
 *   outputEntry: import('../types').OutputFileEntry,
 *   api: import('./UploaderPublicApi.js').UploaderPublicApi,
 * ) => undefined | import('../types').OutputErrorFile} FuncFileValidator
 */ /**
 * @typedef {(
 *   collection: ReturnType<
 *     typeof import('./buildOutputCollectionState.js').buildOutputCollectionState<
 *       import('../types').OutputCollectionStatus
 *     >
 *   >,
 *   api: import('./UploaderPublicApi.js').UploaderPublicApi,
 * ) => undefined | import('../types').OutputErrorCollection} FuncCollectionValidator
 */ const $6d1e99a9fa8431fc$var$LOGGER = {
    file: "File validator execution has failed",
    collection: "Collection validator execution has failed",
    message: "Missing message. We recommend adding message: value."
};
class $6d1e99a9fa8431fc$export$4917be085f2a4cda {
    /**
   * @private
   * @type {import('./UploaderBlock.js').UploaderBlock}
   */ _blockInstance;
    /** @type {FuncFileValidator[]} */ _fileValidators = [
        (0, $827762d3aaca2413$export$ea2578ea7374b3b7),
        (0, $02a98febf4fec7bd$export$5fca150d0f6b0a4a),
        (0, $f6d0629ef1a45549$export$9e3d625eea8cc2e5),
        (0, $6ff5fd68b71f0ad9$export$c78c4cb705e0ff2d)
    ];
    /** @type {FuncCollectionValidator[]} */ _collectionValidators = [
        (0, $cfc558fddbfb6bd1$export$5565a4e7172e6edc),
        (0, $7943f18ad66d6e01$export$705fc21993934f1e)
    ];
    /** @param {import('./UploaderBlock.js').UploaderBlock} blockInstance */ constructor(blockInstance){
        this._blockInstance = blockInstance;
        this._uploadCollection = this._blockInstance.uploadCollection;
        const runAllValidators = ()=>{
            this.runFileValidators();
            this.runCollectionValidators();
        };
        this._blockInstance.subConfigValue("maxLocalFileSizeBytes", runAllValidators);
        this._blockInstance.subConfigValue("multipleMin", runAllValidators);
        this._blockInstance.subConfigValue("multipleMax", runAllValidators);
        this._blockInstance.subConfigValue("multiple", runAllValidators);
        this._blockInstance.subConfigValue("imgOnly", runAllValidators);
        this._blockInstance.subConfigValue("accept", runAllValidators);
    }
    /** @param {string[]} [entryIds] */ runFileValidators(entryIds) {
        const ids = entryIds ?? this._uploadCollection.items();
        for (const id of ids){
            const entry = this._uploadCollection.read(id);
            if (entry) this._runFileValidatorsForEntry(entry);
        }
    }
    runCollectionValidators() {
        const collection = this._blockInstance.api.getOutputCollectionState();
        const errors = [];
        for (const validator of [
            ...this._collectionValidators,
            ...this._addCustomTypeToValidators(this._blockInstance.cfg.collectionValidators)
        ])try {
            const errorOrErrors = validator(collection, this._blockInstance.api);
            if (!errorOrErrors) continue;
            if (errorOrErrors) {
                errors.push(errorOrErrors);
                if (!errorOrErrors.message) console.warn($6d1e99a9fa8431fc$var$LOGGER.message);
            }
        } catch (error) {
            console.warn($6d1e99a9fa8431fc$var$LOGGER.collection, error);
        }
        this._blockInstance.$["*collectionErrors"] = errors;
        if (errors.length > 0) this._blockInstance.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).COMMON_UPLOAD_FAILED, ()=>/** @type {import('../types').OutputCollectionState<'failed'>} */ this._blockInstance.api.getOutputCollectionState(), {
            debounce: true
        });
    }
    /**
   * @private
   * @param {import('./TypedData.js').TypedData} entry
   */ _runFileValidatorsForEntry(entry) {
        const outputEntry = this._blockInstance.api.getOutputItem(entry.uid);
        const errors = [];
        for (const validator of [
            ...this._fileValidators,
            ...this._addCustomTypeToValidators(this._blockInstance.cfg.fileValidators)
        ])try {
            const error = validator(outputEntry, this._blockInstance.api);
            if (!error) continue;
            if (error) {
                errors.push(error);
                if (!error.message) console.warn($6d1e99a9fa8431fc$var$LOGGER.message);
            }
        } catch (error) {
            console.warn($6d1e99a9fa8431fc$var$LOGGER.file, error);
        }
        entry.setValue("errors", errors);
    }
    /**
   * @template T
   * @param {T[]} validators
   * @returns {T[]}
   */ _addCustomTypeToValidators(validators) {
        // @ts-ignore
        return validators.map((fn)=>(...args)=>{
                // @ts-ignore
                const result = fn(...args);
                return result ? {
                    ...result,
                    type: "CUSTOM_ERROR"
                } : undefined;
            });
    }
}


// @ts-check

const $1da46b0f7ca8f75f$export$26419364b8551fd7 = Object.freeze({
    file: {
        type: File,
        value: null
    },
    externalUrl: {
        type: String,
        value: null
    },
    fileName: {
        type: String,
        value: null,
        nullable: true
    },
    fileSize: {
        type: Number,
        value: null,
        nullable: true
    },
    lastModified: {
        type: Number,
        value: Date.now()
    },
    uploadProgress: {
        type: Number,
        value: 0
    },
    uuid: {
        type: String,
        value: null
    },
    isImage: {
        type: Boolean,
        value: false
    },
    mimeType: {
        type: String,
        value: null,
        nullable: true
    },
    ctxName: {
        type: String,
        value: null
    },
    cdnUrl: {
        type: String,
        value: null
    },
    cdnUrlModifiers: {
        type: String,
        value: null
    },
    fileInfo: {
        type: (0, $3905b2ce68ef12c7$export$92ff693e656b1c76),
        value: null
    },
    isUploading: {
        type: Boolean,
        value: false
    },
    abortController: {
        type: AbortController,
        value: null,
        nullable: true
    },
    thumbUrl: {
        type: String,
        value: null,
        nullable: true
    },
    silent: {
        type: Boolean,
        value: false
    },
    source: {
        type: String,
        value: false,
        nullable: true
    },
    fullPath: {
        type: String,
        value: null,
        nullable: true
    },
    metadata: {
        type: Object,
        value: null,
        nullable: true
    },
    errors: {
        type: Array,
        value: []
    },
    uploadError: {
        type: Error,
        value: null,
        nullable: true
    },
    isRemoved: {
        type: Boolean,
        value: false
    }
});



class $764ed4a1a24a6ef1$export$5ece2da0ca12cb21 extends (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747) {
    /** @protected */ couldBeCtxOwner = false;
    /** @private */ isCtxOwner = false;
    init$ = (0, $7f5f1305336629aa$export$e6278a3220543f46)(this);
    /** @private */ get hasCtxOwner() {
        return this.hasBlockInCtx((block)=>{
            if (block instanceof $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) return block.isCtxOwner && block.isConnected && block !== this;
            return false;
        });
    }
    /** @protected */ initCallback() {
        super.initCallback();
        if (!this.has("*uploadCollection")) {
            let uploadCollection = new (0, $28e6f06700817354$export$3a688a1eb31a757a)({
                typedSchema: (0, $1da46b0f7ca8f75f$export$26419364b8551fd7),
                watchList: [
                    "uploadProgress",
                    "uploadError",
                    "fileInfo",
                    "errors",
                    "cdnUrl",
                    "isUploading"
                ]
            });
            this.add("*uploadCollection", uploadCollection);
        }
        if (!this.has("*publicApi")) this.add("*publicApi", new (0, $21e0a565bbf027db$export$462d1f905e62861b)(this));
        if (!this.has("*validationManager")) this.add("*validationManager", new (0, $6d1e99a9fa8431fc$export$4917be085f2a4cda)(this));
        if (!this.hasCtxOwner && this.couldBeCtxOwner) this.initCtxOwner();
    }
    /**
   * @returns {ValidationManager}
   * @protected
   */ get validationManager() {
        if (!this.has("*validationManager")) throw new Error("Unexpected error: ValidationManager is not initialized");
        return this.$["*validationManager"];
    }
    /** @returns {UploaderPublicApi} */ get api() {
        if (!this.has("*publicApi")) throw new Error("Unexpected error: UploaderPublicApi is not initialized");
        return this.$["*publicApi"];
    }
    getAPI() {
        return this.api;
    }
    /** @returns {TypedCollection} */ get uploadCollection() {
        if (!this.has("*uploadCollection")) throw new Error("Unexpected error: TypedCollection is not initialized");
        return this.$["*uploadCollection"];
    }
    /** @protected */ destroyCtxCallback() {
        this._unobserveCollectionProperties?.();
        this._unobserveCollection?.();
        this.uploadCollection.destroy();
        this.$["*uploadCollection"] = null;
        super.destroyCtxCallback();
    }
    /** @private */ initCtxOwner() {
        this.isCtxOwner = true;
        /** @private */ this._unobserveCollection = this.uploadCollection.observeCollection(this._handleCollectionUpdate);
        /** @private */ this._unobserveCollectionProperties = this.uploadCollection.observeProperties(this._handleCollectionPropertiesUpdate);
        this.subConfigValue("maxConcurrentRequests", (value)=>{
            this.$["*uploadQueue"].concurrency = Number(value) || 1;
        });
        if (!this.$["*secureUploadsManager"]) this.$["*secureUploadsManager"] = new (0, $ce11555aa1636ae1$export$1af0355fcc05f133)(this);
        if (this.has("*modalActive")) this.sub("*modalActive", (modalActive)=>{
            if (modalActive && !this.$["*currentActivity"]) this.$["*modalActive"] = false;
        });
    }
    /**
   * @private
   * @param {import('../types').OutputCollectionState} collectionState
   */ async _createGroup(collectionState) {
        const uploadClientOptions = await this.getUploadClientOptions();
        const uuidList = collectionState.allEntries.map((entry)=>{
            return entry.uuid + (entry.cdnUrlModifiers ? `/${entry.cdnUrlModifiers}` : "");
        });
        const abortController = new AbortController();
        const resp = await (0, $3905b2ce68ef12c7$export$1116551e0a2a403c)(uuidList, {
            ...uploadClientOptions,
            signal: abortController.signal
        });
        if (this.$["*collectionState"] !== collectionState) {
            abortController.abort();
            return;
        }
        this.$["*groupInfo"] = resp;
        const collectionStateWithGroup = /** @type {import('../types').OutputCollectionState<'success', 'has-group'>} */ this.api.getOutputCollectionState();
        this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).GROUP_CREATED, collectionStateWithGroup);
        this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).CHANGE, ()=>this.api.getOutputCollectionState(), {
            debounce: true
        });
        this.$["*collectionState"] = collectionStateWithGroup;
    }
    /** @private */ _flushOutputItems = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(async ()=>{
        const data = this.getOutputData();
        if (data.length !== this.uploadCollection.size) return;
        const collectionState = this.api.getOutputCollectionState();
        this.$["*collectionState"] = collectionState;
        this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).CHANGE, ()=>this.api.getOutputCollectionState(), {
            debounce: true
        });
        if (this.cfg.groupOutput && collectionState.totalCount > 0 && collectionState.status === "success") this._createGroup(collectionState);
    }, 300);
    /**
   * @private
   * @type {Parameters<import('./TypedCollection.js').TypedCollection['observeCollection']>[0]}
   * @param {Set<import('./TypedData.js').TypedData>} removed
   */ _handleCollectionUpdate = (entries, added, removed)=>{
        if (added.size || removed.size) this.$["*groupInfo"] = null;
        this.validationManager.runFileValidators();
        this.validationManager.runCollectionValidators();
        for (const entry of added)if (!entry.getValue("silent")) this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).FILE_ADDED, this.api.getOutputItem(entry.uid));
        for (const entry of removed){
            /** @type {Set<string>} */ this.$["*uploadTrigger"].delete(entry.uid);
            entry.getValue("abortController")?.abort();
            entry.setMultipleValues({
                isRemoved: true,
                abortController: null,
                isUploading: false,
                uploadProgress: 0
            });
            URL.revokeObjectURL(entry?.getValue("thumbUrl"));
            this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).FILE_REMOVED, this.api.getOutputItem(entry.uid));
        }
        this.$["*uploadList"] = entries.map((uid)=>{
            return {
                uid: uid
            };
        });
        this._flushCommonUploadProgress();
        this._flushOutputItems();
    };
    /**
   * @private
   * @param {Record<keyof import('./uploadEntrySchema.js').UploadEntry, Set<string>>} changeMap
   */ _handleCollectionPropertiesUpdate = (changeMap)=>{
        this._flushOutputItems();
        const uploadCollection = this.uploadCollection;
        const entriesToRunValidation = [
            ...new Set(Object.entries(changeMap).filter(([key])=>[
                    "uploadError",
                    "fileInfo"
                ].includes(key)).map(([, ids])=>[
                    ...ids
                ]).flat())
        ];
        entriesToRunValidation.length > 0 && setTimeout(()=>{
            // We can't modify entry properties in the same tick, so we need to wait a bit
            this.validationManager.runFileValidators(entriesToRunValidation);
        });
        if (changeMap.uploadProgress) {
            for (const entryId of changeMap.uploadProgress){
                const { isUploading: isUploading, silent: silent } = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
                if (isUploading && !silent) this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).FILE_UPLOAD_PROGRESS, this.api.getOutputItem(entryId));
            }
            this._flushCommonUploadProgress();
        }
        if (changeMap.isUploading) for (const entryId of changeMap.isUploading){
            const { isUploading: isUploading, silent: silent } = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
            if (isUploading && !silent) this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).FILE_UPLOAD_START, this.api.getOutputItem(entryId));
        }
        if (changeMap.fileInfo) {
            for (const entryId of changeMap.fileInfo){
                const { fileInfo: fileInfo, silent: silent } = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
                if (fileInfo && !silent) this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).FILE_UPLOAD_SUCCESS, this.api.getOutputItem(entryId));
            }
            if (this.cfg.cropPreset) this.setInitialCrop();
        }
        if (changeMap.errors) {
            for (const entryId of changeMap.errors){
                const { errors: errors } = (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).getCtx(entryId).store;
                if (errors.length > 0) {
                    this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).FILE_UPLOAD_FAILED, this.api.getOutputItem(entryId));
                    this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).COMMON_UPLOAD_FAILED, ()=>/** @type {import('../types').OutputCollectionState<'failed'>} */ this.api.getOutputCollectionState(), {
                        debounce: true
                    });
                }
            }
            const loadedItems = uploadCollection.findItems((entry)=>{
                return !!entry.getValue("fileInfo");
            });
            const errorItems = uploadCollection.findItems((entry)=>{
                return entry.getValue("errors").length > 0;
            });
            if (uploadCollection.size > 0 && errorItems.length === 0 && uploadCollection.size === loadedItems.length && this.$["*collectionErrors"].length === 0) this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).COMMON_UPLOAD_SUCCESS, /** @type {import('../types').OutputCollectionState<'success'>} */ this.api.getOutputCollectionState());
        }
        if (changeMap.cdnUrl) {
            const uids = [
                ...changeMap.cdnUrl
            ].filter((uid)=>{
                return !!this.uploadCollection.read(uid)?.getValue("cdnUrl");
            });
            uids.forEach((uid)=>{
                this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).FILE_URL_CHANGED, this.api.getOutputItem(uid));
            });
            this.$["*groupInfo"] = null;
        }
    };
    /** @private */ _flushCommonUploadProgress = ()=>{
        let commonProgress = 0;
        /** @type {Set<string>} */ const uploadTrigger = this.$["*uploadTrigger"];
        const items = [
            ...uploadTrigger
        ].filter((id)=>!!this.uploadCollection.read(id));
        items.forEach((id)=>{
            const uploadProgress = this.uploadCollection.readProp(id, "uploadProgress");
            commonProgress += uploadProgress;
        });
        const progress = items.length ? Math.round(commonProgress / items.length) : 0;
        if (this.$["*commonProgress"] === progress) return;
        this.$["*commonProgress"] = progress;
        this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).COMMON_UPLOAD_PROGRESS, /** @type {import('../types').OutputCollectionState<'uploading'>} */ this.api.getOutputCollectionState());
    };
    /** @private */ setInitialCrop() {
        const cropPreset = (0, $cdbc5d9b903cbec9$export$a99f8a1d2eae458)(this.cfg.cropPreset);
        if (cropPreset) {
            const [aspectRatioPreset] = cropPreset;
            const entries = this.uploadCollection.findItems((entry)=>entry.getValue("fileInfo") && entry.getValue("isImage") && !entry.getValue("cdnUrlModifiers")?.includes("/crop/")).map((id)=>this.uploadCollection.read(id));
            for (const entry of entries){
                const fileInfo = entry.getValue("fileInfo");
                const { width: width, height: height } = fileInfo.imageInfo;
                const expectedAspectRatio = aspectRatioPreset.width / aspectRatioPreset.height;
                const crop = (0, $ec2c5c3a08a9901b$export$c770ef1d0f2175d9)(width, height, expectedAspectRatio);
                const cdnUrlModifiers = (0, $8c66713b0e57faf9$export$8fb94a7da5f60007)(`crop/${crop.width}x${crop.height}/${crop.x},${crop.y}`, "preview");
                entry.setMultipleValues({
                    cdnUrlModifiers: cdnUrlModifiers,
                    cdnUrl: (0, $8c66713b0e57faf9$export$226a37372a69410c)(entry.getValue("cdnUrl"), cdnUrlModifiers)
                });
                if (this.uploadCollection.size === 1 && this.cfg.useCloudImageEditor && this.hasBlockInCtx((block)=>block.activityType === (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.CLOUD_IMG_EDIT)) {
                    this.$["*currentActivityParams"] = {
                        internalId: entry.uid
                    };
                    this.$["*currentActivity"] = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.CLOUD_IMG_EDIT;
                }
            }
        }
    }
    /**
   * @param {string} entryId
   * @protected
   */ async getMetadataFor(entryId) {
        const configValue = this.cfg.metadata || undefined;
        if (typeof configValue === "function") {
            const outputFileEntry = this.api.getOutputItem(entryId);
            const metadata = await configValue(outputFileEntry);
            return metadata;
        }
        return configValue;
    }
    /**
   * @returns {Promise<import('@uploadcare/upload-client').FileFromOptions>}
   * @protected
   */ async getUploadClientOptions() {
        /** @type {SecureUploadsManager} */ const secureUploadsManager = this.$["*secureUploadsManager"];
        const secureToken = await secureUploadsManager.getSecureToken().catch(()=>null);
        let options = {
            store: this.cfg.store,
            publicKey: this.cfg.pubkey,
            baseCDN: this.cfg.cdnCname,
            baseURL: this.cfg.baseUrl,
            userAgent: (0, $fef9a574c8419dd8$export$bfcf574709d3c346),
            integration: this.cfg.userAgentIntegration,
            secureSignature: secureToken?.secureSignature,
            secureExpire: secureToken?.secureExpire,
            retryThrottledRequestMaxTimes: this.cfg.retryThrottledRequestMaxTimes,
            multipartMinFileSize: this.cfg.multipartMinFileSize,
            multipartChunkSize: this.cfg.multipartChunkSize,
            maxConcurrentRequests: this.cfg.multipartMaxConcurrentRequests,
            multipartMaxAttempts: this.cfg.multipartMaxAttempts,
            checkForUrlDuplicates: !!this.cfg.checkForUrlDuplicates,
            saveUrlForRecurrentUploads: !!this.cfg.saveUrlForRecurrentUploads
        };
        return options;
    }
    /** @returns {import('../types/exported.js').OutputFileEntry[]} */ getOutputData() {
        const entriesIds = this.uploadCollection.items();
        const data = entriesIds.map((itemId)=>this.api.getOutputItem(itemId));
        return data;
    }
}
/**
 * @deprecated Use list sources ExternalUploadSource from from blocks/utils/UploadSource.js
 * @enum {String}
 */ $764ed4a1a24a6ef1$export$5ece2da0ca12cb21.extSrcList = Object.freeze({
    ...(0, $a53f5e78ad1bb77c$export$a12adc0ad2c4d117)
});
/**
 * @deprecated Use list sources UploadSource from from blocks/utils/UploadSource.js
 * @enum {String}
 */ $764ed4a1a24a6ef1$export$5ece2da0ca12cb21.sourceTypes = Object.freeze({
    ...(0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8)
});


// @ts-check



/**
 * @template {string} T
 * @typedef {T extends `${infer Head} ${infer Tail}` ? `${Lowercase<Head>}-${KebabCase<Tail>}` : Lowercase<T>} KebabCase
 */ /**
 * @template {string} T
 * @param {T} str
 * @returns {KebabCase<T>}
 */ const $631a809cf1e31712$export$73bda83cddbc7187 = (str)=>str.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)?.map((x)=>x.toLowerCase()).join("-");


// @ts-check



/** @param {unknown} value */ const $cb0db7406dd90abe$var$asString = (value)=>String(value);
/** @param {unknown} value */ const $cb0db7406dd90abe$var$asNumber = (value)=>{
    const number = Number(value);
    if (Number.isNaN(number)) throw new Error(`Invalid number: "${value}"`);
    return number;
};
const $cb0db7406dd90abe$export$ffde277b1072591c = (value)=>{
    if (typeof value === "undefined" || value === null) return false;
    if (typeof value === "boolean") return value;
    // for attr like multiple="true" (react will pass it as string)
    if (value === "true") return true;
    // for attr flags like multiple="" (some other libs will pass it as empty string)
    if (value === "") return true;
    // for attr like multiple="false" (react will pass it as string)
    if (value === "false") return false;
    throw new Error(`Invalid boolean: "${value}"`);
};
/** @param {unknown} value */ const $cb0db7406dd90abe$var$asStore = (value)=>value === "auto" ? value : $cb0db7406dd90abe$export$ffde277b1072591c(value);
/** @param {unknown} value */ const $cb0db7406dd90abe$var$asCameraCapture = (value)=>{
    const strValue = $cb0db7406dd90abe$var$asString(value);
    if (strValue !== "user" && strValue !== "environment" && strValue !== "") throw new Error(`Invalid value: "${strValue}"`);
    return strValue;
};
/** @param {unknown} value */ const $cb0db7406dd90abe$var$asCameraMode = (value)=>{
    const strValue = $cb0db7406dd90abe$var$asString(value);
    if (!Object.values((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde)).includes(strValue)) throw new Error(`Invalid value: "${strValue}"`);
    return /** @type {import('../CameraSource/CameraSource.js').CameraMode} */ strValue;
};
/** @param {unknown} value */ const $cb0db7406dd90abe$var$asCameraModes = (value)=>{
    const str = $cb0db7406dd90abe$var$asString(value);
    const array = (0, $cf5145deda9036ee$export$7a086f785998e32e)(str);
    if (array.some((item)=>!Object.values((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde)).includes(item))) throw new Error(`Invalid value: "${JSON.stringify(array)}"`);
    return str;
};
/** @param {unknown} value */ const $cb0db7406dd90abe$var$asMetadata = (value)=>{
    if (typeof value === "object" && !Array.isArray(value)) return /** @type {import('../../types').Metadata} */ value;
    if (typeof value === "function") return /** @type {import('../../types').MetadataCallback} */ value;
    throw new Error("Invalid metadata value. Must be an object or function.");
};
/**
 * @template {{}} T
 * @param {unknown} value
 * @returns {T}
 */ const $cb0db7406dd90abe$var$asObject = (value)=>{
    if (typeof value === "object") return /** @type {T} */ value;
    throw new Error("Invalid value. Must be an object.");
};
/**
 * @template {Function} T
 * @param {unknown} value
 * @returns {T}
 */ const $cb0db7406dd90abe$var$asFunction = (value)=>{
    if (typeof value === "function") return /** @type {T} */ value;
    throw new Error("Invalid value. Must be a function.");
};
/**
 * @template {Function[] | string | {}} T
 * @param {unknown} value
 * @returns {T}
 */ const $cb0db7406dd90abe$var$asArray = (value)=>{
    if (Array.isArray(value)) return /** @type {T} */ value;
    throw new Error("Must be an array.");
};
/**
 * @type {{
 *   [Key in keyof import('../../types').ConfigType]: (
 *     value: unknown,
 *   ) => import('../../types').ConfigType[Key] | undefined;
 * }}
 */ const $cb0db7406dd90abe$var$mapping = {
    pubkey: $cb0db7406dd90abe$var$asString,
    multiple: $cb0db7406dd90abe$export$ffde277b1072591c,
    multipleMin: $cb0db7406dd90abe$var$asNumber,
    multipleMax: $cb0db7406dd90abe$var$asNumber,
    confirmUpload: $cb0db7406dd90abe$export$ffde277b1072591c,
    imgOnly: $cb0db7406dd90abe$export$ffde277b1072591c,
    accept: $cb0db7406dd90abe$var$asString,
    externalSourcesPreferredTypes: $cb0db7406dd90abe$var$asString,
    externalSourcesEmbedCss: $cb0db7406dd90abe$var$asString,
    store: $cb0db7406dd90abe$var$asStore,
    cameraMirror: $cb0db7406dd90abe$export$ffde277b1072591c,
    cameraCapture: $cb0db7406dd90abe$var$asCameraCapture,
    sourceList: $cb0db7406dd90abe$var$asString,
    maxLocalFileSizeBytes: $cb0db7406dd90abe$var$asNumber,
    thumbSize: $cb0db7406dd90abe$var$asNumber,
    showEmptyList: $cb0db7406dd90abe$export$ffde277b1072591c,
    useLocalImageEditor: $cb0db7406dd90abe$export$ffde277b1072591c,
    useCloudImageEditor: $cb0db7406dd90abe$export$ffde277b1072591c,
    cloudImageEditorTabs: $cb0db7406dd90abe$var$asString,
    removeCopyright: $cb0db7406dd90abe$export$ffde277b1072591c,
    cropPreset: $cb0db7406dd90abe$var$asString,
    imageShrink: $cb0db7406dd90abe$var$asString,
    modalScrollLock: $cb0db7406dd90abe$export$ffde277b1072591c,
    modalBackdropStrokes: $cb0db7406dd90abe$export$ffde277b1072591c,
    sourceListWrap: $cb0db7406dd90abe$export$ffde277b1072591c,
    remoteTabSessionKey: $cb0db7406dd90abe$var$asString,
    cdnCname: $cb0db7406dd90abe$var$asString,
    baseUrl: $cb0db7406dd90abe$var$asString,
    socialBaseUrl: $cb0db7406dd90abe$var$asString,
    secureSignature: $cb0db7406dd90abe$var$asString,
    secureExpire: $cb0db7406dd90abe$var$asString,
    secureDeliveryProxy: $cb0db7406dd90abe$var$asString,
    retryThrottledRequestMaxTimes: $cb0db7406dd90abe$var$asNumber,
    multipartMinFileSize: $cb0db7406dd90abe$var$asNumber,
    multipartChunkSize: $cb0db7406dd90abe$var$asNumber,
    maxConcurrentRequests: $cb0db7406dd90abe$var$asNumber,
    multipartMaxConcurrentRequests: $cb0db7406dd90abe$var$asNumber,
    multipartMaxAttempts: $cb0db7406dd90abe$var$asNumber,
    checkForUrlDuplicates: $cb0db7406dd90abe$export$ffde277b1072591c,
    saveUrlForRecurrentUploads: $cb0db7406dd90abe$export$ffde277b1072591c,
    groupOutput: $cb0db7406dd90abe$export$ffde277b1072591c,
    userAgentIntegration: $cb0db7406dd90abe$var$asString,
    debug: $cb0db7406dd90abe$export$ffde277b1072591c,
    localeName: $cb0db7406dd90abe$var$asString,
    metadata: $cb0db7406dd90abe$var$asMetadata,
    secureUploadsExpireThreshold: $cb0db7406dd90abe$var$asNumber,
    localeDefinitionOverride: /** @type {typeof asObject<import('../../types').LocaleDefinitionOverride>} */ $cb0db7406dd90abe$var$asObject,
    secureUploadsSignatureResolver: /** @type {typeof asFunction<import('../../types').SecureUploadsSignatureResolver>} */ $cb0db7406dd90abe$var$asFunction,
    secureDeliveryProxyUrlResolver: /** @type {typeof asFunction<import('../../types').SecureDeliveryProxyUrlResolver>} */ $cb0db7406dd90abe$var$asFunction,
    iconHrefResolver: /** @type {typeof asFunction<import('../../types').IconHrefResolver>} */ $cb0db7406dd90abe$var$asFunction,
    fileValidators: /** @type {typeof asArray<import('../../types').FileValidators>} */ $cb0db7406dd90abe$var$asArray,
    collectionValidators: /** @type {typeof asArray<import('../../types').CollectionValidators>} */ $cb0db7406dd90abe$var$asArray,
    cameraModes: $cb0db7406dd90abe$var$asCameraModes,
    defaultCameraMode: $cb0db7406dd90abe$var$asCameraMode,
    enableAudioRecording: $cb0db7406dd90abe$export$ffde277b1072591c,
    enableVideoRecording: $cb0db7406dd90abe$export$ffde277b1072591c,
    mediaRecorderOptions: $cb0db7406dd90abe$var$asObject,
    maxVideoRecordingDuration: $cb0db7406dd90abe$var$asNumber
};
const $cb0db7406dd90abe$export$fa1437ef11056dea = (key, value)=>{
    if (typeof value === "undefined" || value === null) return undefined;
    try {
        return $cb0db7406dd90abe$var$mapping[key](value);
    } catch (reason) {
        console.error(`Invalid value for config key "${key}".`, reason);
        return (0, $de12e36881279399$export$288021aefa12c882)[key];
    }
};




const $001ec2de1772825b$var$ASSERTIONS = [
    {
        test: (cfg)=>cfg.accept && !!cfg.imgOnly,
        message: "There could be a mistake.\nBoth `accept` and `imgOnly` parameters are set.\nThe value of `accept` will be concatenated with the internal image mime types list."
    },
    {
        test: (cfg)=>cfg.enableVideoRecording !== null,
        message: "The `enableVideoRecording` parameter is deprecated and will be removed in the next major release.\nPlease use the `cameraModes` parameter instead."
    },
    {
        test: (cfg)=>cfg.defaultCameraMode !== null,
        message: "The `defaultCameraMode` parameter is deprecated and will be removed in the next major release.\nPlease use the `cameraModes` parameter instead."
    }
];
const $001ec2de1772825b$export$5c5569dc93cb77ef = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(/** @param {import('../../types').ConfigType} cfg */ (cfg)=>{
    for (const { test: test, message: message } of $001ec2de1772825b$var$ASSERTIONS)if (test(cfg)) (0, $0c6bb43f104c669a$export$5b28268982f175ba)(message);
}, 0);



const $0b47551f21e50968$export$ba119a5d0f3aa548 = ({ key: key, value: value, setValue: setValue, getValue: getValue })=>{
    if (key === "enableVideoRecording" && value !== null) {
        let cameraModes = (0, $cf5145deda9036ee$export$7a086f785998e32e)(getValue("cameraModes"));
        if (value && !cameraModes.includes("video")) cameraModes = cameraModes.concat("video");
        else if (!value) cameraModes = cameraModes.filter((mode)=>mode !== "video");
        setValue("cameraModes", (0, $cf5145deda9036ee$export$1494b4974e65fb4e)(cameraModes));
    }
    if (key === "defaultCameraMode" && value !== null) {
        let cameraModes = (0, $cf5145deda9036ee$export$7a086f785998e32e)(getValue("cameraModes"));
        cameraModes = cameraModes.sort((a, b)=>{
            if (a === value) return -1;
            if (b === value) return 1;
            return 0;
        });
        setValue("cameraModes", (0, $cf5145deda9036ee$export$1494b4974e65fb4e)(cameraModes));
    }
};


const $8f4a76de4f7f9134$var$allConfigKeys = /** @type {(keyof import('../../types').ConfigType)[]} */ [
    // "debug" option should go first to be able to print debug messages from the very beginning
    ...new Set([
        "debug",
        ...Object.keys((0, $de12e36881279399$export$288021aefa12c882))
    ])
];
const $8f4a76de4f7f9134$export$6e9d08db84eeac3e = [
    "metadata",
    "localeDefinitionOverride",
    "secureUploadsSignatureResolver",
    "secureDeliveryProxyUrlResolver",
    "iconHrefResolver",
    "fileValidators",
    "collectionValidators",
    "mediaRecorderOptions"
];
/** @type {(key: keyof import('../../types').ConfigType) => key is keyof import('../../types').ConfigComplexType} */ const $8f4a76de4f7f9134$var$isComplexKey = (key)=>$8f4a76de4f7f9134$export$6e9d08db84eeac3e.includes(key);
/** Config keys that can be passed as attribute */ const $8f4a76de4f7f9134$var$plainConfigKeys = /** @type {(keyof import('../../types').ConfigPlainType)[]} */ $8f4a76de4f7f9134$var$allConfigKeys.filter((key)=>!$8f4a76de4f7f9134$var$isComplexKey(key));
/**
 * Mapping of attribute names to config keys Kebab-case and lowercase are supported. lowercase could be used by
 * frameworks like vue and react.
 */ const $8f4a76de4f7f9134$var$attrKeyMapping = /** @type {Record<keyof import('../../types').ConfigAttributesType, keyof import('../../types').ConfigPlainType>} */ {
    ...Object.fromEntries($8f4a76de4f7f9134$var$plainConfigKeys.map((key)=>[
            (0, $631a809cf1e31712$export$73bda83cddbc7187)(key),
            key
        ])),
    ...Object.fromEntries($8f4a76de4f7f9134$var$plainConfigKeys.map((key)=>[
            key.toLowerCase(),
            key
        ]))
};
/** Mapping of attribute names to state */ const $8f4a76de4f7f9134$var$attrStateMapping = /** @type {Record<keyof import('../../types').ConfigAttributesType, string>} */ {
    ...Object.fromEntries($8f4a76de4f7f9134$var$plainConfigKeys.map((key)=>[
            (0, $631a809cf1e31712$export$73bda83cddbc7187)(key),
            (0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key)
        ])),
    ...Object.fromEntries($8f4a76de4f7f9134$var$plainConfigKeys.map((key)=>[
            key.toLowerCase(),
            (0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key)
        ]))
};
/** @param {string} key */ const $8f4a76de4f7f9134$var$getLocalPropName = (key)=>"__" + key;
class $8f4a76de4f7f9134$var$ConfigClass extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    requireCtxName = true;
    constructor(){
        super();
        /** @type {Block['init$'] & import('../../types').ConfigType} */ this.init$ = {
            ...this.init$,
            ...Object.fromEntries(Object.entries((0, $de12e36881279399$export$288021aefa12c882)).map(([key, value])=>[
                    (0, $93e58aaabbd81ebb$export$16930f9e982fa181)(/** @type {keyof import('../../types').ConfigType} */ key),
                    value
                ]))
        };
    }
    /**
   * @private
   * @param {keyof import('../../types').ConfigType} key
   * @param {unknown} value
   */ _flushValueToAttribute(key, value) {
        if ($8f4a76de4f7f9134$var$plainConfigKeys.includes(key)) {
            // Flush the value to the DOM attributes
            const attrs = [
                ...new Set([
                    (0, $631a809cf1e31712$export$73bda83cddbc7187)(key),
                    key.toLowerCase()
                ])
            ];
            for (const attr of attrs){
                if (typeof value === "undefined" || value === null) this.removeAttribute(attr);
                else if (this.getAttribute(attr) !== value.toString()) this.setAttribute(attr, value.toString());
            }
        }
    }
    /**
   * @private
   * @param {keyof import('../../types').ConfigType} key
   * @param {unknown} value
   */ _flushValueToState(key, value) {
        if (this.$[(0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key)] !== value) {
            if (typeof value === "undefined" || value === null) this.$[(0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key)] = (0, $de12e36881279399$export$288021aefa12c882)[key];
            else this.$[(0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key)] = value;
        }
    }
    /**
   * @private
   * @param {keyof import('../../types').ConfigType} key
   * @param {unknown} value
   */ _setValue(key, value) {
        const anyThis = /** @type {typeof this & any} */ this;
        const normalizedValue = (0, $cb0db7406dd90abe$export$fa1437ef11056dea)(key, value);
        const localPropName = $8f4a76de4f7f9134$var$getLocalPropName(key);
        if (anyThis[localPropName] === normalizedValue) return;
        this._assertSameValueDifferentReference(key, anyThis[localPropName], normalizedValue);
        anyThis[localPropName] = normalizedValue;
        // Flush the value to the state
        this._flushValueToAttribute(key, normalizedValue);
        this._flushValueToState(key, normalizedValue);
        this.debugPrint(`[uc-config] "${key}"`, normalizedValue);
        (0, $001ec2de1772825b$export$5c5569dc93cb77ef)(this.cfg);
        (0, $0b47551f21e50968$export$ba119a5d0f3aa548)({
            key: key,
            value: normalizedValue ?? null,
            setValue: this._setValue.bind(this),
            getValue: this._getValue.bind(this)
        });
    }
    /**
   * @private
   * @param {keyof import('../../types').ConfigType} key
   */ _getValue(key) {
        const anyThis = /** @type {typeof this & any} */ this;
        const localPropName = $8f4a76de4f7f9134$var$getLocalPropName(key);
        return anyThis[localPropName] ?? this.$[(0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key)];
    }
    /**
   * @param {string} key
   * @param {unknown} previousValue
   * @param {unknown} nextValue
   */ _assertSameValueDifferentReference(key, previousValue, nextValue) {
        if (this.cfg.debug) {
            if (nextValue !== previousValue && typeof nextValue === "object" && typeof previousValue === "object" && JSON.stringify(nextValue) === JSON.stringify(previousValue)) {
                console.warn(`[uc-config] Option "${key}" value is the same as the previous one but the reference is different`);
                console.warn(`[uc-config] You should avoid changing the reference of the object to prevent unnecessary calculations`);
                console.warn(`[uc-config] "${key}" previous value:`, previousValue);
                console.warn(`[uc-config] "${key}" new value:`, nextValue);
            }
        }
    }
    initCallback() {
        super.initCallback();
        const anyThis = /** @type {typeof this & any} */ this;
        // Subscribe to the state changes and update the local properties and attributes.
        // Initial callback call is disabled to prevent the initial value to be set here.
        // Initial value will be set below, skipping the default values.
        for (const key of $8f4a76de4f7f9134$var$plainConfigKeys)this.sub((0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key), (value)=>{
            this._setValue(key, value);
        }, false);
        for (const key of $8f4a76de4f7f9134$var$allConfigKeys){
            // Flush the initial value to the state.
            // Initial value is taken from the DOM property if it was set before the element was initialized.
            // If no DOM property was set, the initial value is taken from the initialConfig.
            const initialValue = anyThis[key] ?? this.$[(0, $93e58aaabbd81ebb$export$16930f9e982fa181)(key)];
            if (initialValue !== (0, $de12e36881279399$export$288021aefa12c882)[key]) this._setValue(key, initialValue);
            // Define DOM property setters and getters
            // They will be used in the userland directly or by the frameworks
            Object.defineProperty(this, key, {
                /** @param {unknown} value */ set: (value)=>{
                    this._setValue(key, value);
                },
                get: ()=>{
                    return this._getValue(key);
                }
            });
        }
    }
    /**
   * @param {keyof typeof attrStateMapping} name
   * @param {string} oldVal
   * @param {string} newVal
   */ attributeChangedCallback(name, oldVal, newVal) {
        if (oldVal === newVal) return;
        const anyThis = /** @type {typeof this & any} */ this;
        const key = $8f4a76de4f7f9134$var$attrKeyMapping[name];
        // attributeChangedCallback could be called before the initCallback
        // so we set the DOM property instead of calling this._setValue.
        // If the block was initialized, the value will be handled by the setter.
        // If the block was not initialized, the value will be set to the DOM property
        // and handled on initialization.
        anyThis[key] = newVal;
    }
}
$8f4a76de4f7f9134$var$ConfigClass.bindAttributes($8f4a76de4f7f9134$var$attrStateMapping);
/**
 * Define empty DOM properties for all config keys on the Custom Element class prototype to make them checkable using
 * `key in element` syntax. This is required for the frameworks DOM property bindings to work.
 */ for (const key of $8f4a76de4f7f9134$var$allConfigKeys)/** @type {any} */ $8f4a76de4f7f9134$var$ConfigClass.prototype[key] = undefined;
const $8f4a76de4f7f9134$export$29cd7b75162a9425 = /** @type {Config} */ /** @type {unknown} */ $8f4a76de4f7f9134$var$ConfigClass;


// @ts-check

class $2baaef586dccc7b7$export$f04a61298a47a40f extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            name: "",
            href: ""
        };
    }
    initCallback() {
        super.initCallback();
        this.sub("name", (val)=>{
            if (!val) return;
            let iconHref = `#uc-icon-${val}`;
            this.subConfigValue("iconHrefResolver", (iconHrefResolver)=>{
                if (iconHrefResolver) {
                    const customIconHref = iconHrefResolver(val);
                    iconHref = customIconHref ?? iconHref;
                }
                this.$.href = iconHref;
            });
        });
        this.setAttribute("aria-hidden", "true");
    }
}
$2baaef586dccc7b7$export$f04a61298a47a40f.template = /* HTML */ `
  <svg ref="svg" xmlns="http://www.w3.org/2000/svg">
    <use set="@href: href;"></use>
  </svg>
`;
$2baaef586dccc7b7$export$f04a61298a47a40f.bindAttributes({
    name: "name"
});





/**
 * @template T
 * @param {T[]} arr
 * @returns {T[]}
 */ const $d48541f0df1023a7$export$bbd17ecb0679edd7 = (arr)=>{
    return [
        ...new Set(arr)
    ];
};


const $435531d08418e84a$export$8ee33fdb5e138629 = (params)=>Object.entries(params).filter(([key, value])=>value !== undefined && value !== "").map(([key, value])=>{
        if (key === "cdn-operations") return value;
        if (key === "analytics") return value;
        return `${key}/${value}`;
    });



const $67af7cc115764c08$var$DEFAULT_CDN_BASE = "https://ucarecdn.com";
const $67af7cc115764c08$export$16388cec917aaec5 = Object.freeze({
    "dev-mode": {},
    pubkey: {},
    uuid: {},
    src: {},
    // alt: {},
    // 'placeholder-src': {}, // available via CSS
    lazy: {
        default: 1
    },
    intersection: {},
    breakpoints: {
    },
    "cdn-cname": {
        default: $67af7cc115764c08$var$DEFAULT_CDN_BASE
    },
    "proxy-cname": {},
    "secure-delivery-proxy": {},
    "hi-res-support": {
        default: 1
    },
    "ultra-res-support": {},
    format: {},
    "cdn-operations": {},
    progressive: {},
    quality: {},
    "is-background-for": {},
    "is-preview-blur": {
        default: 1
    }
});


const $dc85bec9322b19ae$export$571a84e7679dfc34 = "--uc-img-";
const $dc85bec9322b19ae$export$d8b6186ee6102965 = "unresolved";
const $dc85bec9322b19ae$export$a1464453b4b0b11 = 2;
const $dc85bec9322b19ae$export$d40396ab3f783ece = 3;
const $dc85bec9322b19ae$export$c338f1d796ca0b28 = !window.location.host.trim() || window.location.host.includes(":") || window.location.hostname.includes("localhost");
const $dc85bec9322b19ae$export$157e21b1e4c118d6 = 3000;
const $dc85bec9322b19ae$export$639e222b32614f23 = 5000;
const $dc85bec9322b19ae$export$84eecae4606a100 = Object.freeze({
    PREVIEW: "PREVIEW",
    MAIN: "MAIN"
});



const $dfbe75a052979dc9$var$CSS_PROPS = Object.create(null);
for(let prop in 0, $67af7cc115764c08$export$16388cec917aaec5)$dfbe75a052979dc9$var$CSS_PROPS[(0, $dc85bec9322b19ae$export$571a84e7679dfc34) + prop] = (0, $67af7cc115764c08$export$16388cec917aaec5)[prop]?.default || "";
class $dfbe75a052979dc9$export$e57f3f42ad40d4f8 extends (0, $7868cd5b229e5c15$export$55ae5207ce896a6b) {
    cssInit$ = $dfbe75a052979dc9$var$CSS_PROPS;
    /**
   * @param {String} key
   * @returns {any}
   */ $$(key) {
        return this.$[(0, $dc85bec9322b19ae$export$571a84e7679dfc34) + key];
    }
    /** @param {Object<String, String | Number>} kvObj */ set$$(kvObj) {
        for(let key in kvObj)this.$[(0, $dc85bec9322b19ae$export$571a84e7679dfc34) + key] = kvObj[key];
    }
    /**
   * @param {String} key
   * @param {(val: any) => void} kbFn
   */ sub$$(key, kbFn) {
        this.sub((0, $dc85bec9322b19ae$export$571a84e7679dfc34) + key, (val)=>{
            // null comes from CSS context property
            // empty string comes from attribute value
            if (val === null || val === "") return;
            kbFn(val);
        });
    }
    analyticsParams() {
        return `-/@clib/${0, $4b0d1e35b7235ecb$export$b8b9d90f9e5bd72b}/${0, $4b0d1e35b7235ecb$export$4a03ffab3315ee34}/uc-img/`;
    }
    initAttributes(el) {
        [
            ...this.attributes
        ].forEach((attr)=>{
            if (!(0, $67af7cc115764c08$export$16388cec917aaec5)[attr.name]) el.setAttribute(attr.name, attr.value);
        });
    }
    /**
   * @param {HTMLElement} el
   * @param {() => void} cbkFn
   */ initIntersection(el, cbkFn) {
        let opts = {
            root: null,
            rootMargin: "0px"
        };
        /** @private */ this._isnObserver = new IntersectionObserver((entries)=>{
            entries.forEach((ent)=>{
                if (ent.isIntersecting) {
                    cbkFn();
                    this._isnObserver.unobserve(el);
                }
            });
        }, opts);
        this._isnObserver.observe(el);
        if (!this._observed) /** @private */ this._observed = new Set();
        this._observed.add(el);
    }
    destroyCallback() {
        super.destroyCallback();
        if (this._isnObserver) {
            this._observed.forEach((el)=>{
                this._isnObserver.unobserve(el);
            });
            this._isnObserver = null;
        }
        (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx(this);
    }
    static get observedAttributes() {
        return Object.keys((0, $67af7cc115764c08$export$16388cec917aaec5));
    }
    attributeChangedCallback(name, oldVal, newVal) {
        window.setTimeout(()=>{
            this.$[(0, $dc85bec9322b19ae$export$571a84e7679dfc34) + name] = newVal;
        });
    }
}



class $c4f4d788d2064b4f$export$34a767944be4878a extends (0, $dfbe75a052979dc9$export$e57f3f42ad40d4f8) {
    _img = new Image();
    _imgPreview = new Image();
    /**
   * @private
   * @param {String} src
   */ _fmtAbs(src) {
        let isRel = !src.includes("//");
        if (isRel && !(0, $dc85bec9322b19ae$export$c338f1d796ca0b28)) src = new URL(src, document.baseURI).href;
        return src;
    }
    /**
   * Validate size
   *
   * @param {String} [size]
   * @returns {String | Number}
   */ _validateSize(size) {
        if (size?.trim() !== "") {
            // Extract numeric part
            let numericPart = size.match(/\d+/)[0];
            // Extract alphabetic part
            let alphabeticPart = size.match(/[a-zA-Z]+/)[0];
            const bp = parseInt(numericPart, 10);
            if (Number(bp) > (0, $dc85bec9322b19ae$export$639e222b32614f23) && this.hasFormatJPG) return (0, $dc85bec9322b19ae$export$639e222b32614f23) + alphabeticPart;
            else if (Number(bp) > (0, $dc85bec9322b19ae$export$157e21b1e4c118d6) && !this.hasFormatJPG) return (0, $dc85bec9322b19ae$export$157e21b1e4c118d6) + alphabeticPart;
        }
        return size;
    }
    /**
   * Image operations
   *
   * @param {String} [size]
   * @param {String} [blur]
   */ _getCdnModifiers(size, blur) {
        const params = {
            format: this.$$("format"),
            quality: this.$$("quality"),
            resize: this._validateSize(size),
            blur: blur,
            "cdn-operations": this.$$("cdn-operations"),
            analytics: this.analyticsParams()
        };
        return (0, $8c66713b0e57faf9$export$8fb94a7da5f60007)(...(0, $435531d08418e84a$export$8ee33fdb5e138629)(params));
    }
    /**
   * @private
   * @param {String} [size]
   * @param {String} [blur]
   * @returns {any}
   */ _getUrlBase(size = "", blur = "") {
        if (this.$$("src").startsWith("data:") || this.$$("src").startsWith("blob:")) return this.$$("src");
        // Localhost + relative image path (DO NOTHING):
        if ((0, $dc85bec9322b19ae$export$c338f1d796ca0b28) && this.$$("src") && !this.$$("src").includes("//")) return this._proxyUrl(this.$$("src"));
        let cdnModifiers = this._getCdnModifiers(size, blur);
        if (this.$$("src").startsWith(this.$$("cdn-cname"))) return (0, $8c66713b0e57faf9$export$226a37372a69410c)(this.$$("src"), cdnModifiers);
        // Alternative CDN name:
        if (this.$$("cdn-cname") && this.$$("uuid")) return this._proxyUrl((0, $8c66713b0e57faf9$export$226a37372a69410c)(//
        (0, $8c66713b0e57faf9$export$816ae8f9591f1ab2)(this.$$("cdn-cname"), this.$$("uuid")), cdnModifiers));
        // UUID only:
        if (this.$$("uuid")) return this._proxyUrl((0, $8c66713b0e57faf9$export$226a37372a69410c)(//
        (0, $8c66713b0e57faf9$export$816ae8f9591f1ab2)(this.$$("cdn-cname"), this.$$("uuid")), cdnModifiers));
        // Alternative proxy name:
        if (this.$$("proxy-cname")) return this._proxyUrl((0, $8c66713b0e57faf9$export$226a37372a69410c)(//
        this.$$("proxy-cname"), cdnModifiers, this._fmtAbs(this.$$("src"))));
        // Project pubkey only:
        if (this.$$("pubkey")) return this._proxyUrl((0, $8c66713b0e57faf9$export$226a37372a69410c)(//
        `https://${this.$$("pubkey")}.ucr.io/`, cdnModifiers, this._fmtAbs(this.$$("src"))));
    }
    /**
   * @private
   * @param {String} url
   * @returns {String}
   */ _proxyUrl(url) {
        let previewProxy = this.$$("secure-delivery-proxy");
        if (!previewProxy) return url;
        return (0, $0d29a7eceb5ca5dd$export$34afab4d3a450b60)(this.$$("secure-delivery-proxy"), {
            previewUrl: url
        }, {
            transform: (value)=>window.encodeURIComponent(value)
        });
    }
    /**
   * @param {HTMLElement} el
   * @param {Number} [k]
   * @param {Boolean} [wOnly]
   */ _getElSize(el, k = 1, wOnly = true) {
        let rect = el.getBoundingClientRect();
        let w = k * Math.round(rect.width);
        let h = wOnly ? "" : k * Math.round(rect.height);
        if (w || h) return `${w ? w : ""}x${h ? h : ""}`;
        else return null;
    }
    /** @param {HTMLImageElement} img */ _setupEventProxy(img) {
        /** @param {Event} e */ let proxifyEvent = (e)=>{
            e.stopPropagation();
            let event = new Event(e.type, e);
            this.dispatchEvent(event);
        };
        let EVENTS = [
            "load",
            "error"
        ];
        for (let event of EVENTS)img.addEventListener(event, proxifyEvent);
    }
    /** @type {HTMLImageElement} */ get img() {
        if (!this.hasPreviewImage) {
            this._setupConfigForImage({
                elNode: this._img
            });
            this.appendChild(this._img);
        }
        return this._img;
    }
    get currentImg() {
        return this.hasPreviewImage ? {
            type: (0, $dc85bec9322b19ae$export$84eecae4606a100).PREVIEW,
            img: this._imgPreview
        } : {
            type: (0, $dc85bec9322b19ae$export$84eecae4606a100).MAIN,
            img: this.img
        };
    }
    get hasPreviewImage() {
        return this.$$("is-preview-blur");
    }
    get bgSelector() {
        return this.$$("is-background-for");
    }
    get breakpoints() {
        if (this.$$("breakpoints")) {
            const list = (0, $15ba4abb0cb95799$export$b9ca061da17f2d30)(this.$$("breakpoints"));
            return (0, $d48541f0df1023a7$export$bbd17ecb0679edd7)(list.map((bp)=>parseInt(bp, 10)));
        } else return null;
    }
    get hasFormatJPG() {
        return this.$$("format").toLowerCase() === "jpeg";
    }
    /** @param {HTMLElement} el */ renderBg(el) {
        let imgSet = new Set();
        imgSet.add(`url("${this._getUrlBase(this._getElSize(el))}") 1x`);
        if (this.$$("hi-res-support")) imgSet.add(`url("${this._getUrlBase(this._getElSize(el, (0, $dc85bec9322b19ae$export$a1464453b4b0b11)))}") ${(0, $dc85bec9322b19ae$export$a1464453b4b0b11)}x`);
        if (this.$$("ultra-res-support")) imgSet.add(`url("${this._getUrlBase(this._getElSize(el, (0, $dc85bec9322b19ae$export$d40396ab3f783ece)))}") ${(0, $dc85bec9322b19ae$export$d40396ab3f783ece)}x`);
        let iSet = `image-set(${[
            ...imgSet
        ].join(", ")})`;
        el.style.setProperty("background-image", iSet);
        el.style.setProperty("background-image", "-webkit-" + iSet);
    }
    getSrcset() {
        let srcset = new Set();
        if (this.breakpoints) this.breakpoints.forEach((bp)=>{
            srcset.add(this._getUrlBase(bp + "x") + ` ${this._validateSize(bp + "w")}`);
            if (this.$$("hi-res-support")) srcset.add(this._getUrlBase(bp * (0, $dc85bec9322b19ae$export$a1464453b4b0b11) + "x") + ` ${this._validateSize(bp * (0, $dc85bec9322b19ae$export$a1464453b4b0b11) + "w")}`);
            if (this.$$("ultra-res-support")) srcset.add(this._getUrlBase(bp * (0, $dc85bec9322b19ae$export$d40396ab3f783ece) + "x") + ` ${this._validateSize(bp * (0, $dc85bec9322b19ae$export$d40396ab3f783ece) + "w")}`);
        });
        else {
            srcset.add(this._getUrlBase(this._getElSize(this.currentImg.img)) + " 1x");
            if (this.$$("hi-res-support")) srcset.add(this._getUrlBase(this._getElSize(this.currentImg.img, 2)) + " 2x");
            if (this.$$("ultra-res-support")) srcset.add(this._getUrlBase(this._getElSize(this.currentImg.img, 3)) + " 3x");
        }
        return [
            ...srcset
        ].join();
    }
    getSrc() {
        return this._getUrlBase();
    }
    get srcUrlPreview() {
        return this._getUrlBase("100x", "100");
    }
    renderBackground() {
        [
            ...document.querySelectorAll(this.bgSelector)
        ].forEach((el)=>{
            if (this.$$("intersection")) this.initIntersection(el, ()=>{
                this.renderBg(el);
            });
            else this.renderBg(el);
        });
    }
    _appendURL({ elNode: elNode, src: src, srcset: srcset }) {
        if (src) elNode.src = src;
        if (srcset) elNode.srcset = srcset;
    }
    _setupConfigForImage({ elNode: elNode }) {
        this._setupEventProxy(elNode);
        this.initAttributes(elNode);
    }
    loaderImage({ src: src, srcset: srcset, elNode: elNode }) {
        return new Promise((resolve, reject)=>{
            this._setupConfigForImage({
                elNode: elNode
            });
            elNode.setAttribute((0, $dc85bec9322b19ae$export$d8b6186ee6102965), "");
            elNode.addEventListener("load", ()=>{
                elNode.removeAttribute((0, $dc85bec9322b19ae$export$d8b6186ee6102965));
                resolve(elNode);
            });
            elNode.addEventListener("error", ()=>{
                reject(false);
            });
            this._appendURL({
                elNode: elNode,
                src: src,
                srcset: srcset
            });
        });
    }
    async renderImage() {
        if (this.$$("intersection")) {
            if (this.hasPreviewImage) {
                this._setupConfigForImage({
                    elNode: this._imgPreview
                });
                this.appendChild(this._imgPreview);
            }
            this.initIntersection(this.currentImg.img, async ()=>{
                if (this.hasPreviewImage) this._imgPreview.src = this.srcUrlPreview;
                try {
                    await this.loaderImage({
                        src: this.getSrc(),
                        srcset: this.getSrcset(),
                        elNode: this._img
                    });
                    if (this.hasPreviewImage) await this._imgPreview.remove();
                    this.appendChild(this._img);
                } catch (e) {
                    if (this.hasPreviewImage) await this._imgPreview?.remove();
                    this.appendChild(this._img);
                }
            });
            return;
        }
        try {
            if (this.hasPreviewImage) {
                await this.loaderImage({
                    src: this.srcUrlPreview,
                    elNode: this._imgPreview
                });
                this.appendChild(this._imgPreview);
            }
            await this.loaderImage({
                src: this.getSrc(),
                srcset: this.getSrcset(),
                elNode: this._img
            });
            if (this.hasPreviewImage) await this._imgPreview?.remove();
            this.appendChild(this._img);
        } catch (e) {
            if (this.hasPreviewImage) await this._imgPreview?.remove();
            this.appendChild(this._img);
        }
    }
    init() {
        if (this.bgSelector) this.renderBackground();
        else this.renderImage();
    }
}


class $23e7ca24d649e9ca$export$cc7b5f925acc71d3 extends (0, $c4f4d788d2064b4f$export$34a767944be4878a) {
    initCallback() {
        super.initCallback();
        this.sub$$("src", ()=>{
            this.init();
        });
        this.sub$$("uuid", ()=>{
            this.init();
        });
        this.sub$$("lazy", (val)=>{
            if (!this.$$("is-background-for") && !this.$$("is-preview-blur")) this.img.loading = val ? "lazy" : "eager";
        });
    }
}


// @ts-check


class $98b837d018ab537b$export$ce3de857dd70689d extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    static styleAttrs = [
        ...super.styleAttrs,
        "uc-simple-btn"
    ];
    couldBeCtxOwner = true;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            withDropZone: true,
            onClick: ()=>{
                this.api.initFlow();
            },
            "button-text": ""
        };
    }
    initCallback() {
        super.initCallback();
        this.defineAccessor("dropzone", /** @param {unknown} val */ (val)=>{
            if (typeof val === "undefined") return;
            this.$.withDropZone = (0, $cb0db7406dd90abe$export$ffde277b1072591c)(val);
        });
        this.subConfigValue("multiple", (val)=>{
            this.$["button-text"] = val ? "upload-files" : "upload-file";
        });
    }
}
$98b837d018ab537b$export$ce3de857dd70689d.template = /* HTML */ `
  <uc-drop-area set="@disabled: !withDropZone">
    <button type="button" set="onclick: onClick">
      <uc-icon name="upload"></uc-icon>
      <span l10n="button-text"></span>
      <slot></slot>
      <div class="uc-visual-drop-area" l10n="drop-files-here"></div>
    </button>
  </uc-drop-area>
`;
$98b837d018ab537b$export$ce3de857dd70689d.bindAttributes({
    // @ts-expect-error TODO: we need to update symbiote types
    dropzone: null
});



class $bba970d19bfec719$export$10a8e4c39671907 extends (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747) {
    historyTracked = true;
    /** @type {import('../../abstract/ActivityBlock.js').ActivityType} */ activityType = "start-from";
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType);
    }
}
$bba970d19bfec719$export$10a8e4c39671907.template = /* HTML */ ` <div class="uc-content"><slot></slot></div> `;


// @ts-check






// @ts-check
/**
 * @typedef {{
 *       type: 'file';
 *       file: File;
 *       fullPath?: string;
 *     }
 *   | {
 *       type: 'url';
 *       url: string;
 *     }} DropItem
 */ /**
 * @param {File} file
 * @returns {Promise<boolean>}
 */ function $6321662d47f5a56d$var$checkIsDirectory(file) {
    return new Promise((resolve)=>{
        if (typeof window.FileReader !== "function") resolve(false);
        try {
            let reader = new FileReader();
            reader.onerror = ()=>{
                resolve(true);
            };
            /** @param {Event} e */ let onLoad = (e)=>{
                if (e.type !== "loadend") reader.abort();
                resolve(false);
            };
            reader.onloadend = onLoad;
            reader.onprogress = onLoad;
            reader.readAsDataURL(file);
        } catch (err) {
            resolve(false);
        }
    });
}
/**
 * @param {FileSystemEntry} webkitEntry
 * @param {string} dataTransferItemType
 * @returns {Promise<DropItem[] | null>}
 */ function $6321662d47f5a56d$var$readEntryContentAsync(webkitEntry, dataTransferItemType) {
    return new Promise((resolve)=>{
        let reading = 0;
        /** @type {DropItem[]} */ const dropItems = [];
        /** @param {FileSystemEntry} entry */ const readEntry = (entry)=>{
            if (!entry) {
                console.warn("Unexpectedly received empty content entry", {
                    scope: "drag-and-drop"
                });
                resolve(null);
            }
            if (entry.isFile) {
                reading++;
                /** @type {FileSystemFileEntry} */ entry.file((file)=>{
                    reading--;
                    // webkitGetAsEntry don't provide type for HEIC images at least, so we use type value from dataTransferItem
                    const clonedFile = new File([
                        file
                    ], file.name, {
                        type: file.type || dataTransferItemType
                    });
                    dropItems.push({
                        type: "file",
                        file: clonedFile,
                        fullPath: entry.fullPath
                    });
                    if (reading === 0) resolve(dropItems);
                });
            } else if (entry.isDirectory) readReaderContent(/** @type {FileSystemDirectoryEntry} */ entry.createReader());
        };
        /** @param {FileSystemDirectoryReader} reader */ let readReaderContent = (reader)=>{
            reading++;
            reader.readEntries((entries)=>{
                reading--;
                for (let entry of entries)readEntry(entry);
                if (reading === 0) resolve(dropItems);
            });
        };
        readEntry(webkitEntry);
    });
}
function $6321662d47f5a56d$export$6b1b1fea528d8dda(dataTransfer) {
    /** @type {DropItem[]} */ const dropItems = [];
    const promises = [];
    for(let i = 0; i < dataTransfer.items.length; i++){
        let item = dataTransfer.items[i];
        if (!item) continue;
        if (item.kind === "file") {
            const itemType = item.type;
            if (typeof item.webkitGetAsEntry === "function" || typeof /** @type {any} */ item.getAsEntry === "function") {
                let entry = typeof item.webkitGetAsEntry === "function" ? item.webkitGetAsEntry() : /** @type {any} */ item.getAsEntry();
                promises.push($6321662d47f5a56d$var$readEntryContentAsync(entry, itemType).then((items)=>{
                    if (items) dropItems.push(...items);
                }));
                continue;
            }
            const file = item.getAsFile();
            file && promises.push($6321662d47f5a56d$var$checkIsDirectory(file).then((isDirectory)=>{
                if (isDirectory) ;
                else dropItems.push({
                    type: "file",
                    file: file
                });
            }));
        } else if (item.kind === "string" && item.type.match("^text/uri-list")) promises.push(new Promise((resolve)=>{
            item.getAsString((value)=>{
                dropItems.push({
                    type: "url",
                    url: value
                });
                resolve(undefined);
            });
        }));
    }
    return Promise.all(promises).then(()=>dropItems);
}


const $4f65cb1abf2614c5$export$e0edc031b86cc335 = {
    ACTIVE: 0,
    INACTIVE: 1,
    NEAR: 2,
    OVER: 3
};
let $4f65cb1abf2614c5$var$RESET_EVENTS = [
    "focus"
];
let $4f65cb1abf2614c5$var$NEAR_OFFSET = 100;
let $4f65cb1abf2614c5$var$nearnessRegistry = new Map();
/**
 * @param {[x: number, y: number]} p
 * @param {{ x: number; y: number; width: number; height: number }} r
 * @returns {number}
 */ function $4f65cb1abf2614c5$var$distance(p, r) {
    let cx = Math.max(Math.min(p[0], r.x + r.width), r.x);
    let cy = Math.max(Math.min(p[1], r.y + r.height), r.y);
    return Math.sqrt((p[0] - cx) * (p[0] - cx) + (p[1] - cy) * (p[1] - cy));
}
function $4f65cb1abf2614c5$export$4a249ef0d5b8b861(desc) {
    let eventCounter = 0;
    let body = document.body;
    let switchHandlers = new Set();
    let handleSwitch = (fn)=>switchHandlers.add(fn);
    let state = $4f65cb1abf2614c5$export$e0edc031b86cc335.INACTIVE;
    let setState = (newState)=>{
        if (desc.shouldIgnore() && newState !== $4f65cb1abf2614c5$export$e0edc031b86cc335.INACTIVE) return;
        if (state !== newState) switchHandlers.forEach((fn)=>fn(newState));
        state = newState;
    };
    let isDragging = ()=>eventCounter > 0;
    handleSwitch((newState)=>desc.onChange(newState));
    let onResetEvent = ()=>{
        eventCounter = 0;
        setState($4f65cb1abf2614c5$export$e0edc031b86cc335.INACTIVE);
    };
    let onDragEnter = ()=>{
        eventCounter += 1;
        if (state === $4f65cb1abf2614c5$export$e0edc031b86cc335.INACTIVE) setState($4f65cb1abf2614c5$export$e0edc031b86cc335.ACTIVE);
    };
    let onDragLeave = ()=>{
        eventCounter -= 1;
        if (!isDragging()) setState($4f65cb1abf2614c5$export$e0edc031b86cc335.INACTIVE);
    };
    let onDrop = (e)=>{
        e.preventDefault();
        eventCounter = 0;
        setState($4f65cb1abf2614c5$export$e0edc031b86cc335.INACTIVE);
    };
    let onDragOver = (e)=>{
        if (desc.shouldIgnore()) return;
        if (!isDragging()) eventCounter += 1;
        /** @type {[Number, Number]} */ let dragPoint = [
            e.x,
            e.y
        ];
        let targetRect = desc.element.getBoundingClientRect();
        let nearness = Math.floor($4f65cb1abf2614c5$var$distance(dragPoint, targetRect));
        let isNear = nearness < $4f65cb1abf2614c5$var$NEAR_OFFSET;
        let isOver = e.composedPath().includes(desc.element);
        $4f65cb1abf2614c5$var$nearnessRegistry.set(desc.element, nearness);
        let isNearest = Math.min(...$4f65cb1abf2614c5$var$nearnessRegistry.values()) === nearness;
        if (isOver && isNearest) {
            e.preventDefault();
            setState($4f65cb1abf2614c5$export$e0edc031b86cc335.OVER);
        } else if (isNear && isNearest) setState($4f65cb1abf2614c5$export$e0edc031b86cc335.NEAR);
        else setState($4f65cb1abf2614c5$export$e0edc031b86cc335.ACTIVE);
    };
    let onElementDrop = async (e)=>{
        if (desc.shouldIgnore()) return;
        e.preventDefault();
        let items = await (0, $6321662d47f5a56d$export$6b1b1fea528d8dda)(e.dataTransfer);
        desc.onItems(items);
        setState($4f65cb1abf2614c5$export$e0edc031b86cc335.INACTIVE);
    };
    body.addEventListener("drop", onDrop);
    body.addEventListener("dragleave", onDragLeave);
    body.addEventListener("dragenter", onDragEnter);
    body.addEventListener("dragover", onDragOver);
    desc.element.addEventListener("drop", onElementDrop);
    $4f65cb1abf2614c5$var$RESET_EVENTS.forEach((eventName)=>{
        window.addEventListener(eventName, onResetEvent);
    });
    return ()=>{
        $4f65cb1abf2614c5$var$nearnessRegistry.delete(desc.element);
        body.removeEventListener("drop", onDrop);
        body.removeEventListener("dragleave", onDragLeave);
        body.removeEventListener("dragenter", onDragEnter);
        body.removeEventListener("dragover", onDragOver);
        desc.element.removeEventListener("drop", onElementDrop);
        $4f65cb1abf2614c5$var$RESET_EVENTS.forEach((eventName)=>{
            window.removeEventListener(eventName, onResetEvent);
        });
    };
}


const $46a48f1a2df4c4b3$var$GLOBAL_CTX_NAME = "uc-drop-area";
const $46a48f1a2df4c4b3$var$REGISTRY_KEY = `${$46a48f1a2df4c4b3$var$GLOBAL_CTX_NAME}/registry`;
class $46a48f1a2df4c4b3$export$a950935544f004b4 extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    static styleAttrs = [
        ...super.styleAttrs,
        "uc-drop-area"
    ];
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            state: (0, $4f65cb1abf2614c5$export$e0edc031b86cc335).INACTIVE,
            withIcon: false,
            isClickable: false,
            isFullscreen: false,
            isEnabled: true,
            isVisible: true,
            text: "",
            [$46a48f1a2df4c4b3$var$REGISTRY_KEY]: null
        };
    }
    isActive() {
        if (!this.$.isEnabled) return false;
        const bounds = this.getBoundingClientRect();
        const hasSize = bounds.width > 0 && bounds.height > 0;
        const isInViewport = bounds.top >= 0 && bounds.left >= 0 && bounds.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounds.right <= (window.innerWidth || document.documentElement.clientWidth);
        const style = window.getComputedStyle(this);
        const visible = style.visibility !== "hidden" && style.display !== "none";
        return hasSize && visible && isInViewport;
    }
    initCallback() {
        super.initCallback();
        this.bindL10n("text", ()=>this.l10n("drop-files-here"));
        if (!this.$[$46a48f1a2df4c4b3$var$REGISTRY_KEY]) this.$[$46a48f1a2df4c4b3$var$REGISTRY_KEY] = new Set();
        this.$[$46a48f1a2df4c4b3$var$REGISTRY_KEY].add(this);
        this.defineAccessor("disabled", /** @param {unknown} value */ (value)=>{
            this.set$({
                isEnabled: !(0, $cb0db7406dd90abe$export$ffde277b1072591c)(value)
            });
        });
        this.defineAccessor("clickable", /** @param {unknown} value */ (value)=>{
            this.set$({
                isClickable: (0, $cb0db7406dd90abe$export$ffde277b1072591c)(value)
            });
        });
        this.defineAccessor("with-icon", /** @param {unknown} value */ (value)=>{
            this.set$({
                withIcon: (0, $cb0db7406dd90abe$export$ffde277b1072591c)(value)
            });
        });
        this.defineAccessor("fullscreen", /** @param {unknown} value */ (value)=>{
            this.set$({
                isFullscreen: (0, $cb0db7406dd90abe$export$ffde277b1072591c)(value)
            });
        });
        this.defineAccessor("text", /** @param {unknown} value */ (value)=>{
            if (typeof value === "string") this.bindL10n("text", ()=>this.l10n(value) || value);
            else this.bindL10n("text", ()=>this.l10n("drop-files-here"));
        });
        /** @private */ this._destroyDropzone = (0, $4f65cb1abf2614c5$export$4a249ef0d5b8b861)({
            element: this,
            shouldIgnore: ()=>this._shouldIgnore(),
            /** @param {DropzoneState} state */ onChange: (state)=>{
                this.$.state = state;
            },
            /** @param {import('./getDropItems.js').DropItem[]} items */ onItems: (items)=>{
                if (!items.length) return;
                items.forEach((/** @type {import('./getDropItems.js').DropItem} */ item)=>{
                    if (item.type === "url") this.api.addFileFromUrl(item.url, {
                        source: (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).DROP_AREA
                    });
                    else if (item.type === "file") this.api.addFileFromObject(item.file, {
                        source: (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).DROP_AREA,
                        fullPath: item.fullPath
                    });
                });
                if (this.uploadCollection.size) {
                    this.set$({
                        "*currentActivity": (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST
                    });
                    this.setOrAddState("*modalActive", true);
                }
            }
        });
        let contentWrapperEl = this.ref["content-wrapper"];
        if (contentWrapperEl) this._destroyContentWrapperDropzone = (0, $4f65cb1abf2614c5$export$4a249ef0d5b8b861)({
            element: contentWrapperEl,
            /** @param {DropzoneState} state */ onChange: (state)=>{
                const stateText = Object.entries((0, $4f65cb1abf2614c5$export$e0edc031b86cc335)).find(([, value])=>value === state)?.[0].toLowerCase();
                stateText && contentWrapperEl.setAttribute("drag-state", stateText);
            },
            onItems: ()=>{},
            shouldIgnore: ()=>this._shouldIgnore()
        });
        this.sub("state", (state)=>{
            const stateText = Object.entries((0, $4f65cb1abf2614c5$export$e0edc031b86cc335)).find(([, value])=>value === state)?.[0].toLowerCase();
            if (stateText) this.setAttribute("drag-state", stateText);
        });
        this.subConfigValue("sourceList", (value)=>{
            const list = (0, $15ba4abb0cb95799$export$b9ca061da17f2d30)(value);
            // Enable drop area if local files are allowed
            this.$.isEnabled = list.includes((0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).LOCAL);
            // Show drop area if it's enabled or default slot is overrided
            this.$.isVisible = this.$.isEnabled || !this.querySelector("[data-default-slot]");
        });
        this.sub("isVisible", (value)=>{
            this.toggleAttribute("hidden", !value);
        });
        this.sub("isClickable", (value)=>{
            this.toggleAttribute("clickable", value);
        });
        if (this.$.isClickable) {
            /**
       * @private
       * @param {KeyboardEvent | Event} event
       */ this._onAreaClicked = (event)=>{
                if (event.type === "keydown") // @ts-ignore
                {
                    if (event.code === "Space" || event.code === "Enter") this.api.openSystemDialog();
                } else if (event.type === "click") this.api.openSystemDialog();
            };
            this.addEventListener("keydown", this._onAreaClicked);
            this.addEventListener("click", this._onAreaClicked);
        }
    }
    /**
   * Ignore drop events if there are other visible drop areas on the page
   *
   * @private
   * @returns {Boolean}
   */ _shouldIgnore() {
        if (!this.$.isEnabled) return true;
        if (!this._couldHandleFiles()) return true;
        if (!this.$.isFullscreen) return false;
        const otherTargets = [
            ...this.$[$46a48f1a2df4c4b3$var$REGISTRY_KEY]
        ].filter((el)=>el !== this);
        const activeTargets = otherTargets.filter((/** @type {typeof this} */ el)=>{
            return el.isActive();
        });
        return activeTargets.length > 0;
    }
    /** @private */ _couldHandleFiles() {
        let isMultiple = this.cfg.multiple;
        let multipleMax = this.cfg.multipleMax;
        let currentFilesCount = this.uploadCollection.size;
        if (isMultiple && multipleMax && currentFilesCount >= multipleMax) return false;
        if (!isMultiple && currentFilesCount > 0) return false;
        return true;
    }
    destroyCallback() {
        super.destroyCallback();
        /** @type {Set<DropArea>} */ const registry = this.$[$46a48f1a2df4c4b3$var$REGISTRY_KEY];
        if (registry) {
            registry.delete(this);
            if (registry.size === 0) (0, $7868cd5b229e5c15$export$2d0294657ab35f1b).deleteCtx($46a48f1a2df4c4b3$var$GLOBAL_CTX_NAME);
        }
        this._destroyDropzone?.();
        this._destroyContentWrapperDropzone?.();
        if (this._onAreaClicked) {
            this.removeEventListener("keydown", this._onAreaClicked);
            this.removeEventListener("click", this._onAreaClicked);
        }
    }
}
$46a48f1a2df4c4b3$export$a950935544f004b4.template = /* HTML */ `
  <slot>
    <div data-default-slot hidden></div>
    <div ref="content-wrapper" class="uc-content-wrapper" set="@hidden: !isVisible">
      <div class="uc-icon-container" set="@hidden: !withIcon">
        <uc-icon name="default"></uc-icon>
        <uc-icon name="arrow-down"></uc-icon>
      </div>
      <span class="uc-text">{{text}}</span>
    </div>
  </slot>
`;
$46a48f1a2df4c4b3$export$a950935544f004b4.bindAttributes({
    // @ts-expect-error TODO: fix types inside symbiote
    "with-icon": null,
    // @ts-expect-error TODO: fix types inside symbiote
    clickable: null,
    // @ts-expect-error TODO: fix types inside symbiote
    text: null,
    // @ts-expect-error TODO: fix types inside symbiote
    fullscreen: null,
    // @ts-expect-error TODO: fix types inside symbiote
    disabled: null
});


// @ts-check





const $fc917d82c39f99df$var$L10N_PREFIX = "src-type-";
class $fc917d82c39f99df$export$86582aae649ac163 extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    /** @type {string | undefined} */ type = undefined;
    /**
   * @private
   * @type {Record<string, TConfig>}
   */ _registeredTypes = {};
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            iconName: "default",
            "src-type": ""
        };
    }
    initTypes() {
        this.registerType({
            type: (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).LOCAL,
            activate: ()=>{
                this.api.openSystemDialog();
                return false;
            }
        });
        this.registerType({
            type: (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).URL,
            activity: (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.URL,
            textKey: "from-url"
        });
        this.registerType({
            type: (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).CAMERA,
            activity: (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.CAMERA,
            activate: ()=>{
                const supportsCapture = (0, $28daeac476405872$export$90f565abb5a84cb2)();
                if (supportsCapture) this.api.openSystemDialog({
                    captureCamera: true
                });
                return !supportsCapture;
            }
        });
        this.registerType({
            type: "draw",
            activity: (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.DRAW,
            icon: "edit-draw"
        });
        for (let mobileSourceType of Object.values((0, $a53f5e78ad1bb77c$export$f7d782fb0db58d2a)))this.registerType({
            type: mobileSourceType,
            activity: (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.CAMERA,
            activate: ()=>{
                const supportsCapture = (0, $28daeac476405872$export$90f565abb5a84cb2)();
                if (supportsCapture) this.api.openSystemDialog({
                    captureCamera: true,
                    modeCamera: mobileSourceType === "mobile-photo-camera" ? (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO : (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO
                });
                return !supportsCapture;
            }
        });
        for (let externalSourceType of Object.values((0, $a53f5e78ad1bb77c$export$a12adc0ad2c4d117)))this.registerType({
            type: externalSourceType,
            activity: (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.EXTERNAL,
            activityParams: {
                externalSourceType: externalSourceType
            }
        });
    }
    initCallback() {
        super.initCallback();
        this.initTypes();
        this.defineAccessor("type", /** @param {string} val */ (val)=>{
            if (!val) return;
            this.applyType(val);
        });
    }
    /** @param {TConfig} typeConfig */ registerType(typeConfig) {
        this._registeredTypes[typeConfig.type] = typeConfig;
    }
    /** @param {string} type */ getType(type) {
        return this._registeredTypes[type];
    }
    activate() {
        if (!this.type) return;
        const configType = this._registeredTypes[this.type];
        const { activity: activity, activate: activate, activityParams: activityParams = {} } = configType;
        const showActivity = activate ? activate() : !!activity;
        showActivity && this.set$({
            "*currentActivityParams": activityParams,
            "*currentActivity": activity
        });
    }
    /** @param {string} type */ applyType(type) {
        const configType = this._registeredTypes[type];
        if (!configType) {
            console.warn("Unsupported source type: " + type);
            return;
        }
        const { textKey: textKey = type, icon: icon = type } = configType;
        this.$["src-type"] = `${$fc917d82c39f99df$var$L10N_PREFIX}${textKey}`;
        this.$.iconName = icon;
        this.onclick = ()=>{
            this.activate();
        };
    }
}
$fc917d82c39f99df$export$86582aae649ac163.template = /* HTML */ `
  <button type="button">
    <uc-icon set="@name: iconName"></uc-icon>
    <div class="uc-txt" l10n="src-type"></div>
  </button>
`;
$fc917d82c39f99df$export$86582aae649ac163.bindAttributes({
    // @ts-expect-error symbiote types bug
    type: null
});


// @ts-check




class $be249e7ae60e5cdc$export$3748a2f1ceae9e24 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    initCallback() {
        super.initCallback();
        this.subConfigValue("sourceList", (/** @type {String} */ val)=>{
            let list = (0, $15ba4abb0cb95799$export$b9ca061da17f2d30)(val);
            let html = "";
            list.forEach((srcName)=>{
                if (srcName === "instagram") {
                    console.error("Instagram source was removed because the Instagram Basic Display API hasn't been available since December 4, 2024. Official statement, see here:https://developers.facebook.com/blog/post/2024/09/04/update-on-instagram-basic-display-api/?locale=en_US");
                    return;
                }
                if (srcName === "camera" && (0, $28daeac476405872$export$90f565abb5a84cb2)()) {
                    this.subConfigValue("cameraModes", (/** @type {String} */ val)=>{
                        const cameraModes = (0, $cf5145deda9036ee$export$7a086f785998e32e)(val);
                        cameraModes.forEach((mode)=>{
                            html += /* HTML */ `<uc-source-btn role="listitem" type="mobile-${mode}-camera"></uc-source-btn>`;
                        });
                        if (cameraModes.length === 0) html += /* HTML */ `<uc-source-btn role="listitem" type="mobile-photo-camera"></uc-source-btn>`;
                    });
                    return;
                }
                html += /* HTML */ `<uc-source-btn role="listitem" type="${srcName}"></uc-source-btn>`;
            });
            if (this.cfg.sourceListWrap) this.innerHTML = html;
            else this.outerHTML = html;
        });
    }
}


// @ts-check

// TODO: unwrap promises
const $5f63a07ca859c63a$var$readJpegChunks = ()=>{
    const stack = [];
    const promiseReadJpegChunks = (blob)=>new Promise((resolve, reject)=>{
            let pos = 2;
            const readToView = (blob, cb)=>{
                const reader = new FileReader();
                reader.addEventListener("load", ()=>{
                    cb(new DataView(reader.result));
                });
                reader.addEventListener("error", (e)=>{
                    reject(`Reader error: ${e}`);
                });
                reader.readAsArrayBuffer(blob);
            };
            const readNext = ()=>readToView(blob.slice(pos, pos + 128), (view)=>{
                    let i, j, ref;
                    for(i = j = 0, ref = view.byteLength; ref >= 0 ? j < ref : j > ref; i = ref >= 0 ? ++j : --j)if (view.getUint8(i) === 0xff) {
                        pos += i;
                        break;
                    }
                    readNextChunk();
                });
            const readNextChunk = ()=>{
                const startPos = pos;
                return readToView(blob.slice(pos, pos += 4), (view)=>{
                    if (view.byteLength !== 4 || view.getUint8(0) !== 0xff) {
                        reject("Corrupted");
                        return;
                    }
                    const marker = view.getUint8(1);
                    if (marker === 0xda) {
                        resolve(true);
                        return;
                    }
                    const length = view.getUint16(2) - 2;
                    return readToView(blob.slice(pos, pos += length), (view)=>{
                        if (view.byteLength !== length) {
                            reject("Corrupted");
                            return;
                        }
                        stack.push({
                            startPos: startPos,
                            length: length,
                            marker: marker,
                            view: view
                        });
                        readNext();
                    });
                });
            };
            if (!(FileReader && DataView)) reject("Not Support");
            readToView(blob.slice(0, 2), (view)=>{
                if (view.getUint16(0) !== 0xffd8) reject("Not jpeg");
                readNext();
            });
        });
    return {
        stack: stack,
        promiseReadJpegChunks: promiseReadJpegChunks
    };
};
const $5f63a07ca859c63a$var$getIccProfile = async (blob)=>{
    const iccProfile = [];
    const { promiseReadJpegChunks: promiseReadJpegChunks, stack: stack } = $5f63a07ca859c63a$var$readJpegChunks();
    await promiseReadJpegChunks(blob);
    stack.forEach(({ marker: marker, view: view })=>{
        if (marker === 0xe2) {
            if (// check for "ICC_PROFILE\0"
            view.getUint32(0) === 0x4943435f && view.getUint32(4) === 0x50524f46 && view.getUint32(8) === 0x494c4500) iccProfile.push(view);
        }
    });
    return iccProfile;
};
const $5f63a07ca859c63a$var$replaceJpegChunk = async (blob, marker, chunks)=>{
    {
        const oldChunkPos = [];
        const oldChunkLength = [];
        const { promiseReadJpegChunks: promiseReadJpegChunks, stack: stack } = $5f63a07ca859c63a$var$readJpegChunks();
        await promiseReadJpegChunks(blob);
        stack.forEach((chunk)=>{
            if (chunk.marker === marker) {
                oldChunkPos.push(chunk.startPos);
                return oldChunkLength.push(chunk.length);
            }
        });
        const newChunks = [
            blob.slice(0, 2)
        ];
        for (const chunk of chunks){
            const intro = new DataView(new ArrayBuffer(4));
            intro.setUint16(0, 0xff00 + marker);
            intro.setUint16(2, chunk.byteLength + 2);
            newChunks.push(intro.buffer);
            newChunks.push(chunk);
        }
        let pos = 2;
        for(let i = 0; i < oldChunkPos.length; i++){
            if (oldChunkPos[i] > pos) newChunks.push(blob.slice(pos, oldChunkPos[i]));
            pos = oldChunkPos[i] + oldChunkLength[i] + 4;
        }
        newChunks.push(blob.slice(pos, blob.size));
        return new Blob(newChunks, {
            type: blob.type
        });
    }
};
const $5f63a07ca859c63a$var$MARKER = 0xe2;
const $5f63a07ca859c63a$var$replaceIccProfile = (blob, iccProfiles)=>{
    return $5f63a07ca859c63a$var$replaceJpegChunk(blob, $5f63a07ca859c63a$var$MARKER, iccProfiles.map((chunk)=>chunk.buffer));
};
const $5f63a07ca859c63a$var$stripIccProfile = async (blob)=>{
    try {
        return await $5f63a07ca859c63a$var$replaceIccProfile(blob, []);
    } catch (e) {
        throw new Error(`Failed to strip ICC profile: ${e}`);
    }
};
const $5f63a07ca859c63a$var$canvasToBlob = (canvas, type, quality)=>{
    return new Promise((resolve, reject)=>{
        const callback = (blob)=>{
            if (!blob) {
                reject("Failed to convert canvas to blob");
                return;
            }
            resolve(blob);
        };
        canvas.toBlob(callback, type, quality);
        canvas.width = canvas.height = 1;
    });
};
const $5f63a07ca859c63a$var$createCanvas = ()=>{
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    return {
        canvas: canvas,
        ctx: ctx
    };
};
const $5f63a07ca859c63a$var$hasTransparency = (img)=>{
    const canvasSize = 50;
    // Create a canvas element and get 2D rendering context
    const { ctx: ctx, canvas: canvas } = $5f63a07ca859c63a$var$createCanvas();
    canvas.width = canvas.height = canvasSize;
    // Draw the image onto the canvas
    ctx.drawImage(img, 0, 0, canvasSize, canvasSize);
    // Get the image data
    const imageData = ctx.getImageData(0, 0, canvasSize, canvasSize).data;
    // Reset the canvas dimensions
    canvas.width = canvas.height = 1;
    // Check for transparency in the alpha channel
    for(let i = 3; i < imageData.length; i += 4){
        if (imageData[i] < 254) return true;
    }
    // No transparency found
    return false;
};
const $5f63a07ca859c63a$var$getExif = async (blob)=>{
    let exif = null;
    const { promiseReadJpegChunks: promiseReadJpegChunks, stack: stack } = $5f63a07ca859c63a$var$readJpegChunks();
    await promiseReadJpegChunks(blob);
    stack.forEach(({ marker: marker, view: view })=>{
        if (!exif && marker === 0xe1) {
            if (view.byteLength >= 14) {
                if (// check for "Exif\0"
                view.getUint32(0) === 0x45786966 && view.getUint16(4) === 0) {
                    exif = view;
                    return;
                }
            }
        }
    });
    return exif;
};
// 2x1 pixel image 90CW rotated with orientation header
const $5f63a07ca859c63a$var$base64ImageSrc = "data:image/jpg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/4QA6RXhpZgAATU0AKgAAAAgAAwESAAMAAAABAAYAAAEoAAMAAAABAAIAAAITAAMAAAABAAEAAAAAAAD/2wBDAP//////////////////////////////////////////////////////////////////////////////////////wAALCAABAAIBASIA/8QAJgABAAAAAAAAAAAAAAAAAAAAAxABAAAAAAAAAAAAAAAAAAAAAP/aAAgBAQAAPwBH/9k=";
let $5f63a07ca859c63a$var$isApplied = undefined;
const $5f63a07ca859c63a$var$isBrowserApplyExifOrientation = ()=>{
    return new Promise((resolve)=>{
        if ($5f63a07ca859c63a$var$isApplied !== undefined) resolve($5f63a07ca859c63a$var$isApplied);
        else {
            const image = new Image();
            image.addEventListener("load", ()=>{
                $5f63a07ca859c63a$var$isApplied = image.naturalWidth < image.naturalHeight;
                image.src = "//:0";
                resolve($5f63a07ca859c63a$var$isApplied);
            });
            image.src = $5f63a07ca859c63a$var$base64ImageSrc;
        }
    });
};
const $5f63a07ca859c63a$var$findExifOrientation = (exif, exifCallback)=>{
    let j, little, offset, ref;
    if (!exif || exif.byteLength < 14 || exif.getUint32(0) !== 0x45786966 || exif.getUint16(4) !== 0) return;
    if (exif.getUint16(6) === 0x4949) little = true;
    else if (exif.getUint16(6) === 0x4d4d) little = false;
    else return;
    if (exif.getUint16(8, little) !== 0x002a) return;
    offset = 8 + exif.getUint32(10, little);
    const count = exif.getUint16(offset - 2, little);
    for(j = 0, ref = count; ref >= 0 ? j < ref : j > ref; ref >= 0 ? ++j : --j){
        if (exif.byteLength < offset + 10) return;
        if (exif.getUint16(offset, little) === 0x0112) exifCallback(offset + 8, little);
        offset += 12;
    }
};
const $5f63a07ca859c63a$var$setExifOrientation = (exif, orientation)=>{
    $5f63a07ca859c63a$var$findExifOrientation(exif, (offset, littleEndian)=>exif.setUint16(offset, orientation, littleEndian));
};
const $5f63a07ca859c63a$var$replaceExif = async (blob, exif, isExifApplied)=>{
    if (isExifApplied) $5f63a07ca859c63a$var$setExifOrientation(exif, 1);
    return $5f63a07ca859c63a$var$replaceJpegChunk(blob, 0xe1, [
        exif.buffer
    ]);
};
const $5f63a07ca859c63a$var$processImage = (image, src)=>{
    return new Promise((resolve, reject)=>{
        if (src) image.src = src;
        if (image.complete) resolve(image);
        else {
            image.addEventListener("load", ()=>{
                resolve(image);
            });
            image.addEventListener("error", ()=>{
                reject(new Error("Failed to load image. Probably not an image."));
            });
        }
    });
};
const $5f63a07ca859c63a$var$imageLoader = (image)=>{
    return $5f63a07ca859c63a$var$processImage(new Image(), image);
};
const $5f63a07ca859c63a$var$allowLayers = [
    1,
    3 // RGB
];
const $5f63a07ca859c63a$var$markers = [
    0xc0,
    0xc1,
    0xc2,
    0xc3,
    0xc5,
    0xc6,
    0xc7,
    0xc9,
    0xca,
    0xcb,
    0xcd,
    0xce,
    0xcf // ("SOF15", "Differential spatial (AC)", SOF)
];
const $5f63a07ca859c63a$var$sizes = {
    squareSide: [
        // Safari (iOS < 9, ram >= 256)
        // We are supported mobile safari < 9 since widget v2, by 5 Mpx limit
        // so it's better to continue support despite the absence of this browser in the support table
        Math.floor(Math.sqrt(5000000)),
        // IE Mobile (Windows Phone 8.x)
        // Safari (iOS >= 9)
        4096,
        // IE 9 (Win)
        8192,
        // Firefox 63 (Mac, Win)
        11180,
        // Chrome 68 (Android 6)
        10836,
        // Chrome 68 (Android 5)
        11402,
        // Chrome 68 (Android 7.1-9)
        14188,
        // Chrome 70 (Mac, Win)
        // Chrome 68 (Android 4.4)
        // Edge 17 (Win)
        // Safari 7-12 (Mac)
        16384
    ],
    dimension: [
        // IE Mobile (Windows Phone 8.x)
        4096,
        // IE 9 (Win)
        8192,
        // Edge 17 (Win)
        // IE11 (Win)
        16384,
        // Chrome 70 (Mac, Win)
        // Chrome 68 (Android 4.4-9)
        // Firefox 63 (Mac, Win)
        32767,
        // Chrome 83 (Mac, Win)
        // Safari 7-12 (Mac)
        // Safari (iOS 9-12)
        // Actually Safari has a much bigger limits - 4194303 of width and 8388607 of height,
        // but we will not use them
        65535
    ]
};
const $5f63a07ca859c63a$var$shouldSkipShrink = async (blob)=>{
    let skip = false;
    const { promiseReadJpegChunks: promiseReadJpegChunks, stack: stack } = $5f63a07ca859c63a$var$readJpegChunks();
    return await promiseReadJpegChunks(blob).then(()=>{
        stack.forEach(({ marker: marker, view: view })=>{
            if (!skip && $5f63a07ca859c63a$var$markers.indexOf(marker) >= 0) {
                const layer = view.getUint8(5);
                if ($5f63a07ca859c63a$var$allowLayers.indexOf(layer) < 0) skip = true;
            }
        });
        return skip;
    }).catch(()=>skip);
};
const $5f63a07ca859c63a$var$memoize = (fn, serializer)=>{
    const cache = {};
    return (...args)=>{
        const key = serializer(args, cache);
        return key in cache ? cache[key] : cache[key] = fn(...args);
    };
};
/**
 * Memoization key serealizer, that prevents unnecessary canvas tests. No need
 * to make test if we know that:
 *
 * - Browser supports higher canvas size
 * - Browser doesn't support lower canvas size
 */ const $5f63a07ca859c63a$var$memoKeySerializer = (args, cache)=>{
    const [w] = args;
    const cachedWidths = Object.keys(cache).map((val)=>parseInt(val, 10)).sort((a, b)=>a - b);
    for(let i = 0; i < cachedWidths.length; i++){
        const cachedWidth = cachedWidths[i];
        const isSupported = !!cache[cachedWidth];
        // higher supported canvas size, return it
        if (cachedWidth > w && isSupported) return cachedWidth;
        // lower unsupported canvas size, return it
        if (cachedWidth < w && !isSupported) return cachedWidth;
    }
    // use canvas width as the key,
    // because we're doing dimension test by width - [dimension, 1]
    return w;
};
// add constants
const $5f63a07ca859c63a$var$TestPixel = {
    R: 55,
    G: 110,
    B: 165,
    A: 255
};
const $5f63a07ca859c63a$var$FILL_STYLE = `rgba(${$5f63a07ca859c63a$var$TestPixel.R}, ${$5f63a07ca859c63a$var$TestPixel.G}, ${$5f63a07ca859c63a$var$TestPixel.B}, ${$5f63a07ca859c63a$var$TestPixel.A / 255})`;
const $5f63a07ca859c63a$var$canvasTest = (width, height)=>{
    try {
        const fill = [
            width - 1,
            height - 1,
            1,
            1
        ]; // x, y, width, height
        const { canvas: cropCvs, ctx: cropCtx } = $5f63a07ca859c63a$var$createCanvas();
        cropCvs.width = 1;
        cropCvs.height = 1;
        const { canvas: testCvs, ctx: testCtx } = $5f63a07ca859c63a$var$createCanvas();
        testCvs.width = width;
        testCvs.height = height;
        if (testCtx) {
            testCtx.fillStyle = $5f63a07ca859c63a$var$FILL_STYLE;
            testCtx.fillRect(...fill);
            // Render the test pixel in the bottom-right corner of the
            // test canvas in the top-left of the 1x1 crop canvas. This
            // dramatically reducing the time for getImageData to complete.
            cropCtx.drawImage(testCvs, width - 1, height - 1, 1, 1, 0, 0, 1, 1);
        }
        const imageData = cropCtx && cropCtx.getImageData(0, 0, 1, 1).data;
        let isTestPass = false;
        if (imageData) // On IE10, imageData have type CanvasPixelArray, not Uint8ClampedArray.
        // CanvasPixelArray supports index access operations only.
        // Array buffers can't be destructuredd and compared with JSON.stringify
        isTestPass = imageData[0] === $5f63a07ca859c63a$var$TestPixel.R && imageData[1] === $5f63a07ca859c63a$var$TestPixel.G && imageData[2] === $5f63a07ca859c63a$var$TestPixel.B && imageData[3] === $5f63a07ca859c63a$var$TestPixel.A;
        testCvs.width = testCvs.height = 1;
        return isTestPass;
    } catch (e) {
        console.error(`Failed to test for max canvas size of ${width}x${height}.`);
        return false;
    }
};
function $5f63a07ca859c63a$var$wrapAsync(fn) {
    return (...args)=>{
        return new Promise((resolve)=>{
            setTimeout(()=>{
                const result = fn(...args);
                resolve(result);
            }, 0);
        });
    };
}
const $5f63a07ca859c63a$var$squareTest = $5f63a07ca859c63a$var$wrapAsync($5f63a07ca859c63a$var$memoize($5f63a07ca859c63a$var$canvasTest, $5f63a07ca859c63a$var$memoKeySerializer));
const $5f63a07ca859c63a$var$dimensionTest = $5f63a07ca859c63a$var$wrapAsync($5f63a07ca859c63a$var$memoize($5f63a07ca859c63a$var$canvasTest, $5f63a07ca859c63a$var$memoKeySerializer));
const $5f63a07ca859c63a$var$testCanvasSize = async (w, h)=>{
    const testSquareSide = $5f63a07ca859c63a$var$sizes.squareSide.find((side)=>side * side >= w * h);
    const testDimension = $5f63a07ca859c63a$var$sizes.dimension.find((side)=>side >= w && side >= h);
    if (!testSquareSide || !testDimension) throw new Error("Not supported");
    const [squareSupported, dimensionSupported] = await Promise.all([
        $5f63a07ca859c63a$var$squareTest(testSquareSide, testSquareSide),
        $5f63a07ca859c63a$var$dimensionTest(testDimension, 1)
    ]);
    if (squareSupported && dimensionSupported) return true;
    else throw new Error("Not supported");
};
const $5f63a07ca859c63a$var$canvasResize = async (img, w, h)=>{
    try {
        const { ctx: ctx, canvas: canvas } = $5f63a07ca859c63a$var$createCanvas();
        canvas.width = w;
        canvas.height = h;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, w, h);
        if (img instanceof HTMLImageElement) img.src = "//:0"; // free memory
        if (img instanceof HTMLCanvasElement) img.width = img.height = 1; // free memory
        return canvas;
    } catch (e) {
        throw new Error("Canvas resize error", {
            cause: e
        });
    }
};
/**
 * Native high-quality canvas resampling
 *
 * Browser support:
 * https://caniuse.com/mdn-api_canvasrenderingcontext2d_imagesmoothingenabled
 * Target dimensions expected to be supported by browser.
 */ const $5f63a07ca859c63a$var$native = ({ img: img, targetW: targetW, targetH: targetH })=>$5f63a07ca859c63a$var$canvasResize(img, targetW, targetH);
/**
 * Goes from target to source by step, the last incomplete step is dropped.
 * Always returns at least one step - target. Source step is not included.
 * Sorted descending.
 *
 * Example with step = 0.71, source = 2000, target = 400 400 (target) <- 563 <-
 * 793 <- 1117 <- 1574 (dropped) <- [2000 (source)]
 */ const $5f63a07ca859c63a$var$calcShrinkSteps = function({ sourceW: sourceW, targetW: targetW, targetH: targetH, step: step }) {
    const steps = [];
    let sW = targetW;
    let sH = targetH;
    // result should include at least one target step,
    // even if abs(source - target) < step * source
    // just to be sure nothing will break
    // if the original resolution / target resolution condition changes
    do {
        steps.push([
            sW,
            sH
        ]);
        sW = Math.round(sW / step);
        sH = Math.round(sH / step);
    }while (sW < sourceW * step);
    return steps.reverse();
};
/**
 * Fallback resampling algorithm
 *
 * Reduces dimensions by step until reaches target dimensions, this gives a
 * better output quality than one-step method
 *
 * Target dimensions expected to be supported by browser, unsupported steps will
 * be dropped.
 */ const $5f63a07ca859c63a$var$fallback = ({ img: img, sourceW: sourceW, targetW: targetW, targetH: targetH, step: step })=>{
    const steps = $5f63a07ca859c63a$var$calcShrinkSteps({
        sourceW: sourceW,
        targetW: targetW,
        targetH: targetH,
        step: step
    });
    return steps.reduce((chain, [w, h], idx)=>{
        return chain.then((canvas)=>{
            return $5f63a07ca859c63a$var$testCanvasSize(w, h).then(()=>$5f63a07ca859c63a$var$canvasResize(canvas, w, h)).catch(()=>{
                if (idx === steps.length - 1) // If the last step is failed then we assume that we can't shrink the image at all
                throw new Error("Not supported");
                return canvas;
            });
        });
    }, Promise.resolve(img));
};
const $5f63a07ca859c63a$var$isIOS = ()=>{
    if (/iPad|iPhone|iPod/.test(navigator.platform)) return true;
    else return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
};
const $5f63a07ca859c63a$var$isIpadOS = navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform);
const $5f63a07ca859c63a$var$STEP = 0.71; // should be > sqrt(0.5)
const $5f63a07ca859c63a$var$shrinkImage = (img, settings)=>{
    // do not shrink image if original resolution / target resolution ratio falls behind 2.0
    if (img.width * $5f63a07ca859c63a$var$STEP * img.height * $5f63a07ca859c63a$var$STEP < settings.size) throw new Error("Not required");
    const sourceW = img.width;
    const sourceH = img.height;
    const ratio = sourceW / sourceH;
    // target size shouldn't be greater than settings.size in any case
    const targetW = Math.floor(Math.sqrt(settings.size * ratio));
    const targetH = Math.floor(settings.size / Math.sqrt(settings.size * ratio));
    // we test the last step because we can skip all intermediate steps
    return $5f63a07ca859c63a$var$testCanvasSize(targetW, targetH).then(()=>{
        const { ctx: ctx } = $5f63a07ca859c63a$var$createCanvas();
        const supportNative = "imageSmoothingQuality" in ctx;
        // native scaling on ios gives blurry results
        // TODO: check if it's still true
        const useNativeScaling = supportNative && !$5f63a07ca859c63a$var$isIOS() && !$5f63a07ca859c63a$var$isIpadOS;
        return useNativeScaling ? $5f63a07ca859c63a$var$native({
            img: img,
            targetW: targetW,
            targetH: targetH
        }) : $5f63a07ca859c63a$var$fallback({
            img: img,
            sourceW: sourceW,
            targetW: targetW,
            targetH: targetH,
            step: $5f63a07ca859c63a$var$STEP
        });
    }).catch(()=>Promise.reject("Not supported"));
};
const $5f63a07ca859c63a$export$d92be28d49332e45 = async (inputBlob, settings)=>{
    try {
        const shouldSkip = await $5f63a07ca859c63a$var$shouldSkipShrink(inputBlob);
        if (shouldSkip) throw new Error("Should skipped");
        // Try to extract EXIF and ICC profile
        const exifResults = await Promise.allSettled([
            $5f63a07ca859c63a$var$getExif(inputBlob),
            $5f63a07ca859c63a$var$isBrowserApplyExifOrientation(),
            $5f63a07ca859c63a$var$getIccProfile(inputBlob)
        ]);
        const isRejected = exifResults.some((result)=>result.status === "rejected");
        // If any of the promises is rejected, this is not a JPEG image
        const isJPEG = !isRejected;
        const [exifResult, isExifOrientationAppliedResult, iccProfileResult] = exifResults;
        // Load blob into the image
        const inputBlobWithoutIcc = await $5f63a07ca859c63a$var$stripIccProfile(inputBlob).catch(()=>inputBlob);
        const image = await $5f63a07ca859c63a$var$imageLoader(URL.createObjectURL(inputBlobWithoutIcc));
        URL.revokeObjectURL(image.src);
        // Shrink the image
        const canvas = await $5f63a07ca859c63a$var$shrinkImage(image, settings);
        let format = "image/jpeg";
        let quality = settings?.quality || 0.8;
        if (!isJPEG && $5f63a07ca859c63a$var$hasTransparency(canvas)) {
            format = "image/png";
            quality = undefined;
        }
        // Convert canvas to blob
        let newBlob = await $5f63a07ca859c63a$var$canvasToBlob(canvas, format, quality);
        // Set EXIF for the new blob
        if (isJPEG && exifResult.status === "fulfilled" && exifResult.value) {
            const exif = exifResult.value;
            const isExifOrientationApplied = isExifOrientationAppliedResult.status === "fulfilled" ? isExifOrientationAppliedResult.value : false;
            newBlob = await $5f63a07ca859c63a$var$replaceExif(newBlob, exif, isExifOrientationApplied);
        // TODO: should we continue shrink if failed to replace EXIF?
        // .catch(() => newBlob)
        }
        // Set ICC profile for the new blob
        if (isJPEG && iccProfileResult.status === "fulfilled" && iccProfileResult.value.length > 0) newBlob = await $5f63a07ca859c63a$var$replaceIccProfile(newBlob, iccProfileResult.value);
        return newBlob;
    } catch (e) {
        let message;
        if (e instanceof Error) message = e.message;
        if (typeof e === "string") message = e;
        throw new Error(`Failed to shrink image. ${message ? `Message: "${message}".` : ""}`, {
            cause: e
        });
    }
};





/**
 * @param {String} svg
 * @returns {String}
 */ function $b724a95bb2ad2fd2$var$createSvgBlobUrl(svg) {
    let blob = new Blob([
        svg
    ], {
        type: "image/svg+xml"
    });
    return URL.createObjectURL(blob);
}
function $b724a95bb2ad2fd2$export$94a13a3239cc67e3(color1 = "#fff", color2 = "rgba(0, 0, 0, .1)") {
    return $b724a95bb2ad2fd2$var$createSvgBlobUrl(/*svg*/ `<svg height="20" width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="20" height="20" fill="${color1}" />
    <rect x="0" y="0" width="10" height="10" fill="${color2}" />
    <rect x="10" y="10" width="10" height="10" fill="${color2}" />
  </svg>`);
}
function $b724a95bb2ad2fd2$export$26900049b1fd0fec(color = "rgba(0, 0, 0, .1)") {
    return $b724a95bb2ad2fd2$var$createSvgBlobUrl(/*svg*/ `<svg height="10" width="10" viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <line x1="0" y1="10" x2="10" y2="0" stroke="${color}" />
  </svg>`);
}
function $b724a95bb2ad2fd2$export$138da82c49e1ea0e(color = "hsl(209, 21%, 65%)", width = 32, height = 32) {
    return $b724a95bb2ad2fd2$var$createSvgBlobUrl(/*svg*/ `
  <svg width="${width}" height="${height}" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" fill="${color}" d="M9.68848 8.70068C9.68848 8.42454 9.91233 8.20068 10.1885 8.20068H15.0885C15.2211 8.20068 15.3483 8.25336 15.442 8.34713L20.342 13.2471C20.4358 13.3409 20.4885 13.4681 20.4885 13.6007V21.3007C20.4885 21.5768 20.2646 21.8007 19.9885 21.8007H10.1885C9.91233 21.8007 9.68848 21.5768 9.68848 21.3007V8.70068ZM10.6885 9.20068V20.8007H19.4885V14.1007L15.0885 14.1007C14.8123 14.1007 14.5885 13.8768 14.5885 13.6007L14.5885 9.20068H10.6885ZM15.5885 9.90779L18.7814 13.1007L15.5885 13.1007L15.5885 9.90779Z"/>
  </svg>
  `);
}



/**
 * @param {File} imgFile
 * @param {Number} [size]
 */ function $6760ce711179327d$export$1c6697d6d7c7cdc2(imgFile, size = 40) {
    if (imgFile.type === "image/svg+xml") return URL.createObjectURL(imgFile);
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    let img = new Image();
    let promise = new Promise((resolve, reject)=>{
        img.onload = ()=>{
            let ratio = img.height / img.width;
            if (ratio > 1) {
                canvas.width = size;
                canvas.height = size * ratio;
            } else {
                canvas.height = size;
                canvas.width = size / ratio;
            }
            ctx.fillStyle = "rgb(240, 240, 240)";
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            canvas.toBlob((blob)=>{
                if (!blob) {
                    reject();
                    return;
                }
                let url = URL.createObjectURL(blob);
                resolve(url);
            });
        };
        img.onerror = (err)=>{
            reject(err);
        };
    });
    img.src = URL.createObjectURL(imgFile);
    return promise;
}


/** TODO parseShrink move to package @uploadcare/image-shrink */ const $9bee63d8bd7bb992$var$MAX_SQUARE_SIDE = 16384;
const $9bee63d8bd7bb992$var$regExpShrink = /^([0-9]+)x([0-9]+)(?:\s+(\d{1,2}|100)%)?$/i;
const $9bee63d8bd7bb992$export$5722be5ae0d8d78a = (value)=>{
    const terms = $9bee63d8bd7bb992$var$regExpShrink.exec(value?.toLocaleLowerCase()) || [];
    if (!terms.length) return false;
    const sizeShrink = terms[1] * terms[2];
    const maxSize = $9bee63d8bd7bb992$var$MAX_SQUARE_SIDE * $9bee63d8bd7bb992$var$MAX_SQUARE_SIDE;
    if (sizeShrink > maxSize) {
        console.warn(`Shrinked size can not be larger than ${Math.floor(maxSize / 1000 / 1000)}MP. ` + `You have set ${terms[1]}x${terms[2]} (` + `${Math.ceil(sizeShrink / 1000 / 100) / 10}MP).`);
        return false;
    }
    return {
        quality: terms[3] ? terms[3] / 100 : undefined,
        size: sizeShrink
    };
};



// @ts-check
/**
 * @template {{ (...args: any[]): void }} T
 * @param {T} fn
 * @param {number} wait
 * @returns {T & { readonly cancel: () => void }} }
 */ const $3463bc23a4723762$export$de363e709c412c8a = (fn, wait)=>{
    /** @type {boolean} */ let inThrottle;
    /** @type {ReturnType<typeof setTimeout>} */ let lastFn;
    /** @type {number} */ let lastTime;
    /** @param {...any} args */ const throttled = (...args)=>{
        if (!inThrottle) {
            fn(...args);
            lastTime = Date.now();
            inThrottle = true;
        } else {
            clearTimeout(lastFn);
            lastFn = setTimeout(()=>{
                if (Date.now() - lastTime >= wait) {
                    fn(...args);
                    lastTime = Date.now();
                }
            }, Math.max(wait - (Date.now() - lastTime), 0));
        }
    };
    Object.defineProperty(throttled, "cancel", {
        configurable: false,
        writable: false,
        enumerable: false,
        value: ()=>{
            clearTimeout(lastFn);
        }
    });
    return /** @type {T & { readonly cancel: () => void }} */ /** @type {unknown} */ throttled;
};


const $d2765c958d00b716$var$FileItemState = Object.freeze({
    FINISHED: Symbol("FINISHED"),
    FAILED: Symbol("FAILED"),
    UPLOADING: Symbol("UPLOADING"),
    IDLE: Symbol("IDLE")
});
class $d2765c958d00b716$export$a964e6adf466d4a6 extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    pauseRender = true;
    /** @private */ _entrySubs = new Set();
    /**
   * @private
   * @type {any} TODO: Add types for upload entry
   */ _entry = null;
    /** @private */ _isIntersecting = false;
    /** @private */ _debouncedGenerateThumb = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(this._generateThumbnail.bind(this), 100);
    /** @private */ _debouncedCalculateState = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(this._calculateState.bind(this), 100);
    /** @private */ _renderedOnce = false;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            uid: "",
            itemName: "",
            errorText: "",
            hint: "",
            thumbUrl: "",
            progressValue: 0,
            progressVisible: false,
            badgeIcon: "",
            isFinished: false,
            isFailed: false,
            isUploading: false,
            isFocused: false,
            isEditable: false,
            state: $d2765c958d00b716$var$FileItemState.IDLE,
            ariaLabelStatusFile: "",
            onEdit: ()=>{
                this.$["*currentActivityParams"] = {
                    internalId: this._entry.uid
                };
                this.$["*currentActivity"] = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.CLOUD_IMG_EDIT;
            },
            onRemove: ()=>{
                this.uploadCollection.remove(this.$.uid);
            },
            onUpload: ()=>{
                this.upload();
            }
        };
    }
    _reset() {
        for (let sub of this._entrySubs)sub.remove();
        this._debouncedGenerateThumb.cancel();
        this._debouncedCalculateState.cancel();
        this._entrySubs = new Set();
        this._entry = null;
    }
    /**
   * @private
   * @param {IntersectionObserverEntry[]} entries
   */ _observerCallback(entries) {
        let [entry] = entries;
        this._isIntersecting = entry.isIntersecting;
        if (entry.isIntersecting && !this._renderedOnce) {
            this.render();
            this._renderedOnce = true;
        }
        if (entry.intersectionRatio === 0) this._debouncedGenerateThumb.cancel();
        else this._debouncedGenerateThumb();
    }
    /** @private */ _calculateState() {
        if (!this._entry) return;
        let entry = this._entry;
        let state = $d2765c958d00b716$var$FileItemState.IDLE;
        if (entry.getValue("errors").length > 0) state = $d2765c958d00b716$var$FileItemState.FAILED;
        else if (entry.getValue("isUploading")) state = $d2765c958d00b716$var$FileItemState.UPLOADING;
        else if (entry.getValue("fileInfo")) state = $d2765c958d00b716$var$FileItemState.FINISHED;
        this.$.state = state;
    }
    /** @private */ async _generateThumbnail() {
        if (!this._entry) return;
        let entry = this._entry;
        if (entry.getValue("fileInfo") && entry.getValue("isImage")) {
            let size = this.cfg.thumbSize;
            let thumbUrl = await this.proxyUrl((0, $8c66713b0e57faf9$export$226a37372a69410c)((0, $8c66713b0e57faf9$export$816ae8f9591f1ab2)(this.cfg.cdnCname, this._entry.getValue("uuid")), (0, $8c66713b0e57faf9$export$8fb94a7da5f60007)(entry.getValue("cdnUrlModifiers"), `scale_crop/${size}x${size}/center`)));
            let currentThumbUrl = entry.getValue("thumbUrl");
            if (currentThumbUrl !== thumbUrl) {
                entry.setValue("thumbUrl", thumbUrl);
                currentThumbUrl?.startsWith("blob:") && URL.revokeObjectURL(currentThumbUrl);
            }
            return;
        }
        if (entry.getValue("thumbUrl")) return;
        if (entry.getValue("file")?.type.includes("image")) try {
            let thumbUrl = await (0, $6760ce711179327d$export$1c6697d6d7c7cdc2)(entry.getValue("file"), this.cfg.thumbSize);
            entry.setValue("thumbUrl", thumbUrl);
        } catch (err) {
            let color = window.getComputedStyle(this).getPropertyValue("--uc-muted-foreground");
            entry.setValue("thumbUrl", (0, $b724a95bb2ad2fd2$export$138da82c49e1ea0e)(color));
        }
        else {
            let color = window.getComputedStyle(this).getPropertyValue("--uc-muted-foreground");
            entry.setValue("thumbUrl", (0, $b724a95bb2ad2fd2$export$138da82c49e1ea0e)(color));
        }
    }
    /**
   * @private
   * @param {string} prop
   * @param {(value: any) => void} handler
   */ _subEntry(prop, handler) {
        let sub = this._entry.subscribe(prop, /** @param {any} value */ (value)=>{
            if (this.isConnected) handler(value);
        });
        this._entrySubs.add(sub);
    }
    _updateHint = (0, $3463bc23a4723762$export$de363e709c412c8a)(()=>{
        const showHint = this.$.state === $d2765c958d00b716$var$FileItemState.UPLOADING && this._entry.getValue("externalUrl") && this._entry.getValue("source") !== (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).URL && this._entry.getValue("errors").length === 0 && this.$.progressValue === 0;
        const hint = showHint ? this.l10n("waiting-for", {
            source: this.l10n(`src-type-${this._entry.getValue("source")}`)
        }) : "";
        this.$.hint = hint;
    }, 100);
    /**
   * @private
   * @param {String} id
   */ _handleEntryId(id) {
        this._reset();
        /** @type {import('../../abstract/TypedData.js').TypedData} */ let entry = this.uploadCollection?.read(id);
        this._entry = entry;
        if (!entry) return;
        this._subEntry("uploadProgress", (uploadProgress)=>{
            this.$.progressValue = uploadProgress;
            this._updateHint();
        });
        this._subEntry("fileName", (name)=>{
            this.$.itemName = name || entry.getValue("externalUrl") || this.l10n("file-no-name");
            this._debouncedCalculateState();
        });
        this._subEntry("externalUrl", (externalUrl)=>{
            this.$.itemName = entry.getValue("fileName") || externalUrl || this.l10n("file-no-name");
        });
        this._subEntry("fileInfo", (fileInfo)=>{
            this._debouncedCalculateState();
            if (fileInfo && this._isIntersecting) this._debouncedGenerateThumb();
        });
        this._subEntry("cdnUrlModifiers", ()=>{
            if (this._isIntersecting) this._debouncedGenerateThumb();
        });
        this._subEntry("thumbUrl", (thumbUrl)=>{
            this.$.thumbUrl = thumbUrl ? `url(${thumbUrl})` : "";
        });
        this._subEntry("errors", ()=>this._debouncedCalculateState());
        this._subEntry("isUploading", ()=>this._debouncedCalculateState());
        this._subEntry("fileSize", ()=>this._debouncedCalculateState());
        this._subEntry("mimeType", ()=>this._debouncedCalculateState());
        this._subEntry("isImage", ()=>this._debouncedCalculateState());
        if (this._isIntersecting) this._debouncedGenerateThumb();
    }
    initCallback() {
        super.initCallback();
        this.sub("uid", (uid)=>{
            this._handleEntryId(uid);
        });
        this.sub("state", (state)=>{
            this._handleState(state);
        });
        this.subConfigValue("useCloudImageEditor", ()=>this._debouncedCalculateState());
        this.onclick = ()=>{
            $d2765c958d00b716$export$a964e6adf466d4a6.activeInstances.forEach((inst)=>{
                if (inst === this) inst.setAttribute("focused", "");
                else inst.removeAttribute("focused");
            });
        };
        this.sub("*uploadTrigger", /** @param {Set<string>} itemsToUpload */ (itemsToUpload)=>{
            if (!itemsToUpload.has(this._entry.uid)) return;
            setTimeout(()=>this.isConnected && this.upload());
        });
        $d2765c958d00b716$export$a964e6adf466d4a6.activeInstances.add(this);
    }
    /** @param {(typeof FileItemState)[keyof typeof FileItemState]} state */ _handleState(state) {
        if (state === $d2765c958d00b716$var$FileItemState.FAILED) this.$.badgeIcon = "badge-error";
        else if (state === $d2765c958d00b716$var$FileItemState.FINISHED) this.$.badgeIcon = "badge-success";
        if (state === $d2765c958d00b716$var$FileItemState.UPLOADING) this.$.isFocused = false;
        this.set$({
            isFailed: state === $d2765c958d00b716$var$FileItemState.FAILED,
            isUploading: state === $d2765c958d00b716$var$FileItemState.UPLOADING,
            isFinished: state === $d2765c958d00b716$var$FileItemState.FINISHED,
            progressVisible: state === $d2765c958d00b716$var$FileItemState.UPLOADING,
            isEditable: this.cfg.useCloudImageEditor && this._entry?.getValue("isImage") && this._entry?.getValue("cdnUrl"),
            errorText: this._entry.getValue("errors")?.[0]?.message,
            ariaLabelStatusFile: this.l10n("a11y-file-item-status", {
                fileName: this._entry?.getValue("fileName"),
                status: this.l10n(state?.description?.toLocaleLowerCase() ?? "").toLocaleLowerCase()
            })
        });
        this._updateHint();
    }
    destroyCallback() {
        super.destroyCallback();
        $d2765c958d00b716$export$a964e6adf466d4a6.activeInstances.delete(this);
        this._reset();
    }
    connectedCallback() {
        super.connectedCallback();
        /** @private */ this._observer = new window.IntersectionObserver(this._observerCallback.bind(this), {
            threshold: [
                0,
                1
            ]
        });
        this._observer.observe(this);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this._debouncedGenerateThumb.cancel();
        this._observer?.disconnect();
    }
    _settingsOfShrink() {
        return (0, $9bee63d8bd7bb992$export$5722be5ae0d8d78a)(this.cfg.imageShrink);
    }
    /**
   * @private
   * @param {File} file
   */ _processShrink(file) {
        return (0, $5f63a07ca859c63a$export$d92be28d49332e45)(file, this._settingsOfShrink());
    }
    async upload() {
        let entry = this._entry;
        if (!this.uploadCollection.read(entry.uid)) return;
        if (entry.getValue("fileInfo") || entry.getValue("isUploading") || entry.getValue("errors").length > 0) return;
        const multipleMax = this.cfg.multiple ? this.cfg.multipleMax : 1;
        if (multipleMax && this.uploadCollection.size > multipleMax) return;
        this._debouncedCalculateState();
        entry.setValue("isUploading", true);
        entry.setValue("errors", []);
        try {
            let abortController = new AbortController();
            entry.setValue("abortController", abortController);
            const uploadTask = async ()=>{
                let file = entry.getValue("file");
                if (file && this.cfg.imageShrink) file = await this._processShrink(file).catch(()=>file);
                const fileInput = file || entry.getValue("externalUrl") || entry.getValue("uuid");
                const baseUploadClientOptions = await this.getUploadClientOptions();
                /** @type {import('@uploadcare/upload-client').FileFromOptions} */ const uploadClientOptions = {
                    ...baseUploadClientOptions,
                    fileName: entry.getValue("fileName"),
                    source: entry.getValue("source"),
                    onProgress: (progress)=>{
                        if (progress.isComputable) {
                            let percentage = progress.value * 100;
                            entry.setValue("uploadProgress", percentage);
                        }
                    },
                    signal: abortController.signal,
                    metadata: await this.getMetadataFor(entry.uid)
                };
                this.debugPrint("upload options", fileInput, uploadClientOptions);
                return (0, $3905b2ce68ef12c7$export$a5575dbeeffdad98)(fileInput, uploadClientOptions);
            };
            /** @type {import('@uploadcare/upload-client').UploadcareFile} */ let fileInfo = await this.$["*uploadQueue"].add(uploadTask);
            entry.setMultipleValues({
                fileInfo: fileInfo,
                isUploading: false,
                fileName: fileInfo.originalFilename,
                fileSize: fileInfo.size,
                isImage: fileInfo.isImage,
                mimeType: fileInfo.contentInfo?.mime?.mime ?? fileInfo.mimeType,
                uuid: fileInfo.uuid,
                cdnUrl: entry.getValue("cdnUrl") ?? fileInfo.cdnUrl,
                cdnUrlModifiers: entry.getValue("cdnUrlModifiers") ?? "",
                uploadProgress: 100,
                source: entry.getValue("source") ?? null
            });
            if (entry === this._entry) this._debouncedCalculateState();
        } catch (cause) {
            if (cause instanceof (0, $3905b2ce68ef12c7$export$d7f5e52d091a66db) && cause.isCancel) entry.setMultipleValues({
                isUploading: false,
                uploadProgress: 0
            });
            else entry.setMultipleValues({
                isUploading: false,
                uploadProgress: 0,
                uploadError: cause
            });
            if (entry === this._entry) this._debouncedCalculateState();
        }
    }
}
$d2765c958d00b716$export$a964e6adf466d4a6.template = /* HTML */ `
  <div class="uc-inner" set="@finished: isFinished; @uploading: isUploading; @failed: isFailed; @focused: isFocused">
    <div class="uc-thumb" set="style.backgroundImage: thumbUrl">
      <div class="uc-badge">
        <uc-icon set="@name: badgeIcon"></uc-icon>
      </div>
    </div>
    <div aria-atomic="true" aria-live="polite" class="uc-file-name-wrapper" set="@aria-label:ariaLabelStatusFile;">
      <span class="uc-file-name">{{itemName}}</span>
      <span class="uc-file-error" set="@hidden: !errorText">{{errorText}}</span>
      <span class="uc-file-hint" set="@hidden: !hint">{{hint}}</span>
    </div>
    <div class="uc-file-actions">
      <button
        type="button"
        l10n="@title:file-item-edit-button;@aria-label:file-item-edit-button"
        class="uc-edit-btn uc-mini-btn"
        set="onclick: onEdit; @hidden: !isEditable"
      >
        <uc-icon name="edit-file"></uc-icon>
      </button>
      <button
        type="button"
        l10n="@title:file-item-remove-button;@aria-label:file-item-remove-button"
        class="uc-remove-btn uc-mini-btn"
        set="onclick: onRemove;"
      >
        <uc-icon name="remove-file"></uc-icon>
      </button>
      <button type="button" class="uc-upload-btn uc-mini-btn" set="onclick: onUpload;">
        <uc-icon name="upload"></uc-icon>
      </button>
    </div>
    <uc-progress-bar class="uc-progress-bar" set="value: progressValue; visible: progressVisible;"> </uc-progress-bar>
  </div>
`;
$d2765c958d00b716$export$a964e6adf466d4a6.activeInstances = new Set();


// @ts-check

class $ab3741267a92b1c4$export$2b77a92f1a5ad772 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    static styleAttrs = [
        ...super.styleAttrs,
        "uc-modal"
    ];
    static StateConsumerScope = "modal";
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            "*modalActive": false,
            isOpen: false,
            closeClicked: this._handleDialogClose
        };
    }
    _handleBackdropClick = ()=>{
        this._closeDialog();
    };
    _closeDialog = ()=>{
        this.setOrAddState("*modalActive", false);
    };
    _handleDialogClose = ()=>{
        this._closeDialog();
    };
    /** @param {Event} e */ _handleDialogMouseDown = (e)=>{
        /** @private */ this._mouseDownTarget = e.target;
    };
    /** @param {Event} e */ _handleDialogMouseUp = (e)=>{
        if (e.target === this.ref.dialog && e.target === this._mouseDownTarget) this._closeDialog();
    };
    show() {
        if (this.ref.dialog.showModal) this.ref.dialog.showModal();
        else this.ref.dialog.setAttribute("open", "");
    }
    hide() {
        if (this.ref.dialog.close) this.ref.dialog.close();
        else this.ref.dialog.removeAttribute("open");
    }
    initCallback() {
        super.initCallback();
        this.ref.dialog.addEventListener("close", this._handleDialogClose);
        this.ref.dialog.addEventListener("mousedown", this._handleDialogMouseDown);
        this.ref.dialog.addEventListener("mouseup", this._handleDialogMouseUp);
        this.sub("*modalActive", (modalActive)=>{
            if (this.$.isOpen !== modalActive) this.$.isOpen = modalActive;
            if (modalActive && this.cfg.modalScrollLock) document.body.style.overflow = "hidden";
            else document.body.style.overflow = "";
        });
        this.subConfigValue("modalBackdropStrokes", (val)=>{
            if (val) this.setAttribute("strokes", "");
            else this.removeAttribute("strokes");
        });
        this.sub("isOpen", (isOpen)=>{
            if (isOpen) {
                this.show();
                this.setAttribute("aria-modal", "true");
            } else {
                this.hide();
                this.setAttribute("aria-modal", "false");
            }
        });
    }
    destroyCallback() {
        super.destroyCallback();
        document.body.style.overflow = "";
        this._mouseDownTarget = undefined;
        this.ref.dialog.removeEventListener("close", this._handleDialogClose);
        this.ref.dialog.removeEventListener("mousedown", this._handleDialogMouseDown);
        this.ref.dialog.removeEventListener("mouseup", this._handleDialogMouseUp);
    }
}
$ab3741267a92b1c4$export$2b77a92f1a5ad772.template = /* HTML */ `
  <dialog ref="dialog">
    <slot></slot>
  </dialog>
`;


// @ts-check




class $25d6a5076117c062$export$41ee0b933a746426 extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    // Context owner should have access to CSS l10n
    // TODO: We need to move away l10n from CSS
    couldBeCtxOwner = true;
    historyTracked = true;
    activityType = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            doneBtnVisible: false,
            doneBtnEnabled: false,
            uploadBtnVisible: false,
            addMoreBtnVisible: false,
            addMoreBtnEnabled: false,
            headerText: "",
            commonErrorMessage: "",
            hasFiles: false,
            onAdd: ()=>{
                this.api.initFlow(true);
            },
            onUpload: ()=>{
                this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).UPLOAD_CLICK);
                this.api.uploadAll();
                this._throttledHandleCollectionUpdate();
            },
            onDone: ()=>{
                this.emit((0, $068cac2d61e2e514$export$3d7865934588d77e).DONE_CLICK, this.api.getOutputCollectionState());
                this.api.doneFlow();
            },
            onCancel: ()=>{
                this.uploadCollection.clearAll();
            }
        };
    }
    /** @private */ _throttledHandleCollectionUpdate = (0, $3463bc23a4723762$export$de363e709c412c8a)(()=>{
        if (!this.isConnected) return;
        this._updateUploadsState();
        if (!this.couldOpenActivity && this.$["*currentActivity"] === this.activityType) this.historyBack();
    }, 300);
    /** @private */ _updateUploadsState() {
        const collectionState = this.api.getOutputCollectionState();
        /** @type {Summary} */ const summary = {
            total: collectionState.totalCount,
            succeed: collectionState.successCount,
            uploading: collectionState.uploadingCount,
            failed: collectionState.failedCount
        };
        const fitCountRestrictions = !collectionState.errors.some((err)=>err.type === "TOO_MANY_FILES" || err.type === "TOO_FEW_FILES");
        const tooMany = collectionState.errors.some((err)=>err.type === "TOO_MANY_FILES");
        const exact = collectionState.totalCount === (this.cfg.multiple ? this.cfg.multipleMax : 1);
        const validationOk = summary.failed === 0 && collectionState.errors.length === 0;
        let uploadBtnVisible = false;
        let allDone = false;
        let doneBtnEnabled = false;
        const readyToUpload = summary.total - summary.succeed - summary.uploading - summary.failed;
        if (readyToUpload > 0 && fitCountRestrictions) uploadBtnVisible = true;
        else {
            allDone = true;
            const groupOk = this.cfg.groupOutput ? !!collectionState.group : true;
            doneBtnEnabled = summary.total === summary.succeed && fitCountRestrictions && validationOk && groupOk;
        }
        this.set$({
            doneBtnVisible: allDone,
            doneBtnEnabled: doneBtnEnabled,
            uploadBtnVisible: uploadBtnVisible,
            addMoreBtnEnabled: summary.total === 0 || !tooMany && !exact,
            addMoreBtnVisible: !exact || this.cfg.multiple
        });
        this.bindL10n("headerText", ()=>this._getHeaderText(summary));
    }
    /**
   * @private
   * @param {Summary} summary
   */ _getHeaderText(summary) {
        /** @param {keyof Summary} status */ const localizedText = (status)=>{
            const count = summary[status];
            return this.l10n(`header-${status}`, {
                count: count
            });
        };
        if (summary.uploading > 0) return localizedText("uploading");
        if (summary.failed > 0) return localizedText("failed");
        if (summary.succeed > 0) return localizedText("succeed");
        return localizedText("total");
    }
    get couldOpenActivity() {
        return this.cfg.showEmptyList || this.uploadCollection.size > 0;
    }
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType);
        this.subConfigValue("multiple", this._throttledHandleCollectionUpdate);
        this.subConfigValue("multipleMin", this._throttledHandleCollectionUpdate);
        this.subConfigValue("multipleMax", this._throttledHandleCollectionUpdate);
        this.sub("*groupInfo", (groupInfo)=>{
            if (groupInfo) this._throttledHandleCollectionUpdate();
        });
        this.sub("*currentActivity", (currentActivity)=>{
            if (!this.couldOpenActivity && currentActivity === this.activityType) this.$["*currentActivity"] = this.initActivity;
        });
        // TODO: could be performance issue on many files
        // there is no need to update buttons state on every progress tick
        this.uploadCollection.observeProperties(this._throttledHandleCollectionUpdate);
        this.sub("*uploadList", (list)=>{
            this._throttledHandleCollectionUpdate();
            this.set$({
                hasFiles: list.length > 0
            });
            if (!this.cfg.confirmUpload) this.api.uploadAll();
        }, false);
        this.sub("*collectionErrors", /** @param {import('../../types').OutputError<import('../../types').OutputCollectionErrorType>[]} errors */ (errors)=>{
            const firstError = errors.filter((err)=>err.type !== "SOME_FILES_HAS_ERRORS")[0];
            if (!firstError) {
                this.set$({
                    commonErrorMessage: null
                });
                return;
            }
            this.set$({
                commonErrorMessage: firstError.message
            });
        });
    }
    destroyCallback() {
        super.destroyCallback();
        this.uploadCollection.unobserveProperties(this._throttledHandleCollectionUpdate);
    }
}
$25d6a5076117c062$export$41ee0b933a746426.template = /* HTML */ `
  <uc-activity-header>
    <span aria-live="polite" class="uc-header-text">{{headerText}}</span>
    <button
      type="button"
      class="uc-mini-btn uc-close-btn"
      set="onclick: *closeModal"
      l10n="@title:a11y-activity-header-button-close;@aria-label:a11y-activity-header-button-close"
    >
      <uc-icon name="close"></uc-icon>
    </button>
  </uc-activity-header>

  <div class="uc-no-files" set="@hidden: hasFiles">
    <slot name="empty"><span l10n="no-files"></span></slot>
  </div>

  <div class="uc-files" repeat="*uploadList" repeat-item-tag="uc-file-item"></div>

  <div class="uc-common-error" set="@hidden: !commonErrorMessage; textContent: commonErrorMessage;"></div>

  <div class="uc-toolbar">
    <button type="button" class="uc-cancel-btn uc-secondary-btn" set="onclick: onCancel;" l10n="clear"></button>
    <div class="uc-toolbar-spacer"></div>
    <button
      type="button"
      class="uc-add-more-btn uc-secondary-btn"
      set="onclick: onAdd; @disabled: !addMoreBtnEnabled; @hidden: !addMoreBtnVisible"
    >
      <uc-icon name="add"></uc-icon><span l10n="add-more"></span>
    </button>
    <button
      type="button"
      class="uc-upload-btn uc-primary-btn"
      set="@hidden: !uploadBtnVisible; onclick: onUpload;"
      l10n="upload"
    ></button>
    <button
      type="button"
      class="uc-done-btn uc-primary-btn"
      set="@hidden: !doneBtnVisible; onclick: onDone;  @disabled: !doneBtnEnabled"
      l10n="done"
    ></button>
  </div>

  <uc-drop-area ghost></uc-drop-area>
`;





class $7e0317bb72a509ca$export$cd326b6b2fa63cf5 extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    activityType = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.URL;
    init$ = {
        ...this.init$,
        importDisabled: true,
        onUpload: (e)=>{
            e.preventDefault();
            let url = this.ref.input["value"];
            this.api.addFileFromUrl(url, {
                source: (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).URL
            });
            this.$["*currentActivity"] = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
        },
        onCancel: ()=>{
            this.historyBack();
        },
        onInput: (e)=>{
            let value = /** @type {HTMLInputElement} */ e.target.value;
            this.set$({
                importDisabled: !value
            });
        }
    };
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType, {
            onActivate: ()=>{
                this.ref.input["value"] = "";
                this.ref.input.focus();
            }
        });
    }
}
$7e0317bb72a509ca$export$cd326b6b2fa63cf5.template = /* HTML */ `
  <uc-activity-header>
    <button type="button" class="uc-mini-btn" set="onclick: *historyBack" l10n="@title:back;@aria-label:back">
      <uc-icon name="back"></uc-icon>
    </button>
    <div>
      <uc-icon name="url"></uc-icon>
      <span l10n="caption-from-url"></span>
    </div>
    <button
      type="button"
      class="uc-mini-btn uc-close-btn"
      set="onclick: *closeModal"
      l10n="@title:a11y-activity-header-button-close;@aria-label:a11y-activity-header-button-close"
    >
      <uc-icon name="close"></uc-icon>
    </button>
  </uc-activity-header>
  <form class="uc-content">
    <input placeholder="https://" class="uc-url-input" type="text" ref="input" set="oninput: onInput" />
    <button
      type="submit"
      class="uc-url-upload-btn uc-primary-btn"
      set="onclick: onUpload; @disabled: importDisabled"
      l10n="upload-url"
    ></button>
  </form>
`;


//@ts-nocheck



const $82641a19318974c8$export$8123dd108ae7e125 = ()=>{
    return typeof navigator.permissions !== "undefined";
};






const $ecd1371329c3da9a$var$DEFAULT_VIDEO_CONFIG = {
    width: {
        ideal: 1920
    },
    height: {
        ideal: 1080
    },
    frameRate: {
        ideal: 30
    }
};
const $ecd1371329c3da9a$var$DEFAULT_PERMISSIONS = [
    "camera",
    "microphone"
];
/**
 * @param {Number} time
 * @returns
 */ function $ecd1371329c3da9a$var$formatTime(time) {
    const minutes = Math.floor(time / 60).toString().padStart(2, "0");
    const seconds = Math.floor(time % 60).toString().padStart(2, "0");
    return `${minutes}:${seconds}`;
}
const $ecd1371329c3da9a$var$DEFAULT_PICTURE_FORMAT = "image/jpeg";
const $ecd1371329c3da9a$var$DEFAULT_VIDEO_FORMAT = "video/webm";
class $ecd1371329c3da9a$export$9a93ce53f488cb2e extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    activityType = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.CAMERA;
    /** @private */ _unsubPermissions = null;
    /** @type {BlobPart[]} */ _chunks = [];
    /** @type {MediaRecorder | null} */ _mediaRecorder = null;
    /** @type {MediaStream | null} */ _stream = null;
    /** @type {string | null} */ _selectedAudioId = null;
    /** @type {string | null} */ _selectedCameraId = null;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            video: null,
            videoTransformCss: null,
            videoHidden: true,
            messageHidden: true,
            requestBtnHidden: (0, $82641a19318974c8$export$8123dd108ae7e125)(),
            cameraSelectOptions: null,
            cameraSelectHidden: true,
            l10nMessage: "",
            // This is refs
            switcher: null,
            panels: null,
            timer: null,
            timerHidden: true,
            cameraHidden: true,
            cameraActionsHidden: true,
            audioSelectOptions: null,
            audioSelectHidden: true,
            audioSelectDisabled: true,
            audioToggleMicrophoneHidden: true,
            tabCameraHidden: true,
            tabVideoHidden: true,
            currentIcon: "camera-full",
            currentTimelineIcon: "play",
            toggleMicrophoneIcon: "microphone",
            /** @type {Number} */ _startTime: 0,
            /** @type {Number} */ _elapsedTime: 0,
            _animationFrameId: null,
            mutableClassButton: "uc-shot-btn uc-camera-action",
            /** @param {Event} e */ onCameraSelectChange: (e)=>{
                this._selectedCameraId = e.target.value;
                this._capture();
            },
            /** @param {Event} e */ onAudioSelectChange: (e)=>{
                this._selectedAudioId = e.target.value;
                this._capture();
            },
            onCancel: ()=>{
                this.historyBack();
            },
            onShot: ()=>this._shot(),
            onRequestPermissions: ()=>this._capture(),
            /** General method for photo and video capture */ onStartCamera: ()=>this._chooseActionWithCamera(),
            onStartRecording: ()=>this._startRecording(),
            onStopRecording: ()=>this._stopRecording(),
            onToggleRecording: ()=>this._toggleRecording(),
            onToggleAudio: ()=>this._toggleEnableAudio(),
            onRetake: ()=>this._retake(),
            onAccept: ()=>this._accept(),
            /** @param {MouseEvent} e */ onClickTab: (e)=>{
                const id = /** @type {HTMLElement} */ e.currentTarget.getAttribute("data-id");
                if (id) this._handleActiveTab(/** @type {CameraMode} */ id);
            }
        };
    }
    _chooseActionWithCamera = ()=>{
        if (this._activeTab === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO) this._shot();
        if (this._activeTab === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO) {
            if (this._mediaRecorder?.state === "recording") {
                this._stopRecording();
                return;
            }
            this._startRecording();
        }
    };
    _updateTimer = ()=>{
        const currentTime = Math.floor((performance.now() - this.$._startTime + this.$._elapsedTime) / 1000);
        if (typeof this.cfg.maxVideoRecordingDuration === "number" && this.cfg.maxVideoRecordingDuration > 0) {
            const remainingTime = this.cfg.maxVideoRecordingDuration - currentTime;
            if (remainingTime <= 0) {
                this.ref.timer.textContent = $ecd1371329c3da9a$var$formatTime(remainingTime);
                this._stopRecording();
                return;
            }
            this.ref.timer.textContent = $ecd1371329c3da9a$var$formatTime(remainingTime);
        } else this.ref.timer.textContent = $ecd1371329c3da9a$var$formatTime(currentTime);
        this._animationFrameId = requestAnimationFrame(this._updateTimer);
    };
    _startTimer = ()=>{
        this.$._startTime = performance.now();
        this.$._elapsedTime = 0;
        this._updateTimer();
    };
    _stopTimer = ()=>{
        if (this._animationFrameId) cancelAnimationFrame(this._animationFrameId);
    };
    _startTimeline = ()=>{
        const currentTime = this.ref.video.currentTime;
        const duration = this.ref.video.duration;
        this.ref.line.style.transform = `scaleX(${currentTime / duration})`;
        this.ref.timer.textContent = $ecd1371329c3da9a$var$formatTime(currentTime);
        this._animationFrameId = requestAnimationFrame(this._startTimeline);
    };
    _stopTimeline = ()=>{
        if (this._animationFrameId) cancelAnimationFrame(this._animationFrameId);
    };
    _startRecording = ()=>{
        try {
            this._chunks = [];
            this._options = {
                ...this.cfg.mediaRecorderOptions
            };
            const { mimeType: mimeType } = this.cfg.mediaRecorderOptions || {};
            if (mimeType && MediaRecorder.isTypeSupported(mimeType)) this._options.mimeType = mimeType;
            else if (MediaRecorder.isTypeSupported($ecd1371329c3da9a$var$DEFAULT_VIDEO_FORMAT)) this._options.mimeType = $ecd1371329c3da9a$var$DEFAULT_VIDEO_FORMAT;
            else this._options.mimeType = "video/mp4";
            if (this._stream) {
                this._mediaRecorder = new MediaRecorder(this._stream, this._options);
                this._mediaRecorder.start();
                this._mediaRecorder.addEventListener("dataavailable", (e)=>{
                    this._chunks.push(e.data);
                });
                this._startTimer();
                this.classList.add("uc-recording");
                this._setCameraState((0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).PLAY);
            }
        } catch (error) {
            console.error("Failed to start recording", error);
        }
    };
    /** @private */ _stopRecording = ()=>{
        this._mediaRecorder?.addEventListener("stop", ()=>{
            this._previewVideo();
            this._stopTimer();
            this._setCameraState((0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).STOP);
        });
        this._mediaRecorder?.stop();
        this.classList.remove("uc-recording");
    };
    /** This method is used to toggle recording pause/resume */ _toggleRecording = ()=>{
        if (this._mediaRecorder?.state === "recording") return;
        if (!this.ref.video.paused && !this.ref.video.ended && this.ref.video.readyState > 2) this.ref.video.pause();
        else if (this.ref.video.paused) this.ref.video.play();
    };
    _toggleEnableAudio = ()=>{
        this._stream?.getAudioTracks().forEach((track)=>{
            track.enabled = !track.enabled;
            this.$.toggleMicrophoneIcon = !track.enabled ? "microphone-mute" : "microphone";
            this.$.audioSelectDisabled = !track.enabled;
        });
    };
    /**
   * Previewing the video that was recorded on the camera
   *
   * @private
   */ _previewVideo = ()=>{
        try {
            const blob = new Blob(this._chunks, {
                type: this._mediaRecorder?.mimeType
            });
            const videoURL = URL.createObjectURL(blob);
            this.ref.video.muted = false;
            this.ref.video.volume = 1;
            this.$.video = null;
            this.ref.video.src = videoURL;
            this.ref.video.addEventListener("play", ()=>{
                this._startTimeline();
                this.set$({
                    currentTimelineIcon: "pause"
                });
            });
            this.ref.video.addEventListener("pause", ()=>{
                this.set$({
                    currentTimelineIcon: "play"
                });
                this._stopTimeline();
            });
        } catch (error) {
            console.error("Failed to preview video", error);
        }
    };
    _retake = ()=>{
        this._setCameraState((0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).RETAKE);
        /** Reset video */ if (this._activeTab === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO) {
            this.$.video = this._stream;
            this.ref.video.muted = true;
        }
        this.ref.video.play();
    };
    _accept = ()=>{
        this._setCameraState((0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).ACCEPT);
        if (this._activeTab === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO) {
            this._canvas?.toBlob((blob)=>{
                const file = this._createFile("camera", "jpeg", $ecd1371329c3da9a$var$DEFAULT_PICTURE_FORMAT, blob);
                this._toSend(file);
            }, $ecd1371329c3da9a$var$DEFAULT_PICTURE_FORMAT);
            return;
        }
        const blob = new Blob(this._chunks, {
            type: this._mediaRecorder?.mimeType
        });
        const ext = this._guessExtensionByMime(this._mediaRecorder?.mimeType);
        const file = this._createFile("video", ext, `video/${ext}`, blob);
        this._toSend(file);
        this._chunks = [];
    };
    /** @param {CameraStatus} status */ _handlePhoto = (status)=>{
        if (status === (0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).SHOT) this.set$({
            tabVideoHidden: true,
            cameraHidden: true,
            tabCameraHidden: true,
            cameraActionsHidden: false,
            cameraSelectHidden: true
        });
        if (status === (0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).RETAKE || status === (0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).ACCEPT) this.set$({
            tabVideoHidden: !this._cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO),
            tabCameraHidden: !this._cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO),
            cameraHidden: false,
            cameraActionsHidden: true,
            cameraSelectHidden: this._cameraDevices.length <= 1
        });
    };
    /** @param {CameraStatus} status */ _handleVideo = (status)=>{
        if (status === (0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).PLAY) this.set$({
            timerHidden: false,
            tabCameraHidden: true,
            cameraSelectHidden: true,
            audioSelectHidden: true,
            currentTimelineIcon: "pause",
            currentIcon: "square",
            mutableClassButton: "uc-shot-btn uc-camera-action uc-stop-record"
        });
        if (status === (0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).STOP) this.set$({
            timerHidden: false,
            cameraHidden: true,
            audioToggleMicrophoneHidden: true,
            cameraActionsHidden: false
        });
        if (status === (0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).RETAKE || status === (0, $5b19d5bf1367d1d4$export$9d766d51f3f726e2).ACCEPT) this.set$({
            timerHidden: true,
            tabVideoHidden: !this._cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO),
            tabCameraHidden: !this._cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO),
            cameraHidden: false,
            cameraActionsHidden: true,
            audioToggleMicrophoneHidden: !this.cfg.enableAudioRecording,
            currentIcon: "video-camera-full",
            mutableClassButton: "uc-shot-btn uc-camera-action",
            audioSelectHidden: !this.cfg.enableAudioRecording || this._audioDevices.length <= 1,
            cameraSelectHidden: this._cameraDevices.length <= 1
        });
    };
    /**
   * @private
   * @param {CameraStatus} status
   */ _setCameraState = (status)=>{
        if (this._activeTab === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO && (status === "shot" || status === "retake" || status === "accept")) this._handlePhoto(status);
        if (this._activeTab === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO && (status === "play" || status === "stop" || status === "retake" || status === "accept" || status === "pause" || status === "resume")) this._handleVideo(status);
    };
    /** @private */ _shot() {
        this._setCameraState("shot");
        this._canvas = document.createElement("canvas");
        this._ctx = this._canvas.getContext("2d");
        if (!this._ctx) throw new Error("Failed to get canvas context");
        this._canvas.height = this.ref.video["videoHeight"];
        this._canvas.width = this.ref.video["videoWidth"];
        if (this.cfg.cameraMirror) {
            this._ctx.translate(this._canvas.width, 0);
            this._ctx.scale(-1, 1);
        }
        this._ctx.drawImage(this.ref.video, 0, 0);
        this.ref.video.pause();
    }
    /**
   * @private
   * @param {CameraMode} tabId
   */ _handleActiveTab = (tabId)=>{
        this.ref.switcher.querySelectorAll("button").forEach((/** @type {HTMLElement} */ btn)=>{
            btn.classList.toggle("uc-active", btn.getAttribute("data-id") === tabId);
        });
        if (tabId === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO) this.set$({
            currentIcon: "camera-full",
            audioSelectHidden: true,
            audioToggleMicrophoneHidden: true
        });
        if (tabId === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO) this.set$({
            currentTimelineIcon: "play",
            currentIcon: "video-camera-full",
            audioSelectHidden: !this.cfg.enableAudioRecording || this._audioDevices.length <= 1,
            audioToggleMicrophoneHidden: !this.cfg.enableAudioRecording
        });
        this._activeTab = tabId;
    };
    /**
   * @param {'camera' | 'video'} type
   * @param {'jpeg' | 'webm'} ext
   * @param {String} format
   * @param {Blob} blob
   */ _createFile = (type, ext, format, blob)=>{
        const date = Date.now();
        const name = `${type}-${date}.${ext}`;
        const file = new File([
            blob
        ], name, {
            lastModified: date,
            type: format
        });
        return file;
    };
    /** @param {String | undefined} mime */ _guessExtensionByMime(mime) {
        const knownContainers = {
            mp4: "mp4",
            ogg: "ogg",
            webm: "webm",
            quicktime: "mov",
            "x-matroska": "mkv"
        };
        // MediaRecorder.mimeType returns empty string in Firefox.
        // Firefox record video as WebM now by default.
        // @link https://bugzilla.mozilla.org/show_bug.cgi?id=1512175
        if (mime === "") return "webm";
        // e.g. "video/x-matroska;codecs=avc1,opus"
        if (mime) {
            // e.g. ["video", "x-matroska;codecs=avc1,opus"]
            /** @type {string | string[]} */ mime = mime.split("/");
            if (mime?.[0] === "video") {
                // e.g. "x-matroska;codecs=avc1,opus"
                mime = mime.slice(1).join("/");
                // e.g. "x-matroska"
                const container = mime?.split(";")[0];
                // e.g. "mkv"
                if (knownContainers[container]) return knownContainers[container];
            }
        }
        // In all other cases just return the base extension for all times
        return "avi";
    }
    /**
   * The send file to the server
   *
   * @param {File} file
   */ _toSend = (file)=>{
        this.api.addFileFromObject(file, {
            source: (0, $a53f5e78ad1bb77c$export$5522e73b726d0ec8).CAMERA
        });
        this.set$({
            "*currentActivity": (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST
        });
    };
    /** @private */ get _cameraModes() {
        return (0, $15ba4abb0cb95799$export$b9ca061da17f2d30)(this.cfg.cameraModes);
    }
    /**
   * @private
   * @param {'granted' | 'denied' | 'prompt'} state
   */ _setPermissionsState = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)((state)=>{
        this.classList.toggle("uc-initialized", state === "granted");
        const visibleAudio = this._activeTab === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO && this.cfg.enableAudioRecording;
        const currentIcon = this._activeTab === (0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO ? "camera-full" : "video-camera-full";
        if (state === "granted") this.set$({
            videoHidden: false,
            cameraHidden: false,
            tabCameraHidden: !this._cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO),
            tabVideoHidden: !this._cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO),
            messageHidden: true,
            timerHidden: true,
            currentIcon: currentIcon,
            audioToggleMicrophoneHidden: !visibleAudio,
            audioSelectHidden: !visibleAudio
        });
        else if (state === "prompt") {
            this.$.l10nMessage = "camera-permissions-prompt";
            this.set$({
                videoHidden: true,
                cameraHidden: true,
                tabCameraHidden: true,
                messageHidden: false
            });
            this._stopCapture();
        } else {
            this.$.l10nMessage = "camera-permissions-denied";
            this.set$({
                videoHidden: true,
                messageHidden: false,
                tabCameraHidden: !this._cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO),
                tabVideoHidden: !this._cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO),
                cameraActionsHidden: true,
                mutableClassButton: "uc-shot-btn uc-camera-action"
            });
            this._stopCapture();
        }
    }, 300);
    _makeStreamInactive = ()=>{
        if (!this._stream) return false;
        const audioTracks = this._stream?.getAudioTracks();
        const videoTracks = this._stream?.getVideoTracks();
        /** @type {MediaStreamTrack[]} */ audioTracks.forEach((track)=>track.stop());
        /** @type {MediaStreamTrack[]} */ videoTracks.forEach((track)=>track.stop());
    };
    _stopCapture = ()=>{
        if (this._capturing) {
            this.ref.video.volume = 0;
            this.$.video?.getTracks()[0].stop();
            this.$.video = null;
            this._makeStreamInactive();
            this._stopTimer();
            this._capturing = false;
        }
    };
    _capture = async ()=>{
        const constraints = {
            video: $ecd1371329c3da9a$var$DEFAULT_VIDEO_CONFIG,
            audio: this.cfg.enableAudioRecording ? {} : false
        };
        if (this._selectedCameraId) constraints.video = {
            deviceId: {
                exact: this._selectedCameraId
            }
        };
        if (this._selectedAudioId && this.cfg.enableAudioRecording) constraints.audio = {
            deviceId: {
                exact: this._selectedAudioId
            }
        };
        // Mute the video to prevent feedback for Firefox
        this.ref.video.volume = 0;
        try {
            this._setPermissionsState("prompt");
            this._stream = await navigator.mediaDevices.getUserMedia(constraints);
            this._stream.addEventListener("inactive", ()=>{
                this._setPermissionsState("denied");
            });
            this.$.video = this._stream;
            /** @private */ this._capturing = true;
            this._setPermissionsState("granted");
        } catch (error) {
            this._setPermissionsState("denied");
            console.log("Failed to capture camera", error);
        }
    };
    _handlePermissionsChange = ()=>{
        this._capture();
    };
    _permissionAccess = async ()=>{
        try {
            for (const permission of $ecd1371329c3da9a$var$DEFAULT_PERMISSIONS){
                // @ts-ignore  https://developer.mozilla.org/en-US/docs/Web/API/Permissions_API
                this[`${permission}Response`] = await navigator.permissions.query({
                    name: permission
                });
                this[`${permission}Response`].addEventListener("change", this._handlePermissionsChange);
            }
        } catch (error) {
            console.log("Failed to use permissions API. Fallback to manual request mode.", error);
            this._capture();
        }
    };
    _getPermission = ()=>{};
    _requestDeviceAccess = async ()=>{
        try {
            await navigator.mediaDevices.getUserMedia({
                video: true,
                audio: this.cfg.enableAudioRecording
            });
            await this._getDevices();
            navigator.mediaDevices.addEventListener("devicechange", this._getDevices);
        } catch (error) {
            console.log("Failed to get user media", error);
        }
    };
    _getDevices = async ()=>{
        try {
            const devices = await navigator.mediaDevices.enumerateDevices();
            this._cameraDevices = devices.filter((device)=>device.kind === "videoinput").map((device, index)=>({
                    text: device.label.trim() || `${this.l10n("caption-camera")} ${index + 1}`,
                    value: device.deviceId
                }));
            this._audioDevices = this.cfg.enableAudioRecording && devices.filter((device)=>device.kind === "audioinput").map((device)=>({
                    text: device.label.trim(),
                    value: device.deviceId
                }));
            if (this._cameraDevices.length > 1) this.set$({
                cameraSelectOptions: this._cameraDevices,
                cameraSelectHidden: false
            });
            this._selectedCameraId = this._cameraDevices[0]?.value;
            if (this._audioDevices.length > 1) this.set$({
                audioSelectOptions: this._audioDevices,
                audioSelectHidden: false
            });
            this._selectedAudioId = this._audioDevices[0]?.value;
        } catch (error) {
            console.log("Failed to get devices", error);
        }
    };
    _onActivate = async ()=>{
        await this._permissionAccess();
        await this._requestDeviceAccess();
        await this._capture();
        this._handleCameraModes(this._cameraModes);
    };
    _onDeactivate = async ()=>{
        if (this._unsubPermissions) this._unsubPermissions();
        /** Calling this method here because safari and firefox don't support the inactive event yet */ const isChromium = !!window.chrome;
        if (!isChromium) this._setPermissionsState("denied");
        this._stopCapture();
    };
    /** @param {CameraMode[]} cameraModes */ _handleCameraModes = (cameraModes)=>{
        this.$.tabVideoHidden = !cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).VIDEO);
        this.$.tabCameraHidden = !cameraModes.includes((0, $5b19d5bf1367d1d4$export$7db9bdd2f098cbde).PHOTO);
        const defaultTab = cameraModes[0];
        if (!this._activeTab || !cameraModes.includes(this._activeTab)) this._handleActiveTab(defaultTab);
    };
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType, {
            onActivate: this._onActivate,
            onDeactivate: this._onDeactivate
        });
        this.subConfigValue("cameraMirror", (val)=>{
            this.$.videoTransformCss = val ? "scaleX(-1)" : null;
        });
        this.subConfigValue("enableAudioRecording", (val)=>{
            this.$.audioToggleMicrophoneHidden = !val;
            this.$.audioSelectDisabled = !val;
        });
        this.subConfigValue("cameraModes", (val)=>{
            if (!this.isActivityActive) return;
            const cameraModes = (0, $cf5145deda9036ee$export$7a086f785998e32e)(val);
            this._handleCameraModes(cameraModes);
        });
    }
    _destroy() {
        for (const permission of $ecd1371329c3da9a$var$DEFAULT_PERMISSIONS)this[`${permission}Response`]?.removeEventListener("change", this._handlePermissionsChange);
        navigator.mediaDevices?.removeEventListener("devicechange", this._getDevices);
    }
    async destroyCallback() {
        super.destroyCallback();
        this._destroy();
    }
}
$ecd1371329c3da9a$export$9a93ce53f488cb2e.template = /* HTML */ `
  <uc-activity-header>
    <button type="button" class="uc-mini-btn" set="onclick: *historyBack" l10n="@title:back">
      <uc-icon name="back"></uc-icon>
    </button>
    <div set="@hidden: !cameraSelectHidden">
      <uc-icon name="camera"></uc-icon>
      <span l10n="caption-camera"></span>
    </div>
    <uc-select
      class="uc-camera-select"
      set="$.options: cameraSelectOptions; @hidden: cameraSelectHidden; onchange: onCameraSelectChange"
    >
    </uc-select>
    <button
      type="button"
      class="uc-mini-btn uc-close-btn"
      set="onclick: *closeModal"
      l10n="@title:a11y-activity-header-button-close;@aria-label:a11y-activity-header-button-close"
    >
      <uc-icon name="close"></uc-icon>
    </button>
  </uc-activity-header>
  <div class="uc-content">
    <video
      muted
      autoplay
      playsinline
      set="srcObject: video; style.transform: videoTransformCss; @hidden: videoHidden"
      ref="video"
    ></video>
    <div class="uc-message-box" set="@hidden: messageHidden">
      <span l10n="l10nMessage"></span>
      <button
        type="button"
        set="onclick: onRequestPermissions; @hidden: requestBtnHidden"
        l10n="camera-permissions-request"
      ></button>
    </div>
  </div>

  <div class="uc-controls">
    <div ref="switcher" class="uc-switcher" set="@hidden:!timerHidden">
      <button
        data-id="photo"
        type="button"
        class="uc-switch uc-mini-btn"
        set="onclick: onClickTab;  @hidden: tabCameraHidden"
      >
        <uc-icon name="camera"></uc-icon>
      </button>
      <button
        data-id="video"
        type="button"
        class="uc-switch uc-mini-btn"
        set="onclick: onClickTab; @hidden: tabVideoHidden"
      >
        <uc-icon name="video-camera"></uc-icon>
      </button>
    </div>

    <button class="uc-secondary-btn uc-recording-timer" set="@hidden:timerHidden; onclick: onToggleRecording">
      <uc-icon set="@name: currentTimelineIcon"></uc-icon>
      <span ref="timer"> 00:00 </span>
      <span ref="line" class="uc-line"></span>
    </button>

    <div class="uc-camera-actions uc-camera-action" set="@hidden: cameraActionsHidden">
      <button type="button" class="uc-secondary-btn" set="onclick: onRetake">Retake</button>
      <button type="button" class="uc-primary-btn" set="onclick: onAccept">Accept</button>
    </div>

    <button
      type="button"
      class="uc-shot-btn uc-camera-action"
      set="onclick: onStartCamera; @class: mutableClassButton; @hidden: cameraHidden;"
    >
      <uc-icon set="@name: currentIcon"></uc-icon>
    </button>

    <div class="uc-select">
      <button class="uc-mini-btn uc-btn-microphone" set="onclick: onToggleAudio; @hidden: audioToggleMicrophoneHidden;">
        <uc-icon set="@name:toggleMicrophoneIcon"></uc-icon>
      </button>

      <uc-select
        class="uc-audio-select"
        set="$.options: audioSelectOptions; onchange: onAudioSelectChange; @hidden: audioSelectHidden; @disabled: audioSelectDisabled"
      >
      </uc-select>
    </div>
  </div>
`;


// @ts-check


class $91463e4c4d2c2556$var$UploadCtxProviderClass extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    requireCtxName = true;
    initCallback() {
        super.initCallback();
        this.$["*eventEmitter"].bindTarget(this);
    }
    destroyCallback() {
        super.destroyCallback();
        this.$["*eventEmitter"].unbindTarget(this);
    }
}
$91463e4c4d2c2556$var$UploadCtxProviderClass.EventType = (0, $068cac2d61e2e514$export$3d7865934588d77e);
const $91463e4c4d2c2556$export$6edf8f70f62f022d = /** @type {UploadCtxProvider} */ /** @type {unknown} */ $91463e4c4d2c2556$var$UploadCtxProviderClass;



class $38eec908de07002f$export$fcea9c441fb00ad4 extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    init$ = {
        ...this.init$,
        visible: false,
        value: 0,
        "*commonProgress": 0
    };
    initCallback() {
        super.initCallback();
        /** @private */ this._unobserveCollection = this.uploadCollection.observeProperties(()=>{
            let anyUploading = this.uploadCollection.items().some((id)=>{
                let item = this.uploadCollection.read(id);
                return item.getValue("isUploading");
            });
            this.$.visible = anyUploading;
        });
        this.sub("visible", (visible)=>{
            if (visible) this.setAttribute("active", "");
            else this.removeAttribute("active");
        });
        this.sub("*commonProgress", (progress)=>{
            this.$.value = progress;
        });
    }
    destroyCallback() {
        super.destroyCallback();
        this._unobserveCollection?.();
    }
}
$38eec908de07002f$export$fcea9c441fb00ad4.template = /* HTML */ ` <uc-progress-bar set="visible: visible; value: value"></uc-progress-bar> `;



class $1f9a758bf5929e11$export$c17561cb55d4db30 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    /** @type {Number} */ _value = 0;
    /** @type {Boolean} */ _visible = true;
    init$ = {
        ...this.init$,
        width: 0,
        opacity: 0
    };
    initCallback() {
        super.initCallback();
        this.defineAccessor("value", (value)=>{
            if (value === undefined || value === null) return;
            const prevValue = this._value;
            this._value = value;
            if (!this._visible) return;
            if (value === 100) this.ref.realProgressLine.addEventListener("transitionend", ()=>{
                this.ref.realProgressLine.classList.toggle("uc-progress--hidden", true);
            }, {
                once: true
            });
            this.ref.fakeProgressLine.classList.toggle("uc-fake-progress--hidden", value !== 0);
            if (value === 0 && prevValue > 0) {
                this.ref.realProgressLine.addEventListener("transitionend", ()=>{
                    this.style.setProperty("--l-progress-value", this._value.toString());
                }, {
                    once: true
                });
                return;
            }
            this.style.setProperty("--l-progress-value", this._value.toString());
        });
        this.defineAccessor("visible", (visible)=>{
            this._visible = visible;
            this.ref.realProgressLine.classList.toggle("uc-progress--hidden", !visible);
            this.ref.fakeProgressLine.classList.toggle("uc-fake-progress--hidden", !visible);
        });
    }
}
$1f9a758bf5929e11$export$c17561cb55d4db30.template = /* HTML */ `
  <div ref="fakeProgressLine" class="uc-fake-progress"></div>
  <div ref="realProgressLine" class="uc-progress"></div>
`;


var $2c4c0ec5840d1e53$exports = {};
var $ebc5de99b36543b0$exports = {};

$parcel$export($ebc5de99b36543b0$exports, "CloudImageEditorBlock", () => $1bdc7ce1b3bbbe34$export$20cace3f5dd477e2);
$parcel$export($ebc5de99b36543b0$exports, "CropFrame", () => $5486109c88d5117e$export$eaec7dd192dada87);
$parcel$export($ebc5de99b36543b0$exports, "EditorCropButtonControl", () => $77a867df28174d0f$export$603075e7d8e604b2);
$parcel$export($ebc5de99b36543b0$exports, "EditorFilterControl", () => $46600dc7b4eceb17$export$1cf4b09278d815ee);
$parcel$export($ebc5de99b36543b0$exports, "EditorOperationControl", () => $449306e34b30b9de$export$cf5be688aafa2355);
$parcel$export($ebc5de99b36543b0$exports, "EditorImageCropper", () => $c5c6bc81c5e4a020$export$fc01d462d57ea6e6);
$parcel$export($ebc5de99b36543b0$exports, "EditorImageFader", () => $04b4249620c794c0$export$15eaf4dbf84459f1);
$parcel$export($ebc5de99b36543b0$exports, "EditorScroller", () => $ab0d3e8cd08c1c00$export$88b72cf03cc30a69);
$parcel$export($ebc5de99b36543b0$exports, "EditorSlider", () => $68b946db693b9392$export$9ab173fa70108ef4);
$parcel$export($ebc5de99b36543b0$exports, "EditorToolbar", () => $2a5cd161e857b06c$export$477aaffea178bc4e);
$parcel$export($ebc5de99b36543b0$exports, "BtnUi", () => $173af55bf5b45a90$export$6cf5cd50acea2c);
$parcel$export($ebc5de99b36543b0$exports, "LineLoaderUi", () => $3f26b9d84520c5bc$export$21cd7d08dbb08eff);
$parcel$export($ebc5de99b36543b0$exports, "PresenceToggle", () => $ac3e7306634bae8b$export$62b432f031007740);
$parcel$export($ebc5de99b36543b0$exports, "SliderUi", () => $d441ef962450dfc1$export$facfb944826701a2);
// @ts-check


const $eb84090877b938d3$export$67da346bbbd9b9d4 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";



function $859d48a3f3b9ecf3$var$normalize(...args) {
    return args.reduce((result, arg)=>{
        if (typeof arg === "string") {
            result[arg] = true;
            return result;
        }
        for (let token of Object.keys(arg))result[token] = arg[token];
        return result;
    }, {});
}
function $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff(...args) {
    let mapping = $859d48a3f3b9ecf3$var$normalize(...args);
    return Object.keys(mapping).reduce((result, token)=>{
        if (mapping[token]) result.push(token);
        return result;
    }, []).join(" ");
}
function $859d48a3f3b9ecf3$export$7efcd118c973e827(element, ...args) {
    let mapping = $859d48a3f3b9ecf3$var$normalize(...args);
    for (let token of Object.keys(mapping))element.classList.toggle(token, mapping[token]);
}



// @ts-check


const $5ac7ce755b69514d$export$26e282a18fc21889 = (tabs)=>{
    if (!tabs) return 0, $8b84db27cd8d65ab$export$d9a4cca3740decc7;
    const tabList = (0, $cf5145deda9036ee$export$7a086f785998e32e)(tabs).filter((tab)=>(0, $8b84db27cd8d65ab$export$d9a4cca3740decc7).includes(tab));
    if (tabList.length === 0) return 0, $8b84db27cd8d65ab$export$d9a4cca3740decc7;
    return tabList;
};



// @ts-check





function $a2965dd206c13984$export$f6196a6c6bb539b4(fnCtx) {
    return {
        "*originalUrl": null,
        "*faderEl": null,
        "*cropperEl": null,
        "*imgEl": null,
        "*imgContainerEl": null,
        "*networkProblems": false,
        "*imageSize": null,
        /** @type {import('./types.js').Transformations} */ "*editorTransformations": {},
        /** @type {import('./types.js').CropPresetList} */ "*cropPresetList": [],
        "*tabList": (0, $8b84db27cd8d65ab$export$d9a4cca3740decc7),
        "*tabId": (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).CROP,
        entry: null,
        extension: null,
        editorMode: false,
        modalCaption: "",
        isImage: false,
        msg: "",
        src: (0, $eb84090877b938d3$export$67da346bbbd9b9d4),
        fileType: "",
        showLoader: false,
        // options
        uuid: null,
        cdnUrl: null,
        cropPreset: "",
        tabs: (0, $cf5145deda9036ee$export$1494b4974e65fb4e)((0, $8b84db27cd8d65ab$export$d9a4cca3740decc7)),
        "presence.networkProblems": false,
        "presence.modalCaption": true,
        "presence.editorToolbar": false,
        "presence.viewerToolbar": true,
        // TODO: beware of wrong ctx in case of element re-creation:
        "*on.retryNetwork": ()=>{
            let images = fnCtx.querySelectorAll("img");
            for (let img of images){
                let originalSrc = img.src;
                img.src = (0, $eb84090877b938d3$export$67da346bbbd9b9d4);
                img.src = originalSrc;
            }
            fnCtx.$["*networkProblems"] = false;
        },
        /** @param {import('./types.js').Transformations} transformations */ "*on.apply": (transformations)=>{
            if (!transformations) return;
            let originalUrl = fnCtx.$["*originalUrl"];
            let cdnUrlModifiers = (0, $8c66713b0e57faf9$export$8fb94a7da5f60007)((0, $429f8fe70c0477d1$export$d901e4e307b689de)(transformations), "preview");
            let cdnUrl = (0, $8c66713b0e57faf9$export$226a37372a69410c)(originalUrl, cdnUrlModifiers);
            /** @type {import('./types.js').ApplyResult} */ let eventData = {
                originalUrl: originalUrl,
                cdnUrlModifiers: cdnUrlModifiers,
                cdnUrl: cdnUrl,
                transformations: transformations
            };
            fnCtx.dispatchEvent(new CustomEvent("apply", {
                detail: eventData,
                bubbles: true,
                composed: true
            }));
            fnCtx.remove();
        },
        "*on.cancel": ()=>{
            fnCtx.remove();
            fnCtx.dispatchEvent(new CustomEvent("cancel", {
                bubbles: true,
                composed: true
            }));
        }
    };
}



var $955108173dc824ec$export$2e2bcd8739ae039 = "<svg width='0' height='0' style='position:absolute'><symbol viewBox='0 0 20 20' id='uc-icon-brightness' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M15 10a5 5 0 0 1-5 5m5-5a5 5 0 0 0-5-5m5 5h-5m0 5a5 5 0 0 1 0-10m0 10V5m0 15v-3M2.93 2.929 5.05 5.05M0 10h3m-.07 7.071 2.12-2.121M10 0v3m7.07 14.071-2.12-2.121M20 10h-3m.07-7.071L14.95 5.05m-.626 2.45H10m4.324 5H10'/></symbol><symbol fill='currentColor' viewBox='0 0 20 20' id='uc-icon-closeMax' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M8.232 10 3.585 5.353l1.768-1.768L10 8.232l4.648-4.647 1.767 1.768L11.768 10l4.647 4.648-1.767 1.767L10 11.768l-4.647 4.647-1.768-1.767L8.232 10Z' clip-rule='evenodd'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-contrast' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M2 10a8 8 0 1 0 16 0 8 8 0 1 0-16 0m8-8v16m8-8h-8m7.598 2.5H10m6.24 2.5H10m7.6-7.5H10M16.242 5H10'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-crop' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M20 14H7.005C6.45 14 6 13.55 6 12.995V0M0 6h13.067c.515 0 .933.418.933.933V20M14.5.4 13 2l1.5 1.6M13 2h2a3 3 0 0 1 3 3v2M5.5 19.6 7 18l-1.5-1.6M7 18H5a3 3 0 0 1-3-3v-2'/></symbol><symbol fill='currentColor' viewBox='0 0 20 20' id='uc-icon-done' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='m18.057 6.333-9.365 9.125a1.25 1.25 0 0 1-1.768-.023L1.92 10.296l1.791-1.744 4.132 4.243 8.47-8.253 1.744 1.79Z' clip-rule='evenodd'/></symbol><symbol fill='currentColor' viewBox='0 0 25 24' id='uc-icon-edit-file' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' d='M18.558 2.804a.78.78 0 0 0-.557.235l-.008.007-2.472 2.46 3.847 3.848 2.46-2.473.004-.003a.78.78 0 0 0 0-1.108l-.004-.003-2.712-2.728a.78.78 0 0 0-.558-.235Zm-.248 7.613-3.852-3.852-8.93 8.887-1.516 5.41 5.41-1.515 8.888-8.93Zm-.636-8.934a2.28 2.28 0 0 1 2.512.505l2.702 2.717.002.002a2.278 2.278 0 0 1 0 3.234l-.002.002-12.541 12.602a.75.75 0 0 1-.33.193l-6.884 1.928a.75.75 0 0 1-.925-.924l1.928-6.885a.75.75 0 0 1 .193-.33l12.603-12.54a2.28 2.28 0 0 1 .742-.504Z' clip-rule='evenodd'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-enhance' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M19 13h-2m0 0a4 4 0 0 1-4-4m4 4a4 4 0 0 0-4 4m0-8V7m0 2a4 4 0 0 1-4 4m-2 0h2m0 0a4 4 0 0 1 4 4m0 0v2M8 8.5H6.5m0 0a2 2 0 0 1-2-2m2 2a2 2 0 0 0-2 2m0-4V5m0 1.5a2 2 0 0 1-2 2M1 8.5h1.5m0 0a2 2 0 0 1 2 2m0 0V12M12 3h-1m0 0a1 1 0 0 1-1-1m1 1a1 1 0 0 0-1 1m0-2V1m0 1a1 1 0 0 1-1 1M8 3h1m0 0a1 1 0 0 1 1 1m0 0v1'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-exposure' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M10 20v-3M2.93 2.929 5.05 5.05M0 10h3m-.07 7.071 2.12-2.121M10 0v3m7.07 14.071-2.12-2.121M20 10h-3m.07-7.071L14.95 5.05M5 10a5 5 0 1 0 10 0 5 5 0 1 0-10 0'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-filters' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M4.5 6.5a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0m-3.5 6a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0m7 0a5.5 5.5 0 1 0 11 0 5.5 5.5 0 1 0-11 0'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-flip' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M19.6 5 18 3.5 16.4 5m3.2 10L18 16.5 16.4 15M18 3.523v12.954M3.3 8.5h10.654c.301 0 .415-.395.159-.554L3.459 1.286A.3.3 0 0 0 3 1.542V8.2a.3.3 0 0 0 .3.3zm0 3h10.654c.301 0 .415.395.159.554l-10.654 6.66A.3.3 0 0 1 3 18.458v-6.66a.3.3 0 0 1 .3-.3z'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-gamma' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M17 3C9 6 2.5 11.5 2.5 17.5m0 0h1m-1 0v-1m14 1h1m-3 0h1m-3 0h1m-3 0h1m-3 0h1m-3 0h1m-3 0h1m-3-14v-1m0 3v-1m0 3v-1m0 3v-1m0 3v-1m0 3v-1m0 3v-1'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-mirror' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M5 .4 3.5 2 5 3.6M15 .4 16.5 2 15 3.6M3.52 2h12.957M8.5 16.7V6.046c0-.301-.394-.415-.554-.159L1.287 16.541a.3.3 0 0 0 .255.459H8.2a.3.3 0 0 0 .3-.3zm3 0V6.046c0-.301.395-.415.555-.159l6.659 10.654a.3.3 0 0 1-.255.459H11.8a.3.3 0 0 1-.3-.3z'/></symbol><symbol viewBox='0 0 40 40' id='uc-icon-original' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.5' d='M0 40 40 0'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-rotate' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M13.5.4 12 2l1.5 1.6M12.023 2H14.4A3.6 3.6 0 0 1 18 5.6V8M4 17h9a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1z'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-sad' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M2 17c4.418-4 11.582-4 16 0M16.5 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-11 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-saturation' xmlns='http://www.w3.org/2000/svg'><defs><linearGradient id='puc-icon-id__a' x1='10.001' y1='1' x2='10.001' y2='19' gradientUnits='userSpaceOnUse'><stop stop-color='#DE15FF'/><stop offset='.203' stop-color='#0029FF'/><stop offset='.479' stop-color='#2AE4F0'/><stop offset='.604' stop-color='#15EF11'/><stop offset='.75' stop-color='#FAE528'/><stop offset='1' stop-color='#EB2A2A'/></linearGradient></defs><circle cx='10.001' cy='10' r='9' transform='rotate(90 10 10)' fill='url(#puc-icon-id__a)'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-slider' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M0 10h11m0 0a2 2 0 1 0 4 0m-4 0a2 2 0 1 1 4 0m0 0h5'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-tuning' xmlns='http://www.w3.org/2000/svg'><path stroke-linejoin='round' fill='none' stroke='currentColor' stroke-width='1.2' d='M8 10h11M1 10h4M1 4.5h11m3 0h4m-18 11h11m3 0h4m-7-11a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0M5 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0m7 5.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0'/></symbol><symbol viewBox='0 0 20 20' id='uc-icon-vibrance' xmlns='http://www.w3.org/2000/svg'><path d='M2.125 5.64A8.96 8.96 0 0 0 1.001 10a8.96 8.96 0 0 0 1.124 4.36V5.64z' fill='url(#suc-icon-id__a)'/><path d='M2.875 15.499V4.502a9.053 9.053 0 0 1 1.75-1.72v14.437a9.05 9.05 0 0 1-1.75-1.72z' fill='url(#suc-icon-id__b)'/><path d='M5.375 17.722c.548.33 1.134.601 1.75.809V1.469a8.956 8.956 0 0 0-1.75.81v15.443z' fill='url(#suc-icon-id__c)'/><path d='M7.875 1.253v17.495c.564.136 1.15.22 1.75.244V1.008a9 9 0 0 0-1.75.245z' fill='url(#suc-icon-id__d)'/><path d='M10.375 1.008v17.984a9 9 0 0 0 1.75-.244V1.252a9 9 0 0 0-1.75-.244z' fill='url(#suc-icon-id__e)'/><path d='M12.875 1.469V18.53a8.957 8.957 0 0 0 1.75-.808V2.277a8.957 8.957 0 0 0-1.75-.808z' fill='url(#suc-icon-id__f)'/><path d='M15.375 2.78v14.44a9.053 9.053 0 0 0 1.75-1.72v-11a9.054 9.054 0 0 0-1.75-1.72z' fill='url(#suc-icon-id__g)'/><path d='M17.875 5.638v8.724A8.959 8.959 0 0 0 19.001 10a8.96 8.96 0 0 0-1.126-4.362z' fill='url(#suc-icon-id__h)'/><defs><linearGradient id='suc-icon-id__a' x1='19.001' y1='10' x2='1.001' y2='10' gradientUnits='userSpaceOnUse'><stop stop-color='#DE15FF'/><stop offset='.203' stop-color='#0029FF'/><stop offset='.479' stop-color='#2AE4F0'/><stop offset='.604' stop-color='#15EF11'/><stop offset='.75' stop-color='#FAE528'/><stop offset='1' stop-color='#EB2A2A'/></linearGradient><linearGradient id='suc-icon-id__b' x1='19.001' y1='10' x2='1.001' y2='10' gradientUnits='userSpaceOnUse'><stop stop-color='#DE15FF'/><stop offset='.203' stop-color='#0029FF'/><stop offset='.479' stop-color='#2AE4F0'/><stop offset='.604' stop-color='#15EF11'/><stop offset='.75' stop-color='#FAE528'/><stop offset='1' stop-color='#EB2A2A'/></linearGradient><linearGradient id='suc-icon-id__c' x1='19.001' y1='10' x2='1.001' y2='10' gradientUnits='userSpaceOnUse'><stop stop-color='#DE15FF'/><stop offset='.203' stop-color='#0029FF'/><stop offset='.479' stop-color='#2AE4F0'/><stop offset='.604' stop-color='#15EF11'/><stop offset='.75' stop-color='#FAE528'/><stop offset='1' stop-color='#EB2A2A'/></linearGradient><linearGradient id='suc-icon-id__d' x1='19.001' y1='10' x2='1.001' y2='10' gradientUnits='userSpaceOnUse'><stop stop-color='#DE15FF'/><stop offset='.203' stop-color='#0029FF'/><stop offset='.479' stop-color='#2AE4F0'/><stop offset='.604' stop-color='#15EF11'/><stop offset='.75' stop-color='#FAE528'/><stop offset='1' stop-color='#EB2A2A'/></linearGradient><linearGradient id='suc-icon-id__e' x1='19.001' y1='10' x2='1.001' y2='10' gradientUnits='userSpaceOnUse'><stop stop-color='#DE15FF'/><stop offset='.203' stop-color='#0029FF'/><stop offset='.479' stop-color='#2AE4F0'/><stop offset='.604' stop-color='#15EF11'/><stop offset='.75' stop-color='#FAE528'/><stop offset='1' stop-color='#EB2A2A'/></linearGradient><linearGradient id='suc-icon-id__f' x1='19.001' y1='10' x2='1.001' y2='10' gradientUnits='userSpaceOnUse'><stop stop-color='#DE15FF'/><stop offset='.203' stop-color='#0029FF'/><stop offset='.479' stop-color='#2AE4F0'/><stop offset='.604' stop-color='#15EF11'/><stop offset='.75' stop-color='#FAE528'/><stop offset='1' stop-color='#EB2A2A'/></linearGradient><linearGradient id='suc-icon-id__g' x1='19.001' y1='10' x2='1.001' y2='10' gradientUnits='userSpaceOnUse'><stop stop-color='#DE15FF'/><stop offset='.203' stop-color='#0029FF'/><stop offset='.479' stop-color='#2AE4F0'/><stop offset='.604' stop-color='#15EF11'/><stop offset='.75' stop-color='#FAE528'/><stop offset='1' stop-color='#EB2A2A'/></linearGradient><linearGradient id='suc-icon-id__h' x1='19.001' y1='10' x2='1.001' y2='10' gradientUnits='userSpaceOnUse'><stop stop-color='#DE15FF'/><stop offset='.203' stop-color='#0029FF'/><stop offset='.479' stop-color='#2AE4F0'/><stop offset='.604' stop-color='#15EF11'/><stop offset='.75' stop-color='#FAE528'/><stop offset='1' stop-color='#EB2A2A'/></linearGradient></defs></symbol><symbol viewBox='0 0 20 20' id='uc-icon-warmth' xmlns='http://www.w3.org/2000/svg'><path d='m7.5 13.05.429.42.171-.175v-.244h-.6zm5 0h-.6v.245l.172.175.428-.42zM8.1 3.5c0-1.05.85-1.9 1.9-1.9V.4a3.1 3.1 0 0 0-3.1 3.1h1.2zm0 9.55V3.5H6.9v9.55h1.2zm-1 2.45c0-.79.315-1.506.829-2.03l-.858-.84A4.088 4.088 0 0 0 5.9 15.5h1.2zm2.9 2.9a2.9 2.9 0 0 1-2.9-2.9H5.9a4.1 4.1 0 0 0 4.1 4.1v-1.2zm2.9-2.9a2.9 2.9 0 0 1-2.9 2.9v1.2a4.1 4.1 0 0 0 4.1-4.1h-1.2zm-.829-2.03c.514.524.829 1.24.829 2.03h1.2c0-1.117-.447-2.13-1.171-2.87l-.858.84zM11.9 3.5v9.55h1.2V3.5h-1.2zM10 1.6c1.05 0 1.9.85 1.9 1.9h1.2A3.1 3.1 0 0 0 10 .4v1.2z' fill='currentColor'/><path d='M10 14V8' stroke='currentColor' stroke-width='1.2' stroke-linecap='round'/><path d='M14 3h3m-3 3h3m-3 3h3m-8 6.5a1 1 0 1 0 2 0 1 1 0 1 0-2 0' stroke='currentColor' stroke-width='1.2'/></symbol></svg>";


const $93bc66bfb1ebf637$export$b3167c59aca35da5 = /* HTML */ `
  ${(0, $955108173dc824ec$export$2e2bcd8739ae039)}
  <div class="uc-wrapper uc-wrapper_desktop">
    <uc-presence-toggle class="uc-network_problems_splash" set="visible: presence.networkProblems;">
      <div class="uc-network_problems_content">
        <div class="uc-network_problems_icon">
          <uc-icon name="sad"></uc-icon>
        </div>
        <div class="uc-network_problems_text">Network error</div>
      </div>
      <div class="uc-network_problems_footer">
        <uc-btn-ui theme="primary" text="Retry" set="onclick: *on.retryNetwork"></uc-btn-ui>
      </div>
    </uc-presence-toggle>
    <div class="uc-viewport">
      <div class="uc-file_type_outer">
        <div class="uc-file_type">{{fileType}}</div>
      </div>
      <div class="uc-image_container" ref="img-container-el">
        <img src="${(0, $eb84090877b938d3$export$67da346bbbd9b9d4)}" class="uc-image uc-image_visible_from_editor" ref="img-el" />
        <uc-editor-image-cropper ref="cropper-el"></uc-editor-image-cropper>
        <uc-editor-image-fader ref="fader-el"></uc-editor-image-fader>
      </div>
      <div class="uc-info_pan">{{msg}}</div>
    </div>
    <div class="uc-toolbar">
      <uc-line-loader-ui set="active: showLoader"></uc-line-loader-ui>
      <div class="uc-toolbar_content uc-toolbar_content__editor">
        <uc-editor-toolbar></uc-editor-toolbar>
      </div>
    </div>
  </div>
`;



class $1bdc7ce1b3bbbe34$export$20cace3f5dd477e2 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    ctxOwner = true;
    static styleAttrs = [
        "uc-cloud-image-editor"
    ];
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            ...(0, $a2965dd206c13984$export$f6196a6c6bb539b4)(this)
        };
    }
    /** @private */ _debouncedShowLoader = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(this._showLoader.bind(this), 300);
    /**
   * @private
   * @param {boolean} show
   */ _showLoader(show) {
        this.$.showLoader = show;
    }
    /**
   * To proper work, we need non-zero size the element. So, we'll wait for it.
   *
   * @private
   * @returns {Promise<void>}
   */ _waitForSize() {
        const TIMEOUT = 3000;
        return new Promise((resolve, reject)=>{
            const timeoutId = setTimeout(()=>{
                reject(new Error("[cloud-image-editor] timeout waiting for non-zero container size"));
            }, TIMEOUT);
            const resizeObserver = new ResizeObserver(([element])=>{
                if (element.contentRect.width > 0 && element.contentRect.height > 0) {
                    resolve();
                    clearTimeout(timeoutId);
                    resizeObserver.disconnect();
                }
            });
            resizeObserver.observe(this);
        });
    }
    initCallback() {
        super.initCallback();
        this.$["*faderEl"] = this.ref["fader-el"];
        this.$["*cropperEl"] = this.ref["cropper-el"];
        this.$["*imgContainerEl"] = this.ref["img-container-el"];
        this.initEditor();
    }
    async updateImage() {
        if (!this.isConnected) return;
        await this._waitForSize();
        if (this.$.cdnUrl) {
            const uuid = (0, $8c66713b0e57faf9$export$fe804a22e4bdd033)(this.$.cdnUrl);
            const originalUrl = (0, $8c66713b0e57faf9$export$816ae8f9591f1ab2)(this.$.cdnUrl, uuid);
            if (originalUrl === this.$["*originalUrl"]) return;
            this.$["*originalUrl"] = originalUrl;
            const operations = (0, $8c66713b0e57faf9$export$6ae4b875b9f5125)(this.$.cdnUrl);
            const transformations = (0, $429f8fe70c0477d1$export$df8366105975a86f)(operations);
            this.$["*editorTransformations"] = transformations;
        } else if (this.$.uuid) {
            const originalUrl = (0, $8c66713b0e57faf9$export$816ae8f9591f1ab2)(this.cfg.cdnCname, this.$.uuid);
            if (originalUrl === this.$["*originalUrl"]) return;
            this.$["*originalUrl"] = originalUrl;
            this.$["*editorTransformations"] = {};
        } else throw new Error("No UUID nor CDN URL provided");
        if (this.$["*tabId"] === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).CROP) this.$["*cropperEl"].deactivate({
            reset: true
        });
        else this.$["*faderEl"].deactivate();
        try {
            const cdnUrl = await this.proxyUrl((0, $8c66713b0e57faf9$export$226a37372a69410c)(this.$["*originalUrl"], (0, $8c66713b0e57faf9$export$8fb94a7da5f60007)("json")));
            const json = await fetch(cdnUrl).then((response)=>response.json());
            const { width: width, height: height } = /** @type {{ width: number; height: number }} */ json;
            this.$["*imageSize"] = {
                width: width,
                height: height
            };
            if (this.$["*tabId"] === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).CROP) this.$["*cropperEl"].activate(this.$["*imageSize"]);
            else this.$["*faderEl"].activate({
                url: this.$["*originalUrl"]
            });
        } catch (err) {
            if (err) console.error("Failed to load image info", err);
        }
    }
    async initEditor() {
        try {
            await this._waitForSize();
        } catch (err) {
            if (this.isConnected) // @ts-ignore TODO: fix this
            console.error(err.message);
            return;
        }
        this.ref["img-el"].addEventListener("load", ()=>{
            this._imgLoading = false;
            this._debouncedShowLoader(false);
            if (this.$.src !== (0, $eb84090877b938d3$export$67da346bbbd9b9d4)) this.$["*networkProblems"] = false;
        });
        this.ref["img-el"].addEventListener("error", ()=>{
            this._imgLoading = false;
            this._debouncedShowLoader(false);
            this.$["*networkProblems"] = true;
        });
        this.sub("src", (src)=>{
            let el = this.ref["img-el"];
            if (el.src !== src) {
                this._imgLoading = true;
                el.src = src || (0, $eb84090877b938d3$export$67da346bbbd9b9d4);
            }
        });
        this.sub("cropPreset", (val)=>{
            this.$["*cropPresetList"] = (0, $cdbc5d9b903cbec9$export$a99f8a1d2eae458)(val);
        });
        this.sub("tabs", /** @param {string} val */ (val)=>{
            this.$["*tabList"] = (0, $5ac7ce755b69514d$export$26e282a18fc21889)(val);
        });
        this.sub("*tabId", (tabId)=>{
            this.ref["img-el"].className = (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)("uc-image", {
                "uc-image_hidden_to_cropper": tabId === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).CROP,
                "uc-image_hidden_effects": tabId !== (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).CROP
            });
        });
        this.classList.add("uc-editor_ON");
        this.sub("*networkProblems", (networkProblems)=>{
            this.$["presence.networkProblems"] = networkProblems;
            this.$["presence.modalCaption"] = !networkProblems;
        });
        this.sub("*editorTransformations", (transformations)=>{
            if (Object.keys(transformations).length === 0) return;
            let originalUrl = this.$["*originalUrl"];
            let cdnUrlModifiers = (0, $8c66713b0e57faf9$export$8fb94a7da5f60007)((0, $429f8fe70c0477d1$export$d901e4e307b689de)(transformations), "preview");
            let cdnUrl = (0, $8c66713b0e57faf9$export$226a37372a69410c)(originalUrl, cdnUrlModifiers);
            /** @type {import('./types.js').ApplyResult} */ let eventData = {
                originalUrl: originalUrl,
                cdnUrlModifiers: cdnUrlModifiers,
                cdnUrl: cdnUrl,
                transformations: transformations
            };
            this.dispatchEvent(new CustomEvent("change", {
                detail: eventData,
                bubbles: true,
                composed: true
            }));
        }, false);
        this.sub("uuid", (val)=>val && this.updateImage());
        this.sub("cdnUrl", (val)=>val && this.updateImage());
    }
}
$1bdc7ce1b3bbbe34$export$20cace3f5dd477e2.template = (0, $93bc66bfb1ebf637$export$b3167c59aca35da5);
$1bdc7ce1b3bbbe34$export$20cace3f5dd477e2.bindAttributes({
    uuid: "uuid",
    "cdn-url": "cdnUrl",
    "crop-preset": "cropPreset",
    tabs: "tabs"
});


// @ts-check




class $5486109c88d5117e$export$eaec7dd192dada87 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            dragging: false
        };
        /** @private */ this._handlePointerUp = this._handlePointerUp_.bind(this);
        /** @private */ this._handlePointerMove = this._handlePointerMove_.bind(this);
        /** @private */ this._handleSvgPointerMove = this._handleSvgPointerMove_.bind(this);
    }
    /**
   * @private
   * @param {import('./types.js').Direction} direction
   */ _shouldThumbBeDisabled(direction) {
        let imageBox = this.$["*imageBox"];
        if (!imageBox) return;
        if (direction === "" && imageBox.height <= (0, $c1f033c89897f5fc$export$9c132ec810e22d8a) && imageBox.width <= (0, $c1f033c89897f5fc$export$9c132ec810e22d8a)) return true;
        let tooHigh = imageBox.height <= (0, $c1f033c89897f5fc$export$9c132ec810e22d8a) && (direction.includes("n") || direction.includes("s"));
        let tooWide = imageBox.width <= (0, $c1f033c89897f5fc$export$9c132ec810e22d8a) && (direction.includes("e") || direction.includes("w"));
        return tooHigh || tooWide;
    }
    /** @private */ _createBackdrop() {
        /** @type {import('./types.js').Rectangle} */ let cropBox = this.$["*cropBox"];
        if (!cropBox) return;
        let { x: x, y: y, width: width, height: height } = cropBox;
        let svg = this.ref["svg-el"];
        let mask = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("mask", {
            id: "backdrop-mask"
        });
        let maskRectOuter = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("rect", {
            x: 0,
            y: 0,
            width: "100%",
            height: "100%",
            fill: "white"
        });
        let maskRectInner = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("rect", {
            x: x,
            y: y,
            width: width,
            height: height,
            fill: "black"
        });
        mask.appendChild(maskRectOuter);
        mask.appendChild(maskRectInner);
        let backdropRect = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("rect", {
            x: 0,
            y: 0,
            width: "100%",
            height: "100%",
            fill: "var(--color-image-background)",
            "fill-opacity": 0.85,
            mask: "url(#backdrop-mask)"
        });
        svg.appendChild(backdropRect);
        svg.appendChild(mask);
        this._backdropMask = mask;
        this._backdropMaskInner = maskRectInner;
    }
    /**
   * @private Super Tricky workaround for the chromium bug See
   *   https://bugs.chromium.org/p/chromium/issues/detail?id=330815
   */ _resizeBackdrop() {
        if (!this._backdropMask) return;
        this._backdropMask.style.display = "none";
        window.requestAnimationFrame(()=>{
            if (this._backdropMask) this._backdropMask.style.display = "block";
        });
    }
    /** @private */ _updateBackdrop() {
        /** @type {import('./types.js').Rectangle} */ let cropBox = this.$["*cropBox"];
        if (!cropBox) return;
        let { x: x, y: y, width: width, height: height } = cropBox;
        this._backdropMaskInner && (0, $ec2c5c3a08a9901b$export$54374d41e42e9676)(this._backdropMaskInner, {
            x: x,
            y: y,
            width: width,
            height: height
        });
    }
    /** @private */ _updateFrame() {
        /** @type {import('./types.js').Rectangle} */ let cropBox = this.$["*cropBox"];
        if (!cropBox || !this._frameGuides || !this._frameThumbs) return;
        for (let thumb of Object.values(this._frameThumbs)){
            let { direction: direction, pathNode: pathNode, interactionNode: interactionNode, groupNode: groupNode } = thumb;
            let isCenter = direction === "";
            let isCorner = direction.length === 2;
            let { x: x, y: y, width: width, height: height } = cropBox;
            if (isCenter) {
                const moveThumbRect = {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                };
                (0, $ec2c5c3a08a9901b$export$54374d41e42e9676)(interactionNode, moveThumbRect);
            } else {
                const thumbSizeMultiplier = (0, $ec2c5c3a08a9901b$export$7d15b64cf5a3a4c4)(Math.min(width, height) / ((0, $c1f033c89897f5fc$export$b69960716b5f670f) * 2 + (0, $c1f033c89897f5fc$export$df6c1d4a19114db4)) / 2, 0, 1);
                let { d: d, center: center } = isCorner ? (0, $ec2c5c3a08a9901b$export$790b609df538a7dd)(cropBox, direction, thumbSizeMultiplier) : (0, $ec2c5c3a08a9901b$export$7b179e18f4ee631a)(cropBox, /** @type {Extract<import('./types.js').Direction, 'n' | 's' | 'w' | 'e'>} */ direction, thumbSizeMultiplier);
                const size = Math.max((0, $c1f033c89897f5fc$export$2950b0064b6e4e77) * (0, $ec2c5c3a08a9901b$export$7d15b64cf5a3a4c4)(Math.min(width, height) / (0, $c1f033c89897f5fc$export$2950b0064b6e4e77) / 3, 0, 1), (0, $c1f033c89897f5fc$export$d00854ad80ddb8a1));
                (0, $ec2c5c3a08a9901b$export$54374d41e42e9676)(interactionNode, {
                    x: center[0] - size,
                    y: center[1] - size,
                    width: size * 2,
                    height: size * 2
                });
                (0, $ec2c5c3a08a9901b$export$54374d41e42e9676)(pathNode, {
                    d: d
                });
            }
            let disableThumb = this._shouldThumbBeDisabled(direction);
            groupNode.setAttribute("class", (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)("uc-thumb", {
                "uc-thumb--hidden": disableThumb,
                "uc-thumb--visible": !disableThumb
            }));
        }
        (0, $ec2c5c3a08a9901b$export$54374d41e42e9676)(this._frameGuides, {
            x: cropBox.x - (0, $c1f033c89897f5fc$export$1cf2b3e7100e85af) * 0.5,
            y: cropBox.y - (0, $c1f033c89897f5fc$export$1cf2b3e7100e85af) * 0.5,
            width: cropBox.width + (0, $c1f033c89897f5fc$export$1cf2b3e7100e85af),
            height: cropBox.height + (0, $c1f033c89897f5fc$export$1cf2b3e7100e85af)
        });
    }
    /**
   * @param {import('./types.js').FrameThumbs} frameThumbs
   * @param {import('./types.js').Direction} direction
   */ _createThumb(frameThumbs, direction) {
        let groupNode = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("g");
        groupNode.classList.add("uc-thumb");
        groupNode.setAttribute("with-effects", "");
        let interactionNode = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("rect", {
            fill: "transparent"
        });
        let pathNode = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("path", {
            stroke: "currentColor",
            fill: "none",
            "stroke-width": (0, $c1f033c89897f5fc$export$9fc5d1d39ca040ea)
        });
        groupNode.appendChild(pathNode);
        groupNode.appendChild(interactionNode);
        frameThumbs[direction] = {
            direction: direction,
            pathNode: pathNode,
            interactionNode: interactionNode,
            groupNode: groupNode
        };
        if (direction === "") groupNode.style.cursor = "move";
        interactionNode.addEventListener("pointerdown", this._handlePointerDown.bind(this, direction));
    }
    /** @private */ _createThumbs() {
        /** @type {import('./types.js').FrameThumbs} */ const frameThumbs = {};
        for(let i = 0; i < 3; i++)for(let j = 0; j < 3; j++){
            let direction = /** @type {import('./types.js').Direction} */ `${[
                "n",
                "",
                "s"
            ][i]}${[
                "w",
                "",
                "e"
            ][j]}`;
            if (direction === "") continue;
            this._createThumb(frameThumbs, direction);
        }
        this._createThumb(frameThumbs, "");
        return frameThumbs;
    }
    /** @private */ _createGuides() {
        let svg = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("svg");
        let rect = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("rect", {
            x: 0,
            y: 0,
            width: "100%",
            height: "100%",
            fill: "none",
            stroke: "currentColor",
            "stroke-width": (0, $c1f033c89897f5fc$export$1cf2b3e7100e85af),
            "stroke-opacity": 0.5
        });
        svg.appendChild(rect);
        for(let i = 1; i <= 2; i++){
            let line = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("line", {
                x1: `${(0, $c1f033c89897f5fc$export$f958e4635c8aa22c) * i}%`,
                y1: `0%`,
                x2: `${(0, $c1f033c89897f5fc$export$f958e4635c8aa22c) * i}%`,
                y2: `100%`,
                stroke: "currentColor",
                "stroke-width": (0, $c1f033c89897f5fc$export$1cf2b3e7100e85af),
                "stroke-opacity": 0.3
            });
            svg.appendChild(line);
        }
        for(let i = 1; i <= 2; i++){
            let line = (0, $ec2c5c3a08a9901b$export$183806b242873ed9)("line", {
                x1: `0%`,
                y1: `${(0, $c1f033c89897f5fc$export$f958e4635c8aa22c) * i}%`,
                x2: `100%`,
                y2: `${(0, $c1f033c89897f5fc$export$f958e4635c8aa22c) * i}%`,
                stroke: "currentColor",
                "stroke-width": (0, $c1f033c89897f5fc$export$1cf2b3e7100e85af),
                "stroke-opacity": 0.3
            });
            svg.appendChild(line);
        }
        svg.classList.add("uc-guides", "uc-guides--semi-hidden");
        return svg;
    }
    /** @private */ _createFrame() {
        let svg = this.ref["svg-el"];
        let fr = document.createDocumentFragment();
        let frameGuides = this._createGuides();
        fr.appendChild(frameGuides);
        let frameThumbs = this._createThumbs();
        for (let { groupNode: groupNode } of Object.values(frameThumbs))fr.appendChild(groupNode);
        svg.appendChild(fr);
        this._frameThumbs = frameThumbs;
        this._frameGuides = frameGuides;
    }
    /**
   * @private
   * @param {import('./types.js').Direction} direction
   * @param {PointerEvent} e
   */ _handlePointerDown(direction, e) {
        if (!this._frameThumbs) return;
        let thumb = this._frameThumbs[direction];
        if (this._shouldThumbBeDisabled(direction)) return;
        let cropBox = this.$["*cropBox"];
        let { x: svgX, y: svgY } = this.ref["svg-el"].getBoundingClientRect();
        let x = e.x - svgX;
        let y = e.y - svgY;
        this.$.dragging = true;
        this._draggingThumb = thumb;
        this._dragStartPoint = [
            x,
            y
        ];
        /** @type {import('./types.js').Rectangle} */ this._dragStartCrop = {
            ...cropBox
        };
    }
    /**
   * @private
   * @param {PointerEvent} e
   */ _handlePointerUp_(e) {
        this._updateCursor();
        if (!this.$.dragging) return;
        e.stopPropagation();
        e.preventDefault();
        this.$.dragging = false;
    }
    /**
   * @private
   * @param {PointerEvent} e
   */ _handlePointerMove_(e) {
        if (!this.$.dragging || !this._dragStartPoint || !this._draggingThumb) return;
        e.stopPropagation();
        e.preventDefault();
        let svg = this.ref["svg-el"];
        let { x: svgX, y: svgY } = svg.getBoundingClientRect();
        let x = e.x - svgX;
        let y = e.y - svgY;
        let dx = x - this._dragStartPoint[0];
        let dy = y - this._dragStartPoint[1];
        let { direction: direction } = this._draggingThumb;
        const movedCropBox = this._calcCropBox(direction, [
            dx,
            dy
        ]);
        if (movedCropBox) this.$["*cropBox"] = movedCropBox;
    }
    /**
   * @private
   * @param {import('./types.js').Direction} direction
   * @param {[Number, Number]} delta
   */ _calcCropBox(direction, delta) {
        const [dx, dy] = delta;
        /** @type {import('./types.js').Rectangle} */ let imageBox = this.$["*imageBox"];
        let rect = /** @type {import('./types.js').Rectangle} */ this._dragStartCrop ?? this.$["*cropBox"];
        /** @type {import('./types.js').CropPresetList[0]} */ const cropPreset = this.$["*cropPresetList"]?.[0];
        const aspectRatio = cropPreset ? cropPreset.width / cropPreset.height : undefined;
        if (direction === "") rect = (0, $ec2c5c3a08a9901b$export$88498a0045263460)({
            rect: rect,
            delta: [
                dx,
                dy
            ],
            imageBox: imageBox
        });
        else rect = (0, $ec2c5c3a08a9901b$export$7395518b474faf76)({
            rect: rect,
            delta: [
                dx,
                dy
            ],
            direction: direction,
            aspectRatio: aspectRatio,
            imageBox: imageBox
        });
        if (!Object.values(rect).every((number)=>Number.isFinite(number) && number >= 0)) {
            console.error("CropFrame is trying to create invalid rectangle", {
                payload: rect
            });
            return;
        }
        return (0, $ec2c5c3a08a9901b$export$25fd15ab86a7b28b)((0, $ec2c5c3a08a9901b$export$166e03518104bf21)(rect), this.$["*imageBox"]);
    }
    /**
   * @private
   * @param {PointerEvent} e
   */ _handleSvgPointerMove_(e) {
        if (!this._frameThumbs) return;
        let hoverThumb = Object.values(this._frameThumbs).find((thumb)=>{
            if (this._shouldThumbBeDisabled(thumb.direction)) return false;
            let node = thumb.interactionNode;
            let bounds = node.getBoundingClientRect();
            let rect = {
                x: bounds.x,
                y: bounds.y,
                width: bounds.width,
                height: bounds.height
            };
            let hover = (0, $ec2c5c3a08a9901b$export$ac4bbe5b05d4ed3f)(rect, [
                e.x,
                e.y
            ]);
            return hover;
        });
        this._hoverThumb = hoverThumb;
        this._updateCursor();
    }
    /** @private */ _updateCursor() {
        let hoverThumb = this._hoverThumb;
        this.ref["svg-el"].style.cursor = hoverThumb ? (0, $ec2c5c3a08a9901b$export$96239d218eb7ece8)(hoverThumb.direction) : "initial";
    }
    /** @private */ _render() {
        this._updateBackdrop();
        this._updateFrame();
    }
    /** @param {boolean} visible */ toggleThumbs(visible) {
        if (!this._frameThumbs) return;
        Object.values(this._frameThumbs).map(({ groupNode: groupNode })=>groupNode).forEach((groupNode)=>{
            groupNode.setAttribute("class", (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)("uc-thumb", {
                "uc-thumb--hidden": !visible,
                "uc-thumb--visible": visible
            }));
        });
    }
    initCallback() {
        super.initCallback();
        this._createBackdrop();
        this._createFrame();
        this.sub("*imageBox", ()=>{
            this._resizeBackdrop();
            window.requestAnimationFrame(()=>{
                this._render();
            });
        });
        this.sub("*cropBox", (cropBox)=>{
            if (!cropBox) return;
            this._guidesHidden = cropBox.height <= (0, $c1f033c89897f5fc$export$9c132ec810e22d8a) || cropBox.width <= (0, $c1f033c89897f5fc$export$9c132ec810e22d8a);
            window.requestAnimationFrame(()=>{
                this._render();
            });
        });
        this.sub("dragging", (dragging)=>{
            if (!this._frameGuides) return;
            this._frameGuides.setAttribute("class", (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)({
                "uc-guides--hidden": this._guidesHidden,
                "uc-guides--visible": !this._guidesHidden && dragging,
                "uc-guides--semi-hidden": !this._guidesHidden && !dragging
            }));
        });
        this.ref["svg-el"].addEventListener("pointermove", this._handleSvgPointerMove, true);
        document.addEventListener("pointermove", this._handlePointerMove, true);
        document.addEventListener("pointerup", this._handlePointerUp, true);
    }
    destroyCallback() {
        super.destroyCallback();
        document.removeEventListener("pointermove", this._handlePointerMove);
        document.removeEventListener("pointerup", this._handlePointerUp);
    }
}
$5486109c88d5117e$export$eaec7dd192dada87.template = /* HTML */ ` <svg class="uc-svg" ref="svg-el" xmlns="http://www.w3.org/2000/svg"></svg> `;




class $52177fcbd4cb5f4d$export$3aa7800404f83f6e extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    init$ = {
        ...this.init$,
        active: false,
        title: "",
        icon: "",
        "on.click": null,
        "title-prop": ""
    };
    initCallback() {
        super.initCallback();
        this._titleEl = this.ref["title-el"];
        this._iconEl = this.ref["icon-el"];
        this.sub("title", (title)=>{
            let titleEl = this._titleEl;
            if (titleEl) this._titleEl.style.display = title ? "block" : "none";
        });
        this.sub("active", (active)=>{
            this.className = (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)({
                "uc-active": active,
                "uc-not_active": !active
            });
        });
        this.sub("on.click", (onClick)=>{
            this.onclick = onClick;
        });
    }
}
$52177fcbd4cb5f4d$export$3aa7800404f83f6e.template = /* HTML */ `
  <button role="option" type="button" set="@aria-label:title-prop;" l10n="@title:title-prop;">
    <uc-icon set="@name: icon;"></uc-icon>
    <div class="uc-title" ref="title-el">{{title}}</div>
  </button>
`;


function $77a867df28174d0f$var$nextAngle(prev) {
    let angle = prev + 90;
    angle = angle >= 360 ? 0 : angle;
    return angle;
}
function $77a867df28174d0f$var$nextValue(operation, prev) {
    if (operation === "rotate") return $77a867df28174d0f$var$nextAngle(prev);
    if ([
        "mirror",
        "flip"
    ].includes(operation)) return !prev;
    return null;
}
class $77a867df28174d0f$export$603075e7d8e604b2 extends (0, $52177fcbd4cb5f4d$export$3aa7800404f83f6e) {
    initCallback() {
        super.initCallback();
        this.defineAccessor("operation", (operation)=>{
            if (!operation) return;
            /** @private */ this._operation = operation;
            this.$["icon"] = operation;
            this.bindL10n("title-prop", ()=>this.l10n("a11y-cloud-editor-apply-crop", {
                    name: this.l10n(operation).toLowerCase()
                }));
        });
        this.$["on.click"] = ()=>{
            let prev = this.$["*cropperEl"].getValue(this._operation);
            let next = $77a867df28174d0f$var$nextValue(this._operation, prev);
            this.$["*cropperEl"].setValue(this._operation, next);
        };
    }
}


// @ts-check




const $68b946db693b9392$var$ControlType = {
    FILTER: "filter",
    COLOR_OPERATION: "color_operation"
};
const $68b946db693b9392$export$e252352c431a3ba = "original";
class $68b946db693b9392$export$9ab173fa70108ef4 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    init$ = {
        ...this.init$,
        disabled: false,
        min: 0,
        max: 100,
        value: 0,
        defaultValue: 0,
        zero: 0,
        "on.input": (value)=>{
            this.$["*faderEl"].set(value);
            this.$.value = value;
        }
    };
    /**
   * @param {String} operation
   * @param {String} [filter]
   */ setOperation(operation, filter) {
        this._controlType = operation === "filter" ? $68b946db693b9392$var$ControlType.FILTER : $68b946db693b9392$var$ControlType.COLOR_OPERATION;
        this._operation = operation;
        this._iconName = operation;
        this._title = operation.toUpperCase();
        this._filter = filter;
        this._initializeValues();
        this.$["*faderEl"].activate({
            url: this.$["*originalUrl"],
            operation: this._operation,
            value: this._filter === $68b946db693b9392$export$e252352c431a3ba ? undefined : this.$.value,
            filter: this._filter === $68b946db693b9392$export$e252352c431a3ba ? undefined : this._filter,
            fromViewer: false
        });
    }
    /** @private */ _initializeValues() {
        let { range: range, zero: zero } = (0, $8b84db27cd8d65ab$export$e3dcdd21a8cd88f9)[this._operation];
        let [min, max] = range;
        this.$.min = min;
        this.$.max = max;
        this.$.zero = zero;
        let transformation = this.$["*editorTransformations"][this._operation];
        if (this._controlType === $68b946db693b9392$var$ControlType.FILTER) {
            let value = max;
            if (transformation) {
                let { name: name, amount: amount } = transformation;
                value = name === this._filter ? amount : max;
            }
            this.$.value = value;
            this.$.defaultValue = value;
        }
        if (this._controlType === $68b946db693b9392$var$ControlType.COLOR_OPERATION) {
            let value = typeof transformation !== "undefined" ? transformation : zero;
            this.$.value = value;
            this.$.defaultValue = value;
        }
    }
    apply() {
        let operationValue;
        if (this._controlType === $68b946db693b9392$var$ControlType.FILTER) {
            if (this._filter === $68b946db693b9392$export$e252352c431a3ba) operationValue = null;
            else operationValue = {
                name: this._filter,
                amount: this.$.value
            };
        } else operationValue = this.$.value;
        /** @type {import('./types.js').Transformations} */ let transformations = {
            ...this.$["*editorTransformations"],
            [this._operation]: operationValue
        };
        this.$["*editorTransformations"] = transformations;
    }
    cancel() {
        this.$["*faderEl"].deactivate({
            hide: false
        });
    }
    initCallback() {
        super.initCallback();
        this.sub("*originalUrl", (originalUrl)=>{
            this._originalUrl = originalUrl;
        });
        this.sub("value", (value)=>{
            let tooltip = `${this._filter || this._operation} ${value}`;
            this.$["*operationTooltip"] = tooltip;
        });
    }
}
$68b946db693b9392$export$9ab173fa70108ef4.template = /* HTML */ `
  <uc-slider-ui
    ref="slider-el"
    set="disabled: disabled; min: min; max: max; defaultValue: defaultValue; zero: zero; onInput: on.input;"
  ></uc-slider-ui>
`;




function $abbc0c6933a6d6f7$export$d8536155e595e20f(src) {
    let image = new Image();
    let promise = new Promise((resolve, reject)=>{
        image.src = src;
        image.onload = resolve;
        image.onerror = reject;
    });
    let cancel = ()=>{
        if (image.naturalWidth === 0) image.src = (0, $eb84090877b938d3$export$67da346bbbd9b9d4);
    };
    return {
        promise: promise,
        image: image,
        cancel: cancel
    };
}
function $abbc0c6933a6d6f7$export$e425c08b8185563d(list) {
    let preloaders = [];
    for (let src of list){
        let preload = $abbc0c6933a6d6f7$export$d8536155e595e20f(src);
        preloaders.push(preload);
    }
    let images = preloaders.map((preload)=>preload.image);
    let promise = Promise.allSettled(preloaders.map((preload)=>preload.promise));
    let cancel = ()=>{
        preloaders.forEach((preload)=>{
            preload.cancel();
        });
    };
    return {
        promise: promise,
        images: images,
        cancel: cancel
    };
}


class $46600dc7b4eceb17$export$1cf4b09278d815ee extends (0, $52177fcbd4cb5f4d$export$3aa7800404f83f6e) {
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            active: false,
            title: "",
            icon: "",
            isOriginal: false,
            iconSize: "20",
            "on.click": null
        };
    }
    _previewSrc() {
        let previewSize = parseInt(window.getComputedStyle(this).getPropertyValue("--l-base-min-width"), 10);
        let dpr = window.devicePixelRatio;
        let size = Math.ceil(dpr * previewSize);
        let quality = dpr >= 2 ? "lightest" : "normal";
        let filterValue = 100;
        /** @type {import('./types.js').Transformations} */ let transformations = {
            ...this.$["*editorTransformations"]
        };
        // @ts-expect-error FIXME: fix this
        transformations[this._operation] = this._filter !== (0, $68b946db693b9392$export$e252352c431a3ba) ? {
            name: this._filter,
            amount: filterValue
        } : undefined;
        return (0, $8c66713b0e57faf9$export$226a37372a69410c)(this._originalUrl, (0, $8c66713b0e57faf9$export$8fb94a7da5f60007)((0, $429f8fe70c0477d1$export$b73a625f3ee32c8), (0, $429f8fe70c0477d1$export$d901e4e307b689de)(transformations), `quality/${quality}`, `scale_crop/${size}x${size}/center`));
    }
    /**
   * @param {IntersectionObserverEntry[]} entries
   * @param {IntersectionObserver} observer
   */ async _observerCallback(entries, observer) {
        let intersectionEntry = entries[0];
        if (intersectionEntry.isIntersecting) {
            let src = await this.proxyUrl(this._previewSrc());
            let previewEl = this.ref["preview-el"];
            let { promise: promise, cancel: cancel } = (0, $abbc0c6933a6d6f7$export$d8536155e595e20f)(src);
            this._cancelPreload = cancel;
            promise.catch((err)=>{
                this.$["*networkProblems"] = true;
                console.error("Failed to load image", {
                    error: err
                });
            }).finally(()=>{
                previewEl.style.backgroundImage = `url(${src})`;
                previewEl.setAttribute("loaded", "");
                observer.unobserve(this);
            });
        } else this._cancelPreload?.();
    }
    initCallback() {
        super.initCallback();
        this.$["on.click"] = ()=>{
            if (!this.$.active) {
                this.$["*sliderEl"].setOperation(this._operation, this._filter);
                this.$["*sliderEl"].apply();
            } else if (!this.$.isOriginal) {
                this.$["*sliderEl"].setOperation(this._operation, this._filter);
                this.$["*showSlider"] = true;
            }
            this.$["*currentFilter"] = this._filter;
        };
        this.defineAccessor("filter", /** @param {string} filter */ (filter)=>{
            this._operation = "filter";
            this._filter = filter;
            this.$.isOriginal = filter === (0, $68b946db693b9392$export$e252352c431a3ba);
            this.$.icon = this.$.isOriginal ? "original" : "slider";
            this.bindL10n("title-prop", ()=>this.l10n("a11y-cloud-editor-apply-filter", {
                    name: filter.toLowerCase()
                }));
        });
        this._observer = new window.IntersectionObserver(this._observerCallback.bind(this), {
            threshold: [
                0,
                1
            ]
        });
        let originalUrl = this.$["*originalUrl"];
        this._originalUrl = originalUrl;
        if (this.$.isOriginal) this.ref["icon-el"].classList.add("uc-original-icon");
        else this._observer.observe(this);
        this.sub("*currentFilter", (currentFilter)=>{
            this.$.active = currentFilter && currentFilter === this._filter;
        });
        this.sub("isOriginal", (isOriginal)=>{
            this.$.iconSize = isOriginal ? 40 : 20;
        });
        this.sub("active", (active)=>{
            if (this.$.isOriginal) return;
            let iconEl = this.ref["icon-el"];
            iconEl.style.opacity = active ? "1" : "0";
            let previewEl = this.ref["preview-el"];
            if (active) previewEl.style.opacity = "0";
            else if (previewEl.style.backgroundImage) previewEl.style.opacity = "1";
        });
        this.sub("*networkProblems", async (networkProblems)=>{
            if (!networkProblems) {
                let src = await this.proxyUrl(this._previewSrc());
                let previewEl = this.ref["preview-el"];
                if (previewEl.style.backgroundImage) {
                    previewEl.style.backgroundImage = "none";
                    previewEl.style.backgroundImage = `url(${src})`;
                }
            }
        });
    }
    destroyCallback() {
        super.destroyCallback();
        this._observer?.disconnect();
        this._cancelPreload?.();
    }
}
$46600dc7b4eceb17$export$1cf4b09278d815ee.template = /* HTML */ `
  <button type="button" role="option" l10n="@title:title-prop;@aria-label:title-prop">
    <div class="uc-preview" ref="preview-el"></div>
    <uc-icon ref="icon-el" set="@name: icon; @size: iconSize;"></uc-icon>
  </button>
`;




class $449306e34b30b9de$export$cf5be688aafa2355 extends (0, $52177fcbd4cb5f4d$export$3aa7800404f83f6e) {
    /**
   * @private
   * @type {String}
   */ _operation = "";
    initCallback() {
        super.initCallback();
        this.$["on.click"] = (e)=>{
            this.$["*sliderEl"].setOperation(this._operation);
            this.$["*showSlider"] = true;
            this.$["*currentOperation"] = this._operation;
        };
        this.defineAccessor("operation", (operation)=>{
            if (operation) {
                this._operation = operation;
                this.$["icon"] = operation;
                this.bindL10n("title-prop", ()=>this.l10n("a11y-cloud-editor-apply-tuning", {
                        name: this.l10n(operation).toLowerCase()
                    }));
                this.bindL10n("title", ()=>this.l10n(operation));
            }
        });
        this.sub("*editorTransformations", (editorTransformations)=>{
            if (!this._operation) return;
            let { zero: zero } = (0, $8b84db27cd8d65ab$export$e3dcdd21a8cd88f9)[this._operation];
            let value = editorTransformations[this._operation];
            let isActive = typeof value !== "undefined" ? value !== zero : false;
            this.$.active = isActive;
        });
    }
}


// @ts-check






/**
 * @param {{}} obj
 * @param {String[]} keys
 * @returns {{}}
 */ function $849fee8c004da20e$export$357523c63a2253b9(obj, keys) {
    let result = {};
    for (let key of keys){
        let value = obj[key];
        if (obj.hasOwnProperty(key) || value !== undefined) result[key] = value;
    }
    return result;
}






function $be99adc3e6f9a7c0$export$fac0f4feef8b6807(originalUrl, width, transformations) {
    const MAX_CDN_DIMENSION = 3000;
    let dpr = window.devicePixelRatio;
    let size = Math.min(Math.ceil(width * dpr), MAX_CDN_DIMENSION);
    let quality = dpr >= 2 ? "lightest" : "normal";
    return (0, $8c66713b0e57faf9$export$226a37372a69410c)(originalUrl, (0, $8c66713b0e57faf9$export$8fb94a7da5f60007)((0, $429f8fe70c0477d1$export$b73a625f3ee32c8), (0, $429f8fe70c0477d1$export$d901e4e307b689de)(transformations), `quality/${quality}`, `stretch/off/-/resize/${size}x`, `@clib/${(0, $4b0d1e35b7235ecb$export$b8b9d90f9e5bd72b)}/${(0, $4b0d1e35b7235ecb$export$4a03ffab3315ee34)}/uc-cloud-image-editor/`));
}


/**
 * @typedef {Object} Operations
 * @property {boolean} flip
 * @property {boolean} mirror
 * @property {Number} rotate
 */ /**
 * @param {import('./types.js').Transformations['crop']} crop
 * @returns {boolean}
 */ function $c5c6bc81c5e4a020$var$validateCrop(crop) {
    if (!crop) return true;
    /** @type {((arg: NonNullable<typeof crop>) => boolean)[]} */ let shouldMatch = [
        ({ dimensions: dimensions, coords: coords })=>[
                ...dimensions,
                ...coords
            ].every((number)=>Number.isInteger(number) && Number.isFinite(number)),
        ({ dimensions: dimensions, coords: coords })=>dimensions.every((d)=>d > 0) && coords.every((c)=>c >= 0)
    ];
    return shouldMatch.every((matcher)=>matcher(crop));
}
class $c5c6bc81c5e4a020$export$fc01d462d57ea6e6 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    ctxOwner = true;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            image: null,
            "*padding": (0, $c1f033c89897f5fc$export$79bf3aa6ff8a6a3c),
            /** @type {Operations} */ "*operations": {
                rotate: 0,
                mirror: false,
                flip: false
            },
            /** @type {import('./types.js').Rectangle} */ "*imageBox": {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            },
            /** @type {import('./types.js').Rectangle} */ "*cropBox": {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        /** @private */ this._commitDebounced = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(this._commit.bind(this), 300);
        /** @private */ this._handleResizeThrottled = (0, $3463bc23a4723762$export$de363e709c412c8a)(this._handleResize.bind(this), 100);
        this._imageSize = {
            width: 0,
            height: 0
        };
    }
    /** @private */ _handleResize() {
        if (!this.isConnected || !this._isActive) return;
        this._initCanvas();
        this._syncTransformations();
        this._alignImage();
        this._alignCrop();
        this._draw();
    }
    /** @private */ _syncTransformations() {
        let transformations = this.$["*editorTransformations"];
        let pickedTransformations = (0, $849fee8c004da20e$export$357523c63a2253b9)(transformations, Object.keys(this.$["*operations"]));
        let operations = {
            ...this.$["*operations"],
            ...pickedTransformations
        };
        this.$["*operations"] = operations;
    }
    /** @private */ _initCanvas() {
        /** @type {HTMLCanvasElement} */ let canvas = this.ref["canvas-el"];
        let ctx = canvas.getContext("2d");
        let width = this.offsetWidth;
        let height = this.offsetHeight;
        let dpr = window.devicePixelRatio;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;
        canvas.width = width * dpr;
        canvas.height = height * dpr;
        ctx?.scale(dpr, dpr);
        this._canvas = canvas;
        this._ctx = ctx;
    }
    /** @private */ _alignImage() {
        if (!this._isActive || !this.$.image) return;
        let image = this.$.image;
        let padding = this.$["*padding"];
        let operations = this.$["*operations"];
        let { rotate: rotate } = operations;
        let bounds = {
            width: this.offsetWidth,
            height: this.offsetHeight
        };
        let naturalSize = (0, $ec2c5c3a08a9901b$export$9e53471bfbfdc361)({
            width: image.naturalWidth,
            height: image.naturalHeight
        }, rotate);
        let imageBox;
        if (naturalSize.width > bounds.width - padding * 2 || naturalSize.height > bounds.height - padding * 2) {
            let imageAspectRatio = naturalSize.width / naturalSize.height;
            let viewportAspectRatio = bounds.width / bounds.height;
            if (imageAspectRatio > viewportAspectRatio) {
                let width = bounds.width - padding * 2;
                let height = width / imageAspectRatio;
                let x = 0 + padding;
                let y = padding + (bounds.height - padding * 2) / 2 - height / 2;
                imageBox = {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                };
            } else {
                let height = bounds.height - padding * 2;
                let width = height * imageAspectRatio;
                let x = padding + (bounds.width - padding * 2) / 2 - width / 2;
                let y = 0 + padding;
                imageBox = {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                };
            }
        } else {
            let { width: width, height: height } = naturalSize;
            let x = padding + (bounds.width - padding * 2) / 2 - width / 2;
            let y = padding + (bounds.height - padding * 2) / 2 - height / 2;
            imageBox = {
                x: x,
                y: y,
                width: width,
                height: height
            };
        }
        this.$["*imageBox"] = (0, $ec2c5c3a08a9901b$export$166e03518104bf21)(imageBox);
    }
    /** @private */ _alignCrop() {
        let cropBox = this.$["*cropBox"];
        let imageBox = this.$["*imageBox"];
        let operations = this.$["*operations"];
        let { rotate: rotate } = operations;
        let cropTransformation = this.$["*editorTransformations"]["crop"];
        let { width: previewWidth, x: previewX, y: previewY } = this.$["*imageBox"];
        if (cropTransformation) {
            let { dimensions: [width, height], coords: [x, y] } = cropTransformation;
            let { width: sourceWidth } = (0, $ec2c5c3a08a9901b$export$9e53471bfbfdc361)(this._imageSize, rotate);
            let ratio = previewWidth / sourceWidth;
            cropBox = (0, $ec2c5c3a08a9901b$export$25fd15ab86a7b28b)((0, $ec2c5c3a08a9901b$export$166e03518104bf21)({
                x: previewX + x * ratio,
                y: previewY + y * ratio,
                width: width * ratio,
                height: height * ratio
            }), this.$["*imageBox"]);
        }
        /** @type {import('./types.js').CropPresetList[0] | undefined} */ const cropPreset = this.$["*cropPresetList"]?.[0];
        const cropAspectRatio = cropPreset ? cropPreset.width / cropPreset.height : undefined;
        if (!(0, $ec2c5c3a08a9901b$export$5b9ad582f7a393a7)(cropBox, imageBox) || cropAspectRatio && !(0, $ec2c5c3a08a9901b$export$c875bfe83ce4f5e0)(cropBox, cropAspectRatio)) {
            const imageAspectRatio = imageBox.width / imageBox.height;
            let width = imageBox.width;
            let height = imageBox.height;
            if (cropAspectRatio) {
                if (imageAspectRatio > cropAspectRatio) width = Math.min(imageBox.height * cropAspectRatio, imageBox.width);
                else height = Math.min(imageBox.width / cropAspectRatio, imageBox.height);
            }
            cropBox = {
                x: imageBox.x + imageBox.width / 2 - width / 2,
                y: imageBox.y + imageBox.height / 2 - height / 2,
                width: width,
                height: height
            };
        }
        this.$["*cropBox"] = (0, $ec2c5c3a08a9901b$export$25fd15ab86a7b28b)((0, $ec2c5c3a08a9901b$export$166e03518104bf21)(cropBox), this.$["*imageBox"]);
    }
    /** @private */ _drawImage() {
        let ctx = this._ctx;
        if (!ctx) return;
        let image = this.$.image;
        let imageBox = this.$["*imageBox"];
        let operations = this.$["*operations"];
        let { mirror: mirror, flip: flip, rotate: rotate } = operations;
        let rotated = (0, $ec2c5c3a08a9901b$export$9e53471bfbfdc361)({
            width: imageBox.width,
            height: imageBox.height
        }, rotate);
        ctx.save();
        ctx.translate(imageBox.x + imageBox.width / 2, imageBox.y + imageBox.height / 2);
        ctx.rotate(rotate * Math.PI * -1 / 180);
        ctx.scale(mirror ? -1 : 1, flip ? -1 : 1);
        ctx.drawImage(image, -rotated.width / 2, -rotated.height / 2, rotated.width, rotated.height);
        ctx.restore();
    }
    /** @private */ _draw() {
        if (!this._isActive || !this.$.image || !this._canvas || !this._ctx) return;
        let canvas = this._canvas;
        let ctx = this._ctx;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        this._drawImage();
    }
    /**
   * @private
   * @param {{ fromViewer?: boolean }} options
   */ _animateIn({ fromViewer: fromViewer }) {
        if (this.$.image) {
            this.ref["frame-el"].toggleThumbs(true);
            this._transitionToImage();
            setTimeout(()=>{
                this.className = (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)({
                    "uc-active_from_viewer": fromViewer,
                    "uc-active_from_editor": !fromViewer,
                    "uc-inactive_to_editor": false
                });
            });
        }
    }
    /**
   * @private
   * @returns {NonNullable<import('./types.js').Transformations['crop']>['dimensions']}
   */ _getCropDimensions() {
        let cropBox = this.$["*cropBox"];
        let imageBox = this.$["*imageBox"];
        let operations = this.$["*operations"];
        let { rotate: rotate } = operations;
        let { width: previewWidth, height: previewHeight } = imageBox;
        let { width: sourceWidth, height: sourceHeight } = (0, $ec2c5c3a08a9901b$export$9e53471bfbfdc361)(this._imageSize, rotate);
        let { width: cropWidth, height: cropHeight } = cropBox;
        let ratioW = previewWidth / sourceWidth;
        let ratioH = previewHeight / sourceHeight;
        /** @type {[Number, Number]} */ let dimensions = [
            (0, $ec2c5c3a08a9901b$export$7d15b64cf5a3a4c4)(Math.round(cropWidth / ratioW), 1, sourceWidth),
            (0, $ec2c5c3a08a9901b$export$7d15b64cf5a3a4c4)(Math.round(cropHeight / ratioH), 1, sourceHeight)
        ];
        return dimensions;
    }
    /**
   * @private
   * @returns {import('./types.js').Transformations['crop']}
   */ _getCropTransformation() {
        let cropBox = this.$["*cropBox"];
        let imageBox = this.$["*imageBox"];
        let operations = this.$["*operations"];
        let { rotate: rotate } = operations;
        let { width: previewWidth, height: previewHeight, x: previewX, y: previewY } = imageBox;
        let { width: sourceWidth, height: sourceHeight } = (0, $ec2c5c3a08a9901b$export$9e53471bfbfdc361)(this._imageSize, rotate);
        let { x: cropX, y: cropY } = cropBox;
        let ratioW = previewWidth / sourceWidth;
        let ratioH = previewHeight / sourceHeight;
        let dimensions = this._getCropDimensions();
        let crop = {
            dimensions: dimensions,
            coords: /** @type {[Number, Number]} */ [
                (0, $ec2c5c3a08a9901b$export$7d15b64cf5a3a4c4)(Math.round((cropX - previewX) / ratioW), 0, sourceWidth - dimensions[0]),
                (0, $ec2c5c3a08a9901b$export$7d15b64cf5a3a4c4)(Math.round((cropY - previewY) / ratioH), 0, sourceHeight - dimensions[1])
            ]
        };
        if (!$c5c6bc81c5e4a020$var$validateCrop(crop)) {
            console.error("Cropper is trying to create invalid crop object", {
                payload: crop
            });
            return undefined;
        }
        if (dimensions[0] === sourceWidth && dimensions[1] === sourceHeight) return undefined;
        return crop;
    }
    /** @private */ _commit() {
        if (!this.isConnected || !this._imageSize) return;
        let operations = this.$["*operations"];
        let { rotate: rotate, mirror: mirror, flip: flip } = operations;
        let crop = this._getCropTransformation();
        /** @type {import('./types.js').Transformations} */ let editorTransformations = this.$["*editorTransformations"];
        let transformations = {
            ...editorTransformations,
            crop: crop,
            rotate: rotate,
            mirror: mirror,
            flip: flip
        };
        this.$["*editorTransformations"] = transformations;
    }
    /**
   * @param {String} operation
   * @param {Number} value
   * @returns {void}
   */ setValue(operation, value) {
        this.$["*operations"] = {
            ...this.$["*operations"],
            [operation]: value
        };
        if (!this._isActive) return;
        this._alignImage();
        this._alignCrop();
        this._draw();
    }
    /**
   * @param {keyof Operations} operation
   * @returns {Number | boolean}
   */ getValue(operation) {
        return this.$["*operations"][operation];
    }
    /**
   * @param {import('./types.js').ImageSize} imageSize
   * @param {{ fromViewer?: boolean }} options
   */ async activate(imageSize, { fromViewer: fromViewer } = {}) {
        if (this._isActive) return;
        this._isActive = true;
        this._imageSize = imageSize;
        this.removeEventListener("transitionend", this._reset);
        try {
            this.$.image = await this._waitForImage(this.$["*originalUrl"], this.$["*editorTransformations"]);
            this._syncTransformations();
            this._animateIn({
                fromViewer: fromViewer
            });
        } catch (err) {
            console.error("Failed to activate cropper", {
                error: err
            });
        }
        this._observer = new ResizeObserver(([entry])=>{
            const nonZeroSize = entry.contentRect.width > 0 && entry.contentRect.height > 0;
            if (nonZeroSize && this._isActive && this.$.image) this._handleResizeThrottled();
        });
        this._observer.observe(this);
    }
    deactivate({ reset: reset = false } = {}) {
        if (!this._isActive) return;
        !reset && this._commit();
        this._isActive = false;
        this._transitionToCrop();
        this.className = (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)({
            "uc-active_from_viewer": false,
            "uc-active_from_editor": false,
            "uc-inactive_to_editor": true
        });
        this.ref["frame-el"].toggleThumbs(false);
        this.addEventListener("transitionend", this._reset, {
            once: true
        });
        this._observer?.disconnect();
    }
    /** @private */ _transitionToCrop() {
        let dimensions = this._getCropDimensions();
        let scaleX = Math.min(this.offsetWidth, dimensions[0]) / this.$["*cropBox"].width;
        let scaleY = Math.min(this.offsetHeight, dimensions[1]) / this.$["*cropBox"].height;
        let scale = Math.min(scaleX, scaleY);
        let cropCenterX = this.$["*cropBox"].x + this.$["*cropBox"].width / 2;
        let cropCenterY = this.$["*cropBox"].y + this.$["*cropBox"].height / 2;
        this.style.transform = `scale(${scale}) translate(${(this.offsetWidth / 2 - cropCenterX) / scale}px, ${(this.offsetHeight / 2 - cropCenterY) / scale}px)`;
        this.style.transformOrigin = `${cropCenterX}px ${cropCenterY}px`;
    }
    /** @private */ _transitionToImage() {
        let cropCenterX = this.$["*cropBox"].x + this.$["*cropBox"].width / 2;
        let cropCenterY = this.$["*cropBox"].y + this.$["*cropBox"].height / 2;
        this.style.transform = `scale(1)`;
        this.style.transformOrigin = `${cropCenterX}px ${cropCenterY}px`;
    }
    /** @private */ _reset() {
        if (this._isActive) return;
        this.$.image = null;
    }
    /**
   * @private
   * @param {String} originalUrl
   * @param {import('./types.js').Transformations} transformations
   * @returns {Promise<HTMLImageElement>}
   */ async _waitForImage(originalUrl, transformations) {
        let width = this.offsetWidth;
        transformations = {
            ...transformations,
            crop: undefined,
            rotate: undefined,
            flip: undefined,
            mirror: undefined
        };
        let src = await this.proxyUrl((0, $be99adc3e6f9a7c0$export$fac0f4feef8b6807)(originalUrl, width, transformations));
        let { promise: promise, cancel: cancel, image: image } = (0, $abbc0c6933a6d6f7$export$d8536155e595e20f)(src);
        let stop = this._handleImageLoading(src);
        image.addEventListener("load", stop, {
            once: true
        });
        image.addEventListener("error", stop, {
            once: true
        });
        this._cancelPreload?.();
        this._cancelPreload = cancel;
        return promise.then(()=>image).catch((err)=>{
            console.error("Failed to load image", {
                error: err
            });
            this.$["*networkProblems"] = true;
            return Promise.resolve(image);
        });
    }
    /**
   * @private
   * @param {String} src
   * @returns {() => void} Destructor
   */ _handleImageLoading(src) {
        let operation = "crop";
        let loadingOperations = this.$["*loadingOperations"];
        if (!loadingOperations.get(operation)) loadingOperations.set(operation, new Map());
        if (!loadingOperations.get(operation).get(src)) {
            loadingOperations.set(operation, loadingOperations.get(operation).set(src, true));
            this.$["*loadingOperations"] = loadingOperations;
        }
        return ()=>{
            if (loadingOperations?.get(operation)?.has(src)) {
                loadingOperations.get(operation).delete(src);
                this.$["*loadingOperations"] = loadingOperations;
            }
        };
    }
    initCallback() {
        super.initCallback();
        this.sub("*imageBox", ()=>{
            this._draw();
        });
        this.sub("*cropBox", ()=>{
            if (this.$.image) this._commitDebounced();
        });
        this.sub("*cropPresetList", ()=>{
            this._alignCrop();
        });
        setTimeout(()=>{
            this.sub("*networkProblems", (networkProblems)=>{
                if (!networkProblems) this._isActive && this.activate(this._imageSize, {
                    fromViewer: false
                });
            });
        }, 0);
    }
    destroyCallback() {
        super.destroyCallback();
        this._observer?.disconnect();
    }
}
$c5c6bc81c5e4a020$export$fc01d462d57ea6e6.template = /* HTML */ `
  <canvas class="uc-canvas" ref="canvas-el"></canvas>
  <uc-crop-frame ref="frame-el"></uc-crop-frame>
`;





/**
 * @param {Number} a Start of sample (int)
 * @param {Number} b End of sample (int)
 * @param {Number} n Number of elements (int)
 * @returns {Number[]}
 */ function $7fb076dbf3a1ed37$export$71255ea3f595147c(a, b, n) {
    let ret = Array(n);
    n--;
    for(let i = n; i >= 0; i--)ret[i] = Math.ceil((i * b + (n - i) * a) / n);
    return ret;
}





/**
 * @param {Number[]} numbers
 * @returns {[Number, Number][]}
 */ function $04b4249620c794c0$var$splitBySections(numbers) {
    return numbers.reduce((acc, point, idx)=>idx < numbers.length - 1 ? [
            ...acc,
            [
                point,
                numbers[idx + 1]
            ]
        ] : acc, []);
}
/**
 * @param {Number[]} keypoints
 * @param {Number} value
 * @param {Number} zero
 */ function $04b4249620c794c0$var$calculateOpacities(keypoints, value, zero) {
    let section = $04b4249620c794c0$var$splitBySections(keypoints).find(([left, right])=>left <= value && value <= right);
    return keypoints.map((point)=>{
        let distance = Math.abs(section[0] - section[1]);
        let relation = Math.abs(value - section[0]) / distance;
        if (section[0] === point) return value > zero ? 1 : 1 - relation;
        if (section[1] === point) return value >= zero ? relation : 1;
        return 0;
    });
}
/**
 * @param {Number[]} keypoints
 * @param {Number} zero
 */ function $04b4249620c794c0$var$calculateZIndices(keypoints, zero) {
    return keypoints.map((point, idx)=>point < zero ? keypoints.length - idx : idx);
}
/**
 * @param {String} operation
 * @param {Number} value
 * @returns {Number[]}
 */ function $04b4249620c794c0$var$keypointsRange(operation, value) {
    let n = (0, $8b84db27cd8d65ab$export$e3dcdd21a8cd88f9)[operation].keypointsNumber;
    let { range: range, zero: zero } = (0, $8b84db27cd8d65ab$export$e3dcdd21a8cd88f9)[operation];
    return [
        ...new Set([
            ...(0, $7fb076dbf3a1ed37$export$71255ea3f595147c)(range[0], zero, n + 1),
            ...(0, $7fb076dbf3a1ed37$export$71255ea3f595147c)(zero, range[1], n + 1),
            zero,
            value
        ])
    ].sort((a, b)=>a - b);
}
class $04b4249620c794c0$export$15eaf4dbf84459f1 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    constructor(){
        super();
        /**
     * @private
     * @type {Boolean}
     */ this._isActive = false;
        /**
     * @private
     * @type {Boolean}
     */ this._hidden = true;
        /** @private */ this._addKeypointDebounced = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(this._addKeypoint.bind(this), 600);
        this.classList.add("uc-inactive_to_cropper");
    }
    /**
   * @private
   * @param {String} src
   * @returns {() => void} Destructor
   */ _handleImageLoading(src) {
        let operation = this._operation;
        let loadingOperations = this.$["*loadingOperations"];
        if (!loadingOperations.get(operation)) loadingOperations.set(operation, new Map());
        if (!loadingOperations.get(operation).get(src)) {
            loadingOperations.set(operation, loadingOperations.get(operation).set(src, true));
            this.$["*loadingOperations"] = loadingOperations;
        }
        return ()=>{
            if (loadingOperations?.get(operation)?.has(src)) {
                loadingOperations.get(operation).delete(src);
                this.$["*loadingOperations"] = loadingOperations;
            }
        };
    }
    /** @private */ _flush() {
        window.cancelAnimationFrame(this._raf);
        this._raf = window.requestAnimationFrame(()=>{
            for (let kp of this._keypoints){
                let { image: image } = kp;
                if (image) {
                    image.style.opacity = kp.opacity.toString();
                    image.style.zIndex = kp.zIndex.toString();
                }
            }
        });
    }
    /**
   * @private
   * @param {Object} options
   * @param {String} [options.url]
   * @param {String} [options.filter]
   * @param {String} [options.operation]
   * @param {Number} [options.value]
   * @returns {Promise<String>}
   */ async _imageSrc({ url: url = this._url, filter: filter = this._filter, operation: operation, value: value } = {}) {
        let transformations = {
            ...this._transformations
        };
        if (operation) transformations[operation] = filter ? {
            name: filter,
            amount: value
        } : value;
        // do not use getBoundingClientRect because scale transform affects it
        let width = this.offsetWidth;
        return await this.proxyUrl((0, $be99adc3e6f9a7c0$export$fac0f4feef8b6807)(url, width, transformations));
    }
    /**
   * @private
   * @param {String} operation
   * @param {Number} value
   * @returns {Promise<Keypoint>}
   */ async _constructKeypoint(operation, value) {
        let src = await this._imageSrc({
            operation: operation,
            value: value
        });
        return {
            src: src,
            image: null,
            opacity: 0,
            zIndex: 0,
            value: value
        };
    }
    /**
   * Check if current operation and filter equals passed ones
   *
   * @private
   * @param {String} operation
   * @param {String} [filter]
   * @returns {Boolean}
   */ _isSame(operation, filter) {
        return this._operation === operation && this._filter === filter;
    }
    /**
   * @private
   * @param {String} operation
   * @param {String | null} filter
   * @param {Number} value
   */ async _addKeypoint(operation, filter, value) {
        let shouldSkip = ()=>!this._isSame(operation, filter) || this._value !== value || !!this._keypoints.find((kp)=>kp.value === value);
        if (shouldSkip()) return;
        let keypoint = await this._constructKeypoint(operation, value);
        let image = new Image();
        image.src = keypoint.src;
        let stop = this._handleImageLoading(keypoint.src);
        image.addEventListener("load", stop, {
            once: true
        });
        image.addEventListener("error", stop, {
            once: true
        });
        keypoint.image = image;
        image.classList.add("uc-fader-image");
        image.addEventListener("load", ()=>{
            if (shouldSkip()) return;
            let keypoints = this._keypoints;
            let idx = keypoints.findIndex((kp)=>kp.value > value);
            let insertBeforeNode = idx < keypoints.length ? keypoints[idx].image : null;
            if (!this._container || insertBeforeNode && !this._container.contains(insertBeforeNode)) return;
            keypoints.splice(idx, 0, keypoint);
            this._container.insertBefore(image, insertBeforeNode);
            this._update(operation, value);
        }, {
            once: true
        });
        image.addEventListener("error", ()=>{
            this.$["*networkProblems"] = true;
        }, {
            once: true
        });
    }
    /** @param {String | Number} value */ set(value) {
        value = typeof value === "string" ? parseInt(value, 10) : value;
        this._update(this._operation, value);
        this._addKeypointDebounced(this._operation, this._filter, value);
    }
    /**
   * @private
   * @param {String} operation
   * @param {Number} value
   */ _update(operation, value) {
        this._operation = operation;
        this._value = value;
        let { zero: zero } = (0, $8b84db27cd8d65ab$export$e3dcdd21a8cd88f9)[operation];
        let keypointValues = this._keypoints.map((kp)=>kp.value);
        let opacities = $04b4249620c794c0$var$calculateOpacities(keypointValues, value, zero);
        let zIndices = $04b4249620c794c0$var$calculateZIndices(keypointValues, zero);
        for (let [idx, kp] of Object.entries(this._keypoints)){
            kp.opacity = opacities[idx];
            kp.zIndex = zIndices[idx];
        }
        this._flush();
    }
    /** @private */ _createPreviewImage() {
        let image = new Image();
        image.classList.add("uc-fader-image", "uc-fader-image--preview");
        image.style.opacity = "0";
        return image;
    }
    /** @private */ async _initNodes() {
        let fr = document.createDocumentFragment();
        this._previewImage = this._previewImage || this._createPreviewImage();
        !this.contains(this._previewImage) && fr.appendChild(this._previewImage);
        let container = document.createElement("div");
        fr.appendChild(container);
        let srcList = this._keypoints.map((kp)=>kp.src);
        let { images: images, promise: promise, cancel: cancel } = (0, $abbc0c6933a6d6f7$export$e425c08b8185563d)(srcList);
        images.forEach((node)=>{
            let stop = this._handleImageLoading(node.src);
            node.addEventListener("load", stop);
            node.addEventListener("error", stop);
        });
        this._cancelLastImages = ()=>{
            cancel();
            this._cancelLastImages = undefined;
        };
        let operation = this._operation;
        let filter = this._filter;
        await promise;
        if (this._isActive && this._isSame(operation, filter)) {
            this._container && this._container.remove();
            this._container = container;
            this._keypoints.forEach((kp, idx)=>{
                let kpImage = images[idx];
                kpImage.classList.add("uc-fader-image");
                kp.image = kpImage;
                this._container.appendChild(kpImage);
            });
            this.appendChild(fr);
            this._flush();
        }
    }
    /** @param {import('./types.js').Transformations} transformations */ async setTransformations(transformations) {
        this._transformations = transformations;
        if (this._previewImage) {
            let src = await this._imageSrc();
            let stop = this._handleImageLoading(src);
            this._previewImage.src = src;
            this._previewImage.addEventListener("load", stop, {
                once: true
            });
            this._previewImage.addEventListener("error", stop, {
                once: true
            });
            this._previewImage.style.opacity = "1";
            this._previewImage.addEventListener("error", ()=>{
                this.$["*networkProblems"] = true;
            }, {
                once: true
            });
        }
    }
    /**
   * @param {object} options
   * @param {String} options.url
   * @param {String} options.operation
   * @param {Number} options.value
   * @param {String} [options.filter]
   */ async preload({ url: url, filter: filter, operation: operation, value: value }) {
        this._cancelBatchPreload && this._cancelBatchPreload();
        let keypoints = $04b4249620c794c0$var$keypointsRange(operation, value);
        let srcList = await Promise.all(keypoints.map((kp)=>this._imageSrc({
                url: url,
                filter: filter,
                operation: operation,
                value: kp
            })));
        let { cancel: cancel } = (0, $abbc0c6933a6d6f7$export$e425c08b8185563d)(srcList);
        this._cancelBatchPreload = cancel;
    }
    /** @private */ _setOriginalSrc(src) {
        let image = this._previewImage || this._createPreviewImage();
        !this.contains(image) && this.appendChild(image);
        this._previewImage = image;
        if (image.src === src) {
            image.style.opacity = "1";
            image.style.transform = "scale(1)";
            this.className = (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)({
                "uc-active_from_viewer": this._fromViewer,
                "uc-active_from_cropper": !this._fromViewer,
                "uc-inactive_to_cropper": false
            });
            return;
        }
        image.style.opacity = "0";
        let stop = this._handleImageLoading(src);
        image.addEventListener("error", stop, {
            once: true
        });
        image.src = src;
        image.addEventListener("load", ()=>{
            stop();
            if (image) {
                image.style.opacity = "1";
                image.style.transform = "scale(1)";
                this.className = (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)({
                    "uc-active_from_viewer": this._fromViewer,
                    "uc-active_from_cropper": !this._fromViewer,
                    "uc-inactive_to_cropper": false
                });
            }
        }, {
            once: true
        });
        image.addEventListener("error", ()=>{
            this.$["*networkProblems"] = true;
        }, {
            once: true
        });
    }
    /**
   * @param {object} options
   * @param {String} options.url
   * @param {String} [options.operation]
   * @param {Number} [options.value]
   * @param {String} [options.filter]
   * @param {Boolean} [options.fromViewer]
   */ async activate({ url: url, operation: operation, value: value, filter: filter, fromViewer: fromViewer }) {
        this._isActive = true;
        this._hidden = false;
        this._url = url;
        this._operation = operation || "initial";
        this._value = value;
        this._filter = filter;
        this._fromViewer = fromViewer;
        let isOriginal = typeof value !== "number" && !filter;
        if (isOriginal) {
            let src = await this._imageSrc({
                operation: operation,
                value: value
            });
            this._setOriginalSrc(src);
            this._container && this._container.remove();
            return;
        }
        this._keypoints = await Promise.all($04b4249620c794c0$var$keypointsRange(operation, value).map((keyValue)=>this._constructKeypoint(operation, keyValue)));
        this._update(operation, value);
        this._initNodes();
    }
    /** @param {{ hide?: Boolean }} options */ deactivate({ hide: hide = true } = {}) {
        this._isActive = false;
        this._cancelLastImages && this._cancelLastImages();
        this._cancelBatchPreload && this._cancelBatchPreload();
        if (hide && !this._hidden) {
            this._hidden = true;
            if (this._previewImage) this._previewImage.style.transform = "scale(1)";
            this.className = (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)({
                "uc-active_from_viewer": false,
                "uc-active_from_cropper": false,
                "uc-inactive_to_cropper": true
            });
            this.addEventListener("transitionend", ()=>{
                this._container && this._container.remove();
            }, {
                once: true
            });
        } else this._container && this._container.remove();
    }
}



const $ab0d3e8cd08c1c00$var$X_THRESHOLD = 1;
class $ab0d3e8cd08c1c00$export$88b72cf03cc30a69 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    initCallback() {
        super.initCallback();
        this.addEventListener("wheel", (e)=>{
            e.preventDefault();
            let { deltaY: deltaY, deltaX: deltaX } = e;
            if (Math.abs(deltaX) > $ab0d3e8cd08c1c00$var$X_THRESHOLD) this.scrollLeft += deltaX;
            else this.scrollLeft += deltaY;
        }, {
            passive: false
        });
        // This fixes some strange bug on MacOS - wheel event doesn't fire for physical mouse wheel if no scroll event attached also
        this.addEventListener("scroll", ()=>{}, {
            passive: true
        });
    }
}
$ab0d3e8cd08c1c00$export$88b72cf03cc30a69.template = /* HTML */ ` <slot></slot> `;



// @ts-check









/** @param {String} id */ function $2a5cd161e857b06c$var$renderTabToggle(id) {
    return /* HTML */ `
    <uc-presence-toggle
      class="uc-tab-toggle"
      set="visible: presence.tabToggle.${id}; styles: presence.tabToggleStyles;"
    >
      <uc-btn-ui
        theme="tab"
        ref="tab-toggle-${id}"
        data-id="${id}"
        icon="${id}"
        set="onclick: on.clickTab; aria-role:tab_role; aria-controls:tab_${id}; title-prop: a11y-editor-tab-${id}"
      >
      </uc-btn-ui>
    </uc-presence-toggle>
  `;
}
/** @param {String} id */ function $2a5cd161e857b06c$var$renderTabContent(id) {
    return /* HTML */ `
    <uc-presence-toggle
      id="tab_${id}"
      class="uc-tab-content"
      set="visible: presence.tabContent.${id}; styles: presence.tabContentStyles"
    >
      <uc-editor-scroller hidden-scrollbar>
        <div class="uc-controls-list_align">
          <div
            role="listbox"
            aria-orientation="horizontal"
            class="uc-controls-list_inner"
            ref="controls-list-${id}"
          ></div>
        </div>
      </uc-editor-scroller>
    </uc-presence-toggle>
  `;
}
class $2a5cd161e857b06c$export$477aaffea178bc4e extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            "*sliderEl": null,
            /** @type {import('./types.js').LoadingOperations} */ "*loadingOperations": new Map(),
            "*showSlider": false,
            "*currentFilter": (0, $68b946db693b9392$export$e252352c431a3ba),
            "*currentOperation": null,
            showLoader: false,
            filters: (0, $8b84db27cd8d65ab$export$5773a777940e5760),
            colorOperations: (0, $8b84db27cd8d65ab$export$68b0885f31248db9),
            cropOperations: (0, $8b84db27cd8d65ab$export$daf320f6382e1d0a),
            "*operationTooltip": null,
            "presence.mainToolbar": true,
            "presence.subToolbar": false,
            "presence.tabToggles": true,
            "presence.tabContent.crop": false,
            "presence.tabContent.tuning": false,
            "presence.tabContent.filters": false,
            "presence.tabToggle.crop": true,
            "presence.tabToggle.tuning": true,
            "presence.tabToggle.filters": true,
            "presence.subTopToolbarStyles": {
                hidden: "uc-sub-toolbar--top-hidden",
                visible: "uc-sub-toolbar--visible"
            },
            "presence.subBottomToolbarStyles": {
                hidden: "uc-sub-toolbar--bottom-hidden",
                visible: "uc-sub-toolbar--visible"
            },
            "presence.tabContentStyles": {
                hidden: "uc-tab-content--hidden",
                visible: "uc-tab-content--visible"
            },
            "presence.tabToggleStyles": {
                hidden: "uc-tab-toggle--hidden",
                visible: "uc-tab-toggle--visible"
            },
            "presence.tabTogglesStyles": {
                hidden: "uc-tab-toggles--hidden",
                visible: "uc-tab-toggles--visible"
            },
            "on.cancel": ()=>{
                this._cancelPreload?.();
                this.$["*on.cancel"]();
            },
            "on.apply": ()=>{
                this.$["*on.apply"](this.$["*editorTransformations"]);
            },
            "on.applySlider": ()=>{
                this.ref["slider-el"].apply();
                this._onSliderClose();
            },
            "on.cancelSlider": ()=>{
                this.ref["slider-el"].cancel();
                this._onSliderClose();
            },
            /** @param {MouseEvent} e */ "on.clickTab": (e)=>{
                const id = /** @type {HTMLElement} */ e.currentTarget.getAttribute("data-id");
                if (id) this._activateTab(id, {
                    fromViewer: false
                });
            },
            tab_role: "tab",
            [`tab_${(0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).TUNING}`]: `tab_${(0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).TUNING}`,
            [`tab_${(0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).CROP}`]: `tab_${(0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).CROP}`,
            [`tab_${(0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).FILTERS}`]: `tab_${(0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).FILTERS}`,
            cancel: "cancel",
            apply: "apply",
            "a11y-editor-tab-filters": "a11y-editor-tab-filters",
            "a11y-editor-tab-tuning": "a11y-editor-tab-tuning",
            "a11y-editor-tab-crop": "a11y-editor-tab-crop"
        };
        /** @private */ this._debouncedShowLoader = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(this._showLoader.bind(this), 500);
    }
    /** @private */ _onSliderClose() {
        this.$["*showSlider"] = false;
        if (this.$["*tabId"] === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).TUNING) this.ref["tooltip-el"].classList.toggle("uc-info-tooltip_visible", false);
    }
    /**
   * @private
   * @param {String} operation
   */ _createOperationControl(operation) {
        let el = new (0, $449306e34b30b9de$export$cf5be688aafa2355)();
        // @ts-expect-error TODO: fix
        el.operation = operation;
        return el;
    }
    /**
   * @private
   * @param {String} filter
   */ _createFilterControl(filter) {
        let el = new (0, $46600dc7b4eceb17$export$1cf4b09278d815ee)();
        // @ts-expect-error TODO: fix
        el.filter = filter;
        return el;
    }
    /**
   * @private
   * @param {String} operation
   */ _createToggleControl(operation) {
        let el = new (0, $77a867df28174d0f$export$603075e7d8e604b2)();
        // @ts-expect-error TODO: fix
        el.operation = operation;
        return el;
    }
    /**
   * @private
   * @param {String} tabId
   */ _renderControlsList(tabId) {
        let listEl = this.ref[`controls-list-${tabId}`];
        let fr = document.createDocumentFragment();
        if (tabId === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).CROP) this.$.cropOperations.forEach(/** @param {string} operation */ (operation)=>{
            let el = this._createToggleControl(operation);
            // @ts-ignore
            fr.appendChild(el);
        });
        else if (tabId === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).FILTERS) [
            (0, $68b946db693b9392$export$e252352c431a3ba),
            ...this.$.filters
        ].forEach((filterId)=>{
            let el = this._createFilterControl(filterId);
            // @ts-ignore
            fr.appendChild(el);
        });
        else if (tabId === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).TUNING) this.$.colorOperations.forEach(/** @param {string} operation */ (operation)=>{
            let el = this._createOperationControl(operation);
            // @ts-ignore
            fr.appendChild(el);
        });
        [
            ...fr.children
        ].forEach((el, idx)=>{
            if (idx === fr.childNodes.length - 1) el.classList.add("uc-controls-list_last-item");
        });
        listEl.innerHTML = "";
        listEl.appendChild(fr);
    }
    /**
   * @private
   * @param {String} id
   * @param {{ fromViewer?: Boolean }} options
   */ _activateTab(id, { fromViewer: fromViewer }) {
        this.$["*tabId"] = id;
        if (id === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).CROP) {
            this.$["*faderEl"].deactivate();
            this.$["*cropperEl"].activate(this.$["*imageSize"], {
                fromViewer: fromViewer
            });
        } else {
            this.$["*faderEl"].activate({
                url: this.$["*originalUrl"],
                fromViewer: fromViewer
            });
            this.$["*cropperEl"].deactivate();
        }
        for (let tabId of (0, $8b84db27cd8d65ab$export$d9a4cca3740decc7)){
            let isCurrentTab = tabId === id;
            let tabToggleEl = this.ref[`tab-toggle-${tabId}`];
            tabToggleEl.active = isCurrentTab;
            if (isCurrentTab) {
                this._renderControlsList(id);
                this._syncTabIndicator();
            } else this._unmountTabControls(tabId);
            this.$[`presence.tabContent.${tabId}`] = isCurrentTab;
        }
    }
    /**
   * @private
   * @param {String} tabId
   */ _unmountTabControls(tabId) {
        let listEl = this.ref[`controls-list-${tabId}`];
        if (listEl) listEl.innerHTML = "";
    }
    /** @private */ _syncTabIndicator() {
        let tabToggleEl = this.ref[`tab-toggle-${this.$["*tabId"]}`];
        let indicatorEl = this.ref["tabs-indicator"];
        indicatorEl.style.transform = `translateX(${tabToggleEl.offsetLeft}px)`;
    }
    /** @private */ async _preloadEditedImage() {
        if (this.$["*imgContainerEl"] && this.$["*originalUrl"]) {
            let width = this.$["*imgContainerEl"].offsetWidth;
            let src = await this.proxyUrl((0, $be99adc3e6f9a7c0$export$fac0f4feef8b6807)(this.$["*originalUrl"], width, this.$["*editorTransformations"]));
            this._cancelPreload?.();
            let { cancel: cancel } = (0, $abbc0c6933a6d6f7$export$e425c08b8185563d)([
                src
            ]);
            this._cancelPreload = ()=>{
                cancel();
                this._cancelPreload = undefined;
            };
        }
    }
    /**
   * @private
   * @param {boolean} show
   */ _showLoader(show) {
        this.$.showLoader = show;
    }
    _updateInfoTooltip = (0, $10eeafe046ef78dd$export$61fc7d43ac8f84b0)(()=>{
        const transformations = this.$["*editorTransformations"];
        /** @type {keyof COLOR_OPERATIONS_CONFIG} */ const currentOperation = this.$["*currentOperation"];
        let text = "";
        let visible = false;
        if (this.$["*tabId"] === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).FILTERS) {
            visible = true;
            if (this.$["*currentFilter"] && transformations?.filter?.name === this.$["*currentFilter"]) {
                let value = transformations?.filter?.amount || 100;
                text = this.$["*currentFilter"] + " " + value;
            } else text = this.l10n((0, $68b946db693b9392$export$e252352c431a3ba));
        } else if (this.$["*tabId"] === (0, $8b84db27cd8d65ab$export$bb9ea7aab152411a).TUNING && currentOperation) {
            visible = true;
            let value = transformations?.[currentOperation] || (0, $8b84db27cd8d65ab$export$e3dcdd21a8cd88f9)[currentOperation].zero;
            text = this.l10n(currentOperation) + " " + value;
        }
        if (visible) this.$["*operationTooltip"] = text;
        this.ref["tooltip-el"].classList.toggle("uc-info-tooltip_visible", visible);
    }, 0);
    initCallback() {
        super.initCallback();
        this.$["*sliderEl"] = this.ref["slider-el"];
        this.sub("*imageSize", (imageSize)=>{
            if (imageSize) setTimeout(()=>{
                this._activateTab(this.$["*tabId"], {
                    fromViewer: true
                });
            }, 0);
        });
        this.sub("*editorTransformations", (editorTransformations)=>{
            let appliedFilter = editorTransformations?.filter?.name;
            if (this.$["*currentFilter"] !== appliedFilter) this.$["*currentFilter"] = appliedFilter;
        });
        this.sub("*currentFilter", ()=>{
            this._updateInfoTooltip();
        });
        this.sub("*currentOperation", ()=>{
            this._updateInfoTooltip();
        });
        this.sub("*tabId", ()=>{
            this._updateInfoTooltip();
        });
        this.sub("*originalUrl", ()=>{
            this.$["*faderEl"] && this.$["*faderEl"].deactivate();
        });
        this.sub("*editorTransformations", (transformations)=>{
            this._preloadEditedImage();
            if (this.$["*faderEl"]) this.$["*faderEl"].setTransformations(transformations);
        });
        this.sub("*loadingOperations", (/** @type {import('./types.js').LoadingOperations} */ loadingOperations)=>{
            let anyLoading = false;
            for (let [, mapping] of loadingOperations.entries()){
                if (anyLoading) break;
                for (let [, loading] of mapping.entries())if (loading) {
                    anyLoading = true;
                    break;
                }
            }
            this._debouncedShowLoader(anyLoading);
        });
        this.sub("*showSlider", (showSlider)=>{
            this.$["presence.subToolbar"] = showSlider;
            this.$["presence.mainToolbar"] = !showSlider;
        });
        this.sub("*tabList", (tabList)=>{
            this.$["presence.tabToggles"] = tabList.length > 1;
            for (const tabId of (0, $8b84db27cd8d65ab$export$d9a4cca3740decc7)){
                this.$[`presence.tabToggle.${tabId}`] = tabList.includes(tabId);
                const toggleEl = this.ref[`tab-toggle-${tabId}`];
                toggleEl.style.gridColumn = tabList.indexOf(tabId) + 1;
            }
            if (!tabList.includes(this.$["*tabId"])) this._activateTab(tabList[0], {
                fromViewer: false
            });
        });
        this._updateInfoTooltip();
    }
    destroyCallback() {
        this.$["*showSlider"] = false;
    }
}
$2a5cd161e857b06c$export$477aaffea178bc4e.template = /* HTML */ `
  <uc-line-loader-ui set="active: showLoader"></uc-line-loader-ui>
  <div class="uc-info-tooltip_container">
    <div class="uc-info-tooltip_wrapper">
      <div ref="tooltip-el" class="uc-info-tooltip uc-info-tooltip_hidden">{{*operationTooltip}}</div>
    </div>
  </div>
  <div class="uc-toolbar-container">
    <uc-presence-toggle
      role="tablist"
      class="uc-sub-toolbar"
      set="visible: presence.mainToolbar; styles: presence.subTopToolbarStyles"
    >
      <div class="uc-tab-content-row">${(0, $8b84db27cd8d65ab$export$d9a4cca3740decc7).map($2a5cd161e857b06c$var$renderTabContent).join("")}</div>
      <div class="uc-controls-row">
        <uc-presence-toggle
          class="uc-tab-toggles"
          set="visible: presence.tabToggles; styles: presence.tabTogglesStyles"
        >
          <div ref="tabs-indicator" class="uc-tab-toggles_indicator"></div>
          ${(0, $8b84db27cd8d65ab$export$d9a4cca3740decc7).map($2a5cd161e857b06c$var$renderTabToggle).join("")}
        </uc-presence-toggle>
        <uc-btn-ui style="order: -1" theme="secondary-icon" icon="closeMax" set="onclick: on.cancel; title-prop:cancel">
        </uc-btn-ui>
        <uc-btn-ui theme="primary-icon" icon="done" set="onclick: on.apply; title-prop:apply"> </uc-btn-ui>
      </div>
    </uc-presence-toggle>
    <uc-presence-toggle
      class="uc-sub-toolbar"
      set="visible: presence.subToolbar; styles: presence.subBottomToolbarStyles"
    >
      <div class="uc-slider">
        <uc-editor-slider ref="slider-el"></uc-editor-slider>
      </div>
      <div class="uc-controls-row">
        <uc-btn-ui theme="secondary" set="onclick: on.cancelSlider" l10n="@text:cancel"> </uc-btn-ui>
        <uc-btn-ui theme="primary" set="onclick: on.applySlider" l10n="@text:apply"> </uc-btn-ui>
      </div>
    </uc-presence-toggle>
  </div>
`;




class $173af55bf5b45a90$export$6cf5cd50acea2c extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    constructor(){
        super();
        this._iconReversed = false;
        this._iconSingle = false;
        this._iconHidden = false;
        this.init$ = {
            ...this.init$,
            text: "",
            icon: "",
            iconCss: this._iconCss(),
            theme: null,
            "aria-role": "",
            "aria-controls": "",
            "title-prop": ""
        };
        this.defineAccessor("active", (active)=>{
            if (active) this.setAttribute("active", "");
            else this.removeAttribute("active");
        });
    }
    _iconCss() {
        return (0, $859d48a3f3b9ecf3$export$ce4ab0c55987d1ff)("uc-icon", {
            "uc-icon_left": !this._iconReversed,
            "uc-icon_right": this._iconReversed,
            "uc-icon_hidden": this._iconHidden,
            "uc-icon_single": this._iconSingle
        });
    }
    initCallback() {
        super.initCallback();
        this.sub("icon", (iconName)=>{
            this._iconSingle = !this.$.text;
            this._iconHidden = !iconName;
            this.$.iconCss = this._iconCss();
        });
        this.sub("theme", (theme)=>{
            if (theme !== "custom") this.className = `uc-${theme}`;
        });
        this.sub("text", (txt)=>{
            this._iconSingle = false;
        });
        if (!this.hasAttribute("theme")) this.setAttribute("theme", "default");
        this.defineAccessor("aria-role", (value)=>{
            this.$["aria-role"] = value || "";
        });
        this.defineAccessor("aria-controls", (value)=>{
            this.$["aria-controls"] = value || "";
        });
        this.defineAccessor("title-prop", (value)=>{
            this.$["title-prop"] = value || "";
        });
    }
    set reverse(val) {
        if (this.hasAttribute("reverse")) {
            this.style.flexDirection = "row-reverse";
            this._iconReversed = true;
        } else {
            this._iconReversed = false;
            this.style.flexDirection = null;
        }
    }
}
$173af55bf5b45a90$export$6cf5cd50acea2c.bindAttributes({
    text: "text",
    icon: "icon",
    reverse: "reverse",
    theme: "theme"
});
$173af55bf5b45a90$export$6cf5cd50acea2c.template = /* HTML */ `
  <button
    type="button"
    set="@role:aria-role; @aria-controls: aria-controls; @aria-label:title-prop"
    l10n="@title:title-prop;"
  >
    <uc-icon set="className: iconCss; @name: icon; @hidden: !icon"></uc-icon>
    <div class="uc-text">{{text}}</div>
  </button>
`;



class $3f26b9d84520c5bc$export$21cd7d08dbb08eff extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    constructor(){
        super();
        this._active = false;
        this._handleTransitionEndRight = ()=>{
            let lineEl = this.ref["line-el"];
            lineEl.style.transition = `initial`;
            lineEl.style.opacity = "0";
            lineEl.style.transform = `translateX(-101%)`;
            this._active && this._start();
        };
    }
    initCallback() {
        super.initCallback();
        this.defineAccessor("active", (active)=>{
            if (typeof active === "boolean") {
                if (active) this._start();
                else this._stop();
            }
        });
    }
    _start() {
        this._active = true;
        let { width: width } = this.getBoundingClientRect();
        let lineEl = this.ref["line-el"];
        lineEl.style.transition = `transform 1s`;
        lineEl.style.opacity = "1";
        lineEl.style.transform = `translateX(${width}px)`;
        lineEl.addEventListener("transitionend", this._handleTransitionEndRight, {
            once: true
        });
    }
    _stop() {
        this._active = false;
    }
}
$3f26b9d84520c5bc$export$21cd7d08dbb08eff.template = /* HTML */ `
  <div class="uc-inner">
    <div class="uc-line" ref="line-el"></div>
  </div>
`;




/**
 * @typedef {Object} Style
 * @property {String} [transition]
 * @property {String} [visible]
 * @property {String} [hidden]
 */ /** @type {Style} */ const $ac3e7306634bae8b$var$DEFAULT_STYLE = {
    transition: "uc-transition",
    visible: "uc-visible",
    hidden: "uc-hidden"
};
class $ac3e7306634bae8b$export$62b432f031007740 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    constructor(){
        super();
        this._visible = false;
        this._visibleStyle = $ac3e7306634bae8b$var$DEFAULT_STYLE.visible;
        this._hiddenStyle = $ac3e7306634bae8b$var$DEFAULT_STYLE.hidden;
        this._externalTransitions = false;
        this.defineAccessor("styles", (styles)=>{
            if (!styles) return;
            this._externalTransitions = true;
            this._visibleStyle = styles.visible;
            this._hiddenStyle = styles.hidden;
        });
        this.defineAccessor("visible", (visible)=>{
            if (typeof visible !== "boolean") return;
            this._visible = visible;
            this._handleVisible();
        });
    }
    _handleVisible() {
        this.style.visibility = this._visible ? "inherit" : "hidden";
        (0, $859d48a3f3b9ecf3$export$7efcd118c973e827)(this, {
            [$ac3e7306634bae8b$var$DEFAULT_STYLE.transition]: !this._externalTransitions,
            [this._visibleStyle]: this._visible,
            [this._hiddenStyle]: !this._visible
        });
        this.setAttribute("aria-hidden", this._visible ? "false" : "true");
    }
    initCallback() {
        super.initCallback();
        this.classList.toggle("uc-initial", true);
        if (!this._externalTransitions) this.classList.add($ac3e7306634bae8b$var$DEFAULT_STYLE.transition);
        this._handleVisible();
        setTimeout(()=>{
            this.classList.toggle("uc-initial", false);
        }, 0);
    }
}
$ac3e7306634bae8b$export$62b432f031007740.template = /* HTML */ `<slot></slot> `;



class $d441ef962450dfc1$export$facfb944826701a2 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    init$ = {
        ...this.init$,
        disabled: false,
        min: 0,
        max: 100,
        onInput: null,
        onChange: null,
        defaultValue: null,
        "on.sliderInput": ()=>{
            let value = parseInt(this.ref["input-el"].value, 10);
            this._updateValue(value);
            this.$.onInput && this.$.onInput(value);
        },
        "on.sliderChange": ()=>{
            let value = parseInt(this.ref["input-el"].value, 10);
            this.$.onChange && this.$.onChange(value);
        }
    };
    constructor(){
        super();
        this.setAttribute("with-effects", "");
    }
    initCallback() {
        super.initCallback();
        this.defineAccessor("disabled", (disabled)=>{
            this.$.disabled = disabled;
        });
        this.defineAccessor("min", (min)=>{
            this.$.min = min;
        });
        this.defineAccessor("max", (max)=>{
            this.$.max = max;
        });
        this.defineAccessor("defaultValue", (defaultValue)=>{
            this.$.defaultValue = defaultValue;
            this.ref["input-el"].value = defaultValue;
            this._updateValue(defaultValue);
        });
        this.defineAccessor("zero", (zero)=>{
            this._zero = zero;
        });
        this.defineAccessor("onInput", (onInput)=>{
            if (!onInput) return;
            this.$.onInput = onInput;
        });
        this.defineAccessor("onChange", (onChange)=>{
            if (!onChange) return;
            this.$.onChange = onChange;
        });
        this._updateSteps();
        this._observer = new ResizeObserver(()=>{
            this._updateSteps();
            let value = parseInt(this.ref["input-el"].value, 10);
            this._updateValue(value);
        });
        this._observer.observe(this);
        this._thumbSize = parseInt(window.getComputedStyle(this).getPropertyValue("--l-thumb-size"), 10);
        setTimeout(()=>{
            let value = parseInt(this.ref["input-el"].value, 10);
            this._updateValue(value);
        }, 0);
        this.sub("disabled", (disabled)=>{
            let el = this.ref["input-el"];
            if (disabled) el.setAttribute("disabled", "disabled");
            else el.removeAttribute("disabled");
        });
        let inputEl = this.ref["input-el"];
        inputEl.addEventListener("focus", ()=>{
            this.style.setProperty("--color-effect", "var(--hover-color-rgb)");
        });
        inputEl.addEventListener("blur", ()=>{
            this.style.setProperty("--color-effect", "var(--idle-color-rgb)");
        });
    }
    _updateValue(value) {
        this._updateZeroDot(value);
        let { width: width } = this.getBoundingClientRect();
        let slope = 100 / (this.$.max - this.$.min);
        let mappedValue = slope * (value - this.$.min);
        let offset = mappedValue * (width - this._thumbSize) / 100;
        window.requestAnimationFrame(()=>{
            this.ref["thumb-el"].style.transform = `translateX(${offset}px)`;
        });
    }
    _updateZeroDot(value) {
        if (!this._zeroDotEl) return;
        if (value === this._zero) this._zeroDotEl.style.opacity = "0";
        else this._zeroDotEl.style.opacity = "1";
        let { width: width } = this.getBoundingClientRect();
        let slope = 100 / (this.$.max - this.$.min);
        let mappedValue = slope * (this._zero - this.$.min);
        let offset = mappedValue * (width - this._thumbSize) / 100;
        window.requestAnimationFrame(()=>{
            this._zeroDotEl.style.transform = `translateX(${offset}px)`;
        });
    }
    _updateSteps() {
        const STEP_GAP = 15;
        let stepsEl = this.ref["steps-el"];
        let { width: width } = stepsEl.getBoundingClientRect();
        let half = Math.ceil(width / 2);
        let count = Math.ceil(half / STEP_GAP) - 2;
        if (this._stepsCount === count) return;
        let fr = document.createDocumentFragment();
        let minorStepEl = document.createElement("div");
        let borderStepEl = document.createElement("div");
        minorStepEl.className = "uc-minor-step";
        borderStepEl.className = "uc-border-step";
        fr.appendChild(borderStepEl);
        for(let i = 0; i < count; i++)fr.appendChild(minorStepEl.cloneNode());
        fr.appendChild(borderStepEl.cloneNode());
        for(let i = 0; i < count; i++)fr.appendChild(minorStepEl.cloneNode());
        fr.appendChild(borderStepEl.cloneNode());
        let zeroDotEl = document.createElement("div");
        zeroDotEl.className = "uc-zero-dot";
        fr.appendChild(zeroDotEl);
        this._zeroDotEl = zeroDotEl;
        stepsEl.innerHTML = "";
        stepsEl.appendChild(fr);
        this._stepsCount = count;
    }
    destroyCallback() {
        super.destroyCallback();
        this._observer?.disconnect();
    }
}
$d441ef962450dfc1$export$facfb944826701a2.template = /* HTML */ `
  <div class="uc-steps" ref="steps-el"></div>
  <div ref="thumb-el" class="uc-thumb"></div>
  <input
    class="uc-input"
    type="range"
    ref="input-el"
    set="oninput: on.sliderInput; onchange: on.sliderChange; @min: min; @max: max; @value: defaultValue;"
  />
`;




$parcel$exportWildcard($2c4c0ec5840d1e53$exports, $ebc5de99b36543b0$exports);


// @ts-check



class $f9f3694ad31893f3$export$cb7e12222b993acb extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    activityType = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.CLOUD_IMG_EDIT;
    /**
   * @private
   * @type {import('../../abstract/TypedData.js').TypedData | undefined}
   */ _entry;
    /**
   * @private
   * @type {CloudImageEditorBlock | undefined}
   */ _instance;
    /** @type {ActivityParams} */ get activityParams() {
        const params = super.activityParams;
        if ("internalId" in params) return params;
        throw new Error(`Cloud Image Editor activity params not found`);
    }
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType, {
            onActivate: ()=>this.mountEditor(),
            onDeactivate: ()=>this.unmountEditor()
        });
        this.subConfigValue("cropPreset", (cropPreset)=>{
            if (this._instance && this._instance.getAttribute("crop-preset") !== cropPreset) this._instance.setAttribute("crop-preset", cropPreset);
        });
        this.subConfigValue("cloudImageEditorTabs", (tabs)=>{
            if (this._instance && this._instance.getAttribute("tabs") !== tabs) this._instance.setAttribute("tabs", tabs);
        });
    }
    /** @param {CustomEvent<import('../CloudImageEditor/src/types.js').ApplyResult>} e */ handleApply(e) {
        if (!this._entry) return;
        let result = e.detail;
        this._entry.setMultipleValues({
            cdnUrl: result.cdnUrl,
            cdnUrlModifiers: result.cdnUrlModifiers
        });
        this.historyBack();
    }
    handleCancel() {
        this.historyBack();
    }
    mountEditor() {
        const { internalId: internalId } = this.activityParams;
        this._entry = this.uploadCollection.read(internalId);
        if (!this._entry) throw new Error(`Entry with internalId "${internalId}" not found`);
        const cdnUrl = this._entry.getValue("cdnUrl");
        if (!cdnUrl) throw new Error(`Entry with internalId "${internalId}" hasn't uploaded yet`);
        const instance = new (0, $1bdc7ce1b3bbbe34$export$20cace3f5dd477e2)();
        const cropPreset = this.cfg.cropPreset;
        const tabs = this.cfg.cloudImageEditorTabs;
        instance.setAttribute("ctx-name", this.ctxName);
        instance.setAttribute("cdn-url", cdnUrl);
        if (cropPreset) instance.setAttribute("crop-preset", cropPreset);
        if (tabs) instance.setAttribute("tabs", tabs);
        instance.addEventListener("apply", (e)=>{
            const customEvent = /** @type {CustomEvent<import('../CloudImageEditor/src/types.js').ApplyResult>} */ e;
            this.handleApply(customEvent);
            this.debugPrint(`editor event "apply"`, customEvent.detail);
        });
        instance.addEventListener("cancel", (e)=>{
            const customEvent = /** @type {CustomEvent<void>} */ e;
            this.handleCancel();
            this.debugPrint(`editor event "cancel"`, customEvent.detail);
        });
        instance.addEventListener("change", (e)=>{
            const customEvent = /** @type {CustomEvent<import('../CloudImageEditor/src/types.js').ChangeResult>} */ e;
            this.debugPrint(`editor event "change"`, customEvent.detail);
        });
        this.innerHTML = "";
        this.appendChild(instance);
        this._instance = instance;
    }
    unmountEditor() {
        this._instance = undefined;
        this._entry = undefined;
        this.innerHTML = "";
    }
}


// @ts-check




/**
 * @param {string} str
 * @returns {string}
 */ const $d44bfde65723c54c$var$escapeRegExp = function(str) {
    return str.replace(/[\\-\\[]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
};
const $d44bfde65723c54c$export$2c080af651447618 = function(str, flags = "i") {
    const parts = str.split("*").map($d44bfde65723c54c$var$escapeRegExp);
    return new RegExp("^" + parts.join(".+") + "$", flags);
};


// @ts-check
/**
 * @param {HTMLElement} element
 * @param {string} propName
 */ function $5d1fce096039d6c8$var$getCssValue(element, propName) {
    let style = window.getComputedStyle(element);
    return style.getPropertyValue(propName).trim();
}
const $5d1fce096039d6c8$var$ucCustomProperties = /** @type {(keyof import('./types.js').ThemeDefinition)[]} */ [
    "--uc-font-family",
    "--uc-font-size",
    "--uc-line-height",
    "--uc-button-size",
    "--uc-preview-size",
    "--uc-input-size",
    "--uc-padding",
    "--uc-radius",
    "--uc-transition",
    "--uc-background",
    "--uc-foreground",
    "--uc-primary",
    "--uc-primary-hover",
    "--uc-primary-transparent",
    "--uc-primary-foreground",
    "--uc-secondary",
    "--uc-secondary-hover",
    "--uc-secondary-foreground",
    "--uc-muted",
    "--uc-muted-foreground",
    "--uc-destructive",
    "--uc-destructive-foreground",
    "--uc-border"
];
function $5d1fce096039d6c8$export$89eb5c9ea17ff80d(element) {
    return $5d1fce096039d6c8$var$ucCustomProperties.reduce((acc, prop)=>{
        const value = $5d1fce096039d6c8$var$getCssValue(element, prop);
        if (value) acc[prop] = value;
        return acc;
    }, /** @type {Record<keyof import('./types.js').ThemeDefinition, string>} */ {});
}


/** @type {import('./types').InputMessageType[]} */ const $6c2cf51e6af683f4$var$MESSAGE_TYPE_WHITELIST = [
    "selected-files-change"
];
/**
 * @param {unknown} message
 * @returns {message is import("./types").InputMessageMap[import("./types").InputMessageType]}
 */ const $6c2cf51e6af683f4$var$isWhitelistedMessage = (message)=>{
    if (!message) return false;
    if (typeof message !== "object") return false;
    return "type" in message && $6c2cf51e6af683f4$var$MESSAGE_TYPE_WHITELIST.includes(/** @type {import('./types').InputMessageType} */ message.type);
};
class $6c2cf51e6af683f4$export$8f4a692269911007 {
    /** @type {Map<string, Set<import('./types').InputMessageHandler<import('./types').InputMessageType>>>} */ _handlerMap = new Map();
    /** @type {Window} */ _context;
    /** @param {Window} context */ constructor(context){
        this._context = context;
        window.addEventListener("message", this._handleMessage);
    }
    /** @param {MessageEvent} e */ _handleMessage = (e)=>{
        if (e.source !== this._context) return;
        const message = e.data;
        if (!$6c2cf51e6af683f4$var$isWhitelistedMessage(message)) return;
        const handlers = this._handlerMap.get(message.type);
        if (handlers) for (const handler of handlers)handler(message);
    };
    /**
   * @template {import('./types').InputMessageType} T
   * @param {T} type
   * @param {import('./types').InputMessageHandler<T>} handler
   */ on(type, handler) {
        const handlers = this._handlerMap.get(type) ?? new Set();
        if (!this._handlerMap.has(type)) this._handlerMap.set(type, handlers);
        handlers.add(/** @type {import('./types').InputMessageHandler<import('./types').InputMessageType>} */ handler);
    }
    /** @param {import('./types').OutputMessage} message */ send(message) {
        this._context.postMessage(message, "*");
    }
    destroy() {
        window.removeEventListener("message", this._handleMessage);
    }
}


/**
 * @param {{ [key: string]: string | number | boolean | null | undefined }} params
 * @returns {string}
 */ function $103d47370d8a609c$export$ded69dcd8ce7e468(params) {
    let list = [];
    for (let [key, value] of Object.entries(params)){
        if (value === undefined || value === null || typeof value === "string" && value.length === 0) continue;
        list.push(`${key}=${encodeURIComponent(value)}`);
    }
    return list.join("&");
}


class $1dbb14c13d11dd7b$export$ffc19e40a21f08eb extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    couldBeCtxOwner = true;
    activityType = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.EXTERNAL;
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            activityIcon: "",
            activityCaption: "",
            /** @type {import('./types.js').InputMessageMap['selected-files-change']['selectedFiles']} */ selectedList: [],
            total: 0,
            isSelectionReady: false,
            isDoneBtnEnabled: false,
            couldSelectAll: false,
            couldDeselectAll: false,
            showSelectionStatus: false,
            counterText: "",
            doneBtnTextClass: "uc-hidden",
            onDone: ()=>{
                for (const message of this.$.selectedList){
                    const url = this.extractUrlFromSelectedFile(message);
                    const { filename: filename } = message;
                    const { externalSourceType: externalSourceType } = this.activityParams;
                    this.api.addFileFromUrl(url, {
                        fileName: filename,
                        source: externalSourceType
                    });
                }
                this.$["*currentActivity"] = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
            },
            onCancel: ()=>{
                this.historyBack();
            },
            onSelectAll: ()=>{
                this._messageBridge?.send({
                    type: "select-all"
                });
            },
            onDeselectAll: ()=>{
                this._messageBridge?.send({
                    type: "deselect-all"
                });
            }
        };
    }
    /** @type {ActivityParams} */ get activityParams() {
        const params = super.activityParams;
        if ("externalSourceType" in params) return params;
        throw new Error(`External Source activity params not found`);
    }
    initCallback() {
        super.initCallback();
        this.registerActivity(this.activityType, {
            onActivate: ()=>{
                let { externalSourceType: externalSourceType } = /** @type {ActivityParams} */ this.activityParams;
                if (!externalSourceType) {
                    this.$["*currentActivity"] = null;
                    this.setOrAddState("*modalActive", false);
                    console.error(`Param "externalSourceType" is required for activity "${this.activityType}"`);
                    return;
                }
                this.set$({
                    activityCaption: `${externalSourceType?.[0].toUpperCase()}${externalSourceType?.slice(1)}`,
                    activityIcon: externalSourceType
                });
                this.mountIframe();
            }
        });
        this.sub("*currentActivityParams", (val)=>{
            if (!this.isActivityActive) return;
            this.unmountIframe();
            this.mountIframe();
        });
        this.sub("*currentActivity", (val)=>{
            if (val !== this.activityType) this.unmountIframe();
        });
        this.subConfigValue("multiple", (multiple)=>{
            this.$.showSelectionStatus = multiple;
        });
        this.subConfigValue("localeName", (val)=>{
            this.setupL10n();
        });
        this.subConfigValue("externalSourcesEmbedCss", (embedCss)=>{
            this.applyEmbedCss(embedCss);
        });
    }
    /**
   * @private
   * @param {NonNullable<import('./types.js').InputMessageMap['selected-files-change']['selectedFiles']>[number]} selectedFile
   */ extractUrlFromSelectedFile(selectedFile) {
        if (selectedFile.alternatives) {
            const preferredTypes = (0, $15ba4abb0cb95799$export$b9ca061da17f2d30)(this.cfg.externalSourcesPreferredTypes);
            for (const preferredType of preferredTypes){
                const regexp = (0, $d44bfde65723c54c$export$2c080af651447618)(preferredType);
                for (const [type, typeUrl] of Object.entries(selectedFile.alternatives)){
                    if (regexp.test(type)) return typeUrl;
                }
            }
        }
        return selectedFile.url;
    }
    /**
   * @private
   * @param {import('./types.js').InputMessageMap['selected-files-change']} message
   */ async handleSelectedFilesChange(message) {
        if (this.cfg.multiple !== message.isMultipleMode) {
            console.error("Multiple mode mismatch");
            return;
        }
        this.bindL10n("counterText", ()=>this.l10n("selected-count", {
                count: message.selectedCount,
                total: message.total
            }));
        this.set$({
            doneBtnTextClass: message.isReady ? "" : "uc-hidden",
            isSelectionReady: message.isReady,
            isDoneBtnEnabled: message.isReady && message.selectedFiles.length > 0,
            showSelectionStatus: message.isMultipleMode && message.total > 0,
            couldSelectAll: message.selectedCount < message.total,
            couldDeselectAll: message.selectedCount === message.total,
            selectedList: message.selectedFiles
        });
    }
    /** @private */ handleIframeLoad() {
        this.applyEmbedCss(this.cfg.externalSourcesEmbedCss);
        this.applyTheme();
        this.setupL10n();
    }
    /** @private */ applyTheme() {
        this._messageBridge?.send({
            type: "set-theme-definition",
            theme: (0, $5d1fce096039d6c8$export$89eb5c9ea17ff80d)(this)
        });
    }
    /**
   * @private
   * @param {string} css
   */ applyEmbedCss(css) {
        this._messageBridge?.send({
            type: "set-embed-css",
            css: css
        });
    }
    /** @private */ setupL10n() {
        this._messageBridge?.send({
            type: "set-locale-definition",
            localeDefinition: this.cfg.localeName
        });
    }
    /** @private */ remoteUrl() {
        const { pubkey: pubkey, remoteTabSessionKey: remoteTabSessionKey, socialBaseUrl: socialBaseUrl, multiple: multiple } = this.cfg;
        const { externalSourceType: externalSourceType } = this.activityParams;
        const lang = this.l10n("social-source-lang")?.split("-")?.[0] || "en";
        const params = {
            lang: lang,
            public_key: pubkey,
            images_only: false.toString(),
            session_key: remoteTabSessionKey,
            wait_for_theme: true,
            multiple: multiple.toString()
        };
        const url = new URL(`/window4/${externalSourceType}`, socialBaseUrl);
        url.search = (0, $103d47370d8a609c$export$ded69dcd8ce7e468)(params);
        return url.toString();
    }
    /** @private */ mountIframe() {
        /** @type {HTMLIFrameElement} */ // @ts-ignore
        let iframe = (0, $7868cd5b229e5c15$export$185802fd694ee1f5)({
            tag: "iframe",
            attributes: {
                src: this.remoteUrl(),
                marginheight: 0,
                marginwidth: 0,
                frameborder: 0,
                allowTransparency: true
            }
        });
        iframe.addEventListener("load", this.handleIframeLoad.bind(this));
        this.ref.iframeWrapper.innerHTML = "";
        this.ref.iframeWrapper.appendChild(iframe);
        if (!iframe.contentWindow) return;
        this._messageBridge?.destroy();
        /** @private */ this._messageBridge = new (0, $6c2cf51e6af683f4$export$8f4a692269911007)(iframe.contentWindow);
        this._messageBridge.on("selected-files-change", this.handleSelectedFilesChange.bind(this));
        this.resetSelectionStatus();
    }
    /** @private */ unmountIframe() {
        this._messageBridge?.destroy();
        this._messageBridge = undefined;
        this.ref.iframeWrapper.innerHTML = "";
        this.resetSelectionStatus();
    }
    /** @private */ resetSelectionStatus() {
        this.set$({
            selectedList: [],
            total: 0,
            isDoneBtnEnabled: false,
            couldSelectAll: false,
            couldDeselectAll: false,
            showSelectionStatus: false
        });
    }
}
$1dbb14c13d11dd7b$export$ffc19e40a21f08eb.template = /* HTML */ `
  <uc-activity-header>
    <button
      type="button"
      class="uc-mini-btn uc-close-btn"
      set="onclick: *historyBack"
      l10n="@title:a11y-activity-header-button-close;@aria-label:a11y-activity-header-button-close"
    >
      <uc-icon name="close"></uc-icon>
    </button>
  </uc-activity-header>
  <div class="uc-content">
    <div ref="iframeWrapper" class="uc-iframe-wrapper"></div>
    <div class="uc-toolbar">
      <button type="button" class="uc-cancel-btn uc-secondary-btn" set="onclick: onCancel" l10n="cancel"></button>
      <div set="@hidden: !showSelectionStatus" class="uc-selection-status-box">
        <span>{{counterText}}</span>
        <button type="button" set="onclick: onSelectAll; @hidden: !couldSelectAll" l10n="select-all"></button>
        <button type="button" set="onclick: onDeselectAll; @hidden: !couldDeselectAll" l10n="deselect-all"></button>
      </div>
      <button type="button" class="uc-done-btn uc-primary-btn" set="onclick: onDone; @disabled: !isDoneBtnEnabled;">
        <uc-spinner set="@hidden: isSelectionReady"></uc-spinner>
        <span l10n="done" set="@class: doneBtnTextClass"></span>
      </button>
    </div>
  </div>
`;


// @ts-check


class $fa3d8930d0ddec4e$export$fd970bbd10854e43 extends (0, $764ed4a1a24a6ef1$export$5ece2da0ca12cb21) {
    requireCtxName = true;
    _createValidationInput() {
        const validationInput = document.createElement("input");
        validationInput.type = "text";
        validationInput.name = this.ctxName;
        validationInput.required = this.cfg.multipleMin > 0;
        validationInput.tabIndex = -1;
        (0, $7868cd5b229e5c15$export$41428deff1a0db9e)(validationInput, {
            opacity: 0,
            height: 0,
            width: 0
        });
        return validationInput;
    }
    initCallback() {
        super.initCallback();
        this._validationInputElement = this._createValidationInput();
        this.appendChild(this._validationInputElement);
        this.sub("*collectionState", (/** @type {import('../../types/index.js').OutputCollectionState} */ collectionState)=>{
            {
                if (!this._dynamicInputsContainer) {
                    this._dynamicInputsContainer = document.createElement("div");
                    this.appendChild(this._dynamicInputsContainer);
                }
                if (!this._validationInputElement) {
                    const input = this._createValidationInput();
                    this.appendChild(input);
                    this._validationInputElement = input;
                }
                this._dynamicInputsContainer.innerHTML = "";
                if (collectionState.status === "uploading" || collectionState.status === "idle") {
                    this._validationInputElement.value = "";
                    this._validationInputElement.setCustomValidity("");
                    return;
                }
                if (collectionState.status === "failed") {
                    const errorMsg = collectionState.errors[0]?.message;
                    this._validationInputElement.value = "";
                    this._validationInputElement.setCustomValidity(errorMsg);
                    return;
                }
                const group = collectionState.group ? collectionState.group : null;
                if (group) {
                    this._validationInputElement.value = group.cdnUrl;
                    this._validationInputElement.setCustomValidity("");
                    return;
                }
                const cdnUrls = collectionState.allEntries.map((entry)=>entry.cdnUrl);
                if (!this.cfg.multiple && cdnUrls.length === 1) {
                    this._validationInputElement.value = cdnUrls[0];
                    this._validationInputElement.setCustomValidity("");
                    return;
                }
                // Remove validation input to prevent it from being submitted
                this._validationInputElement.remove();
                this._validationInputElement = null;
                const fr = new DocumentFragment();
                for (let value of cdnUrls){
                    const input = document.createElement("input");
                    input.type = "hidden";
                    input.name = `${this.ctxName}[]`;
                    input.value = value;
                    fr.appendChild(input);
                }
                this._dynamicInputsContainer.replaceChildren(fr);
            }
        }, false);
    }
}



class $c011cf78e0b82aca$export$cdc1ca0f45c41261 extends (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747) {
}



class $4b4d4c473b7bff40$export$ef9b1a59e592288f extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    init$ = {
        ...this.init$,
        currentText: "",
        options: [],
        selectHtml: "",
        onSelect: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.value = this.ref.select.value;
            this.$.currentText = this.$.options.find((opt)=>{
                return opt.value == this.value;
            })?.text || "";
            this.dispatchEvent(new Event("change"));
        }
    };
    initCallback() {
        super.initCallback();
        this.sub("options", (/** @type {{ text: String; value: String }[]} */ options)=>{
            this.$.currentText = options?.[0]?.text || "";
            let html = "";
            options?.forEach((opt)=>{
                html += /* HTML */ `<option value="${opt.value}">${opt.text}</option>`;
            });
            this.$.selectHtml = html;
        });
    }
}
$4b4d4c473b7bff40$export$ef9b1a59e592288f.template = /* HTML */ ` <select ref="select" set="innerHTML: selectHtml; onchange: onSelect"></select> `;



class $0236056c1c7caf3c$export$7b024d8cdfcd6192 extends (0, $07ad8cbe44b14bef$export$d96a8827a60d6b69) {
    initCallback() {
        super.initCallback();
        this.subConfigValue("removeCopyright", /** @param {number} value */ (value)=>{
            this.toggleAttribute("hidden", !!value);
        });
    }
    static template = /* HTML */ `
    <a
      href="https://uploadcare.com/?utm_source=copyright&utm_medium=referral&utm_campaign=v4"
      target="_blank noopener"
      class="uc-credits"
      >Powered by Uploadcare</a
    >
  `;
}



class $37e2dd26bdb63f12$export$7f7cbe89f1eacd2 extends (0, $7868cd5b229e5c15$export$55ae5207ce896a6b) {
}
$37e2dd26bdb63f12$export$7f7cbe89f1eacd2.template = /* HTML */ ` <div class="uc-spinner"></div> `;


// @ts-check



class $9d9a977fd07c0024$export$2c9ccda59fbaf1f6 extends (0, $ef19f577698fac1f$export$bec543de6927e621) {
    static styleAttrs = [
        ...super.styleAttrs,
        "uc-file-uploader-regular"
    ];
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            isHidden: false
        };
    }
    initCallback() {
        super.initCallback();
        this.defineAccessor("headless", /** @param {unknown} value */ (value)=>{
            this.set$({
                isHidden: (0, $cb0db7406dd90abe$export$ffde277b1072591c)(value)
            });
        });
        this.sub("*modalActive", (modalActive)=>{
            if (this._lastModalActive !== modalActive) this.emit(modalActive ? (0, $068cac2d61e2e514$export$3d7865934588d77e).MODAL_OPEN : (0, $068cac2d61e2e514$export$3d7865934588d77e).MODAL_CLOSE, undefined, {
                debounce: true
            });
            /** @private */ this._lastModalActive = modalActive;
        }, false);
    }
}
$9d9a977fd07c0024$export$2c9ccda59fbaf1f6.template = /* HTML */ `
  <uc-simple-btn set="@hidden: isHidden"></uc-simple-btn>

  <uc-modal strokes block-body-scrolling>
    <uc-start-from>
      <uc-drop-area with-icon clickable></uc-drop-area>
      <uc-source-list role="list" wrap></uc-source-list>
      <button type="button" l10n="start-from-cancel" class="uc-secondary-btn" set="onclick: *historyBack"></button>
      <uc-copyright></uc-copyright>
    </uc-start-from>
    <uc-upload-list></uc-upload-list>
    <uc-camera-source></uc-camera-source>
    <uc-url-source></uc-url-source>
    <uc-external-source></uc-external-source>
    <uc-cloud-image-editor-activity></uc-cloud-image-editor-activity>
  </uc-modal>
`;
$9d9a977fd07c0024$export$2c9ccda59fbaf1f6.bindAttributes({
    // @ts-expect-error TODO: fix types inside symbiote
    headless: null
});




class $01521abbf07f210c$export$e225fbea59169a64 extends (0, $ef19f577698fac1f$export$bec543de6927e621) {
    static styleAttrs = [
        ...super.styleAttrs,
        "uc-file-uploader-minimal"
    ];
    initCallback() {
        super.initCallback();
        /** @type {import('../../../abstract/UploaderBlock.js').UploaderBlock} */ const uBlock = this.ref.uBlock;
        this.sub("*currentActivity", (val)=>{
            if (!val) this.$["*currentActivity"] = uBlock.initActivity || (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.START_FROM;
        });
        this.sub("*uploadList", (list)=>{
            if (list?.length > 0) this.$["*currentActivity"] = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
            else this.$["*currentActivity"] = uBlock.initActivity || (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.START_FROM;
        });
        this.subConfigValue("sourceList", (sourceList)=>{
            if (sourceList !== "local") this.cfg.sourceList = "local";
        });
        this.subConfigValue("confirmUpload", (confirmUpload)=>{
            if (confirmUpload !== false) this.cfg.confirmUpload = false;
        });
    }
}
$01521abbf07f210c$export$e225fbea59169a64.template = /* HTML */ `
  <uc-start-from>
    <uc-drop-area tabindex="0" clickable l10n="choose-file"></uc-drop-area>
    <uc-copyright></uc-copyright>
  </uc-start-from>
  <uc-upload-list ref="uBlock"></uc-upload-list>
`;


// @ts-check


class $e0efb1ca2d7cdb15$export$1930c3118e9a7a5e extends (0, $ef19f577698fac1f$export$bec543de6927e621) {
    static styleAttrs = [
        ...super.styleAttrs,
        "uc-file-uploader-inline"
    ];
    constructor(){
        super();
        this.init$ = {
            ...this.init$,
            couldCancel: false,
            cancel: ()=>{
                if (this.couldHistoryBack) this.$["*historyBack"]();
                else if (this.couldShowList) this.$["*currentActivity"] = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
            }
        };
    }
    get couldHistoryBack() {
        const history = this.$["*history"];
        return history.length > 1 && history[history.length - 1] !== (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.START_FROM;
    }
    get couldShowList() {
        return this.cfg.showEmptyList || this.$["*uploadList"].length > 0;
    }
    initCallback() {
        super.initCallback();
        /** @type {import('../../../abstract/UploaderBlock.js').UploaderBlock} */ const uBlock = this.ref.uBlock;
        this.sub("*currentActivity", (val)=>{
            if (!val) this.$["*currentActivity"] = uBlock.initActivity || (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.START_FROM;
        });
        this.sub("*uploadList", (list)=>{
            if (list?.length > 0 && this.$["*currentActivity"] === (uBlock.initActivity || (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.START_FROM)) this.$["*currentActivity"] = (0, $cdc07cfe072a0265$export$5e3ae1ab277e5747).activities.UPLOAD_LIST;
        });
        this.sub("*history", ()=>{
            this.$["couldCancel"] = this.couldHistoryBack || this.couldShowList;
        });
    }
}
$e0efb1ca2d7cdb15$export$1930c3118e9a7a5e.template = /* HTML */ `
  <uc-start-from>
    <uc-drop-area with-icon clickable></uc-drop-area>
    <uc-source-list role="list" wrap></uc-source-list>
    <button
      type="button"
      l10n="start-from-cancel"
      class="uc-cancel-btn uc-secondary-btn"
      set="onclick: cancel; @hidden: !couldCancel"
    ></button>
    <uc-copyright></uc-copyright>
  </uc-start-from>
  <uc-upload-list ref="uBlock"></uc-upload-list>
  <uc-camera-source></uc-camera-source>
  <uc-url-source></uc-url-source>
  <uc-external-source></uc-external-source>
  <uc-cloud-image-editor-activity></uc-cloud-image-editor-activity>
`;


// @ts-check

class $0ad990545254a1c2$export$f41f1027242219f6 extends (0, $1bdc7ce1b3bbbe34$export$20cace3f5dd477e2) {
    static styleAttrs = [
        ...super.styleAttrs,
        "uc-wgt-common"
    ];
    initCallback() {
        super.initCallback();
        this.a11y?.registerBlock(this);
    }
}


/** @param {Object<string, any>} blockExports */ function $a95e7041a2b08d01$export$eedad10bc030664d(blockExports) {
    for(let blockName in blockExports){
        let tagName = [
            ...blockName
        ].reduce((name, char)=>{
            if (char.toUpperCase() === char) char = "-" + char.toLowerCase();
            return name += char;
        }, "");
        if (tagName.startsWith("-")) tagName = tagName.replace("-", "");
        if (!tagName.startsWith("uc-")) tagName = "uc-" + tagName;
        if (blockExports[blockName].reg) blockExports[blockName].reg(tagName);
    }
}




const $b02aaa1e9c1c5b67$export$3d824bcd20885a63 = "UC";
async function $b02aaa1e9c1c5b67$export$9ba6249374db0928(url, register = false) {
    return new Promise((resolve, reject)=>{
        if (typeof document !== "object") {
            resolve(null);
            return;
        }
        if (typeof window === "object" && window[$b02aaa1e9c1c5b67$export$3d824bcd20885a63]) {
            resolve(window[$b02aaa1e9c1c5b67$export$3d824bcd20885a63]);
            return;
        }
        let script = document.createElement("script");
        script.async = true;
        script.src = url;
        script.onerror = ()=>{
            reject();
        };
        script.onload = ()=>{
            /** @type {import('../index.js')} */ let blocks = window[$b02aaa1e9c1c5b67$export$3d824bcd20885a63];
            register && (0, $a95e7041a2b08d01$export$eedad10bc030664d)(blocks);
            resolve(blocks);
        };
        document.head.appendChild(script);
    });
}





var $51e936b16093f89b$exports = {};
/* eslint-disable import/export */ var $9c4b7c9e5cf21b78$exports = {};


var $3a2b79916336418e$exports = {};


$parcel$exportWildcard($51e936b16093f89b$exports, $9c4b7c9e5cf21b78$exports);
$parcel$exportWildcard($51e936b16093f89b$exports, $3a2b79916336418e$exports);


$parcel$exportWildcard($c84717ce84e05cfa$exports, $2c4c0ec5840d1e53$exports);
$parcel$exportWildcard($c84717ce84e05cfa$exports, $4b0d1e35b7235ecb$exports);
$parcel$exportWildcard($c84717ce84e05cfa$exports, $51e936b16093f89b$exports);



var $e1jtj = parcelRequire("e1jtj");
var $ir4bw = parcelRequire("ir4bw");

const $1202f55c93d3422a$var$b = /* @__PURE__ */ new Set([
    "children",
    "ref",
    "style",
    "className"
]), $1202f55c93d3422a$var$A = (e = {})=>Object == null ? void 0 : Object.keys(e).reduce((n, o)=>{
        var s, t;
        const r = e == null ? void 0 : e[o], a = `on${(t = (s = r == null ? void 0 : r.split("-")) == null ? void 0 : s.map((c)=>c.charAt(0).toUpperCase() + c.slice(1))) == null ? void 0 : t.join("")}`;
        return n[a] = r, n;
    }, {}), $1202f55c93d3422a$var$m = /* @__PURE__ */ new WeakMap(), $1202f55c93d3422a$var$M = (e)=>{
    let n = $1202f55c93d3422a$var$m.get(e);
    return n === void 0 && (n = /* @__PURE__ */ new Map(), $1202f55c93d3422a$var$m.set(e, n)), n;
}, $1202f55c93d3422a$var$E = ({ node: e, nameProp: n, valueProp: o, prevValueProp: s, event: t })=>{
    if (t !== void 0) {
        if (o !== s) {
            const r = $1202f55c93d3422a$var$M(e), a = r.has(t);
            let c = r.get(t);
            o !== void 0 ? a ? c.handleEvent = o : (c = {
                handleEvent: o
            }, r.set(t, c), e.addEventListener(t, (u)=>c.handleEvent(u.detail))) : a && (r.delete(t), e.removeEventListener(t, c));
        }
        return;
    }
    e[n] = o, o == null && n in HTMLElement.prototype && e.removeAttribute(n);
}, $1202f55c93d3422a$var$O = (e, n, o)=>{
    const s = {}, t = {};
    return Object.entries(e).forEach(([r, a])=>{
        $1202f55c93d3422a$var$b.has(r) ? s[r === "className" ? "class" : r] = a : n.has(r) || r in o.prototype ? t[r] = a : s[r] = a;
    }), {
        reactProps: s,
        customElProps: t
    };
}, $1202f55c93d3422a$export$8b22cf2602fb60ce = ({ react: e, // https://react.dev/warnings/invalid-hook-call-warning
tag: n, elClass: o, schemaEvents: s })=>{
    const t = $1202f55c93d3422a$var$A(s), r = new Set(Object.keys(t ?? {})), a = e.forwardRef((c, u)=>{
        const i = e.useRef(/* @__PURE__ */ new Map()), d = e.useRef(null), { reactProps: h, customElProps: f } = $1202f55c93d3422a$var$O(c, r, o);
        return e.useLayoutEffect(()=>{
            if (d.current === null) return;
            const p = /* @__PURE__ */ new Map();
            for(const l in f)$1202f55c93d3422a$var$E({
                node: d.current,
                nameProp: l,
                valueProp: f[l],
                prevValueProp: i.current.get(l),
                event: t[l]
            }), i.current.delete(l), p.set(l, c[l]);
            for (const [l, C] of i.current)$1202f55c93d3422a$var$E({
                node: d.current,
                nameProp: l,
                valueProp: void 0,
                prevValueProp: C,
                event: t[l]
            });
            i.current = p;
        }), e.createElement(n ?? o.__tag, {
            ...h,
            ref: e.useCallback((p)=>{
                d.current = p, typeof u == "function" ? u(p) : u !== null && (u.current = p);
            }, [
                u
            ])
        });
    });
    return a.displayName = o.name, a;
}, $1202f55c93d3422a$export$ebd11618f299a286 = $1202f55c93d3422a$export$8b22cf2602fb60ce({
    react: (0, $e1jtj.default),
    tag: "uc-config",
    elClass: $8f4a76de4f7f9134$export$29cd7b75162a9425
}), $1202f55c93d3422a$export$db3b6bfb95261072 = $1202f55c93d3422a$export$8b22cf2602fb60ce({
    react: (0, $e1jtj.default),
    tag: "uc-upload-ctx-provider",
    elClass: $91463e4c4d2c2556$export$6edf8f70f62f022d,
    schemaEvents: $91463e4c4d2c2556$export$6edf8f70f62f022d.EventType
}), $1202f55c93d3422a$export$39b482c5e57630a8 = (e)=>{
    const n = {}, o = {}, s = {};
    for (const [t, r] of Object.entries(e)){
        if (t.startsWith("on")) {
            n[t] = r;
            continue;
        }
        if (t === "headless") {
            s[t] = r;
            continue;
        }
        o[t] = r;
    }
    return {
        eventHandlers: n,
        uploader: s,
        config: o
    };
}, $1202f55c93d3422a$var$U = "1.5.0", $1202f55c93d3422a$var$j = "React-Uploader", $1202f55c93d3422a$export$407448d2b89b1813 = ()=>`${$1202f55c93d3422a$var$j}/${$1202f55c93d3422a$var$U}`, $1202f55c93d3422a$export$e7094788287c5e9b = ({ children: e })=>e, $1202f55c93d3422a$export$3b14a55fb2447963 = ()=>{
    const [e, n] = (0, $ir4bw.useState)(!1);
    return (0, $ir4bw.useEffect)(()=>{
        typeof window < "u" && n(!0);
    }, []), e;
};


$c84717ce84e05cfa$exports.defineComponents($c84717ce84e05cfa$exports);
const $dd4308b476c9d480$var$I = (0, $1202f55c93d3422a$export$8b22cf2602fb60ce)({
    react: (0, $e1jtj.default),
    tag: "uc-file-uploader-regular",
    elClass: $c84717ce84e05cfa$exports.FileUploaderRegular
}), $dd4308b476c9d480$export$2c9ccda59fbaf1f6 = ({ ctxName: a, className: s, classNameUploader: l, apiRef: c, fallback: i, ...n })=>{
    const t = (0, $ir4bw.useMemo)(()=>a ?? $c84717ce84e05cfa$exports.UID.generate(), [
        a
    ]), { eventHandlers: d, config: g, uploader: m } = (0, $ir4bw.useMemo)(()=>(0, $1202f55c93d3422a$export$39b482c5e57630a8)(n), [
        n
    ]), p = (0, $1202f55c93d3422a$export$3b14a55fb2447963)();
    return /* @__PURE__ */ (0, $e1jtj.default).createElement((0, $1202f55c93d3422a$export$e7094788287c5e9b), {
        condition: p,
        fallback: i
    }, /* @__PURE__ */ (0, $e1jtj.default).createElement("div", {
        className: s
    }, /* @__PURE__ */ (0, $e1jtj.default).createElement((0, $1202f55c93d3422a$export$ebd11618f299a286), {
        userAgentIntegration: (0, $1202f55c93d3422a$export$407448d2b89b1813)(),
        "ctx-name": t,
        ...g
    }), /* @__PURE__ */ (0, $e1jtj.default).createElement((0, $1202f55c93d3422a$export$db3b6bfb95261072), {
        ref: c,
        "ctx-name": t,
        ...d
    }), /* @__PURE__ */ (0, $e1jtj.default).createElement($dd4308b476c9d480$var$I, {
        class: l,
        "ctx-name": t,
        ...m
    })));
};



var $e1jtj = parcelRequire("e1jtj");
var $ir4bw = parcelRequire("ir4bw");


$c84717ce84e05cfa$exports.defineComponents($c84717ce84e05cfa$exports);
const $72458abfe534965c$var$M = (0, $1202f55c93d3422a$export$8b22cf2602fb60ce)({
    react: (0, $e1jtj.default),
    tag: "uc-file-uploader-minimal",
    elClass: $c84717ce84e05cfa$exports.FileUploaderMinimal
}), $72458abfe534965c$export$e225fbea59169a64 = ({ ctxName: n, className: s, classNameUploader: i, apiRef: l, fallback: c, ...r })=>{
    const a = (0, $ir4bw.useMemo)(()=>n ?? $c84717ce84e05cfa$exports.UID.generate(), [
        n
    ]), { eventHandlers: m, config: d } = (0, $ir4bw.useMemo)(()=>(0, $1202f55c93d3422a$export$39b482c5e57630a8)(r), [
        r
    ]), p = (0, $1202f55c93d3422a$export$3b14a55fb2447963)();
    return /* @__PURE__ */ (0, $e1jtj.default).createElement((0, $1202f55c93d3422a$export$e7094788287c5e9b), {
        condition: p,
        fallback: c
    }, /* @__PURE__ */ (0, $e1jtj.default).createElement("div", {
        className: s
    }, /* @__PURE__ */ (0, $e1jtj.default).createElement((0, $1202f55c93d3422a$export$ebd11618f299a286), {
        userAgentIntegration: (0, $1202f55c93d3422a$export$407448d2b89b1813)(),
        "ctx-name": a,
        ...d
    }), /* @__PURE__ */ (0, $e1jtj.default).createElement((0, $1202f55c93d3422a$export$db3b6bfb95261072), {
        ref: l,
        "ctx-name": a,
        ...m
    }), /* @__PURE__ */ (0, $e1jtj.default).createElement($72458abfe534965c$var$M, {
        class: i,
        "ctx-name": a
    })));
};



var $e1jtj = parcelRequire("e1jtj");
var $ir4bw = parcelRequire("ir4bw");


$c84717ce84e05cfa$exports.defineComponents($c84717ce84e05cfa$exports);
const $e3b6e4a03175fec9$var$I = (0, $1202f55c93d3422a$export$8b22cf2602fb60ce)({
    react: (0, $e1jtj.default),
    tag: "uc-file-uploader-inline",
    elClass: $c84717ce84e05cfa$exports.FileUploaderMinimal
}), $e3b6e4a03175fec9$export$1930c3118e9a7a5e = ({ ctxName: r, className: s, classNameUploader: i, apiRef: l, fallback: c, ...a })=>{
    const n = (0, $ir4bw.useMemo)(()=>r ?? $c84717ce84e05cfa$exports.UID.generate(), [
        r
    ]), { eventHandlers: m, config: d } = (0, $ir4bw.useMemo)(()=>(0, $1202f55c93d3422a$export$39b482c5e57630a8)(a), [
        a
    ]), p = (0, $1202f55c93d3422a$export$3b14a55fb2447963)();
    return /* @__PURE__ */ (0, $e1jtj.default).createElement((0, $1202f55c93d3422a$export$e7094788287c5e9b), {
        condition: p,
        fallback: c
    }, /* @__PURE__ */ (0, $e1jtj.default).createElement("div", {
        className: s
    }, /* @__PURE__ */ (0, $e1jtj.default).createElement((0, $1202f55c93d3422a$export$ebd11618f299a286), {
        userAgentIntegration: (0, $1202f55c93d3422a$export$407448d2b89b1813)(),
        "ctx-name": n,
        ...d
    }), /* @__PURE__ */ (0, $e1jtj.default).createElement((0, $1202f55c93d3422a$export$db3b6bfb95261072), {
        ref: l,
        "ctx-name": n,
        ...m
    }), /* @__PURE__ */ (0, $e1jtj.default).createElement($e3b6e4a03175fec9$var$I, {
        class: i,
        "ctx-name": n
    })));
};





parcelRequire("e1jtj");
var $ir4bw = parcelRequire("ir4bw");
var $5VC2c = parcelRequire("5VC2c");
var $e1jtj = parcelRequire("e1jtj");
function $6da948ce3e31f187$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $6da948ce3e31f187$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $6da948ce3e31f187$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $6da948ce3e31f187$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $6da948ce3e31f187$export$2e2bcd8739ae039 = $6da948ce3e31f187$export$4f5d2d50c9deca37;


var $2785da2b7d7107bb$var$ClassNames;
(function(ClassNames) {
    ClassNames["hiddenOnSearch"] = "epr-hidden-on-search";
    ClassNames["searchActive"] = "epr-search-active";
    ClassNames["hidden"] = "epr-hidden";
    ClassNames["visible"] = "epr-visible";
    ClassNames["active"] = "epr-active";
    ClassNames["emoji"] = "epr-emoji";
    ClassNames["category"] = "epr-emoji-category";
    ClassNames["label"] = "epr-emoji-category-label";
    ClassNames["categoryContent"] = "epr-emoji-category-content";
    ClassNames["emojiHasVariations"] = "epr-emoji-has-variations";
    ClassNames["scrollBody"] = "epr-body";
    ClassNames["emojiList"] = "epr-emoji-list";
    ClassNames["external"] = "__EmojiPicker__";
    ClassNames["emojiPicker"] = "EmojiPickerReact";
    ClassNames["open"] = "epr-open";
    ClassNames["vertical"] = "epr-vertical";
    ClassNames["horizontal"] = "epr-horizontal";
    ClassNames["variationPicker"] = "epr-emoji-variation-picker";
})($2785da2b7d7107bb$var$ClassNames || ($2785da2b7d7107bb$var$ClassNames = {}));
function $2785da2b7d7107bb$var$asSelectors() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.map(function(c) {
        return "." + c;
    }).join("");
}
function $2785da2b7d7107bb$var$focusElement(element) {
    if (!element) return;
    requestAnimationFrame(function() {
        element.focus();
    });
}
function $2785da2b7d7107bb$var$focusPrevElementSibling(element) {
    if (!element) return;
    var prev = element.previousElementSibling;
    $2785da2b7d7107bb$var$focusElement(prev);
}
function $2785da2b7d7107bb$var$focusNextElementSibling(element) {
    if (!element) return;
    var next = element.nextElementSibling;
    $2785da2b7d7107bb$var$focusElement(next);
}
function $2785da2b7d7107bb$var$focusFirstElementChild(element) {
    if (!element) return;
    var first = element.firstElementChild;
    $2785da2b7d7107bb$var$focusElement(first);
}
function $2785da2b7d7107bb$var$ElementRefContextProvider(_ref) {
    var children = _ref.children;
    var PickerMainRef = (0, $ir4bw.useRef)(null);
    var AnchoredEmojiRef = (0, $ir4bw.useRef)(null);
    var BodyRef = (0, $ir4bw.useRef)(null);
    var SearchInputRef = (0, $ir4bw.useRef)(null);
    var SkinTonePickerRef = (0, $ir4bw.useRef)(null);
    var CategoryNavigationRef = (0, $ir4bw.useRef)(null);
    var VariationPickerRef = (0, $ir4bw.useRef)(null);
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ElementRefContext.Provider, {
        value: {
            AnchoredEmojiRef: AnchoredEmojiRef,
            BodyRef: BodyRef,
            CategoryNavigationRef: CategoryNavigationRef,
            PickerMainRef: PickerMainRef,
            SearchInputRef: SearchInputRef,
            SkinTonePickerRef: SkinTonePickerRef,
            VariationPickerRef: VariationPickerRef
        }
    }, children);
}
var $2785da2b7d7107bb$var$ElementRefContext = /*#__PURE__*/ (0, $5VC2c.createContext)({
    AnchoredEmojiRef: /*#__PURE__*/ (0, $5VC2c.createRef)(),
    BodyRef: /*#__PURE__*/ (0, $5VC2c.createRef)(),
    CategoryNavigationRef: /*#__PURE__*/ (0, $5VC2c.createRef)(),
    PickerMainRef: /*#__PURE__*/ (0, $5VC2c.createRef)(),
    SearchInputRef: /*#__PURE__*/ (0, $5VC2c.createRef)(),
    SkinTonePickerRef: /*#__PURE__*/ (0, $5VC2c.createRef)(),
    VariationPickerRef: /*#__PURE__*/ (0, $5VC2c.createRef)()
});
function $2785da2b7d7107bb$var$useElementRef() {
    return (0, $ir4bw.useContext)($2785da2b7d7107bb$var$ElementRefContext);
}
function $2785da2b7d7107bb$var$usePickerMainRef() {
    return $2785da2b7d7107bb$var$useElementRef()["PickerMainRef"];
}
function $2785da2b7d7107bb$var$useAnchoredEmojiRef() {
    return $2785da2b7d7107bb$var$useElementRef()["AnchoredEmojiRef"];
}
function $2785da2b7d7107bb$var$useSetAnchoredEmojiRef() {
    var AnchoredEmojiRef = $2785da2b7d7107bb$var$useAnchoredEmojiRef();
    return function(target) {
        if (target === null && AnchoredEmojiRef.current !== null) $2785da2b7d7107bb$var$focusElement(AnchoredEmojiRef.current);
        AnchoredEmojiRef.current = target;
    };
}
function $2785da2b7d7107bb$var$useBodyRef() {
    return $2785da2b7d7107bb$var$useElementRef()["BodyRef"];
}
function $2785da2b7d7107bb$var$useSearchInputRef() {
    return $2785da2b7d7107bb$var$useElementRef()["SearchInputRef"];
}
function $2785da2b7d7107bb$var$useSkinTonePickerRef() {
    return $2785da2b7d7107bb$var$useElementRef()["SkinTonePickerRef"];
}
function $2785da2b7d7107bb$var$useCategoryNavigationRef() {
    return $2785da2b7d7107bb$var$useElementRef()["CategoryNavigationRef"];
}
function $2785da2b7d7107bb$var$useVariationPickerRef() {
    return $2785da2b7d7107bb$var$useElementRef()["VariationPickerRef"];
}
function $2785da2b7d7107bb$var$isSystemDarkTheme() {
    if (typeof window === "undefined") return false;
    return !!window.matchMedia("(prefers-color-scheme: dark)").matches;
}
function $2785da2b7d7107bb$var$_extends() {
    $2785da2b7d7107bb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2785da2b7d7107bb$var$_extends.apply(this, arguments);
}
function $2785da2b7d7107bb$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $2785da2b7d7107bb$var$_setPrototypeOf(subClass, superClass);
}
function $2785da2b7d7107bb$var$_setPrototypeOf(o, p) {
    $2785da2b7d7107bb$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2785da2b7d7107bb$var$_setPrototypeOf(o, p);
}
function $2785da2b7d7107bb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2785da2b7d7107bb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2785da2b7d7107bb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2785da2b7d7107bb$var$_arrayLikeToArray(o, minLen);
}
function $2785da2b7d7107bb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2785da2b7d7107bb$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2785da2b7d7107bb$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $2785da2b7d7107bb$export$599319363ef7770d;
(function(SuggestionMode) {
    SuggestionMode["RECENT"] = "recent";
    SuggestionMode["FREQUENT"] = "frequent";
})($2785da2b7d7107bb$export$599319363ef7770d || ($2785da2b7d7107bb$export$599319363ef7770d = {}));
var $2785da2b7d7107bb$export$92260a1a02147e89;
(function(EmojiStyle) {
    EmojiStyle["NATIVE"] = "native";
    EmojiStyle["APPLE"] = "apple";
    EmojiStyle["TWITTER"] = "twitter";
    EmojiStyle["GOOGLE"] = "google";
    EmojiStyle["FACEBOOK"] = "facebook";
})($2785da2b7d7107bb$export$92260a1a02147e89 || ($2785da2b7d7107bb$export$92260a1a02147e89 = {}));
var $2785da2b7d7107bb$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
    Theme["AUTO"] = "auto";
})($2785da2b7d7107bb$export$14faa19a0f3bbeb2 || ($2785da2b7d7107bb$export$14faa19a0f3bbeb2 = {}));
var $2785da2b7d7107bb$export$8502e178dd60af86;
(function(SkinTones) {
    SkinTones["NEUTRAL"] = "neutral";
    SkinTones["LIGHT"] = "1f3fb";
    SkinTones["MEDIUM_LIGHT"] = "1f3fc";
    SkinTones["MEDIUM"] = "1f3fd";
    SkinTones["MEDIUM_DARK"] = "1f3fe";
    SkinTones["DARK"] = "1f3ff";
})($2785da2b7d7107bb$export$8502e178dd60af86 || ($2785da2b7d7107bb$export$8502e178dd60af86 = {}));
var $2785da2b7d7107bb$export$e1e795cef0e670e6;
(function(Categories) {
    Categories["SUGGESTED"] = "suggested";
    Categories["CUSTOM"] = "custom";
    Categories["SMILEYS_PEOPLE"] = "smileys_people";
    Categories["ANIMALS_NATURE"] = "animals_nature";
    Categories["FOOD_DRINK"] = "food_drink";
    Categories["TRAVEL_PLACES"] = "travel_places";
    Categories["ACTIVITIES"] = "activities";
    Categories["OBJECTS"] = "objects";
    Categories["SYMBOLS"] = "symbols";
    Categories["FLAGS"] = "flags";
})($2785da2b7d7107bb$export$e1e795cef0e670e6 || ($2785da2b7d7107bb$export$e1e795cef0e670e6 = {}));
var $2785da2b7d7107bb$export$da9a330bf5ab5dfb;
(function(SkinTonePickerLocation) {
    SkinTonePickerLocation["SEARCH"] = "SEARCH";
    SkinTonePickerLocation["PREVIEW"] = "PREVIEW";
})($2785da2b7d7107bb$export$da9a330bf5ab5dfb || ($2785da2b7d7107bb$export$da9a330bf5ab5dfb = {}));
var $2785da2b7d7107bb$var$_configByCategory;
var $2785da2b7d7107bb$var$categoriesOrdered = [
    $2785da2b7d7107bb$export$e1e795cef0e670e6.SUGGESTED,
    $2785da2b7d7107bb$export$e1e795cef0e670e6.CUSTOM,
    $2785da2b7d7107bb$export$e1e795cef0e670e6.SMILEYS_PEOPLE,
    $2785da2b7d7107bb$export$e1e795cef0e670e6.ANIMALS_NATURE,
    $2785da2b7d7107bb$export$e1e795cef0e670e6.FOOD_DRINK,
    $2785da2b7d7107bb$export$e1e795cef0e670e6.TRAVEL_PLACES,
    $2785da2b7d7107bb$export$e1e795cef0e670e6.ACTIVITIES,
    $2785da2b7d7107bb$export$e1e795cef0e670e6.OBJECTS,
    $2785da2b7d7107bb$export$e1e795cef0e670e6.SYMBOLS,
    $2785da2b7d7107bb$export$e1e795cef0e670e6.FLAGS
];
var $2785da2b7d7107bb$var$SuggestedRecent = {
    name: "Recently Used",
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.SUGGESTED
};
var $2785da2b7d7107bb$var$configByCategory = ($2785da2b7d7107bb$var$_configByCategory = {}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.SUGGESTED] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.SUGGESTED,
    name: "Frequently Used"
}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.CUSTOM] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.CUSTOM,
    name: "Custom Emojis"
}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.SMILEYS_PEOPLE] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.SMILEYS_PEOPLE,
    name: "Smileys & People"
}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.ANIMALS_NATURE] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.ANIMALS_NATURE,
    name: "Animals & Nature"
}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.FOOD_DRINK] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.FOOD_DRINK,
    name: "Food & Drink"
}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.TRAVEL_PLACES] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.TRAVEL_PLACES,
    name: "Travel & Places"
}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.ACTIVITIES] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.ACTIVITIES,
    name: "Activities"
}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.OBJECTS] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.OBJECTS,
    name: "Objects"
}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.SYMBOLS] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.SYMBOLS,
    name: "Symbols"
}, $2785da2b7d7107bb$var$_configByCategory[$2785da2b7d7107bb$export$e1e795cef0e670e6.FLAGS] = {
    category: $2785da2b7d7107bb$export$e1e795cef0e670e6.FLAGS,
    name: "Flags"
}, $2785da2b7d7107bb$var$_configByCategory);
function $2785da2b7d7107bb$var$baseCategoriesConfig(modifiers) {
    return $2785da2b7d7107bb$var$categoriesOrdered.map(function(category) {
        return $2785da2b7d7107bb$var$_extends({}, $2785da2b7d7107bb$var$configByCategory[category], modifiers && modifiers[category] && modifiers[category]);
    });
}
function $2785da2b7d7107bb$var$categoryFromCategoryConfig(category) {
    return category.category;
}
function $2785da2b7d7107bb$var$categoryNameFromCategoryConfig(category) {
    return category.name;
}
function $2785da2b7d7107bb$var$mergeCategoriesConfig(userCategoriesConfig, modifiers) {
    var _userCategoriesConfig;
    if (userCategoriesConfig === void 0) userCategoriesConfig = [];
    if (modifiers === void 0) modifiers = {};
    var extra = {};
    if (modifiers.suggestionMode === $2785da2b7d7107bb$export$599319363ef7770d.RECENT) extra[$2785da2b7d7107bb$export$e1e795cef0e670e6.SUGGESTED] = $2785da2b7d7107bb$var$SuggestedRecent;
    var base = $2785da2b7d7107bb$var$baseCategoriesConfig(extra);
    if (!((_userCategoriesConfig = userCategoriesConfig) != null && _userCategoriesConfig.length)) return base;
    return userCategoriesConfig.map(function(category) {
        if (typeof category === "string") return $2785da2b7d7107bb$var$getBaseConfigByCategory(category, extra[category]);
        return $2785da2b7d7107bb$var$_extends({}, $2785da2b7d7107bb$var$getBaseConfigByCategory(category.category, extra[category.category]), category);
    });
}
function $2785da2b7d7107bb$var$getBaseConfigByCategory(category, modifier) {
    if (modifier === void 0) modifier = {};
    return Object.assign($2785da2b7d7107bb$var$configByCategory[category], modifier);
}
var $2785da2b7d7107bb$var$CDN_URL_APPLE = "https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/";
var $2785da2b7d7107bb$var$CDN_URL_FACEBOOK = "https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/";
var $2785da2b7d7107bb$var$CDN_URL_TWITTER = "https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/";
var $2785da2b7d7107bb$var$CDN_URL_GOOGLE = "https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/";
function $2785da2b7d7107bb$var$cdnUrl(emojiStyle) {
    switch(emojiStyle){
        case $2785da2b7d7107bb$export$92260a1a02147e89.TWITTER:
            return $2785da2b7d7107bb$var$CDN_URL_TWITTER;
        case $2785da2b7d7107bb$export$92260a1a02147e89.GOOGLE:
            return $2785da2b7d7107bb$var$CDN_URL_GOOGLE;
        case $2785da2b7d7107bb$export$92260a1a02147e89.FACEBOOK:
            return $2785da2b7d7107bb$var$CDN_URL_FACEBOOK;
        case $2785da2b7d7107bb$export$92260a1a02147e89.APPLE:
        default:
            return $2785da2b7d7107bb$var$CDN_URL_APPLE;
    }
}
var $2785da2b7d7107bb$var$custom = [];
var $2785da2b7d7107bb$var$smileys_people = [
    {
        n: [
            "grinning",
            "grinning face"
        ],
        u: "1f600",
        a: "1.0"
    },
    {
        n: [
            "smiley",
            "smiling face with open mouth"
        ],
        u: "1f603",
        a: "0.6"
    },
    {
        n: [
            "smile",
            "smiling face with open mouth and smiling eyes"
        ],
        u: "1f604",
        a: "0.6"
    },
    {
        n: [
            "grin",
            "grinning face with smiling eyes"
        ],
        u: "1f601",
        a: "0.6"
    },
    {
        n: [
            "laughing",
            "satisfied",
            "smiling face with open mouth and tightly-closed eyes"
        ],
        u: "1f606",
        a: "0.6"
    },
    {
        n: [
            "sweat smile",
            "smiling face with open mouth and cold sweat"
        ],
        u: "1f605",
        a: "0.6"
    },
    {
        n: [
            "rolling on the floor laughing"
        ],
        u: "1f923",
        a: "3.0"
    },
    {
        n: [
            "joy",
            "face with tears of joy"
        ],
        u: "1f602",
        a: "0.6"
    },
    {
        n: [
            "slightly smiling face"
        ],
        u: "1f642",
        a: "1.0"
    },
    {
        n: [
            "upside-down face",
            "upside down face"
        ],
        u: "1f643",
        a: "1.0"
    },
    {
        n: [
            "melting face"
        ],
        u: "1fae0",
        a: "14.0"
    },
    {
        n: [
            "wink",
            "winking face"
        ],
        u: "1f609",
        a: "0.6"
    },
    {
        n: [
            "blush",
            "smiling face with smiling eyes"
        ],
        u: "1f60a",
        a: "0.6"
    },
    {
        n: [
            "innocent",
            "smiling face with halo"
        ],
        u: "1f607",
        a: "1.0"
    },
    {
        n: [
            "smiling face with 3 hearts",
            "smiling face with smiling eyes and three hearts"
        ],
        u: "1f970",
        a: "11.0"
    },
    {
        n: [
            "heart eyes",
            "smiling face with heart-shaped eyes"
        ],
        u: "1f60d",
        a: "0.6"
    },
    {
        n: [
            "star-struck",
            "grinning face with star eyes"
        ],
        u: "1f929",
        a: "5.0"
    },
    {
        n: [
            "kissing heart",
            "face throwing a kiss"
        ],
        u: "1f618",
        a: "0.6"
    },
    {
        n: [
            "kissing",
            "kissing face"
        ],
        u: "1f617",
        a: "1.0"
    },
    {
        n: [
            "relaxed",
            "white smiling face"
        ],
        u: "263a-fe0f",
        a: "0.6"
    },
    {
        n: [
            "kissing closed eyes",
            "kissing face with closed eyes"
        ],
        u: "1f61a",
        a: "0.6"
    },
    {
        n: [
            "kissing smiling eyes",
            "kissing face with smiling eyes"
        ],
        u: "1f619",
        a: "1.0"
    },
    {
        n: [
            "smiling face with tear"
        ],
        u: "1f972",
        a: "13.0"
    },
    {
        n: [
            "yum",
            "face savouring delicious food"
        ],
        u: "1f60b",
        a: "0.6"
    },
    {
        n: [
            "stuck out tongue",
            "face with stuck-out tongue"
        ],
        u: "1f61b",
        a: "1.0"
    },
    {
        n: [
            "stuck out tongue winking eye",
            "face with stuck-out tongue and winking eye"
        ],
        u: "1f61c",
        a: "0.6"
    },
    {
        n: [
            "zany face",
            "grinning face with one large and one small eye"
        ],
        u: "1f92a",
        a: "5.0"
    },
    {
        n: [
            "stuck out tongue closed eyes",
            "face with stuck-out tongue and tightly-closed eyes"
        ],
        u: "1f61d",
        a: "0.6"
    },
    {
        n: [
            "money-mouth face",
            "money mouth face"
        ],
        u: "1f911",
        a: "1.0"
    },
    {
        n: [
            "hugging face"
        ],
        u: "1f917",
        a: "1.0"
    },
    {
        n: [
            "face with hand over mouth",
            "smiling face with smiling eyes and hand covering mouth"
        ],
        u: "1f92d",
        a: "5.0"
    },
    {
        n: [
            "face with open eyes and hand over mouth"
        ],
        u: "1fae2",
        a: "14.0"
    },
    {
        n: [
            "face with peeking eye"
        ],
        u: "1fae3",
        a: "14.0"
    },
    {
        n: [
            "shushing face",
            "face with finger covering closed lips"
        ],
        u: "1f92b",
        a: "5.0"
    },
    {
        n: [
            "thinking face"
        ],
        u: "1f914",
        a: "1.0"
    },
    {
        n: [
            "saluting face"
        ],
        u: "1fae1",
        a: "14.0"
    },
    {
        n: [
            "zipper-mouth face",
            "zipper mouth face"
        ],
        u: "1f910",
        a: "1.0"
    },
    {
        n: [
            "face with raised eyebrow",
            "face with one eyebrow raised"
        ],
        u: "1f928",
        a: "5.0"
    },
    {
        n: [
            "neutral face"
        ],
        u: "1f610",
        a: "0.7"
    },
    {
        n: [
            "expressionless",
            "expressionless face"
        ],
        u: "1f611",
        a: "1.0"
    },
    {
        n: [
            "no mouth",
            "face without mouth"
        ],
        u: "1f636",
        a: "1.0"
    },
    {
        n: [
            "dotted line face"
        ],
        u: "1fae5",
        a: "14.0"
    },
    {
        n: [
            "face in clouds"
        ],
        u: "1f636-200d-1f32b-fe0f",
        a: "13.1"
    },
    {
        n: [
            "smirk",
            "smirking face"
        ],
        u: "1f60f",
        a: "0.6"
    },
    {
        n: [
            "unamused",
            "unamused face"
        ],
        u: "1f612",
        a: "0.6"
    },
    {
        n: [
            "face with rolling eyes"
        ],
        u: "1f644",
        a: "1.0"
    },
    {
        n: [
            "grimacing",
            "grimacing face"
        ],
        u: "1f62c",
        a: "1.0"
    },
    {
        n: [
            "face exhaling"
        ],
        u: "1f62e-200d-1f4a8",
        a: "13.1"
    },
    {
        n: [
            "lying face"
        ],
        u: "1f925",
        a: "3.0"
    },
    {
        n: [
            "relieved",
            "relieved face"
        ],
        u: "1f60c",
        a: "0.6"
    },
    {
        n: [
            "pensive",
            "pensive face"
        ],
        u: "1f614",
        a: "0.6"
    },
    {
        n: [
            "sleepy",
            "sleepy face"
        ],
        u: "1f62a",
        a: "0.6"
    },
    {
        n: [
            "drooling face"
        ],
        u: "1f924",
        a: "3.0"
    },
    {
        n: [
            "sleeping",
            "sleeping face"
        ],
        u: "1f634",
        a: "1.0"
    },
    {
        n: [
            "mask",
            "face with medical mask"
        ],
        u: "1f637",
        a: "0.6"
    },
    {
        n: [
            "face with thermometer"
        ],
        u: "1f912",
        a: "1.0"
    },
    {
        n: [
            "face with head-bandage",
            "face with head bandage"
        ],
        u: "1f915",
        a: "1.0"
    },
    {
        n: [
            "nauseated face"
        ],
        u: "1f922",
        a: "3.0"
    },
    {
        n: [
            "face vomiting",
            "face with open mouth vomiting"
        ],
        u: "1f92e",
        a: "5.0"
    },
    {
        n: [
            "sneezing face"
        ],
        u: "1f927",
        a: "3.0"
    },
    {
        n: [
            "hot face",
            "overheated face"
        ],
        u: "1f975",
        a: "11.0"
    },
    {
        n: [
            "cold face",
            "freezing face"
        ],
        u: "1f976",
        a: "11.0"
    },
    {
        n: [
            "woozy face",
            "face with uneven eyes and wavy mouth"
        ],
        u: "1f974",
        a: "11.0"
    },
    {
        n: [
            "dizzy face"
        ],
        u: "1f635",
        a: "0.6"
    },
    {
        n: [
            "face with spiral eyes"
        ],
        u: "1f635-200d-1f4ab",
        a: "13.1"
    },
    {
        n: [
            "exploding head",
            "shocked face with exploding head"
        ],
        u: "1f92f",
        a: "5.0"
    },
    {
        n: [
            "face with cowboy hat"
        ],
        u: "1f920",
        a: "3.0"
    },
    {
        n: [
            "partying face",
            "face with party horn and party hat"
        ],
        u: "1f973",
        a: "11.0"
    },
    {
        n: [
            "disguised face"
        ],
        u: "1f978",
        a: "13.0"
    },
    {
        n: [
            "sunglasses",
            "smiling face with sunglasses"
        ],
        u: "1f60e",
        a: "1.0"
    },
    {
        n: [
            "nerd face"
        ],
        u: "1f913",
        a: "1.0"
    },
    {
        n: [
            "face with monocle"
        ],
        u: "1f9d0",
        a: "5.0"
    },
    {
        n: [
            "confused",
            "confused face"
        ],
        u: "1f615",
        a: "1.0"
    },
    {
        n: [
            "face with diagonal mouth"
        ],
        u: "1fae4",
        a: "14.0"
    },
    {
        n: [
            "worried",
            "worried face"
        ],
        u: "1f61f",
        a: "1.0"
    },
    {
        n: [
            "slightly frowning face"
        ],
        u: "1f641",
        a: "1.0"
    },
    {
        n: [
            "frowning face",
            "white frowning face"
        ],
        u: "2639-fe0f",
        a: "0.7"
    },
    {
        n: [
            "open mouth",
            "face with open mouth"
        ],
        u: "1f62e",
        a: "1.0"
    },
    {
        n: [
            "hushed",
            "hushed face"
        ],
        u: "1f62f",
        a: "1.0"
    },
    {
        n: [
            "astonished",
            "astonished face"
        ],
        u: "1f632",
        a: "0.6"
    },
    {
        n: [
            "flushed",
            "flushed face"
        ],
        u: "1f633",
        a: "0.6"
    },
    {
        n: [
            "pleading face",
            "face with pleading eyes"
        ],
        u: "1f97a",
        a: "11.0"
    },
    {
        n: [
            "face holding back tears"
        ],
        u: "1f979",
        a: "14.0"
    },
    {
        n: [
            "frowning",
            "frowning face with open mouth"
        ],
        u: "1f626",
        a: "1.0"
    },
    {
        n: [
            "anguished",
            "anguished face"
        ],
        u: "1f627",
        a: "1.0"
    },
    {
        n: [
            "fearful",
            "fearful face"
        ],
        u: "1f628",
        a: "0.6"
    },
    {
        n: [
            "cold sweat",
            "face with open mouth and cold sweat"
        ],
        u: "1f630",
        a: "0.6"
    },
    {
        n: [
            "disappointed relieved",
            "disappointed but relieved face"
        ],
        u: "1f625",
        a: "0.6"
    },
    {
        n: [
            "cry",
            "crying face"
        ],
        u: "1f622",
        a: "0.6"
    },
    {
        n: [
            "sob",
            "loudly crying face"
        ],
        u: "1f62d",
        a: "0.6"
    },
    {
        n: [
            "scream",
            "face screaming in fear"
        ],
        u: "1f631",
        a: "0.6"
    },
    {
        n: [
            "confounded",
            "confounded face"
        ],
        u: "1f616",
        a: "0.6"
    },
    {
        n: [
            "persevere",
            "persevering face"
        ],
        u: "1f623",
        a: "0.6"
    },
    {
        n: [
            "disappointed",
            "disappointed face"
        ],
        u: "1f61e",
        a: "0.6"
    },
    {
        n: [
            "sweat",
            "face with cold sweat"
        ],
        u: "1f613",
        a: "0.6"
    },
    {
        n: [
            "weary",
            "weary face"
        ],
        u: "1f629",
        a: "0.6"
    },
    {
        n: [
            "tired face"
        ],
        u: "1f62b",
        a: "0.6"
    },
    {
        n: [
            "yawning face"
        ],
        u: "1f971",
        a: "12.0"
    },
    {
        n: [
            "triumph",
            "face with look of triumph"
        ],
        u: "1f624",
        a: "0.6"
    },
    {
        n: [
            "rage",
            "pouting face"
        ],
        u: "1f621",
        a: "0.6"
    },
    {
        n: [
            "angry",
            "angry face"
        ],
        u: "1f620",
        a: "0.6"
    },
    {
        n: [
            "face with symbols on mouth",
            "serious face with symbols covering mouth"
        ],
        u: "1f92c",
        a: "5.0"
    },
    {
        n: [
            "smiling imp",
            "smiling face with horns"
        ],
        u: "1f608",
        a: "1.0"
    },
    {
        n: [
            "imp"
        ],
        u: "1f47f",
        a: "0.6"
    },
    {
        n: [
            "skull"
        ],
        u: "1f480",
        a: "0.6"
    },
    {
        n: [
            "skull and crossbones"
        ],
        u: "2620-fe0f",
        a: "1.0"
    },
    {
        n: [
            "poop",
            "shit",
            "hankey",
            "pile of poo"
        ],
        u: "1f4a9",
        a: "0.6"
    },
    {
        n: [
            "clown face"
        ],
        u: "1f921",
        a: "3.0"
    },
    {
        n: [
            "japanese ogre"
        ],
        u: "1f479",
        a: "0.6"
    },
    {
        n: [
            "japanese goblin"
        ],
        u: "1f47a",
        a: "0.6"
    },
    {
        n: [
            "ghost"
        ],
        u: "1f47b",
        a: "0.6"
    },
    {
        n: [
            "alien",
            "extraterrestrial alien"
        ],
        u: "1f47d",
        a: "0.6"
    },
    {
        n: [
            "alien monster",
            "space invader"
        ],
        u: "1f47e",
        a: "0.6"
    },
    {
        n: [
            "robot face"
        ],
        u: "1f916",
        a: "1.0"
    },
    {
        n: [
            "smiley cat",
            "smiling cat face with open mouth"
        ],
        u: "1f63a",
        a: "0.6"
    },
    {
        n: [
            "smile cat",
            "grinning cat face with smiling eyes"
        ],
        u: "1f638",
        a: "0.6"
    },
    {
        n: [
            "joy cat",
            "cat face with tears of joy"
        ],
        u: "1f639",
        a: "0.6"
    },
    {
        n: [
            "heart eyes cat",
            "smiling cat face with heart-shaped eyes"
        ],
        u: "1f63b",
        a: "0.6"
    },
    {
        n: [
            "smirk cat",
            "cat face with wry smile"
        ],
        u: "1f63c",
        a: "0.6"
    },
    {
        n: [
            "kissing cat",
            "kissing cat face with closed eyes"
        ],
        u: "1f63d",
        a: "0.6"
    },
    {
        n: [
            "scream cat",
            "weary cat face"
        ],
        u: "1f640",
        a: "0.6"
    },
    {
        n: [
            "crying cat face"
        ],
        u: "1f63f",
        a: "0.6"
    },
    {
        n: [
            "pouting cat",
            "pouting cat face"
        ],
        u: "1f63e",
        a: "0.6"
    },
    {
        n: [
            "see no evil",
            "see-no-evil monkey"
        ],
        u: "1f648",
        a: "0.6"
    },
    {
        n: [
            "hear no evil",
            "hear-no-evil monkey"
        ],
        u: "1f649",
        a: "0.6"
    },
    {
        n: [
            "speak no evil",
            "speak-no-evil monkey"
        ],
        u: "1f64a",
        a: "0.6"
    },
    {
        n: [
            "kiss",
            "kiss mark"
        ],
        u: "1f48b",
        a: "0.6"
    },
    {
        n: [
            "love letter"
        ],
        u: "1f48c",
        a: "0.6"
    },
    {
        n: [
            "cupid",
            "heart with arrow"
        ],
        u: "1f498",
        a: "0.6"
    },
    {
        n: [
            "gift heart",
            "heart with ribbon"
        ],
        u: "1f49d",
        a: "0.6"
    },
    {
        n: [
            "sparkling heart"
        ],
        u: "1f496",
        a: "0.6"
    },
    {
        n: [
            "heartpulse",
            "growing heart"
        ],
        u: "1f497",
        a: "0.6"
    },
    {
        n: [
            "heartbeat",
            "beating heart"
        ],
        u: "1f493",
        a: "0.6"
    },
    {
        n: [
            "revolving hearts"
        ],
        u: "1f49e",
        a: "0.6"
    },
    {
        n: [
            "two hearts"
        ],
        u: "1f495",
        a: "0.6"
    },
    {
        n: [
            "heart decoration"
        ],
        u: "1f49f",
        a: "0.6"
    },
    {
        n: [
            "heart exclamation",
            "heavy heart exclamation mark ornament"
        ],
        u: "2763-fe0f",
        a: "1.0"
    },
    {
        n: [
            "broken heart"
        ],
        u: "1f494",
        a: "0.6"
    },
    {
        n: [
            "heart on fire"
        ],
        u: "2764-fe0f-200d-1f525",
        a: "13.1"
    },
    {
        n: [
            "mending heart"
        ],
        u: "2764-fe0f-200d-1fa79",
        a: "13.1"
    },
    {
        n: [
            "heart",
            "heavy black heart"
        ],
        u: "2764-fe0f",
        a: "0.6"
    },
    {
        n: [
            "orange heart"
        ],
        u: "1f9e1",
        a: "5.0"
    },
    {
        n: [
            "yellow heart"
        ],
        u: "1f49b",
        a: "0.6"
    },
    {
        n: [
            "green heart"
        ],
        u: "1f49a",
        a: "0.6"
    },
    {
        n: [
            "blue heart"
        ],
        u: "1f499",
        a: "0.6"
    },
    {
        n: [
            "purple heart"
        ],
        u: "1f49c",
        a: "0.6"
    },
    {
        n: [
            "brown heart"
        ],
        u: "1f90e",
        a: "12.0"
    },
    {
        n: [
            "black heart"
        ],
        u: "1f5a4",
        a: "3.0"
    },
    {
        n: [
            "white heart"
        ],
        u: "1f90d",
        a: "12.0"
    },
    {
        n: [
            "100",
            "hundred points symbol"
        ],
        u: "1f4af",
        a: "0.6"
    },
    {
        n: [
            "anger",
            "anger symbol"
        ],
        u: "1f4a2",
        a: "0.6"
    },
    {
        n: [
            "boom",
            "collision",
            "collision symbol"
        ],
        u: "1f4a5",
        a: "0.6"
    },
    {
        n: [
            "dizzy",
            "dizzy symbol"
        ],
        u: "1f4ab",
        a: "0.6"
    },
    {
        n: [
            "sweat drops",
            "splashing sweat symbol"
        ],
        u: "1f4a6",
        a: "0.6"
    },
    {
        n: [
            "dash",
            "dash symbol"
        ],
        u: "1f4a8",
        a: "0.6"
    },
    {
        n: [
            "hole"
        ],
        u: "1f573-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bomb"
        ],
        u: "1f4a3",
        a: "0.6"
    },
    {
        n: [
            "speech balloon"
        ],
        u: "1f4ac",
        a: "0.6"
    },
    {
        n: [
            "eye in speech bubble",
            "eye-in-speech-bubble"
        ],
        u: "1f441-fe0f-200d-1f5e8-fe0f",
        a: "2.0"
    },
    {
        n: [
            "left speech bubble"
        ],
        u: "1f5e8-fe0f",
        a: "2.0"
    },
    {
        n: [
            "right anger bubble"
        ],
        u: "1f5ef-fe0f",
        a: "0.7"
    },
    {
        n: [
            "thought balloon"
        ],
        u: "1f4ad",
        a: "1.0"
    },
    {
        n: [
            "zzz",
            "sleeping symbol"
        ],
        u: "1f4a4",
        a: "0.6"
    },
    {
        n: [
            "wave",
            "waving hand sign"
        ],
        u: "1f44b",
        v: [
            "1f44b-1f3fb",
            "1f44b-1f3fc",
            "1f44b-1f3fd",
            "1f44b-1f3fe",
            "1f44b-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "raised back of hand"
        ],
        u: "1f91a",
        v: [
            "1f91a-1f3fb",
            "1f91a-1f3fc",
            "1f91a-1f3fd",
            "1f91a-1f3fe",
            "1f91a-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "hand with fingers splayed",
            "raised hand with fingers splayed"
        ],
        u: "1f590-fe0f",
        v: [
            "1f590-1f3fb",
            "1f590-1f3fc",
            "1f590-1f3fd",
            "1f590-1f3fe",
            "1f590-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "hand",
            "raised hand"
        ],
        u: "270b",
        v: [
            "270b-1f3fb",
            "270b-1f3fc",
            "270b-1f3fd",
            "270b-1f3fe",
            "270b-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "spock-hand",
            "raised hand with part between middle and ring fingers"
        ],
        u: "1f596",
        v: [
            "1f596-1f3fb",
            "1f596-1f3fc",
            "1f596-1f3fd",
            "1f596-1f3fe",
            "1f596-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "rightwards hand"
        ],
        u: "1faf1",
        v: [
            "1faf1-1f3fb",
            "1faf1-1f3fc",
            "1faf1-1f3fd",
            "1faf1-1f3fe",
            "1faf1-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "leftwards hand"
        ],
        u: "1faf2",
        v: [
            "1faf2-1f3fb",
            "1faf2-1f3fc",
            "1faf2-1f3fd",
            "1faf2-1f3fe",
            "1faf2-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "palm down hand"
        ],
        u: "1faf3",
        v: [
            "1faf3-1f3fb",
            "1faf3-1f3fc",
            "1faf3-1f3fd",
            "1faf3-1f3fe",
            "1faf3-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "palm up hand"
        ],
        u: "1faf4",
        v: [
            "1faf4-1f3fb",
            "1faf4-1f3fc",
            "1faf4-1f3fd",
            "1faf4-1f3fe",
            "1faf4-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "ok hand",
            "ok hand sign"
        ],
        u: "1f44c",
        v: [
            "1f44c-1f3fb",
            "1f44c-1f3fc",
            "1f44c-1f3fd",
            "1f44c-1f3fe",
            "1f44c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "pinched fingers"
        ],
        u: "1f90c",
        v: [
            "1f90c-1f3fb",
            "1f90c-1f3fc",
            "1f90c-1f3fd",
            "1f90c-1f3fe",
            "1f90c-1f3ff"
        ],
        a: "13.0"
    },
    {
        n: [
            "pinching hand"
        ],
        u: "1f90f",
        v: [
            "1f90f-1f3fb",
            "1f90f-1f3fc",
            "1f90f-1f3fd",
            "1f90f-1f3fe",
            "1f90f-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "v",
            "victory hand"
        ],
        u: "270c-fe0f",
        v: [
            "270c-1f3fb",
            "270c-1f3fc",
            "270c-1f3fd",
            "270c-1f3fe",
            "270c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "crossed fingers",
            "hand with index and middle fingers crossed"
        ],
        u: "1f91e",
        v: [
            "1f91e-1f3fb",
            "1f91e-1f3fc",
            "1f91e-1f3fd",
            "1f91e-1f3fe",
            "1f91e-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "hand with index finger and thumb crossed"
        ],
        u: "1faf0",
        v: [
            "1faf0-1f3fb",
            "1faf0-1f3fc",
            "1faf0-1f3fd",
            "1faf0-1f3fe",
            "1faf0-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "i love you hand sign"
        ],
        u: "1f91f",
        v: [
            "1f91f-1f3fb",
            "1f91f-1f3fc",
            "1f91f-1f3fd",
            "1f91f-1f3fe",
            "1f91f-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "the horns",
            "sign of the horns"
        ],
        u: "1f918",
        v: [
            "1f918-1f3fb",
            "1f918-1f3fc",
            "1f918-1f3fd",
            "1f918-1f3fe",
            "1f918-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "call me hand"
        ],
        u: "1f919",
        v: [
            "1f919-1f3fb",
            "1f919-1f3fc",
            "1f919-1f3fd",
            "1f919-1f3fe",
            "1f919-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "point left",
            "white left pointing backhand index"
        ],
        u: "1f448",
        v: [
            "1f448-1f3fb",
            "1f448-1f3fc",
            "1f448-1f3fd",
            "1f448-1f3fe",
            "1f448-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "point right",
            "white right pointing backhand index"
        ],
        u: "1f449",
        v: [
            "1f449-1f3fb",
            "1f449-1f3fc",
            "1f449-1f3fd",
            "1f449-1f3fe",
            "1f449-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "point up 2",
            "white up pointing backhand index"
        ],
        u: "1f446",
        v: [
            "1f446-1f3fb",
            "1f446-1f3fc",
            "1f446-1f3fd",
            "1f446-1f3fe",
            "1f446-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "middle finger",
            "reversed hand with middle finger extended"
        ],
        u: "1f595",
        v: [
            "1f595-1f3fb",
            "1f595-1f3fc",
            "1f595-1f3fd",
            "1f595-1f3fe",
            "1f595-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "point down",
            "white down pointing backhand index"
        ],
        u: "1f447",
        v: [
            "1f447-1f3fb",
            "1f447-1f3fc",
            "1f447-1f3fd",
            "1f447-1f3fe",
            "1f447-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "point up",
            "white up pointing index"
        ],
        u: "261d-fe0f",
        v: [
            "261d-1f3fb",
            "261d-1f3fc",
            "261d-1f3fd",
            "261d-1f3fe",
            "261d-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "index pointing at the viewer"
        ],
        u: "1faf5",
        v: [
            "1faf5-1f3fb",
            "1faf5-1f3fc",
            "1faf5-1f3fd",
            "1faf5-1f3fe",
            "1faf5-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "+1",
            "thumbsup",
            "thumbs up sign"
        ],
        u: "1f44d",
        v: [
            "1f44d-1f3fb",
            "1f44d-1f3fc",
            "1f44d-1f3fd",
            "1f44d-1f3fe",
            "1f44d-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "-1",
            "thumbsdown",
            "thumbs down sign"
        ],
        u: "1f44e",
        v: [
            "1f44e-1f3fb",
            "1f44e-1f3fc",
            "1f44e-1f3fd",
            "1f44e-1f3fe",
            "1f44e-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "fist",
            "raised fist"
        ],
        u: "270a",
        v: [
            "270a-1f3fb",
            "270a-1f3fc",
            "270a-1f3fd",
            "270a-1f3fe",
            "270a-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "punch",
            "facepunch",
            "fisted hand sign"
        ],
        u: "1f44a",
        v: [
            "1f44a-1f3fb",
            "1f44a-1f3fc",
            "1f44a-1f3fd",
            "1f44a-1f3fe",
            "1f44a-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "left-facing fist"
        ],
        u: "1f91b",
        v: [
            "1f91b-1f3fb",
            "1f91b-1f3fc",
            "1f91b-1f3fd",
            "1f91b-1f3fe",
            "1f91b-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "right-facing fist"
        ],
        u: "1f91c",
        v: [
            "1f91c-1f3fb",
            "1f91c-1f3fc",
            "1f91c-1f3fd",
            "1f91c-1f3fe",
            "1f91c-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "clap",
            "clapping hands sign"
        ],
        u: "1f44f",
        v: [
            "1f44f-1f3fb",
            "1f44f-1f3fc",
            "1f44f-1f3fd",
            "1f44f-1f3fe",
            "1f44f-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "raised hands",
            "person raising both hands in celebration"
        ],
        u: "1f64c",
        v: [
            "1f64c-1f3fb",
            "1f64c-1f3fc",
            "1f64c-1f3fd",
            "1f64c-1f3fe",
            "1f64c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "heart hands"
        ],
        u: "1faf6",
        v: [
            "1faf6-1f3fb",
            "1faf6-1f3fc",
            "1faf6-1f3fd",
            "1faf6-1f3fe",
            "1faf6-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "open hands",
            "open hands sign"
        ],
        u: "1f450",
        v: [
            "1f450-1f3fb",
            "1f450-1f3fc",
            "1f450-1f3fd",
            "1f450-1f3fe",
            "1f450-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "palms up together"
        ],
        u: "1f932",
        v: [
            "1f932-1f3fb",
            "1f932-1f3fc",
            "1f932-1f3fd",
            "1f932-1f3fe",
            "1f932-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "handshake"
        ],
        u: "1f91d",
        v: [
            "1f91d-1f3fb",
            "1f91d-1f3fc",
            "1f91d-1f3fd",
            "1f91d-1f3fe",
            "1f91d-1f3ff",
            "1faf1-1f3fb-200d-1faf2-1f3fc",
            "1faf1-1f3fb-200d-1faf2-1f3fd",
            "1faf1-1f3fb-200d-1faf2-1f3fe",
            "1faf1-1f3fb-200d-1faf2-1f3ff",
            "1faf1-1f3fc-200d-1faf2-1f3fb",
            "1faf1-1f3fc-200d-1faf2-1f3fd",
            "1faf1-1f3fc-200d-1faf2-1f3fe",
            "1faf1-1f3fc-200d-1faf2-1f3ff",
            "1faf1-1f3fd-200d-1faf2-1f3fb",
            "1faf1-1f3fd-200d-1faf2-1f3fc",
            "1faf1-1f3fd-200d-1faf2-1f3fe",
            "1faf1-1f3fd-200d-1faf2-1f3ff",
            "1faf1-1f3fe-200d-1faf2-1f3fb",
            "1faf1-1f3fe-200d-1faf2-1f3fc",
            "1faf1-1f3fe-200d-1faf2-1f3fd",
            "1faf1-1f3fe-200d-1faf2-1f3ff",
            "1faf1-1f3ff-200d-1faf2-1f3fb",
            "1faf1-1f3ff-200d-1faf2-1f3fc",
            "1faf1-1f3ff-200d-1faf2-1f3fd",
            "1faf1-1f3ff-200d-1faf2-1f3fe"
        ],
        a: "3.0"
    },
    {
        n: [
            "pray",
            "person with folded hands"
        ],
        u: "1f64f",
        v: [
            "1f64f-1f3fb",
            "1f64f-1f3fc",
            "1f64f-1f3fd",
            "1f64f-1f3fe",
            "1f64f-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "writing hand"
        ],
        u: "270d-fe0f",
        v: [
            "270d-1f3fb",
            "270d-1f3fc",
            "270d-1f3fd",
            "270d-1f3fe",
            "270d-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "nail care",
            "nail polish"
        ],
        u: "1f485",
        v: [
            "1f485-1f3fb",
            "1f485-1f3fc",
            "1f485-1f3fd",
            "1f485-1f3fe",
            "1f485-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "selfie"
        ],
        u: "1f933",
        v: [
            "1f933-1f3fb",
            "1f933-1f3fc",
            "1f933-1f3fd",
            "1f933-1f3fe",
            "1f933-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "muscle",
            "flexed biceps"
        ],
        u: "1f4aa",
        v: [
            "1f4aa-1f3fb",
            "1f4aa-1f3fc",
            "1f4aa-1f3fd",
            "1f4aa-1f3fe",
            "1f4aa-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "mechanical arm"
        ],
        u: "1f9be",
        a: "12.0"
    },
    {
        n: [
            "mechanical leg"
        ],
        u: "1f9bf",
        a: "12.0"
    },
    {
        n: [
            "leg"
        ],
        u: "1f9b5",
        v: [
            "1f9b5-1f3fb",
            "1f9b5-1f3fc",
            "1f9b5-1f3fd",
            "1f9b5-1f3fe",
            "1f9b5-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "foot"
        ],
        u: "1f9b6",
        v: [
            "1f9b6-1f3fb",
            "1f9b6-1f3fc",
            "1f9b6-1f3fd",
            "1f9b6-1f3fe",
            "1f9b6-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "ear"
        ],
        u: "1f442",
        v: [
            "1f442-1f3fb",
            "1f442-1f3fc",
            "1f442-1f3fd",
            "1f442-1f3fe",
            "1f442-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "ear with hearing aid"
        ],
        u: "1f9bb",
        v: [
            "1f9bb-1f3fb",
            "1f9bb-1f3fc",
            "1f9bb-1f3fd",
            "1f9bb-1f3fe",
            "1f9bb-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "nose"
        ],
        u: "1f443",
        v: [
            "1f443-1f3fb",
            "1f443-1f3fc",
            "1f443-1f3fd",
            "1f443-1f3fe",
            "1f443-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "brain"
        ],
        u: "1f9e0",
        a: "5.0"
    },
    {
        n: [
            "anatomical heart"
        ],
        u: "1fac0",
        a: "13.0"
    },
    {
        n: [
            "lungs"
        ],
        u: "1fac1",
        a: "13.0"
    },
    {
        n: [
            "tooth"
        ],
        u: "1f9b7",
        a: "11.0"
    },
    {
        n: [
            "bone"
        ],
        u: "1f9b4",
        a: "11.0"
    },
    {
        n: [
            "eyes"
        ],
        u: "1f440",
        a: "0.6"
    },
    {
        n: [
            "eye"
        ],
        u: "1f441-fe0f",
        a: "0.7"
    },
    {
        n: [
            "tongue"
        ],
        u: "1f445",
        a: "0.6"
    },
    {
        n: [
            "lips",
            "mouth"
        ],
        u: "1f444",
        a: "0.6"
    },
    {
        n: [
            "biting lip"
        ],
        u: "1fae6",
        a: "14.0"
    },
    {
        n: [
            "baby"
        ],
        u: "1f476",
        v: [
            "1f476-1f3fb",
            "1f476-1f3fc",
            "1f476-1f3fd",
            "1f476-1f3fe",
            "1f476-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "child"
        ],
        u: "1f9d2",
        v: [
            "1f9d2-1f3fb",
            "1f9d2-1f3fc",
            "1f9d2-1f3fd",
            "1f9d2-1f3fe",
            "1f9d2-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "boy"
        ],
        u: "1f466",
        v: [
            "1f466-1f3fb",
            "1f466-1f3fc",
            "1f466-1f3fd",
            "1f466-1f3fe",
            "1f466-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "girl"
        ],
        u: "1f467",
        v: [
            "1f467-1f3fb",
            "1f467-1f3fc",
            "1f467-1f3fd",
            "1f467-1f3fe",
            "1f467-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "adult"
        ],
        u: "1f9d1",
        v: [
            "1f9d1-1f3fb",
            "1f9d1-1f3fc",
            "1f9d1-1f3fd",
            "1f9d1-1f3fe",
            "1f9d1-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "person with blond hair"
        ],
        u: "1f471",
        v: [
            "1f471-1f3fb",
            "1f471-1f3fc",
            "1f471-1f3fd",
            "1f471-1f3fe",
            "1f471-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man"
        ],
        u: "1f468",
        v: [
            "1f468-1f3fb",
            "1f468-1f3fc",
            "1f468-1f3fd",
            "1f468-1f3fe",
            "1f468-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "bearded person"
        ],
        u: "1f9d4",
        v: [
            "1f9d4-1f3fb",
            "1f9d4-1f3fc",
            "1f9d4-1f3fd",
            "1f9d4-1f3fe",
            "1f9d4-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man: beard",
            "man with beard"
        ],
        u: "1f9d4-200d-2642-fe0f",
        v: [
            "1f9d4-1f3fb-200d-2642-fe0f",
            "1f9d4-1f3fc-200d-2642-fe0f",
            "1f9d4-1f3fd-200d-2642-fe0f",
            "1f9d4-1f3fe-200d-2642-fe0f",
            "1f9d4-1f3ff-200d-2642-fe0f"
        ],
        a: "13.1"
    },
    {
        n: [
            "woman: beard",
            "woman with beard"
        ],
        u: "1f9d4-200d-2640-fe0f",
        v: [
            "1f9d4-1f3fb-200d-2640-fe0f",
            "1f9d4-1f3fc-200d-2640-fe0f",
            "1f9d4-1f3fd-200d-2640-fe0f",
            "1f9d4-1f3fe-200d-2640-fe0f",
            "1f9d4-1f3ff-200d-2640-fe0f"
        ],
        a: "13.1"
    },
    {
        n: [
            "man: red hair",
            "red haired man"
        ],
        u: "1f468-200d-1f9b0",
        v: [
            "1f468-1f3fb-200d-1f9b0",
            "1f468-1f3fc-200d-1f9b0",
            "1f468-1f3fd-200d-1f9b0",
            "1f468-1f3fe-200d-1f9b0",
            "1f468-1f3ff-200d-1f9b0"
        ],
        a: "11.0"
    },
    {
        n: [
            "man: curly hair",
            "curly haired man"
        ],
        u: "1f468-200d-1f9b1",
        v: [
            "1f468-1f3fb-200d-1f9b1",
            "1f468-1f3fc-200d-1f9b1",
            "1f468-1f3fd-200d-1f9b1",
            "1f468-1f3fe-200d-1f9b1",
            "1f468-1f3ff-200d-1f9b1"
        ],
        a: "11.0"
    },
    {
        n: [
            "man: white hair",
            "white haired man"
        ],
        u: "1f468-200d-1f9b3",
        v: [
            "1f468-1f3fb-200d-1f9b3",
            "1f468-1f3fc-200d-1f9b3",
            "1f468-1f3fd-200d-1f9b3",
            "1f468-1f3fe-200d-1f9b3",
            "1f468-1f3ff-200d-1f9b3"
        ],
        a: "11.0"
    },
    {
        n: [
            "bald man",
            "man: bald"
        ],
        u: "1f468-200d-1f9b2",
        v: [
            "1f468-1f3fb-200d-1f9b2",
            "1f468-1f3fc-200d-1f9b2",
            "1f468-1f3fd-200d-1f9b2",
            "1f468-1f3fe-200d-1f9b2",
            "1f468-1f3ff-200d-1f9b2"
        ],
        a: "11.0"
    },
    {
        n: [
            "woman"
        ],
        u: "1f469",
        v: [
            "1f469-1f3fb",
            "1f469-1f3fc",
            "1f469-1f3fd",
            "1f469-1f3fe",
            "1f469-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "woman: red hair",
            "red haired woman"
        ],
        u: "1f469-200d-1f9b0",
        v: [
            "1f469-1f3fb-200d-1f9b0",
            "1f469-1f3fc-200d-1f9b0",
            "1f469-1f3fd-200d-1f9b0",
            "1f469-1f3fe-200d-1f9b0",
            "1f469-1f3ff-200d-1f9b0"
        ],
        a: "11.0"
    },
    {
        n: [
            "person: red hair",
            "red haired person"
        ],
        u: "1f9d1-200d-1f9b0",
        v: [
            "1f9d1-1f3fb-200d-1f9b0",
            "1f9d1-1f3fc-200d-1f9b0",
            "1f9d1-1f3fd-200d-1f9b0",
            "1f9d1-1f3fe-200d-1f9b0",
            "1f9d1-1f3ff-200d-1f9b0"
        ],
        a: "12.1"
    },
    {
        n: [
            "woman: curly hair",
            "curly haired woman"
        ],
        u: "1f469-200d-1f9b1",
        v: [
            "1f469-1f3fb-200d-1f9b1",
            "1f469-1f3fc-200d-1f9b1",
            "1f469-1f3fd-200d-1f9b1",
            "1f469-1f3fe-200d-1f9b1",
            "1f469-1f3ff-200d-1f9b1"
        ],
        a: "11.0"
    },
    {
        n: [
            "person: curly hair",
            "curly haired person"
        ],
        u: "1f9d1-200d-1f9b1",
        v: [
            "1f9d1-1f3fb-200d-1f9b1",
            "1f9d1-1f3fc-200d-1f9b1",
            "1f9d1-1f3fd-200d-1f9b1",
            "1f9d1-1f3fe-200d-1f9b1",
            "1f9d1-1f3ff-200d-1f9b1"
        ],
        a: "12.1"
    },
    {
        n: [
            "woman: white hair",
            "white haired woman"
        ],
        u: "1f469-200d-1f9b3",
        v: [
            "1f469-1f3fb-200d-1f9b3",
            "1f469-1f3fc-200d-1f9b3",
            "1f469-1f3fd-200d-1f9b3",
            "1f469-1f3fe-200d-1f9b3",
            "1f469-1f3ff-200d-1f9b3"
        ],
        a: "11.0"
    },
    {
        n: [
            "person: white hair",
            "white haired person"
        ],
        u: "1f9d1-200d-1f9b3",
        v: [
            "1f9d1-1f3fb-200d-1f9b3",
            "1f9d1-1f3fc-200d-1f9b3",
            "1f9d1-1f3fd-200d-1f9b3",
            "1f9d1-1f3fe-200d-1f9b3",
            "1f9d1-1f3ff-200d-1f9b3"
        ],
        a: "12.1"
    },
    {
        n: [
            "bald woman",
            "woman: bald"
        ],
        u: "1f469-200d-1f9b2",
        v: [
            "1f469-1f3fb-200d-1f9b2",
            "1f469-1f3fc-200d-1f9b2",
            "1f469-1f3fd-200d-1f9b2",
            "1f469-1f3fe-200d-1f9b2",
            "1f469-1f3ff-200d-1f9b2"
        ],
        a: "11.0"
    },
    {
        n: [
            "bald person",
            "person: bald"
        ],
        u: "1f9d1-200d-1f9b2",
        v: [
            "1f9d1-1f3fb-200d-1f9b2",
            "1f9d1-1f3fc-200d-1f9b2",
            "1f9d1-1f3fd-200d-1f9b2",
            "1f9d1-1f3fe-200d-1f9b2",
            "1f9d1-1f3ff-200d-1f9b2"
        ],
        a: "12.1"
    },
    {
        n: [
            "woman: blond hair",
            "blond-haired-woman"
        ],
        u: "1f471-200d-2640-fe0f",
        v: [
            "1f471-1f3fb-200d-2640-fe0f",
            "1f471-1f3fc-200d-2640-fe0f",
            "1f471-1f3fd-200d-2640-fe0f",
            "1f471-1f3fe-200d-2640-fe0f",
            "1f471-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "man: blond hair",
            "blond-haired-man"
        ],
        u: "1f471-200d-2642-fe0f",
        v: [
            "1f471-1f3fb-200d-2642-fe0f",
            "1f471-1f3fc-200d-2642-fe0f",
            "1f471-1f3fd-200d-2642-fe0f",
            "1f471-1f3fe-200d-2642-fe0f",
            "1f471-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "older adult"
        ],
        u: "1f9d3",
        v: [
            "1f9d3-1f3fb",
            "1f9d3-1f3fc",
            "1f9d3-1f3fd",
            "1f9d3-1f3fe",
            "1f9d3-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "older man"
        ],
        u: "1f474",
        v: [
            "1f474-1f3fb",
            "1f474-1f3fc",
            "1f474-1f3fd",
            "1f474-1f3fe",
            "1f474-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "older woman"
        ],
        u: "1f475",
        v: [
            "1f475-1f3fb",
            "1f475-1f3fc",
            "1f475-1f3fd",
            "1f475-1f3fe",
            "1f475-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "person frowning"
        ],
        u: "1f64d",
        v: [
            "1f64d-1f3fb",
            "1f64d-1f3fc",
            "1f64d-1f3fd",
            "1f64d-1f3fe",
            "1f64d-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man frowning",
            "man-frowning"
        ],
        u: "1f64d-200d-2642-fe0f",
        v: [
            "1f64d-1f3fb-200d-2642-fe0f",
            "1f64d-1f3fc-200d-2642-fe0f",
            "1f64d-1f3fd-200d-2642-fe0f",
            "1f64d-1f3fe-200d-2642-fe0f",
            "1f64d-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman frowning",
            "woman-frowning"
        ],
        u: "1f64d-200d-2640-fe0f",
        v: [
            "1f64d-1f3fb-200d-2640-fe0f",
            "1f64d-1f3fc-200d-2640-fe0f",
            "1f64d-1f3fd-200d-2640-fe0f",
            "1f64d-1f3fe-200d-2640-fe0f",
            "1f64d-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person with pouting face"
        ],
        u: "1f64e",
        v: [
            "1f64e-1f3fb",
            "1f64e-1f3fc",
            "1f64e-1f3fd",
            "1f64e-1f3fe",
            "1f64e-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man pouting",
            "man-pouting"
        ],
        u: "1f64e-200d-2642-fe0f",
        v: [
            "1f64e-1f3fb-200d-2642-fe0f",
            "1f64e-1f3fc-200d-2642-fe0f",
            "1f64e-1f3fd-200d-2642-fe0f",
            "1f64e-1f3fe-200d-2642-fe0f",
            "1f64e-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman pouting",
            "woman-pouting"
        ],
        u: "1f64e-200d-2640-fe0f",
        v: [
            "1f64e-1f3fb-200d-2640-fe0f",
            "1f64e-1f3fc-200d-2640-fe0f",
            "1f64e-1f3fd-200d-2640-fe0f",
            "1f64e-1f3fe-200d-2640-fe0f",
            "1f64e-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "no good",
            "face with no good gesture"
        ],
        u: "1f645",
        v: [
            "1f645-1f3fb",
            "1f645-1f3fc",
            "1f645-1f3fd",
            "1f645-1f3fe",
            "1f645-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man gesturing no",
            "man-gesturing-no"
        ],
        u: "1f645-200d-2642-fe0f",
        v: [
            "1f645-1f3fb-200d-2642-fe0f",
            "1f645-1f3fc-200d-2642-fe0f",
            "1f645-1f3fd-200d-2642-fe0f",
            "1f645-1f3fe-200d-2642-fe0f",
            "1f645-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman gesturing no",
            "woman-gesturing-no"
        ],
        u: "1f645-200d-2640-fe0f",
        v: [
            "1f645-1f3fb-200d-2640-fe0f",
            "1f645-1f3fc-200d-2640-fe0f",
            "1f645-1f3fd-200d-2640-fe0f",
            "1f645-1f3fe-200d-2640-fe0f",
            "1f645-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "ok woman",
            "face with ok gesture"
        ],
        u: "1f646",
        v: [
            "1f646-1f3fb",
            "1f646-1f3fc",
            "1f646-1f3fd",
            "1f646-1f3fe",
            "1f646-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man gesturing ok",
            "man-gesturing-ok"
        ],
        u: "1f646-200d-2642-fe0f",
        v: [
            "1f646-1f3fb-200d-2642-fe0f",
            "1f646-1f3fc-200d-2642-fe0f",
            "1f646-1f3fd-200d-2642-fe0f",
            "1f646-1f3fe-200d-2642-fe0f",
            "1f646-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman gesturing ok",
            "woman-gesturing-ok"
        ],
        u: "1f646-200d-2640-fe0f",
        v: [
            "1f646-1f3fb-200d-2640-fe0f",
            "1f646-1f3fc-200d-2640-fe0f",
            "1f646-1f3fd-200d-2640-fe0f",
            "1f646-1f3fe-200d-2640-fe0f",
            "1f646-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "information desk person"
        ],
        u: "1f481",
        v: [
            "1f481-1f3fb",
            "1f481-1f3fc",
            "1f481-1f3fd",
            "1f481-1f3fe",
            "1f481-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man tipping hand",
            "man-tipping-hand"
        ],
        u: "1f481-200d-2642-fe0f",
        v: [
            "1f481-1f3fb-200d-2642-fe0f",
            "1f481-1f3fc-200d-2642-fe0f",
            "1f481-1f3fd-200d-2642-fe0f",
            "1f481-1f3fe-200d-2642-fe0f",
            "1f481-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman tipping hand",
            "woman-tipping-hand"
        ],
        u: "1f481-200d-2640-fe0f",
        v: [
            "1f481-1f3fb-200d-2640-fe0f",
            "1f481-1f3fc-200d-2640-fe0f",
            "1f481-1f3fd-200d-2640-fe0f",
            "1f481-1f3fe-200d-2640-fe0f",
            "1f481-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "raising hand",
            "happy person raising one hand"
        ],
        u: "1f64b",
        v: [
            "1f64b-1f3fb",
            "1f64b-1f3fc",
            "1f64b-1f3fd",
            "1f64b-1f3fe",
            "1f64b-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man raising hand",
            "man-raising-hand"
        ],
        u: "1f64b-200d-2642-fe0f",
        v: [
            "1f64b-1f3fb-200d-2642-fe0f",
            "1f64b-1f3fc-200d-2642-fe0f",
            "1f64b-1f3fd-200d-2642-fe0f",
            "1f64b-1f3fe-200d-2642-fe0f",
            "1f64b-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman raising hand",
            "woman-raising-hand"
        ],
        u: "1f64b-200d-2640-fe0f",
        v: [
            "1f64b-1f3fb-200d-2640-fe0f",
            "1f64b-1f3fc-200d-2640-fe0f",
            "1f64b-1f3fd-200d-2640-fe0f",
            "1f64b-1f3fe-200d-2640-fe0f",
            "1f64b-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "deaf person"
        ],
        u: "1f9cf",
        v: [
            "1f9cf-1f3fb",
            "1f9cf-1f3fc",
            "1f9cf-1f3fd",
            "1f9cf-1f3fe",
            "1f9cf-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "deaf man"
        ],
        u: "1f9cf-200d-2642-fe0f",
        v: [
            "1f9cf-1f3fb-200d-2642-fe0f",
            "1f9cf-1f3fc-200d-2642-fe0f",
            "1f9cf-1f3fd-200d-2642-fe0f",
            "1f9cf-1f3fe-200d-2642-fe0f",
            "1f9cf-1f3ff-200d-2642-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "deaf woman"
        ],
        u: "1f9cf-200d-2640-fe0f",
        v: [
            "1f9cf-1f3fb-200d-2640-fe0f",
            "1f9cf-1f3fc-200d-2640-fe0f",
            "1f9cf-1f3fd-200d-2640-fe0f",
            "1f9cf-1f3fe-200d-2640-fe0f",
            "1f9cf-1f3ff-200d-2640-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "bow",
            "person bowing deeply"
        ],
        u: "1f647",
        v: [
            "1f647-1f3fb",
            "1f647-1f3fc",
            "1f647-1f3fd",
            "1f647-1f3fe",
            "1f647-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man bowing",
            "man-bowing"
        ],
        u: "1f647-200d-2642-fe0f",
        v: [
            "1f647-1f3fb-200d-2642-fe0f",
            "1f647-1f3fc-200d-2642-fe0f",
            "1f647-1f3fd-200d-2642-fe0f",
            "1f647-1f3fe-200d-2642-fe0f",
            "1f647-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman bowing",
            "woman-bowing"
        ],
        u: "1f647-200d-2640-fe0f",
        v: [
            "1f647-1f3fb-200d-2640-fe0f",
            "1f647-1f3fc-200d-2640-fe0f",
            "1f647-1f3fd-200d-2640-fe0f",
            "1f647-1f3fe-200d-2640-fe0f",
            "1f647-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "face palm"
        ],
        u: "1f926",
        v: [
            "1f926-1f3fb",
            "1f926-1f3fc",
            "1f926-1f3fd",
            "1f926-1f3fe",
            "1f926-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man facepalming",
            "man-facepalming"
        ],
        u: "1f926-200d-2642-fe0f",
        v: [
            "1f926-1f3fb-200d-2642-fe0f",
            "1f926-1f3fc-200d-2642-fe0f",
            "1f926-1f3fd-200d-2642-fe0f",
            "1f926-1f3fe-200d-2642-fe0f",
            "1f926-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman facepalming",
            "woman-facepalming"
        ],
        u: "1f926-200d-2640-fe0f",
        v: [
            "1f926-1f3fb-200d-2640-fe0f",
            "1f926-1f3fc-200d-2640-fe0f",
            "1f926-1f3fd-200d-2640-fe0f",
            "1f926-1f3fe-200d-2640-fe0f",
            "1f926-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "shrug"
        ],
        u: "1f937",
        v: [
            "1f937-1f3fb",
            "1f937-1f3fc",
            "1f937-1f3fd",
            "1f937-1f3fe",
            "1f937-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man shrugging",
            "man-shrugging"
        ],
        u: "1f937-200d-2642-fe0f",
        v: [
            "1f937-1f3fb-200d-2642-fe0f",
            "1f937-1f3fc-200d-2642-fe0f",
            "1f937-1f3fd-200d-2642-fe0f",
            "1f937-1f3fe-200d-2642-fe0f",
            "1f937-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman shrugging",
            "woman-shrugging"
        ],
        u: "1f937-200d-2640-fe0f",
        v: [
            "1f937-1f3fb-200d-2640-fe0f",
            "1f937-1f3fc-200d-2640-fe0f",
            "1f937-1f3fd-200d-2640-fe0f",
            "1f937-1f3fe-200d-2640-fe0f",
            "1f937-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "health worker"
        ],
        u: "1f9d1-200d-2695-fe0f",
        v: [
            "1f9d1-1f3fb-200d-2695-fe0f",
            "1f9d1-1f3fc-200d-2695-fe0f",
            "1f9d1-1f3fd-200d-2695-fe0f",
            "1f9d1-1f3fe-200d-2695-fe0f",
            "1f9d1-1f3ff-200d-2695-fe0f"
        ],
        a: "12.1"
    },
    {
        n: [
            "male-doctor",
            "man health worker"
        ],
        u: "1f468-200d-2695-fe0f",
        v: [
            "1f468-1f3fb-200d-2695-fe0f",
            "1f468-1f3fc-200d-2695-fe0f",
            "1f468-1f3fd-200d-2695-fe0f",
            "1f468-1f3fe-200d-2695-fe0f",
            "1f468-1f3ff-200d-2695-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "female-doctor",
            "woman health worker"
        ],
        u: "1f469-200d-2695-fe0f",
        v: [
            "1f469-1f3fb-200d-2695-fe0f",
            "1f469-1f3fc-200d-2695-fe0f",
            "1f469-1f3fd-200d-2695-fe0f",
            "1f469-1f3fe-200d-2695-fe0f",
            "1f469-1f3ff-200d-2695-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "student"
        ],
        u: "1f9d1-200d-1f393",
        v: [
            "1f9d1-1f3fb-200d-1f393",
            "1f9d1-1f3fc-200d-1f393",
            "1f9d1-1f3fd-200d-1f393",
            "1f9d1-1f3fe-200d-1f393",
            "1f9d1-1f3ff-200d-1f393"
        ],
        a: "12.1"
    },
    {
        n: [
            "man student",
            "male-student"
        ],
        u: "1f468-200d-1f393",
        v: [
            "1f468-1f3fb-200d-1f393",
            "1f468-1f3fc-200d-1f393",
            "1f468-1f3fd-200d-1f393",
            "1f468-1f3fe-200d-1f393",
            "1f468-1f3ff-200d-1f393"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman student",
            "female-student"
        ],
        u: "1f469-200d-1f393",
        v: [
            "1f469-1f3fb-200d-1f393",
            "1f469-1f3fc-200d-1f393",
            "1f469-1f3fd-200d-1f393",
            "1f469-1f3fe-200d-1f393",
            "1f469-1f3ff-200d-1f393"
        ],
        a: "4.0"
    },
    {
        n: [
            "teacher"
        ],
        u: "1f9d1-200d-1f3eb",
        v: [
            "1f9d1-1f3fb-200d-1f3eb",
            "1f9d1-1f3fc-200d-1f3eb",
            "1f9d1-1f3fd-200d-1f3eb",
            "1f9d1-1f3fe-200d-1f3eb",
            "1f9d1-1f3ff-200d-1f3eb"
        ],
        a: "12.1"
    },
    {
        n: [
            "man teacher",
            "male-teacher"
        ],
        u: "1f468-200d-1f3eb",
        v: [
            "1f468-1f3fb-200d-1f3eb",
            "1f468-1f3fc-200d-1f3eb",
            "1f468-1f3fd-200d-1f3eb",
            "1f468-1f3fe-200d-1f3eb",
            "1f468-1f3ff-200d-1f3eb"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman teacher",
            "female-teacher"
        ],
        u: "1f469-200d-1f3eb",
        v: [
            "1f469-1f3fb-200d-1f3eb",
            "1f469-1f3fc-200d-1f3eb",
            "1f469-1f3fd-200d-1f3eb",
            "1f469-1f3fe-200d-1f3eb",
            "1f469-1f3ff-200d-1f3eb"
        ],
        a: "4.0"
    },
    {
        n: [
            "judge"
        ],
        u: "1f9d1-200d-2696-fe0f",
        v: [
            "1f9d1-1f3fb-200d-2696-fe0f",
            "1f9d1-1f3fc-200d-2696-fe0f",
            "1f9d1-1f3fd-200d-2696-fe0f",
            "1f9d1-1f3fe-200d-2696-fe0f",
            "1f9d1-1f3ff-200d-2696-fe0f"
        ],
        a: "12.1"
    },
    {
        n: [
            "man judge",
            "male-judge"
        ],
        u: "1f468-200d-2696-fe0f",
        v: [
            "1f468-1f3fb-200d-2696-fe0f",
            "1f468-1f3fc-200d-2696-fe0f",
            "1f468-1f3fd-200d-2696-fe0f",
            "1f468-1f3fe-200d-2696-fe0f",
            "1f468-1f3ff-200d-2696-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman judge",
            "female-judge"
        ],
        u: "1f469-200d-2696-fe0f",
        v: [
            "1f469-1f3fb-200d-2696-fe0f",
            "1f469-1f3fc-200d-2696-fe0f",
            "1f469-1f3fd-200d-2696-fe0f",
            "1f469-1f3fe-200d-2696-fe0f",
            "1f469-1f3ff-200d-2696-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "farmer"
        ],
        u: "1f9d1-200d-1f33e",
        v: [
            "1f9d1-1f3fb-200d-1f33e",
            "1f9d1-1f3fc-200d-1f33e",
            "1f9d1-1f3fd-200d-1f33e",
            "1f9d1-1f3fe-200d-1f33e",
            "1f9d1-1f3ff-200d-1f33e"
        ],
        a: "12.1"
    },
    {
        n: [
            "man farmer",
            "male-farmer"
        ],
        u: "1f468-200d-1f33e",
        v: [
            "1f468-1f3fb-200d-1f33e",
            "1f468-1f3fc-200d-1f33e",
            "1f468-1f3fd-200d-1f33e",
            "1f468-1f3fe-200d-1f33e",
            "1f468-1f3ff-200d-1f33e"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman farmer",
            "female-farmer"
        ],
        u: "1f469-200d-1f33e",
        v: [
            "1f469-1f3fb-200d-1f33e",
            "1f469-1f3fc-200d-1f33e",
            "1f469-1f3fd-200d-1f33e",
            "1f469-1f3fe-200d-1f33e",
            "1f469-1f3ff-200d-1f33e"
        ],
        a: "4.0"
    },
    {
        n: [
            "cook"
        ],
        u: "1f9d1-200d-1f373",
        v: [
            "1f9d1-1f3fb-200d-1f373",
            "1f9d1-1f3fc-200d-1f373",
            "1f9d1-1f3fd-200d-1f373",
            "1f9d1-1f3fe-200d-1f373",
            "1f9d1-1f3ff-200d-1f373"
        ],
        a: "12.1"
    },
    {
        n: [
            "man cook",
            "male-cook"
        ],
        u: "1f468-200d-1f373",
        v: [
            "1f468-1f3fb-200d-1f373",
            "1f468-1f3fc-200d-1f373",
            "1f468-1f3fd-200d-1f373",
            "1f468-1f3fe-200d-1f373",
            "1f468-1f3ff-200d-1f373"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman cook",
            "female-cook"
        ],
        u: "1f469-200d-1f373",
        v: [
            "1f469-1f3fb-200d-1f373",
            "1f469-1f3fc-200d-1f373",
            "1f469-1f3fd-200d-1f373",
            "1f469-1f3fe-200d-1f373",
            "1f469-1f3ff-200d-1f373"
        ],
        a: "4.0"
    },
    {
        n: [
            "mechanic"
        ],
        u: "1f9d1-200d-1f527",
        v: [
            "1f9d1-1f3fb-200d-1f527",
            "1f9d1-1f3fc-200d-1f527",
            "1f9d1-1f3fd-200d-1f527",
            "1f9d1-1f3fe-200d-1f527",
            "1f9d1-1f3ff-200d-1f527"
        ],
        a: "12.1"
    },
    {
        n: [
            "man mechanic",
            "male-mechanic"
        ],
        u: "1f468-200d-1f527",
        v: [
            "1f468-1f3fb-200d-1f527",
            "1f468-1f3fc-200d-1f527",
            "1f468-1f3fd-200d-1f527",
            "1f468-1f3fe-200d-1f527",
            "1f468-1f3ff-200d-1f527"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman mechanic",
            "female-mechanic"
        ],
        u: "1f469-200d-1f527",
        v: [
            "1f469-1f3fb-200d-1f527",
            "1f469-1f3fc-200d-1f527",
            "1f469-1f3fd-200d-1f527",
            "1f469-1f3fe-200d-1f527",
            "1f469-1f3ff-200d-1f527"
        ],
        a: "4.0"
    },
    {
        n: [
            "factory worker"
        ],
        u: "1f9d1-200d-1f3ed",
        v: [
            "1f9d1-1f3fb-200d-1f3ed",
            "1f9d1-1f3fc-200d-1f3ed",
            "1f9d1-1f3fd-200d-1f3ed",
            "1f9d1-1f3fe-200d-1f3ed",
            "1f9d1-1f3ff-200d-1f3ed"
        ],
        a: "12.1"
    },
    {
        n: [
            "man factory worker",
            "male-factory-worker"
        ],
        u: "1f468-200d-1f3ed",
        v: [
            "1f468-1f3fb-200d-1f3ed",
            "1f468-1f3fc-200d-1f3ed",
            "1f468-1f3fd-200d-1f3ed",
            "1f468-1f3fe-200d-1f3ed",
            "1f468-1f3ff-200d-1f3ed"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman factory worker",
            "female-factory-worker"
        ],
        u: "1f469-200d-1f3ed",
        v: [
            "1f469-1f3fb-200d-1f3ed",
            "1f469-1f3fc-200d-1f3ed",
            "1f469-1f3fd-200d-1f3ed",
            "1f469-1f3fe-200d-1f3ed",
            "1f469-1f3ff-200d-1f3ed"
        ],
        a: "4.0"
    },
    {
        n: [
            "office worker"
        ],
        u: "1f9d1-200d-1f4bc",
        v: [
            "1f9d1-1f3fb-200d-1f4bc",
            "1f9d1-1f3fc-200d-1f4bc",
            "1f9d1-1f3fd-200d-1f4bc",
            "1f9d1-1f3fe-200d-1f4bc",
            "1f9d1-1f3ff-200d-1f4bc"
        ],
        a: "12.1"
    },
    {
        n: [
            "man office worker",
            "male-office-worker"
        ],
        u: "1f468-200d-1f4bc",
        v: [
            "1f468-1f3fb-200d-1f4bc",
            "1f468-1f3fc-200d-1f4bc",
            "1f468-1f3fd-200d-1f4bc",
            "1f468-1f3fe-200d-1f4bc",
            "1f468-1f3ff-200d-1f4bc"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman office worker",
            "female-office-worker"
        ],
        u: "1f469-200d-1f4bc",
        v: [
            "1f469-1f3fb-200d-1f4bc",
            "1f469-1f3fc-200d-1f4bc",
            "1f469-1f3fd-200d-1f4bc",
            "1f469-1f3fe-200d-1f4bc",
            "1f469-1f3ff-200d-1f4bc"
        ],
        a: "4.0"
    },
    {
        n: [
            "scientist"
        ],
        u: "1f9d1-200d-1f52c",
        v: [
            "1f9d1-1f3fb-200d-1f52c",
            "1f9d1-1f3fc-200d-1f52c",
            "1f9d1-1f3fd-200d-1f52c",
            "1f9d1-1f3fe-200d-1f52c",
            "1f9d1-1f3ff-200d-1f52c"
        ],
        a: "12.1"
    },
    {
        n: [
            "man scientist",
            "male-scientist"
        ],
        u: "1f468-200d-1f52c",
        v: [
            "1f468-1f3fb-200d-1f52c",
            "1f468-1f3fc-200d-1f52c",
            "1f468-1f3fd-200d-1f52c",
            "1f468-1f3fe-200d-1f52c",
            "1f468-1f3ff-200d-1f52c"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman scientist",
            "female-scientist"
        ],
        u: "1f469-200d-1f52c",
        v: [
            "1f469-1f3fb-200d-1f52c",
            "1f469-1f3fc-200d-1f52c",
            "1f469-1f3fd-200d-1f52c",
            "1f469-1f3fe-200d-1f52c",
            "1f469-1f3ff-200d-1f52c"
        ],
        a: "4.0"
    },
    {
        n: [
            "technologist"
        ],
        u: "1f9d1-200d-1f4bb",
        v: [
            "1f9d1-1f3fb-200d-1f4bb",
            "1f9d1-1f3fc-200d-1f4bb",
            "1f9d1-1f3fd-200d-1f4bb",
            "1f9d1-1f3fe-200d-1f4bb",
            "1f9d1-1f3ff-200d-1f4bb"
        ],
        a: "12.1"
    },
    {
        n: [
            "man technologist",
            "male-technologist"
        ],
        u: "1f468-200d-1f4bb",
        v: [
            "1f468-1f3fb-200d-1f4bb",
            "1f468-1f3fc-200d-1f4bb",
            "1f468-1f3fd-200d-1f4bb",
            "1f468-1f3fe-200d-1f4bb",
            "1f468-1f3ff-200d-1f4bb"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman technologist",
            "female-technologist"
        ],
        u: "1f469-200d-1f4bb",
        v: [
            "1f469-1f3fb-200d-1f4bb",
            "1f469-1f3fc-200d-1f4bb",
            "1f469-1f3fd-200d-1f4bb",
            "1f469-1f3fe-200d-1f4bb",
            "1f469-1f3ff-200d-1f4bb"
        ],
        a: "4.0"
    },
    {
        n: [
            "singer"
        ],
        u: "1f9d1-200d-1f3a4",
        v: [
            "1f9d1-1f3fb-200d-1f3a4",
            "1f9d1-1f3fc-200d-1f3a4",
            "1f9d1-1f3fd-200d-1f3a4",
            "1f9d1-1f3fe-200d-1f3a4",
            "1f9d1-1f3ff-200d-1f3a4"
        ],
        a: "12.1"
    },
    {
        n: [
            "man singer",
            "male-singer"
        ],
        u: "1f468-200d-1f3a4",
        v: [
            "1f468-1f3fb-200d-1f3a4",
            "1f468-1f3fc-200d-1f3a4",
            "1f468-1f3fd-200d-1f3a4",
            "1f468-1f3fe-200d-1f3a4",
            "1f468-1f3ff-200d-1f3a4"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman singer",
            "female-singer"
        ],
        u: "1f469-200d-1f3a4",
        v: [
            "1f469-1f3fb-200d-1f3a4",
            "1f469-1f3fc-200d-1f3a4",
            "1f469-1f3fd-200d-1f3a4",
            "1f469-1f3fe-200d-1f3a4",
            "1f469-1f3ff-200d-1f3a4"
        ],
        a: "4.0"
    },
    {
        n: [
            "artist"
        ],
        u: "1f9d1-200d-1f3a8",
        v: [
            "1f9d1-1f3fb-200d-1f3a8",
            "1f9d1-1f3fc-200d-1f3a8",
            "1f9d1-1f3fd-200d-1f3a8",
            "1f9d1-1f3fe-200d-1f3a8",
            "1f9d1-1f3ff-200d-1f3a8"
        ],
        a: "12.1"
    },
    {
        n: [
            "man artist",
            "male-artist"
        ],
        u: "1f468-200d-1f3a8",
        v: [
            "1f468-1f3fb-200d-1f3a8",
            "1f468-1f3fc-200d-1f3a8",
            "1f468-1f3fd-200d-1f3a8",
            "1f468-1f3fe-200d-1f3a8",
            "1f468-1f3ff-200d-1f3a8"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman artist",
            "female-artist"
        ],
        u: "1f469-200d-1f3a8",
        v: [
            "1f469-1f3fb-200d-1f3a8",
            "1f469-1f3fc-200d-1f3a8",
            "1f469-1f3fd-200d-1f3a8",
            "1f469-1f3fe-200d-1f3a8",
            "1f469-1f3ff-200d-1f3a8"
        ],
        a: "4.0"
    },
    {
        n: [
            "pilot"
        ],
        u: "1f9d1-200d-2708-fe0f",
        v: [
            "1f9d1-1f3fb-200d-2708-fe0f",
            "1f9d1-1f3fc-200d-2708-fe0f",
            "1f9d1-1f3fd-200d-2708-fe0f",
            "1f9d1-1f3fe-200d-2708-fe0f",
            "1f9d1-1f3ff-200d-2708-fe0f"
        ],
        a: "12.1"
    },
    {
        n: [
            "man pilot",
            "male-pilot"
        ],
        u: "1f468-200d-2708-fe0f",
        v: [
            "1f468-1f3fb-200d-2708-fe0f",
            "1f468-1f3fc-200d-2708-fe0f",
            "1f468-1f3fd-200d-2708-fe0f",
            "1f468-1f3fe-200d-2708-fe0f",
            "1f468-1f3ff-200d-2708-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman pilot",
            "female-pilot"
        ],
        u: "1f469-200d-2708-fe0f",
        v: [
            "1f469-1f3fb-200d-2708-fe0f",
            "1f469-1f3fc-200d-2708-fe0f",
            "1f469-1f3fd-200d-2708-fe0f",
            "1f469-1f3fe-200d-2708-fe0f",
            "1f469-1f3ff-200d-2708-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "astronaut"
        ],
        u: "1f9d1-200d-1f680",
        v: [
            "1f9d1-1f3fb-200d-1f680",
            "1f9d1-1f3fc-200d-1f680",
            "1f9d1-1f3fd-200d-1f680",
            "1f9d1-1f3fe-200d-1f680",
            "1f9d1-1f3ff-200d-1f680"
        ],
        a: "12.1"
    },
    {
        n: [
            "man astronaut",
            "male-astronaut"
        ],
        u: "1f468-200d-1f680",
        v: [
            "1f468-1f3fb-200d-1f680",
            "1f468-1f3fc-200d-1f680",
            "1f468-1f3fd-200d-1f680",
            "1f468-1f3fe-200d-1f680",
            "1f468-1f3ff-200d-1f680"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman astronaut",
            "female-astronaut"
        ],
        u: "1f469-200d-1f680",
        v: [
            "1f469-1f3fb-200d-1f680",
            "1f469-1f3fc-200d-1f680",
            "1f469-1f3fd-200d-1f680",
            "1f469-1f3fe-200d-1f680",
            "1f469-1f3ff-200d-1f680"
        ],
        a: "4.0"
    },
    {
        n: [
            "firefighter"
        ],
        u: "1f9d1-200d-1f692",
        v: [
            "1f9d1-1f3fb-200d-1f692",
            "1f9d1-1f3fc-200d-1f692",
            "1f9d1-1f3fd-200d-1f692",
            "1f9d1-1f3fe-200d-1f692",
            "1f9d1-1f3ff-200d-1f692"
        ],
        a: "12.1"
    },
    {
        n: [
            "man firefighter",
            "male-firefighter"
        ],
        u: "1f468-200d-1f692",
        v: [
            "1f468-1f3fb-200d-1f692",
            "1f468-1f3fc-200d-1f692",
            "1f468-1f3fd-200d-1f692",
            "1f468-1f3fe-200d-1f692",
            "1f468-1f3ff-200d-1f692"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman firefighter",
            "female-firefighter"
        ],
        u: "1f469-200d-1f692",
        v: [
            "1f469-1f3fb-200d-1f692",
            "1f469-1f3fc-200d-1f692",
            "1f469-1f3fd-200d-1f692",
            "1f469-1f3fe-200d-1f692",
            "1f469-1f3ff-200d-1f692"
        ],
        a: "4.0"
    },
    {
        n: [
            "cop",
            "police officer"
        ],
        u: "1f46e",
        v: [
            "1f46e-1f3fb",
            "1f46e-1f3fc",
            "1f46e-1f3fd",
            "1f46e-1f3fe",
            "1f46e-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man police officer",
            "male-police-officer"
        ],
        u: "1f46e-200d-2642-fe0f",
        v: [
            "1f46e-1f3fb-200d-2642-fe0f",
            "1f46e-1f3fc-200d-2642-fe0f",
            "1f46e-1f3fd-200d-2642-fe0f",
            "1f46e-1f3fe-200d-2642-fe0f",
            "1f46e-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman police officer",
            "female-police-officer"
        ],
        u: "1f46e-200d-2640-fe0f",
        v: [
            "1f46e-1f3fb-200d-2640-fe0f",
            "1f46e-1f3fc-200d-2640-fe0f",
            "1f46e-1f3fd-200d-2640-fe0f",
            "1f46e-1f3fe-200d-2640-fe0f",
            "1f46e-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "detective",
            "sleuth or spy"
        ],
        u: "1f575-fe0f",
        v: [
            "1f575-1f3fb",
            "1f575-1f3fc",
            "1f575-1f3fd",
            "1f575-1f3fe",
            "1f575-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man detective",
            "male-detective"
        ],
        u: "1f575-fe0f-200d-2642-fe0f",
        v: [
            "1f575-1f3fb-200d-2642-fe0f",
            "1f575-1f3fc-200d-2642-fe0f",
            "1f575-1f3fd-200d-2642-fe0f",
            "1f575-1f3fe-200d-2642-fe0f",
            "1f575-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman detective",
            "female-detective"
        ],
        u: "1f575-fe0f-200d-2640-fe0f",
        v: [
            "1f575-1f3fb-200d-2640-fe0f",
            "1f575-1f3fc-200d-2640-fe0f",
            "1f575-1f3fd-200d-2640-fe0f",
            "1f575-1f3fe-200d-2640-fe0f",
            "1f575-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "guardsman"
        ],
        u: "1f482",
        v: [
            "1f482-1f3fb",
            "1f482-1f3fc",
            "1f482-1f3fd",
            "1f482-1f3fe",
            "1f482-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man guard",
            "male-guard"
        ],
        u: "1f482-200d-2642-fe0f",
        v: [
            "1f482-1f3fb-200d-2642-fe0f",
            "1f482-1f3fc-200d-2642-fe0f",
            "1f482-1f3fd-200d-2642-fe0f",
            "1f482-1f3fe-200d-2642-fe0f",
            "1f482-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman guard",
            "female-guard"
        ],
        u: "1f482-200d-2640-fe0f",
        v: [
            "1f482-1f3fb-200d-2640-fe0f",
            "1f482-1f3fc-200d-2640-fe0f",
            "1f482-1f3fd-200d-2640-fe0f",
            "1f482-1f3fe-200d-2640-fe0f",
            "1f482-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "ninja"
        ],
        u: "1f977",
        v: [
            "1f977-1f3fb",
            "1f977-1f3fc",
            "1f977-1f3fd",
            "1f977-1f3fe",
            "1f977-1f3ff"
        ],
        a: "13.0"
    },
    {
        n: [
            "construction worker"
        ],
        u: "1f477",
        v: [
            "1f477-1f3fb",
            "1f477-1f3fc",
            "1f477-1f3fd",
            "1f477-1f3fe",
            "1f477-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man construction worker",
            "male-construction-worker"
        ],
        u: "1f477-200d-2642-fe0f",
        v: [
            "1f477-1f3fb-200d-2642-fe0f",
            "1f477-1f3fc-200d-2642-fe0f",
            "1f477-1f3fd-200d-2642-fe0f",
            "1f477-1f3fe-200d-2642-fe0f",
            "1f477-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman construction worker",
            "female-construction-worker"
        ],
        u: "1f477-200d-2640-fe0f",
        v: [
            "1f477-1f3fb-200d-2640-fe0f",
            "1f477-1f3fc-200d-2640-fe0f",
            "1f477-1f3fd-200d-2640-fe0f",
            "1f477-1f3fe-200d-2640-fe0f",
            "1f477-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person with crown"
        ],
        u: "1fac5",
        v: [
            "1fac5-1f3fb",
            "1fac5-1f3fc",
            "1fac5-1f3fd",
            "1fac5-1f3fe",
            "1fac5-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "prince"
        ],
        u: "1f934",
        v: [
            "1f934-1f3fb",
            "1f934-1f3fc",
            "1f934-1f3fd",
            "1f934-1f3fe",
            "1f934-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "princess"
        ],
        u: "1f478",
        v: [
            "1f478-1f3fb",
            "1f478-1f3fc",
            "1f478-1f3fd",
            "1f478-1f3fe",
            "1f478-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man with turban"
        ],
        u: "1f473",
        v: [
            "1f473-1f3fb",
            "1f473-1f3fc",
            "1f473-1f3fd",
            "1f473-1f3fe",
            "1f473-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man wearing turban",
            "man-wearing-turban"
        ],
        u: "1f473-200d-2642-fe0f",
        v: [
            "1f473-1f3fb-200d-2642-fe0f",
            "1f473-1f3fc-200d-2642-fe0f",
            "1f473-1f3fd-200d-2642-fe0f",
            "1f473-1f3fe-200d-2642-fe0f",
            "1f473-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman wearing turban",
            "woman-wearing-turban"
        ],
        u: "1f473-200d-2640-fe0f",
        v: [
            "1f473-1f3fb-200d-2640-fe0f",
            "1f473-1f3fc-200d-2640-fe0f",
            "1f473-1f3fd-200d-2640-fe0f",
            "1f473-1f3fe-200d-2640-fe0f",
            "1f473-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "man with gua pi mao"
        ],
        u: "1f472",
        v: [
            "1f472-1f3fb",
            "1f472-1f3fc",
            "1f472-1f3fd",
            "1f472-1f3fe",
            "1f472-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "person with headscarf"
        ],
        u: "1f9d5",
        v: [
            "1f9d5-1f3fb",
            "1f9d5-1f3fc",
            "1f9d5-1f3fd",
            "1f9d5-1f3fe",
            "1f9d5-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man in tuxedo",
            "person in tuxedo"
        ],
        u: "1f935",
        v: [
            "1f935-1f3fb",
            "1f935-1f3fc",
            "1f935-1f3fd",
            "1f935-1f3fe",
            "1f935-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man in tuxedo"
        ],
        u: "1f935-200d-2642-fe0f",
        v: [
            "1f935-1f3fb-200d-2642-fe0f",
            "1f935-1f3fc-200d-2642-fe0f",
            "1f935-1f3fd-200d-2642-fe0f",
            "1f935-1f3fe-200d-2642-fe0f",
            "1f935-1f3ff-200d-2642-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "woman in tuxedo"
        ],
        u: "1f935-200d-2640-fe0f",
        v: [
            "1f935-1f3fb-200d-2640-fe0f",
            "1f935-1f3fc-200d-2640-fe0f",
            "1f935-1f3fd-200d-2640-fe0f",
            "1f935-1f3fe-200d-2640-fe0f",
            "1f935-1f3ff-200d-2640-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "bride with veil"
        ],
        u: "1f470",
        v: [
            "1f470-1f3fb",
            "1f470-1f3fc",
            "1f470-1f3fd",
            "1f470-1f3fe",
            "1f470-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man with veil"
        ],
        u: "1f470-200d-2642-fe0f",
        v: [
            "1f470-1f3fb-200d-2642-fe0f",
            "1f470-1f3fc-200d-2642-fe0f",
            "1f470-1f3fd-200d-2642-fe0f",
            "1f470-1f3fe-200d-2642-fe0f",
            "1f470-1f3ff-200d-2642-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "woman with veil"
        ],
        u: "1f470-200d-2640-fe0f",
        v: [
            "1f470-1f3fb-200d-2640-fe0f",
            "1f470-1f3fc-200d-2640-fe0f",
            "1f470-1f3fd-200d-2640-fe0f",
            "1f470-1f3fe-200d-2640-fe0f",
            "1f470-1f3ff-200d-2640-fe0f"
        ],
        a: "13.0"
    },
    {
        n: [
            "pregnant woman"
        ],
        u: "1f930",
        v: [
            "1f930-1f3fb",
            "1f930-1f3fc",
            "1f930-1f3fd",
            "1f930-1f3fe",
            "1f930-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "pregnant man"
        ],
        u: "1fac3",
        v: [
            "1fac3-1f3fb",
            "1fac3-1f3fc",
            "1fac3-1f3fd",
            "1fac3-1f3fe",
            "1fac3-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "pregnant person"
        ],
        u: "1fac4",
        v: [
            "1fac4-1f3fb",
            "1fac4-1f3fc",
            "1fac4-1f3fd",
            "1fac4-1f3fe",
            "1fac4-1f3ff"
        ],
        a: "14.0"
    },
    {
        n: [
            "breast-feeding"
        ],
        u: "1f931",
        v: [
            "1f931-1f3fb",
            "1f931-1f3fc",
            "1f931-1f3fd",
            "1f931-1f3fe",
            "1f931-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman feeding baby"
        ],
        u: "1f469-200d-1f37c",
        v: [
            "1f469-1f3fb-200d-1f37c",
            "1f469-1f3fc-200d-1f37c",
            "1f469-1f3fd-200d-1f37c",
            "1f469-1f3fe-200d-1f37c",
            "1f469-1f3ff-200d-1f37c"
        ],
        a: "13.0"
    },
    {
        n: [
            "man feeding baby"
        ],
        u: "1f468-200d-1f37c",
        v: [
            "1f468-1f3fb-200d-1f37c",
            "1f468-1f3fc-200d-1f37c",
            "1f468-1f3fd-200d-1f37c",
            "1f468-1f3fe-200d-1f37c",
            "1f468-1f3ff-200d-1f37c"
        ],
        a: "13.0"
    },
    {
        n: [
            "person feeding baby"
        ],
        u: "1f9d1-200d-1f37c",
        v: [
            "1f9d1-1f3fb-200d-1f37c",
            "1f9d1-1f3fc-200d-1f37c",
            "1f9d1-1f3fd-200d-1f37c",
            "1f9d1-1f3fe-200d-1f37c",
            "1f9d1-1f3ff-200d-1f37c"
        ],
        a: "13.0"
    },
    {
        n: [
            "angel",
            "baby angel"
        ],
        u: "1f47c",
        v: [
            "1f47c-1f3fb",
            "1f47c-1f3fc",
            "1f47c-1f3fd",
            "1f47c-1f3fe",
            "1f47c-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "santa",
            "father christmas"
        ],
        u: "1f385",
        v: [
            "1f385-1f3fb",
            "1f385-1f3fc",
            "1f385-1f3fd",
            "1f385-1f3fe",
            "1f385-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "mrs claus",
            "mother christmas"
        ],
        u: "1f936",
        v: [
            "1f936-1f3fb",
            "1f936-1f3fc",
            "1f936-1f3fd",
            "1f936-1f3fe",
            "1f936-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "mx claus"
        ],
        u: "1f9d1-200d-1f384",
        v: [
            "1f9d1-1f3fb-200d-1f384",
            "1f9d1-1f3fc-200d-1f384",
            "1f9d1-1f3fd-200d-1f384",
            "1f9d1-1f3fe-200d-1f384",
            "1f9d1-1f3ff-200d-1f384"
        ],
        a: "13.0"
    },
    {
        n: [
            "superhero"
        ],
        u: "1f9b8",
        v: [
            "1f9b8-1f3fb",
            "1f9b8-1f3fc",
            "1f9b8-1f3fd",
            "1f9b8-1f3fe",
            "1f9b8-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "man superhero",
            "male superhero"
        ],
        u: "1f9b8-200d-2642-fe0f",
        v: [
            "1f9b8-1f3fb-200d-2642-fe0f",
            "1f9b8-1f3fc-200d-2642-fe0f",
            "1f9b8-1f3fd-200d-2642-fe0f",
            "1f9b8-1f3fe-200d-2642-fe0f",
            "1f9b8-1f3ff-200d-2642-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "woman superhero",
            "female superhero"
        ],
        u: "1f9b8-200d-2640-fe0f",
        v: [
            "1f9b8-1f3fb-200d-2640-fe0f",
            "1f9b8-1f3fc-200d-2640-fe0f",
            "1f9b8-1f3fd-200d-2640-fe0f",
            "1f9b8-1f3fe-200d-2640-fe0f",
            "1f9b8-1f3ff-200d-2640-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "supervillain"
        ],
        u: "1f9b9",
        v: [
            "1f9b9-1f3fb",
            "1f9b9-1f3fc",
            "1f9b9-1f3fd",
            "1f9b9-1f3fe",
            "1f9b9-1f3ff"
        ],
        a: "11.0"
    },
    {
        n: [
            "man supervillain",
            "male supervillain"
        ],
        u: "1f9b9-200d-2642-fe0f",
        v: [
            "1f9b9-1f3fb-200d-2642-fe0f",
            "1f9b9-1f3fc-200d-2642-fe0f",
            "1f9b9-1f3fd-200d-2642-fe0f",
            "1f9b9-1f3fe-200d-2642-fe0f",
            "1f9b9-1f3ff-200d-2642-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "woman supervillain",
            "female supervillain"
        ],
        u: "1f9b9-200d-2640-fe0f",
        v: [
            "1f9b9-1f3fb-200d-2640-fe0f",
            "1f9b9-1f3fc-200d-2640-fe0f",
            "1f9b9-1f3fd-200d-2640-fe0f",
            "1f9b9-1f3fe-200d-2640-fe0f",
            "1f9b9-1f3ff-200d-2640-fe0f"
        ],
        a: "11.0"
    },
    {
        n: [
            "mage"
        ],
        u: "1f9d9",
        v: [
            "1f9d9-1f3fb",
            "1f9d9-1f3fc",
            "1f9d9-1f3fd",
            "1f9d9-1f3fe",
            "1f9d9-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man mage",
            "male mage"
        ],
        u: "1f9d9-200d-2642-fe0f",
        v: [
            "1f9d9-1f3fb-200d-2642-fe0f",
            "1f9d9-1f3fc-200d-2642-fe0f",
            "1f9d9-1f3fd-200d-2642-fe0f",
            "1f9d9-1f3fe-200d-2642-fe0f",
            "1f9d9-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman mage",
            "female mage"
        ],
        u: "1f9d9-200d-2640-fe0f",
        v: [
            "1f9d9-1f3fb-200d-2640-fe0f",
            "1f9d9-1f3fc-200d-2640-fe0f",
            "1f9d9-1f3fd-200d-2640-fe0f",
            "1f9d9-1f3fe-200d-2640-fe0f",
            "1f9d9-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "fairy"
        ],
        u: "1f9da",
        v: [
            "1f9da-1f3fb",
            "1f9da-1f3fc",
            "1f9da-1f3fd",
            "1f9da-1f3fe",
            "1f9da-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man fairy",
            "male fairy"
        ],
        u: "1f9da-200d-2642-fe0f",
        v: [
            "1f9da-1f3fb-200d-2642-fe0f",
            "1f9da-1f3fc-200d-2642-fe0f",
            "1f9da-1f3fd-200d-2642-fe0f",
            "1f9da-1f3fe-200d-2642-fe0f",
            "1f9da-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman fairy",
            "female fairy"
        ],
        u: "1f9da-200d-2640-fe0f",
        v: [
            "1f9da-1f3fb-200d-2640-fe0f",
            "1f9da-1f3fc-200d-2640-fe0f",
            "1f9da-1f3fd-200d-2640-fe0f",
            "1f9da-1f3fe-200d-2640-fe0f",
            "1f9da-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "vampire"
        ],
        u: "1f9db",
        v: [
            "1f9db-1f3fb",
            "1f9db-1f3fc",
            "1f9db-1f3fd",
            "1f9db-1f3fe",
            "1f9db-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man vampire",
            "male vampire"
        ],
        u: "1f9db-200d-2642-fe0f",
        v: [
            "1f9db-1f3fb-200d-2642-fe0f",
            "1f9db-1f3fc-200d-2642-fe0f",
            "1f9db-1f3fd-200d-2642-fe0f",
            "1f9db-1f3fe-200d-2642-fe0f",
            "1f9db-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman vampire",
            "female vampire"
        ],
        u: "1f9db-200d-2640-fe0f",
        v: [
            "1f9db-1f3fb-200d-2640-fe0f",
            "1f9db-1f3fc-200d-2640-fe0f",
            "1f9db-1f3fd-200d-2640-fe0f",
            "1f9db-1f3fe-200d-2640-fe0f",
            "1f9db-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "merperson"
        ],
        u: "1f9dc",
        v: [
            "1f9dc-1f3fb",
            "1f9dc-1f3fc",
            "1f9dc-1f3fd",
            "1f9dc-1f3fe",
            "1f9dc-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "merman"
        ],
        u: "1f9dc-200d-2642-fe0f",
        v: [
            "1f9dc-1f3fb-200d-2642-fe0f",
            "1f9dc-1f3fc-200d-2642-fe0f",
            "1f9dc-1f3fd-200d-2642-fe0f",
            "1f9dc-1f3fe-200d-2642-fe0f",
            "1f9dc-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "mermaid"
        ],
        u: "1f9dc-200d-2640-fe0f",
        v: [
            "1f9dc-1f3fb-200d-2640-fe0f",
            "1f9dc-1f3fc-200d-2640-fe0f",
            "1f9dc-1f3fd-200d-2640-fe0f",
            "1f9dc-1f3fe-200d-2640-fe0f",
            "1f9dc-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "elf"
        ],
        u: "1f9dd",
        v: [
            "1f9dd-1f3fb",
            "1f9dd-1f3fc",
            "1f9dd-1f3fd",
            "1f9dd-1f3fe",
            "1f9dd-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man elf",
            "male elf"
        ],
        u: "1f9dd-200d-2642-fe0f",
        v: [
            "1f9dd-1f3fb-200d-2642-fe0f",
            "1f9dd-1f3fc-200d-2642-fe0f",
            "1f9dd-1f3fd-200d-2642-fe0f",
            "1f9dd-1f3fe-200d-2642-fe0f",
            "1f9dd-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman elf",
            "female elf"
        ],
        u: "1f9dd-200d-2640-fe0f",
        v: [
            "1f9dd-1f3fb-200d-2640-fe0f",
            "1f9dd-1f3fc-200d-2640-fe0f",
            "1f9dd-1f3fd-200d-2640-fe0f",
            "1f9dd-1f3fe-200d-2640-fe0f",
            "1f9dd-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "genie"
        ],
        u: "1f9de",
        a: "5.0"
    },
    {
        n: [
            "man genie",
            "male genie"
        ],
        u: "1f9de-200d-2642-fe0f",
        a: "5.0"
    },
    {
        n: [
            "woman genie",
            "female genie"
        ],
        u: "1f9de-200d-2640-fe0f",
        a: "5.0"
    },
    {
        n: [
            "zombie"
        ],
        u: "1f9df",
        a: "5.0"
    },
    {
        n: [
            "man zombie",
            "male zombie"
        ],
        u: "1f9df-200d-2642-fe0f",
        a: "5.0"
    },
    {
        n: [
            "woman zombie",
            "female zombie"
        ],
        u: "1f9df-200d-2640-fe0f",
        a: "5.0"
    },
    {
        n: [
            "troll"
        ],
        u: "1f9cc",
        a: "14.0"
    },
    {
        n: [
            "massage",
            "face massage"
        ],
        u: "1f486",
        v: [
            "1f486-1f3fb",
            "1f486-1f3fc",
            "1f486-1f3fd",
            "1f486-1f3fe",
            "1f486-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man getting massage",
            "man-getting-massage"
        ],
        u: "1f486-200d-2642-fe0f",
        v: [
            "1f486-1f3fb-200d-2642-fe0f",
            "1f486-1f3fc-200d-2642-fe0f",
            "1f486-1f3fd-200d-2642-fe0f",
            "1f486-1f3fe-200d-2642-fe0f",
            "1f486-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman getting massage",
            "woman-getting-massage"
        ],
        u: "1f486-200d-2640-fe0f",
        v: [
            "1f486-1f3fb-200d-2640-fe0f",
            "1f486-1f3fc-200d-2640-fe0f",
            "1f486-1f3fd-200d-2640-fe0f",
            "1f486-1f3fe-200d-2640-fe0f",
            "1f486-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "haircut"
        ],
        u: "1f487",
        v: [
            "1f487-1f3fb",
            "1f487-1f3fc",
            "1f487-1f3fd",
            "1f487-1f3fe",
            "1f487-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man getting haircut",
            "man-getting-haircut"
        ],
        u: "1f487-200d-2642-fe0f",
        v: [
            "1f487-1f3fb-200d-2642-fe0f",
            "1f487-1f3fc-200d-2642-fe0f",
            "1f487-1f3fd-200d-2642-fe0f",
            "1f487-1f3fe-200d-2642-fe0f",
            "1f487-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman getting haircut",
            "woman-getting-haircut"
        ],
        u: "1f487-200d-2640-fe0f",
        v: [
            "1f487-1f3fb-200d-2640-fe0f",
            "1f487-1f3fc-200d-2640-fe0f",
            "1f487-1f3fd-200d-2640-fe0f",
            "1f487-1f3fe-200d-2640-fe0f",
            "1f487-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "walking",
            "pedestrian"
        ],
        u: "1f6b6",
        v: [
            "1f6b6-1f3fb",
            "1f6b6-1f3fc",
            "1f6b6-1f3fd",
            "1f6b6-1f3fe",
            "1f6b6-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man walking",
            "man-walking"
        ],
        u: "1f6b6-200d-2642-fe0f",
        v: [
            "1f6b6-1f3fb-200d-2642-fe0f",
            "1f6b6-1f3fc-200d-2642-fe0f",
            "1f6b6-1f3fd-200d-2642-fe0f",
            "1f6b6-1f3fe-200d-2642-fe0f",
            "1f6b6-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman walking",
            "woman-walking"
        ],
        u: "1f6b6-200d-2640-fe0f",
        v: [
            "1f6b6-1f3fb-200d-2640-fe0f",
            "1f6b6-1f3fc-200d-2640-fe0f",
            "1f6b6-1f3fd-200d-2640-fe0f",
            "1f6b6-1f3fe-200d-2640-fe0f",
            "1f6b6-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "standing person"
        ],
        u: "1f9cd",
        v: [
            "1f9cd-1f3fb",
            "1f9cd-1f3fc",
            "1f9cd-1f3fd",
            "1f9cd-1f3fe",
            "1f9cd-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "man standing"
        ],
        u: "1f9cd-200d-2642-fe0f",
        v: [
            "1f9cd-1f3fb-200d-2642-fe0f",
            "1f9cd-1f3fc-200d-2642-fe0f",
            "1f9cd-1f3fd-200d-2642-fe0f",
            "1f9cd-1f3fe-200d-2642-fe0f",
            "1f9cd-1f3ff-200d-2642-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman standing"
        ],
        u: "1f9cd-200d-2640-fe0f",
        v: [
            "1f9cd-1f3fb-200d-2640-fe0f",
            "1f9cd-1f3fc-200d-2640-fe0f",
            "1f9cd-1f3fd-200d-2640-fe0f",
            "1f9cd-1f3fe-200d-2640-fe0f",
            "1f9cd-1f3ff-200d-2640-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "kneeling person"
        ],
        u: "1f9ce",
        v: [
            "1f9ce-1f3fb",
            "1f9ce-1f3fc",
            "1f9ce-1f3fd",
            "1f9ce-1f3fe",
            "1f9ce-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "man kneeling"
        ],
        u: "1f9ce-200d-2642-fe0f",
        v: [
            "1f9ce-1f3fb-200d-2642-fe0f",
            "1f9ce-1f3fc-200d-2642-fe0f",
            "1f9ce-1f3fd-200d-2642-fe0f",
            "1f9ce-1f3fe-200d-2642-fe0f",
            "1f9ce-1f3ff-200d-2642-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman kneeling"
        ],
        u: "1f9ce-200d-2640-fe0f",
        v: [
            "1f9ce-1f3fb-200d-2640-fe0f",
            "1f9ce-1f3fc-200d-2640-fe0f",
            "1f9ce-1f3fd-200d-2640-fe0f",
            "1f9ce-1f3fe-200d-2640-fe0f",
            "1f9ce-1f3ff-200d-2640-fe0f"
        ],
        a: "12.0"
    },
    {
        n: [
            "person with white cane",
            "person with probing cane"
        ],
        u: "1f9d1-200d-1f9af",
        v: [
            "1f9d1-1f3fb-200d-1f9af",
            "1f9d1-1f3fc-200d-1f9af",
            "1f9d1-1f3fd-200d-1f9af",
            "1f9d1-1f3fe-200d-1f9af",
            "1f9d1-1f3ff-200d-1f9af"
        ],
        a: "12.1"
    },
    {
        n: [
            "man with white cane",
            "man with probing cane"
        ],
        u: "1f468-200d-1f9af",
        v: [
            "1f468-1f3fb-200d-1f9af",
            "1f468-1f3fc-200d-1f9af",
            "1f468-1f3fd-200d-1f9af",
            "1f468-1f3fe-200d-1f9af",
            "1f468-1f3ff-200d-1f9af"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman with white cane",
            "woman with probing cane"
        ],
        u: "1f469-200d-1f9af",
        v: [
            "1f469-1f3fb-200d-1f9af",
            "1f469-1f3fc-200d-1f9af",
            "1f469-1f3fd-200d-1f9af",
            "1f469-1f3fe-200d-1f9af",
            "1f469-1f3ff-200d-1f9af"
        ],
        a: "12.0"
    },
    {
        n: [
            "person in motorized wheelchair"
        ],
        u: "1f9d1-200d-1f9bc",
        v: [
            "1f9d1-1f3fb-200d-1f9bc",
            "1f9d1-1f3fc-200d-1f9bc",
            "1f9d1-1f3fd-200d-1f9bc",
            "1f9d1-1f3fe-200d-1f9bc",
            "1f9d1-1f3ff-200d-1f9bc"
        ],
        a: "12.1"
    },
    {
        n: [
            "man in motorized wheelchair"
        ],
        u: "1f468-200d-1f9bc",
        v: [
            "1f468-1f3fb-200d-1f9bc",
            "1f468-1f3fc-200d-1f9bc",
            "1f468-1f3fd-200d-1f9bc",
            "1f468-1f3fe-200d-1f9bc",
            "1f468-1f3ff-200d-1f9bc"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman in motorized wheelchair"
        ],
        u: "1f469-200d-1f9bc",
        v: [
            "1f469-1f3fb-200d-1f9bc",
            "1f469-1f3fc-200d-1f9bc",
            "1f469-1f3fd-200d-1f9bc",
            "1f469-1f3fe-200d-1f9bc",
            "1f469-1f3ff-200d-1f9bc"
        ],
        a: "12.0"
    },
    {
        n: [
            "person in manual wheelchair"
        ],
        u: "1f9d1-200d-1f9bd",
        v: [
            "1f9d1-1f3fb-200d-1f9bd",
            "1f9d1-1f3fc-200d-1f9bd",
            "1f9d1-1f3fd-200d-1f9bd",
            "1f9d1-1f3fe-200d-1f9bd",
            "1f9d1-1f3ff-200d-1f9bd"
        ],
        a: "12.1"
    },
    {
        n: [
            "man in manual wheelchair"
        ],
        u: "1f468-200d-1f9bd",
        v: [
            "1f468-1f3fb-200d-1f9bd",
            "1f468-1f3fc-200d-1f9bd",
            "1f468-1f3fd-200d-1f9bd",
            "1f468-1f3fe-200d-1f9bd",
            "1f468-1f3ff-200d-1f9bd"
        ],
        a: "12.0"
    },
    {
        n: [
            "woman in manual wheelchair"
        ],
        u: "1f469-200d-1f9bd",
        v: [
            "1f469-1f3fb-200d-1f9bd",
            "1f469-1f3fc-200d-1f9bd",
            "1f469-1f3fd-200d-1f9bd",
            "1f469-1f3fe-200d-1f9bd",
            "1f469-1f3ff-200d-1f9bd"
        ],
        a: "12.0"
    },
    {
        n: [
            "runner",
            "running"
        ],
        u: "1f3c3",
        v: [
            "1f3c3-1f3fb",
            "1f3c3-1f3fc",
            "1f3c3-1f3fd",
            "1f3c3-1f3fe",
            "1f3c3-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man running",
            "man-running"
        ],
        u: "1f3c3-200d-2642-fe0f",
        v: [
            "1f3c3-1f3fb-200d-2642-fe0f",
            "1f3c3-1f3fc-200d-2642-fe0f",
            "1f3c3-1f3fd-200d-2642-fe0f",
            "1f3c3-1f3fe-200d-2642-fe0f",
            "1f3c3-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman running",
            "woman-running"
        ],
        u: "1f3c3-200d-2640-fe0f",
        v: [
            "1f3c3-1f3fb-200d-2640-fe0f",
            "1f3c3-1f3fc-200d-2640-fe0f",
            "1f3c3-1f3fd-200d-2640-fe0f",
            "1f3c3-1f3fe-200d-2640-fe0f",
            "1f3c3-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "dancer"
        ],
        u: "1f483",
        v: [
            "1f483-1f3fb",
            "1f483-1f3fc",
            "1f483-1f3fd",
            "1f483-1f3fe",
            "1f483-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man dancing"
        ],
        u: "1f57a",
        v: [
            "1f57a-1f3fb",
            "1f57a-1f3fc",
            "1f57a-1f3fd",
            "1f57a-1f3fe",
            "1f57a-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "person in suit levitating",
            "man in business suit levitating"
        ],
        u: "1f574-fe0f",
        v: [
            "1f574-1f3fb",
            "1f574-1f3fc",
            "1f574-1f3fd",
            "1f574-1f3fe",
            "1f574-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "dancers",
            "woman with bunny ears"
        ],
        u: "1f46f",
        a: "0.6"
    },
    {
        n: [
            "men with bunny ears",
            "men-with-bunny-ears-partying",
            "man-with-bunny-ears-partying"
        ],
        u: "1f46f-200d-2642-fe0f",
        a: "4.0"
    },
    {
        n: [
            "women with bunny ears",
            "women-with-bunny-ears-partying",
            "woman-with-bunny-ears-partying"
        ],
        u: "1f46f-200d-2640-fe0f",
        a: "4.0"
    },
    {
        n: [
            "person in steamy room"
        ],
        u: "1f9d6",
        v: [
            "1f9d6-1f3fb",
            "1f9d6-1f3fc",
            "1f9d6-1f3fd",
            "1f9d6-1f3fe",
            "1f9d6-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man in steamy room"
        ],
        u: "1f9d6-200d-2642-fe0f",
        v: [
            "1f9d6-1f3fb-200d-2642-fe0f",
            "1f9d6-1f3fc-200d-2642-fe0f",
            "1f9d6-1f3fd-200d-2642-fe0f",
            "1f9d6-1f3fe-200d-2642-fe0f",
            "1f9d6-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman in steamy room"
        ],
        u: "1f9d6-200d-2640-fe0f",
        v: [
            "1f9d6-1f3fb-200d-2640-fe0f",
            "1f9d6-1f3fc-200d-2640-fe0f",
            "1f9d6-1f3fd-200d-2640-fe0f",
            "1f9d6-1f3fe-200d-2640-fe0f",
            "1f9d6-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "person climbing"
        ],
        u: "1f9d7",
        v: [
            "1f9d7-1f3fb",
            "1f9d7-1f3fc",
            "1f9d7-1f3fd",
            "1f9d7-1f3fe",
            "1f9d7-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man climbing"
        ],
        u: "1f9d7-200d-2642-fe0f",
        v: [
            "1f9d7-1f3fb-200d-2642-fe0f",
            "1f9d7-1f3fc-200d-2642-fe0f",
            "1f9d7-1f3fd-200d-2642-fe0f",
            "1f9d7-1f3fe-200d-2642-fe0f",
            "1f9d7-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman climbing"
        ],
        u: "1f9d7-200d-2640-fe0f",
        v: [
            "1f9d7-1f3fb-200d-2640-fe0f",
            "1f9d7-1f3fc-200d-2640-fe0f",
            "1f9d7-1f3fd-200d-2640-fe0f",
            "1f9d7-1f3fe-200d-2640-fe0f",
            "1f9d7-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "fencer"
        ],
        u: "1f93a",
        a: "3.0"
    },
    {
        n: [
            "horse racing"
        ],
        u: "1f3c7",
        v: [
            "1f3c7-1f3fb",
            "1f3c7-1f3fc",
            "1f3c7-1f3fd",
            "1f3c7-1f3fe",
            "1f3c7-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "skier"
        ],
        u: "26f7-fe0f",
        a: "0.7"
    },
    {
        n: [
            "snowboarder"
        ],
        u: "1f3c2",
        v: [
            "1f3c2-1f3fb",
            "1f3c2-1f3fc",
            "1f3c2-1f3fd",
            "1f3c2-1f3fe",
            "1f3c2-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "golfer",
            "person golfing"
        ],
        u: "1f3cc-fe0f",
        v: [
            "1f3cc-1f3fb",
            "1f3cc-1f3fc",
            "1f3cc-1f3fd",
            "1f3cc-1f3fe",
            "1f3cc-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man golfing",
            "man-golfing"
        ],
        u: "1f3cc-fe0f-200d-2642-fe0f",
        v: [
            "1f3cc-1f3fb-200d-2642-fe0f",
            "1f3cc-1f3fc-200d-2642-fe0f",
            "1f3cc-1f3fd-200d-2642-fe0f",
            "1f3cc-1f3fe-200d-2642-fe0f",
            "1f3cc-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman golfing",
            "woman-golfing"
        ],
        u: "1f3cc-fe0f-200d-2640-fe0f",
        v: [
            "1f3cc-1f3fb-200d-2640-fe0f",
            "1f3cc-1f3fc-200d-2640-fe0f",
            "1f3cc-1f3fd-200d-2640-fe0f",
            "1f3cc-1f3fe-200d-2640-fe0f",
            "1f3cc-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "surfer"
        ],
        u: "1f3c4",
        v: [
            "1f3c4-1f3fb",
            "1f3c4-1f3fc",
            "1f3c4-1f3fd",
            "1f3c4-1f3fe",
            "1f3c4-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man surfing",
            "man-surfing"
        ],
        u: "1f3c4-200d-2642-fe0f",
        v: [
            "1f3c4-1f3fb-200d-2642-fe0f",
            "1f3c4-1f3fc-200d-2642-fe0f",
            "1f3c4-1f3fd-200d-2642-fe0f",
            "1f3c4-1f3fe-200d-2642-fe0f",
            "1f3c4-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman surfing",
            "woman-surfing"
        ],
        u: "1f3c4-200d-2640-fe0f",
        v: [
            "1f3c4-1f3fb-200d-2640-fe0f",
            "1f3c4-1f3fc-200d-2640-fe0f",
            "1f3c4-1f3fd-200d-2640-fe0f",
            "1f3c4-1f3fe-200d-2640-fe0f",
            "1f3c4-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "rowboat"
        ],
        u: "1f6a3",
        v: [
            "1f6a3-1f3fb",
            "1f6a3-1f3fc",
            "1f6a3-1f3fd",
            "1f6a3-1f3fe",
            "1f6a3-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "man rowing boat",
            "man-rowing-boat"
        ],
        u: "1f6a3-200d-2642-fe0f",
        v: [
            "1f6a3-1f3fb-200d-2642-fe0f",
            "1f6a3-1f3fc-200d-2642-fe0f",
            "1f6a3-1f3fd-200d-2642-fe0f",
            "1f6a3-1f3fe-200d-2642-fe0f",
            "1f6a3-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman rowing boat",
            "woman-rowing-boat"
        ],
        u: "1f6a3-200d-2640-fe0f",
        v: [
            "1f6a3-1f3fb-200d-2640-fe0f",
            "1f6a3-1f3fc-200d-2640-fe0f",
            "1f6a3-1f3fd-200d-2640-fe0f",
            "1f6a3-1f3fe-200d-2640-fe0f",
            "1f6a3-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "swimmer"
        ],
        u: "1f3ca",
        v: [
            "1f3ca-1f3fb",
            "1f3ca-1f3fc",
            "1f3ca-1f3fd",
            "1f3ca-1f3fe",
            "1f3ca-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "man swimming",
            "man-swimming"
        ],
        u: "1f3ca-200d-2642-fe0f",
        v: [
            "1f3ca-1f3fb-200d-2642-fe0f",
            "1f3ca-1f3fc-200d-2642-fe0f",
            "1f3ca-1f3fd-200d-2642-fe0f",
            "1f3ca-1f3fe-200d-2642-fe0f",
            "1f3ca-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman swimming",
            "woman-swimming"
        ],
        u: "1f3ca-200d-2640-fe0f",
        v: [
            "1f3ca-1f3fb-200d-2640-fe0f",
            "1f3ca-1f3fc-200d-2640-fe0f",
            "1f3ca-1f3fd-200d-2640-fe0f",
            "1f3ca-1f3fe-200d-2640-fe0f",
            "1f3ca-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person with ball",
            "person bouncing ball"
        ],
        u: "26f9-fe0f",
        v: [
            "26f9-1f3fb",
            "26f9-1f3fc",
            "26f9-1f3fd",
            "26f9-1f3fe",
            "26f9-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man bouncing ball",
            "man-bouncing-ball"
        ],
        u: "26f9-fe0f-200d-2642-fe0f",
        v: [
            "26f9-1f3fb-200d-2642-fe0f",
            "26f9-1f3fc-200d-2642-fe0f",
            "26f9-1f3fd-200d-2642-fe0f",
            "26f9-1f3fe-200d-2642-fe0f",
            "26f9-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman bouncing ball",
            "woman-bouncing-ball"
        ],
        u: "26f9-fe0f-200d-2640-fe0f",
        v: [
            "26f9-1f3fb-200d-2640-fe0f",
            "26f9-1f3fc-200d-2640-fe0f",
            "26f9-1f3fd-200d-2640-fe0f",
            "26f9-1f3fe-200d-2640-fe0f",
            "26f9-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "weight lifter",
            "person lifting weights"
        ],
        u: "1f3cb-fe0f",
        v: [
            "1f3cb-1f3fb",
            "1f3cb-1f3fc",
            "1f3cb-1f3fd",
            "1f3cb-1f3fe",
            "1f3cb-1f3ff"
        ],
        a: "0.7"
    },
    {
        n: [
            "man lifting weights",
            "man-lifting-weights"
        ],
        u: "1f3cb-fe0f-200d-2642-fe0f",
        v: [
            "1f3cb-1f3fb-200d-2642-fe0f",
            "1f3cb-1f3fc-200d-2642-fe0f",
            "1f3cb-1f3fd-200d-2642-fe0f",
            "1f3cb-1f3fe-200d-2642-fe0f",
            "1f3cb-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman lifting weights",
            "woman-lifting-weights"
        ],
        u: "1f3cb-fe0f-200d-2640-fe0f",
        v: [
            "1f3cb-1f3fb-200d-2640-fe0f",
            "1f3cb-1f3fc-200d-2640-fe0f",
            "1f3cb-1f3fd-200d-2640-fe0f",
            "1f3cb-1f3fe-200d-2640-fe0f",
            "1f3cb-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "bicyclist"
        ],
        u: "1f6b4",
        v: [
            "1f6b4-1f3fb",
            "1f6b4-1f3fc",
            "1f6b4-1f3fd",
            "1f6b4-1f3fe",
            "1f6b4-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "man biking",
            "man-biking"
        ],
        u: "1f6b4-200d-2642-fe0f",
        v: [
            "1f6b4-1f3fb-200d-2642-fe0f",
            "1f6b4-1f3fc-200d-2642-fe0f",
            "1f6b4-1f3fd-200d-2642-fe0f",
            "1f6b4-1f3fe-200d-2642-fe0f",
            "1f6b4-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman biking",
            "woman-biking"
        ],
        u: "1f6b4-200d-2640-fe0f",
        v: [
            "1f6b4-1f3fb-200d-2640-fe0f",
            "1f6b4-1f3fc-200d-2640-fe0f",
            "1f6b4-1f3fd-200d-2640-fe0f",
            "1f6b4-1f3fe-200d-2640-fe0f",
            "1f6b4-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "mountain bicyclist"
        ],
        u: "1f6b5",
        v: [
            "1f6b5-1f3fb",
            "1f6b5-1f3fc",
            "1f6b5-1f3fd",
            "1f6b5-1f3fe",
            "1f6b5-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "man mountain biking",
            "man-mountain-biking"
        ],
        u: "1f6b5-200d-2642-fe0f",
        v: [
            "1f6b5-1f3fb-200d-2642-fe0f",
            "1f6b5-1f3fc-200d-2642-fe0f",
            "1f6b5-1f3fd-200d-2642-fe0f",
            "1f6b5-1f3fe-200d-2642-fe0f",
            "1f6b5-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman mountain biking",
            "woman-mountain-biking"
        ],
        u: "1f6b5-200d-2640-fe0f",
        v: [
            "1f6b5-1f3fb-200d-2640-fe0f",
            "1f6b5-1f3fc-200d-2640-fe0f",
            "1f6b5-1f3fd-200d-2640-fe0f",
            "1f6b5-1f3fe-200d-2640-fe0f",
            "1f6b5-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person doing cartwheel"
        ],
        u: "1f938",
        v: [
            "1f938-1f3fb",
            "1f938-1f3fc",
            "1f938-1f3fd",
            "1f938-1f3fe",
            "1f938-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man cartwheeling",
            "man-cartwheeling"
        ],
        u: "1f938-200d-2642-fe0f",
        v: [
            "1f938-1f3fb-200d-2642-fe0f",
            "1f938-1f3fc-200d-2642-fe0f",
            "1f938-1f3fd-200d-2642-fe0f",
            "1f938-1f3fe-200d-2642-fe0f",
            "1f938-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman cartwheeling",
            "woman-cartwheeling"
        ],
        u: "1f938-200d-2640-fe0f",
        v: [
            "1f938-1f3fb-200d-2640-fe0f",
            "1f938-1f3fc-200d-2640-fe0f",
            "1f938-1f3fd-200d-2640-fe0f",
            "1f938-1f3fe-200d-2640-fe0f",
            "1f938-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "wrestlers"
        ],
        u: "1f93c",
        a: "3.0"
    },
    {
        n: [
            "men wrestling",
            "man-wrestling"
        ],
        u: "1f93c-200d-2642-fe0f",
        a: "4.0"
    },
    {
        n: [
            "women wrestling",
            "woman-wrestling"
        ],
        u: "1f93c-200d-2640-fe0f",
        a: "4.0"
    },
    {
        n: [
            "water polo"
        ],
        u: "1f93d",
        v: [
            "1f93d-1f3fb",
            "1f93d-1f3fc",
            "1f93d-1f3fd",
            "1f93d-1f3fe",
            "1f93d-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man playing water polo",
            "man-playing-water-polo"
        ],
        u: "1f93d-200d-2642-fe0f",
        v: [
            "1f93d-1f3fb-200d-2642-fe0f",
            "1f93d-1f3fc-200d-2642-fe0f",
            "1f93d-1f3fd-200d-2642-fe0f",
            "1f93d-1f3fe-200d-2642-fe0f",
            "1f93d-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman playing water polo",
            "woman-playing-water-polo"
        ],
        u: "1f93d-200d-2640-fe0f",
        v: [
            "1f93d-1f3fb-200d-2640-fe0f",
            "1f93d-1f3fc-200d-2640-fe0f",
            "1f93d-1f3fd-200d-2640-fe0f",
            "1f93d-1f3fe-200d-2640-fe0f",
            "1f93d-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "handball"
        ],
        u: "1f93e",
        v: [
            "1f93e-1f3fb",
            "1f93e-1f3fc",
            "1f93e-1f3fd",
            "1f93e-1f3fe",
            "1f93e-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man playing handball",
            "man-playing-handball"
        ],
        u: "1f93e-200d-2642-fe0f",
        v: [
            "1f93e-1f3fb-200d-2642-fe0f",
            "1f93e-1f3fc-200d-2642-fe0f",
            "1f93e-1f3fd-200d-2642-fe0f",
            "1f93e-1f3fe-200d-2642-fe0f",
            "1f93e-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman playing handball",
            "woman-playing-handball"
        ],
        u: "1f93e-200d-2640-fe0f",
        v: [
            "1f93e-1f3fb-200d-2640-fe0f",
            "1f93e-1f3fc-200d-2640-fe0f",
            "1f93e-1f3fd-200d-2640-fe0f",
            "1f93e-1f3fe-200d-2640-fe0f",
            "1f93e-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "juggling"
        ],
        u: "1f939",
        v: [
            "1f939-1f3fb",
            "1f939-1f3fc",
            "1f939-1f3fd",
            "1f939-1f3fe",
            "1f939-1f3ff"
        ],
        a: "3.0"
    },
    {
        n: [
            "man juggling",
            "man-juggling"
        ],
        u: "1f939-200d-2642-fe0f",
        v: [
            "1f939-1f3fb-200d-2642-fe0f",
            "1f939-1f3fc-200d-2642-fe0f",
            "1f939-1f3fd-200d-2642-fe0f",
            "1f939-1f3fe-200d-2642-fe0f",
            "1f939-1f3ff-200d-2642-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "woman juggling",
            "woman-juggling"
        ],
        u: "1f939-200d-2640-fe0f",
        v: [
            "1f939-1f3fb-200d-2640-fe0f",
            "1f939-1f3fc-200d-2640-fe0f",
            "1f939-1f3fd-200d-2640-fe0f",
            "1f939-1f3fe-200d-2640-fe0f",
            "1f939-1f3ff-200d-2640-fe0f"
        ],
        a: "4.0"
    },
    {
        n: [
            "person in lotus position"
        ],
        u: "1f9d8",
        v: [
            "1f9d8-1f3fb",
            "1f9d8-1f3fc",
            "1f9d8-1f3fd",
            "1f9d8-1f3fe",
            "1f9d8-1f3ff"
        ],
        a: "5.0"
    },
    {
        n: [
            "man in lotus position"
        ],
        u: "1f9d8-200d-2642-fe0f",
        v: [
            "1f9d8-1f3fb-200d-2642-fe0f",
            "1f9d8-1f3fc-200d-2642-fe0f",
            "1f9d8-1f3fd-200d-2642-fe0f",
            "1f9d8-1f3fe-200d-2642-fe0f",
            "1f9d8-1f3ff-200d-2642-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "woman in lotus position"
        ],
        u: "1f9d8-200d-2640-fe0f",
        v: [
            "1f9d8-1f3fb-200d-2640-fe0f",
            "1f9d8-1f3fc-200d-2640-fe0f",
            "1f9d8-1f3fd-200d-2640-fe0f",
            "1f9d8-1f3fe-200d-2640-fe0f",
            "1f9d8-1f3ff-200d-2640-fe0f"
        ],
        a: "5.0"
    },
    {
        n: [
            "bath"
        ],
        u: "1f6c0",
        v: [
            "1f6c0-1f3fb",
            "1f6c0-1f3fc",
            "1f6c0-1f3fd",
            "1f6c0-1f3fe",
            "1f6c0-1f3ff"
        ],
        a: "0.6"
    },
    {
        n: [
            "sleeping accommodation"
        ],
        u: "1f6cc",
        v: [
            "1f6cc-1f3fb",
            "1f6cc-1f3fc",
            "1f6cc-1f3fd",
            "1f6cc-1f3fe",
            "1f6cc-1f3ff"
        ],
        a: "1.0"
    },
    {
        n: [
            "people holding hands"
        ],
        u: "1f9d1-200d-1f91d-200d-1f9d1",
        v: [
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
            "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
        ],
        a: "12.0"
    },
    {
        n: [
            "women holding hands",
            "two women holding hands"
        ],
        u: "1f46d",
        v: [
            "1f46d-1f3fb",
            "1f46d-1f3fc",
            "1f46d-1f3fd",
            "1f46d-1f3fe",
            "1f46d-1f3ff",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
            "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
            "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
            "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
            "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
        ],
        a: "1.0"
    },
    {
        n: [
            "couple",
            "man and woman holding hands",
            "woman and man holding hands"
        ],
        u: "1f46b",
        v: [
            "1f46b-1f3fb",
            "1f46b-1f3fc",
            "1f46b-1f3fd",
            "1f46b-1f3fe",
            "1f46b-1f3ff",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
            "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
            "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
            "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
            "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
        ],
        a: "0.6"
    },
    {
        n: [
            "men holding hands",
            "two men holding hands"
        ],
        u: "1f46c",
        v: [
            "1f46c-1f3fb",
            "1f46c-1f3fc",
            "1f46c-1f3fd",
            "1f46c-1f3fe",
            "1f46c-1f3ff",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
            "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
            "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
            "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
            "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
        ],
        a: "1.0"
    },
    {
        n: [
            "kiss",
            "couplekiss"
        ],
        u: "1f48f",
        v: [
            "1f48f-1f3fb",
            "1f48f-1f3fc",
            "1f48f-1f3fd",
            "1f48f-1f3fe",
            "1f48f-1f3ff",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
        ],
        a: "0.6"
    },
    {
        n: [
            "woman-kiss-man",
            "kiss: woman, man"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "man-kiss-man",
            "kiss: man, man"
        ],
        u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
        v: [
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "woman-kiss-woman",
            "kiss: woman, woman"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "couple with heart"
        ],
        u: "1f491",
        v: [
            "1f491-1f3fb",
            "1f491-1f3fc",
            "1f491-1f3fd",
            "1f491-1f3fe",
            "1f491-1f3ff",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
            "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
            "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
            "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
            "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
        ],
        a: "0.6"
    },
    {
        n: [
            "woman-heart-man",
            "couple with heart: woman, man"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f468",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "man-heart-man",
            "couple with heart: man, man"
        ],
        u: "1f468-200d-2764-fe0f-200d-1f468",
        v: [
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
            "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "woman-heart-woman",
            "couple with heart: woman, woman"
        ],
        u: "1f469-200d-2764-fe0f-200d-1f469",
        v: [
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
            "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
        ],
        a: "2.0"
    },
    {
        n: [
            "family"
        ],
        u: "1f46a",
        a: "0.6"
    },
    {
        n: [
            "man-woman-boy",
            "family: man, woman, boy"
        ],
        u: "1f468-200d-1f469-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-woman-girl",
            "family: man, woman, girl"
        ],
        u: "1f468-200d-1f469-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-woman-girl-boy",
            "family: man, woman, girl, boy"
        ],
        u: "1f468-200d-1f469-200d-1f467-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-woman-boy-boy",
            "family: man, woman, boy, boy"
        ],
        u: "1f468-200d-1f469-200d-1f466-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-woman-girl-girl",
            "family: man, woman, girl, girl"
        ],
        u: "1f468-200d-1f469-200d-1f467-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-man-boy",
            "family: man, man, boy"
        ],
        u: "1f468-200d-1f468-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-man-girl",
            "family: man, man, girl"
        ],
        u: "1f468-200d-1f468-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-man-girl-boy",
            "family: man, man, girl, boy"
        ],
        u: "1f468-200d-1f468-200d-1f467-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-man-boy-boy",
            "family: man, man, boy, boy"
        ],
        u: "1f468-200d-1f468-200d-1f466-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "man-man-girl-girl",
            "family: man, man, girl, girl"
        ],
        u: "1f468-200d-1f468-200d-1f467-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-boy",
            "family: woman, woman, boy"
        ],
        u: "1f469-200d-1f469-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-girl",
            "family: woman, woman, girl"
        ],
        u: "1f469-200d-1f469-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-girl-boy",
            "family: woman, woman, girl, boy"
        ],
        u: "1f469-200d-1f469-200d-1f467-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-boy-boy",
            "family: woman, woman, boy, boy"
        ],
        u: "1f469-200d-1f469-200d-1f466-200d-1f466",
        a: "2.0"
    },
    {
        n: [
            "woman-woman-girl-girl",
            "family: woman, woman, girl, girl"
        ],
        u: "1f469-200d-1f469-200d-1f467-200d-1f467",
        a: "2.0"
    },
    {
        n: [
            "man-boy",
            "family: man, boy"
        ],
        u: "1f468-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "man-boy-boy",
            "family: man, boy, boy"
        ],
        u: "1f468-200d-1f466-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "man-girl",
            "family: man, girl"
        ],
        u: "1f468-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "man-girl-boy",
            "family: man, girl, boy"
        ],
        u: "1f468-200d-1f467-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "man-girl-girl",
            "family: man, girl, girl"
        ],
        u: "1f468-200d-1f467-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "woman-boy",
            "family: woman, boy"
        ],
        u: "1f469-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "woman-boy-boy",
            "family: woman, boy, boy"
        ],
        u: "1f469-200d-1f466-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "woman-girl",
            "family: woman, girl"
        ],
        u: "1f469-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "woman-girl-boy",
            "family: woman, girl, boy"
        ],
        u: "1f469-200d-1f467-200d-1f466",
        a: "4.0"
    },
    {
        n: [
            "woman-girl-girl",
            "family: woman, girl, girl"
        ],
        u: "1f469-200d-1f467-200d-1f467",
        a: "4.0"
    },
    {
        n: [
            "speaking head",
            "speaking head in silhouette"
        ],
        u: "1f5e3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bust in silhouette"
        ],
        u: "1f464",
        a: "0.6"
    },
    {
        n: [
            "busts in silhouette"
        ],
        u: "1f465",
        a: "1.0"
    },
    {
        n: [
            "people hugging"
        ],
        u: "1fac2",
        a: "13.0"
    },
    {
        n: [
            "footprints"
        ],
        u: "1f463",
        a: "0.6"
    }
];
var $2785da2b7d7107bb$var$animals_nature = [
    {
        n: [
            "monkey face"
        ],
        u: "1f435",
        a: "0.6"
    },
    {
        n: [
            "monkey"
        ],
        u: "1f412",
        a: "0.6"
    },
    {
        n: [
            "gorilla"
        ],
        u: "1f98d",
        a: "3.0"
    },
    {
        n: [
            "orangutan"
        ],
        u: "1f9a7",
        a: "12.0"
    },
    {
        n: [
            "dog",
            "dog face"
        ],
        u: "1f436",
        a: "0.6"
    },
    {
        n: [
            "dog",
            "dog2"
        ],
        u: "1f415",
        a: "0.7"
    },
    {
        n: [
            "guide dog"
        ],
        u: "1f9ae",
        a: "12.0"
    },
    {
        n: [
            "service dog"
        ],
        u: "1f415-200d-1f9ba",
        a: "12.0"
    },
    {
        n: [
            "poodle"
        ],
        u: "1f429",
        a: "0.6"
    },
    {
        n: [
            "wolf",
            "wolf face"
        ],
        u: "1f43a",
        a: "0.6"
    },
    {
        n: [
            "fox face"
        ],
        u: "1f98a",
        a: "3.0"
    },
    {
        n: [
            "raccoon"
        ],
        u: "1f99d",
        a: "11.0"
    },
    {
        n: [
            "cat",
            "cat face"
        ],
        u: "1f431",
        a: "0.6"
    },
    {
        n: [
            "cat",
            "cat2"
        ],
        u: "1f408",
        a: "0.7"
    },
    {
        n: [
            "black cat"
        ],
        u: "1f408-200d-2b1b",
        a: "13.0"
    },
    {
        n: [
            "lion face"
        ],
        u: "1f981",
        a: "1.0"
    },
    {
        n: [
            "tiger",
            "tiger face"
        ],
        u: "1f42f",
        a: "0.6"
    },
    {
        n: [
            "tiger",
            "tiger2"
        ],
        u: "1f405",
        a: "1.0"
    },
    {
        n: [
            "leopard"
        ],
        u: "1f406",
        a: "1.0"
    },
    {
        n: [
            "horse",
            "horse face"
        ],
        u: "1f434",
        a: "0.6"
    },
    {
        n: [
            "horse",
            "racehorse"
        ],
        u: "1f40e",
        a: "0.6"
    },
    {
        n: [
            "unicorn face"
        ],
        u: "1f984",
        a: "1.0"
    },
    {
        n: [
            "zebra face"
        ],
        u: "1f993",
        a: "5.0"
    },
    {
        n: [
            "deer"
        ],
        u: "1f98c",
        a: "3.0"
    },
    {
        n: [
            "bison"
        ],
        u: "1f9ac",
        a: "13.0"
    },
    {
        n: [
            "cow",
            "cow face"
        ],
        u: "1f42e",
        a: "0.6"
    },
    {
        n: [
            "ox"
        ],
        u: "1f402",
        a: "1.0"
    },
    {
        n: [
            "water buffalo"
        ],
        u: "1f403",
        a: "1.0"
    },
    {
        n: [
            "cow",
            "cow2"
        ],
        u: "1f404",
        a: "1.0"
    },
    {
        n: [
            "pig",
            "pig face"
        ],
        u: "1f437",
        a: "0.6"
    },
    {
        n: [
            "pig",
            "pig2"
        ],
        u: "1f416",
        a: "1.0"
    },
    {
        n: [
            "boar"
        ],
        u: "1f417",
        a: "0.6"
    },
    {
        n: [
            "pig nose"
        ],
        u: "1f43d",
        a: "0.6"
    },
    {
        n: [
            "ram"
        ],
        u: "1f40f",
        a: "1.0"
    },
    {
        n: [
            "sheep"
        ],
        u: "1f411",
        a: "0.6"
    },
    {
        n: [
            "goat"
        ],
        u: "1f410",
        a: "1.0"
    },
    {
        n: [
            "dromedary camel"
        ],
        u: "1f42a",
        a: "1.0"
    },
    {
        n: [
            "camel",
            "bactrian camel"
        ],
        u: "1f42b",
        a: "0.6"
    },
    {
        n: [
            "llama"
        ],
        u: "1f999",
        a: "11.0"
    },
    {
        n: [
            "giraffe face"
        ],
        u: "1f992",
        a: "5.0"
    },
    {
        n: [
            "elephant"
        ],
        u: "1f418",
        a: "0.6"
    },
    {
        n: [
            "mammoth"
        ],
        u: "1f9a3",
        a: "13.0"
    },
    {
        n: [
            "rhinoceros"
        ],
        u: "1f98f",
        a: "3.0"
    },
    {
        n: [
            "hippopotamus"
        ],
        u: "1f99b",
        a: "11.0"
    },
    {
        n: [
            "mouse",
            "mouse face"
        ],
        u: "1f42d",
        a: "0.6"
    },
    {
        n: [
            "mouse",
            "mouse2"
        ],
        u: "1f401",
        a: "1.0"
    },
    {
        n: [
            "rat"
        ],
        u: "1f400",
        a: "1.0"
    },
    {
        n: [
            "hamster",
            "hamster face"
        ],
        u: "1f439",
        a: "0.6"
    },
    {
        n: [
            "rabbit",
            "rabbit face"
        ],
        u: "1f430",
        a: "0.6"
    },
    {
        n: [
            "rabbit",
            "rabbit2"
        ],
        u: "1f407",
        a: "1.0"
    },
    {
        n: [
            "chipmunk"
        ],
        u: "1f43f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "beaver"
        ],
        u: "1f9ab",
        a: "13.0"
    },
    {
        n: [
            "hedgehog"
        ],
        u: "1f994",
        a: "5.0"
    },
    {
        n: [
            "bat"
        ],
        u: "1f987",
        a: "3.0"
    },
    {
        n: [
            "bear",
            "bear face"
        ],
        u: "1f43b",
        a: "0.6"
    },
    {
        n: [
            "polar bear"
        ],
        u: "1f43b-200d-2744-fe0f",
        a: "13.0"
    },
    {
        n: [
            "koala"
        ],
        u: "1f428",
        a: "0.6"
    },
    {
        n: [
            "panda face"
        ],
        u: "1f43c",
        a: "0.6"
    },
    {
        n: [
            "sloth"
        ],
        u: "1f9a5",
        a: "12.0"
    },
    {
        n: [
            "otter"
        ],
        u: "1f9a6",
        a: "12.0"
    },
    {
        n: [
            "skunk"
        ],
        u: "1f9a8",
        a: "12.0"
    },
    {
        n: [
            "kangaroo"
        ],
        u: "1f998",
        a: "11.0"
    },
    {
        n: [
            "badger"
        ],
        u: "1f9a1",
        a: "11.0"
    },
    {
        n: [
            "feet",
            "paw prints"
        ],
        u: "1f43e",
        a: "0.6"
    },
    {
        n: [
            "turkey"
        ],
        u: "1f983",
        a: "1.0"
    },
    {
        n: [
            "chicken"
        ],
        u: "1f414",
        a: "0.6"
    },
    {
        n: [
            "rooster"
        ],
        u: "1f413",
        a: "1.0"
    },
    {
        n: [
            "hatching chick"
        ],
        u: "1f423",
        a: "0.6"
    },
    {
        n: [
            "baby chick"
        ],
        u: "1f424",
        a: "0.6"
    },
    {
        n: [
            "hatched chick",
            "front-facing baby chick"
        ],
        u: "1f425",
        a: "0.6"
    },
    {
        n: [
            "bird"
        ],
        u: "1f426",
        a: "0.6"
    },
    {
        n: [
            "penguin"
        ],
        u: "1f427",
        a: "0.6"
    },
    {
        n: [
            "dove",
            "dove of peace"
        ],
        u: "1f54a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "eagle"
        ],
        u: "1f985",
        a: "3.0"
    },
    {
        n: [
            "duck"
        ],
        u: "1f986",
        a: "3.0"
    },
    {
        n: [
            "swan"
        ],
        u: "1f9a2",
        a: "11.0"
    },
    {
        n: [
            "owl"
        ],
        u: "1f989",
        a: "3.0"
    },
    {
        n: [
            "dodo"
        ],
        u: "1f9a4",
        a: "13.0"
    },
    {
        n: [
            "feather"
        ],
        u: "1fab6",
        a: "13.0"
    },
    {
        n: [
            "flamingo"
        ],
        u: "1f9a9",
        a: "12.0"
    },
    {
        n: [
            "peacock"
        ],
        u: "1f99a",
        a: "11.0"
    },
    {
        n: [
            "parrot"
        ],
        u: "1f99c",
        a: "11.0"
    },
    {
        n: [
            "frog",
            "frog face"
        ],
        u: "1f438",
        a: "0.6"
    },
    {
        n: [
            "crocodile"
        ],
        u: "1f40a",
        a: "1.0"
    },
    {
        n: [
            "turtle"
        ],
        u: "1f422",
        a: "0.6"
    },
    {
        n: [
            "lizard"
        ],
        u: "1f98e",
        a: "3.0"
    },
    {
        n: [
            "snake"
        ],
        u: "1f40d",
        a: "0.6"
    },
    {
        n: [
            "dragon face"
        ],
        u: "1f432",
        a: "0.6"
    },
    {
        n: [
            "dragon"
        ],
        u: "1f409",
        a: "1.0"
    },
    {
        n: [
            "sauropod"
        ],
        u: "1f995",
        a: "5.0"
    },
    {
        n: [
            "t-rex"
        ],
        u: "1f996",
        a: "5.0"
    },
    {
        n: [
            "whale",
            "spouting whale"
        ],
        u: "1f433",
        a: "0.6"
    },
    {
        n: [
            "whale",
            "whale2"
        ],
        u: "1f40b",
        a: "1.0"
    },
    {
        n: [
            "dolphin",
            "flipper"
        ],
        u: "1f42c",
        a: "0.6"
    },
    {
        n: [
            "seal"
        ],
        u: "1f9ad",
        a: "13.0"
    },
    {
        n: [
            "fish"
        ],
        u: "1f41f",
        a: "0.6"
    },
    {
        n: [
            "tropical fish"
        ],
        u: "1f420",
        a: "0.6"
    },
    {
        n: [
            "blowfish"
        ],
        u: "1f421",
        a: "0.6"
    },
    {
        n: [
            "shark"
        ],
        u: "1f988",
        a: "3.0"
    },
    {
        n: [
            "octopus"
        ],
        u: "1f419",
        a: "0.6"
    },
    {
        n: [
            "shell",
            "spiral shell"
        ],
        u: "1f41a",
        a: "0.6"
    },
    {
        n: [
            "coral"
        ],
        u: "1fab8",
        a: "14.0"
    },
    {
        n: [
            "snail"
        ],
        u: "1f40c",
        a: "0.6"
    },
    {
        n: [
            "butterfly"
        ],
        u: "1f98b",
        a: "3.0"
    },
    {
        n: [
            "bug"
        ],
        u: "1f41b",
        a: "0.6"
    },
    {
        n: [
            "ant"
        ],
        u: "1f41c",
        a: "0.6"
    },
    {
        n: [
            "bee",
            "honeybee"
        ],
        u: "1f41d",
        a: "0.6"
    },
    {
        n: [
            "beetle"
        ],
        u: "1fab2",
        a: "13.0"
    },
    {
        n: [
            "ladybug",
            "lady beetle"
        ],
        u: "1f41e",
        a: "0.6"
    },
    {
        n: [
            "cricket"
        ],
        u: "1f997",
        a: "5.0"
    },
    {
        n: [
            "cockroach"
        ],
        u: "1fab3",
        a: "13.0"
    },
    {
        n: [
            "spider"
        ],
        u: "1f577-fe0f",
        a: "0.7"
    },
    {
        n: [
            "spider web"
        ],
        u: "1f578-fe0f",
        a: "0.7"
    },
    {
        n: [
            "scorpion"
        ],
        u: "1f982",
        a: "1.0"
    },
    {
        n: [
            "mosquito"
        ],
        u: "1f99f",
        a: "11.0"
    },
    {
        n: [
            "fly"
        ],
        u: "1fab0",
        a: "13.0"
    },
    {
        n: [
            "worm"
        ],
        u: "1fab1",
        a: "13.0"
    },
    {
        n: [
            "microbe"
        ],
        u: "1f9a0",
        a: "11.0"
    },
    {
        n: [
            "bouquet"
        ],
        u: "1f490",
        a: "0.6"
    },
    {
        n: [
            "cherry blossom"
        ],
        u: "1f338",
        a: "0.6"
    },
    {
        n: [
            "white flower"
        ],
        u: "1f4ae",
        a: "0.6"
    },
    {
        n: [
            "lotus"
        ],
        u: "1fab7",
        a: "14.0"
    },
    {
        n: [
            "rosette"
        ],
        u: "1f3f5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rose"
        ],
        u: "1f339",
        a: "0.6"
    },
    {
        n: [
            "wilted flower"
        ],
        u: "1f940",
        a: "3.0"
    },
    {
        n: [
            "hibiscus"
        ],
        u: "1f33a",
        a: "0.6"
    },
    {
        n: [
            "sunflower"
        ],
        u: "1f33b",
        a: "0.6"
    },
    {
        n: [
            "blossom"
        ],
        u: "1f33c",
        a: "0.6"
    },
    {
        n: [
            "tulip"
        ],
        u: "1f337",
        a: "0.6"
    },
    {
        n: [
            "seedling"
        ],
        u: "1f331",
        a: "0.6"
    },
    {
        n: [
            "potted plant"
        ],
        u: "1fab4",
        a: "13.0"
    },
    {
        n: [
            "evergreen tree"
        ],
        u: "1f332",
        a: "1.0"
    },
    {
        n: [
            "deciduous tree"
        ],
        u: "1f333",
        a: "1.0"
    },
    {
        n: [
            "palm tree"
        ],
        u: "1f334",
        a: "0.6"
    },
    {
        n: [
            "cactus"
        ],
        u: "1f335",
        a: "0.6"
    },
    {
        n: [
            "ear of rice"
        ],
        u: "1f33e",
        a: "0.6"
    },
    {
        n: [
            "herb"
        ],
        u: "1f33f",
        a: "0.6"
    },
    {
        n: [
            "shamrock"
        ],
        u: "2618-fe0f",
        a: "1.0"
    },
    {
        n: [
            "four leaf clover"
        ],
        u: "1f340",
        a: "0.6"
    },
    {
        n: [
            "maple leaf"
        ],
        u: "1f341",
        a: "0.6"
    },
    {
        n: [
            "fallen leaf"
        ],
        u: "1f342",
        a: "0.6"
    },
    {
        n: [
            "leaves",
            "leaf fluttering in wind"
        ],
        u: "1f343",
        a: "0.6"
    },
    {
        n: [
            "empty nest"
        ],
        u: "1fab9",
        a: "14.0"
    },
    {
        n: [
            "nest with eggs"
        ],
        u: "1faba",
        a: "14.0"
    }
];
var $2785da2b7d7107bb$var$food_drink = [
    {
        n: [
            "grapes"
        ],
        u: "1f347",
        a: "0.6"
    },
    {
        n: [
            "melon"
        ],
        u: "1f348",
        a: "0.6"
    },
    {
        n: [
            "watermelon"
        ],
        u: "1f349",
        a: "0.6"
    },
    {
        n: [
            "tangerine"
        ],
        u: "1f34a",
        a: "0.6"
    },
    {
        n: [
            "lemon"
        ],
        u: "1f34b",
        a: "1.0"
    },
    {
        n: [
            "banana"
        ],
        u: "1f34c",
        a: "0.6"
    },
    {
        n: [
            "pineapple"
        ],
        u: "1f34d",
        a: "0.6"
    },
    {
        n: [
            "mango"
        ],
        u: "1f96d",
        a: "11.0"
    },
    {
        n: [
            "apple",
            "red apple"
        ],
        u: "1f34e",
        a: "0.6"
    },
    {
        n: [
            "green apple"
        ],
        u: "1f34f",
        a: "0.6"
    },
    {
        n: [
            "pear"
        ],
        u: "1f350",
        a: "1.0"
    },
    {
        n: [
            "peach"
        ],
        u: "1f351",
        a: "0.6"
    },
    {
        n: [
            "cherries"
        ],
        u: "1f352",
        a: "0.6"
    },
    {
        n: [
            "strawberry"
        ],
        u: "1f353",
        a: "0.6"
    },
    {
        n: [
            "blueberries"
        ],
        u: "1fad0",
        a: "13.0"
    },
    {
        n: [
            "kiwifruit"
        ],
        u: "1f95d",
        a: "3.0"
    },
    {
        n: [
            "tomato"
        ],
        u: "1f345",
        a: "0.6"
    },
    {
        n: [
            "olive"
        ],
        u: "1fad2",
        a: "13.0"
    },
    {
        n: [
            "coconut"
        ],
        u: "1f965",
        a: "5.0"
    },
    {
        n: [
            "avocado"
        ],
        u: "1f951",
        a: "3.0"
    },
    {
        n: [
            "eggplant",
            "aubergine"
        ],
        u: "1f346",
        a: "0.6"
    },
    {
        n: [
            "potato"
        ],
        u: "1f954",
        a: "3.0"
    },
    {
        n: [
            "carrot"
        ],
        u: "1f955",
        a: "3.0"
    },
    {
        n: [
            "corn",
            "ear of maize"
        ],
        u: "1f33d",
        a: "0.6"
    },
    {
        n: [
            "hot pepper"
        ],
        u: "1f336-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bell pepper"
        ],
        u: "1fad1",
        a: "13.0"
    },
    {
        n: [
            "cucumber"
        ],
        u: "1f952",
        a: "3.0"
    },
    {
        n: [
            "leafy green"
        ],
        u: "1f96c",
        a: "11.0"
    },
    {
        n: [
            "broccoli"
        ],
        u: "1f966",
        a: "5.0"
    },
    {
        n: [
            "garlic"
        ],
        u: "1f9c4",
        a: "12.0"
    },
    {
        n: [
            "onion"
        ],
        u: "1f9c5",
        a: "12.0"
    },
    {
        n: [
            "mushroom"
        ],
        u: "1f344",
        a: "0.6"
    },
    {
        n: [
            "peanuts"
        ],
        u: "1f95c",
        a: "3.0"
    },
    {
        n: [
            "beans"
        ],
        u: "1fad8",
        a: "14.0"
    },
    {
        n: [
            "chestnut"
        ],
        u: "1f330",
        a: "0.6"
    },
    {
        n: [
            "bread"
        ],
        u: "1f35e",
        a: "0.6"
    },
    {
        n: [
            "croissant"
        ],
        u: "1f950",
        a: "3.0"
    },
    {
        n: [
            "baguette bread"
        ],
        u: "1f956",
        a: "3.0"
    },
    {
        n: [
            "flatbread"
        ],
        u: "1fad3",
        a: "13.0"
    },
    {
        n: [
            "pretzel"
        ],
        u: "1f968",
        a: "5.0"
    },
    {
        n: [
            "bagel"
        ],
        u: "1f96f",
        a: "11.0"
    },
    {
        n: [
            "pancakes"
        ],
        u: "1f95e",
        a: "3.0"
    },
    {
        n: [
            "waffle"
        ],
        u: "1f9c7",
        a: "12.0"
    },
    {
        n: [
            "cheese wedge"
        ],
        u: "1f9c0",
        a: "1.0"
    },
    {
        n: [
            "meat on bone"
        ],
        u: "1f356",
        a: "0.6"
    },
    {
        n: [
            "poultry leg"
        ],
        u: "1f357",
        a: "0.6"
    },
    {
        n: [
            "cut of meat"
        ],
        u: "1f969",
        a: "5.0"
    },
    {
        n: [
            "bacon"
        ],
        u: "1f953",
        a: "3.0"
    },
    {
        n: [
            "hamburger"
        ],
        u: "1f354",
        a: "0.6"
    },
    {
        n: [
            "fries",
            "french fries"
        ],
        u: "1f35f",
        a: "0.6"
    },
    {
        n: [
            "pizza",
            "slice of pizza"
        ],
        u: "1f355",
        a: "0.6"
    },
    {
        n: [
            "hotdog",
            "hot dog"
        ],
        u: "1f32d",
        a: "1.0"
    },
    {
        n: [
            "sandwich"
        ],
        u: "1f96a",
        a: "5.0"
    },
    {
        n: [
            "taco"
        ],
        u: "1f32e",
        a: "1.0"
    },
    {
        n: [
            "burrito"
        ],
        u: "1f32f",
        a: "1.0"
    },
    {
        n: [
            "tamale"
        ],
        u: "1fad4",
        a: "13.0"
    },
    {
        n: [
            "stuffed flatbread"
        ],
        u: "1f959",
        a: "3.0"
    },
    {
        n: [
            "falafel"
        ],
        u: "1f9c6",
        a: "12.0"
    },
    {
        n: [
            "egg"
        ],
        u: "1f95a",
        a: "3.0"
    },
    {
        n: [
            "cooking",
            "fried egg"
        ],
        u: "1f373",
        a: "0.6"
    },
    {
        n: [
            "shallow pan of food"
        ],
        u: "1f958",
        a: "3.0"
    },
    {
        n: [
            "stew",
            "pot of food"
        ],
        u: "1f372",
        a: "0.6"
    },
    {
        n: [
            "fondue"
        ],
        u: "1fad5",
        a: "13.0"
    },
    {
        n: [
            "bowl with spoon"
        ],
        u: "1f963",
        a: "5.0"
    },
    {
        n: [
            "green salad"
        ],
        u: "1f957",
        a: "3.0"
    },
    {
        n: [
            "popcorn"
        ],
        u: "1f37f",
        a: "1.0"
    },
    {
        n: [
            "butter"
        ],
        u: "1f9c8",
        a: "12.0"
    },
    {
        n: [
            "salt",
            "salt shaker"
        ],
        u: "1f9c2",
        a: "11.0"
    },
    {
        n: [
            "canned food"
        ],
        u: "1f96b",
        a: "5.0"
    },
    {
        n: [
            "bento",
            "bento box"
        ],
        u: "1f371",
        a: "0.6"
    },
    {
        n: [
            "rice cracker"
        ],
        u: "1f358",
        a: "0.6"
    },
    {
        n: [
            "rice ball"
        ],
        u: "1f359",
        a: "0.6"
    },
    {
        n: [
            "rice",
            "cooked rice"
        ],
        u: "1f35a",
        a: "0.6"
    },
    {
        n: [
            "curry",
            "curry and rice"
        ],
        u: "1f35b",
        a: "0.6"
    },
    {
        n: [
            "ramen",
            "steaming bowl"
        ],
        u: "1f35c",
        a: "0.6"
    },
    {
        n: [
            "spaghetti"
        ],
        u: "1f35d",
        a: "0.6"
    },
    {
        n: [
            "sweet potato",
            "roasted sweet potato"
        ],
        u: "1f360",
        a: "0.6"
    },
    {
        n: [
            "oden"
        ],
        u: "1f362",
        a: "0.6"
    },
    {
        n: [
            "sushi"
        ],
        u: "1f363",
        a: "0.6"
    },
    {
        n: [
            "fried shrimp"
        ],
        u: "1f364",
        a: "0.6"
    },
    {
        n: [
            "fish cake",
            "fish cake with swirl design"
        ],
        u: "1f365",
        a: "0.6"
    },
    {
        n: [
            "moon cake"
        ],
        u: "1f96e",
        a: "11.0"
    },
    {
        n: [
            "dango"
        ],
        u: "1f361",
        a: "0.6"
    },
    {
        n: [
            "dumpling"
        ],
        u: "1f95f",
        a: "5.0"
    },
    {
        n: [
            "fortune cookie"
        ],
        u: "1f960",
        a: "5.0"
    },
    {
        n: [
            "takeout box"
        ],
        u: "1f961",
        a: "5.0"
    },
    {
        n: [
            "crab"
        ],
        u: "1f980",
        a: "1.0"
    },
    {
        n: [
            "lobster"
        ],
        u: "1f99e",
        a: "11.0"
    },
    {
        n: [
            "shrimp"
        ],
        u: "1f990",
        a: "3.0"
    },
    {
        n: [
            "squid"
        ],
        u: "1f991",
        a: "3.0"
    },
    {
        n: [
            "oyster"
        ],
        u: "1f9aa",
        a: "12.0"
    },
    {
        n: [
            "icecream",
            "soft ice cream"
        ],
        u: "1f366",
        a: "0.6"
    },
    {
        n: [
            "shaved ice"
        ],
        u: "1f367",
        a: "0.6"
    },
    {
        n: [
            "ice cream"
        ],
        u: "1f368",
        a: "0.6"
    },
    {
        n: [
            "doughnut"
        ],
        u: "1f369",
        a: "0.6"
    },
    {
        n: [
            "cookie"
        ],
        u: "1f36a",
        a: "0.6"
    },
    {
        n: [
            "birthday",
            "birthday cake"
        ],
        u: "1f382",
        a: "0.6"
    },
    {
        n: [
            "cake",
            "shortcake"
        ],
        u: "1f370",
        a: "0.6"
    },
    {
        n: [
            "cupcake"
        ],
        u: "1f9c1",
        a: "11.0"
    },
    {
        n: [
            "pie"
        ],
        u: "1f967",
        a: "5.0"
    },
    {
        n: [
            "chocolate bar"
        ],
        u: "1f36b",
        a: "0.6"
    },
    {
        n: [
            "candy"
        ],
        u: "1f36c",
        a: "0.6"
    },
    {
        n: [
            "lollipop"
        ],
        u: "1f36d",
        a: "0.6"
    },
    {
        n: [
            "custard"
        ],
        u: "1f36e",
        a: "0.6"
    },
    {
        n: [
            "honey pot"
        ],
        u: "1f36f",
        a: "0.6"
    },
    {
        n: [
            "baby bottle"
        ],
        u: "1f37c",
        a: "1.0"
    },
    {
        n: [
            "glass of milk"
        ],
        u: "1f95b",
        a: "3.0"
    },
    {
        n: [
            "coffee",
            "hot beverage"
        ],
        u: "2615",
        a: "0.6"
    },
    {
        n: [
            "teapot"
        ],
        u: "1fad6",
        a: "13.0"
    },
    {
        n: [
            "tea",
            "teacup without handle"
        ],
        u: "1f375",
        a: "0.6"
    },
    {
        n: [
            "sake",
            "sake bottle and cup"
        ],
        u: "1f376",
        a: "0.6"
    },
    {
        n: [
            "champagne",
            "bottle with popping cork"
        ],
        u: "1f37e",
        a: "1.0"
    },
    {
        n: [
            "wine glass"
        ],
        u: "1f377",
        a: "0.6"
    },
    {
        n: [
            "cocktail",
            "cocktail glass"
        ],
        u: "1f378",
        a: "0.6"
    },
    {
        n: [
            "tropical drink"
        ],
        u: "1f379",
        a: "0.6"
    },
    {
        n: [
            "beer",
            "beer mug"
        ],
        u: "1f37a",
        a: "0.6"
    },
    {
        n: [
            "beers",
            "clinking beer mugs"
        ],
        u: "1f37b",
        a: "0.6"
    },
    {
        n: [
            "clinking glasses"
        ],
        u: "1f942",
        a: "3.0"
    },
    {
        n: [
            "tumbler glass"
        ],
        u: "1f943",
        a: "3.0"
    },
    {
        n: [
            "pouring liquid"
        ],
        u: "1fad7",
        a: "14.0"
    },
    {
        n: [
            "cup with straw"
        ],
        u: "1f964",
        a: "5.0"
    },
    {
        n: [
            "bubble tea"
        ],
        u: "1f9cb",
        a: "13.0"
    },
    {
        n: [
            "beverage box"
        ],
        u: "1f9c3",
        a: "12.0"
    },
    {
        n: [
            "mate drink"
        ],
        u: "1f9c9",
        a: "12.0"
    },
    {
        n: [
            "ice cube"
        ],
        u: "1f9ca",
        a: "12.0"
    },
    {
        n: [
            "chopsticks"
        ],
        u: "1f962",
        a: "5.0"
    },
    {
        n: [
            "knife fork plate",
            "fork and knife with plate"
        ],
        u: "1f37d-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fork and knife"
        ],
        u: "1f374",
        a: "0.6"
    },
    {
        n: [
            "spoon"
        ],
        u: "1f944",
        a: "3.0"
    },
    {
        n: [
            "hocho",
            "knife"
        ],
        u: "1f52a",
        a: "0.6"
    },
    {
        n: [
            "jar"
        ],
        u: "1fad9",
        a: "14.0"
    },
    {
        n: [
            "amphora"
        ],
        u: "1f3fa",
        a: "1.0"
    }
];
var $2785da2b7d7107bb$var$travel_places = [
    {
        n: [
            "earth africa",
            "earth globe europe-africa"
        ],
        u: "1f30d",
        a: "0.7"
    },
    {
        n: [
            "earth americas",
            "earth globe americas"
        ],
        u: "1f30e",
        a: "0.7"
    },
    {
        n: [
            "earth asia",
            "earth globe asia-australia"
        ],
        u: "1f30f",
        a: "0.6"
    },
    {
        n: [
            "globe with meridians"
        ],
        u: "1f310",
        a: "1.0"
    },
    {
        n: [
            "world map"
        ],
        u: "1f5fa-fe0f",
        a: "0.7"
    },
    {
        n: [
            "japan",
            "silhouette of japan"
        ],
        u: "1f5fe",
        a: "0.6"
    },
    {
        n: [
            "compass"
        ],
        u: "1f9ed",
        a: "11.0"
    },
    {
        n: [
            "snow-capped mountain",
            "snow capped mountain"
        ],
        u: "1f3d4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "mountain"
        ],
        u: "26f0-fe0f",
        a: "0.7"
    },
    {
        n: [
            "volcano"
        ],
        u: "1f30b",
        a: "0.6"
    },
    {
        n: [
            "mount fuji"
        ],
        u: "1f5fb",
        a: "0.6"
    },
    {
        n: [
            "camping"
        ],
        u: "1f3d5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "beach with umbrella"
        ],
        u: "1f3d6-fe0f",
        a: "0.7"
    },
    {
        n: [
            "desert"
        ],
        u: "1f3dc-fe0f",
        a: "0.7"
    },
    {
        n: [
            "desert island"
        ],
        u: "1f3dd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "national park"
        ],
        u: "1f3de-fe0f",
        a: "0.7"
    },
    {
        n: [
            "stadium"
        ],
        u: "1f3df-fe0f",
        a: "0.7"
    },
    {
        n: [
            "classical building"
        ],
        u: "1f3db-fe0f",
        a: "0.7"
    },
    {
        n: [
            "building construction"
        ],
        u: "1f3d7-fe0f",
        a: "0.7"
    },
    {
        n: [
            "brick",
            "bricks"
        ],
        u: "1f9f1",
        a: "11.0"
    },
    {
        n: [
            "rock"
        ],
        u: "1faa8",
        a: "13.0"
    },
    {
        n: [
            "wood"
        ],
        u: "1fab5",
        a: "13.0"
    },
    {
        n: [
            "hut"
        ],
        u: "1f6d6",
        a: "13.0"
    },
    {
        n: [
            "houses",
            "house buildings"
        ],
        u: "1f3d8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "derelict house",
            "derelict house building"
        ],
        u: "1f3da-fe0f",
        a: "0.7"
    },
    {
        n: [
            "house",
            "house building"
        ],
        u: "1f3e0",
        a: "0.6"
    },
    {
        n: [
            "house with garden"
        ],
        u: "1f3e1",
        a: "0.6"
    },
    {
        n: [
            "office",
            "office building"
        ],
        u: "1f3e2",
        a: "0.6"
    },
    {
        n: [
            "post office",
            "japanese post office"
        ],
        u: "1f3e3",
        a: "0.6"
    },
    {
        n: [
            "european post office"
        ],
        u: "1f3e4",
        a: "1.0"
    },
    {
        n: [
            "hospital"
        ],
        u: "1f3e5",
        a: "0.6"
    },
    {
        n: [
            "bank"
        ],
        u: "1f3e6",
        a: "0.6"
    },
    {
        n: [
            "hotel"
        ],
        u: "1f3e8",
        a: "0.6"
    },
    {
        n: [
            "love hotel"
        ],
        u: "1f3e9",
        a: "0.6"
    },
    {
        n: [
            "convenience store"
        ],
        u: "1f3ea",
        a: "0.6"
    },
    {
        n: [
            "school"
        ],
        u: "1f3eb",
        a: "0.6"
    },
    {
        n: [
            "department store"
        ],
        u: "1f3ec",
        a: "0.6"
    },
    {
        n: [
            "factory"
        ],
        u: "1f3ed",
        a: "0.6"
    },
    {
        n: [
            "japanese castle"
        ],
        u: "1f3ef",
        a: "0.6"
    },
    {
        n: [
            "european castle"
        ],
        u: "1f3f0",
        a: "0.6"
    },
    {
        n: [
            "wedding"
        ],
        u: "1f492",
        a: "0.6"
    },
    {
        n: [
            "tokyo tower"
        ],
        u: "1f5fc",
        a: "0.6"
    },
    {
        n: [
            "statue of liberty"
        ],
        u: "1f5fd",
        a: "0.6"
    },
    {
        n: [
            "church"
        ],
        u: "26ea",
        a: "0.6"
    },
    {
        n: [
            "mosque"
        ],
        u: "1f54c",
        a: "1.0"
    },
    {
        n: [
            "hindu temple"
        ],
        u: "1f6d5",
        a: "12.0"
    },
    {
        n: [
            "synagogue"
        ],
        u: "1f54d",
        a: "1.0"
    },
    {
        n: [
            "shinto shrine"
        ],
        u: "26e9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "kaaba"
        ],
        u: "1f54b",
        a: "1.0"
    },
    {
        n: [
            "fountain"
        ],
        u: "26f2",
        a: "0.6"
    },
    {
        n: [
            "tent"
        ],
        u: "26fa",
        a: "0.6"
    },
    {
        n: [
            "foggy"
        ],
        u: "1f301",
        a: "0.6"
    },
    {
        n: [
            "night with stars"
        ],
        u: "1f303",
        a: "0.6"
    },
    {
        n: [
            "cityscape"
        ],
        u: "1f3d9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "sunrise over mountains"
        ],
        u: "1f304",
        a: "0.6"
    },
    {
        n: [
            "sunrise"
        ],
        u: "1f305",
        a: "0.6"
    },
    {
        n: [
            "city sunset",
            "cityscape at dusk"
        ],
        u: "1f306",
        a: "0.6"
    },
    {
        n: [
            "city sunrise",
            "sunset over buildings"
        ],
        u: "1f307",
        a: "0.6"
    },
    {
        n: [
            "bridge at night"
        ],
        u: "1f309",
        a: "0.6"
    },
    {
        n: [
            "hotsprings",
            "hot springs"
        ],
        u: "2668-fe0f",
        a: "0.6"
    },
    {
        n: [
            "carousel horse"
        ],
        u: "1f3a0",
        a: "0.6"
    },
    {
        n: [
            "playground slide"
        ],
        u: "1f6dd",
        a: "14.0"
    },
    {
        n: [
            "ferris wheel"
        ],
        u: "1f3a1",
        a: "0.6"
    },
    {
        n: [
            "roller coaster"
        ],
        u: "1f3a2",
        a: "0.6"
    },
    {
        n: [
            "barber",
            "barber pole"
        ],
        u: "1f488",
        a: "0.6"
    },
    {
        n: [
            "circus tent"
        ],
        u: "1f3aa",
        a: "0.6"
    },
    {
        n: [
            "steam locomotive"
        ],
        u: "1f682",
        a: "1.0"
    },
    {
        n: [
            "railway car"
        ],
        u: "1f683",
        a: "0.6"
    },
    {
        n: [
            "high-speed train",
            "bullettrain side"
        ],
        u: "1f684",
        a: "0.6"
    },
    {
        n: [
            "bullettrain front",
            "high-speed train with bullet nose"
        ],
        u: "1f685",
        a: "0.6"
    },
    {
        n: [
            "train",
            "train2"
        ],
        u: "1f686",
        a: "1.0"
    },
    {
        n: [
            "metro"
        ],
        u: "1f687",
        a: "0.6"
    },
    {
        n: [
            "light rail"
        ],
        u: "1f688",
        a: "1.0"
    },
    {
        n: [
            "station"
        ],
        u: "1f689",
        a: "0.6"
    },
    {
        n: [
            "tram"
        ],
        u: "1f68a",
        a: "1.0"
    },
    {
        n: [
            "monorail"
        ],
        u: "1f69d",
        a: "1.0"
    },
    {
        n: [
            "mountain railway"
        ],
        u: "1f69e",
        a: "1.0"
    },
    {
        n: [
            "train",
            "tram car"
        ],
        u: "1f68b",
        a: "1.0"
    },
    {
        n: [
            "bus"
        ],
        u: "1f68c",
        a: "0.6"
    },
    {
        n: [
            "oncoming bus"
        ],
        u: "1f68d",
        a: "0.7"
    },
    {
        n: [
            "trolleybus"
        ],
        u: "1f68e",
        a: "1.0"
    },
    {
        n: [
            "minibus"
        ],
        u: "1f690",
        a: "1.0"
    },
    {
        n: [
            "ambulance"
        ],
        u: "1f691",
        a: "0.6"
    },
    {
        n: [
            "fire engine"
        ],
        u: "1f692",
        a: "0.6"
    },
    {
        n: [
            "police car"
        ],
        u: "1f693",
        a: "0.6"
    },
    {
        n: [
            "oncoming police car"
        ],
        u: "1f694",
        a: "0.7"
    },
    {
        n: [
            "taxi"
        ],
        u: "1f695",
        a: "0.6"
    },
    {
        n: [
            "oncoming taxi"
        ],
        u: "1f696",
        a: "1.0"
    },
    {
        n: [
            "car",
            "red car",
            "automobile"
        ],
        u: "1f697",
        a: "0.6"
    },
    {
        n: [
            "oncoming automobile"
        ],
        u: "1f698",
        a: "0.7"
    },
    {
        n: [
            "blue car",
            "recreational vehicle"
        ],
        u: "1f699",
        a: "0.6"
    },
    {
        n: [
            "pickup truck"
        ],
        u: "1f6fb",
        a: "13.0"
    },
    {
        n: [
            "truck",
            "delivery truck"
        ],
        u: "1f69a",
        a: "0.6"
    },
    {
        n: [
            "articulated lorry"
        ],
        u: "1f69b",
        a: "1.0"
    },
    {
        n: [
            "tractor"
        ],
        u: "1f69c",
        a: "1.0"
    },
    {
        n: [
            "racing car"
        ],
        u: "1f3ce-fe0f",
        a: "0.7"
    },
    {
        n: [
            "motorcycle",
            "racing motorcycle"
        ],
        u: "1f3cd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "motor scooter"
        ],
        u: "1f6f5",
        a: "3.0"
    },
    {
        n: [
            "manual wheelchair"
        ],
        u: "1f9bd",
        a: "12.0"
    },
    {
        n: [
            "motorized wheelchair"
        ],
        u: "1f9bc",
        a: "12.0"
    },
    {
        n: [
            "auto rickshaw"
        ],
        u: "1f6fa",
        a: "12.0"
    },
    {
        n: [
            "bike",
            "bicycle"
        ],
        u: "1f6b2",
        a: "0.6"
    },
    {
        n: [
            "scooter"
        ],
        u: "1f6f4",
        a: "3.0"
    },
    {
        n: [
            "skateboard"
        ],
        u: "1f6f9",
        a: "11.0"
    },
    {
        n: [
            "roller skate"
        ],
        u: "1f6fc",
        a: "13.0"
    },
    {
        n: [
            "busstop",
            "bus stop"
        ],
        u: "1f68f",
        a: "0.6"
    },
    {
        n: [
            "motorway"
        ],
        u: "1f6e3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "railway track"
        ],
        u: "1f6e4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "oil drum"
        ],
        u: "1f6e2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fuelpump",
            "fuel pump"
        ],
        u: "26fd",
        a: "0.6"
    },
    {
        n: [
            "wheel"
        ],
        u: "1f6de",
        a: "14.0"
    },
    {
        n: [
            "rotating light",
            "police cars revolving light"
        ],
        u: "1f6a8",
        a: "0.6"
    },
    {
        n: [
            "traffic light",
            "horizontal traffic light"
        ],
        u: "1f6a5",
        a: "0.6"
    },
    {
        n: [
            "vertical traffic light"
        ],
        u: "1f6a6",
        a: "1.0"
    },
    {
        n: [
            "octagonal sign"
        ],
        u: "1f6d1",
        a: "3.0"
    },
    {
        n: [
            "construction",
            "construction sign"
        ],
        u: "1f6a7",
        a: "0.6"
    },
    {
        n: [
            "anchor"
        ],
        u: "2693",
        a: "0.6"
    },
    {
        n: [
            "ring buoy"
        ],
        u: "1f6df",
        a: "14.0"
    },
    {
        n: [
            "boat",
            "sailboat"
        ],
        u: "26f5",
        a: "0.6"
    },
    {
        n: [
            "canoe"
        ],
        u: "1f6f6",
        a: "3.0"
    },
    {
        n: [
            "speedboat"
        ],
        u: "1f6a4",
        a: "0.6"
    },
    {
        n: [
            "passenger ship"
        ],
        u: "1f6f3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "ferry"
        ],
        u: "26f4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "motor boat"
        ],
        u: "1f6e5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "ship"
        ],
        u: "1f6a2",
        a: "0.6"
    },
    {
        n: [
            "airplane"
        ],
        u: "2708-fe0f",
        a: "0.6"
    },
    {
        n: [
            "small airplane"
        ],
        u: "1f6e9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "airplane departure"
        ],
        u: "1f6eb",
        a: "1.0"
    },
    {
        n: [
            "airplane arriving"
        ],
        u: "1f6ec",
        a: "1.0"
    },
    {
        n: [
            "parachute"
        ],
        u: "1fa82",
        a: "12.0"
    },
    {
        n: [
            "seat"
        ],
        u: "1f4ba",
        a: "0.6"
    },
    {
        n: [
            "helicopter"
        ],
        u: "1f681",
        a: "1.0"
    },
    {
        n: [
            "suspension railway"
        ],
        u: "1f69f",
        a: "1.0"
    },
    {
        n: [
            "mountain cableway"
        ],
        u: "1f6a0",
        a: "1.0"
    },
    {
        n: [
            "aerial tramway"
        ],
        u: "1f6a1",
        a: "1.0"
    },
    {
        n: [
            "satellite"
        ],
        u: "1f6f0-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rocket"
        ],
        u: "1f680",
        a: "0.6"
    },
    {
        n: [
            "flying saucer"
        ],
        u: "1f6f8",
        a: "5.0"
    },
    {
        n: [
            "bellhop bell"
        ],
        u: "1f6ce-fe0f",
        a: "0.7"
    },
    {
        n: [
            "luggage"
        ],
        u: "1f9f3",
        a: "11.0"
    },
    {
        n: [
            "hourglass"
        ],
        u: "231b",
        a: "0.6"
    },
    {
        n: [
            "hourglass flowing sand",
            "hourglass with flowing sand"
        ],
        u: "23f3",
        a: "0.6"
    },
    {
        n: [
            "watch"
        ],
        u: "231a",
        a: "0.6"
    },
    {
        n: [
            "alarm clock"
        ],
        u: "23f0",
        a: "0.6"
    },
    {
        n: [
            "stopwatch"
        ],
        u: "23f1-fe0f",
        a: "1.0"
    },
    {
        n: [
            "timer clock"
        ],
        u: "23f2-fe0f",
        a: "1.0"
    },
    {
        n: [
            "mantelpiece clock"
        ],
        u: "1f570-fe0f",
        a: "0.7"
    },
    {
        n: [
            "clock12",
            "clock face twelve oclock"
        ],
        u: "1f55b",
        a: "0.6"
    },
    {
        n: [
            "clock1230",
            "clock face twelve-thirty"
        ],
        u: "1f567",
        a: "0.7"
    },
    {
        n: [
            "clock1",
            "clock face one oclock"
        ],
        u: "1f550",
        a: "0.6"
    },
    {
        n: [
            "clock130",
            "clock face one-thirty"
        ],
        u: "1f55c",
        a: "0.7"
    },
    {
        n: [
            "clock2",
            "clock face two oclock"
        ],
        u: "1f551",
        a: "0.6"
    },
    {
        n: [
            "clock230",
            "clock face two-thirty"
        ],
        u: "1f55d",
        a: "0.7"
    },
    {
        n: [
            "clock3",
            "clock face three oclock"
        ],
        u: "1f552",
        a: "0.6"
    },
    {
        n: [
            "clock330",
            "clock face three-thirty"
        ],
        u: "1f55e",
        a: "0.7"
    },
    {
        n: [
            "clock4",
            "clock face four oclock"
        ],
        u: "1f553",
        a: "0.6"
    },
    {
        n: [
            "clock430",
            "clock face four-thirty"
        ],
        u: "1f55f",
        a: "0.7"
    },
    {
        n: [
            "clock5",
            "clock face five oclock"
        ],
        u: "1f554",
        a: "0.6"
    },
    {
        n: [
            "clock530",
            "clock face five-thirty"
        ],
        u: "1f560",
        a: "0.7"
    },
    {
        n: [
            "clock6",
            "clock face six oclock"
        ],
        u: "1f555",
        a: "0.6"
    },
    {
        n: [
            "clock630",
            "clock face six-thirty"
        ],
        u: "1f561",
        a: "0.7"
    },
    {
        n: [
            "clock7",
            "clock face seven oclock"
        ],
        u: "1f556",
        a: "0.6"
    },
    {
        n: [
            "clock730",
            "clock face seven-thirty"
        ],
        u: "1f562",
        a: "0.7"
    },
    {
        n: [
            "clock8",
            "clock face eight oclock"
        ],
        u: "1f557",
        a: "0.6"
    },
    {
        n: [
            "clock830",
            "clock face eight-thirty"
        ],
        u: "1f563",
        a: "0.7"
    },
    {
        n: [
            "clock9",
            "clock face nine oclock"
        ],
        u: "1f558",
        a: "0.6"
    },
    {
        n: [
            "clock930",
            "clock face nine-thirty"
        ],
        u: "1f564",
        a: "0.7"
    },
    {
        n: [
            "clock10",
            "clock face ten oclock"
        ],
        u: "1f559",
        a: "0.6"
    },
    {
        n: [
            "clock1030",
            "clock face ten-thirty"
        ],
        u: "1f565",
        a: "0.7"
    },
    {
        n: [
            "clock11",
            "clock face eleven oclock"
        ],
        u: "1f55a",
        a: "0.6"
    },
    {
        n: [
            "clock1130",
            "clock face eleven-thirty"
        ],
        u: "1f566",
        a: "0.7"
    },
    {
        n: [
            "new moon",
            "new moon symbol"
        ],
        u: "1f311",
        a: "0.6"
    },
    {
        n: [
            "waxing crescent moon",
            "waxing crescent moon symbol"
        ],
        u: "1f312",
        a: "1.0"
    },
    {
        n: [
            "first quarter moon",
            "first quarter moon symbol"
        ],
        u: "1f313",
        a: "0.6"
    },
    {
        n: [
            "moon",
            "waxing gibbous moon",
            "waxing gibbous moon symbol"
        ],
        u: "1f314",
        a: "0.6"
    },
    {
        n: [
            "full moon",
            "full moon symbol"
        ],
        u: "1f315",
        a: "0.6"
    },
    {
        n: [
            "waning gibbous moon",
            "waning gibbous moon symbol"
        ],
        u: "1f316",
        a: "1.0"
    },
    {
        n: [
            "last quarter moon",
            "last quarter moon symbol"
        ],
        u: "1f317",
        a: "1.0"
    },
    {
        n: [
            "waning crescent moon",
            "waning crescent moon symbol"
        ],
        u: "1f318",
        a: "1.0"
    },
    {
        n: [
            "crescent moon"
        ],
        u: "1f319",
        a: "0.6"
    },
    {
        n: [
            "new moon with face"
        ],
        u: "1f31a",
        a: "1.0"
    },
    {
        n: [
            "first quarter moon with face"
        ],
        u: "1f31b",
        a: "0.6"
    },
    {
        n: [
            "last quarter moon with face"
        ],
        u: "1f31c",
        a: "0.7"
    },
    {
        n: [
            "thermometer"
        ],
        u: "1f321-fe0f",
        a: "0.7"
    },
    {
        n: [
            "sunny",
            "black sun with rays"
        ],
        u: "2600-fe0f",
        a: "0.6"
    },
    {
        n: [
            "full moon with face"
        ],
        u: "1f31d",
        a: "1.0"
    },
    {
        n: [
            "sun with face"
        ],
        u: "1f31e",
        a: "1.0"
    },
    {
        n: [
            "ringed planet"
        ],
        u: "1fa90",
        a: "12.0"
    },
    {
        n: [
            "star",
            "white medium star"
        ],
        u: "2b50",
        a: "0.6"
    },
    {
        n: [
            "star2",
            "glowing star"
        ],
        u: "1f31f",
        a: "0.6"
    },
    {
        n: [
            "stars",
            "shooting star"
        ],
        u: "1f320",
        a: "0.6"
    },
    {
        n: [
            "milky way"
        ],
        u: "1f30c",
        a: "0.6"
    },
    {
        n: [
            "cloud"
        ],
        u: "2601-fe0f",
        a: "0.6"
    },
    {
        n: [
            "partly sunny",
            "sun behind cloud"
        ],
        u: "26c5",
        a: "0.6"
    },
    {
        n: [
            "thunder cloud and rain",
            "cloud with lightning and rain"
        ],
        u: "26c8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "mostly sunny",
            "sun small cloud",
            "sun behind small cloud"
        ],
        u: "1f324-fe0f",
        a: "0.7"
    },
    {
        n: [
            "barely sunny",
            "sun behind cloud",
            "sun behind large cloud"
        ],
        u: "1f325-fe0f",
        a: "0.7"
    },
    {
        n: [
            "partly sunny rain",
            "sun behind rain cloud"
        ],
        u: "1f326-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rain cloud",
            "cloud with rain"
        ],
        u: "1f327-fe0f",
        a: "0.7"
    },
    {
        n: [
            "snow cloud",
            "cloud with snow"
        ],
        u: "1f328-fe0f",
        a: "0.7"
    },
    {
        n: [
            "lightning",
            "lightning cloud",
            "cloud with lightning"
        ],
        u: "1f329-fe0f",
        a: "0.7"
    },
    {
        n: [
            "tornado",
            "tornado cloud"
        ],
        u: "1f32a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fog"
        ],
        u: "1f32b-fe0f",
        a: "0.7"
    },
    {
        n: [
            "wind face",
            "wind blowing face"
        ],
        u: "1f32c-fe0f",
        a: "0.7"
    },
    {
        n: [
            "cyclone"
        ],
        u: "1f300",
        a: "0.6"
    },
    {
        n: [
            "rainbow"
        ],
        u: "1f308",
        a: "0.6"
    },
    {
        n: [
            "closed umbrella"
        ],
        u: "1f302",
        a: "0.6"
    },
    {
        n: [
            "umbrella"
        ],
        u: "2602-fe0f",
        a: "0.7"
    },
    {
        n: [
            "umbrella with rain drops"
        ],
        u: "2614",
        a: "0.6"
    },
    {
        n: [
            "umbrella on ground"
        ],
        u: "26f1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "zap",
            "high voltage sign"
        ],
        u: "26a1",
        a: "0.6"
    },
    {
        n: [
            "snowflake"
        ],
        u: "2744-fe0f",
        a: "0.6"
    },
    {
        n: [
            "snowman"
        ],
        u: "2603-fe0f",
        a: "0.7"
    },
    {
        n: [
            "snowman without snow"
        ],
        u: "26c4",
        a: "0.6"
    },
    {
        n: [
            "comet"
        ],
        u: "2604-fe0f",
        a: "1.0"
    },
    {
        n: [
            "fire"
        ],
        u: "1f525",
        a: "0.6"
    },
    {
        n: [
            "droplet"
        ],
        u: "1f4a7",
        a: "0.6"
    },
    {
        n: [
            "ocean",
            "water wave"
        ],
        u: "1f30a",
        a: "0.6"
    }
];
var $2785da2b7d7107bb$var$activities = [
    {
        n: [
            "jack-o-lantern",
            "jack o lantern"
        ],
        u: "1f383",
        a: "0.6"
    },
    {
        n: [
            "christmas tree"
        ],
        u: "1f384",
        a: "0.6"
    },
    {
        n: [
            "fireworks"
        ],
        u: "1f386",
        a: "0.6"
    },
    {
        n: [
            "sparkler",
            "firework sparkler"
        ],
        u: "1f387",
        a: "0.6"
    },
    {
        n: [
            "firecracker"
        ],
        u: "1f9e8",
        a: "11.0"
    },
    {
        n: [
            "sparkles"
        ],
        u: "2728",
        a: "0.6"
    },
    {
        n: [
            "balloon"
        ],
        u: "1f388",
        a: "0.6"
    },
    {
        n: [
            "tada",
            "party popper"
        ],
        u: "1f389",
        a: "0.6"
    },
    {
        n: [
            "confetti ball"
        ],
        u: "1f38a",
        a: "0.6"
    },
    {
        n: [
            "tanabata tree"
        ],
        u: "1f38b",
        a: "0.6"
    },
    {
        n: [
            "bamboo",
            "pine decoration"
        ],
        u: "1f38d",
        a: "0.6"
    },
    {
        n: [
            "dolls",
            "japanese dolls"
        ],
        u: "1f38e",
        a: "0.6"
    },
    {
        n: [
            "flags",
            "carp streamer"
        ],
        u: "1f38f",
        a: "0.6"
    },
    {
        n: [
            "wind chime"
        ],
        u: "1f390",
        a: "0.6"
    },
    {
        n: [
            "rice scene",
            "moon viewing ceremony"
        ],
        u: "1f391",
        a: "0.6"
    },
    {
        n: [
            "red envelope",
            "red gift envelope"
        ],
        u: "1f9e7",
        a: "11.0"
    },
    {
        n: [
            "ribbon"
        ],
        u: "1f380",
        a: "0.6"
    },
    {
        n: [
            "gift",
            "wrapped present"
        ],
        u: "1f381",
        a: "0.6"
    },
    {
        n: [
            "reminder ribbon"
        ],
        u: "1f397-fe0f",
        a: "0.7"
    },
    {
        n: [
            "admission tickets"
        ],
        u: "1f39f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "ticket"
        ],
        u: "1f3ab",
        a: "0.6"
    },
    {
        n: [
            "medal",
            "military medal"
        ],
        u: "1f396-fe0f",
        a: "0.7"
    },
    {
        n: [
            "trophy"
        ],
        u: "1f3c6",
        a: "0.6"
    },
    {
        n: [
            "sports medal"
        ],
        u: "1f3c5",
        a: "1.0"
    },
    {
        n: [
            "first place medal"
        ],
        u: "1f947",
        a: "3.0"
    },
    {
        n: [
            "second place medal"
        ],
        u: "1f948",
        a: "3.0"
    },
    {
        n: [
            "third place medal"
        ],
        u: "1f949",
        a: "3.0"
    },
    {
        n: [
            "soccer",
            "soccer ball"
        ],
        u: "26bd",
        a: "0.6"
    },
    {
        n: [
            "baseball"
        ],
        u: "26be",
        a: "0.6"
    },
    {
        n: [
            "softball"
        ],
        u: "1f94e",
        a: "11.0"
    },
    {
        n: [
            "basketball",
            "basketball and hoop"
        ],
        u: "1f3c0",
        a: "0.6"
    },
    {
        n: [
            "volleyball"
        ],
        u: "1f3d0",
        a: "1.0"
    },
    {
        n: [
            "football",
            "american football"
        ],
        u: "1f3c8",
        a: "0.6"
    },
    {
        n: [
            "rugby football"
        ],
        u: "1f3c9",
        a: "1.0"
    },
    {
        n: [
            "tennis",
            "tennis racquet and ball"
        ],
        u: "1f3be",
        a: "0.6"
    },
    {
        n: [
            "flying disc"
        ],
        u: "1f94f",
        a: "11.0"
    },
    {
        n: [
            "bowling"
        ],
        u: "1f3b3",
        a: "0.6"
    },
    {
        n: [
            "cricket bat and ball"
        ],
        u: "1f3cf",
        a: "1.0"
    },
    {
        n: [
            "field hockey stick and ball"
        ],
        u: "1f3d1",
        a: "1.0"
    },
    {
        n: [
            "ice hockey stick and puck"
        ],
        u: "1f3d2",
        a: "1.0"
    },
    {
        n: [
            "lacrosse",
            "lacrosse stick and ball"
        ],
        u: "1f94d",
        a: "11.0"
    },
    {
        n: [
            "table tennis paddle and ball"
        ],
        u: "1f3d3",
        a: "1.0"
    },
    {
        n: [
            "badminton racquet and shuttlecock"
        ],
        u: "1f3f8",
        a: "1.0"
    },
    {
        n: [
            "boxing glove"
        ],
        u: "1f94a",
        a: "3.0"
    },
    {
        n: [
            "martial arts uniform"
        ],
        u: "1f94b",
        a: "3.0"
    },
    {
        n: [
            "goal net"
        ],
        u: "1f945",
        a: "3.0"
    },
    {
        n: [
            "golf",
            "flag in hole"
        ],
        u: "26f3",
        a: "0.6"
    },
    {
        n: [
            "ice skate"
        ],
        u: "26f8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "fishing pole and fish"
        ],
        u: "1f3a3",
        a: "0.6"
    },
    {
        n: [
            "diving mask"
        ],
        u: "1f93f",
        a: "12.0"
    },
    {
        n: [
            "running shirt with sash"
        ],
        u: "1f3bd",
        a: "0.6"
    },
    {
        n: [
            "ski",
            "ski and ski boot"
        ],
        u: "1f3bf",
        a: "0.6"
    },
    {
        n: [
            "sled"
        ],
        u: "1f6f7",
        a: "5.0"
    },
    {
        n: [
            "curling stone"
        ],
        u: "1f94c",
        a: "5.0"
    },
    {
        n: [
            "dart",
            "direct hit"
        ],
        u: "1f3af",
        a: "0.6"
    },
    {
        n: [
            "yo-yo"
        ],
        u: "1fa80",
        a: "12.0"
    },
    {
        n: [
            "kite"
        ],
        u: "1fa81",
        a: "12.0"
    },
    {
        n: [
            "8ball",
            "billiards"
        ],
        u: "1f3b1",
        a: "0.6"
    },
    {
        n: [
            "crystal ball"
        ],
        u: "1f52e",
        a: "0.6"
    },
    {
        n: [
            "magic wand"
        ],
        u: "1fa84",
        a: "13.0"
    },
    {
        n: [
            "nazar amulet"
        ],
        u: "1f9ff",
        a: "11.0"
    },
    {
        n: [
            "hamsa"
        ],
        u: "1faac",
        a: "14.0"
    },
    {
        n: [
            "video game"
        ],
        u: "1f3ae",
        a: "0.6"
    },
    {
        n: [
            "joystick"
        ],
        u: "1f579-fe0f",
        a: "0.7"
    },
    {
        n: [
            "slot machine"
        ],
        u: "1f3b0",
        a: "0.6"
    },
    {
        n: [
            "game die"
        ],
        u: "1f3b2",
        a: "0.6"
    },
    {
        n: [
            "jigsaw",
            "jigsaw puzzle piece"
        ],
        u: "1f9e9",
        a: "11.0"
    },
    {
        n: [
            "teddy bear"
        ],
        u: "1f9f8",
        a: "11.0"
    },
    {
        n: [
            "pinata"
        ],
        u: "1fa85",
        a: "13.0"
    },
    {
        n: [
            "mirror ball"
        ],
        u: "1faa9",
        a: "14.0"
    },
    {
        n: [
            "nesting dolls"
        ],
        u: "1fa86",
        a: "13.0"
    },
    {
        n: [
            "spades",
            "black spade suit"
        ],
        u: "2660-fe0f",
        a: "0.6"
    },
    {
        n: [
            "hearts",
            "black heart suit"
        ],
        u: "2665-fe0f",
        a: "0.6"
    },
    {
        n: [
            "diamonds",
            "black diamond suit"
        ],
        u: "2666-fe0f",
        a: "0.6"
    },
    {
        n: [
            "clubs",
            "black club suit"
        ],
        u: "2663-fe0f",
        a: "0.6"
    },
    {
        n: [
            "chess pawn"
        ],
        u: "265f-fe0f",
        a: "11.0"
    },
    {
        n: [
            "black joker",
            "playing card black joker"
        ],
        u: "1f0cf",
        a: "0.6"
    },
    {
        n: [
            "mahjong",
            "mahjong tile red dragon"
        ],
        u: "1f004",
        a: "0.6"
    },
    {
        n: [
            "flower playing cards"
        ],
        u: "1f3b4",
        a: "0.6"
    },
    {
        n: [
            "performing arts"
        ],
        u: "1f3ad",
        a: "0.6"
    },
    {
        n: [
            "framed picture",
            "frame with picture"
        ],
        u: "1f5bc-fe0f",
        a: "0.7"
    },
    {
        n: [
            "art",
            "artist palette"
        ],
        u: "1f3a8",
        a: "0.6"
    },
    {
        n: [
            "thread",
            "spool of thread"
        ],
        u: "1f9f5",
        a: "11.0"
    },
    {
        n: [
            "sewing needle"
        ],
        u: "1faa1",
        a: "13.0"
    },
    {
        n: [
            "yarn",
            "ball of yarn"
        ],
        u: "1f9f6",
        a: "11.0"
    },
    {
        n: [
            "knot"
        ],
        u: "1faa2",
        a: "13.0"
    }
];
var $2785da2b7d7107bb$var$objects = [
    {
        n: [
            "eyeglasses"
        ],
        u: "1f453",
        a: "0.6"
    },
    {
        n: [
            "sunglasses",
            "dark sunglasses"
        ],
        u: "1f576-fe0f",
        a: "0.7"
    },
    {
        n: [
            "goggles"
        ],
        u: "1f97d",
        a: "11.0"
    },
    {
        n: [
            "lab coat"
        ],
        u: "1f97c",
        a: "11.0"
    },
    {
        n: [
            "safety vest"
        ],
        u: "1f9ba",
        a: "12.0"
    },
    {
        n: [
            "necktie"
        ],
        u: "1f454",
        a: "0.6"
    },
    {
        n: [
            "shirt",
            "tshirt",
            "t-shirt"
        ],
        u: "1f455",
        a: "0.6"
    },
    {
        n: [
            "jeans"
        ],
        u: "1f456",
        a: "0.6"
    },
    {
        n: [
            "scarf"
        ],
        u: "1f9e3",
        a: "5.0"
    },
    {
        n: [
            "gloves"
        ],
        u: "1f9e4",
        a: "5.0"
    },
    {
        n: [
            "coat"
        ],
        u: "1f9e5",
        a: "5.0"
    },
    {
        n: [
            "socks"
        ],
        u: "1f9e6",
        a: "5.0"
    },
    {
        n: [
            "dress"
        ],
        u: "1f457",
        a: "0.6"
    },
    {
        n: [
            "kimono"
        ],
        u: "1f458",
        a: "0.6"
    },
    {
        n: [
            "sari"
        ],
        u: "1f97b",
        a: "12.0"
    },
    {
        n: [
            "one-piece swimsuit"
        ],
        u: "1fa71",
        a: "12.0"
    },
    {
        n: [
            "briefs"
        ],
        u: "1fa72",
        a: "12.0"
    },
    {
        n: [
            "shorts"
        ],
        u: "1fa73",
        a: "12.0"
    },
    {
        n: [
            "bikini"
        ],
        u: "1f459",
        a: "0.6"
    },
    {
        n: [
            "womans clothes"
        ],
        u: "1f45a",
        a: "0.6"
    },
    {
        n: [
            "purse"
        ],
        u: "1f45b",
        a: "0.6"
    },
    {
        n: [
            "handbag"
        ],
        u: "1f45c",
        a: "0.6"
    },
    {
        n: [
            "pouch"
        ],
        u: "1f45d",
        a: "0.6"
    },
    {
        n: [
            "shopping bags"
        ],
        u: "1f6cd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "school satchel"
        ],
        u: "1f392",
        a: "0.6"
    },
    {
        n: [
            "thong sandal"
        ],
        u: "1fa74",
        a: "13.0"
    },
    {
        n: [
            "shoe",
            "mans shoe"
        ],
        u: "1f45e",
        a: "0.6"
    },
    {
        n: [
            "athletic shoe"
        ],
        u: "1f45f",
        a: "0.6"
    },
    {
        n: [
            "hiking boot"
        ],
        u: "1f97e",
        a: "11.0"
    },
    {
        n: [
            "flat shoe",
            "womans flat shoe"
        ],
        u: "1f97f",
        a: "11.0"
    },
    {
        n: [
            "high heel",
            "high-heeled shoe"
        ],
        u: "1f460",
        a: "0.6"
    },
    {
        n: [
            "sandal",
            "womans sandal"
        ],
        u: "1f461",
        a: "0.6"
    },
    {
        n: [
            "ballet shoes"
        ],
        u: "1fa70",
        a: "12.0"
    },
    {
        n: [
            "boot",
            "womans boots"
        ],
        u: "1f462",
        a: "0.6"
    },
    {
        n: [
            "crown"
        ],
        u: "1f451",
        a: "0.6"
    },
    {
        n: [
            "womans hat"
        ],
        u: "1f452",
        a: "0.6"
    },
    {
        n: [
            "tophat",
            "top hat"
        ],
        u: "1f3a9",
        a: "0.6"
    },
    {
        n: [
            "mortar board",
            "graduation cap"
        ],
        u: "1f393",
        a: "0.6"
    },
    {
        n: [
            "billed cap"
        ],
        u: "1f9e2",
        a: "5.0"
    },
    {
        n: [
            "military helmet"
        ],
        u: "1fa96",
        a: "13.0"
    },
    {
        n: [
            "rescue worker’s helmet",
            "helmet with white cross"
        ],
        u: "26d1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "prayer beads"
        ],
        u: "1f4ff",
        a: "1.0"
    },
    {
        n: [
            "lipstick"
        ],
        u: "1f484",
        a: "0.6"
    },
    {
        n: [
            "ring"
        ],
        u: "1f48d",
        a: "0.6"
    },
    {
        n: [
            "gem",
            "gem stone"
        ],
        u: "1f48e",
        a: "0.6"
    },
    {
        n: [
            "mute",
            "speaker with cancellation stroke"
        ],
        u: "1f507",
        a: "1.0"
    },
    {
        n: [
            "speaker"
        ],
        u: "1f508",
        a: "0.7"
    },
    {
        n: [
            "sound",
            "speaker with one sound wave"
        ],
        u: "1f509",
        a: "1.0"
    },
    {
        n: [
            "loud sound",
            "speaker with three sound waves"
        ],
        u: "1f50a",
        a: "0.6"
    },
    {
        n: [
            "loudspeaker",
            "public address loudspeaker"
        ],
        u: "1f4e2",
        a: "0.6"
    },
    {
        n: [
            "mega",
            "cheering megaphone"
        ],
        u: "1f4e3",
        a: "0.6"
    },
    {
        n: [
            "postal horn"
        ],
        u: "1f4ef",
        a: "1.0"
    },
    {
        n: [
            "bell"
        ],
        u: "1f514",
        a: "0.6"
    },
    {
        n: [
            "no bell",
            "bell with cancellation stroke"
        ],
        u: "1f515",
        a: "1.0"
    },
    {
        n: [
            "musical score"
        ],
        u: "1f3bc",
        a: "0.6"
    },
    {
        n: [
            "musical note"
        ],
        u: "1f3b5",
        a: "0.6"
    },
    {
        n: [
            "notes",
            "multiple musical notes"
        ],
        u: "1f3b6",
        a: "0.6"
    },
    {
        n: [
            "studio microphone"
        ],
        u: "1f399-fe0f",
        a: "0.7"
    },
    {
        n: [
            "level slider"
        ],
        u: "1f39a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "control knobs"
        ],
        u: "1f39b-fe0f",
        a: "0.7"
    },
    {
        n: [
            "microphone"
        ],
        u: "1f3a4",
        a: "0.6"
    },
    {
        n: [
            "headphone",
            "headphones"
        ],
        u: "1f3a7",
        a: "0.6"
    },
    {
        n: [
            "radio"
        ],
        u: "1f4fb",
        a: "0.6"
    },
    {
        n: [
            "saxophone"
        ],
        u: "1f3b7",
        a: "0.6"
    },
    {
        n: [
            "accordion"
        ],
        u: "1fa97",
        a: "13.0"
    },
    {
        n: [
            "guitar"
        ],
        u: "1f3b8",
        a: "0.6"
    },
    {
        n: [
            "musical keyboard"
        ],
        u: "1f3b9",
        a: "0.6"
    },
    {
        n: [
            "trumpet"
        ],
        u: "1f3ba",
        a: "0.6"
    },
    {
        n: [
            "violin"
        ],
        u: "1f3bb",
        a: "0.6"
    },
    {
        n: [
            "banjo"
        ],
        u: "1fa95",
        a: "12.0"
    },
    {
        n: [
            "drum with drumsticks"
        ],
        u: "1f941",
        a: "3.0"
    },
    {
        n: [
            "long drum"
        ],
        u: "1fa98",
        a: "13.0"
    },
    {
        n: [
            "iphone",
            "mobile phone"
        ],
        u: "1f4f1",
        a: "0.6"
    },
    {
        n: [
            "calling",
            "mobile phone with rightwards arrow at left"
        ],
        u: "1f4f2",
        a: "0.6"
    },
    {
        n: [
            "phone",
            "telephone",
            "black telephone"
        ],
        u: "260e-fe0f",
        a: "0.6"
    },
    {
        n: [
            "telephone receiver"
        ],
        u: "1f4de",
        a: "0.6"
    },
    {
        n: [
            "pager"
        ],
        u: "1f4df",
        a: "0.6"
    },
    {
        n: [
            "fax",
            "fax machine"
        ],
        u: "1f4e0",
        a: "0.6"
    },
    {
        n: [
            "battery"
        ],
        u: "1f50b",
        a: "0.6"
    },
    {
        n: [
            "low battery"
        ],
        u: "1faab",
        a: "14.0"
    },
    {
        n: [
            "electric plug"
        ],
        u: "1f50c",
        a: "0.6"
    },
    {
        n: [
            "computer",
            "personal computer"
        ],
        u: "1f4bb",
        a: "0.6"
    },
    {
        n: [
            "desktop computer"
        ],
        u: "1f5a5-fe0f",
        a: "0.7"
    },
    {
        n: [
            "printer"
        ],
        u: "1f5a8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "keyboard"
        ],
        u: "2328-fe0f",
        a: "1.0"
    },
    {
        n: [
            "computer mouse",
            "three button mouse"
        ],
        u: "1f5b1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "trackball"
        ],
        u: "1f5b2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "minidisc"
        ],
        u: "1f4bd",
        a: "0.6"
    },
    {
        n: [
            "floppy disk"
        ],
        u: "1f4be",
        a: "0.6"
    },
    {
        n: [
            "cd",
            "optical disc"
        ],
        u: "1f4bf",
        a: "0.6"
    },
    {
        n: [
            "dvd"
        ],
        u: "1f4c0",
        a: "0.6"
    },
    {
        n: [
            "abacus"
        ],
        u: "1f9ee",
        a: "11.0"
    },
    {
        n: [
            "movie camera"
        ],
        u: "1f3a5",
        a: "0.6"
    },
    {
        n: [
            "film frames"
        ],
        u: "1f39e-fe0f",
        a: "0.7"
    },
    {
        n: [
            "film projector"
        ],
        u: "1f4fd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "clapper",
            "clapper board"
        ],
        u: "1f3ac",
        a: "0.6"
    },
    {
        n: [
            "tv",
            "television"
        ],
        u: "1f4fa",
        a: "0.6"
    },
    {
        n: [
            "camera"
        ],
        u: "1f4f7",
        a: "0.6"
    },
    {
        n: [
            "camera with flash"
        ],
        u: "1f4f8",
        a: "1.0"
    },
    {
        n: [
            "video camera"
        ],
        u: "1f4f9",
        a: "0.6"
    },
    {
        n: [
            "vhs",
            "videocassette"
        ],
        u: "1f4fc",
        a: "0.6"
    },
    {
        n: [
            "mag",
            "left-pointing magnifying glass"
        ],
        u: "1f50d",
        a: "0.6"
    },
    {
        n: [
            "mag right",
            "right-pointing magnifying glass"
        ],
        u: "1f50e",
        a: "0.6"
    },
    {
        n: [
            "candle"
        ],
        u: "1f56f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bulb",
            "electric light bulb"
        ],
        u: "1f4a1",
        a: "0.6"
    },
    {
        n: [
            "flashlight",
            "electric torch"
        ],
        u: "1f526",
        a: "0.6"
    },
    {
        n: [
            "lantern",
            "izakaya lantern"
        ],
        u: "1f3ee",
        a: "0.6"
    },
    {
        n: [
            "diya lamp"
        ],
        u: "1fa94",
        a: "12.0"
    },
    {
        n: [
            "notebook with decorative cover"
        ],
        u: "1f4d4",
        a: "0.6"
    },
    {
        n: [
            "closed book"
        ],
        u: "1f4d5",
        a: "0.6"
    },
    {
        n: [
            "book",
            "open book"
        ],
        u: "1f4d6",
        a: "0.6"
    },
    {
        n: [
            "green book"
        ],
        u: "1f4d7",
        a: "0.6"
    },
    {
        n: [
            "blue book"
        ],
        u: "1f4d8",
        a: "0.6"
    },
    {
        n: [
            "orange book"
        ],
        u: "1f4d9",
        a: "0.6"
    },
    {
        n: [
            "books"
        ],
        u: "1f4da",
        a: "0.6"
    },
    {
        n: [
            "notebook"
        ],
        u: "1f4d3",
        a: "0.6"
    },
    {
        n: [
            "ledger"
        ],
        u: "1f4d2",
        a: "0.6"
    },
    {
        n: [
            "page with curl"
        ],
        u: "1f4c3",
        a: "0.6"
    },
    {
        n: [
            "scroll"
        ],
        u: "1f4dc",
        a: "0.6"
    },
    {
        n: [
            "page facing up"
        ],
        u: "1f4c4",
        a: "0.6"
    },
    {
        n: [
            "newspaper"
        ],
        u: "1f4f0",
        a: "0.6"
    },
    {
        n: [
            "rolled-up newspaper",
            "rolled up newspaper"
        ],
        u: "1f5de-fe0f",
        a: "0.7"
    },
    {
        n: [
            "bookmark tabs"
        ],
        u: "1f4d1",
        a: "0.6"
    },
    {
        n: [
            "bookmark"
        ],
        u: "1f516",
        a: "0.6"
    },
    {
        n: [
            "label"
        ],
        u: "1f3f7-fe0f",
        a: "0.7"
    },
    {
        n: [
            "moneybag",
            "money bag"
        ],
        u: "1f4b0",
        a: "0.6"
    },
    {
        n: [
            "coin"
        ],
        u: "1fa99",
        a: "13.0"
    },
    {
        n: [
            "yen",
            "banknote with yen sign"
        ],
        u: "1f4b4",
        a: "0.6"
    },
    {
        n: [
            "dollar",
            "banknote with dollar sign"
        ],
        u: "1f4b5",
        a: "0.6"
    },
    {
        n: [
            "euro",
            "banknote with euro sign"
        ],
        u: "1f4b6",
        a: "1.0"
    },
    {
        n: [
            "pound",
            "banknote with pound sign"
        ],
        u: "1f4b7",
        a: "1.0"
    },
    {
        n: [
            "money with wings"
        ],
        u: "1f4b8",
        a: "0.6"
    },
    {
        n: [
            "credit card"
        ],
        u: "1f4b3",
        a: "0.6"
    },
    {
        n: [
            "receipt"
        ],
        u: "1f9fe",
        a: "11.0"
    },
    {
        n: [
            "chart",
            "chart with upwards trend and yen sign"
        ],
        u: "1f4b9",
        a: "0.6"
    },
    {
        n: [
            "email",
            "envelope"
        ],
        u: "2709-fe0f",
        a: "0.6"
    },
    {
        n: [
            "e-mail",
            "e-mail symbol"
        ],
        u: "1f4e7",
        a: "0.6"
    },
    {
        n: [
            "incoming envelope"
        ],
        u: "1f4e8",
        a: "0.6"
    },
    {
        n: [
            "envelope with arrow",
            "envelope with downwards arrow above"
        ],
        u: "1f4e9",
        a: "0.6"
    },
    {
        n: [
            "outbox tray"
        ],
        u: "1f4e4",
        a: "0.6"
    },
    {
        n: [
            "inbox tray"
        ],
        u: "1f4e5",
        a: "0.6"
    },
    {
        n: [
            "package"
        ],
        u: "1f4e6",
        a: "0.6"
    },
    {
        n: [
            "mailbox",
            "closed mailbox with raised flag"
        ],
        u: "1f4eb",
        a: "0.6"
    },
    {
        n: [
            "mailbox closed",
            "closed mailbox with lowered flag"
        ],
        u: "1f4ea",
        a: "0.6"
    },
    {
        n: [
            "mailbox with mail",
            "open mailbox with raised flag"
        ],
        u: "1f4ec",
        a: "0.7"
    },
    {
        n: [
            "mailbox with no mail",
            "open mailbox with lowered flag"
        ],
        u: "1f4ed",
        a: "0.7"
    },
    {
        n: [
            "postbox"
        ],
        u: "1f4ee",
        a: "0.6"
    },
    {
        n: [
            "ballot box with ballot"
        ],
        u: "1f5f3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "pencil",
            "pencil2"
        ],
        u: "270f-fe0f",
        a: "0.6"
    },
    {
        n: [
            "black nib"
        ],
        u: "2712-fe0f",
        a: "0.6"
    },
    {
        n: [
            "fountain pen",
            "lower left fountain pen"
        ],
        u: "1f58b-fe0f",
        a: "0.7"
    },
    {
        n: [
            "pen",
            "lower left ballpoint pen"
        ],
        u: "1f58a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "paintbrush",
            "lower left paintbrush"
        ],
        u: "1f58c-fe0f",
        a: "0.7"
    },
    {
        n: [
            "crayon",
            "lower left crayon"
        ],
        u: "1f58d-fe0f",
        a: "0.7"
    },
    {
        n: [
            "memo",
            "pencil"
        ],
        u: "1f4dd",
        a: "0.6"
    },
    {
        n: [
            "briefcase"
        ],
        u: "1f4bc",
        a: "0.6"
    },
    {
        n: [
            "file folder"
        ],
        u: "1f4c1",
        a: "0.6"
    },
    {
        n: [
            "open file folder"
        ],
        u: "1f4c2",
        a: "0.6"
    },
    {
        n: [
            "card index dividers"
        ],
        u: "1f5c2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "date",
            "calendar"
        ],
        u: "1f4c5",
        a: "0.6"
    },
    {
        n: [
            "calendar",
            "tear-off calendar"
        ],
        u: "1f4c6",
        a: "0.6"
    },
    {
        n: [
            "spiral notepad",
            "spiral note pad"
        ],
        u: "1f5d2-fe0f",
        a: "0.7"
    },
    {
        n: [
            "spiral calendar",
            "spiral calendar pad"
        ],
        u: "1f5d3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "card index"
        ],
        u: "1f4c7",
        a: "0.6"
    },
    {
        n: [
            "chart with upwards trend"
        ],
        u: "1f4c8",
        a: "0.6"
    },
    {
        n: [
            "chart with downwards trend"
        ],
        u: "1f4c9",
        a: "0.6"
    },
    {
        n: [
            "bar chart"
        ],
        u: "1f4ca",
        a: "0.6"
    },
    {
        n: [
            "clipboard"
        ],
        u: "1f4cb",
        a: "0.6"
    },
    {
        n: [
            "pushpin"
        ],
        u: "1f4cc",
        a: "0.6"
    },
    {
        n: [
            "round pushpin"
        ],
        u: "1f4cd",
        a: "0.6"
    },
    {
        n: [
            "paperclip"
        ],
        u: "1f4ce",
        a: "0.6"
    },
    {
        n: [
            "linked paperclips"
        ],
        u: "1f587-fe0f",
        a: "0.7"
    },
    {
        n: [
            "straight ruler"
        ],
        u: "1f4cf",
        a: "0.6"
    },
    {
        n: [
            "triangular ruler"
        ],
        u: "1f4d0",
        a: "0.6"
    },
    {
        n: [
            "scissors",
            "black scissors"
        ],
        u: "2702-fe0f",
        a: "0.6"
    },
    {
        n: [
            "card file box"
        ],
        u: "1f5c3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "file cabinet"
        ],
        u: "1f5c4-fe0f",
        a: "0.7"
    },
    {
        n: [
            "wastebasket"
        ],
        u: "1f5d1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "lock"
        ],
        u: "1f512",
        a: "0.6"
    },
    {
        n: [
            "unlock",
            "open lock"
        ],
        u: "1f513",
        a: "0.6"
    },
    {
        n: [
            "lock with ink pen"
        ],
        u: "1f50f",
        a: "0.6"
    },
    {
        n: [
            "closed lock with key"
        ],
        u: "1f510",
        a: "0.6"
    },
    {
        n: [
            "key"
        ],
        u: "1f511",
        a: "0.6"
    },
    {
        n: [
            "old key"
        ],
        u: "1f5dd-fe0f",
        a: "0.7"
    },
    {
        n: [
            "hammer"
        ],
        u: "1f528",
        a: "0.6"
    },
    {
        n: [
            "axe"
        ],
        u: "1fa93",
        a: "12.0"
    },
    {
        n: [
            "pick"
        ],
        u: "26cf-fe0f",
        a: "0.7"
    },
    {
        n: [
            "hammer and pick"
        ],
        u: "2692-fe0f",
        a: "1.0"
    },
    {
        n: [
            "hammer and wrench"
        ],
        u: "1f6e0-fe0f",
        a: "0.7"
    },
    {
        n: [
            "dagger",
            "dagger knife"
        ],
        u: "1f5e1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "crossed swords"
        ],
        u: "2694-fe0f",
        a: "1.0"
    },
    {
        n: [
            "gun",
            "pistol"
        ],
        u: "1f52b",
        a: "0.6"
    },
    {
        n: [
            "boomerang"
        ],
        u: "1fa83",
        a: "13.0"
    },
    {
        n: [
            "bow and arrow"
        ],
        u: "1f3f9",
        a: "1.0"
    },
    {
        n: [
            "shield"
        ],
        u: "1f6e1-fe0f",
        a: "0.7"
    },
    {
        n: [
            "carpentry saw"
        ],
        u: "1fa9a",
        a: "13.0"
    },
    {
        n: [
            "wrench"
        ],
        u: "1f527",
        a: "0.6"
    },
    {
        n: [
            "screwdriver"
        ],
        u: "1fa9b",
        a: "13.0"
    },
    {
        n: [
            "nut and bolt"
        ],
        u: "1f529",
        a: "0.6"
    },
    {
        n: [
            "gear"
        ],
        u: "2699-fe0f",
        a: "1.0"
    },
    {
        n: [
            "clamp",
            "compression"
        ],
        u: "1f5dc-fe0f",
        a: "0.7"
    },
    {
        n: [
            "scales",
            "balance scale"
        ],
        u: "2696-fe0f",
        a: "1.0"
    },
    {
        n: [
            "probing cane"
        ],
        u: "1f9af",
        a: "12.0"
    },
    {
        n: [
            "link",
            "link symbol"
        ],
        u: "1f517",
        a: "0.6"
    },
    {
        n: [
            "chains"
        ],
        u: "26d3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "hook"
        ],
        u: "1fa9d",
        a: "13.0"
    },
    {
        n: [
            "toolbox"
        ],
        u: "1f9f0",
        a: "11.0"
    },
    {
        n: [
            "magnet"
        ],
        u: "1f9f2",
        a: "11.0"
    },
    {
        n: [
            "ladder"
        ],
        u: "1fa9c",
        a: "13.0"
    },
    {
        n: [
            "alembic"
        ],
        u: "2697-fe0f",
        a: "1.0"
    },
    {
        n: [
            "test tube"
        ],
        u: "1f9ea",
        a: "11.0"
    },
    {
        n: [
            "petri dish"
        ],
        u: "1f9eb",
        a: "11.0"
    },
    {
        n: [
            "dna",
            "dna double helix"
        ],
        u: "1f9ec",
        a: "11.0"
    },
    {
        n: [
            "microscope"
        ],
        u: "1f52c",
        a: "1.0"
    },
    {
        n: [
            "telescope"
        ],
        u: "1f52d",
        a: "1.0"
    },
    {
        n: [
            "satellite antenna"
        ],
        u: "1f4e1",
        a: "0.6"
    },
    {
        n: [
            "syringe"
        ],
        u: "1f489",
        a: "0.6"
    },
    {
        n: [
            "drop of blood"
        ],
        u: "1fa78",
        a: "12.0"
    },
    {
        n: [
            "pill"
        ],
        u: "1f48a",
        a: "0.6"
    },
    {
        n: [
            "adhesive bandage"
        ],
        u: "1fa79",
        a: "12.0"
    },
    {
        n: [
            "crutch"
        ],
        u: "1fa7c",
        a: "14.0"
    },
    {
        n: [
            "stethoscope"
        ],
        u: "1fa7a",
        a: "12.0"
    },
    {
        n: [
            "x-ray"
        ],
        u: "1fa7b",
        a: "14.0"
    },
    {
        n: [
            "door"
        ],
        u: "1f6aa",
        a: "0.6"
    },
    {
        n: [
            "elevator"
        ],
        u: "1f6d7",
        a: "13.0"
    },
    {
        n: [
            "mirror"
        ],
        u: "1fa9e",
        a: "13.0"
    },
    {
        n: [
            "window"
        ],
        u: "1fa9f",
        a: "13.0"
    },
    {
        n: [
            "bed"
        ],
        u: "1f6cf-fe0f",
        a: "0.7"
    },
    {
        n: [
            "couch and lamp"
        ],
        u: "1f6cb-fe0f",
        a: "0.7"
    },
    {
        n: [
            "chair"
        ],
        u: "1fa91",
        a: "12.0"
    },
    {
        n: [
            "toilet"
        ],
        u: "1f6bd",
        a: "0.6"
    },
    {
        n: [
            "plunger"
        ],
        u: "1faa0",
        a: "13.0"
    },
    {
        n: [
            "shower"
        ],
        u: "1f6bf",
        a: "1.0"
    },
    {
        n: [
            "bathtub"
        ],
        u: "1f6c1",
        a: "1.0"
    },
    {
        n: [
            "mouse trap"
        ],
        u: "1faa4",
        a: "13.0"
    },
    {
        n: [
            "razor"
        ],
        u: "1fa92",
        a: "12.0"
    },
    {
        n: [
            "lotion bottle"
        ],
        u: "1f9f4",
        a: "11.0"
    },
    {
        n: [
            "safety pin"
        ],
        u: "1f9f7",
        a: "11.0"
    },
    {
        n: [
            "broom"
        ],
        u: "1f9f9",
        a: "11.0"
    },
    {
        n: [
            "basket"
        ],
        u: "1f9fa",
        a: "11.0"
    },
    {
        n: [
            "roll of paper"
        ],
        u: "1f9fb",
        a: "11.0"
    },
    {
        n: [
            "bucket"
        ],
        u: "1faa3",
        a: "13.0"
    },
    {
        n: [
            "soap",
            "bar of soap"
        ],
        u: "1f9fc",
        a: "11.0"
    },
    {
        n: [
            "bubbles"
        ],
        u: "1fae7",
        a: "14.0"
    },
    {
        n: [
            "toothbrush"
        ],
        u: "1faa5",
        a: "13.0"
    },
    {
        n: [
            "sponge"
        ],
        u: "1f9fd",
        a: "11.0"
    },
    {
        n: [
            "fire extinguisher"
        ],
        u: "1f9ef",
        a: "11.0"
    },
    {
        n: [
            "shopping trolley"
        ],
        u: "1f6d2",
        a: "3.0"
    },
    {
        n: [
            "smoking",
            "smoking symbol"
        ],
        u: "1f6ac",
        a: "0.6"
    },
    {
        n: [
            "coffin"
        ],
        u: "26b0-fe0f",
        a: "1.0"
    },
    {
        n: [
            "headstone"
        ],
        u: "1faa6",
        a: "13.0"
    },
    {
        n: [
            "funeral urn"
        ],
        u: "26b1-fe0f",
        a: "1.0"
    },
    {
        n: [
            "moyai"
        ],
        u: "1f5ff",
        a: "0.6"
    },
    {
        n: [
            "placard"
        ],
        u: "1faa7",
        a: "13.0"
    },
    {
        n: [
            "identification card"
        ],
        u: "1faaa",
        a: "14.0"
    }
];
var $2785da2b7d7107bb$var$symbols = [
    {
        n: [
            "atm",
            "automated teller machine"
        ],
        u: "1f3e7",
        a: "0.6"
    },
    {
        n: [
            "put litter in its place",
            "put litter in its place symbol"
        ],
        u: "1f6ae",
        a: "1.0"
    },
    {
        n: [
            "potable water",
            "potable water symbol"
        ],
        u: "1f6b0",
        a: "1.0"
    },
    {
        n: [
            "wheelchair",
            "wheelchair symbol"
        ],
        u: "267f",
        a: "0.6"
    },
    {
        n: [
            "mens",
            "mens symbol"
        ],
        u: "1f6b9",
        a: "0.6"
    },
    {
        n: [
            "womens",
            "womens symbol"
        ],
        u: "1f6ba",
        a: "0.6"
    },
    {
        n: [
            "restroom"
        ],
        u: "1f6bb",
        a: "0.6"
    },
    {
        n: [
            "baby symbol"
        ],
        u: "1f6bc",
        a: "0.6"
    },
    {
        n: [
            "wc",
            "water closet"
        ],
        u: "1f6be",
        a: "0.6"
    },
    {
        n: [
            "passport control"
        ],
        u: "1f6c2",
        a: "1.0"
    },
    {
        n: [
            "customs"
        ],
        u: "1f6c3",
        a: "1.0"
    },
    {
        n: [
            "baggage claim"
        ],
        u: "1f6c4",
        a: "1.0"
    },
    {
        n: [
            "left luggage"
        ],
        u: "1f6c5",
        a: "1.0"
    },
    {
        n: [
            "warning",
            "warning sign"
        ],
        u: "26a0-fe0f",
        a: "0.6"
    },
    {
        n: [
            "children crossing"
        ],
        u: "1f6b8",
        a: "1.0"
    },
    {
        n: [
            "no entry"
        ],
        u: "26d4",
        a: "0.6"
    },
    {
        n: [
            "no entry sign"
        ],
        u: "1f6ab",
        a: "0.6"
    },
    {
        n: [
            "no bicycles"
        ],
        u: "1f6b3",
        a: "1.0"
    },
    {
        n: [
            "no smoking",
            "no smoking symbol"
        ],
        u: "1f6ad",
        a: "0.6"
    },
    {
        n: [
            "do not litter",
            "do not litter symbol"
        ],
        u: "1f6af",
        a: "1.0"
    },
    {
        n: [
            "non-potable water",
            "non-potable water symbol"
        ],
        u: "1f6b1",
        a: "1.0"
    },
    {
        n: [
            "no pedestrians"
        ],
        u: "1f6b7",
        a: "1.0"
    },
    {
        n: [
            "no mobile phones"
        ],
        u: "1f4f5",
        a: "1.0"
    },
    {
        n: [
            "underage",
            "no one under eighteen symbol"
        ],
        u: "1f51e",
        a: "0.6"
    },
    {
        n: [
            "radioactive",
            "radioactive sign"
        ],
        u: "2622-fe0f",
        a: "1.0"
    },
    {
        n: [
            "biohazard",
            "biohazard sign"
        ],
        u: "2623-fe0f",
        a: "1.0"
    },
    {
        n: [
            "arrow up",
            "upwards black arrow"
        ],
        u: "2b06-fe0f",
        a: "0.6"
    },
    {
        n: [
            "north east arrow",
            "arrow upper right"
        ],
        u: "2197-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow right",
            "black rightwards arrow"
        ],
        u: "27a1-fe0f",
        a: "0.6"
    },
    {
        n: [
            "south east arrow",
            "arrow lower right"
        ],
        u: "2198-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow down",
            "downwards black arrow"
        ],
        u: "2b07-fe0f",
        a: "0.6"
    },
    {
        n: [
            "south west arrow",
            "arrow lower left"
        ],
        u: "2199-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow left",
            "leftwards black arrow"
        ],
        u: "2b05-fe0f",
        a: "0.6"
    },
    {
        n: [
            "north west arrow",
            "arrow upper left"
        ],
        u: "2196-fe0f",
        a: "0.6"
    },
    {
        n: [
            "up down arrow",
            "arrow up down"
        ],
        u: "2195-fe0f",
        a: "0.6"
    },
    {
        n: [
            "left right arrow"
        ],
        u: "2194-fe0f",
        a: "0.6"
    },
    {
        n: [
            "leftwards arrow with hook"
        ],
        u: "21a9-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow right hook",
            "rightwards arrow with hook"
        ],
        u: "21aa-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow heading up",
            "arrow pointing rightwards then curving upwards"
        ],
        u: "2934-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrow heading down",
            "arrow pointing rightwards then curving downwards"
        ],
        u: "2935-fe0f",
        a: "0.6"
    },
    {
        n: [
            "arrows clockwise",
            "clockwise downwards and upwards open circle arrows"
        ],
        u: "1f503",
        a: "0.6"
    },
    {
        n: [
            "arrows counterclockwise",
            "anticlockwise downwards and upwards open circle arrows"
        ],
        u: "1f504",
        a: "1.0"
    },
    {
        n: [
            "back",
            "back with leftwards arrow above"
        ],
        u: "1f519",
        a: "0.6"
    },
    {
        n: [
            "end",
            "end with leftwards arrow above"
        ],
        u: "1f51a",
        a: "0.6"
    },
    {
        n: [
            "on",
            "on with exclamation mark with left right arrow above"
        ],
        u: "1f51b",
        a: "0.6"
    },
    {
        n: [
            "soon",
            "soon with rightwards arrow above"
        ],
        u: "1f51c",
        a: "0.6"
    },
    {
        n: [
            "top",
            "top with upwards arrow above"
        ],
        u: "1f51d",
        a: "0.6"
    },
    {
        n: [
            "place of worship"
        ],
        u: "1f6d0",
        a: "1.0"
    },
    {
        n: [
            "atom symbol"
        ],
        u: "269b-fe0f",
        a: "1.0"
    },
    {
        n: [
            "om",
            "om symbol"
        ],
        u: "1f549-fe0f",
        a: "0.7"
    },
    {
        n: [
            "star of david"
        ],
        u: "2721-fe0f",
        a: "0.7"
    },
    {
        n: [
            "wheel of dharma"
        ],
        u: "2638-fe0f",
        a: "0.7"
    },
    {
        n: [
            "yin yang"
        ],
        u: "262f-fe0f",
        a: "0.7"
    },
    {
        n: [
            "latin cross"
        ],
        u: "271d-fe0f",
        a: "0.7"
    },
    {
        n: [
            "orthodox cross"
        ],
        u: "2626-fe0f",
        a: "1.0"
    },
    {
        n: [
            "star and crescent"
        ],
        u: "262a-fe0f",
        a: "0.7"
    },
    {
        n: [
            "peace symbol"
        ],
        u: "262e-fe0f",
        a: "1.0"
    },
    {
        n: [
            "menorah with nine branches"
        ],
        u: "1f54e",
        a: "1.0"
    },
    {
        n: [
            "six pointed star",
            "six pointed star with middle dot"
        ],
        u: "1f52f",
        a: "0.6"
    },
    {
        n: [
            "aries"
        ],
        u: "2648",
        a: "0.6"
    },
    {
        n: [
            "taurus"
        ],
        u: "2649",
        a: "0.6"
    },
    {
        n: [
            "gemini"
        ],
        u: "264a",
        a: "0.6"
    },
    {
        n: [
            "cancer"
        ],
        u: "264b",
        a: "0.6"
    },
    {
        n: [
            "leo"
        ],
        u: "264c",
        a: "0.6"
    },
    {
        n: [
            "virgo"
        ],
        u: "264d",
        a: "0.6"
    },
    {
        n: [
            "libra"
        ],
        u: "264e",
        a: "0.6"
    },
    {
        n: [
            "scorpius"
        ],
        u: "264f",
        a: "0.6"
    },
    {
        n: [
            "sagittarius"
        ],
        u: "2650",
        a: "0.6"
    },
    {
        n: [
            "capricorn"
        ],
        u: "2651",
        a: "0.6"
    },
    {
        n: [
            "aquarius"
        ],
        u: "2652",
        a: "0.6"
    },
    {
        n: [
            "pisces"
        ],
        u: "2653",
        a: "0.6"
    },
    {
        n: [
            "ophiuchus"
        ],
        u: "26ce",
        a: "0.6"
    },
    {
        n: [
            "twisted rightwards arrows"
        ],
        u: "1f500",
        a: "1.0"
    },
    {
        n: [
            "repeat",
            "clockwise rightwards and leftwards open circle arrows"
        ],
        u: "1f501",
        a: "1.0"
    },
    {
        n: [
            "repeat one",
            "clockwise rightwards and leftwards open circle arrows with circled one overlay"
        ],
        u: "1f502",
        a: "1.0"
    },
    {
        n: [
            "arrow forward",
            "black right-pointing triangle"
        ],
        u: "25b6-fe0f",
        a: "0.6"
    },
    {
        n: [
            "fast forward",
            "black right-pointing double triangle"
        ],
        u: "23e9",
        a: "0.6"
    },
    {
        n: [
            "next track button",
            "black right pointing double triangle with vertical bar"
        ],
        u: "23ed-fe0f",
        a: "0.7"
    },
    {
        n: [
            "play or pause button",
            "black right pointing triangle with double vertical bar"
        ],
        u: "23ef-fe0f",
        a: "1.0"
    },
    {
        n: [
            "arrow backward",
            "black left-pointing triangle"
        ],
        u: "25c0-fe0f",
        a: "0.6"
    },
    {
        n: [
            "rewind",
            "black left-pointing double triangle"
        ],
        u: "23ea",
        a: "0.6"
    },
    {
        n: [
            "last track button",
            "black left pointing double triangle with vertical bar"
        ],
        u: "23ee-fe0f",
        a: "0.7"
    },
    {
        n: [
            "arrow up small",
            "up-pointing small red triangle"
        ],
        u: "1f53c",
        a: "0.6"
    },
    {
        n: [
            "arrow double up",
            "black up-pointing double triangle"
        ],
        u: "23eb",
        a: "0.6"
    },
    {
        n: [
            "arrow down small",
            "down-pointing small red triangle"
        ],
        u: "1f53d",
        a: "0.6"
    },
    {
        n: [
            "arrow double down",
            "black down-pointing double triangle"
        ],
        u: "23ec",
        a: "0.6"
    },
    {
        n: [
            "pause button",
            "double vertical bar"
        ],
        u: "23f8-fe0f",
        a: "0.7"
    },
    {
        n: [
            "stop button",
            "black square for stop"
        ],
        u: "23f9-fe0f",
        a: "0.7"
    },
    {
        n: [
            "record button",
            "black circle for record"
        ],
        u: "23fa-fe0f",
        a: "0.7"
    },
    {
        n: [
            "eject",
            "eject button"
        ],
        u: "23cf-fe0f",
        a: "1.0"
    },
    {
        n: [
            "cinema"
        ],
        u: "1f3a6",
        a: "0.6"
    },
    {
        n: [
            "low brightness",
            "low brightness symbol"
        ],
        u: "1f505",
        a: "1.0"
    },
    {
        n: [
            "high brightness",
            "high brightness symbol"
        ],
        u: "1f506",
        a: "1.0"
    },
    {
        n: [
            "signal strength",
            "antenna with bars"
        ],
        u: "1f4f6",
        a: "0.6"
    },
    {
        n: [
            "vibration mode"
        ],
        u: "1f4f3",
        a: "0.6"
    },
    {
        n: [
            "mobile phone off"
        ],
        u: "1f4f4",
        a: "0.6"
    },
    {
        n: [
            "female sign"
        ],
        u: "2640-fe0f",
        a: "4.0"
    },
    {
        n: [
            "male sign"
        ],
        u: "2642-fe0f",
        a: "4.0"
    },
    {
        n: [
            "transgender symbol"
        ],
        u: "26a7-fe0f",
        a: "13.0"
    },
    {
        n: [
            "heavy multiplication x"
        ],
        u: "2716-fe0f",
        a: "0.6"
    },
    {
        n: [
            "heavy plus sign"
        ],
        u: "2795",
        a: "0.6"
    },
    {
        n: [
            "heavy minus sign"
        ],
        u: "2796",
        a: "0.6"
    },
    {
        n: [
            "heavy division sign"
        ],
        u: "2797",
        a: "0.6"
    },
    {
        n: [
            "heavy equals sign"
        ],
        u: "1f7f0",
        a: "14.0"
    },
    {
        n: [
            "infinity"
        ],
        u: "267e-fe0f",
        a: "11.0"
    },
    {
        n: [
            "bangbang",
            "double exclamation mark"
        ],
        u: "203c-fe0f",
        a: "0.6"
    },
    {
        n: [
            "interrobang",
            "exclamation question mark"
        ],
        u: "2049-fe0f",
        a: "0.6"
    },
    {
        n: [
            "question",
            "black question mark ornament"
        ],
        u: "2753",
        a: "0.6"
    },
    {
        n: [
            "grey question",
            "white question mark ornament"
        ],
        u: "2754",
        a: "0.6"
    },
    {
        n: [
            "grey exclamation",
            "white exclamation mark ornament"
        ],
        u: "2755",
        a: "0.6"
    },
    {
        n: [
            "exclamation",
            "heavy exclamation mark",
            "heavy exclamation mark symbol"
        ],
        u: "2757",
        a: "0.6"
    },
    {
        n: [
            "wavy dash"
        ],
        u: "3030-fe0f",
        a: "0.6"
    },
    {
        n: [
            "currency exchange"
        ],
        u: "1f4b1",
        a: "0.6"
    },
    {
        n: [
            "heavy dollar sign"
        ],
        u: "1f4b2",
        a: "0.6"
    },
    {
        n: [
            "medical symbol",
            "staff of aesculapius"
        ],
        u: "2695-fe0f",
        a: "4.0"
    },
    {
        n: [
            "recycle",
            "black universal recycling symbol"
        ],
        u: "267b-fe0f",
        a: "0.6"
    },
    {
        n: [
            "fleur-de-lis",
            "fleur de lis"
        ],
        u: "269c-fe0f",
        a: "1.0"
    },
    {
        n: [
            "trident",
            "trident emblem"
        ],
        u: "1f531",
        a: "0.6"
    },
    {
        n: [
            "name badge"
        ],
        u: "1f4db",
        a: "0.6"
    },
    {
        n: [
            "beginner",
            "japanese symbol for beginner"
        ],
        u: "1f530",
        a: "0.6"
    },
    {
        n: [
            "o",
            "heavy large circle"
        ],
        u: "2b55",
        a: "0.6"
    },
    {
        n: [
            "white check mark",
            "white heavy check mark"
        ],
        u: "2705",
        a: "0.6"
    },
    {
        n: [
            "ballot box with check"
        ],
        u: "2611-fe0f",
        a: "0.6"
    },
    {
        n: [
            "heavy check mark"
        ],
        u: "2714-fe0f",
        a: "0.6"
    },
    {
        n: [
            "x",
            "cross mark"
        ],
        u: "274c",
        a: "0.6"
    },
    {
        n: [
            "negative squared cross mark"
        ],
        u: "274e",
        a: "0.6"
    },
    {
        n: [
            "curly loop"
        ],
        u: "27b0",
        a: "0.6"
    },
    {
        n: [
            "loop",
            "double curly loop"
        ],
        u: "27bf",
        a: "1.0"
    },
    {
        n: [
            "part alternation mark"
        ],
        u: "303d-fe0f",
        a: "0.6"
    },
    {
        n: [
            "eight spoked asterisk"
        ],
        u: "2733-fe0f",
        a: "0.6"
    },
    {
        n: [
            "eight pointed black star"
        ],
        u: "2734-fe0f",
        a: "0.6"
    },
    {
        n: [
            "sparkle"
        ],
        u: "2747-fe0f",
        a: "0.6"
    },
    {
        n: [
            "copyright",
            "copyright sign"
        ],
        u: "00a9-fe0f",
        a: "0.6"
    },
    {
        n: [
            "registered",
            "registered sign"
        ],
        u: "00ae-fe0f",
        a: "0.6"
    },
    {
        n: [
            "tm",
            "trade mark sign"
        ],
        u: "2122-fe0f",
        a: "0.6"
    },
    {
        n: [
            "hash",
            "hash key"
        ],
        u: "0023-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "keycap: *",
            "keycap star"
        ],
        u: "002a-fe0f-20e3",
        a: "2.0"
    },
    {
        n: [
            "zero",
            "keycap 0"
        ],
        u: "0030-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "one",
            "keycap 1"
        ],
        u: "0031-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "two",
            "keycap 2"
        ],
        u: "0032-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "three",
            "keycap 3"
        ],
        u: "0033-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "four",
            "keycap 4"
        ],
        u: "0034-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "five",
            "keycap 5"
        ],
        u: "0035-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "six",
            "keycap 6"
        ],
        u: "0036-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "seven",
            "keycap 7"
        ],
        u: "0037-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "eight",
            "keycap 8"
        ],
        u: "0038-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "nine",
            "keycap 9"
        ],
        u: "0039-fe0f-20e3",
        a: "0.6"
    },
    {
        n: [
            "keycap ten"
        ],
        u: "1f51f",
        a: "0.6"
    },
    {
        n: [
            "capital abcd",
            "input symbol for latin capital letters"
        ],
        u: "1f520",
        a: "0.6"
    },
    {
        n: [
            "abcd",
            "input symbol for latin small letters"
        ],
        u: "1f521",
        a: "0.6"
    },
    {
        n: [
            "1234",
            "input symbol for numbers"
        ],
        u: "1f522",
        a: "0.6"
    },
    {
        n: [
            "symbols",
            "input symbol for symbols"
        ],
        u: "1f523",
        a: "0.6"
    },
    {
        n: [
            "abc",
            "input symbol for latin letters"
        ],
        u: "1f524",
        a: "0.6"
    },
    {
        n: [
            "a",
            "negative squared latin capital letter a"
        ],
        u: "1f170-fe0f",
        a: "0.6"
    },
    {
        n: [
            "ab",
            "negative squared ab"
        ],
        u: "1f18e",
        a: "0.6"
    },
    {
        n: [
            "b",
            "negative squared latin capital letter b"
        ],
        u: "1f171-fe0f",
        a: "0.6"
    },
    {
        n: [
            "cl",
            "squared cl"
        ],
        u: "1f191",
        a: "0.6"
    },
    {
        n: [
            "cool",
            "squared cool"
        ],
        u: "1f192",
        a: "0.6"
    },
    {
        n: [
            "free",
            "squared free"
        ],
        u: "1f193",
        a: "0.6"
    },
    {
        n: [
            "information source"
        ],
        u: "2139-fe0f",
        a: "0.6"
    },
    {
        n: [
            "id",
            "squared id"
        ],
        u: "1f194",
        a: "0.6"
    },
    {
        n: [
            "m",
            "circled latin capital letter m"
        ],
        u: "24c2-fe0f",
        a: "0.6"
    },
    {
        n: [
            "new",
            "squared new"
        ],
        u: "1f195",
        a: "0.6"
    },
    {
        n: [
            "ng",
            "squared ng"
        ],
        u: "1f196",
        a: "0.6"
    },
    {
        n: [
            "o2",
            "negative squared latin capital letter o"
        ],
        u: "1f17e-fe0f",
        a: "0.6"
    },
    {
        n: [
            "ok",
            "squared ok"
        ],
        u: "1f197",
        a: "0.6"
    },
    {
        n: [
            "parking",
            "negative squared latin capital letter p"
        ],
        u: "1f17f-fe0f",
        a: "0.6"
    },
    {
        n: [
            "sos",
            "squared sos"
        ],
        u: "1f198",
        a: "0.6"
    },
    {
        n: [
            "up",
            "squared up with exclamation mark"
        ],
        u: "1f199",
        a: "0.6"
    },
    {
        n: [
            "vs",
            "squared vs"
        ],
        u: "1f19a",
        a: "0.6"
    },
    {
        n: [
            "koko",
            "squared katakana koko"
        ],
        u: "1f201",
        a: "0.6"
    },
    {
        n: [
            "sa",
            "squared katakana sa"
        ],
        u: "1f202-fe0f",
        a: "0.6"
    },
    {
        n: [
            "u6708",
            "squared cjk unified ideograph-6708"
        ],
        u: "1f237-fe0f",
        a: "0.6"
    },
    {
        n: [
            "u6709",
            "squared cjk unified ideograph-6709"
        ],
        u: "1f236",
        a: "0.6"
    },
    {
        n: [
            "u6307",
            "squared cjk unified ideograph-6307"
        ],
        u: "1f22f",
        a: "0.6"
    },
    {
        n: [
            "ideograph advantage",
            "circled ideograph advantage"
        ],
        u: "1f250",
        a: "0.6"
    },
    {
        n: [
            "u5272",
            "squared cjk unified ideograph-5272"
        ],
        u: "1f239",
        a: "0.6"
    },
    {
        n: [
            "u7121",
            "squared cjk unified ideograph-7121"
        ],
        u: "1f21a",
        a: "0.6"
    },
    {
        n: [
            "u7981",
            "squared cjk unified ideograph-7981"
        ],
        u: "1f232",
        a: "0.6"
    },
    {
        n: [
            "accept",
            "circled ideograph accept"
        ],
        u: "1f251",
        a: "0.6"
    },
    {
        n: [
            "u7533",
            "squared cjk unified ideograph-7533"
        ],
        u: "1f238",
        a: "0.6"
    },
    {
        n: [
            "u5408",
            "squared cjk unified ideograph-5408"
        ],
        u: "1f234",
        a: "0.6"
    },
    {
        n: [
            "u7a7a",
            "squared cjk unified ideograph-7a7a"
        ],
        u: "1f233",
        a: "0.6"
    },
    {
        n: [
            "congratulations",
            "circled ideograph congratulation"
        ],
        u: "3297-fe0f",
        a: "0.6"
    },
    {
        n: [
            "secret",
            "circled ideograph secret"
        ],
        u: "3299-fe0f",
        a: "0.6"
    },
    {
        n: [
            "u55b6",
            "squared cjk unified ideograph-55b6"
        ],
        u: "1f23a",
        a: "0.6"
    },
    {
        n: [
            "u6e80",
            "squared cjk unified ideograph-6e80"
        ],
        u: "1f235",
        a: "0.6"
    },
    {
        n: [
            "red circle",
            "large red circle"
        ],
        u: "1f534",
        a: "0.6"
    },
    {
        n: [
            "large orange circle"
        ],
        u: "1f7e0",
        a: "12.0"
    },
    {
        n: [
            "large yellow circle"
        ],
        u: "1f7e1",
        a: "12.0"
    },
    {
        n: [
            "large green circle"
        ],
        u: "1f7e2",
        a: "12.0"
    },
    {
        n: [
            "large blue circle"
        ],
        u: "1f535",
        a: "0.6"
    },
    {
        n: [
            "large purple circle"
        ],
        u: "1f7e3",
        a: "12.0"
    },
    {
        n: [
            "large brown circle"
        ],
        u: "1f7e4",
        a: "12.0"
    },
    {
        n: [
            "black circle",
            "medium black circle"
        ],
        u: "26ab",
        a: "0.6"
    },
    {
        n: [
            "white circle",
            "medium white circle"
        ],
        u: "26aa",
        a: "0.6"
    },
    {
        n: [
            "large red square"
        ],
        u: "1f7e5",
        a: "12.0"
    },
    {
        n: [
            "large orange square"
        ],
        u: "1f7e7",
        a: "12.0"
    },
    {
        n: [
            "large yellow square"
        ],
        u: "1f7e8",
        a: "12.0"
    },
    {
        n: [
            "large green square"
        ],
        u: "1f7e9",
        a: "12.0"
    },
    {
        n: [
            "large blue square"
        ],
        u: "1f7e6",
        a: "12.0"
    },
    {
        n: [
            "large purple square"
        ],
        u: "1f7ea",
        a: "12.0"
    },
    {
        n: [
            "large brown square"
        ],
        u: "1f7eb",
        a: "12.0"
    },
    {
        n: [
            "black large square"
        ],
        u: "2b1b",
        a: "0.6"
    },
    {
        n: [
            "white large square"
        ],
        u: "2b1c",
        a: "0.6"
    },
    {
        n: [
            "black medium square"
        ],
        u: "25fc-fe0f",
        a: "0.6"
    },
    {
        n: [
            "white medium square"
        ],
        u: "25fb-fe0f",
        a: "0.6"
    },
    {
        n: [
            "black medium small square"
        ],
        u: "25fe",
        a: "0.6"
    },
    {
        n: [
            "white medium small square"
        ],
        u: "25fd",
        a: "0.6"
    },
    {
        n: [
            "black small square"
        ],
        u: "25aa-fe0f",
        a: "0.6"
    },
    {
        n: [
            "white small square"
        ],
        u: "25ab-fe0f",
        a: "0.6"
    },
    {
        n: [
            "large orange diamond"
        ],
        u: "1f536",
        a: "0.6"
    },
    {
        n: [
            "large blue diamond"
        ],
        u: "1f537",
        a: "0.6"
    },
    {
        n: [
            "small orange diamond"
        ],
        u: "1f538",
        a: "0.6"
    },
    {
        n: [
            "small blue diamond"
        ],
        u: "1f539",
        a: "0.6"
    },
    {
        n: [
            "small red triangle",
            "up-pointing red triangle"
        ],
        u: "1f53a",
        a: "0.6"
    },
    {
        n: [
            "small red triangle down",
            "down-pointing red triangle"
        ],
        u: "1f53b",
        a: "0.6"
    },
    {
        n: [
            "diamond shape with a dot inside"
        ],
        u: "1f4a0",
        a: "0.6"
    },
    {
        n: [
            "radio button"
        ],
        u: "1f518",
        a: "0.6"
    },
    {
        n: [
            "white square button"
        ],
        u: "1f533",
        a: "0.6"
    },
    {
        n: [
            "black square button"
        ],
        u: "1f532",
        a: "0.6"
    }
];
var $2785da2b7d7107bb$var$flags = [
    {
        n: [
            "chequered flag",
            "checkered flag"
        ],
        u: "1f3c1",
        a: "0.6"
    },
    {
        n: [
            "triangular flag on post"
        ],
        u: "1f6a9",
        a: "0.6"
    },
    {
        n: [
            "crossed flags"
        ],
        u: "1f38c",
        a: "0.6"
    },
    {
        n: [
            "waving black flag"
        ],
        u: "1f3f4",
        a: "1.0"
    },
    {
        n: [
            "white flag",
            "waving white flag"
        ],
        u: "1f3f3-fe0f",
        a: "0.7"
    },
    {
        n: [
            "rainbow flag",
            "rainbow-flag"
        ],
        u: "1f3f3-fe0f-200d-1f308",
        a: "4.0"
    },
    {
        n: [
            "transgender flag"
        ],
        u: "1f3f3-fe0f-200d-26a7-fe0f",
        a: "13.0"
    },
    {
        n: [
            "pirate flag"
        ],
        u: "1f3f4-200d-2620-fe0f",
        a: "11.0"
    },
    {
        n: [
            "flag-ac",
            "ascension island flag"
        ],
        u: "1f1e6-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ad",
            "andorra flag"
        ],
        u: "1f1e6-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-ae",
            "united arab emirates flag"
        ],
        u: "1f1e6-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-af",
            "afghanistan flag"
        ],
        u: "1f1e6-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-ag",
            "antigua & barbuda flag"
        ],
        u: "1f1e6-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ai",
            "anguilla flag"
        ],
        u: "1f1e6-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-al",
            "albania flag"
        ],
        u: "1f1e6-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-am",
            "armenia flag"
        ],
        u: "1f1e6-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-ao",
            "angola flag"
        ],
        u: "1f1e6-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-aq",
            "antarctica flag"
        ],
        u: "1f1e6-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-ar",
            "argentina flag"
        ],
        u: "1f1e6-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-as",
            "american samoa flag"
        ],
        u: "1f1e6-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-at",
            "austria flag"
        ],
        u: "1f1e6-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-au",
            "australia flag"
        ],
        u: "1f1e6-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-aw",
            "aruba flag"
        ],
        u: "1f1e6-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-ax",
            "\xe5land islands flag"
        ],
        u: "1f1e6-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-az",
            "azerbaijan flag"
        ],
        u: "1f1e6-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ba",
            "bosnia & herzegovina flag"
        ],
        u: "1f1e7-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-bb",
            "barbados flag"
        ],
        u: "1f1e7-1f1e7",
        a: "2.0"
    },
    {
        n: [
            "flag-bd",
            "bangladesh flag"
        ],
        u: "1f1e7-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-be",
            "belgium flag"
        ],
        u: "1f1e7-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-bf",
            "burkina faso flag"
        ],
        u: "1f1e7-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-bg",
            "bulgaria flag"
        ],
        u: "1f1e7-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-bh",
            "bahrain flag"
        ],
        u: "1f1e7-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-bi",
            "burundi flag"
        ],
        u: "1f1e7-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-bj",
            "benin flag"
        ],
        u: "1f1e7-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-bl",
            "st. barth\xe9lemy flag"
        ],
        u: "1f1e7-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-bm",
            "bermuda flag"
        ],
        u: "1f1e7-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-bn",
            "brunei flag"
        ],
        u: "1f1e7-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-bo",
            "bolivia flag"
        ],
        u: "1f1e7-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-bq",
            "caribbean netherlands flag"
        ],
        u: "1f1e7-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-br",
            "brazil flag"
        ],
        u: "1f1e7-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-bs",
            "bahamas flag"
        ],
        u: "1f1e7-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-bt",
            "bhutan flag"
        ],
        u: "1f1e7-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-bv",
            "bouvet island flag"
        ],
        u: "1f1e7-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-bw",
            "botswana flag"
        ],
        u: "1f1e7-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-by",
            "belarus flag"
        ],
        u: "1f1e7-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-bz",
            "belize flag"
        ],
        u: "1f1e7-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ca",
            "canada flag"
        ],
        u: "1f1e8-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-cc",
            "cocos (keeling) islands flag"
        ],
        u: "1f1e8-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-cd",
            "congo - kinshasa flag"
        ],
        u: "1f1e8-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-cf",
            "central african republic flag"
        ],
        u: "1f1e8-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-cg",
            "congo - brazzaville flag"
        ],
        u: "1f1e8-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ch",
            "switzerland flag"
        ],
        u: "1f1e8-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-ci",
            "c\xf4te d’ivoire flag"
        ],
        u: "1f1e8-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-ck",
            "cook islands flag"
        ],
        u: "1f1e8-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-cl",
            "chile flag"
        ],
        u: "1f1e8-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-cm",
            "cameroon flag"
        ],
        u: "1f1e8-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "cn",
            "flag-cn",
            "china flag"
        ],
        u: "1f1e8-1f1f3",
        a: "0.6"
    },
    {
        n: [
            "flag-co",
            "colombia flag"
        ],
        u: "1f1e8-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-cp",
            "clipperton island flag"
        ],
        u: "1f1e8-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-cr",
            "costa rica flag"
        ],
        u: "1f1e8-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-cu",
            "cuba flag"
        ],
        u: "1f1e8-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-cv",
            "cape verde flag"
        ],
        u: "1f1e8-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-cw",
            "cura\xe7ao flag"
        ],
        u: "1f1e8-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-cx",
            "christmas island flag"
        ],
        u: "1f1e8-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-cy",
            "cyprus flag"
        ],
        u: "1f1e8-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-cz",
            "czechia flag"
        ],
        u: "1f1e8-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "de",
            "flag-de",
            "germany flag"
        ],
        u: "1f1e9-1f1ea",
        a: "0.6"
    },
    {
        n: [
            "flag-dg",
            "diego garcia flag"
        ],
        u: "1f1e9-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-dj",
            "djibouti flag"
        ],
        u: "1f1e9-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-dk",
            "denmark flag"
        ],
        u: "1f1e9-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-dm",
            "dominica flag"
        ],
        u: "1f1e9-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-do",
            "dominican republic flag"
        ],
        u: "1f1e9-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-dz",
            "algeria flag"
        ],
        u: "1f1e9-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ea",
            "ceuta & melilla flag"
        ],
        u: "1f1ea-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-ec",
            "ecuador flag"
        ],
        u: "1f1ea-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ee",
            "estonia flag"
        ],
        u: "1f1ea-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-eg",
            "egypt flag"
        ],
        u: "1f1ea-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-eh",
            "western sahara flag"
        ],
        u: "1f1ea-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-er",
            "eritrea flag"
        ],
        u: "1f1ea-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "es",
            "flag-es",
            "spain flag"
        ],
        u: "1f1ea-1f1f8",
        a: "0.6"
    },
    {
        n: [
            "flag-et",
            "ethiopia flag"
        ],
        u: "1f1ea-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-eu",
            "european union flag"
        ],
        u: "1f1ea-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-fi",
            "finland flag"
        ],
        u: "1f1eb-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-fj",
            "fiji flag"
        ],
        u: "1f1eb-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-fk",
            "falkland islands flag"
        ],
        u: "1f1eb-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-fm",
            "micronesia flag"
        ],
        u: "1f1eb-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-fo",
            "faroe islands flag"
        ],
        u: "1f1eb-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "fr",
            "flag-fr",
            "france flag"
        ],
        u: "1f1eb-1f1f7",
        a: "0.6"
    },
    {
        n: [
            "flag-ga",
            "gabon flag"
        ],
        u: "1f1ec-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "gb",
            "uk",
            "flag-gb",
            "united kingdom flag"
        ],
        u: "1f1ec-1f1e7",
        a: "0.6"
    },
    {
        n: [
            "flag-gd",
            "grenada flag"
        ],
        u: "1f1ec-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-ge",
            "georgia flag"
        ],
        u: "1f1ec-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-gf",
            "french guiana flag"
        ],
        u: "1f1ec-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-gg",
            "guernsey flag"
        ],
        u: "1f1ec-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-gh",
            "ghana flag"
        ],
        u: "1f1ec-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-gi",
            "gibraltar flag"
        ],
        u: "1f1ec-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-gl",
            "greenland flag"
        ],
        u: "1f1ec-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-gm",
            "gambia flag"
        ],
        u: "1f1ec-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-gn",
            "guinea flag"
        ],
        u: "1f1ec-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-gp",
            "guadeloupe flag"
        ],
        u: "1f1ec-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-gq",
            "equatorial guinea flag"
        ],
        u: "1f1ec-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-gr",
            "greece flag"
        ],
        u: "1f1ec-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-gs",
            "south georgia & south sandwich islands flag"
        ],
        u: "1f1ec-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-gt",
            "guatemala flag"
        ],
        u: "1f1ec-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-gu",
            "guam flag"
        ],
        u: "1f1ec-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-gw",
            "guinea-bissau flag"
        ],
        u: "1f1ec-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-gy",
            "guyana flag"
        ],
        u: "1f1ec-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-hk",
            "hong kong sar china flag"
        ],
        u: "1f1ed-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-hm",
            "heard & mcdonald islands flag"
        ],
        u: "1f1ed-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-hn",
            "honduras flag"
        ],
        u: "1f1ed-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-hr",
            "croatia flag"
        ],
        u: "1f1ed-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ht",
            "haiti flag"
        ],
        u: "1f1ed-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-hu",
            "hungary flag"
        ],
        u: "1f1ed-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-ic",
            "canary islands flag"
        ],
        u: "1f1ee-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-id",
            "indonesia flag"
        ],
        u: "1f1ee-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-ie",
            "ireland flag"
        ],
        u: "1f1ee-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-il",
            "israel flag"
        ],
        u: "1f1ee-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-im",
            "isle of man flag"
        ],
        u: "1f1ee-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-in",
            "india flag"
        ],
        u: "1f1ee-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-io",
            "british indian ocean territory flag"
        ],
        u: "1f1ee-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-iq",
            "iraq flag"
        ],
        u: "1f1ee-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-ir",
            "iran flag"
        ],
        u: "1f1ee-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-is",
            "iceland flag"
        ],
        u: "1f1ee-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "it",
            "flag-it",
            "italy flag"
        ],
        u: "1f1ee-1f1f9",
        a: "0.6"
    },
    {
        n: [
            "flag-je",
            "jersey flag"
        ],
        u: "1f1ef-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-jm",
            "jamaica flag"
        ],
        u: "1f1ef-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-jo",
            "jordan flag"
        ],
        u: "1f1ef-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "jp",
            "flag-jp",
            "japan flag"
        ],
        u: "1f1ef-1f1f5",
        a: "0.6"
    },
    {
        n: [
            "flag-ke",
            "kenya flag"
        ],
        u: "1f1f0-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-kg",
            "kyrgyzstan flag"
        ],
        u: "1f1f0-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-kh",
            "cambodia flag"
        ],
        u: "1f1f0-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-ki",
            "kiribati flag"
        ],
        u: "1f1f0-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-km",
            "comoros flag"
        ],
        u: "1f1f0-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-kn",
            "st. kitts & nevis flag"
        ],
        u: "1f1f0-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-kp",
            "north korea flag"
        ],
        u: "1f1f0-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "kr",
            "flag-kr",
            "south korea flag"
        ],
        u: "1f1f0-1f1f7",
        a: "0.6"
    },
    {
        n: [
            "flag-kw",
            "kuwait flag"
        ],
        u: "1f1f0-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-ky",
            "cayman islands flag"
        ],
        u: "1f1f0-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-kz",
            "kazakhstan flag"
        ],
        u: "1f1f0-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-la",
            "laos flag"
        ],
        u: "1f1f1-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-lb",
            "lebanon flag"
        ],
        u: "1f1f1-1f1e7",
        a: "2.0"
    },
    {
        n: [
            "flag-lc",
            "st. lucia flag"
        ],
        u: "1f1f1-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-li",
            "liechtenstein flag"
        ],
        u: "1f1f1-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-lk",
            "sri lanka flag"
        ],
        u: "1f1f1-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-lr",
            "liberia flag"
        ],
        u: "1f1f1-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ls",
            "lesotho flag"
        ],
        u: "1f1f1-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-lt",
            "lithuania flag"
        ],
        u: "1f1f1-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-lu",
            "luxembourg flag"
        ],
        u: "1f1f1-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-lv",
            "latvia flag"
        ],
        u: "1f1f1-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-ly",
            "libya flag"
        ],
        u: "1f1f1-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-ma",
            "morocco flag"
        ],
        u: "1f1f2-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-mc",
            "monaco flag"
        ],
        u: "1f1f2-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-md",
            "moldova flag"
        ],
        u: "1f1f2-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-me",
            "montenegro flag"
        ],
        u: "1f1f2-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-mf",
            "st. martin flag"
        ],
        u: "1f1f2-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-mg",
            "madagascar flag"
        ],
        u: "1f1f2-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-mh",
            "marshall islands flag"
        ],
        u: "1f1f2-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-mk",
            "north macedonia flag"
        ],
        u: "1f1f2-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-ml",
            "mali flag"
        ],
        u: "1f1f2-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-mm",
            "myanmar (burma) flag"
        ],
        u: "1f1f2-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-mn",
            "mongolia flag"
        ],
        u: "1f1f2-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-mo",
            "macao sar china flag"
        ],
        u: "1f1f2-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-mp",
            "northern mariana islands flag"
        ],
        u: "1f1f2-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-mq",
            "martinique flag"
        ],
        u: "1f1f2-1f1f6",
        a: "2.0"
    },
    {
        n: [
            "flag-mr",
            "mauritania flag"
        ],
        u: "1f1f2-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ms",
            "montserrat flag"
        ],
        u: "1f1f2-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-mt",
            "malta flag"
        ],
        u: "1f1f2-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-mu",
            "mauritius flag"
        ],
        u: "1f1f2-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-mv",
            "maldives flag"
        ],
        u: "1f1f2-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-mw",
            "malawi flag"
        ],
        u: "1f1f2-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-mx",
            "mexico flag"
        ],
        u: "1f1f2-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-my",
            "malaysia flag"
        ],
        u: "1f1f2-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-mz",
            "mozambique flag"
        ],
        u: "1f1f2-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-na",
            "namibia flag"
        ],
        u: "1f1f3-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-nc",
            "new caledonia flag"
        ],
        u: "1f1f3-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ne",
            "niger flag"
        ],
        u: "1f1f3-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-nf",
            "norfolk island flag"
        ],
        u: "1f1f3-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-ng",
            "nigeria flag"
        ],
        u: "1f1f3-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ni",
            "nicaragua flag"
        ],
        u: "1f1f3-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-nl",
            "netherlands flag"
        ],
        u: "1f1f3-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-no",
            "norway flag"
        ],
        u: "1f1f3-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-np",
            "nepal flag"
        ],
        u: "1f1f3-1f1f5",
        a: "2.0"
    },
    {
        n: [
            "flag-nr",
            "nauru flag"
        ],
        u: "1f1f3-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-nu",
            "niue flag"
        ],
        u: "1f1f3-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-nz",
            "new zealand flag"
        ],
        u: "1f1f3-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-om",
            "oman flag"
        ],
        u: "1f1f4-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-pa",
            "panama flag"
        ],
        u: "1f1f5-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-pe",
            "peru flag"
        ],
        u: "1f1f5-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-pf",
            "french polynesia flag"
        ],
        u: "1f1f5-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-pg",
            "papua new guinea flag"
        ],
        u: "1f1f5-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-ph",
            "philippines flag"
        ],
        u: "1f1f5-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-pk",
            "pakistan flag"
        ],
        u: "1f1f5-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-pl",
            "poland flag"
        ],
        u: "1f1f5-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-pm",
            "st. pierre & miquelon flag"
        ],
        u: "1f1f5-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-pn",
            "pitcairn islands flag"
        ],
        u: "1f1f5-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-pr",
            "puerto rico flag"
        ],
        u: "1f1f5-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ps",
            "palestinian territories flag"
        ],
        u: "1f1f5-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-pt",
            "portugal flag"
        ],
        u: "1f1f5-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-pw",
            "palau flag"
        ],
        u: "1f1f5-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-py",
            "paraguay flag"
        ],
        u: "1f1f5-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-qa",
            "qatar flag"
        ],
        u: "1f1f6-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-re",
            "r\xe9union flag"
        ],
        u: "1f1f7-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-ro",
            "romania flag"
        ],
        u: "1f1f7-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-rs",
            "serbia flag"
        ],
        u: "1f1f7-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "ru",
            "flag-ru",
            "russia flag"
        ],
        u: "1f1f7-1f1fa",
        a: "0.6"
    },
    {
        n: [
            "flag-rw",
            "rwanda flag"
        ],
        u: "1f1f7-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-sa",
            "saudi arabia flag"
        ],
        u: "1f1f8-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-sb",
            "solomon islands flag"
        ],
        u: "1f1f8-1f1e7",
        a: "2.0"
    },
    {
        n: [
            "flag-sc",
            "seychelles flag"
        ],
        u: "1f1f8-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-sd",
            "sudan flag"
        ],
        u: "1f1f8-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-se",
            "sweden flag"
        ],
        u: "1f1f8-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-sg",
            "singapore flag"
        ],
        u: "1f1f8-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-sh",
            "st. helena flag"
        ],
        u: "1f1f8-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-si",
            "slovenia flag"
        ],
        u: "1f1f8-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-sj",
            "svalbard & jan mayen flag"
        ],
        u: "1f1f8-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-sk",
            "slovakia flag"
        ],
        u: "1f1f8-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-sl",
            "sierra leone flag"
        ],
        u: "1f1f8-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-sm",
            "san marino flag"
        ],
        u: "1f1f8-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-sn",
            "senegal flag"
        ],
        u: "1f1f8-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-so",
            "somalia flag"
        ],
        u: "1f1f8-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-sr",
            "suriname flag"
        ],
        u: "1f1f8-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-ss",
            "south sudan flag"
        ],
        u: "1f1f8-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-st",
            "s\xe3o tom\xe9 & pr\xedncipe flag"
        ],
        u: "1f1f8-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-sv",
            "el salvador flag"
        ],
        u: "1f1f8-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-sx",
            "sint maarten flag"
        ],
        u: "1f1f8-1f1fd",
        a: "2.0"
    },
    {
        n: [
            "flag-sy",
            "syria flag"
        ],
        u: "1f1f8-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-sz",
            "eswatini flag"
        ],
        u: "1f1f8-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ta",
            "tristan da cunha flag"
        ],
        u: "1f1f9-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-tc",
            "turks & caicos islands flag"
        ],
        u: "1f1f9-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-td",
            "chad flag"
        ],
        u: "1f1f9-1f1e9",
        a: "2.0"
    },
    {
        n: [
            "flag-tf",
            "french southern territories flag"
        ],
        u: "1f1f9-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-tg",
            "togo flag"
        ],
        u: "1f1f9-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-th",
            "thailand flag"
        ],
        u: "1f1f9-1f1ed",
        a: "2.0"
    },
    {
        n: [
            "flag-tj",
            "tajikistan flag"
        ],
        u: "1f1f9-1f1ef",
        a: "2.0"
    },
    {
        n: [
            "flag-tk",
            "tokelau flag"
        ],
        u: "1f1f9-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-tl",
            "timor-leste flag"
        ],
        u: "1f1f9-1f1f1",
        a: "2.0"
    },
    {
        n: [
            "flag-tm",
            "turkmenistan flag"
        ],
        u: "1f1f9-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-tn",
            "tunisia flag"
        ],
        u: "1f1f9-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-to",
            "tonga flag"
        ],
        u: "1f1f9-1f1f4",
        a: "2.0"
    },
    {
        n: [
            "flag-tr",
            "turkey flag"
        ],
        u: "1f1f9-1f1f7",
        a: "2.0"
    },
    {
        n: [
            "flag-tt",
            "trinidad & tobago flag"
        ],
        u: "1f1f9-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-tv",
            "tuvalu flag"
        ],
        u: "1f1f9-1f1fb",
        a: "2.0"
    },
    {
        n: [
            "flag-tw",
            "taiwan flag"
        ],
        u: "1f1f9-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "flag-tz",
            "tanzania flag"
        ],
        u: "1f1f9-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-ua",
            "ukraine flag"
        ],
        u: "1f1fa-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-ug",
            "uganda flag"
        ],
        u: "1f1fa-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-um",
            "u.s. outlying islands flag"
        ],
        u: "1f1fa-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-un",
            "united nations flag"
        ],
        u: "1f1fa-1f1f3",
        a: "4.0"
    },
    {
        n: [
            "us",
            "flag-us",
            "united states flag"
        ],
        u: "1f1fa-1f1f8",
        a: "0.6"
    },
    {
        n: [
            "flag-uy",
            "uruguay flag"
        ],
        u: "1f1fa-1f1fe",
        a: "2.0"
    },
    {
        n: [
            "flag-uz",
            "uzbekistan flag"
        ],
        u: "1f1fa-1f1ff",
        a: "2.0"
    },
    {
        n: [
            "flag-va",
            "vatican city flag"
        ],
        u: "1f1fb-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-vc",
            "st. vincent & grenadines flag"
        ],
        u: "1f1fb-1f1e8",
        a: "2.0"
    },
    {
        n: [
            "flag-ve",
            "venezuela flag"
        ],
        u: "1f1fb-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-vg",
            "british virgin islands flag"
        ],
        u: "1f1fb-1f1ec",
        a: "2.0"
    },
    {
        n: [
            "flag-vi",
            "u.s. virgin islands flag"
        ],
        u: "1f1fb-1f1ee",
        a: "2.0"
    },
    {
        n: [
            "flag-vn",
            "vietnam flag"
        ],
        u: "1f1fb-1f1f3",
        a: "2.0"
    },
    {
        n: [
            "flag-vu",
            "vanuatu flag"
        ],
        u: "1f1fb-1f1fa",
        a: "2.0"
    },
    {
        n: [
            "flag-wf",
            "wallis & futuna flag"
        ],
        u: "1f1fc-1f1eb",
        a: "2.0"
    },
    {
        n: [
            "flag-ws",
            "samoa flag"
        ],
        u: "1f1fc-1f1f8",
        a: "2.0"
    },
    {
        n: [
            "flag-xk",
            "kosovo flag"
        ],
        u: "1f1fd-1f1f0",
        a: "2.0"
    },
    {
        n: [
            "flag-ye",
            "yemen flag"
        ],
        u: "1f1fe-1f1ea",
        a: "2.0"
    },
    {
        n: [
            "flag-yt",
            "mayotte flag"
        ],
        u: "1f1fe-1f1f9",
        a: "2.0"
    },
    {
        n: [
            "flag-za",
            "south africa flag"
        ],
        u: "1f1ff-1f1e6",
        a: "2.0"
    },
    {
        n: [
            "flag-zm",
            "zambia flag"
        ],
        u: "1f1ff-1f1f2",
        a: "2.0"
    },
    {
        n: [
            "flag-zw",
            "zimbabwe flag"
        ],
        u: "1f1ff-1f1fc",
        a: "2.0"
    },
    {
        n: [
            "england flag",
            "flag-england"
        ],
        u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
        a: "5.0"
    },
    {
        n: [
            "scotland flag",
            "flag-scotland"
        ],
        u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
        a: "5.0"
    },
    {
        n: [
            "wales flag",
            "flag-wales"
        ],
        u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
        a: "5.0"
    }
];
var $2785da2b7d7107bb$var$emojis = {
    custom: $2785da2b7d7107bb$var$custom,
    smileys_people: $2785da2b7d7107bb$var$smileys_people,
    animals_nature: $2785da2b7d7107bb$var$animals_nature,
    food_drink: $2785da2b7d7107bb$var$food_drink,
    travel_places: $2785da2b7d7107bb$var$travel_places,
    activities: $2785da2b7d7107bb$var$activities,
    objects: $2785da2b7d7107bb$var$objects,
    symbols: $2785da2b7d7107bb$var$symbols,
    flags: $2785da2b7d7107bb$var$flags
};
var $2785da2b7d7107bb$var$skinToneVariations = [
    $2785da2b7d7107bb$export$8502e178dd60af86.NEUTRAL,
    $2785da2b7d7107bb$export$8502e178dd60af86.LIGHT,
    $2785da2b7d7107bb$export$8502e178dd60af86.MEDIUM_LIGHT,
    $2785da2b7d7107bb$export$8502e178dd60af86.MEDIUM,
    $2785da2b7d7107bb$export$8502e178dd60af86.MEDIUM_DARK,
    $2785da2b7d7107bb$export$8502e178dd60af86.DARK
];
var $2785da2b7d7107bb$var$skinTonesNamed = /*#__PURE__*/ Object.entries($2785da2b7d7107bb$export$8502e178dd60af86).reduce(function(acc, _ref) {
    var key = _ref[0], value = _ref[1];
    acc[value] = key;
    return acc;
}, {});
var $2785da2b7d7107bb$var$skinTonesMapped = /*#__PURE__*/ $2785da2b7d7107bb$var$skinToneVariations.reduce(function(mapped, skinTone) {
    var _Object$assign;
    return Object.assign(mapped, (_Object$assign = {}, _Object$assign[skinTone] = skinTone, _Object$assign));
}, {});
var $2785da2b7d7107bb$var$EmojiProperties;
(function(EmojiProperties) {
    EmojiProperties["name"] = "n";
    EmojiProperties["unified"] = "u";
    EmojiProperties["variations"] = "v";
    EmojiProperties["added_in"] = "a";
    EmojiProperties["imgUrl"] = "imgUrl";
})($2785da2b7d7107bb$var$EmojiProperties || ($2785da2b7d7107bb$var$EmojiProperties = {}));
var $2785da2b7d7107bb$var$alphaNumericEmojiIndex = {};
setTimeout(function() {
    $2785da2b7d7107bb$var$allEmojis.reduce(function(searchIndex, emoji) {
        $2785da2b7d7107bb$var$indexEmoji(emoji);
        return searchIndex;
    }, $2785da2b7d7107bb$var$alphaNumericEmojiIndex);
});
function $2785da2b7d7107bb$var$indexEmoji(emoji) {
    var joinedNameString = $2785da2b7d7107bb$var$emojiNames(emoji).flat().join("").toLowerCase().replace(/[^a-zA-Z\d]/g, "").split("");
    joinedNameString.forEach(function(_char) {
        var _alphaNumericEmojiInd;
        $2785da2b7d7107bb$var$alphaNumericEmojiIndex[_char] = (_alphaNumericEmojiInd = $2785da2b7d7107bb$var$alphaNumericEmojiIndex[_char]) != null ? _alphaNumericEmojiInd : {};
        $2785da2b7d7107bb$var$alphaNumericEmojiIndex[_char][$2785da2b7d7107bb$var$emojiUnified(emoji)] = emoji;
    });
}
function $2785da2b7d7107bb$var$emojiNames(emoji) {
    var _emoji$EmojiPropertie;
    return (_emoji$EmojiPropertie = emoji[$2785da2b7d7107bb$var$EmojiProperties.name]) != null ? _emoji$EmojiPropertie : [];
}
function $2785da2b7d7107bb$var$addedIn(emoji) {
    return parseFloat(emoji[$2785da2b7d7107bb$var$EmojiProperties.added_in]);
}
function $2785da2b7d7107bb$var$emojiName(emoji) {
    if (!emoji) return "";
    return $2785da2b7d7107bb$var$emojiNames(emoji)[0];
}
function $2785da2b7d7107bb$var$unifiedWithoutSkinTone(unified) {
    var splat = unified.split("-");
    var _splat$splice = splat.splice(1, 1), skinTone = _splat$splice[0];
    if ($2785da2b7d7107bb$var$skinTonesMapped[skinTone]) return splat.join("-");
    return unified;
}
function $2785da2b7d7107bb$var$emojiUnified(emoji, skinTone) {
    var _emojiVariationUnifie;
    var unified = emoji[$2785da2b7d7107bb$var$EmojiProperties.unified];
    if (!skinTone || !$2785da2b7d7107bb$var$emojiHasVariations(emoji)) return unified;
    return (_emojiVariationUnifie = $2785da2b7d7107bb$var$emojiVariationUnified(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}
function $2785da2b7d7107bb$var$emojisByCategory(category) {
    var _emojis$category;
    // @ts-ignore
    return (_emojis$category = $2785da2b7d7107bb$var$emojis == null ? void 0 : $2785da2b7d7107bb$var$emojis[category]) != null ? _emojis$category : [];
} // WARNING: DO NOT USE DIRECTLY
function $2785da2b7d7107bb$var$emojiUrlByUnified(unified, emojiStyle) {
    return "" + $2785da2b7d7107bb$var$cdnUrl(emojiStyle) + unified + ".png";
}
function $2785da2b7d7107bb$var$emojiVariations(emoji) {
    var _emoji$EmojiPropertie2;
    return (_emoji$EmojiPropertie2 = emoji[$2785da2b7d7107bb$var$EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function $2785da2b7d7107bb$var$emojiHasVariations(emoji) {
    return $2785da2b7d7107bb$var$emojiVariations(emoji).length > 0;
}
function $2785da2b7d7107bb$var$emojiVariationUnified(emoji, skinTone) {
    return skinTone ? $2785da2b7d7107bb$var$emojiVariations(emoji).find(function(variation) {
        return variation.includes(skinTone);
    }) : $2785da2b7d7107bb$var$emojiUnified(emoji);
}
function $2785da2b7d7107bb$var$emojiByUnified(unified) {
    if (!unified) return;
    if ($2785da2b7d7107bb$var$allEmojisByUnified[unified]) return $2785da2b7d7107bb$var$allEmojisByUnified[unified];
    var withoutSkinTone = $2785da2b7d7107bb$var$unifiedWithoutSkinTone(unified);
    return $2785da2b7d7107bb$var$allEmojisByUnified[withoutSkinTone];
}
var $2785da2b7d7107bb$var$allEmojis = /*#__PURE__*/ Object.values($2785da2b7d7107bb$var$emojis).flat();
function $2785da2b7d7107bb$var$addCustomEmojis(customEmojis) {
    customEmojis.forEach(function(emoji) {
        var emojiData = $2785da2b7d7107bb$var$customToRegularEmoji(emoji);
        if ($2785da2b7d7107bb$var$allEmojisByUnified[emojiData[$2785da2b7d7107bb$var$EmojiProperties.unified]]) return;
        $2785da2b7d7107bb$var$allEmojis.push(emojiData);
        $2785da2b7d7107bb$var$allEmojisByUnified[emojiData[$2785da2b7d7107bb$var$EmojiProperties.unified]] = emojiData;
        $2785da2b7d7107bb$var$emojis[$2785da2b7d7107bb$export$e1e795cef0e670e6.CUSTOM].push(emojiData);
        $2785da2b7d7107bb$var$indexEmoji(emojiData);
    });
}
function $2785da2b7d7107bb$var$customToRegularEmoji(emoji) {
    var _ref;
    return _ref = {}, _ref[$2785da2b7d7107bb$var$EmojiProperties.name] = emoji.names.map(function(name) {
        return name.toLowerCase();
    }), _ref[$2785da2b7d7107bb$var$EmojiProperties.unified] = emoji.id.toLowerCase(), _ref[$2785da2b7d7107bb$var$EmojiProperties.added_in] = "0", _ref[$2785da2b7d7107bb$var$EmojiProperties.imgUrl] = emoji.imgUrl, _ref;
}
var $2785da2b7d7107bb$var$allEmojisByUnified = {};
setTimeout(function() {
    $2785da2b7d7107bb$var$allEmojis.reduce(function(allEmojis, Emoji) {
        allEmojis[$2785da2b7d7107bb$var$emojiUnified(Emoji)] = Emoji;
        return allEmojis;
    }, $2785da2b7d7107bb$var$allEmojisByUnified);
});
function $2785da2b7d7107bb$var$activeVariationFromUnified(unified) {
    var _unified$split = unified.split("-"), suspectedSkinTone = _unified$split[1];
    return $2785da2b7d7107bb$var$skinToneVariations.includes(suspectedSkinTone) ? suspectedSkinTone : null;
}
var $2785da2b7d7107bb$var$KNOWN_FAILING_EMOJIS = [
    "2640-fe0f",
    "2642-fe0f",
    "2695-fe0f"
];
var $2785da2b7d7107bb$var$DEFAULT_SEARCH_PLACEHOLDER = "Search";
function $2785da2b7d7107bb$var$mergeConfig(userConfig) {
    var _userConfig$previewCo, _config$customEmojis;
    if (userConfig === void 0) userConfig = {};
    var base = $2785da2b7d7107bb$var$basePickerConfig();
    var previewConfig = Object.assign(base.previewConfig, (_userConfig$previewCo = userConfig.previewConfig) != null ? _userConfig$previewCo : {});
    var config = Object.assign(base, userConfig);
    var categories = $2785da2b7d7107bb$var$mergeCategoriesConfig(userConfig.categories, {
        suggestionMode: config.suggestedEmojisMode
    });
    $2785da2b7d7107bb$var$addCustomEmojis((_config$customEmojis = config.customEmojis) != null ? _config$customEmojis : []);
    var skinTonePickerLocation = config.searchDisabled ? $2785da2b7d7107bb$export$da9a330bf5ab5dfb.PREVIEW : config.skinTonePickerLocation;
    return $2785da2b7d7107bb$var$_extends({}, config, {
        categories: categories,
        previewConfig: previewConfig,
        skinTonePickerLocation: skinTonePickerLocation
    });
}
function $2785da2b7d7107bb$var$basePickerConfig() {
    return {
        autoFocusSearch: true,
        categories: $2785da2b7d7107bb$var$baseCategoriesConfig(),
        customEmojis: [],
        defaultSkinTone: $2785da2b7d7107bb$export$8502e178dd60af86.NEUTRAL,
        emojiStyle: $2785da2b7d7107bb$export$92260a1a02147e89.APPLE,
        emojiVersion: null,
        getEmojiUrl: $2785da2b7d7107bb$var$emojiUrlByUnified,
        height: 450,
        lazyLoadEmojis: false,
        onEmojiClick: function defaultOnClickHandler(// eslint-disable-next-line @typescript-eslint/no-unused-vars
        emoji, // eslint-disable-next-line @typescript-eslint/no-unused-vars
        event) {},
        previewConfig: $2785da2b7d7107bb$var$_extends({}, $2785da2b7d7107bb$var$basePreviewConfig),
        searchDisabled: false,
        searchPlaceHolder: $2785da2b7d7107bb$var$DEFAULT_SEARCH_PLACEHOLDER,
        searchPlaceholder: $2785da2b7d7107bb$var$DEFAULT_SEARCH_PLACEHOLDER,
        skinTonePickerLocation: $2785da2b7d7107bb$export$da9a330bf5ab5dfb.SEARCH,
        skinTonesDisabled: false,
        suggestedEmojisMode: $2785da2b7d7107bb$export$599319363ef7770d.FREQUENT,
        theme: $2785da2b7d7107bb$export$14faa19a0f3bbeb2.LIGHT,
        unicodeToHide: new Set($2785da2b7d7107bb$var$KNOWN_FAILING_EMOJIS),
        width: 350
    };
}
var $2785da2b7d7107bb$var$basePreviewConfig = {
    defaultEmoji: "1f60a",
    defaultCaption: "What's your mood?",
    showPreview: true
};
var $2785da2b7d7107bb$var$_excluded = [
    "children"
];
var $2785da2b7d7107bb$var$ConfigContext = /*#__PURE__*/ (0, $5VC2c.createContext)(/*#__PURE__*/ $2785da2b7d7107bb$var$basePickerConfig());
function $2785da2b7d7107bb$var$PickerConfigProvider(_ref) {
    var children = _ref.children, config = $2785da2b7d7107bb$var$_objectWithoutPropertiesLoose(_ref, $2785da2b7d7107bb$var$_excluded);
    var _React$useState = (0, $ir4bw.useState)(function() {
        return $2785da2b7d7107bb$var$mergeConfig(config);
    }), mergedConfig = _React$useState[0];
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ConfigContext.Provider, {
        value: mergedConfig
    }, children);
}
function $2785da2b7d7107bb$var$usePickerConfig() {
    return (0, $ir4bw.useContext)($2785da2b7d7107bb$var$ConfigContext);
}
function $2785da2b7d7107bb$var$useSearchPlaceHolderConfig() {
    var _find;
    var _usePickerConfig = $2785da2b7d7107bb$var$usePickerConfig(), searchPlaceHolder = _usePickerConfig.searchPlaceHolder, searchPlaceholder = _usePickerConfig.searchPlaceholder;
    return (_find = [
        searchPlaceHolder,
        searchPlaceholder
    ].find(function(p) {
        return p !== $2785da2b7d7107bb$var$DEFAULT_SEARCH_PLACEHOLDER;
    })) != null ? _find : $2785da2b7d7107bb$var$DEFAULT_SEARCH_PLACEHOLDER;
}
function $2785da2b7d7107bb$var$useDefaultSkinToneConfig() {
    var _usePickerConfig2 = $2785da2b7d7107bb$var$usePickerConfig(), defaultSkinTone = _usePickerConfig2.defaultSkinTone;
    return defaultSkinTone;
}
function $2785da2b7d7107bb$var$useSkinTonesDisabledConfig() {
    var _usePickerConfig3 = $2785da2b7d7107bb$var$usePickerConfig(), skinTonesDisabled = _usePickerConfig3.skinTonesDisabled;
    return skinTonesDisabled;
}
function $2785da2b7d7107bb$var$useEmojiStyleConfig() {
    var _usePickerConfig4 = $2785da2b7d7107bb$var$usePickerConfig(), emojiStyle = _usePickerConfig4.emojiStyle;
    return emojiStyle;
}
function $2785da2b7d7107bb$var$useAutoFocusSearchConfig() {
    var _usePickerConfig5 = $2785da2b7d7107bb$var$usePickerConfig(), autoFocusSearch = _usePickerConfig5.autoFocusSearch;
    return autoFocusSearch;
}
function $2785da2b7d7107bb$var$useCategoriesConfig() {
    var _usePickerConfig6 = $2785da2b7d7107bb$var$usePickerConfig(), categories = _usePickerConfig6.categories;
    return categories;
}
function $2785da2b7d7107bb$var$useCustomEmojisConfig() {
    var _usePickerConfig7 = $2785da2b7d7107bb$var$usePickerConfig(), customEmojis = _usePickerConfig7.customEmojis;
    return customEmojis;
}
function $2785da2b7d7107bb$var$useOnEmojiClickConfig() {
    var _usePickerConfig8 = $2785da2b7d7107bb$var$usePickerConfig(), onEmojiClick = _usePickerConfig8.onEmojiClick;
    return onEmojiClick;
}
function $2785da2b7d7107bb$var$usePreviewConfig() {
    var _usePickerConfig9 = $2785da2b7d7107bb$var$usePickerConfig(), previewConfig = _usePickerConfig9.previewConfig;
    return previewConfig;
}
function $2785da2b7d7107bb$var$useThemeConfig() {
    var _usePickerConfig10 = $2785da2b7d7107bb$var$usePickerConfig(), theme = _usePickerConfig10.theme;
    if (theme === $2785da2b7d7107bb$export$14faa19a0f3bbeb2.AUTO) return $2785da2b7d7107bb$var$isSystemDarkTheme() ? $2785da2b7d7107bb$export$14faa19a0f3bbeb2.DARK : $2785da2b7d7107bb$export$14faa19a0f3bbeb2.LIGHT;
    return theme;
}
function $2785da2b7d7107bb$var$useSuggestedEmojisModeConfig() {
    var _usePickerConfig11 = $2785da2b7d7107bb$var$usePickerConfig(), suggestedEmojisMode = _usePickerConfig11.suggestedEmojisMode;
    return suggestedEmojisMode;
}
function $2785da2b7d7107bb$var$useLazyLoadEmojisConfig() {
    var _usePickerConfig12 = $2785da2b7d7107bb$var$usePickerConfig(), lazyLoadEmojis = _usePickerConfig12.lazyLoadEmojis;
    return lazyLoadEmojis;
}
function $2785da2b7d7107bb$var$usePickerSizeConfig() {
    var _usePickerConfig13 = $2785da2b7d7107bb$var$usePickerConfig(), height = _usePickerConfig13.height, width = _usePickerConfig13.width;
    return {
        height: $2785da2b7d7107bb$var$getDimension(height),
        width: $2785da2b7d7107bb$var$getDimension(width)
    };
}
function $2785da2b7d7107bb$var$useEmojiVersionConfig() {
    var _usePickerConfig14 = $2785da2b7d7107bb$var$usePickerConfig(), emojiVersion = _usePickerConfig14.emojiVersion;
    return emojiVersion;
}
function $2785da2b7d7107bb$var$useSearchDisabledConfig() {
    var _usePickerConfig15 = $2785da2b7d7107bb$var$usePickerConfig(), searchDisabled = _usePickerConfig15.searchDisabled;
    return searchDisabled;
}
function $2785da2b7d7107bb$var$useSkinTonePickerLocationConfig() {
    var _usePickerConfig16 = $2785da2b7d7107bb$var$usePickerConfig(), skinTonePickerLocation = _usePickerConfig16.skinTonePickerLocation;
    return skinTonePickerLocation;
}
function $2785da2b7d7107bb$var$useUnicodeToHide() {
    var _usePickerConfig17 = $2785da2b7d7107bb$var$usePickerConfig(), unicodeToHide = _usePickerConfig17.unicodeToHide;
    return unicodeToHide;
}
function $2785da2b7d7107bb$var$useGetEmojiUrlConfig() {
    var _usePickerConfig18 = $2785da2b7d7107bb$var$usePickerConfig(), getEmojiUrl = _usePickerConfig18.getEmojiUrl;
    return getEmojiUrl;
}
function $2785da2b7d7107bb$var$getDimension(dimensionConfig) {
    return typeof dimensionConfig === "number" ? dimensionConfig + "px" : dimensionConfig;
}
function $2785da2b7d7107bb$var$useDebouncedState(initialValue, delay) {
    if (delay === void 0) delay = 0;
    var _useState = (0, $ir4bw.useState)(initialValue), state = _useState[0], setState = _useState[1];
    var timer = (0, $ir4bw.useRef)(null);
    function debouncedSetState(value) {
        return new Promise(function(resolve) {
            var _window;
            if (timer.current) clearTimeout(timer.current);
            timer.current = (_window = window) == null ? void 0 : _window.setTimeout(function() {
                setState(value);
                resolve(value);
            }, delay);
        });
    }
    return [
        state,
        debouncedSetState
    ];
}
function $2785da2b7d7107bb$var$useIsUnicodeHidden() {
    var unicodeToHide = $2785da2b7d7107bb$var$useUnicodeToHide();
    return function(emojiUnified) {
        return unicodeToHide.has(emojiUnified);
    };
}
function $2785da2b7d7107bb$var$useDisallowedEmojis() {
    var DisallowedEmojisRef = (0, $ir4bw.useRef)({});
    var emojiVersionConfig = $2785da2b7d7107bb$var$useEmojiVersionConfig();
    return (0, $ir4bw.useMemo)(function() {
        var emojiVersion = parseFloat("" + emojiVersionConfig);
        if (!emojiVersionConfig || Number.isNaN(emojiVersion)) return DisallowedEmojisRef.current;
        return $2785da2b7d7107bb$var$allEmojis.reduce(function(disallowedEmojis, emoji) {
            if ($2785da2b7d7107bb$var$addedInNewerVersion(emoji, emojiVersion)) disallowedEmojis[$2785da2b7d7107bb$var$emojiUnified(emoji)] = true;
            return disallowedEmojis;
        }, DisallowedEmojisRef.current);
    }, [
        emojiVersionConfig
    ]);
}
function $2785da2b7d7107bb$var$useIsEmojiDisallowed() {
    var disallowedEmojis = $2785da2b7d7107bb$var$useDisallowedEmojis();
    var isUnicodeHidden = $2785da2b7d7107bb$var$useIsUnicodeHidden();
    return function isEmojiDisallowed(emoji) {
        var unified = $2785da2b7d7107bb$var$unifiedWithoutSkinTone($2785da2b7d7107bb$var$emojiUnified(emoji));
        return Boolean(disallowedEmojis[unified] || isUnicodeHidden(unified));
    };
}
function $2785da2b7d7107bb$var$addedInNewerVersion(emoji, supportedLevel) {
    return $2785da2b7d7107bb$var$addedIn(emoji) > supportedLevel;
}
function $2785da2b7d7107bb$var$useMarkInitialLoad(dispatch) {
    (0, $ir4bw.useEffect)(function() {
        dispatch(true);
    }, [
        dispatch
    ]);
}
function $2785da2b7d7107bb$var$PickerContextProvider(_ref) {
    var children = _ref.children;
    var disallowedEmojis = $2785da2b7d7107bb$var$useDisallowedEmojis();
    var defaultSkinTone = $2785da2b7d7107bb$var$useDefaultSkinToneConfig(); // Initialize the filter with the inititial dictionary
    var filterRef = (0, $ir4bw.useRef)($2785da2b7d7107bb$var$alphaNumericEmojiIndex);
    var disallowClickRef = (0, $ir4bw.useRef)(false);
    var disallowMouseRef = (0, $ir4bw.useRef)(false);
    var disallowedEmojisRef = (0, $ir4bw.useRef)(disallowedEmojis);
    var suggestedUpdateState = $2785da2b7d7107bb$var$useDebouncedState(Date.now(), 200);
    var searchTerm = $2785da2b7d7107bb$var$useDebouncedState("", 100);
    var skinToneFanOpenState = (0, $ir4bw.useState)(false);
    var activeSkinTone = (0, $ir4bw.useState)(defaultSkinTone);
    var activeCategoryState = (0, $ir4bw.useState)(null);
    var emojisThatFailedToLoadState = (0, $ir4bw.useState)(new Set());
    var emojiVariationPickerState = (0, $ir4bw.useState)(null);
    var _useState = (0, $ir4bw.useState)(false), isPastInitialLoad = _useState[0], setIsPastInitialLoad = _useState[1];
    $2785da2b7d7107bb$var$useMarkInitialLoad(setIsPastInitialLoad);
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$PickerContext.Provider, {
        value: {
            activeCategoryState: activeCategoryState,
            activeSkinTone: activeSkinTone,
            disallowClickRef: disallowClickRef,
            disallowMouseRef: disallowMouseRef,
            disallowedEmojisRef: disallowedEmojisRef,
            emojiVariationPickerState: emojiVariationPickerState,
            emojisThatFailedToLoadState: emojisThatFailedToLoadState,
            filterRef: filterRef,
            isPastInitialLoad: isPastInitialLoad,
            searchTerm: searchTerm,
            skinToneFanOpenState: skinToneFanOpenState,
            suggestedUpdateState: suggestedUpdateState
        }
    }, children);
}
var $2785da2b7d7107bb$var$PickerContext = /*#__PURE__*/ (0, $5VC2c.createContext)({
    activeCategoryState: [
        null,
        function() {}
    ],
    activeSkinTone: [
        $2785da2b7d7107bb$export$8502e178dd60af86.NEUTRAL,
        function() {}
    ],
    disallowClickRef: {
        current: false
    },
    disallowMouseRef: {
        current: false
    },
    disallowedEmojisRef: {
        current: {}
    },
    emojiVariationPickerState: [
        null,
        function() {}
    ],
    emojisThatFailedToLoadState: [
        /*#__PURE__*/ new Set(),
        function() {}
    ],
    filterRef: {
        current: {}
    },
    isPastInitialLoad: true,
    searchTerm: [
        "",
        function() {
            return new Promise(function() {
                return undefined;
            });
        }
    ],
    skinToneFanOpenState: [
        false,
        function() {}
    ],
    suggestedUpdateState: [
        /*#__PURE__*/ Date.now(),
        function() {}
    ]
});
function $2785da2b7d7107bb$var$useFilterRef() {
    var _React$useContext = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), filterRef = _React$useContext.filterRef;
    return filterRef;
}
function $2785da2b7d7107bb$var$useDisallowClickRef() {
    var _React$useContext2 = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), disallowClickRef = _React$useContext2.disallowClickRef;
    return disallowClickRef;
}
function $2785da2b7d7107bb$var$useDisallowMouseRef() {
    var _React$useContext3 = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), disallowMouseRef = _React$useContext3.disallowMouseRef;
    return disallowMouseRef;
}
function $2785da2b7d7107bb$var$useSearchTermState() {
    var _React$useContext4 = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), searchTerm = _React$useContext4.searchTerm;
    return searchTerm;
}
function $2785da2b7d7107bb$var$useActiveSkinToneState() {
    var _React$useContext5 = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), activeSkinTone = _React$useContext5.activeSkinTone;
    return activeSkinTone;
}
function $2785da2b7d7107bb$var$useEmojisThatFailedToLoadState() {
    var _React$useContext6 = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), emojisThatFailedToLoadState = _React$useContext6.emojisThatFailedToLoadState;
    return emojisThatFailedToLoadState;
}
function $2785da2b7d7107bb$var$useIsPastInitialLoad() {
    var _React$useContext7 = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), isPastInitialLoad = _React$useContext7.isPastInitialLoad;
    return isPastInitialLoad;
}
function $2785da2b7d7107bb$var$useEmojiVariationPickerState() {
    var _React$useContext8 = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), emojiVariationPickerState = _React$useContext8.emojiVariationPickerState;
    return emojiVariationPickerState;
}
function $2785da2b7d7107bb$var$useSkinToneFanOpenState() {
    var _React$useContext9 = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), skinToneFanOpenState = _React$useContext9.skinToneFanOpenState;
    return skinToneFanOpenState;
}
function $2785da2b7d7107bb$var$useUpdateSuggested() {
    var _React$useContext11 = (0, $ir4bw.useContext)($2785da2b7d7107bb$var$PickerContext), suggestedUpdateState = _React$useContext11.suggestedUpdateState;
    var suggestedUpdated = suggestedUpdateState[0], setsuggestedUpdate = suggestedUpdateState[1];
    return [
        suggestedUpdated,
        function updateSuggested() {
            setsuggestedUpdate(Date.now());
        }
    ];
}
function $2785da2b7d7107bb$var$useDisallowMouseMove() {
    var DisallowMouseRef = $2785da2b7d7107bb$var$useDisallowMouseRef();
    return function disallowMouseMove() {
        DisallowMouseRef.current = true;
    };
}
function $2785da2b7d7107bb$var$useAllowMouseMove() {
    var DisallowMouseRef = $2785da2b7d7107bb$var$useDisallowMouseRef();
    return function allowMouseMove() {
        DisallowMouseRef.current = false;
    };
}
function $2785da2b7d7107bb$var$useIsMouseDisallowed() {
    var DisallowMouseRef = $2785da2b7d7107bb$var$useDisallowMouseRef();
    return function isMouseDisallowed() {
        return DisallowMouseRef.current;
    };
}
function $2785da2b7d7107bb$var$useOnMouseMove() {
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    var allowMouseMove = $2785da2b7d7107bb$var$useAllowMouseMove();
    var isMouseDisallowed = $2785da2b7d7107bb$var$useIsMouseDisallowed();
    (0, $ir4bw.useEffect)(function() {
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener("mousemove", onMouseMove, {
            passive: true
        });
        function onMouseMove() {
            if (isMouseDisallowed()) allowMouseMove();
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener("mousemove", onMouseMove);
        };
    }, [
        BodyRef,
        allowMouseMove,
        isMouseDisallowed
    ]);
}
function $2785da2b7d7107bb$var$elementCountInRow(parent, element) {
    if (!parent || !element) return 0;
    var parentWidth = parent.getBoundingClientRect().width;
    var elementWidth = element.getBoundingClientRect().width;
    return Math.floor(parentWidth / elementWidth);
}
function $2785da2b7d7107bb$var$elementIndexInRow(parent, element) {
    if (!parent || !element) return 0;
    var elementWidth = element.getBoundingClientRect().width;
    var elementLeft = element.getBoundingClientRect().left;
    var parentLeft = parent.getBoundingClientRect().left;
    return Math.floor((elementLeft - parentLeft) / elementWidth);
}
function $2785da2b7d7107bb$var$rowNumber(parent, element) {
    if (!parent || !element) return 0;
    var elementHeight = element.getBoundingClientRect().height;
    var elementTop = element.getBoundingClientRect().top;
    var parentTop = parent.getBoundingClientRect().top;
    return Math.round((elementTop - parentTop) / elementHeight);
}
function $2785da2b7d7107bb$var$hasNextRow(parent, element) {
    if (!parent || !element) return false;
    var elementHeight = element.getBoundingClientRect().height;
    var elementTop = element.getBoundingClientRect().top;
    var parentTop = parent.getBoundingClientRect().top;
    var parentHeight = parent.getBoundingClientRect().height;
    return Math.round(elementTop - parentTop + elementHeight) < parentHeight;
}
function $2785da2b7d7107bb$var$getRowElements(elements, row, elementsInRow) {
    if (row === -1) {
        var lastRow = Math.floor((elements.length - 1) / elementsInRow);
        var firstElementIndex = lastRow * elementsInRow;
        var lastElementIndex = elements.length - 1;
        return elements.slice(firstElementIndex, lastElementIndex + 1);
    }
    return elements.slice(row * elementsInRow, (row + 1) * elementsInRow);
}
function $2785da2b7d7107bb$var$getNextRowElements(allElements, currentRow, elementsInRow) {
    var nextRow = currentRow + 1;
    if (nextRow * elementsInRow > allElements.length) return [];
    return $2785da2b7d7107bb$var$getRowElements(allElements, nextRow, elementsInRow);
}
function $2785da2b7d7107bb$var$getElementInRow(elements, row, elementsInRow, indexInRow) {
    var rowElements = $2785da2b7d7107bb$var$getRowElements(elements, row, elementsInRow); // get element, default to last
    return rowElements[indexInRow] || rowElements[rowElements.length - 1] || null;
}
function $2785da2b7d7107bb$var$getElementInNextRow(allElements, currentRow, elementsInRow, index) {
    var nextRowElements = $2785da2b7d7107bb$var$getNextRowElements(allElements, currentRow, elementsInRow); // return item in index, or last item in row
    return nextRowElements[index] || nextRowElements[nextRowElements.length - 1] || null;
}
function $2785da2b7d7107bb$var$getElementInPrevRow(allElements, currentRow, elementsInRow, index) {
    var prevRowElements = $2785da2b7d7107bb$var$getRowElements(allElements, currentRow - 1, elementsInRow); // default to last
    return prevRowElements[index] || prevRowElements[prevRowElements.length - 1] || null;
}
function $2785da2b7d7107bb$var$firstVisibleElementInContainer(parent, elements) {
    if (!parent || !elements.length) return null;
    var parentTop = parent.getBoundingClientRect().top;
    var parentBottom = parent.getBoundingClientRect().bottom;
    var visibleElements = elements.find(function(element) {
        var elementTop = element.getBoundingClientRect().top;
        var elementBottom = element.getBoundingClientRect().bottom;
        return elementTop >= parentTop && elementTop <= parentBottom || elementBottom >= parentTop && elementBottom <= parentBottom;
    });
    return visibleElements || null;
}
function $2785da2b7d7107bb$var$hasNextElementSibling(element) {
    return !!element.nextElementSibling;
}
var $2785da2b7d7107bb$var$EmojiButtonSelector = "button" + /*#__PURE__*/ $2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.emoji);
var $2785da2b7d7107bb$var$VisibleEmojiSelector = /*#__PURE__*/ [
    $2785da2b7d7107bb$var$EmojiButtonSelector,
    $2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.visible),
    ":not(" + $2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.hidden) + ")"
].join("");
function $2785da2b7d7107bb$var$buttonFromTarget(emojiElement) {
    var _emojiElement$closest;
    return (_emojiElement$closest = emojiElement == null ? void 0 : emojiElement.closest($2785da2b7d7107bb$var$EmojiButtonSelector)) != null ? _emojiElement$closest : null;
}
function $2785da2b7d7107bb$var$emojiFromElement(element) {
    var originalUnified = $2785da2b7d7107bb$var$originalUnifiedFromEmojiElement(element);
    var unified = $2785da2b7d7107bb$var$unifiedFromEmojiElement(element);
    if (!originalUnified) return [];
    var emoji = $2785da2b7d7107bb$var$emojiByUnified(originalUnified);
    if (!emoji) return [];
    return [
        emoji,
        unified
    ];
}
function $2785da2b7d7107bb$var$isEmojiElement(element) {
    var _element$parentElemen;
    return Boolean((element == null ? void 0 : element.matches($2785da2b7d7107bb$var$EmojiButtonSelector)) || (element == null ? void 0 : (_element$parentElemen = element.parentElement) == null ? void 0 : _element$parentElemen.matches($2785da2b7d7107bb$var$EmojiButtonSelector)));
}
function $2785da2b7d7107bb$var$elementHeight(element) {
    var _element$clientHeight;
    return (_element$clientHeight = element == null ? void 0 : element.clientHeight) != null ? _element$clientHeight : 0;
}
function $2785da2b7d7107bb$var$emojiTrueOffsetTop(element) {
    if (!element) return 0;
    var button = $2785da2b7d7107bb$var$buttonFromTarget(element);
    var category = $2785da2b7d7107bb$var$closestCategory(button); // compensate for the label height
    var labelHeight = $2785da2b7d7107bb$var$categoryLabelHeight(category);
    return $2785da2b7d7107bb$var$elementOffsetTop(button) + $2785da2b7d7107bb$var$elementOffsetTop(category) + labelHeight;
}
function $2785da2b7d7107bb$var$categoryLabelHeight(category) {
    var _category$clientHeigh, _categoryWithoutLabel;
    if (!category) return 0;
    var categoryWithoutLabel = category.querySelector($2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.categoryContent));
    return ((_category$clientHeigh = category == null ? void 0 : category.clientHeight) != null ? _category$clientHeigh : 0) - ((_categoryWithoutLabel = categoryWithoutLabel == null ? void 0 : categoryWithoutLabel.clientHeight) != null ? _categoryWithoutLabel : 0);
}
function $2785da2b7d7107bb$var$isEmojiBehindLabel(emoji) {
    if (!emoji) return false;
    return $2785da2b7d7107bb$var$emojiDistanceFromScrollTop(emoji) < $2785da2b7d7107bb$var$categoryLabelHeight($2785da2b7d7107bb$var$closestCategory(emoji));
}
function $2785da2b7d7107bb$var$queryScrollBody(root) {
    if (!root) return null;
    return root.matches($2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.scrollBody)) ? root : root.querySelector($2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.scrollBody));
}
function $2785da2b7d7107bb$var$emojiDistanceFromScrollTop(emoji) {
    var _closestScrollBody$sc, _closestScrollBody;
    if (!emoji) return 0;
    return $2785da2b7d7107bb$var$emojiTrueOffsetTop(emoji) - ((_closestScrollBody$sc = (_closestScrollBody = $2785da2b7d7107bb$var$closestScrollBody(emoji)) == null ? void 0 : _closestScrollBody.scrollTop) != null ? _closestScrollBody$sc : 0);
}
function $2785da2b7d7107bb$var$closestScrollBody(element) {
    var _element$closest;
    if (!element) return null;
    return (_element$closest = element.closest($2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.scrollBody))) != null ? _element$closest : null;
}
function $2785da2b7d7107bb$var$emojiTruOffsetLeft(element) {
    var button = $2785da2b7d7107bb$var$buttonFromTarget(element);
    var category = $2785da2b7d7107bb$var$closestCategory(button);
    return $2785da2b7d7107bb$var$elementOffsetLeft(button) + $2785da2b7d7107bb$var$elementOffsetLeft(category);
}
function $2785da2b7d7107bb$var$elementOffsetTop(element) {
    var _element$offsetTop;
    return (_element$offsetTop = element == null ? void 0 : element.offsetTop) != null ? _element$offsetTop : 0;
}
function $2785da2b7d7107bb$var$elementOffsetLeft(element) {
    var _element$offsetLeft;
    return (_element$offsetLeft = element == null ? void 0 : element.offsetLeft) != null ? _element$offsetLeft : 0;
}
function $2785da2b7d7107bb$var$unifiedFromEmojiElement(emoji) {
    var _elementDataSetKey;
    return (_elementDataSetKey = $2785da2b7d7107bb$var$elementDataSetKey($2785da2b7d7107bb$var$buttonFromTarget(emoji), "unified")) != null ? _elementDataSetKey : null;
}
function $2785da2b7d7107bb$var$originalUnifiedFromEmojiElement(emoji) {
    var unified = $2785da2b7d7107bb$var$unifiedFromEmojiElement(emoji);
    if (unified) return $2785da2b7d7107bb$var$unifiedWithoutSkinTone(unified);
    return null;
}
function $2785da2b7d7107bb$var$elementDataSetKey(element, key) {
    var _elementDataSet$key;
    return (_elementDataSet$key = $2785da2b7d7107bb$var$elementDataSet(element)[key]) != null ? _elementDataSet$key : null;
}
function $2785da2b7d7107bb$var$elementDataSet(element) {
    var _element$dataset;
    return (_element$dataset = element == null ? void 0 : element.dataset) != null ? _element$dataset : {};
}
function $2785da2b7d7107bb$var$isVisibleEmoji(element) {
    return element.classList.contains($2785da2b7d7107bb$var$ClassNames.visible);
}
function $2785da2b7d7107bb$var$isHidden(element) {
    if (!element) return true;
    return element.classList.contains($2785da2b7d7107bb$var$ClassNames.hidden);
}
function $2785da2b7d7107bb$var$allVisibleEmojis(parent) {
    if (!parent) return [];
    return Array.from(parent.querySelectorAll($2785da2b7d7107bb$var$VisibleEmojiSelector));
}
function $2785da2b7d7107bb$var$lastVisibleEmoji(element) {
    if (!element) return null;
    var allEmojis = $2785da2b7d7107bb$var$allVisibleEmojis(element);
    var _allEmojis$slice = allEmojis.slice(-1), last = _allEmojis$slice[0];
    if (!last) return null;
    if (!$2785da2b7d7107bb$var$isVisibleEmoji(last)) return $2785da2b7d7107bb$var$prevVisibleEmoji(last);
    return last;
}
function $2785da2b7d7107bb$var$nextVisibleEmoji(element) {
    var next = element.nextElementSibling;
    if (!next) return $2785da2b7d7107bb$var$firstVisibleEmoji($2785da2b7d7107bb$var$nextCategory(element));
    if (!$2785da2b7d7107bb$var$isVisibleEmoji(next)) return $2785da2b7d7107bb$var$nextVisibleEmoji(next);
    return next;
}
function $2785da2b7d7107bb$var$prevVisibleEmoji(element) {
    var prev = element.previousElementSibling;
    if (!prev) return $2785da2b7d7107bb$var$lastVisibleEmoji($2785da2b7d7107bb$var$prevCategory(element));
    if (!$2785da2b7d7107bb$var$isVisibleEmoji(prev)) return $2785da2b7d7107bb$var$prevVisibleEmoji(prev);
    return prev;
}
function $2785da2b7d7107bb$var$firstVisibleEmoji(parent) {
    if (!parent) return null;
    var allEmojis = $2785da2b7d7107bb$var$allVisibleEmojis(parent);
    return $2785da2b7d7107bb$var$firstVisibleElementInContainer(parent, allEmojis);
}
function $2785da2b7d7107bb$var$prevCategory(element) {
    var category = $2785da2b7d7107bb$var$closestCategory(element);
    if (!category) return null;
    var prev = category.previousElementSibling;
    if (!prev) return null;
    if ($2785da2b7d7107bb$var$isHidden(prev)) return $2785da2b7d7107bb$var$prevCategory(prev);
    return prev;
}
function $2785da2b7d7107bb$var$nextCategory(element) {
    var category = $2785da2b7d7107bb$var$closestCategory(element);
    if (!category) return null;
    var next = category.nextElementSibling;
    if (!next) return null;
    if ($2785da2b7d7107bb$var$isHidden(next)) return $2785da2b7d7107bb$var$nextCategory(next);
    return next;
}
function $2785da2b7d7107bb$var$closestCategory(element) {
    if (!element) return null;
    return element.closest($2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.category));
}
function $2785da2b7d7107bb$var$closestCategoryContent(element) {
    if (!element) return null;
    return element.closest($2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.categoryContent));
}
function $2785da2b7d7107bb$var$parseNativeEmoji(unified) {
    return unified.split("-").map(function(hex) {
        return String.fromCodePoint(parseInt(hex, 16));
    }).join("");
}
var $2785da2b7d7107bb$var$SUGGESTED_LS_KEY = "epr_suggested";
function $2785da2b7d7107bb$var$getSuggested(mode) {
    try {
        var _window, _window$localStorage$, _window2;
        if (!((_window = window) != null && _window.localStorage)) return [];
        var recent = JSON.parse((_window$localStorage$ = (_window2 = window) == null ? void 0 : _window2.localStorage.getItem($2785da2b7d7107bb$var$SUGGESTED_LS_KEY)) != null ? _window$localStorage$ : "[]");
        if (mode === $2785da2b7d7107bb$export$599319363ef7770d.FREQUENT) return recent.sort(function(a, b) {
            return b.count - a.count;
        });
        return recent;
    } catch (_unused) {
        return [];
    }
}
function $2785da2b7d7107bb$var$setSuggested(emoji, skinTone) {
    var recent = $2785da2b7d7107bb$var$getSuggested();
    var unified = $2785da2b7d7107bb$var$emojiUnified(emoji, skinTone);
    var originalUnified = $2785da2b7d7107bb$var$emojiUnified(emoji);
    var existing = recent.find(function(_ref) {
        var u = _ref.unified;
        return u === unified;
    });
    var nextList;
    if (existing) nextList = [
        existing
    ].concat(recent.filter(function(i) {
        return i !== existing;
    }));
    else {
        existing = {
            unified: unified,
            original: originalUnified,
            count: 0
        };
        nextList = [
            existing
        ].concat(recent);
    }
    existing.count++;
    nextList.length = Math.min(nextList.length, 14);
    try {
        var _window3;
        (_window3 = window) == null || _window3.localStorage.setItem($2785da2b7d7107bb$var$SUGGESTED_LS_KEY, JSON.stringify(nextList)); // Prevents the change from being seen immediately.
    } catch (_unused2) {}
}
function $2785da2b7d7107bb$var$isCustomCategory(category) {
    return category.category === $2785da2b7d7107bb$export$e1e795cef0e670e6.CUSTOM;
}
function $2785da2b7d7107bb$var$isCustomEmoji(emoji) {
    return emoji.imgUrl !== undefined;
}
function $2785da2b7d7107bb$var$useCloseAllOpenToggles() {
    var _useEmojiVariationPic = $2785da2b7d7107bb$var$useEmojiVariationPickerState(), variationPicker = _useEmojiVariationPic[0], setVariationPicker = _useEmojiVariationPic[1];
    var _useSkinToneFanOpenSt = $2785da2b7d7107bb$var$useSkinToneFanOpenState(), skinToneFanOpen = _useSkinToneFanOpenSt[0], setSkinToneFanOpen = _useSkinToneFanOpenSt[1];
    var closeAllOpenToggles = (0, $ir4bw.useCallback)(function() {
        if (variationPicker) setVariationPicker(null);
        if (skinToneFanOpen) setSkinToneFanOpen(false);
    }, [
        variationPicker,
        skinToneFanOpen,
        setVariationPicker,
        setSkinToneFanOpen
    ]);
    return closeAllOpenToggles;
}
function $2785da2b7d7107bb$var$useHasOpenToggles() {
    var _useEmojiVariationPic2 = $2785da2b7d7107bb$var$useEmojiVariationPickerState(), variationPicker = _useEmojiVariationPic2[0];
    var _useSkinToneFanOpenSt2 = $2785da2b7d7107bb$var$useSkinToneFanOpenState(), skinToneFanOpen = _useSkinToneFanOpenSt2[0];
    return function hasOpenToggles() {
        return !!variationPicker || skinToneFanOpen;
    };
}
function $2785da2b7d7107bb$var$useSetVariationPicker() {
    var setAnchoredEmojiRef = $2785da2b7d7107bb$var$useSetAnchoredEmojiRef();
    var _useEmojiVariationPic = $2785da2b7d7107bb$var$useEmojiVariationPickerState(), setEmojiVariationPicker = _useEmojiVariationPic[1];
    return function setVariationPicker(element) {
        var _emojiFromElement = $2785da2b7d7107bb$var$emojiFromElement(element), emoji = _emojiFromElement[0];
        if (emoji) {
            setAnchoredEmojiRef(element);
            setEmojiVariationPicker(emoji);
        }
    };
}
function $2785da2b7d7107bb$var$useMouseDownHandlers(BodyRef) {
    var mouseDownTimerRef = (0, $ir4bw.useRef)();
    var setVariationPicker = $2785da2b7d7107bb$var$useSetVariationPicker();
    var disallowClickRef = $2785da2b7d7107bb$var$useDisallowClickRef();
    var _useEmojiVariationPic = $2785da2b7d7107bb$var$useEmojiVariationPickerState(), setEmojiVariationPicker = _useEmojiVariationPic[1];
    var closeAllOpenToggles = $2785da2b7d7107bb$var$useCloseAllOpenToggles();
    var _useActiveSkinToneSta = $2785da2b7d7107bb$var$useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0];
    var onEmojiClick = $2785da2b7d7107bb$var$useOnEmojiClickConfig();
    var _useUpdateSuggested = $2785da2b7d7107bb$var$useUpdateSuggested(), updateSuggested = _useUpdateSuggested[1];
    var getEmojiUrl = $2785da2b7d7107bb$var$useGetEmojiUrlConfig();
    var activeEmojiStyle = $2785da2b7d7107bb$var$useEmojiStyleConfig();
    var onClick = (0, $ir4bw.useCallback)(function onClick(event) {
        if (disallowClickRef.current) return;
        closeAllOpenToggles();
        var _emojiFromEvent = $2785da2b7d7107bb$var$emojiFromEvent(event), emoji = _emojiFromEvent[0], unified = _emojiFromEvent[1];
        if (!emoji || !unified) return;
        var skinToneToUse = $2785da2b7d7107bb$var$activeVariationFromUnified(unified) || activeSkinTone;
        updateSuggested();
        $2785da2b7d7107bb$var$setSuggested(emoji, skinToneToUse);
        onEmojiClick($2785da2b7d7107bb$var$emojiClickOutput(emoji, skinToneToUse, activeEmojiStyle, getEmojiUrl), event);
    }, [
        activeSkinTone,
        closeAllOpenToggles,
        disallowClickRef,
        onEmojiClick,
        updateSuggested,
        getEmojiUrl,
        activeEmojiStyle
    ]);
    var onMouseDown = (0, $ir4bw.useCallback)(function onMouseDown(event) {
        var _window;
        if (mouseDownTimerRef.current) clearTimeout(mouseDownTimerRef.current);
        var _emojiFromEvent2 = $2785da2b7d7107bb$var$emojiFromEvent(event), emoji = _emojiFromEvent2[0];
        if (!emoji || !$2785da2b7d7107bb$var$emojiHasVariations(emoji)) return;
        mouseDownTimerRef.current = (_window = window) == null ? void 0 : _window.setTimeout(function() {
            disallowClickRef.current = true;
            mouseDownTimerRef.current = undefined;
            closeAllOpenToggles();
            setVariationPicker(event.target);
            setEmojiVariationPicker(emoji);
        }, 500);
    }, [
        disallowClickRef,
        closeAllOpenToggles,
        setVariationPicker,
        setEmojiVariationPicker
    ]);
    var onMouseUp = (0, $ir4bw.useCallback)(function onMouseUp() {
        if (mouseDownTimerRef.current) {
            clearTimeout(mouseDownTimerRef.current);
            mouseDownTimerRef.current = undefined;
        } else if (disallowClickRef.current) // The problem we're trying to overcome here
        // is that the emoji has both mouseup and click events
        // and when releasing a mouseup event
        // the click gets triggered too
        // So we're disallowing the click event for a short time
        requestAnimationFrame(function() {
            disallowClickRef.current = false;
        });
    }, [
        disallowClickRef
    ]);
    (0, $ir4bw.useEffect)(function() {
        if (!BodyRef.current) return;
        var bodyRef = BodyRef.current;
        bodyRef.addEventListener("click", onClick, {
            passive: true
        });
        bodyRef.addEventListener("mousedown", onMouseDown, {
            passive: true
        });
        bodyRef.addEventListener("mouseup", onMouseUp, {
            passive: true
        });
        return function() {
            bodyRef == null || bodyRef.removeEventListener("click", onClick);
            bodyRef == null || bodyRef.removeEventListener("mousedown", onMouseDown);
            bodyRef == null || bodyRef.removeEventListener("mouseup", onMouseUp);
        };
    }, [
        BodyRef,
        onClick,
        onMouseDown,
        onMouseUp
    ]);
}
function $2785da2b7d7107bb$var$emojiFromEvent(event) {
    var target = event == null ? void 0 : event.target;
    if (!$2785da2b7d7107bb$var$isEmojiElement(target)) return [];
    return $2785da2b7d7107bb$var$emojiFromElement(target);
}
function $2785da2b7d7107bb$var$emojiClickOutput(emoji, activeSkinTone, activeEmojiStyle, getEmojiUrl) {
    var names = $2785da2b7d7107bb$var$emojiNames(emoji);
    if ($2785da2b7d7107bb$var$isCustomEmoji(emoji)) {
        var _unified = $2785da2b7d7107bb$var$emojiUnified(emoji);
        return {
            activeSkinTone: activeSkinTone,
            emoji: _unified,
            getImageUrl: function getImageUrl() {
                return emoji.imgUrl;
            },
            imageUrl: emoji.imgUrl,
            isCustom: true,
            names: names,
            unified: _unified,
            unifiedWithoutSkinTone: _unified
        };
    }
    var unified = $2785da2b7d7107bb$var$emojiUnified(emoji, activeSkinTone);
    return {
        activeSkinTone: activeSkinTone,
        emoji: $2785da2b7d7107bb$var$parseNativeEmoji(unified),
        getImageUrl: function getImageUrl(emojiStyle) {
            if (emojiStyle === void 0) emojiStyle = activeEmojiStyle != null ? activeEmojiStyle : $2785da2b7d7107bb$export$92260a1a02147e89.APPLE;
            return getEmojiUrl(unified, emojiStyle);
        },
        imageUrl: getEmojiUrl(unified, activeEmojiStyle != null ? activeEmojiStyle : $2785da2b7d7107bb$export$92260a1a02147e89.APPLE),
        isCustom: false,
        names: names,
        unified: unified,
        unifiedWithoutSkinTone: $2785da2b7d7107bb$var$emojiUnified(emoji)
    };
}
function $2785da2b7d7107bb$var$useOnScroll(BodyRef) {
    var closeAllOpenToggles = $2785da2b7d7107bb$var$useCloseAllOpenToggles();
    (0, $ir4bw.useEffect)(function() {
        var bodyRef = BodyRef.current;
        if (!bodyRef) return;
        bodyRef.addEventListener("scroll", onScroll, {
            passive: true
        });
        function onScroll() {
            closeAllOpenToggles();
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener("scroll", onScroll);
        };
    }, [
        BodyRef,
        closeAllOpenToggles
    ]);
}
function $2785da2b7d7107bb$var$scrollTo(root, top) {
    if (top === void 0) top = 0;
    var $eprBody = $2785da2b7d7107bb$var$queryScrollBody(root);
    if (!$eprBody) return;
    requestAnimationFrame(function() {
        $eprBody.scrollTop = top + 1;
    });
}
function $2785da2b7d7107bb$var$scrollBy(root, by) {
    var $eprBody = $2785da2b7d7107bb$var$queryScrollBody(root);
    if (!$eprBody) return;
    requestAnimationFrame(function() {
        $eprBody.scrollTop = $eprBody.scrollTop + by;
    });
}
function $2785da2b7d7107bb$var$useScrollTo() {
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    return (0, $ir4bw.useCallback)(function(top) {
        requestAnimationFrame(function() {
            if (BodyRef.current) BodyRef.current.scrollTop = top;
        });
    }, [
        BodyRef
    ]);
}
function $2785da2b7d7107bb$var$scrollEmojiAboveLabel(emoji) {
    if (!emoji || !$2785da2b7d7107bb$var$isEmojiBehindLabel(emoji)) return;
    if (emoji.closest($2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.variationPicker))) return;
    var scrollBody = $2785da2b7d7107bb$var$closestScrollBody(emoji);
    var by = $2785da2b7d7107bb$var$emojiDistanceFromScrollTop(emoji);
    $2785da2b7d7107bb$var$scrollBy(scrollBody, -($2785da2b7d7107bb$var$categoryLabelHeight($2785da2b7d7107bb$var$closestCategory(emoji)) - by));
}
function $2785da2b7d7107bb$var$useFocusSearchInput() {
    var SearchInputRef = $2785da2b7d7107bb$var$useSearchInputRef();
    return (0, $ir4bw.useCallback)(function() {
        $2785da2b7d7107bb$var$focusElement(SearchInputRef.current);
    }, [
        SearchInputRef
    ]);
}
function $2785da2b7d7107bb$var$useFocusSkinTonePicker() {
    var SkinTonePickerRef = $2785da2b7d7107bb$var$useSkinTonePickerRef();
    return (0, $ir4bw.useCallback)(function() {
        if (!SkinTonePickerRef.current) return;
        $2785da2b7d7107bb$var$focusFirstElementChild(SkinTonePickerRef.current);
    }, [
        SkinTonePickerRef
    ]);
}
function $2785da2b7d7107bb$var$useFocusCategoryNavigation() {
    var CategoryNavigationRef = $2785da2b7d7107bb$var$useCategoryNavigationRef();
    return (0, $ir4bw.useCallback)(function() {
        if (!CategoryNavigationRef.current) return;
        $2785da2b7d7107bb$var$focusFirstElementChild(CategoryNavigationRef.current);
    }, [
        CategoryNavigationRef
    ]);
}
function $2785da2b7d7107bb$var$useSetFilterRef() {
    var filterRef = $2785da2b7d7107bb$var$useFilterRef();
    return function setFilter(setter) {
        if (typeof setter === "function") return setFilter(setter(filterRef.current));
        filterRef.current = setter;
    };
}
function $2785da2b7d7107bb$var$useClearSearch() {
    var applySearch = $2785da2b7d7107bb$var$useApplySearch();
    var SearchInputRef = $2785da2b7d7107bb$var$useSearchInputRef();
    var focusSearchInput = $2785da2b7d7107bb$var$useFocusSearchInput();
    return function clearSearch() {
        if (SearchInputRef.current) SearchInputRef.current.value = "";
        applySearch("");
        focusSearchInput();
    };
}
function $2785da2b7d7107bb$var$useAppendSearch() {
    var SearchInputRef = $2785da2b7d7107bb$var$useSearchInputRef();
    var applySearch = $2785da2b7d7107bb$var$useApplySearch();
    return function appendSearch(str) {
        if (SearchInputRef.current) {
            SearchInputRef.current.value = "" + SearchInputRef.current.value + str;
            applySearch($2785da2b7d7107bb$var$getNormalizedSearchTerm(SearchInputRef.current.value));
        } else applySearch($2785da2b7d7107bb$var$getNormalizedSearchTerm(str));
    };
}
function $2785da2b7d7107bb$var$useFilter() {
    var SearchInputRef = $2785da2b7d7107bb$var$useSearchInputRef();
    var filterRef = $2785da2b7d7107bb$var$useFilterRef();
    var setFilterRef = $2785da2b7d7107bb$var$useSetFilterRef();
    var applySearch = $2785da2b7d7107bb$var$useApplySearch();
    var _useSearchTermState = $2785da2b7d7107bb$var$useSearchTermState(), searchTerm = _useSearchTermState[0];
    return {
        onChange: onChange,
        searchTerm: searchTerm,
        SearchInputRef: SearchInputRef
    };
    function onChange(inputValue) {
        var filter = filterRef.current;
        var nextValue = inputValue.toLowerCase();
        if (filter != null && filter[nextValue] || nextValue.length <= 1) return applySearch(nextValue);
        var longestMatch = $2785da2b7d7107bb$var$findLongestMatch(nextValue, filter);
        if (!longestMatch) // Can we even get here?
        // If so, we need to search among all emojis
        return applySearch(nextValue);
        setFilterRef(function(current) {
            var _Object$assign;
            return Object.assign(current, (_Object$assign = {}, _Object$assign[nextValue] = $2785da2b7d7107bb$var$filterEmojiObjectByKeyword(longestMatch, nextValue), _Object$assign));
        });
        applySearch(nextValue);
    }
}
function $2785da2b7d7107bb$var$useApplySearch() {
    var _useSearchTermState2 = $2785da2b7d7107bb$var$useSearchTermState(), setSearchTerm = _useSearchTermState2[1];
    var PickerMainRef = $2785da2b7d7107bb$var$usePickerMainRef();
    return function applySearch(searchTerm) {
        requestAnimationFrame(function() {
            setSearchTerm(searchTerm ? searchTerm == null ? void 0 : searchTerm.toLowerCase() : searchTerm).then(function() {
                $2785da2b7d7107bb$var$scrollTo(PickerMainRef.current, 0);
            });
        });
    };
}
function $2785da2b7d7107bb$var$filterEmojiObjectByKeyword(emojis, keyword) {
    var filtered = {};
    for(var unified in emojis){
        var emoji = emojis[unified];
        if ($2785da2b7d7107bb$var$hasMatch(emoji, keyword)) filtered[unified] = emoji;
    }
    return filtered;
}
function $2785da2b7d7107bb$var$hasMatch(emoji, keyword) {
    return $2785da2b7d7107bb$var$emojiNames(emoji).some(function(name) {
        return name.includes(keyword);
    });
}
function $2785da2b7d7107bb$var$useIsEmojiFiltered() {
    var _useFilterRef = $2785da2b7d7107bb$var$useFilterRef(), filter = _useFilterRef.current;
    var _useSearchTermState3 = $2785da2b7d7107bb$var$useSearchTermState(), searchTerm = _useSearchTermState3[0];
    return function(unified) {
        return $2785da2b7d7107bb$var$isEmojiFilteredBySearchTerm(unified, filter, searchTerm);
    };
}
function $2785da2b7d7107bb$var$isEmojiFilteredBySearchTerm(unified, filter, searchTerm) {
    var _filter$searchTerm;
    if (!filter || !searchTerm) return false;
    return !((_filter$searchTerm = filter[searchTerm]) != null && _filter$searchTerm[unified]);
}
function $2785da2b7d7107bb$var$findLongestMatch(keyword, dict) {
    if (!dict) return null;
    if (dict[keyword]) return dict[keyword];
    var longestMatchingKey = Object.keys(dict).sort(function(a, b) {
        return b.length - a.length;
    }).find(function(key) {
        return keyword.includes(key);
    });
    if (longestMatchingKey) return dict[longestMatchingKey];
    return null;
}
function $2785da2b7d7107bb$var$getNormalizedSearchTerm(str) {
    if (!str || typeof str !== "string") return "";
    return str.trim().toLowerCase();
}
function $2785da2b7d7107bb$var$useIsEmojiHidden() {
    var _useEmojisThatFailedT = $2785da2b7d7107bb$var$useEmojisThatFailedToLoadState(), emojisThatFailedToLoad = _useEmojisThatFailedT[0];
    var isEmojiFiltered = $2785da2b7d7107bb$var$useIsEmojiFiltered();
    return function(emoji) {
        var unified = $2785da2b7d7107bb$var$emojiUnified(emoji);
        var failedToLoad = emojisThatFailedToLoad.has(unified);
        var filteredOut = isEmojiFiltered(unified);
        return {
            failedToLoad: failedToLoad,
            filteredOut: filteredOut,
            hidden: failedToLoad || filteredOut
        };
    };
}
function $2785da2b7d7107bb$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $2785da2b7d7107bb$var$css_248z = '.EmojiPickerReact button.epr-emoji{align-items:center;border-radius:8px;box-sizing:border-box;display:flex;height:var(--epr-emoji-fullsize);justify-content:center;max-height:var(--epr-emoji-fullsize);max-width:var(--epr-emoji-fullsize);overflow:hidden;position:relative;width:var(--epr-emoji-fullsize)}.EmojiPickerReact button.epr-emoji.epr-emoji-has-variations:after{border-bottom:4px solid var(--epr-emoji-variation-indicator-color);border-left:4px solid transparent;border-right:4px solid transparent;bottom:1px;content:"";display:block;height:0;position:absolute;right:0;transform:rotate(135deg);width:0;z-index:var(--epr-emoji-variations-indictator-z-index)}.EmojiPickerReact button.epr-emoji .epr-emoji-img{max-height:var(--epr-emoji-fullsize);max-width:var(--epr-emoji-fullsize);min-height:var(--epr-emoji-fullsize);min-width:var(--epr-emoji-fullsize);padding:var(--epr-emoji-padding)}.EmojiPickerReact button.epr-emoji .epr-emoji-native{padding:var(--epr-emoji-padding)}.EmojiPickerReact button.epr-emoji>*{align-self:center;display:block;justify-self:center}.EmojiPickerReact button.epr-emoji.epr-emoji-has-variations:hover:after{border-bottom:4px solid var(--epr-emoji-variation-indicator-color-hover)}.__EmojiPicker__.epr-emoji-img{font-size:0}.__EmojiPicker__.epr-emoji-native{align-self:center;font-family:Segoe UI Emoji,Segoe UI Symbol,Segoe UI,Apple Color Emoji,Twemoji Mozilla,Noto Color Emoji,Android Emoji,Times,Symbola,Aegyptus,Code2000,Code2001,Code2002,Musica,serif,LastResort;font-size:var(--epr-emoji-size);justify-self:center;letter-spacing:0;line-height:100%;position:relative;text-align:center}.EmojiPickerReact button.epr-emoji:hover>*{background-color:var(--epr-emoji-hover-color)}.EmojiPickerReact button.epr-emoji:focus>*{background-color:var(--epr-focus-bg-color)}';
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z);
function $2785da2b7d7107bb$var$Button(props) {
    return (0, $5VC2c.createElement)("button", Object.assign({
        type: "button"
    }, props, {
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)("epr-btn", props.className)
    }), props.children);
}
function $2785da2b7d7107bb$var$ClickableEmojiButton(_ref) {
    var _clsx;
    var emojiNames = _ref.emojiNames, unified = _ref.unified, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch, _ref$showVariations = _ref.showVariations, showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations, hasVariations = _ref.hasVariations, children = _ref.children;
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Button, {
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)($2785da2b7d7107bb$var$ClassNames.emoji, (_clsx = {}, _clsx[$2785da2b7d7107bb$var$ClassNames.hidden] = hidden, _clsx[$2785da2b7d7107bb$var$ClassNames.hiddenOnSearch] = hiddenOnSearch, _clsx[$2785da2b7d7107bb$var$ClassNames.visible] = !hidden && !hiddenOnSearch, _clsx[$2785da2b7d7107bb$var$ClassNames.emojiHasVariations] = hasVariations && showVariations, _clsx)),
        "data-unified": unified,
        "aria-label": emojiNames[0],
        "data-full-name": emojiNames
    }, children);
}
function $2785da2b7d7107bb$var$EmojiImg(_ref) {
    var emojiName = _ref.emojiName, style = _ref.style, _ref$lazyLoad = _ref.lazyLoad, lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad, imgUrl = _ref.imgUrl, onError = _ref.onError;
    return (0, $5VC2c.createElement)("img", {
        src: imgUrl,
        alt: emojiName,
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)($2785da2b7d7107bb$var$ClassNames.external, "epr-emoji-img"),
        loading: lazyLoad ? "lazy" : "eager",
        onError: onError,
        style: style
    });
}
function $2785da2b7d7107bb$var$NativeEmoji(_ref) {
    var unified = _ref.unified, style = _ref.style;
    return (0, $5VC2c.createElement)("span", {
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)($2785da2b7d7107bb$var$ClassNames.external, "epr-emoji-native"),
        "data-unified": unified,
        style: style
    }, $2785da2b7d7107bb$var$parseNativeEmoji(unified));
}
function $2785da2b7d7107bb$var$ViewOnlyEmoji(_ref) {
    var emoji = _ref.emoji, unified = _ref.unified, emojiStyle = _ref.emojiStyle, size = _ref.size, lazyLoad = _ref.lazyLoad, _ref$getEmojiUrl = _ref.getEmojiUrl, getEmojiUrl = _ref$getEmojiUrl === void 0 ? $2785da2b7d7107bb$var$emojiUrlByUnified : _ref$getEmojiUrl;
    var _useEmojisThatFailedT = $2785da2b7d7107bb$var$useEmojisThatFailedToLoadState(), setEmojisThatFailedToLoad = _useEmojisThatFailedT[1];
    var style = {};
    if (size) style.width = style.height = style.fontSize = size + "px";
    var emojiToRender = emoji ? emoji : $2785da2b7d7107bb$var$emojiByUnified(unified);
    if (!emojiToRender) return null;
    if ($2785da2b7d7107bb$var$isCustomEmoji(emojiToRender)) return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$EmojiImg, {
        style: style,
        emojiName: unified,
        emojiStyle: $2785da2b7d7107bb$export$92260a1a02147e89.NATIVE,
        lazyLoad: lazyLoad,
        imgUrl: emojiToRender.imgUrl,
        onError: onError
    });
    return (0, $5VC2c.createElement)((0, $5VC2c.Fragment), null, emojiStyle === $2785da2b7d7107bb$export$92260a1a02147e89.NATIVE ? (0, $5VC2c.createElement)($2785da2b7d7107bb$var$NativeEmoji, {
        unified: unified,
        style: style
    }) : (0, $5VC2c.createElement)($2785da2b7d7107bb$var$EmojiImg, {
        style: style,
        emojiName: $2785da2b7d7107bb$var$emojiName(emojiToRender),
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        imgUrl: getEmojiUrl(unified, emojiStyle),
        onError: onError
    }));
    function onError() {
        setEmojisThatFailedToLoad(function(prev) {
            return new Set(prev).add(unified);
        });
    }
}
function $2785da2b7d7107bb$var$ClickableEmoji(_ref) {
    var emoji = _ref.emoji, unified = _ref.unified, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch, emojiStyle = _ref.emojiStyle, _ref$showVariations = _ref.showVariations, showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations, size = _ref.size, lazyLoad = _ref.lazyLoad, getEmojiUrl = _ref.getEmojiUrl;
    var hasVariations = $2785da2b7d7107bb$var$emojiHasVariations(emoji);
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ClickableEmojiButton, {
        hasVariations: hasVariations,
        showVariations: showVariations,
        hidden: hidden,
        hiddenOnSearch: hiddenOnSearch,
        emojiNames: $2785da2b7d7107bb$var$emojiNames(emoji),
        unified: unified
    }, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ViewOnlyEmoji, {
        unified: unified,
        emoji: emoji,
        size: size,
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        getEmojiUrl: getEmojiUrl
    }));
}
var $2785da2b7d7107bb$var$css_248z$1 = ".EmojiPickerReact li.epr-emoji-category>.epr-emoji-category-content{grid-gap:0;display:grid;grid-template-columns:repeat(auto-fill,var(--epr-emoji-fullsize));justify-content:space-between;margin:var(--epr-category-padding);position:relative}.EmojiPickerReact li.epr-emoji-category:not(:has(.epr-visible)){display:none}.EmojiPickerReact li.epr-emoji-category>.epr-emoji-category-label{align-items:center;-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);background-color:var(--epr-category-label-bg-color);color:var(--epr-category-label-text-color);display:flex;font-weight:700;height:var(--epr-category-label-height);padding:var(--epr-category-label-padding);position:-webkit-sticky;position:sticky;text-transform:capitalize;top:0;width:100%;z-index:var(--epr-category-label-z-index)}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$1);
function $2785da2b7d7107bb$var$EmojiCategory(_ref) {
    var _clsx;
    var categoryConfig = _ref.categoryConfig, children = _ref.children, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch;
    var category = $2785da2b7d7107bb$var$categoryFromCategoryConfig(categoryConfig);
    var categoryName = $2785da2b7d7107bb$var$categoryNameFromCategoryConfig(categoryConfig);
    return (0, $5VC2c.createElement)("li", {
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)($2785da2b7d7107bb$var$ClassNames.category, (_clsx = {}, _clsx[$2785da2b7d7107bb$var$ClassNames.hidden] = hidden, _clsx[$2785da2b7d7107bb$var$ClassNames.hiddenOnSearch] = hiddenOnSearch, _clsx)),
        "data-name": category,
        "aria-label": categoryName
    }, (0, $5VC2c.createElement)("div", {
        className: $2785da2b7d7107bb$var$ClassNames.label
    }, categoryName), (0, $5VC2c.createElement)("div", {
        className: $2785da2b7d7107bb$var$ClassNames.categoryContent
    }, children));
}
function $2785da2b7d7107bb$var$Suggested(_ref) {
    var categoryConfig = _ref.categoryConfig;
    var _useUpdateSuggested = $2785da2b7d7107bb$var$useUpdateSuggested(), suggestedUpdated = _useUpdateSuggested[0];
    var suggestedEmojisModeConfig = $2785da2b7d7107bb$var$useSuggestedEmojisModeConfig();
    var getEmojiUrl = $2785da2b7d7107bb$var$useGetEmojiUrlConfig();
    var suggested = (0, $ir4bw.useMemo)(function() {
        var _getSuggested;
        return (_getSuggested = $2785da2b7d7107bb$var$getSuggested(suggestedEmojisModeConfig)) != null ? _getSuggested : [];
    }, [
        suggestedUpdated,
        suggestedEmojisModeConfig
    ]);
    var emojiStyle = $2785da2b7d7107bb$var$useEmojiStyleConfig();
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$EmojiCategory, {
        categoryConfig: categoryConfig,
        hiddenOnSearch: true,
        hidden: suggested.length === 0
    }, suggested.map(function(suggestedItem) {
        var emoji = $2785da2b7d7107bb$var$emojiByUnified(suggestedItem.original);
        if (!emoji) return null;
        return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ClickableEmoji, {
            showVariations: false,
            unified: suggestedItem.unified,
            emojiStyle: emojiStyle,
            emoji: emoji,
            key: suggestedItem.unified,
            getEmojiUrl: getEmojiUrl
        });
    }));
}
var $2785da2b7d7107bb$var$css_248z$2 = ".EmojiPickerReact ul.epr-emoji-list{list-style:none;margin:0;padding:0}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$2);
function $2785da2b7d7107bb$var$EmojiList() {
    var categories = $2785da2b7d7107bb$var$useCategoriesConfig();
    return (0, $5VC2c.createElement)("ul", {
        className: $2785da2b7d7107bb$var$ClassNames.emojiList
    }, categories.map(function(categoryConfig, index) {
        var category = $2785da2b7d7107bb$var$categoryFromCategoryConfig(categoryConfig);
        if (category === $2785da2b7d7107bb$export$e1e795cef0e670e6.SUGGESTED) return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Suggested, {
            key: category,
            categoryConfig: categoryConfig
        });
        return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$RenderCategory, {
            key: category,
            index: index,
            category: category,
            categoryConfig: categoryConfig
        });
    }));
}
function $2785da2b7d7107bb$var$RenderCategory(_ref) {
    var index = _ref.index, category = _ref.category, categoryConfig = _ref.categoryConfig;
    var isEmojiHidden = $2785da2b7d7107bb$var$useIsEmojiHidden();
    var lazyLoadEmojis = $2785da2b7d7107bb$var$useLazyLoadEmojisConfig();
    var emojiStyle = $2785da2b7d7107bb$var$useEmojiStyleConfig();
    var isPastInitialLoad = $2785da2b7d7107bb$var$useIsPastInitialLoad();
    var _useActiveSkinToneSta = $2785da2b7d7107bb$var$useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0];
    var isEmojiDisallowed = $2785da2b7d7107bb$var$useIsEmojiDisallowed();
    var getEmojiUrl = $2785da2b7d7107bb$var$useGetEmojiUrlConfig();
    var showVariations = !$2785da2b7d7107bb$var$useSkinTonesDisabledConfig(); // Small trick to defer the rendering of all emoji categories until the first category is visible
    // This way the user gets to actually see something and not wait for the whole picker to render.
    var emojisToPush = !isPastInitialLoad && index > 1 ? [] : $2785da2b7d7107bb$var$emojisByCategory(category);
    var hiddenCounter = 0;
    var emojis = emojisToPush.map(function(emoji) {
        var unified = $2785da2b7d7107bb$var$emojiUnified(emoji, activeSkinTone);
        var _isEmojiHidden = isEmojiHidden(emoji), failedToLoad = _isEmojiHidden.failedToLoad, filteredOut = _isEmojiHidden.filteredOut, hidden = _isEmojiHidden.hidden;
        var isDisallowed = isEmojiDisallowed(emoji);
        if (hidden || isDisallowed) hiddenCounter++;
        if (isDisallowed) return null;
        return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ClickableEmoji, {
            showVariations: showVariations,
            key: unified,
            emoji: emoji,
            unified: unified,
            hidden: failedToLoad,
            hiddenOnSearch: filteredOut,
            emojiStyle: emojiStyle,
            lazyLoad: lazyLoadEmojis,
            getEmojiUrl: getEmojiUrl
        });
    });
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$EmojiCategory, {
        categoryConfig: categoryConfig,
        // Indicates that there are no visible emojis
        // Hence, the category should be hidden
        hidden: hiddenCounter === emojis.length
    }, emojis);
}
function $2785da2b7d7107bb$var$focusFirstVisibleEmoji(parent) {
    var emoji = $2785da2b7d7107bb$var$firstVisibleEmoji(parent);
    $2785da2b7d7107bb$var$focusElement(emoji);
    $2785da2b7d7107bb$var$scrollEmojiAboveLabel(emoji);
}
function $2785da2b7d7107bb$var$focusAndClickFirstVisibleEmoji(parent) {
    var firstEmoji = $2785da2b7d7107bb$var$firstVisibleEmoji(parent);
    $2785da2b7d7107bb$var$focusElement(firstEmoji);
    firstEmoji == null || firstEmoji.click();
}
function $2785da2b7d7107bb$var$focusLastVisibleEmoji(parent) {
    $2785da2b7d7107bb$var$focusElement($2785da2b7d7107bb$var$lastVisibleEmoji(parent));
}
function $2785da2b7d7107bb$var$focusNextVisibleEmoji(element) {
    if (!element) return;
    var next = $2785da2b7d7107bb$var$nextVisibleEmoji(element);
    if (!next) return $2785da2b7d7107bb$var$focusFirstVisibleEmoji($2785da2b7d7107bb$var$nextCategory(element));
    $2785da2b7d7107bb$var$focusElement(next);
    $2785da2b7d7107bb$var$scrollEmojiAboveLabel(next);
}
function $2785da2b7d7107bb$var$focusPrevVisibleEmoji(element) {
    if (!element) return;
    var prev = $2785da2b7d7107bb$var$prevVisibleEmoji(element);
    if (!prev) return $2785da2b7d7107bb$var$focusLastVisibleEmoji($2785da2b7d7107bb$var$prevCategory(element));
    $2785da2b7d7107bb$var$focusElement(prev);
    $2785da2b7d7107bb$var$scrollEmojiAboveLabel(prev);
}
function $2785da2b7d7107bb$var$focusVisibleEmojiOneRowUp(element, exitUp) {
    if (!element) return;
    var prev = $2785da2b7d7107bb$var$visibleEmojiOneRowUp(element);
    if (!prev) return exitUp();
    $2785da2b7d7107bb$var$focusElement(prev);
    $2785da2b7d7107bb$var$scrollEmojiAboveLabel(prev);
}
function $2785da2b7d7107bb$var$focusVisibleEmojiOneRowDown(element) {
    if (!element) return;
    var next = $2785da2b7d7107bb$var$visibleEmojiOneRowDown(element);
    return $2785da2b7d7107bb$var$focusElement(next);
}
function $2785da2b7d7107bb$var$visibleEmojiOneRowUp(element) {
    if (!element) return null;
    var categoryContent = $2785da2b7d7107bb$var$closestCategoryContent(element);
    var category = $2785da2b7d7107bb$var$closestCategory(categoryContent);
    var indexInRow = $2785da2b7d7107bb$var$elementIndexInRow(categoryContent, element);
    var row = $2785da2b7d7107bb$var$rowNumber(categoryContent, element);
    var countInRow = $2785da2b7d7107bb$var$elementCountInRow(categoryContent, element);
    if (row === 0) {
        var prevVisibleCategory = $2785da2b7d7107bb$var$prevCategory(category);
        if (!prevVisibleCategory) return null;
        return $2785da2b7d7107bb$var$getElementInRow($2785da2b7d7107bb$var$allVisibleEmojis(prevVisibleCategory), -1, countInRow, indexInRow);
    }
    return $2785da2b7d7107bb$var$getElementInPrevRow($2785da2b7d7107bb$var$allVisibleEmojis(categoryContent), row, countInRow, indexInRow);
}
function $2785da2b7d7107bb$var$visibleEmojiOneRowDown(element) {
    if (!element) return null;
    var categoryContent = $2785da2b7d7107bb$var$closestCategoryContent(element);
    var category = $2785da2b7d7107bb$var$closestCategory(categoryContent);
    var indexInRow = $2785da2b7d7107bb$var$elementIndexInRow(categoryContent, element);
    var row = $2785da2b7d7107bb$var$rowNumber(categoryContent, element);
    var countInRow = $2785da2b7d7107bb$var$elementCountInRow(categoryContent, element);
    if (!$2785da2b7d7107bb$var$hasNextRow(categoryContent, element)) {
        var nextVisibleCategory = $2785da2b7d7107bb$var$nextCategory(category);
        if (!nextVisibleCategory) return null;
        return $2785da2b7d7107bb$var$getElementInRow($2785da2b7d7107bb$var$allVisibleEmojis(nextVisibleCategory), 0, countInRow, indexInRow);
    }
    var itemInNextRow = $2785da2b7d7107bb$var$getElementInNextRow($2785da2b7d7107bb$var$allVisibleEmojis(categoryContent), row, countInRow, indexInRow);
    return itemInNextRow;
}
var $2785da2b7d7107bb$var$css_248z$3 = ".EmojiPickerReact .epr-emoji-variation-picker{align-items:center;background:var(--epr-emoji-variation-picker-bg-color);border:1px solid var(--epr-picker-border-color);border-radius:3px;box-shadow:0 2px 5px rgba(0,0,0,.2);display:flex;height:0;height:var(--epr-emoji-variation-picker-height);justify-content:space-around;left:15px;opacity:0;padding:5px;pointer-events:none;position:absolute;right:15px;top:0;top:-100%;transform:scale(.9);transition:transform .1s ease-out,opacity .2s ease-out;visibility:hidden;z-index:var(--epr-skin-variation-picker-z-index)}.EmojiPickerReact .epr-emoji-variation-picker.pointing-up{transform:scale(.9);transform-origin:center 0}.EmojiPickerReact .epr-emoji-variation-picker.visible{opacity:1;pointer-events:all;transform:scale(1);visibility:visible}.EmojiPickerReact .epr-emoji-variation-picker .EmojiPickerReact .epr-emoji-variation-picker button.epr-emoji:hover{background:none}.EmojiPickerReact .epr-emoji-variation-picker .epr-emoji-pointer{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50' height='15' xml:space='preserve'%3E%3Cg stroke-miterlimit='10'%3E%3Cpath fill='%23FFF' stroke='%23E8E7E7' d='m1.86-.43 9.83 11.53c.59.69 1.56.69 2.14 0L23.66-.43'/%3E%3Cpath fill='%23010202' stroke='%23151617' d='m26.86-.43 9.83 11.53c.59.69 1.56.69 2.14 0L48.66-.43'/%3E%3C/g%3E%3C/svg%3E\");background-position:0 0;background-repeat:no-repeat;background-size:50px 15px;content:\"\";height:15px;position:absolute;top:-10px;width:25px}.EmojiPickerReact.epr-dark-theme .epr-emoji-variation-picker .epr-emoji-pointer{background-position:-25px 0}.EmojiPickerReact .epr-emoji-variation-picker .epr-emoji-pointer{top:100%;transform:translateX(-18px)}.EmojiPickerReact .epr-emoji-variation-picker.pointing-up .epr-emoji-pointer{top:0;transform:rotate(180deg) translateY(100%) translateX(18px)}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$3);
var $2785da2b7d7107bb$var$Direction;
(function(Direction) {
    Direction[Direction["Up"] = 0] = "Up";
    Direction[Direction["Down"] = 1] = "Down";
})($2785da2b7d7107bb$var$Direction || ($2785da2b7d7107bb$var$Direction = {}));
function $2785da2b7d7107bb$var$EmojiVariationPicker() {
    var AnchoredEmojiRef = $2785da2b7d7107bb$var$useAnchoredEmojiRef();
    var VariationPickerRef = $2785da2b7d7107bb$var$useVariationPickerRef();
    var _useEmojiVariationPic = $2785da2b7d7107bb$var$useEmojiVariationPickerState(), emoji = _useEmojiVariationPic[0];
    var emojiStyle = $2785da2b7d7107bb$var$useEmojiStyleConfig();
    var _useVariationPickerTo = $2785da2b7d7107bb$var$useVariationPickerTop(VariationPickerRef), getTop = _useVariationPickerTo.getTop, getMenuDirection = _useVariationPickerTo.getMenuDirection;
    var setAnchoredEmojiRef = $2785da2b7d7107bb$var$useSetAnchoredEmojiRef();
    var getPointerStyle = $2785da2b7d7107bb$var$usePointerStyle(VariationPickerRef);
    var getEmojiUrl = $2785da2b7d7107bb$var$useGetEmojiUrlConfig();
    var button = $2785da2b7d7107bb$var$buttonFromTarget(AnchoredEmojiRef.current);
    var visible = emoji && button && $2785da2b7d7107bb$var$emojiHasVariations(emoji) && button.classList.contains($2785da2b7d7107bb$var$ClassNames.emojiHasVariations);
    (0, $ir4bw.useEffect)(function() {
        if (!visible) return;
        $2785da2b7d7107bb$var$focusFirstVisibleEmoji(VariationPickerRef.current);
    }, [
        VariationPickerRef,
        visible,
        AnchoredEmojiRef
    ]);
    var top, pointerStyle;
    if (!visible && AnchoredEmojiRef.current) setAnchoredEmojiRef(null);
    else {
        top = getTop();
        pointerStyle = getPointerStyle();
    }
    return (0, $5VC2c.createElement)("div", {
        ref: VariationPickerRef,
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)($2785da2b7d7107bb$var$ClassNames.variationPicker, {
            visible: visible,
            "pointing-up": getMenuDirection() === $2785da2b7d7107bb$var$Direction.Down
        }),
        style: {
            top: top
        }
    }, visible && emoji ? [
        $2785da2b7d7107bb$var$emojiUnified(emoji)
    ].concat($2785da2b7d7107bb$var$emojiVariations(emoji)).slice(0, 6).map(function(unified) {
        return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ClickableEmoji, {
            key: unified,
            emoji: emoji,
            unified: unified,
            emojiStyle: emojiStyle,
            showVariations: false,
            getEmojiUrl: getEmojiUrl
        });
    }) : null, (0, $5VC2c.createElement)("div", {
        className: "epr-emoji-pointer",
        style: pointerStyle
    }));
}
function $2785da2b7d7107bb$var$usePointerStyle(VariationPickerRef) {
    var AnchoredEmojiRef = $2785da2b7d7107bb$var$useAnchoredEmojiRef();
    return function getPointerStyle() {
        var style = {};
        if (!VariationPickerRef.current) return style;
        if (AnchoredEmojiRef.current) {
            var button = $2785da2b7d7107bb$var$buttonFromTarget(AnchoredEmojiRef.current);
            var offsetLeft = $2785da2b7d7107bb$var$emojiTruOffsetLeft(button);
            if (!button) return style;
             // half of the button
            style.left = offsetLeft + (button == null ? void 0 : button.clientWidth) / 2;
        }
        return style;
    };
}
function $2785da2b7d7107bb$var$useVariationPickerTop(VariationPickerRef) {
    var AnchoredEmojiRef = $2785da2b7d7107bb$var$useAnchoredEmojiRef();
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    var direction = $2785da2b7d7107bb$var$Direction.Up;
    return {
        getMenuDirection: getMenuDirection,
        getTop: getTop
    };
    function getMenuDirection() {
        return direction;
    }
    function getTop() {
        direction = $2785da2b7d7107bb$var$Direction.Up;
        var emojiOffsetTop = 0;
        if (!VariationPickerRef.current) return 0;
        var height = $2785da2b7d7107bb$var$elementHeight(VariationPickerRef.current);
        if (AnchoredEmojiRef.current) {
            var _bodyRef$scrollTop;
            var bodyRef = BodyRef.current;
            var button = $2785da2b7d7107bb$var$buttonFromTarget(AnchoredEmojiRef.current);
            var buttonHeight = $2785da2b7d7107bb$var$elementHeight(button);
            emojiOffsetTop = $2785da2b7d7107bb$var$emojiTrueOffsetTop(button);
            var scrollTop = (_bodyRef$scrollTop = bodyRef == null ? void 0 : bodyRef.scrollTop) != null ? _bodyRef$scrollTop : 0;
            if (scrollTop > emojiOffsetTop - height) {
                direction = $2785da2b7d7107bb$var$Direction.Down;
                emojiOffsetTop += buttonHeight + height;
            }
        }
        return emojiOffsetTop - height;
    }
}
var $2785da2b7d7107bb$var$css_248z$4 = ".EmojiPickerReact .epr-body{flex:1;overflow-x:hidden;overflow-y:scroll;position:relative}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$4);
function $2785da2b7d7107bb$var$Body() {
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    $2785da2b7d7107bb$var$useOnScroll(BodyRef);
    $2785da2b7d7107bb$var$useMouseDownHandlers(BodyRef);
    $2785da2b7d7107bb$var$useOnMouseMove();
    return (0, $5VC2c.createElement)("div", {
        className: $2785da2b7d7107bb$var$ClassNames.scrollBody,
        ref: BodyRef
    }, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$EmojiVariationPicker, null), (0, $5VC2c.createElement)($2785da2b7d7107bb$var$EmojiList, null));
}
function $2785da2b7d7107bb$var$useEmojiPreviewEvents(allow, setPreviewEmoji) {
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    var isMouseDisallowed = $2785da2b7d7107bb$var$useIsMouseDisallowed();
    var allowMouseMove = $2785da2b7d7107bb$var$useAllowMouseMove();
    (0, $ir4bw.useEffect)(function() {
        if (!allow) return;
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener("keydown", onEscape, {
            passive: true
        });
        bodyRef == null || bodyRef.addEventListener("mouseover", onMouseOver, true);
        bodyRef == null || bodyRef.addEventListener("focus", onEnter, true);
        bodyRef == null || bodyRef.addEventListener("mouseout", onLeave, {
            passive: true
        });
        bodyRef == null || bodyRef.addEventListener("blur", onLeave, true);
        function onEnter(e) {
            var button = $2785da2b7d7107bb$var$buttonFromTarget(e.target);
            if (!button) return onLeave();
            var unified = $2785da2b7d7107bb$var$unifiedFromEmojiElement(button);
            var originalUnified = $2785da2b7d7107bb$var$originalUnifiedFromEmojiElement(button);
            if (!unified || !originalUnified) return onLeave();
            setPreviewEmoji({
                unified: unified,
                originalUnified: originalUnified
            });
        }
        function onLeave(e) {
            if (e) {
                var relatedTarget = e.relatedTarget;
                if (!$2785da2b7d7107bb$var$buttonFromTarget(relatedTarget)) return setPreviewEmoji(null);
            }
            setPreviewEmoji(null);
        }
        function onEscape(e) {
            if (e.key === "Escape") setPreviewEmoji(null);
        }
        function onMouseOver(e) {
            if (isMouseDisallowed()) return;
            var button = $2785da2b7d7107bb$var$buttonFromTarget(e.target);
            if (button) $2785da2b7d7107bb$var$focusElement(button);
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener("mouseover", onMouseOver);
            bodyRef == null || bodyRef.removeEventListener("mouseout", onLeave);
            bodyRef == null || bodyRef.removeEventListener("focus", onEnter, true);
            bodyRef == null || bodyRef.removeEventListener("blur", onLeave, true);
            bodyRef == null || bodyRef.removeEventListener("keydown", onEscape);
        };
    }, [
        BodyRef,
        allow,
        setPreviewEmoji,
        isMouseDisallowed,
        allowMouseMove
    ]);
}
function $2785da2b7d7107bb$var$useIsSkinToneInSearch() {
    var skinTonePickerLocationConfig = $2785da2b7d7107bb$var$useSkinTonePickerLocationConfig();
    return skinTonePickerLocationConfig === $2785da2b7d7107bb$export$da9a330bf5ab5dfb.SEARCH;
}
function $2785da2b7d7107bb$var$useIsSkinToneInPreview() {
    var skinTonePickerLocationConfig = $2785da2b7d7107bb$var$useSkinTonePickerLocationConfig();
    return skinTonePickerLocationConfig === $2785da2b7d7107bb$export$da9a330bf5ab5dfb.PREVIEW;
}
var $2785da2b7d7107bb$var$css_248z$5 = ".EmojiPickerReact .Flex{display:flex}.EmojiPickerReact .Flex.FlexRow{flex-direction:row}.EmojiPickerReact .Flex.FlexColumn{flex-direction:column}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$5);
var $2785da2b7d7107bb$var$FlexDirection;
(function(FlexDirection) {
    FlexDirection["ROW"] = "FlexRow";
    FlexDirection["COLUMN"] = "FlexColumn";
})($2785da2b7d7107bb$var$FlexDirection || ($2785da2b7d7107bb$var$FlexDirection = {}));
function $2785da2b7d7107bb$var$Flex(_ref) {
    var children = _ref.children, className = _ref.className, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? $2785da2b7d7107bb$var$FlexDirection.ROW : _ref$direction;
    return (0, $5VC2c.createElement)("div", {
        style: $2785da2b7d7107bb$var$_extends({}, style),
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)("Flex", className, direction)
    }, children);
}
function $2785da2b7d7107bb$var$Space(_ref) {
    var className = _ref.className, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    return (0, $5VC2c.createElement)("div", {
        style: $2785da2b7d7107bb$var$_extends({
            flex: 1
        }, style),
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)(className)
    });
}
var $2785da2b7d7107bb$var$css_248z$6 = ".EmojiPickerReact .epr-preview{align-items:center;border-top:1px solid var(--epr-preview-border-color);height:var(--epr-preview-height);padding:0 var(--epr-horizontal-padding);position:relative;z-index:1;z-index:var(--epr-preview-z-index)}.EmojiPickerReact .epr-preview .epr-preview-emoji-label{color:var(--epr-preview-text-color);font-size:var(--epr-preview-text-size);padding:var(--epr-preview-text-padding);text-transform:capitalize}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$6);
function $2785da2b7d7107bb$var$Absolute(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style;
    return (0, $5VC2c.createElement)("div", {
        style: $2785da2b7d7107bb$var$_extends({}, style, {
            position: "absolute"
        }),
        className: className
    }, children);
}
function $2785da2b7d7107bb$var$Relative(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style;
    return (0, $5VC2c.createElement)("div", {
        style: $2785da2b7d7107bb$var$_extends({}, style, {
            position: "relative"
        }),
        className: className
    }, children);
}
var $2785da2b7d7107bb$var$css_248z$7 = '.EmojiPickerReact .epr-skin-tones{--epr-skin-tone-size:15px;align-items:center;display:flex;justify-content:flex-end;padding:10px 0;transition:all .3s ease-in-out}.EmojiPickerReact .epr-skin-tones.epr-vertical{align-items:flex-end;border:1px solid var(--epr-bg-color);border-radius:6px;flex-direction:column;padding:5px}.EmojiPickerReact .epr-skin-tones.epr-vertical.epr-open{-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);background:var(--epr-skin-tone-picker-menu-color);border:1px solid var(--epr-picker-border-color)}.EmojiPickerReact .epr-skin-tone-select{height:var(--epr-skin-tone-size);position:relative;width:var(--epr-skin-tone-size)}.EmojiPickerReact .epr-skin-tones.epr-open .epr-tone{transition:transform .3s ease-in-out,opacity .3s ease-in-out}.EmojiPickerReact .epr-skin-tones:not(.epr-open) .epr-tone{opacity:0;z-index:0}.EmojiPickerReact .epr-skin-tones .epr-tone{border-radius:4px;box-shadow:0 0 0 0 var(--epr-active-skin-hover-color);cursor:pointer;display:block;height:var(--epr-skin-tone-size);position:absolute;right:0;transition:transform .3s ease-in-out,opacity .5s ease-in-out;width:var(--epr-skin-tone-size);z-index:1}.EmojiPickerReact .epr-skin-tones .epr-tone:hover{box-shadow:0 0 0 3px var(--epr-active-skin-hover-color)}.EmojiPickerReact .epr-skin-tones .epr-tone:focus{box-shadow:0 0 0 3px var(--epr-focus-bg-color)}.EmojiPickerReact .epr-skin-tones.epr-open .epr-skin-tone-select .epr-tone.epr-active:after{border:1px solid var(--epr-active-skin-tone-indicator-border-color);border-radius:5px;bottom:-2px;content:"";left:-2px;position:absolute;right:-2px;top:-2px}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-active{opacity:1;z-index:1}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-neutral{background-color:#ffd225}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3fb{background-color:#ffdfbd}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3fc{background-color:#e9c197}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3fd{background-color:#c88e62}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3fe{background-color:#a86637}.EmojiPickerReact .epr-skin-tones .epr-tone.epr-tone-1f3ff{background-color:#60463a}';
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$7);
var $2785da2b7d7107bb$var$ITEM_SIZE = 28;
function $2785da2b7d7107bb$var$SkinTonePickerMenu() {
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Relative, {
        style: {
            height: $2785da2b7d7107bb$var$ITEM_SIZE
        }
    }, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Absolute, {
        style: {
            bottom: 0,
            right: 0
        }
    }, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$SkinTonePicker, {
        direction: $2785da2b7d7107bb$var$SkinTonePickerDirection.VERTICAL
    })));
}
function $2785da2b7d7107bb$var$SkinTonePicker(_ref) {
    var _clsx;
    var _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? $2785da2b7d7107bb$var$SkinTonePickerDirection.HORIZONTAL : _ref$direction;
    var SkinTonePickerRef = $2785da2b7d7107bb$var$useSkinTonePickerRef();
    var isDisabled = $2785da2b7d7107bb$var$useSkinTonesDisabledConfig();
    var _useSkinToneFanOpenSt = $2785da2b7d7107bb$var$useSkinToneFanOpenState(), isOpen = _useSkinToneFanOpenSt[0], setIsOpen = _useSkinToneFanOpenSt[1];
    var _useActiveSkinToneSta = $2785da2b7d7107bb$var$useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0], setActiveSkinTone = _useActiveSkinToneSta[1];
    var closeAllOpenToggles = $2785da2b7d7107bb$var$useCloseAllOpenToggles();
    var focusSearchInput = $2785da2b7d7107bb$var$useFocusSearchInput();
    if (isDisabled) return null;
    var fullWidth = $2785da2b7d7107bb$var$ITEM_SIZE * $2785da2b7d7107bb$var$skinToneVariations.length + "px";
    var expandedSize = isOpen ? fullWidth : $2785da2b7d7107bb$var$ITEM_SIZE + "px";
    var vertical = direction === $2785da2b7d7107bb$var$SkinTonePickerDirection.VERTICAL;
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Relative, {
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)("epr-skin-tones", direction, (_clsx = {}, _clsx[$2785da2b7d7107bb$var$ClassNames.open] = isOpen, _clsx)),
        style: vertical ? {
            flexBasis: expandedSize,
            height: expandedSize
        } : {
            flexBasis: expandedSize
        }
    }, (0, $5VC2c.createElement)("div", {
        className: "epr-skin-tone-select",
        ref: SkinTonePickerRef
    }, $2785da2b7d7107bb$var$skinToneVariations.map(function(skinToneVariation, i) {
        var _clsx2;
        var active = skinToneVariation === activeSkinTone;
        return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Button, {
            style: {
                transform: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)(vertical ? "translateY(-" + i * (isOpen ? $2785da2b7d7107bb$var$ITEM_SIZE : 0) + "px)" : "translateX(-" + i * (isOpen ? $2785da2b7d7107bb$var$ITEM_SIZE : 0) + "px)", isOpen && active && "scale(1.3)")
            },
            onClick: function onClick() {
                if (isOpen) {
                    setActiveSkinTone(skinToneVariation);
                    focusSearchInput();
                } else setIsOpen(true);
                closeAllOpenToggles();
            },
            key: skinToneVariation,
            className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)("epr-tone-" + skinToneVariation, "epr-tone", (_clsx2 = {}, _clsx2[$2785da2b7d7107bb$var$ClassNames.active] = active, _clsx2)),
            tabIndex: isOpen ? 0 : -1,
            "aria-pressed": active,
            "aria-label": "Skin tone " + $2785da2b7d7107bb$var$skinTonesNamed[skinToneVariation]
        });
    })));
}
var $2785da2b7d7107bb$var$SkinTonePickerDirection;
(function(SkinTonePickerDirection) {
    SkinTonePickerDirection["VERTICAL"] = "epr-vertical";
    SkinTonePickerDirection["HORIZONTAL"] = "epr-horizontal";
})($2785da2b7d7107bb$var$SkinTonePickerDirection || ($2785da2b7d7107bb$var$SkinTonePickerDirection = {}));
function $2785da2b7d7107bb$var$Preview() {
    var previewConfig = $2785da2b7d7107bb$var$usePreviewConfig();
    var isSkinToneInPreview = $2785da2b7d7107bb$var$useIsSkinToneInPreview();
    if (!previewConfig.showPreview) return null;
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Flex, {
        className: "epr-preview"
    }, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$PreviewBody, null), (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Space, null), isSkinToneInPreview ? (0, $5VC2c.createElement)($2785da2b7d7107bb$var$SkinTonePickerMenu, null) : null);
}
function $2785da2b7d7107bb$var$PreviewBody() {
    var previewConfig = $2785da2b7d7107bb$var$usePreviewConfig();
    var _useState = (0, $ir4bw.useState)(null), previewEmoji = _useState[0], setPreviewEmoji = _useState[1];
    var emojiStyle = $2785da2b7d7107bb$var$useEmojiStyleConfig();
    var _useEmojiVariationPic = $2785da2b7d7107bb$var$useEmojiVariationPickerState(), variationPickerEmoji = _useEmojiVariationPic[0];
    var getEmojiUrl = $2785da2b7d7107bb$var$useGetEmojiUrlConfig();
    $2785da2b7d7107bb$var$useEmojiPreviewEvents(previewConfig.showPreview, setPreviewEmoji);
    var emoji = $2785da2b7d7107bb$var$emojiByUnified(previewEmoji == null ? void 0 : previewEmoji.originalUnified);
    var show = emoji != null && previewEmoji != null;
    return (0, $5VC2c.createElement)(PreviewContent, null);
    function PreviewContent() {
        var defaultEmoji = variationPickerEmoji != null ? variationPickerEmoji : $2785da2b7d7107bb$var$emojiByUnified(previewConfig.defaultEmoji);
        if (!defaultEmoji) return null;
        var defaultText = variationPickerEmoji ? $2785da2b7d7107bb$var$emojiName(variationPickerEmoji) : previewConfig.defaultCaption;
        return (0, $5VC2c.createElement)((0, $5VC2c.Fragment), null, (0, $5VC2c.createElement)("div", null, show ? (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ViewOnlyEmoji, {
            unified: previewEmoji == null ? void 0 : previewEmoji.unified,
            emoji: emoji,
            emojiStyle: emojiStyle,
            size: 45,
            getEmojiUrl: getEmojiUrl
        }) : defaultEmoji ? (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ViewOnlyEmoji, {
            unified: $2785da2b7d7107bb$var$emojiUnified(defaultEmoji),
            emoji: defaultEmoji,
            emojiStyle: emojiStyle,
            size: 45,
            getEmojiUrl: getEmojiUrl
        }) : null), show ? (0, $5VC2c.createElement)("div", {
            className: "epr-preview-emoji-label"
        }, $2785da2b7d7107bb$var$emojiName(emoji)) : (0, $5VC2c.createElement)("div", {
            className: "epr-preview-emoji-label"
        }, defaultText));
    }
}
var $2785da2b7d7107bb$var$css_248z$8 = ".EmojiPickerReact .epr-category-nav{display:flex;flex-direction:row;justify-content:space-around;padding:var(--epr-header-padding)}.EmojiPickerReact .epr-category-nav>button.epr-cat-btn{background-size:calc(var(--epr-category-navigation-button-size)*10);display:inline-block;height:var(--epr-category-navigation-button-size);outline:none;position:relative;transition:opacity .2s ease-in-out;width:var(--epr-category-navigation-button-size)}.EmojiPickerReact .epr-category-nav>button.epr-cat-btn:focus:before{border:2px solid var(--epr-category-icon-active-color);border-radius:50%;bottom:-2px;content:\"\";left:-2px;position:absolute;right:-2px;top:-2px}aside.EmojiPickerReact.epr-main:has(input:not(:-moz-placeholder-shown)) .epr-category-nav{cursor:default;opacity:.3;pointer-events:none}aside.EmojiPickerReact.epr-main:has(input:not(:placeholder-shown)) .epr-category-nav{cursor:default;opacity:.3;pointer-events:none}.EmojiPickerReact.epr-search-active .epr-category-nav{cursor:default;opacity:.3;pointer-events:none}aside.EmojiPickerReact.epr-main:has(input:not(:-moz-placeholder-shown)) .epr-category-nav>button.epr-cat-btn:hover{background-position-y:var(--epr-category-navigation-button-size);opacity:1}aside.EmojiPickerReact.epr-main:has(input:not(:placeholder-shown)) .epr-category-nav>button.epr-cat-btn:hover{background-position-y:var(--epr-category-navigation-button-size);opacity:1}.EmojiPickerReact:not(.epr-search-active) .epr-category-nav>button.epr-cat-btn.epr-active,.EmojiPickerReact:not(.epr-search-active) .epr-category-nav>button.epr-cat-btn:hover{background-position-y:var(--epr-category-navigation-button-size);opacity:1}.EmojiPickerReact .epr-category-nav>button.epr-cat-btn{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='80' xml:space='preserve'%3E%3Cg fill='%233371B7' stroke='%233371B7' stroke-width='.1' stroke-miterlimit='10'%3E%3Cpath d='M12.8 29.5c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.2-1.1-1.2-.6 0-1.2.5-1.2 1.2 0 .6.6 1.1 1.2 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4z'/%3E%3Cpath d='M10 23c-3.8 0-7 3.1-7 7 0 3.8 3.1 7 7 7s7-3.1 7-7c0-3.8-3.2-7-7-7zm0 13.2c-3.4 0-6.2-2.8-6.2-6.2 0-3.4 2.8-6.2 6.2-6.2s6.2 2.8 6.2 6.2c0 3.4-2.8 6.2-6.2 6.2z'/%3E%3Cpath d='M14.6 31.2c-.1-.1-.2-.2-.3-.2H5.7c-.1 0-.2.1-.3.2-.1.1-.1.2 0 .4.7 2 2.5 3.3 4.6 3.3s3.9-1.3 4.6-3.3c.1-.1.1-.3 0-.4zM10 34.1c-1.6 0-3-.9-3.7-2.2h7.3c-.6 1.3-2 2.2-3.6 2.2zm-2.8-4.6c.6 0 1.2-.5 1.2-1.1 0-.6-.5-1.2-1.2-1.2-.6 0-1.1.5-1.1 1.2 0 .6.5 1.1 1.1 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%233371B7' d='M64.1 33.4h2.3c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.3c-.2 0-.4-.2-.4-.4v-2.1c0-.2.1-.4.4-.4zm9.4.1h2.4c.2 0 .4.2.4.4v2c0 .2-.2.4-.4.4h-2.4c-.2 0-.4-.2-.4-.4v-2c0-.3.2-.4.4-.4zm-9.8-5.1h12.6v5H63.7v-5z'/%3E%3Cpath fill='none' stroke='%233371B7' d='M65.5 23.6h8.9c1 0 1.9.8 1.9 1.9v3.1H63.7v-3.1c0-1 .8-1.9 1.8-1.9z'/%3E%3Cellipse fill='%233371B7' cx='66.2' cy='30.9' rx='.9' ry='1'/%3E%3Cellipse fill='%233371B7' cx='73.8' cy='30.9' rx='.9' ry='1'/%3E%3Cg fill='none' stroke='%233371B7'%3E%3Cpath d='M96.4 30c0 3.6-2.9 6.5-6.4 6.5s-6.4-2.9-6.4-6.5 2.9-6.5 6.4-6.5 6.4 2.9 6.4 6.5z'/%3E%3Cpath d='M96.3 28.6v.1c-.9.1-2.9.1-4.6-1.1-1.1-.8-2-1.7-2.6-2.5-.3-.4-.6-.8-.7-1-.1-.1-.1-.1-.1-.2.5-.1 1.2-.2 2-.1 1.2 0 2.5.3 3.5 1.1s1.7 1.8 2.1 2.8c.2.2.3.6.4.9zM84 32.2v-.1c.9-.2 2.9-.4 4.7.6 1.1.7 1.9 1.5 2.4 2.3.4.5.6 1 .7 1.3-.4.1-1 .2-1.7.3-1 0-2.1-.1-3.2-.8s-1.9-1.6-2.4-2.5c-.3-.5-.4-.8-.5-1.1z'/%3E%3C/g%3E%3Cg fill='none' stroke='%233371B7'%3E%3Cpath stroke-linecap='round' d='m116.3 26.8-1.4 2-.8-.8-.6-.6v.9l-.1 8.2h-6.8l-.1-8.2v-.9l-.6.6-.8.8-1.4-2 2.6-2.9c.1-.1.2-.1.3-.1h1.3l.4.7c.7 1.3 2.6 1.3 3.3-.1l.3-.6h1.2c.1 0 .2 0 .3.1l.3-.3-.3.3 2.9 2.9z'/%3E%3Cpath d='M110.1 27.7h2v.9c0 .4-.4.7-1 .7s-1-.3-1-.7v-.9z'/%3E%3C/g%3E%3Cpath d='M126.8 34.3c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2 1 2.2 2.2zm10.8 0c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c1.2 0 2.2 1 2.2 2.2zm-10.8-9.9v9.9m10.9-9.9v9.9m-10.9-10.8h10.8v2.7h-10.8v-2.7z' fill='none' stroke='%233371B7'/%3E%3Cg fill='%233371B7'%3E%3Cpath d='M170.8 23.1h-.8c-2.1 0-4 1-5.3 2.5h-.1l-.1-.1-1-1.2-.3 3.4 3.4.3-1.1-1.3-.1-.1.1-.1c1.1-1.5 3-2.3 5-2.1 3.2.3 5.5 3.1 5.2 6.3-.3 3-3.1 5.3-6.1 5.1-3.1-.2-5.4-2.9-5.3-6l-1.3-.1c-.2 3.8 2.6 7.1 6.3 7.4 3.9.3 7.3-2.6 7.6-6.5.3-3.8-2.5-7.1-6.1-7.5z'/%3E%3Cpath d='M170.3 27.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v3.2c0 .2.1.3.2.4.1.1.3.2.4.2h2.4c.4 0 .6-.3.6-.6 0-.4-.3-.6-.6-.6h-1.8v-2.6z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%233371B7' d='M186.2 23.4h7.7c1.5 0 2.7 1.2 2.7 2.7v7.7c0 1.5-1.2 2.7-2.7 2.7h-7.7c-1.5 0-2.7-1.2-2.7-2.7v-7.7c-.1-1.5 1.2-2.7 2.7-2.7z'/%3E%3Ccircle fill='%233371B7' cx='186' cy='28.9' r='.7'/%3E%3Ccircle fill='%233371B7' cx='194' cy='26.7' r='.7'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='m186 33.3.4-.3c.4-.3 1-.3 1.5-.1l1 .4c.5.2 1 .2 1.5-.1l.8-.5c.4-.3 1-.3 1.5-.1l1.8.8'/%3E%3Cpath fill='%233371B7' stroke='%233371B7' stroke-width='.25' stroke-miterlimit='10' d='M156 24.3c-.2-.1-.4-.1-.5 0 0 0-.2.1-.9.2-.7 0-2.4-.1-3.8-.6-.8-.3-1.7-.5-2.5-.5h-.5c-1.3 0-2.5.3-3.6 1-.2.1-.2.2-.2.4v11.6c0 .3.1.5.3.5.6 0 .5-.4.5-.6v-5.7c.7-.3 3.2-1.1 5.8-.1 1.6.6 3.5.7 4.3.7.8 0 1.3-.3 1.3-.3.2-.1.3-.2.3-.4v-5.7c-.3-.2-.4-.4-.5-.5zm-.4 5.9c-.1 0-.7.1-1 .1-.7 0-2.4-.1-3.8-.6-2.5-1-5-.5-6.2-.1v-4.9c.9-.5 2.2-.7 3.2-.7h.4c.7 0 1.5.2 2.2.4 1.6.6 3.5.7 4.3.7.2 0 .8 0 1-.1v5.2z'/%3E%3Cpath fill='none' stroke='%233371B7' d='M48.1 23.5h3.7c2.5 0 4.5 2 4.5 4.5 0 .5-.4.9-.9.9H44.5c-.5 0-.9-.4-.9-.9 0-2.5 2-4.5 4.5-4.5z'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='M43.5 28.8c-.2.1-.5 1.2 0 1.5 1.4 1 8.5.8 11.3.6.8-.1 1.6-.4 1.7-1.2 0-.3-.1-.6-.6-.9'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='m43.5 30.6-.2.4c-.2.5.2 1 .7.9.3-.1.5 0 .7.3l.1.2c.3.5 1 .6 1.5.2h0c.3-.2.7-.3 1-.2l.8.3c.4.2.8.1 1.2 0l.5-.2c.4-.2.9-.2 1.3 0l.5.2c.4.2.8.2 1.2 0l.2-.1c.3-.2.8-.2 1.1.1l.2.2c.3.3.8.2 1-.2l.1-.2c.1-.2 0-.3.2-.3.5 0 1.2-.3 1.1-.7l-.4-1.1'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='M43.5 32.2c-.1.2-.3.8 0 1.1.3.4 3 1.1 6.4 1.1 2.2 0 4.6-.3 6-.6.5-.1.9-.5.8-.9 0-.2-.2-.5-.4-.7'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='M43.5 33.3c0 .5.6 2.3 1.3 2.7 1.8.8 5.7.7 8.1.5 1.3-.1 2.5-.7 3.2-1.8.3-.5.5-1 .5-1.4'/%3E%3Cellipse fill='%233371B7' cx='51.6' cy='26.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%233371B7' cx='53' cy='25' rx='.3' ry='.4'/%3E%3Cellipse fill='%233371B7' cx='53' cy='27.2' rx='.3' ry='.4'/%3E%3Cellipse fill='%233371B7' cx='54.3' cy='26.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%233371B7' cx='50.9' cy='25' rx='.3' ry='.4'/%3E%3Cpath fill='none' stroke='%233371B7' d='M24.2 31v-7.6c.1.1.8.9 2.8 3.1 2.5-1.6 5.6-.7 6.9 0l2.4-3.1v7.1c0 1.2-.1 2.5-.9 3.4-1 1.2-2.7 2.5-5.3 2.5-2.9 0-4.5-1.5-5.3-2.9-.6-.6-.6-1.5-.6-2.5z'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='m21.2 30 5.4 1.2m-5.4 2.9 5.4-1.2M38.8 30l-5.4 1.2m5.4 2.9-5.4-1.2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%233371B7' d='m29.5 32.4-.5-.7c-.2-.3 0-.6.3-.6h1.4c.3 0 .5.4.3.6l-.7 1c-.7 1.2-2.6 1.1-3.1-.3l-.1-.2c-.1-.2 0-.4.2-.5s.4 0 .5.2l.1.2c.4.7 1.2.8 1.6.3z'/%3E%3Cpath fill='none' stroke='%233371B7' stroke-linecap='round' d='m32.4 32.1-.1.2c-.4 1-1.8 1.1-2.3.2'/%3E%3Ccircle fill='%233371B7' cx='27.6' cy='29.7' r='.7'/%3E%3Ccircle fill='%233371B7' cx='32.4' cy='29.7' r='.7'/%3E%3Cg fill='%23C0C0BF' stroke='%23C0C0BF' stroke-width='.1' stroke-miterlimit='10'%3E%3Cpath d='M12.8 49.5c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.2-1.1-1.2-.6 0-1.2.5-1.2 1.2 0 .6.6 1.1 1.2 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4zm1.8 3.2c-.1-.1-.2-.2-.3-.2H5.7c-.1 0-.2.1-.3.2-.1.1-.1.2 0 .4.7 2 2.5 3.3 4.6 3.3s3.9-1.3 4.6-3.3c.1-.1.1-.3 0-.4zM10 54.1c-1.6 0-3-.9-3.7-2.2h7.3c-.6 1.3-2 2.2-3.6 2.2zm-2.8-4.6c.6 0 1.2-.5 1.2-1.1 0-.6-.5-1.2-1.2-1.2-.6 0-1.1.5-1.1 1.2 0 .6.5 1.1 1.1 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4z'/%3E%3Cpath d='M10 43c-3.8 0-7 3.1-7 7 0 3.8 3.1 7 7 7s7-3.1 7-7c0-3.8-3.2-7-7-7zm0 13.2c-3.4 0-6.2-2.8-6.2-6.2 0-3.4 2.8-6.2 6.2-6.2s6.2 2.8 6.2 6.2c0 3.4-2.8 6.2-6.2 6.2z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M64.1 53.4h2.3c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.3c-.2 0-.4-.2-.4-.4v-2.1c0-.2.1-.4.4-.4zm9.4.1h2.4c.2 0 .4.2.4.4v2c0 .2-.2.4-.4.4h-2.4c-.2 0-.4-.2-.4-.4v-2c0-.3.2-.4.4-.4zm-9.8-5.1h12.6v5H63.7v-5z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M65.5 43.6h8.9c1 0 1.9.8 1.9 1.9v3.1H63.7v-3.1c0-1 .8-1.9 1.8-1.9z'/%3E%3Cellipse fill='%23C0C0BF' cx='66.2' cy='50.9' rx='.9' ry='1'/%3E%3Cellipse fill='%23C0C0BF' cx='73.8' cy='50.9' rx='.9' ry='1'/%3E%3Cg fill='none' stroke='%23C0C0BF'%3E%3Cpath d='M96.4 50c0 3.6-2.9 6.5-6.4 6.5s-6.4-2.9-6.4-6.5 2.9-6.5 6.4-6.5 6.4 2.9 6.4 6.5z'/%3E%3Cpath d='M96.3 48.6v.1c-.9.1-2.9.1-4.6-1.2-1.1-.8-2-1.7-2.6-2.5-.3-.4-.6-.8-.7-1-.1-.1-.1-.2-.1-.2.5-.1 1.2-.2 2-.2 1.2 0 2.5.3 3.5 1.1s1.7 1.8 2.1 2.8c.2.4.3.8.4 1.1zM84 52.2v-.1c.9-.2 2.9-.4 4.7.6 1.1.7 1.9 1.5 2.4 2.3.4.5.6 1 .7 1.3-.4.1-1 .2-1.7.3-1 0-2.1-.1-3.2-.8s-1.9-1.6-2.4-2.5c-.3-.5-.4-.8-.5-1.1z'/%3E%3C/g%3E%3Cg fill='none' stroke='%23C0C0BF'%3E%3Cpath stroke-linecap='round' d='m116.3 46.8-1.4 2-.8-.8-.6-.7v.9l-.1 8.2h-6.8l-.1-8.2v-.9l-.6.7-.8.8-1.4-2 2.6-2.9c.1-.1.2-.1.3-.1h1.3l.4.7c.7 1.3 2.6 1.3 3.3-.1l.3-.6h1.2c.1 0 .2 0 .3.1l.3-.3-.3.3 2.9 2.9z'/%3E%3Cpath d='M110.1 47.7h2v.9c0 .4-.4.7-1 .7s-1-.3-1-.7v-.9z'/%3E%3C/g%3E%3Cpath d='M126.8 54.3c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2 1 2.2 2.2zm10.8 0c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c1.2 0 2.2 1 2.2 2.2zm-10.8-9.9v9.9m10.9-9.9v9.9m-10.9-10.8h10.8v2.7h-10.8v-2.7z' fill='none' stroke='%23C0C0BF'/%3E%3Cg fill='%23C0C0BF'%3E%3Cpath d='M170.8 43.1h-.8c-2.1 0-4 1-5.3 2.5h-.1l-.1-.1-1-1.2-.3 3.4 3.4.3-1.1-1.3-.1-.1.1-.1c1.1-1.5 3-2.3 5-2.1 3.2.3 5.5 3.1 5.2 6.3-.3 3-3.1 5.3-6.1 5.1-3.1-.2-5.4-2.9-5.3-6l-1.3-.1c-.2 3.8 2.6 7.1 6.3 7.4 3.9.3 7.3-2.6 7.6-6.5.3-3.8-2.5-7.1-6.1-7.5z'/%3E%3Cpath d='M170.3 47.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v3.2c0 .2.1.3.2.4.1.1.3.2.4.2h2.4c.4 0 .6-.3.6-.6s-.3-.6-.6-.6h-1.8v-2.6z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M186.2 43.4h7.7c1.5 0 2.7 1.2 2.7 2.7v7.7c0 1.5-1.2 2.7-2.7 2.7h-7.7c-1.5 0-2.7-1.2-2.7-2.7v-7.7c-.1-1.4 1.2-2.7 2.7-2.7z'/%3E%3Ccircle fill='%23C0C0BF' cx='186' cy='48.9' r='.7'/%3E%3Ccircle fill='%23C0C0BF' cx='194' cy='46.7' r='.7'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='m186 53.3.4-.3c.4-.3 1-.3 1.5-.1l1 .4c.5.2 1 .2 1.5-.1l.8-.5c.4-.3 1-.3 1.5-.1l1.8.8'/%3E%3Cpath fill='%23C0C0BF' stroke='%23C0C0BF' stroke-width='.25' stroke-miterlimit='10' d='M156 44.3c-.2-.1-.4-.1-.5 0 0 0-.2.1-.9.2-.7 0-2.4-.1-3.8-.6-.8-.3-1.7-.5-2.5-.5h-.5c-1.3 0-2.5.3-3.6 1-.2.1-.2.2-.2.4v11.6c0 .3.1.5.3.5.6 0 .5-.4.5-.6v-5.7c.7-.3 3.2-1.1 5.8-.1 1.6.6 3.5.7 4.3.7.8 0 1.3-.3 1.3-.3.2-.1.3-.2.3-.4v-5.7c-.3-.2-.4-.4-.5-.5zm-.4 5.9c-.1 0-.7.1-1 .1-.7 0-2.4-.1-3.8-.6-2.5-1-5-.5-6.2-.1v-4.9c.9-.5 2.2-.7 3.2-.7h.4c.7 0 1.5.2 2.2.4 1.6.6 3.5.7 4.3.7.2 0 .8 0 1-.1v5.2z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M48.1 43.5h3.7c2.5 0 4.5 2 4.5 4.5 0 .5-.4.9-.9.9H44.5c-.5 0-.9-.4-.9-.9 0-2.5 2-4.5 4.5-4.5z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='M43.5 48.8c-.2.1-.5 1.2 0 1.5 1.4 1 8.5.8 11.3.6.8-.1 1.6-.4 1.7-1.2 0-.3-.1-.6-.6-.9'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='m43.5 50.6-.2.4c-.2.5.2 1 .7.9.3-.1.5 0 .7.3l.1.2c.3.5 1 .6 1.5.2h0c.3-.2.7-.3 1-.2l.8.3c.4.2.8.1 1.2 0l.5-.2c.4-.2.9-.2 1.3 0l.5.2c.4.2.8.2 1.2 0l.2-.1c.3-.2.8-.2 1.1.1l.2.2c.3.3.8.2 1-.2l.1-.2c.1-.2 0-.3.2-.3.5 0 1.2-.3 1.1-.7l-.4-1.1'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='M43.5 52.2c-.1.2-.3.8 0 1.1.3.4 3 1.1 6.4 1.1 2.2 0 4.6-.3 6-.6.5-.1.9-.5.8-.9 0-.2-.2-.5-.4-.7'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='M43.5 53.3c0 .5.6 2.3 1.3 2.7 1.8.8 5.7.7 8.1.5 1.3-.1 2.5-.7 3.2-1.8.3-.5.5-1 .5-1.4'/%3E%3Cellipse fill='%23C0C0BF' cx='51.6' cy='46.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%23C0C0BF' cx='53' cy='45' rx='.3' ry='.4'/%3E%3Cellipse fill='%23C0C0BF' cx='53' cy='47.2' rx='.3' ry='.4'/%3E%3Cellipse fill='%23C0C0BF' cx='54.3' cy='46.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%23C0C0BF' cx='50.9' cy='45' rx='.3' ry='.4'/%3E%3Cpath fill='none' stroke='%23C0C0BF' d='M24.2 51v-7.6c.1.1.8.9 2.8 3.1 2.5-1.7 5.6-.7 6.9 0l2.4-3.1v7.1c0 1.2-.1 2.5-.9 3.4-1 1.2-2.7 2.5-5.3 2.5-2.9 0-4.5-1.5-5.3-2.9-.6-.6-.6-1.5-.6-2.5z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='m21.2 50 5.4 1.2m-5.4 2.9 5.4-1.2M38.8 50l-5.4 1.2m5.4 2.9-5.4-1.2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%23C0C0BF' d='m29.5 52.4-.5-.7c-.2-.3 0-.6.3-.6h1.4c.3 0 .5.4.3.6l-.7 1c-.7 1.2-2.6 1.1-3.1-.3l-.1-.2c-.1-.2 0-.4.2-.5s.4 0 .5.2l.1.2c.4.7 1.2.8 1.6.3z'/%3E%3Cpath fill='none' stroke='%23C0C0BF' stroke-linecap='round' d='m32.4 52.1-.1.2c-.4 1-1.8 1.1-2.3.2'/%3E%3Ccircle fill='%23C0C0BF' cx='27.6' cy='49.7' r='.7'/%3E%3Ccircle fill='%23C0C0BF' cx='32.4' cy='49.7' r='.7'/%3E%3Cg fill='%236AA9DD' stroke='%236AA9DD' stroke-width='.1' stroke-miterlimit='10'%3E%3Cpath d='M14.6 71.2c-.1-.1-.2-.2-.3-.2H5.7c-.1 0-.2.1-.3.2-.1.1-.1.2 0 .4.7 2 2.5 3.3 4.6 3.3s3.9-1.3 4.6-3.3c.1-.1.1-.3 0-.4zM10 74.1c-1.6 0-3-.9-3.7-2.2h7.3c-.6 1.3-2 2.2-3.6 2.2zm2.8-4.6c.6 0 1.1-.5 1.1-1.1 0-.6-.5-1.2-1.1-1.2-.6 0-1.2.5-1.2 1.2 0 .6.6 1.1 1.2 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4zm-5.6 1.5c.6 0 1.2-.5 1.2-1.1 0-.6-.5-1.2-1.2-1.2-.6 0-1.1.5-1.1 1.2 0 .6.5 1.1 1.1 1.1zm0-1.5c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4c0-.3.2-.4.4-.4z'/%3E%3Cpath d='M10 63c-3.8 0-7 3.1-7 7 0 3.8 3.1 7 7 7s7-3.1 7-7c0-3.8-3.2-7-7-7zm0 13.2c-3.4 0-6.2-2.8-6.2-6.2 0-3.4 2.8-6.2 6.2-6.2s6.2 2.8 6.2 6.2c0 3.4-2.8 6.2-6.2 6.2z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%236AA9DD' d='M64.1 73.4h2.3c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.3c-.2 0-.4-.2-.4-.4v-2.1c0-.2.1-.4.4-.4zm9.4.1h2.4c.2 0 .4.2.4.4V76c0 .2-.2.4-.4.4h-2.4c-.2 0-.4-.2-.4-.4v-2.1c0-.3.2-.4.4-.4zm-9.8-5.1h12.6v5H63.7v-5z'/%3E%3Cpath fill='none' stroke='%236AA9DD' d='M65.5 63.6h8.9c1 0 1.9.8 1.9 1.9v3.1H63.7v-3.1c0-1 .8-1.9 1.8-1.9z'/%3E%3Ccircle fill='%236AA9DD' cx='66.2' cy='70.9' r='.9'/%3E%3Ccircle fill='%236AA9DD' cx='73.8' cy='70.9' r='.9'/%3E%3Cg fill='none' stroke='%236AA9DD'%3E%3Cpath d='M96.4 70c0 3.6-2.9 6.5-6.4 6.5s-6.4-2.9-6.4-6.5 2.9-6.5 6.4-6.5 6.4 2.9 6.4 6.5z'/%3E%3Cpath d='M96.3 68.6v.1c-.9.1-2.9.1-4.6-1.2-1.1-.8-2-1.7-2.6-2.5-.3-.4-.6-.8-.7-1.1-.1-.1-.1-.2-.1-.2.5-.1 1.2-.2 2-.2 1.2 0 2.5.3 3.5 1.1s1.7 1.8 2.1 2.8c.2.5.3.9.4 1.2zM84 72.2v-.1c.9-.2 2.9-.4 4.7.6 1.1.7 1.9 1.5 2.4 2.3.4.5.6 1 .7 1.3-.4.1-1 .2-1.7.3-1 0-2.1-.1-3.2-.8s-1.9-1.6-2.4-2.5c-.3-.5-.4-.9-.5-1.1z'/%3E%3C/g%3E%3Cg fill='none' stroke='%236AA9DD'%3E%3Cpath stroke-linecap='round' d='m116.3 66.8-1.4 2-.8-.8-.6-.7v.9l-.1 8.2h-6.8l-.1-8.2v-.9l-.6.7-.8.8-1.4-2 2.6-2.9c.1-.1.2-.1.3-.1h1.3l.4.7c.7 1.3 2.6 1.3 3.3-.1l.3-.6h1.2c.1 0 .2 0 .3.1l.3-.3-.3.3 2.9 2.9z'/%3E%3Cpath d='M110.1 67.7h2v.9c0 .4-.4.7-1 .7s-1-.3-1-.7v-.9z'/%3E%3C/g%3E%3Cpath d='M126.8 74.3c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2 1 2.2 2.2zm10.8 0c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c1.2 0 2.2 1 2.2 2.2zm-10.8-9.9v9.9m10.9-9.9v9.9m-10.9-10.8h10.8v2.7h-10.8v-2.7z' fill='none' stroke='%236AA9DD'/%3E%3Cg fill='%236AA9DD'%3E%3Cpath d='M170.8 63.1h-.8c-2.1 0-4 1-5.3 2.5h-.1l-.1-.1-1-1.2-.3 3.4 3.4.3-1.1-1.3-.1-.1.1-.1c1.1-1.4 3-2.3 5-2.1 3.2.3 5.5 3.1 5.2 6.3-.3 3-3.1 5.3-6.1 5.1-3.1-.2-5.4-2.9-5.3-6l-1.3-.1c-.2 3.8 2.6 7.1 6.3 7.4 3.9.3 7.3-2.6 7.6-6.5.3-3.8-2.5-7.1-6.1-7.5z'/%3E%3Cpath d='M170.3 67.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v3.2c0 .2.1.3.2.4.1.1.3.2.4.2h2.4c.4 0 .6-.3.6-.6s-.3-.6-.7-.6h-1.8v-.2l.1-2.4z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%236AA9DD' d='M186.2 63.4h7.7c1.5 0 2.7 1.2 2.7 2.7v7.7c0 1.5-1.2 2.7-2.7 2.7h-7.7c-1.5 0-2.7-1.2-2.7-2.7v-7.7c-.1-1.4 1.2-2.7 2.7-2.7z'/%3E%3Ccircle fill='%236AA9DD' cx='186' cy='68.9' r='.7'/%3E%3Ccircle fill='%236AA9DD' cx='194' cy='66.7' r='.7'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='m186 73.3.4-.3c.4-.3 1-.3 1.5-.1l1 .4c.5.2 1 .2 1.5-.1l.8-.5c.4-.3 1-.3 1.5-.1l1.8.8'/%3E%3Cpath fill='%236AA9DD' stroke='%236AA9DD' stroke-width='.25' stroke-miterlimit='10' d='M156 64.3c-.2-.1-.4-.1-.5 0 0 0-.2.1-.9.2-.7 0-2.4-.1-3.8-.6-.8-.3-1.7-.5-2.5-.5h-.5c-1.3 0-2.5.3-3.6 1-.2.1-.2.2-.2.4v11.6c0 .3.1.5.3.5.6 0 .5-.4.5-.6v-5.7c.7-.3 3.2-1.1 5.8-.1 1.6.6 3.5.7 4.3.7.8 0 1.3-.3 1.3-.3.2-.1.3-.2.3-.4v-5.7c-.3-.2-.4-.4-.5-.5zm-.4 5.9c-.1 0-.7.1-1 .1-.7 0-2.4-.1-3.8-.6-2.5-1-5-.5-6.2-.1v-4.9c.9-.5 2.2-.7 3.2-.7h.4c.7 0 1.5.2 2.2.4 1.6.6 3.5.7 4.3.7.2 0 .8 0 1-.1v5.2z'/%3E%3Cpath fill='none' stroke='%236AA9DD' d='M48.1 63.5h3.7c2.5 0 4.5 2 4.5 4.5 0 .5-.4.9-.9.9H44.5c-.5 0-.9-.4-.9-.9 0-2.5 2-4.5 4.5-4.5z'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='M43.5 68.8c-.2.1-.5 1.2 0 1.5 1.4.9 8.5.8 11.3.6.8-.1 1.6-.4 1.7-1.2 0-.3-.1-.6-.6-.9'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='m43.5 70.6-.2.4c-.2.5.2 1 .7.9.3-.1.5.1.7.3l.1.2c.3.5 1 .6 1.5.2h0c.3-.2.7-.3 1-.2l.8.3c.4.2.8.1 1.2 0l.5-.2c.4-.2.9-.2 1.3 0l.5.2c.4.2.8.2 1.2-.1l.2-.1c.3-.2.8-.2 1.1.1l.2.2c.3.3.8.2 1-.2l.1-.2c.1-.2 0-.3.2-.3.5 0 1.2-.3 1.1-.7l-.4-1.1'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='M43.5 72.2c-.1.2-.3.8 0 1.1.3.4 3 1.1 6.4 1.1 2.2 0 4.6-.3 6-.6.5-.1.9-.4.8-.9 0-.2-.2-.5-.4-.7'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='M43.5 73.3c0 .5.6 2.3 1.3 2.7 1.8.8 5.7.7 8.1.5 1.3-.1 2.5-.7 3.2-1.8.3-.5.5-1 .5-1.4'/%3E%3Cellipse fill='%236AA9DD' cx='51.6' cy='66.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%236AA9DD' cx='53' cy='65' rx='.3' ry='.4'/%3E%3Cellipse fill='%236AA9DD' cx='53' cy='67.2' rx='.3' ry='.4'/%3E%3Cellipse fill='%236AA9DD' cx='54.3' cy='66.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%236AA9DD' cx='50.9' cy='65' rx='.3' ry='.4'/%3E%3Cpath fill='none' stroke='%236AA9DD' d='M24.2 71v-7.6c.1.1.8.9 2.8 3.1 2.5-1.7 5.6-.7 6.9 0l2.4-3.1v7.1c0 1.2-.1 2.5-.9 3.4-1 1.2-2.7 2.5-5.3 2.5-2.9 0-4.5-1.5-5.3-2.9-.6-.6-.6-1.5-.6-2.5z'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='m21.2 70.1 5.4 1.2m-5.4 2.8 5.4-1.2m12.2-2.8-5.4 1.2m5.4 2.8-5.4-1.2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%236AA9DD' d='m29.5 72.4-.5-.7c-.2-.3 0-.6.3-.6h1.4c.3 0 .5.4.3.6l-.7 1c-.7 1.2-2.6 1.1-3.1-.3l-.1-.2c-.1-.2 0-.4.2-.5.2-.1.4 0 .5.2l.1.2c.4.7 1.2.8 1.6.3z'/%3E%3Cpath fill='none' stroke='%236AA9DD' stroke-linecap='round' d='m32.4 72.1-.1.2c-.4 1-1.8 1.1-2.3.2'/%3E%3Ccircle fill='%236AA9DD' cx='27.6' cy='69.7' r='.7'/%3E%3Ccircle fill='%236AA9DD' cx='32.4' cy='69.7' r='.7'/%3E%3Cg fill='%23868686' stroke='%23868686' stroke-width='.1' stroke-miterlimit='10'%3E%3Cpath d='M12.8 9.5c.6 0 1.1-.5 1.1-1.2 0-.6-.5-1.1-1.1-1.1-.6 0-1.2.5-1.2 1.1s.6 1.2 1.2 1.2zm0-1.6c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zM7.2 9.5c.6 0 1.2-.5 1.2-1.2 0-.6-.5-1.1-1.2-1.1-.6 0-1.1.5-1.1 1.1s.5 1.2 1.1 1.2zm0-1.6c.2 0 .4.2.4.4s-.2.4-.4.4-.4-.2-.4-.4.2-.4.4-.4zm7.4 3.3c-.1-.1-.2-.2-.3-.2H5.7c-.1 0-.2.1-.3.2-.1.1-.1.2 0 .4.7 2 2.5 3.3 4.6 3.3s3.9-1.3 4.6-3.3c.1-.2.1-.3 0-.4zM10 14.1c-1.6 0-3-.9-3.7-2.2h7.3c-.6 1.3-2 2.2-3.6 2.2z'/%3E%3Cpath d='M10 3c-3.8 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.2-7-7-7zm0 13.2c-3.4 0-6.2-2.8-6.2-6.2S6.6 3.8 10 3.8s6.2 2.8 6.2 6.2-2.8 6.2-6.2 6.2z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%23868686' d='M64.1 13.4h2.3c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.3c-.2 0-.4-.2-.4-.4v-2.1c0-.2.1-.4.4-.4zm9.4 0h2.4c.2 0 .4.2.4.4v2.1c0 .2-.2.4-.4.4h-2.4c-.2 0-.4-.2-.4-.4v-2.1c0-.2.2-.4.4-.4zm-9.8-5h12.6v5H63.7v-5z'/%3E%3Cpath fill='none' stroke='%23868686' d='M65.5 3.6h8.9c1 0 1.9.8 1.9 1.9v3.1H63.7V5.5c0-1.1.8-1.9 1.8-1.9z'/%3E%3Ccircle fill='%23868686' cx='66.2' cy='10.9' r='.9'/%3E%3Ccircle fill='%23868686' cx='73.8' cy='10.9' r='.9'/%3E%3Cg fill='none' stroke='%23868686'%3E%3Cpath d='M96.4 10c0 3.6-2.9 6.5-6.4 6.5s-6.4-2.9-6.4-6.5 2.9-6.5 6.4-6.5 6.4 2.9 6.4 6.5z'/%3E%3Cpath d='M96.3 8.6v.1c-.9.1-2.9.1-4.6-1.2-1.1-.8-2-1.7-2.6-2.5-.3-.4-.6-.8-.7-1.1-.1-.1-.1-.2-.1-.2.5-.1 1.2-.2 2-.2 1.2 0 2.5.3 3.5 1.1s1.7 1.8 2.1 2.8c.2.5.3.9.4 1.2zM84 12.1V12c.9-.2 2.9-.4 4.7.6 1.1.6 1.9 1.5 2.4 2.3.4.5.6 1 .7 1.3-.4.1-1 .2-1.7.3-1 0-2.1-.1-3.2-.8-1.1-.6-1.9-1.6-2.4-2.5-.3-.4-.4-.8-.5-1.1z'/%3E%3C/g%3E%3Cg fill='none' stroke='%23868686'%3E%3Cpath stroke-linecap='round' d='m116.3 6.8-1.4 2-.8-.8-.6-.7v.9l-.1 8.2h-6.8l-.1-8.2v-.9l-.6.7-.8.8-1.4-2 2.6-2.9c.1-.1.2-.1.3-.1h1.3l.4.7c.7 1.3 2.6 1.3 3.3-.1l.3-.6h1.2c.1 0 .2 0 .3.1l.3-.3-.3.3 2.9 2.9z'/%3E%3Cpath d='M110.1 7.7h2v.9c0 .4-.4.7-1 .7s-1-.3-1-.7v-.9z'/%3E%3C/g%3E%3Cpath d='M126.8 14.3c0 1.2-1 2.2-2.2 2.2s-2.2-1-2.2-2.2 1-2.2 2.2-2.2 2.2 1 2.2 2.2zm10.8 0c0 1.2-1 2.2-2.2 2.2-1.2 0-2.2-1-2.2-2.2s1-2.2 2.2-2.2c1.2 0 2.2 1 2.2 2.2zm-10.8-9.9v9.9m10.9-9.9v9.9M126.8 3.5h10.8v2.7h-10.8V3.5z' fill='none' stroke='%23868686'/%3E%3Cg fill='%23868686'%3E%3Cpath d='M170.8 3.1h-.8c-2.1 0-4 1-5.3 2.5h-.1l-.1-.1-1-1.2-.3 3.4 3.4.3-1.1-1.3-.1-.1.1-.1c1.1-1.4 3-2.3 5-2.1 3.2.3 5.5 3.1 5.2 6.3-.3 3-3.1 5.3-6.1 5.1-3.1-.2-5.4-2.9-5.3-6l-1.3-.3c-.2 3.8 2.6 7.1 6.3 7.4 3.9.4 7.3-2.6 7.6-6.5.3-3.6-2.5-6.9-6.1-7.3z'/%3E%3Cpath d='M170.3 7.4c0-.3-.3-.6-.6-.6s-.7.3-.7.6v3.2c0 .2.1.3.2.4.1.1.3.2.4.2h2.4c.4 0 .6-.3.6-.6s-.3-.6-.6-.6h-1.8v-.2l.1-2.4z'/%3E%3C/g%3E%3Cpath fill='none' stroke='%23868686' d='M186.2 3.4h7.7c1.5 0 2.7 1.2 2.7 2.7v7.7c0 1.5-1.2 2.7-2.7 2.7h-7.7c-1.5 0-2.7-1.2-2.7-2.7V6.1c-.1-1.5 1.2-2.7 2.7-2.7z'/%3E%3Ccircle fill='%23868686' cx='186' cy='8.9' r='.7'/%3E%3Ccircle fill='%23868686' cx='194' cy='6.7' r='.7'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='m186 13.3.4-.3c.4-.3 1-.3 1.5-.1l1 .4c.5.2 1 .2 1.5-.1l.8-.5c.4-.3 1-.3 1.5-.1l1.8.8'/%3E%3Cpath fill='%23868686' stroke='%23868686' stroke-width='.25' stroke-miterlimit='10' d='M156 4.3c-.2-.1-.4-.1-.5 0 0 0-.2.1-.9.1s-2.4-.1-3.8-.6c-.8-.3-1.7-.5-2.5-.5h-.5c-1.3 0-2.5.3-3.6 1-.2.1-.2.2-.2.4v11.6c0 .3.1.5.3.5.6 0 .5-.4.5-.6v-5.7c.7-.3 3.2-1.1 5.8-.1 1.6.6 3.5.7 4.3.7.8 0 1.3-.3 1.3-.3.2-.1.3-.2.3-.4V4.7c-.3-.2-.4-.3-.5-.4zm-.4 5.9c-.1 0-.7.1-1 .1-.7 0-2.4-.1-3.8-.6-2.5-1-5-.5-6.2-.1V4.7c.9-.5 2.2-.7 3.2-.7h.4c.7 0 1.5.2 2.2.4 1.6.6 3.5.7 4.3.7.2 0 .8 0 1-.1v5.2z'/%3E%3Cpath fill='none' stroke='%23868686' d='M48.1 3.5h3.7c2.5 0 4.5 2 4.5 4.5 0 .5-.4.9-.9.9H44.5c-.5 0-.9-.4-.9-.9 0-2.5 2-4.5 4.5-4.5z'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='M43.5 8.7c-.2.1-.5 1.2 0 1.5 1.4.9 8.5.8 11.3.6.8-.1 1.6-.4 1.7-1.2 0-.3-.1-.6-.6-.9'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='m43.5 10.6-.2.4c-.2.5.2 1 .7.9.3-.1.5.1.7.3l.1.2c.3.5 1 .6 1.5.2h0c.3-.2.7-.3 1-.2l.8.3c.4.1.8.1 1.2 0l.5-.2c.4-.2.9-.2 1.3 0l.5.2c.4.2.8.1 1.2-.1l.2-.1c.3-.2.8-.1 1.1.1l.2.2c.3.3.8.2 1-.2l.1-.2c.1-.2 0-.3.2-.4.5 0 1.2-.3 1.1-.7l-.4-1.1'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='M43.5 12.1c-.1.2-.3.8 0 1.1.3.4 3 1.1 6.4 1.1 2.2 0 4.6-.3 6-.6.5-.1.9-.4.8-.9 0-.2-.2-.5-.4-.7'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='M43.5 13.3c0 .5.6 2.4 1.3 2.6 1.8.8 5.7.7 8.1.5 1.3-.1 2.5-.7 3.2-1.8.3-.5.5-1 .5-1.4'/%3E%3Cellipse fill='%23868686' cx='51.6' cy='6.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%23868686' cx='53' cy='4.9' rx='.3' ry='.4'/%3E%3Cellipse fill='%23868686' cx='53' cy='7.2' rx='.3' ry='.4'/%3E%3Cellipse fill='%23868686' cx='54.3' cy='6.5' rx='.3' ry='.4'/%3E%3Cellipse fill='%23868686' cx='50.9' cy='4.9' rx='.3' ry='.4'/%3E%3Cpath fill='none' stroke='%23868686' d='M24.2 11V3.5c.1.1.8.9 2.8 3.1 2.5-1.7 5.6-.7 6.9 0l2.4-3.1v7.1c0 1.2-.1 2.5-.9 3.4-1 1.2-2.7 2.5-5.3 2.5-2.9 0-4.5-1.5-5.3-2.9-.6-.7-.6-1.7-.6-2.6z'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='m21.2 10 5.4 1.2m-5.4 2.9 5.4-1.2M38.8 10l-5.4 1.2m5.4 2.9-5.4-1.2'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%23868686' d='m29.5 12.4-.5-.7c-.2-.3 0-.6.3-.6h1.4c.3 0 .5.4.3.6l-.7 1c-.7 1.2-2.6 1.1-3.1-.3l-.1-.2c-.1-.2 0-.4.2-.5s.4 0 .5.2l.1.2c.4.6 1.2.8 1.6.3z'/%3E%3Cpath fill='none' stroke='%23868686' stroke-linecap='round' d='m32.4 12.1-.1.2c-.4 1-1.8 1.1-2.3.2'/%3E%3Ccircle fill='%23868686' cx='27.6' cy='9.7' r='.7'/%3E%3Ccircle fill='%23868686' cx='32.4' cy='9.7' r='.7'/%3E%3C/svg%3E\");background-position:0 0}.EmojiPickerReact.epr-dark-theme .epr-category-nav>button.epr-cat-btn{background-position-y:calc(var(--epr-category-navigation-button-size)*2)}aside.EmojiPickerReact.epr-main:has(input:-moz-placeholder-shown) .epr-category-nav{background-position-y:calc(var(--epr-category-navigation-button-size)*3)}aside.EmojiPickerReact.epr-main:has(input:placeholder-shown) .epr-category-nav{background-position-y:calc(var(--epr-category-navigation-button-size)*3)}.EmojiPickerReact.epr-dark-theme:not(.epr-search-active) .epr-category-nav>button.epr-cat-btn.epr-active,.EmojiPickerReact.epr-dark-theme:not(.epr-search-active) .epr-category-nav>button.epr-cat-btn:hover{background-position-y:calc(var(--epr-category-navigation-button-size)*3)}.EmojiPickerReact button.epr-cat-btn.epr-icn-suggested{background-position-x:calc(var(--epr-category-navigation-button-size)*-8)}.EmojiPickerReact button.epr-cat-btn.epr-icn-custom{background-position-x:calc(var(--epr-category-navigation-button-size)*-9)}.EmojiPickerReact button.epr-cat-btn.epr-icn-activities{background-position-x:calc(var(--epr-category-navigation-button-size)*-4)}.EmojiPickerReact button.epr-cat-btn.epr-icn-animals_nature{background-position-x:calc(var(--epr-category-navigation-button-size)*-1)}.EmojiPickerReact button.epr-cat-btn.epr-icn-flags{background-position-x:calc(var(--epr-category-navigation-button-size)*-7)}.EmojiPickerReact button.epr-cat-btn.epr-icn-food_drink{background-position-x:calc(var(--epr-category-navigation-button-size)*-2)}.EmojiPickerReact button.epr-cat-btn.epr-icn-objects{background-position-x:calc(var(--epr-category-navigation-button-size)*-5)}.EmojiPickerReact button.epr-cat-btn.epr-icn-smileys_people{background-position-x:0}.EmojiPickerReact button.epr-cat-btn.epr-icn-symbols{background-position-x:calc(var(--epr-category-navigation-button-size)*-6)}.EmojiPickerReact button.epr-cat-btn.epr-icn-travel_places{background-position-x:calc(var(--epr-category-navigation-button-size)*-3)}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$8);
function $2785da2b7d7107bb$var$categoryNameFromDom($category) {
    var _$category$getAttribu;
    return (_$category$getAttribu = $category == null ? void 0 : $category.getAttribute("data-name")) != null ? _$category$getAttribu : null;
}
function $2785da2b7d7107bb$var$useActiveCategoryScrollDetection(setActiveCategory) {
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    (0, $ir4bw.useEffect)(function() {
        var visibleCategories = new Map();
        var bodyRef = BodyRef.current;
        var observer = new IntersectionObserver(function(entries) {
            if (!bodyRef) return;
            for(var _iterator = $2785da2b7d7107bb$var$_createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;){
                var entry = _step.value;
                var _id = $2785da2b7d7107bb$var$categoryNameFromDom(entry.target);
                visibleCategories.set(_id, entry.intersectionRatio);
            }
            var ratios = Array.from(visibleCategories);
            var lastCategory = ratios[ratios.length - 1];
            if (lastCategory[1] == 1) return setActiveCategory(lastCategory[0]);
            for(var _i = 0, _ratios = ratios; _i < _ratios.length; _i++){
                var _ratios$_i = _ratios[_i], id = _ratios$_i[0], ratio = _ratios$_i[1];
                if (ratio) {
                    setActiveCategory(id);
                    break;
                }
            }
        }, {
            threshold: [
                0,
                1
            ]
        });
        bodyRef == null || bodyRef.querySelectorAll($2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.category)).forEach(function(el) {
            observer.observe(el);
        });
    }, [
        BodyRef,
        setActiveCategory
    ]);
}
function $2785da2b7d7107bb$var$useIsSearchMode() {
    var _useSearchTermState = $2785da2b7d7107bb$var$useSearchTermState(), searchTerm = _useSearchTermState[0];
    return !!searchTerm;
}
function $2785da2b7d7107bb$var$useScrollCategoryIntoView() {
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    var PickerMainRef = $2785da2b7d7107bb$var$usePickerMainRef();
    return function scrollCategoryIntoView(category) {
        var _BodyRef$current;
        if (!BodyRef.current) return;
        var $category = (_BodyRef$current = BodyRef.current) == null ? void 0 : _BodyRef$current.querySelector('[data-name="' + category + '"]');
        if (!$category) return;
        var offsetTop = $category.offsetTop || 0;
        $2785da2b7d7107bb$var$scrollTo(PickerMainRef.current, offsetTop);
    };
}
function $2785da2b7d7107bb$var$useShouldHideCustomEmojis() {
    var customCategoryConfig = $2785da2b7d7107bb$var$useCustomEmojisConfig();
    if (!customCategoryConfig) return false;
    return customCategoryConfig.length === 0;
}
function $2785da2b7d7107bb$var$CategoryNavigation() {
    var _useState = (0, $ir4bw.useState)(null), activeCategory = _useState[0], setActiveCategory = _useState[1];
    var scrollCategoryIntoView = $2785da2b7d7107bb$var$useScrollCategoryIntoView();
    $2785da2b7d7107bb$var$useActiveCategoryScrollDetection(setActiveCategory);
    var isSearchMode = $2785da2b7d7107bb$var$useIsSearchMode();
    var categoriesConfig = $2785da2b7d7107bb$var$useCategoriesConfig();
    var CategoryNavigationRef = $2785da2b7d7107bb$var$useCategoryNavigationRef();
    var hideCustomCategory = $2785da2b7d7107bb$var$useShouldHideCustomEmojis();
    return (0, $5VC2c.createElement)("div", {
        className: "epr-category-nav",
        ref: CategoryNavigationRef
    }, categoriesConfig.map(function(categoryConfig) {
        var _clsx;
        var category = $2785da2b7d7107bb$var$categoryFromCategoryConfig(categoryConfig);
        if ($2785da2b7d7107bb$var$isCustomCategory(categoryConfig) && hideCustomCategory) return null;
        return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Button, {
            tabIndex: isSearchMode ? -1 : 0,
            className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)("epr-cat-btn", "epr-icn-" + category, (_clsx = {}, _clsx[$2785da2b7d7107bb$var$ClassNames.active] = category === activeCategory, _clsx)),
            key: category,
            onClick: function onClick() {
                setActiveCategory(category);
                scrollCategoryIntoView(category);
            },
            "aria-label": $2785da2b7d7107bb$var$categoryNameFromCategoryConfig(categoryConfig)
        });
    }));
}
var $2785da2b7d7107bb$var$css_248z$9 = ".EmojiPickerReact .epr-header .epr-header-overlay{padding:var(--epr-header-padding);z-index:var(--epr-header-overlay-z-index)}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$9);
var $2785da2b7d7107bb$var$css_248z$a = ".EmojiPickerReact .epr-search-container{display:block;flex:1;min-width:0}.EmojiPickerReact .epr-search-container input.epr-search{background-color:var(--epr-search-input-bg-color);border:1px solid var(--epr-search-input-bg-color);border-radius:var(--epr-search-input-border-radius);color:var(--epr-search-input-text-color);height:var(--epr-search-input-height);outline:none;padding:var(--epr-search-input-padding);transition:all .2s ease-in-out;width:100%}.EmojiPickerReact .epr-search-container button.epr-btn-clear-search .epr-icn-clear-search{background-color:transparent;background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='80' xml:space='preserve'%3E%3Cpath fill='%23868686' d='M6.98 13.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 8c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.4a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.2-.21.54 0 .74z'/%3E%3Cpath fill='%23868686' d='M10.15 18.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zm0-14.94c3.83 0 6.94 3.11 6.94 6.94 0 3.83-3.11 6.94-6.94 6.94-3.83 0-6.94-3.11-6.94-6.94 0-3.83 3.12-6.94 6.94-6.94z'/%3E%3Cpath fill='%233371B7' d='M6.98 33.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 28c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.41a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.21-.21.55 0 .75z'/%3E%3Cpath fill='%233371B7' d='M10.15 38.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zm0-14.94c3.83 0 6.94 3.11 6.94 6.94 0 3.83-3.11 6.94-6.94 6.94-3.83 0-6.94-3.11-6.94-6.94 0-3.83 3.12-6.94 6.94-6.94z'/%3E%3Cpath fill='%23C0C0BF' d='M6.98 53.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 48c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.41a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.21-.21.55 0 .75z'/%3E%3Cpath fill='%23C0C0BF' d='M10.15 58.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zm0-14.94c3.83 0 6.94 3.11 6.94 6.94 0 3.83-3.11 6.94-6.94 6.94-3.83 0-6.94-3.11-6.94-6.94 0-3.83 3.12-6.94 6.94-6.94z'/%3E%3Cpath fill='%236AA9DD' d='M6.98 73.59a.53.53 0 0 0 .74 0l2.42-2.42 2.43 2.43a.53.53 0 0 0 .74 0c.21-.21.21-.54 0-.75l-2.43-2.43L13.32 68c.21-.21.21-.54 0-.75a.525.525 0 0 0-.75 0l-2.42 2.42-2.41-2.41a.525.525 0 0 0-.75 0c-.21.21-.21.54 0 .75l2.41 2.41-2.42 2.42c-.21.21-.21.55 0 .75z'/%3E%3Cpath fill='%236AA9DD' d='M10.15 78.43c4.41 0 8-3.59 8-8s-3.59-8-8-8-8 3.59-8 8 3.59 8 8 8zm0-14.94c3.83 0 6.94 3.11 6.94 6.94 0 3.83-3.11 6.94-6.94 6.94-3.83 0-6.94-3.11-6.94-6.94 0-3.83 3.12-6.94 6.94-6.94z'/%3E%3C/svg%3E\");background-repeat:no-repeat;background-size:20px;height:20px;width:20px}.EmojiPickerReact .epr-search-container button.epr-btn-clear-search{align-items:center;border-radius:50%;display:flex;height:30px;justify-content:center;padding:0;position:absolute;right:var(--epr-search-bar-inner-padding);top:50%;transform:translateY(-50%);width:30px}.EmojiPickerReact .epr-search-container button.epr-btn-clear-search:focus .epr-icn-clear-search,.EmojiPickerReact .epr-search-container button.epr-btn-clear-search:hover .epr-icn-clear-search{background-position-y:-20px}.EmojiPickerReact .epr-search-container button.epr-btn-clear-search:focus,.EmojiPickerReact .epr-search-container button.epr-btn-clear-search:hover{background:var(--epr-hover-bg-color)}.EmojiPickerReact..epr-dark-theme .epr-search-container button.epr-btn-clear-search .epr-icn-clear-search{background-position-y:-40px}.EmojiPickerReact..epr-dark-theme .epr-search-container button.epr-btn-clear-search:hover .epr-icn-clear-search{background-position-y:-60px}.EmojiPickerReact .epr-search-container .epr-icn-search{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='40' xml:space='preserve'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%23868686' d='M12 8.81c0 2.08-1.68 3.76-3.76 3.76s-3.76-1.68-3.76-3.76 1.68-3.76 3.76-3.76S12 6.73 12 8.81zm-.77 3.91c-.83.64-1.87 1.01-2.99 1.01-2.72 0-4.92-2.2-4.92-4.92 0-2.72 2.2-4.92 4.92-4.92 2.72 0 4.92 2.2 4.92 4.92 0 1.13-.38 2.16-1.01 2.99l3.94 3.93c.25.25.25.66 0 .92-.25.25-.66.25-.92 0l-3.94-3.93z'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' fill='%23C0C0BF' d='M12 28.81c0 2.08-1.68 3.76-3.76 3.76s-3.76-1.68-3.76-3.76 1.68-3.76 3.76-3.76S12 26.73 12 28.81zm-.77 3.91c-.83.64-1.87 1.01-2.99 1.01-2.72 0-4.92-2.2-4.92-4.92 0-2.72 2.2-4.92 4.92-4.92 2.72 0 4.92 2.2 4.92 4.92 0 1.13-.38 2.16-1.01 2.99l3.94 3.93c.25.25.25.66 0 .92-.25.25-.66.25-.92 0l-3.94-3.93z'/%3E%3C/svg%3E\");background-position:0 0;background-repeat:no-repeat;background-size:20px;content:\"\";height:20px;left:var(--epr-search-bar-inner-padding);position:absolute;top:50%;transform:translateY(-50%);width:20px}.EmojiPickerReact.epr-dark-theme .epr-search-container .epr-icn-search{background-position-y:-20px}.EmojiPickerReact .epr-search-container input.epr-search::-moz-placeholder{color:var(--epr-search-input-placeholder-color)}.EmojiPickerReact .epr-search-container input.epr-search::placeholder{color:var(--epr-search-input-placeholder-color)}.EmojiPickerReact .epr-search-container input.epr-search:focus{background-color:var(--epr-search-input-bg-color-active);border:1px solid var(--epr-search-border-color)}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$a);
function $2785da2b7d7107bb$var$SearchContainer() {
    var searchDisabled = $2785da2b7d7107bb$var$useSearchDisabledConfig();
    var isSkinToneInSearch = $2785da2b7d7107bb$var$useIsSkinToneInSearch();
    if (searchDisabled) return null;
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Flex, {
        className: "epr-header-overlay"
    }, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Search, null), isSkinToneInSearch ? (0, $5VC2c.createElement)($2785da2b7d7107bb$var$SkinTonePicker, null) : null);
}
function $2785da2b7d7107bb$var$Search() {
    var _useState = (0, $ir4bw.useState)(0), inc = _useState[0], setInc = _useState[1];
    var closeAllOpenToggles = $2785da2b7d7107bb$var$useCloseAllOpenToggles();
    var SearchInputRef = $2785da2b7d7107bb$var$useSearchInputRef();
    var clearSearch = $2785da2b7d7107bb$var$useClearSearch();
    var placeholder = $2785da2b7d7107bb$var$useSearchPlaceHolderConfig();
    var autoFocus = $2785da2b7d7107bb$var$useAutoFocusSearchConfig();
    var _useFilter = $2785da2b7d7107bb$var$useFilter(), _onChange = _useFilter.onChange;
    var input = SearchInputRef == null ? void 0 : SearchInputRef.current;
    var value = input == null ? void 0 : input.value;
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Relative, {
        className: "epr-search-container"
    }, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$CssSearch, {
        value: value
    }), (0, $5VC2c.createElement)("input", {
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus,
        "aria-label": "Type to search for an emoji",
        onFocus: closeAllOpenToggles,
        className: "epr-search",
        type: "text",
        placeholder: placeholder,
        onChange: function onChange(event) {
            setInc(inc + 1);
            setTimeout(function() {
                var _event$target$value, _event$target;
                _onChange((_event$target$value = event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value) != null ? _event$target$value : value);
            });
        },
        ref: SearchInputRef
    }), (0, $5VC2c.createElement)("div", {
        className: "epr-icn-search"
    }), (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Button, {
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)("epr-btn-clear-search", "epr-visible-on-search-only"),
        onClick: clearSearch
    }, (0, $5VC2c.createElement)("div", {
        className: "epr-icn-clear-search"
    })));
}
var $2785da2b7d7107bb$var$CSS_SEARCH_SELECTOR = /*#__PURE__*/ $2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.emojiPicker) + " " + /*#__PURE__*/ $2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.emojiList);
function $2785da2b7d7107bb$var$CssSearch(_ref) {
    var value = _ref.value;
    if (!value) return null;
    var searchQuery = 'button[data-full-name*="' + $2785da2b7d7107bb$var$getNormalizedSearchTerm(value) + '"]';
    return (0, $5VC2c.createElement)("style", null, "\n        " + $2785da2b7d7107bb$var$CSS_SEARCH_SELECTOR + " " + $2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.category) + ":not(:has(" + searchQuery + ")) {\n        display: none;\n      }\n\n        " + $2785da2b7d7107bb$var$CSS_SEARCH_SELECTOR + " button" + $2785da2b7d7107bb$var$asSelectors($2785da2b7d7107bb$var$ClassNames.emoji) + ":not(" + searchQuery + ") {\n        display: none;\n      }\n  ");
}
function $2785da2b7d7107bb$var$Header() {
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Relative, {
        className: "epr-header"
    }, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$SearchContainer, null), (0, $5VC2c.createElement)($2785da2b7d7107bb$var$CategoryNavigation, null));
}
function $2785da2b7d7107bb$var$getActiveElement() {
    return document.activeElement;
}
var $2785da2b7d7107bb$var$KeyboardEvents;
(function(KeyboardEvents) {
    KeyboardEvents["ArrowDown"] = "ArrowDown";
    KeyboardEvents["ArrowUp"] = "ArrowUp";
    KeyboardEvents["ArrowLeft"] = "ArrowLeft";
    KeyboardEvents["ArrowRight"] = "ArrowRight";
    KeyboardEvents["Escape"] = "Escape";
    KeyboardEvents["Enter"] = "Enter";
    KeyboardEvents["Space"] = " ";
})($2785da2b7d7107bb$var$KeyboardEvents || ($2785da2b7d7107bb$var$KeyboardEvents = {}));
function $2785da2b7d7107bb$var$useKeyboardNavigation() {
    $2785da2b7d7107bb$var$usePickerMainKeyboardEvents();
    $2785da2b7d7107bb$var$useSearchInputKeyboardEvents();
    $2785da2b7d7107bb$var$useSkinTonePickerKeyboardEvents();
    $2785da2b7d7107bb$var$useCategoryNavigationKeyboardEvents();
    $2785da2b7d7107bb$var$useBodyKeyboardEvents();
}
function $2785da2b7d7107bb$var$usePickerMainKeyboardEvents() {
    var PickerMainRef = $2785da2b7d7107bb$var$usePickerMainRef();
    var clearSearch = $2785da2b7d7107bb$var$useClearSearch();
    var scrollTo = $2785da2b7d7107bb$var$useScrollTo();
    var SearchInputRef = $2785da2b7d7107bb$var$useSearchInputRef();
    var focusSearchInput = $2785da2b7d7107bb$var$useFocusSearchInput();
    var hasOpenToggles = $2785da2b7d7107bb$var$useHasOpenToggles();
    var disallowMouseMove = $2785da2b7d7107bb$var$useDisallowMouseMove();
    var closeAllOpenToggles = $2785da2b7d7107bb$var$useCloseAllOpenToggles();
    var onKeyDown = (0, $ir4bw.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            disallowMouseMove();
            switch(key){
                // eslint-disable-next-line no-fallthrough
                case $2785da2b7d7107bb$var$KeyboardEvents.Escape:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        return;
                    }
                    clearSearch();
                    scrollTo(0);
                    focusSearchInput();
                    break;
            }
        };
    }, [
        scrollTo,
        clearSearch,
        closeAllOpenToggles,
        focusSearchInput,
        hasOpenToggles,
        disallowMouseMove
    ]);
    (0, $ir4bw.useEffect)(function() {
        var current = PickerMainRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        PickerMainRef,
        SearchInputRef,
        scrollTo,
        onKeyDown
    ]);
}
function $2785da2b7d7107bb$var$useSearchInputKeyboardEvents() {
    var focusSkinTonePicker = $2785da2b7d7107bb$var$useFocusSkinTonePicker();
    var PickerMainRef = $2785da2b7d7107bb$var$usePickerMainRef();
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    var SearchInputRef = $2785da2b7d7107bb$var$useSearchInputRef();
    var _useSkinToneFanOpenSt = $2785da2b7d7107bb$var$useSkinToneFanOpenState(), setSkinToneFanOpenState = _useSkinToneFanOpenSt[1];
    var goDownFromSearchInput = $2785da2b7d7107bb$var$useGoDownFromSearchInput();
    var isSkinToneInSearch = $2785da2b7d7107bb$var$useIsSkinToneInSearch();
    var onKeyDown = (0, $ir4bw.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            switch(key){
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowRight:
                    if (!isSkinToneInSearch) return;
                    event.preventDefault();
                    setSkinToneFanOpenState(true);
                    focusSkinTonePicker();
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    goDownFromSearchInput();
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.Enter:
                    event.preventDefault();
                    $2785da2b7d7107bb$var$focusAndClickFirstVisibleEmoji(BodyRef.current);
                    break;
            }
        };
    }, [
        focusSkinTonePicker,
        goDownFromSearchInput,
        setSkinToneFanOpenState,
        BodyRef,
        isSkinToneInSearch
    ]);
    (0, $ir4bw.useEffect)(function() {
        var current = SearchInputRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        PickerMainRef,
        SearchInputRef,
        onKeyDown
    ]);
}
function $2785da2b7d7107bb$var$useSkinTonePickerKeyboardEvents() {
    var SkinTonePickerRef = $2785da2b7d7107bb$var$useSkinTonePickerRef();
    var focusSearchInput = $2785da2b7d7107bb$var$useFocusSearchInput();
    var SearchInputRef = $2785da2b7d7107bb$var$useSearchInputRef();
    var goDownFromSearchInput = $2785da2b7d7107bb$var$useGoDownFromSearchInput();
    var _useSkinToneFanOpenSt2 = $2785da2b7d7107bb$var$useSkinToneFanOpenState(), isOpen = _useSkinToneFanOpenSt2[0], setIsOpen = _useSkinToneFanOpenSt2[1];
    var isSkinToneInPreview = $2785da2b7d7107bb$var$useIsSkinToneInPreview();
    var isSkinToneInSearch = $2785da2b7d7107bb$var$useIsSkinToneInSearch();
    var onType = $2785da2b7d7107bb$var$useOnType();
    var onKeyDown = (0, $ir4bw.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            if (isSkinToneInSearch) switch(key){
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    $2785da2b7d7107bb$var$focusNextSkinTone(focusSearchInput);
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    $2785da2b7d7107bb$var$focusPrevSkinTone();
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (isOpen) setIsOpen(false);
                    goDownFromSearchInput();
                    break;
                default:
                    onType(event);
                    break;
            }
            if (isSkinToneInPreview) switch(key){
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    $2785da2b7d7107bb$var$focusNextSkinTone(focusSearchInput);
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    $2785da2b7d7107bb$var$focusPrevSkinTone();
                    break;
                default:
                    onType(event);
                    break;
            }
        };
    }, [
        isOpen,
        focusSearchInput,
        setIsOpen,
        goDownFromSearchInput,
        onType,
        isSkinToneInPreview,
        isSkinToneInSearch
    ]);
    (0, $ir4bw.useEffect)(function() {
        var current = SkinTonePickerRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        SkinTonePickerRef,
        SearchInputRef,
        isOpen,
        onKeyDown
    ]);
}
function $2785da2b7d7107bb$var$useCategoryNavigationKeyboardEvents() {
    var focusSearchInput = $2785da2b7d7107bb$var$useFocusSearchInput();
    var CategoryNavigationRef = $2785da2b7d7107bb$var$useCategoryNavigationRef();
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    var onType = $2785da2b7d7107bb$var$useOnType();
    var onKeyDown = (0, $ir4bw.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            switch(key){
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    focusSearchInput();
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    $2785da2b7d7107bb$var$focusNextElementSibling($2785da2b7d7107bb$var$getActiveElement());
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    $2785da2b7d7107bb$var$focusPrevElementSibling($2785da2b7d7107bb$var$getActiveElement());
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    $2785da2b7d7107bb$var$focusFirstVisibleEmoji(BodyRef.current);
                    break;
                default:
                    onType(event);
                    break;
            }
        };
    }, [
        BodyRef,
        focusSearchInput,
        onType
    ]);
    (0, $ir4bw.useEffect)(function() {
        var current = CategoryNavigationRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        CategoryNavigationRef,
        BodyRef,
        onKeyDown
    ]);
}
function $2785da2b7d7107bb$var$useBodyKeyboardEvents() {
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    var goUpFromBody = $2785da2b7d7107bb$var$useGoUpFromBody();
    var setVariationPicker = $2785da2b7d7107bb$var$useSetVariationPicker();
    var hasOpenToggles = $2785da2b7d7107bb$var$useHasOpenToggles();
    var closeAllOpenToggles = $2785da2b7d7107bb$var$useCloseAllOpenToggles();
    var onType = $2785da2b7d7107bb$var$useOnType();
    var onKeyDown = (0, $ir4bw.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            var activeElement = $2785da2b7d7107bb$var$buttonFromTarget($2785da2b7d7107bb$var$getActiveElement());
            switch(key){
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    $2785da2b7d7107bb$var$focusNextVisibleEmoji(activeElement);
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    $2785da2b7d7107bb$var$focusPrevVisibleEmoji(activeElement);
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        break;
                    }
                    $2785da2b7d7107bb$var$focusVisibleEmojiOneRowDown(activeElement);
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        break;
                    }
                    $2785da2b7d7107bb$var$focusVisibleEmojiOneRowUp(activeElement, goUpFromBody);
                    break;
                case $2785da2b7d7107bb$var$KeyboardEvents.Space:
                    event.preventDefault();
                    setVariationPicker(event.target);
                    break;
                default:
                    onType(event);
                    break;
            }
        };
    }, [
        goUpFromBody,
        onType,
        setVariationPicker,
        hasOpenToggles,
        closeAllOpenToggles
    ]);
    (0, $ir4bw.useEffect)(function() {
        var current = BodyRef.current;
        if (!current) return;
        current.addEventListener("keydown", onKeyDown);
        return function() {
            current.removeEventListener("keydown", onKeyDown);
        };
    }, [
        BodyRef,
        onKeyDown
    ]);
}
function $2785da2b7d7107bb$var$useGoDownFromSearchInput() {
    var focusCategoryNavigation = $2785da2b7d7107bb$var$useFocusCategoryNavigation();
    var isSearchMode = $2785da2b7d7107bb$var$useIsSearchMode();
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    return (0, $ir4bw.useCallback)(function goDownFromSearchInput() {
        if (isSearchMode) return $2785da2b7d7107bb$var$focusFirstVisibleEmoji(BodyRef.current);
        return focusCategoryNavigation();
    }, [
        BodyRef,
        focusCategoryNavigation,
        isSearchMode
    ]);
}
function $2785da2b7d7107bb$var$useGoUpFromBody() {
    var focusSearchInput = $2785da2b7d7107bb$var$useFocusSearchInput();
    var focusCategoryNavigation = $2785da2b7d7107bb$var$useFocusCategoryNavigation();
    var isSearchMode = $2785da2b7d7107bb$var$useIsSearchMode();
    return (0, $ir4bw.useCallback)(function goUpFromEmoji() {
        if (isSearchMode) return focusSearchInput();
        return focusCategoryNavigation();
    }, [
        focusSearchInput,
        isSearchMode,
        focusCategoryNavigation
    ]);
}
function $2785da2b7d7107bb$var$focusNextSkinTone(exitLeft) {
    var currentSkinTone = $2785da2b7d7107bb$var$getActiveElement();
    if (!currentSkinTone) return;
    if (!$2785da2b7d7107bb$var$hasNextElementSibling(currentSkinTone)) exitLeft();
    $2785da2b7d7107bb$var$focusNextElementSibling(currentSkinTone);
}
function $2785da2b7d7107bb$var$focusPrevSkinTone() {
    var currentSkinTone = $2785da2b7d7107bb$var$getActiveElement();
    if (!currentSkinTone) return;
    $2785da2b7d7107bb$var$focusPrevElementSibling(currentSkinTone);
}
function $2785da2b7d7107bb$var$useOnType() {
    var appendSearch = $2785da2b7d7107bb$var$useAppendSearch();
    var focusSearchInput = $2785da2b7d7107bb$var$useFocusSearchInput();
    var searchDisabled = $2785da2b7d7107bb$var$useSearchDisabledConfig();
    var closeAllOpenToggles = $2785da2b7d7107bb$var$useCloseAllOpenToggles();
    return function onType(event) {
        var key = event.key;
        if ($2785da2b7d7107bb$var$hasModifier(event) || searchDisabled) return;
        if (key.match(/(^[a-zA-Z0-9]$){1}/)) {
            event.preventDefault();
            closeAllOpenToggles();
            focusSearchInput();
            appendSearch(key);
        }
    };
}
function $2785da2b7d7107bb$var$hasModifier(event) {
    var metaKey = event.metaKey, ctrlKey = event.ctrlKey, altKey = event.altKey;
    return metaKey || ctrlKey || altKey;
}
function $2785da2b7d7107bb$var$preloadEmoji(getEmojiUrl, emoji, emojiStyle) {
    if (!emoji) return;
    if (emojiStyle === $2785da2b7d7107bb$export$92260a1a02147e89.NATIVE) return;
    var unified = $2785da2b7d7107bb$var$emojiUnified(emoji);
    if ($2785da2b7d7107bb$var$preloadedEmojs.has(unified)) return;
    $2785da2b7d7107bb$var$emojiVariations(emoji).forEach(function(variation) {
        var emojiUrl = getEmojiUrl(variation, emojiStyle);
        $2785da2b7d7107bb$var$preloadImage(emojiUrl);
    });
    $2785da2b7d7107bb$var$preloadedEmojs.add(unified);
}
var $2785da2b7d7107bb$var$preloadedEmojs = /*#__PURE__*/ new Set();
function $2785da2b7d7107bb$var$preloadImage(url) {
    var image = new Image();
    image.src = url;
}
function $2785da2b7d7107bb$var$useOnFocus() {
    var BodyRef = $2785da2b7d7107bb$var$useBodyRef();
    var emojiStyle = $2785da2b7d7107bb$var$useEmojiStyleConfig();
    var getEmojiUrl = $2785da2b7d7107bb$var$useGetEmojiUrlConfig();
    (0, $ir4bw.useEffect)(function() {
        if (emojiStyle === $2785da2b7d7107bb$export$92260a1a02147e89.NATIVE) return;
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener("focusin", onFocus);
        return function() {
            bodyRef == null || bodyRef.removeEventListener("focusin", onFocus);
        };
        function onFocus(event) {
            var button = $2785da2b7d7107bb$var$buttonFromTarget(event.target);
            if (!button) return;
            var _emojiFromElement = $2785da2b7d7107bb$var$emojiFromElement(button), emoji = _emojiFromElement[0];
            if (!emoji) return;
            if ($2785da2b7d7107bb$var$emojiHasVariations(emoji)) $2785da2b7d7107bb$var$preloadEmoji(getEmojiUrl, emoji, emojiStyle);
        }
    }, [
        BodyRef,
        emojiStyle,
        getEmojiUrl
    ]);
}
var $2785da2b7d7107bb$var$css_248z$b = "aside.EmojiPickerReact.epr-main{border-color:var(--epr-picker-border-color);border-radius:var(--epr-picker-border-radius);border-style:solid;border-width:1px;display:flex;flex-direction:column;position:relative}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$b);
function $2785da2b7d7107bb$var$PickerMain(_ref) {
    var children = _ref.children;
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$PickerContextProvider, null, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$PickerRootElement, null, children));
}
function $2785da2b7d7107bb$var$PickerRootElement(_ref2) {
    var _clsx;
    var children = _ref2.children;
    var theme = $2785da2b7d7107bb$var$useThemeConfig();
    var searchModeActive = $2785da2b7d7107bb$var$useIsSearchMode();
    var PickerMainRef = $2785da2b7d7107bb$var$usePickerMainRef();
    var _usePickerSizeConfig = $2785da2b7d7107bb$var$usePickerSizeConfig(), height = _usePickerSizeConfig.height, width = _usePickerSizeConfig.width;
    $2785da2b7d7107bb$var$useKeyboardNavigation();
    $2785da2b7d7107bb$var$useOnFocus();
    var style = {
        height: height,
        width: width
    };
    return (0, $5VC2c.createElement)("aside", {
        className: (0, $6da948ce3e31f187$export$2e2bcd8739ae039)($2785da2b7d7107bb$var$ClassNames.emojiPicker, "epr-main", (_clsx = {}, _clsx[$2785da2b7d7107bb$var$ClassNames.searchActive] = searchModeActive, _clsx["epr-dark-theme"] = theme === $2785da2b7d7107bb$export$14faa19a0f3bbeb2.DARK, _clsx)),
        ref: PickerMainRef,
        style: style
    }, children);
}
var $2785da2b7d7107bb$var$css_248z$c = ".EmojiPickerReact{--epr-highlight-color:#007aeb;--epr-hover-bg-color:#f1f8ff;--epr-focus-bg-color:#e0f0ff;--epr-text-color:#858585;--epr-search-input-bg-color:#f6f6f6;--epr-picker-border-color:#e7e7e7;--epr-bg-color:#fff;--epr-category-icon-active-color:#6aa8de;--epr-skin-tone-picker-menu-color:#ffffff95;--epr-horizontal-padding:10px;--epr-picker-border-radius:8px;--epr-search-border-color:var(--epr-highlight-color);--epr-header-padding:15px var(--epr-horizontal-padding);--epr-active-skin-tone-indicator-border-color:var(--epr-highlight-color);--epr-active-skin-hover-color:var(--epr-hover-bg-color);--epr-search-input-bg-color-active:var(--epr-search-input-bg-color);--epr-search-input-padding:0 30px;--epr-search-input-border-radius:8px;--epr-search-input-height:40px;--epr-search-input-text-color:var(--epr-text-color);--epr-search-input-placeholder-color:var(--epr-text-color);--epr-search-bar-inner-padding:var(--epr-horizontal-padding);--epr-category-navigation-button-size:30px;--epr-emoji-variation-picker-height:45px;--epr-emoji-variation-picker-bg-color:var(--epr-bg-color);--epr-preview-height:70px;--epr-preview-text-size:14px;--epr-preview-text-padding:0 var(--epr-horizontal-padding);--epr-preview-border-color:var(--epr-picker-border-color);--epr-preview-text-color:var(--epr-text-color);--epr-category-padding:0 var(--epr-horizontal-padding);--epr-category-label-bg-color:#ffffffe6;--epr-category-label-text-color:var(--epr-text-color);--epr-category-label-padding:0 var(--epr-horizontal-padding);--epr-category-label-height:40px;--epr-emoji-size:30px;--epr-emoji-padding:5px;--epr-emoji-fullsize:calc(var(--epr-emoji-size) + var(--epr-emoji-padding)*2);--epr-emoji-hover-color:var(--epr-hover-bg-color);--epr-emoji-variation-indicator-color:var(--epr-picker-border-color);--epr-emoji-variation-indicator-color-hover:var(--epr-text-color);--epr-header-overlay-z-index:3;--epr-emoji-variations-indictator-z-index:1;--epr-category-label-z-index:2;--epr-skin-variation-picker-z-index:5;--epr-preview-z-index:6}.EmojiPickerReact.epr-dark-theme{--epr-dark:#000;--epr-emoji-variation-picker-bg-color:var(--epr-dark);--epr-highlight-color:silver;--epr-text-color:var(--epr-highlight-color);--epr-hover-bg-color:#363636f6;--epr-focus-bg-color:#474747;--epr-search-input-bg-color:#333;--epr-category-label-bg-color:#222222e6;--epr-picker-border-color:#151617;--epr-bg-color:#222;--epr-search-input-bg-color-active:var(--epr-dark);--epr-emoji-variation-indicator-color:#444;--epr-category-icon-active-color:#3271b7;--epr-skin-tone-picker-menu-color:#22222295}.EmojiPickerReact{background-color:var(--epr-bg-color);overflow:hidden}.EmojiPickerReact .epr-hidden,.EmojiPickerReact.epr-search-active .epr-hidden-on-search,.EmojiPickerReact:not(.epr-search-active) .epr-visible-on-search-only{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}aside.EmojiPickerReact.epr-main:has(input:not(:-moz-placeholder-shown)) .epr-hidden-on-search{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}aside.EmojiPickerReact.epr-main:has(input:not(:placeholder-shown)) .epr-hidden-on-search{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}aside.EmojiPickerReact.epr-main:has(input:-moz-placeholder-shown) .epr-visible-on-search-only{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}aside.EmojiPickerReact.epr-main:has(input:placeholder-shown) .epr-visible-on-search-only{display:none!important;opacity:0!important;pointer-events:none!important;visibility:hidden!important}.EmojiPickerReact *{box-sizing:border-box;font-family:sans-serif}.EmojiPickerReact button.epr-btn{background:none;border:0;cursor:pointer;outline:none}";
$2785da2b7d7107bb$var$styleInject($2785da2b7d7107bb$var$css_248z$c);
function $2785da2b7d7107bb$var$EmojiPicker(props) {
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ElementRefContextProvider, null, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$PickerConfigProvider, Object.assign({}, props), (0, $5VC2c.createElement)($2785da2b7d7107bb$var$PickerMain, null, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Header, null), (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Body, null), (0, $5VC2c.createElement)($2785da2b7d7107bb$var$Preview, null))));
}
var $2785da2b7d7107bb$var$ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    $2785da2b7d7107bb$var$_inheritsLoose(ErrorBoundary, _React$Component);
    function ErrorBoundary(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            hasError: false
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error("Emoji Picker React failed to render:", error, errorInfo);
    };
    _proto.render = function render() {
        if (this.state.hasError) return null;
        return this.props.children;
    };
    return ErrorBoundary;
}((0, $5VC2c.Component));
function $2785da2b7d7107bb$export$56cc48506ff790a(_ref) {
    var unified = _ref.unified, _ref$size = _ref.size, size = _ref$size === void 0 ? 32 : _ref$size, _ref$emojiStyle = _ref.emojiStyle, emojiStyle = _ref$emojiStyle === void 0 ? $2785da2b7d7107bb$export$92260a1a02147e89.APPLE : _ref$emojiStyle, _ref$lazyLoad = _ref.lazyLoad, lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad, getEmojiUrl = _ref.getEmojiUrl, emojiUrl = _ref.emojiUrl;
    if (!unified && !emojiUrl && !getEmojiUrl) return null;
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ViewOnlyEmoji, {
        unified: unified,
        size: size,
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        getEmojiUrl: emojiUrl ? function() {
            return emojiUrl;
        } : getEmojiUrl
    });
}
function $2785da2b7d7107bb$var$EmojiPicker$1(props) {
    return (0, $5VC2c.createElement)($2785da2b7d7107bb$var$ErrorBoundary, null, (0, $5VC2c.createElement)($2785da2b7d7107bb$var$EmojiPicker, Object.assign({}, props)));
} // eslint-disable-next-line complexity
var $2785da2b7d7107bb$var$index = /*#__PURE__*/ (0, $e1jtj.memo)($2785da2b7d7107bb$var$EmojiPicker$1, function(prev, next) {
    return prev.emojiVersion === next.emojiVersion && prev.searchPlaceHolder === next.searchPlaceHolder && prev.searchPlaceholder === next.searchPlaceholder && prev.defaultSkinTone === next.defaultSkinTone && prev.skinTonesDisabled === next.skinTonesDisabled && prev.autoFocusSearch === next.autoFocusSearch && prev.emojiStyle === next.emojiStyle && prev.theme === next.theme && prev.suggestedEmojisMode === next.suggestedEmojisMode && prev.lazyLoadEmojis === next.lazyLoadEmojis && prev.height === next.height && prev.width === next.width && prev.searchDisabled === next.searchDisabled && prev.skinTonePickerLocation === next.skinTonePickerLocation;
});
var $2785da2b7d7107bb$export$2e2bcd8739ae039 = $2785da2b7d7107bb$var$index;


parcelRequire("e1jtj");
var $ir4bw = parcelRequire("ir4bw");




var $c841605347e1c59f$var$__assign = undefined && undefined.__assign || function() {
    $c841605347e1c59f$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $c841605347e1c59f$var$__assign.apply(this, arguments);
};
var $c841605347e1c59f$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $c841605347e1c59f$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
function $c841605347e1c59f$export$2e2bcd8739ae039() {
    var _this = this;
    var _a = (0, $ir4bw.useState)({
        logo_type: "image",
        logo_image: "",
        logo_text: "",
        logo_emoji: "",
        logo_size: 20,
        height: 20,
        is_floating: false,
        background_color: "",
        color: ""
    }), data = _a[0], setData = _a[1];
    var _b = (0, $ir4bw.useState)(false), showEmojiPicker = _b[0], setShowEmojiPicker = _b[1];
    var _c = (0, $ir4bw.useState)(false), loading = _c[0], setLoading = _c[1];
    var _d = (0, $ir4bw.useState)(false), removeLoading = _d[0], setRemoveLoading = _d[1];
    var _e = (0, $ir4bw.useContext)((0, $2d3b74a5ba71405d$exports.NavbarContext)), save = _e.save, logoData = _e.logoData, siteId = _e.siteId;
    var remove = function() {
        return $c841605347e1c59f$var$__awaiter(_this, void 0, void 0, function() {
            return $c841605347e1c59f$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            (0, $f2ec8d2c6ac3c51c$exports.default).remove(siteId)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    var removeNavbar = function() {
        return $c841605347e1c59f$var$__awaiter(_this, void 0, void 0, function() {
            return $c841605347e1c59f$var$__generator(this, function(_a) {
                (0, (/*@__PURE__*/$parcel$interopDefault($1b004826bb3c78d0$exports))).fire({
                    title: "Remove navbar",
                    text: "Are you sure you want to remove this navbar?",
                    showDenyButton: true,
                    confirmButtonText: "Continue",
                    denyButtonText: "Cancel"
                }).then(function(result) {
                    /* Read more about isConfirmed, isDenied below */ if (result.isConfirmed) (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).promise(remove(), {
                        loading: "Deleting link...",
                        success: "Link deleted",
                        error: "Error deleting link"
                    }).then(function() {
                        window.location.reload();
                    });
                });
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    (0, $ir4bw.useEffect)(function() {
        window.addEventListener("click", function(e) {
            if (e.target instanceof HTMLElement && !e.target.closest(".emoji-picker-react")) setShowEmojiPicker(false);
        });
    }, []);
    (0, $ir4bw.useEffect)(function() {
        setData(logoData);
    }, [
        logoData
    ]);
    var update = function() {
        setLoading(true);
        (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).promise(save({
            logo_type: data.logo_type,
            logo_image: data.logo_image,
            logo_text: data.logo_text,
            logo_emoji: data.logo_emoji,
            logo_size: Number(data.logo_size || "40"),
            height: isNaN(Number(data.height || "40")) ? 40 : Number(data.height || "40"),
            is_floating: data.is_floating,
            background_color: data.background_color,
            color: data.color
        }), {
            loading: "Saving...",
            success: function(res) {
                setLoading(false);
                return "Saved!";
            },
            error: function(err) {
                setLoading(false);
                return "Error saving";
            }
        });
    };
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        class: "navbarfooter-half-wrapper right-side",
        children: [
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "section-mb-40",
                children: [
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("h4", {
                        children: "Logo"
                    }),
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        class: "form-block-100 ",
                        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                            id: "email-form-2",
                            name: "email-form-2",
                            "data-name": "Email Form 2",
                            method: "get",
                            "data-wf-page-id": "60e84ecd7a80ead60d99f12b",
                            "data-wf-element-id": "84a563b8-2261-b4b5-759a-6a06e9e67788",
                            "aria-label": "Email Form 2",
                            children: [
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                    for: "",
                                    children: "Set as a logo:"
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "relative-div-wrapper-for-tooltips _100-width mt-5",
                                    style: {
                                        zIndex: 10
                                    },
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("select", {
                                        id: "appearance-2",
                                        name: "appearance-2",
                                        "data-name": "Appearance 2",
                                        class: "form-entry-select-dropdown _100-width w-select",
                                        defaultValue: data.logo_type,
                                        onChange: function(e) {
                                            setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                logo_type: e.target.value
                                            }));
                                        },
                                        children: [
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                                value: "image",
                                                children: "Image"
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                                value: "emoji",
                                                children: "Emoji"
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                                value: "text",
                                                children: "Text"
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("option", {
                                                value: "no-logo",
                                                children: "No logo"
                                            })
                                        ]
                                    })
                                }),
                                data.logo_type === "image" && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "mt-30",
                                    children: [
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                            for: "email",
                                            class: "label-step",
                                            children: "Set an image logo"
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                            class: "div-block-264",
                                            children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $dd4308b476c9d480$export$2c9ccda59fbaf1f6), {
                                                classNameUploader: "uc-dark",
                                                className: "fileUploaderWrapper",
                                                pubkey: "31bbea05082a5fbd5967",
                                                multiple: false,
                                                accept: "image/*" // accept only image files
                                                ,
                                                onChange: function(e) {
                                                    var _a;
                                                    setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                        logo_image: (_a = e.allEntries[0]) === null || _a === void 0 ? void 0 : _a.cdnUrl
                                                    }));
                                                }
                                            })
                                        }),
                                        data.logo_image && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("img", {
                                            src: data.logo_image,
                                            style: {
                                                height: "30px",
                                                marginTop: "20px",
                                                display: "block"
                                            }
                                        })
                                    ]
                                }),
                                data.logo_type === "emoji" && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "mt-30",
                                    children: [
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                            for: "email",
                                            class: "label-step",
                                            children: "Set an emoji logo"
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("button", {
                                            class: "w-button button-3",
                                            onClick: function(e) {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setShowEmojiPicker(true);
                                            },
                                            children: "Select emoji"
                                        }),
                                        showEmojiPicker && (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $5VC2c.Fragment), {
                                            children: [
                                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                    class: "div-block-264",
                                                    style: {
                                                        position: "relative"
                                                    },
                                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                        style: {
                                                            position: "absolute",
                                                            zIndex: 100
                                                        },
                                                        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $2785da2b7d7107bb$export$2e2bcd8739ae039), {
                                                            onEmojiClick: function(e, emojiObject) {
                                                                console.log(emojiObject.target.currentSrc);
                                                                setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                                    logo_emoji: emojiObject.target.currentSrc
                                                                }));
                                                            }
                                                        })
                                                    })
                                                }),
                                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                    style: {
                                                        position: "absolute",
                                                        top: 0,
                                                        left: "0px",
                                                        width: "100vw",
                                                        height: "100vh",
                                                        zIndex: 10,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center"
                                                    }
                                                })
                                            ]
                                        }),
                                        data.logo_emoji && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("img", {
                                            src: data.logo_emoji,
                                            style: {
                                                height: "30px",
                                                marginTop: "20px",
                                                display: "block"
                                            }
                                        })
                                    ]
                                }),
                                data.logo_type === "text" && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "mt-30",
                                    children: [
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                            class: "label-step",
                                            children: [
                                                "Set a title logo",
                                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("br", {})
                                            ]
                                        }),
                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                            type: "text",
                                            class: "form-entry form-field w-input",
                                            placeholder: "Title",
                                            value: data.logo_text,
                                            onChange: function(e) {
                                                setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                    logo_text: e.target.value
                                                }));
                                            }
                                        })
                                    ]
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "button-white-with-shadow pt-pb-0 mt-30",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        class: "slider-wrapper",
                                        children: [
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "flex-horizontal-top-left mt-14",
                                                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                    class: "flex-horizontal-center-extremes _100-width mb-10",
                                                    children: [
                                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                            children: "Logo height"
                                                        }),
                                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                            children: [
                                                                data.logo_size,
                                                                " pixels"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "fs-rangeslider_wrapper",
                                                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                    type: "range",
                                                    min: "20",
                                                    max: "300",
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    value: data.logo_size,
                                                    onChange: function(e) {
                                                        setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                            logo_size: Number(e.target.value)
                                                        }));
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                class: "section-mb-40",
                children: [
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("h4", {
                        children: "Navbar styling"
                    }),
                    (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                        class: "form-block-100 ",
                        children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("form", {
                            id: "email-form-3",
                            name: "email-form-3",
                            "data-name": "Email Form 3",
                            method: "get",
                            "data-wf-page-id": "60e84ecd7a80ead60d99f12b",
                            "data-wf-element-id": "84a563b8-2261-b4b5-759a-6a06e9e677b5",
                            "aria-label": "Email Form 3",
                            children: [
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "button-white-with-shadow pt-pb-0",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        class: "slider-wrapper",
                                        children: [
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "flex-horizontal-top-left mt-14",
                                                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                    class: "flex-horizontal-center-extremes _100-width mb-10",
                                                    children: [
                                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                            children: "Navbar size"
                                                        }),
                                                        (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                            children: [
                                                                data.height,
                                                                " pixels"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "fs-rangeslider_wrapper",
                                                children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                    class: "fs-rangeslider_wrapper",
                                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                        type: "range",
                                                        min: "20",
                                                        max: "300",
                                                        style: {
                                                            width: "100%"
                                                        },
                                                        defaultValue: String(data.height),
                                                        onChange: function(e) {
                                                            setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                                height: e.target.value
                                                            }));
                                                        }
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "flex-horizontal-center-extremes-100 mt-10",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                        class: "w-checkbox dropdown-entry aligned-horizontally-relative",
                                        children: [
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                type: "checkbox",
                                                class: "w-checkbox-input checkbox-2",
                                                id: "navbar_visible_on_scroll",
                                                checked: data.is_floating,
                                                onChange: function(e) {
                                                    setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                        is_floating: e.target.checked
                                                    }));
                                                }
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                                class: "form-entry-w-o-size-constraints-copy w-form-label",
                                                for: "navbar_visible_on_scroll"
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "text-block-12",
                                                children: "Make the navigation bar visible on scroll"
                                            })
                                        ]
                                    })
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "flex-horizontal-center-extremes-100 mt-10",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                        class: "w-checkbox dropdown-entry aligned-horizontally-relative",
                                        children: [
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                type: "checkbox",
                                                id: "background_colour",
                                                class: "w-checkbox-input checkbox-2",
                                                defaultChecked: !!data.background_color,
                                                onChange: function(e) {
                                                    setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                        background_color: e.target.checked ? "black" : ""
                                                    }));
                                                }
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                                class: "form-entry-w-o-size-constraints-copy w-form-label",
                                                for: "background_colour"
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "text-block-12",
                                                children: "Background colour"
                                            })
                                        ]
                                    })
                                }),
                                data.background_color && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "flex-horizontal-center-extremes-100 mt-10",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                        type: "color",
                                        class: "form-entry-w-o-size-constraints w-input",
                                        placeholder: "#ffffff",
                                        style: {
                                            width: "100%",
                                            padding: "0px"
                                        },
                                        defaultValue: data.background_color,
                                        onChange: function(e) {
                                            setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                background_color: e.target.value
                                            }));
                                        }
                                    })
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "flex-horizontal-center-extremes-100 mt-10",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("label", {
                                        class: "w-checkbox dropdown-entry aligned-horizontally-relative",
                                        children: [
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                                type: "checkbox",
                                                id: "text_colour",
                                                class: "w-checkbox-input checkbox-2",
                                                defaultChecked: !!data.color,
                                                onChange: function(e) {
                                                    setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                        color: e.target.checked ? "black" : ""
                                                    }));
                                                }
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("span", {
                                                class: "form-entry-w-o-size-constraints-copy w-form-label",
                                                for: "text_colour"
                                            }),
                                            (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                                class: "text-block-12",
                                                children: "Text colour"
                                            })
                                        ]
                                    })
                                }),
                                data.color && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "flex-horizontal-center-extremes-100 mt-10",
                                    children: (0, $563cc721c6a67067$export$34b9dba7ce09269b)("input", {
                                        type: "color",
                                        class: "form-entry-w-o-size-constraints w-input",
                                        placeholder: "#ffffff",
                                        defaultValue: data.color,
                                        style: {
                                            width: "100%",
                                            padding: "0px"
                                        },
                                        onChange: function(e) {
                                            setData($c841605347e1c59f$var$__assign($c841605347e1c59f$var$__assign({}, data), {
                                                color: e.target.value
                                            }));
                                        }
                                    })
                                }),
                                (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    class: "dropdown-entry",
                                    style: {
                                        padding: "10px 0px"
                                    },
                                    children: !loading ? (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
                                        class: "button button-blue-primary button-block-centered-text mt-0 w-button",
                                        onClick: function(e) {
                                            e.preventDefault();
                                            update();
                                        },
                                        children: "Save changes"
                                    }) : (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        class: "button button-blue-primary button-block-centered-text mt-0 w-button",
                                        children: "Saving..."
                                    })
                                }),
                                logoData.id && (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                    style: {
                                        width: "100%",
                                        marginTop: "10px"
                                    },
                                    children: !removeLoading ? (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        onClick: removeNavbar,
                                        class: "button button-blue-primary button-block-centered-text mt-0 w-button",
                                        style: {
                                            backgroundColor: "red"
                                        },
                                        children: "Remove Navbar"
                                    }) : (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
                                        class: "button button-blue-primary button-block-centered-text mt-0 w-button",
                                        children: "Saving..."
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}


parcelRequire("e1jtj");
var $ir4bw = parcelRequire("ir4bw");





var $9d97a5a9a883c69e$var$__assign = undefined && undefined.__assign || function() {
    $9d97a5a9a883c69e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $9d97a5a9a883c69e$var$__assign.apply(this, arguments);
};
var $9d97a5a9a883c69e$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9d97a5a9a883c69e$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $9d97a5a9a883c69e$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9d97a5a9a883c69e$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $9d97a5a9a883c69e$var$TToaster = (0, $3412d7152e02b24a$exports.Toaster);
function $9d97a5a9a883c69e$var$Card() {
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)("div", {
        class: "div-block-267",
        children: [
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $23fbbca513fd42e2$exports.default), {}),
            (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $c841605347e1c59f$exports.default), {})
        ]
    });
}
function $9d97a5a9a883c69e$var$distructureQueryString(queryString) {
    var query = queryString.substring(1);
    var vars = query.split("&");
    var queryObj = {};
    for(var i = 0; i < vars.length; i++){
        var pair = vars[i].split("=");
        queryObj[pair[0]] = decodeURIComponent(pair[1]);
    }
    return queryObj;
}
function $9d97a5a9a883c69e$var$App() {
    var _this = this;
    var _a = (0, $ir4bw.useState)(null), data = _a[0], setData = _a[1];
    var query = window.location.search;
    var site_id = $9d97a5a9a883c69e$var$distructureQueryString(query).site_id;
    var _b = (0, $ir4bw.useState)(true), loading = _b[0], setLoading = _b[1];
    var fetchNavbar = function(silent) {
        if (silent === void 0) silent = false;
        return $9d97a5a9a883c69e$var$__awaiter(_this, void 0, void 0, function() {
            var res, err_1;
            return $9d97a5a9a883c69e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        !silent && setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            (0, $f2ec8d2c6ac3c51c$exports.default).fetch(site_id)
                        ];
                    case 2:
                        res = _a.sent();
                        setData(res.data);
                        setLoading(false);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_1 = _a.sent();
                        (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).error("Error fetching navbar");
                        setLoading(false);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var createNavbar = function() {
        return $9d97a5a9a883c69e$var$__awaiter(_this, void 0, void 0, function() {
            var payload, err_2;
            return $9d97a5a9a883c69e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        setLoading(true);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        payload = {
                            body: {
                                logo_type: "image",
                                logo_image: "",
                                logo_text: "",
                                logo_emoji: "",
                                logo_size: "40",
                                height: "40",
                                is_floating: false,
                                background_color: "",
                                color: ""
                            },
                            links: [],
                            buttons: []
                        };
                        return [
                            4 /*yield*/ ,
                            (0, $f2ec8d2c6ac3c51c$exports.default).create(site_id, payload)
                        ];
                    case 2:
                        _a.sent();
                        fetchNavbar();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        err_2 = _a.sent();
                        (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).error("Error fetching navbar");
                        setLoading(false);
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var updateNavbar = function(input, silent) {
        if (silent === void 0) silent = false;
        return $9d97a5a9a883c69e$var$__awaiter(_this, void 0, void 0, function() {
            var payload, response, err_3;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return $9d97a5a9a883c69e$var$__generator(this, function(_k) {
                switch(_k.label){
                    case 0:
                        _k.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        !silent && setLoading(true);
                        payload = $9d97a5a9a883c69e$var$__assign($9d97a5a9a883c69e$var$__assign({
                            logo_size: (_a = input.logo_size) !== null && _a !== void 0 ? _a : "40",
                            height: (_b = input.height) !== null && _b !== void 0 ? _b : "40",
                            logo_type: (_c = input.logo_type) !== null && _c !== void 0 ? _c : "image",
                            logo_image: (_d = input.logo_image) !== null && _d !== void 0 ? _d : "",
                            logo_text: (_e = input.logo_text) !== null && _e !== void 0 ? _e : "",
                            logo_emoji: (_f = input.logo_emoji) !== null && _f !== void 0 ? _f : "",
                            is_floating: (_g = input.is_floating) !== null && _g !== void 0 ? _g : false,
                            background_color: (_h = input.background_color) !== null && _h !== void 0 ? _h : "",
                            color: (_j = input.color) !== null && _j !== void 0 ? _j : ""
                        }, input), {
                            links: (input === null || input === void 0 ? void 0 : input.links) ? input.links : (data === null || data === void 0 ? void 0 : data.links) || [],
                            buttons: (input === null || input === void 0 ? void 0 : input.buttons) ? input.buttons : (data === null || data === void 0 ? void 0 : data.buttons) || []
                        });
                        return [
                            4 /*yield*/ ,
                            (0, $f2ec8d2c6ac3c51c$exports.default).update(site_id, payload)
                        ];
                    case 1:
                        response = _k.sent();
                        setData(response.data);
                        setLoading(false);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        err_3 = _k.sent();
                        (0, (/*@__PURE__*/$parcel$interopDefault($3412d7152e02b24a$exports))).error("Error fetching navbar");
                        setLoading(false);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    (0, $ir4bw.useEffect)(function() {
        fetchNavbar();
    }, []);
    var saveNavbar = function(payload) {
        return $9d97a5a9a883c69e$var$__awaiter(_this, void 0, void 0, function() {
            return $9d97a5a9a883c69e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!data) return [
                            3 /*break*/ ,
                            1
                        ];
                        updateNavbar(payload);
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            createNavbar()
                        ];
                    case 2:
                        _a.sent();
                        updateNavbar(payload);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var saveLink = function(link) {
        return $9d97a5a9a883c69e$var$__awaiter(_this, void 0, void 0, function() {
            var links_1, response;
            return $9d97a5a9a883c69e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!data) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            createNavbar()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(link.id > 0)) return [
                            3 /*break*/ ,
                            3
                        ];
                        links_1 = data.links.map(function(l) {
                            if (l.id === link.id) return link;
                            return l;
                        });
                        updateNavbar({
                            links: $9d97a5a9a883c69e$var$__spreadArray([], links_1, true)
                        }, true);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $f2ec8d2c6ac3c51c$exports.default).createLink(site_id, link)
                        ];
                    case 4:
                        response = _a.sent();
                        setData($9d97a5a9a883c69e$var$__assign($9d97a5a9a883c69e$var$__assign({}, data), {
                            links: $9d97a5a9a883c69e$var$__spreadArray($9d97a5a9a883c69e$var$__spreadArray([], data === null || data === void 0 ? void 0 : data.links, true), [
                                response.data
                            ], false)
                        }));
                        fetchNavbar(true);
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var saveButton = function(button) {
        return $9d97a5a9a883c69e$var$__awaiter(_this, void 0, void 0, function() {
            var buttons_1, response;
            return $9d97a5a9a883c69e$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!data) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            createNavbar()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(button.id > 0)) return [
                            3 /*break*/ ,
                            3
                        ];
                        buttons_1 = data.buttons.map(function(b) {
                            if (b.id === button.id) return button;
                            return b;
                        });
                        updateNavbar({
                            buttons: $9d97a5a9a883c69e$var$__spreadArray([], buttons_1, true)
                        }, true);
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $f2ec8d2c6ac3c51c$exports.default).createButton(site_id, button)
                        ];
                    case 4:
                        response = _a.sent();
                        setData($9d97a5a9a883c69e$var$__assign($9d97a5a9a883c69e$var$__assign({}, data), {
                            buttons: $9d97a5a9a883c69e$var$__spreadArray($9d97a5a9a883c69e$var$__spreadArray([], data === null || data === void 0 ? void 0 : data.buttons, true), [
                                response.data
                            ], false)
                        }));
                        fetchNavbar(true);
                        _a.label = 5;
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var _c = data || {}, links = _c.links, buttons = _c.buttons, rest = $9d97a5a9a883c69e$var$__rest(_c, [
        "links",
        "buttons"
    ]);
    return (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $5VC2c.Fragment), {
        children: !loading ? (0, $563cc721c6a67067$export$34b9dba7ce09269b)((0, $2d3b74a5ba71405d$exports.NavbarContext).Provider, {
            value: {
                links: links || [],
                buttons: buttons || [],
                logoData: $9d97a5a9a883c69e$var$__assign($9d97a5a9a883c69e$var$__assign({}, rest), {
                    logo_size: rest.logo_size || "40",
                    height: rest.height || "40",
                    logo_type: rest.logo_type || "image"
                }),
                siteId: site_id,
                saveLink: saveLink,
                saveButton: saveButton,
                save: saveNavbar,
                refetch: fetchNavbar,
                update: function(_a) {
                    var buttons = _a.buttons, link = _a.link, logoData = _a.logoData;
                    if (buttons) updateNavbar({
                        buttons: $9d97a5a9a883c69e$var$__spreadArray([], buttons, true)
                    });
                    if (link) updateNavbar({
                        links: $9d97a5a9a883c69e$var$__spreadArray([], links, true)
                    });
                    if (logoData) updateNavbar($9d97a5a9a883c69e$var$__assign({}, logoData));
                }
            },
            children: [
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)($9d97a5a9a883c69e$var$TToaster, {}),
                (0, $563cc721c6a67067$export$34b9dba7ce09269b)($9d97a5a9a883c69e$var$Card, {})
            ]
        }) : (0, $563cc721c6a67067$export$34b9dba7ce09269b)("p", {
            children: "Loading..."
        })
    });
}
var $9d97a5a9a883c69e$var$el = document.querySelector("#navigation-card");
console.log("About to render navbar to the dom", $9d97a5a9a883c69e$var$el);
if ($9d97a5a9a883c69e$var$el) {
    console.log("rendering navbar");
    (0, $5VC2c.render)((0, $563cc721c6a67067$export$34b9dba7ce09269b)($9d97a5a9a883c69e$var$App, {}), $9d97a5a9a883c69e$var$el);
}

})();
//# sourceMappingURL=index.js.map
